webpackJsonp([6],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".speed-dial[data-v-fa02ab1e]{position:fixed;z-index:5}.chart-head[data-v-fa02ab1e]{margin-right:1.5rem}.chart-subhead[data-v-fa02ab1e]{margin:.5rem 0;padding:.5rem 1rem;font-size:12px;font-weight:400;background-color:#0071c7;border-radius:1.5rem;color:#fff}.custom-select[data-v-fa02ab1e]{padding:4px 16px}.md-drawer[data-v-fa02ab1e]{height:100vh;position:fixed;width:320px;max-width:calc(100vw - 125px);z-index:100}.toolbar-title[data-v-fa02ab1e]{min-height:44px}.md-datepicker[data-v-fa02ab1e],.md-list[data-v-fa02ab1e],.md-radio[data-v-fa02ab1e]{margin:0}.switch[data-v-fa02ab1e]{position:relative;display:inline-block;width:30px;height:17px}.switch input[data-v-fa02ab1e]{opacity:0;width:0;height:0}.slider[data-v-fa02ab1e]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider[data-v-fa02ab1e]:before{position:absolute;content:\"\";height:13px;width:13px;left:2px;bottom:2px;background-color:#fff;transition:.4s}input:checked+.slider[data-v-fa02ab1e]{background-color:var(--radio-button-checked)}input:focus+.slider[data-v-fa02ab1e]{box-shadow:0 0 1px var(--radio-button-checked)}input:checked+.slider[data-v-fa02ab1e]:before{transform:translateX(13px)}.slider.round[data-v-fa02ab1e]{border-radius:17px}.slider.round[data-v-fa02ab1e]:before{border-radius:50%}.slider-text[data-v-fa02ab1e]{margin:0 8px;font-size:12px;position:absolute;cursor:pointer}.pe-radio[data-v-fa02ab1e]{display:block;position:relative;padding-left:17.5px;margin-bottom:6px;cursor:pointer;font-size:22px;-webkit-user-select:none;-ms-user-select:none;user-select:none}.pe-radio-text[data-v-fa02ab1e]{font-size:14px;margin:0 8px;display:block}.pe-radio input[data-v-fa02ab1e]{position:absolute;opacity:0;cursor:pointer}.checkmark[data-v-fa02ab1e]{position:absolute;top:0;left:0;height:16px;width:16px;background-color:#eee;border-radius:50%}.pe-radio:hover input~.checkmark[data-v-fa02ab1e]{background-color:#ccc}.pe-radio input:checked~.checkmark[data-v-fa02ab1e]{background-color:var(--radio-button-checked)}.checkmark[data-v-fa02ab1e]:after{content:\"\";position:absolute;display:none}.pe-radio input:checked~.checkmark[data-v-fa02ab1e]:after{display:block}.pe-radio .checkmark[data-v-fa02ab1e]:after{top:4.5px;left:4.5px;width:6px;height:6px;border-radius:50%;background:#fff}.error-message[data-v-fa02ab1e],.loading-spinner[data-v-fa02ab1e]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:315px;position:absolute;top:0;left:0;right:0;bottom:0;font-size:14px;background-color:hsla(0,0%,50%,.5);z-index:1}.error-message[data-v-fa02ab1e]{font-weight:700;color:red}.chart-wrapper[data-v-fa02ab1e]{position:relative}.chart-inner[data-v-fa02ab1e]{position:relative;height:300px}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Presion/Presion.vue"],"names":[],"mappings":"AACA,6BACE,eAAgB,AAChB,SAAW,CACZ,AACD,6BACE,mBAAqB,CACtB,AACD,gCACE,eAAgB,AAChB,mBAAmB,AAInB,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,qBAAsB,AACtB,UAAY,CACb,AACD,gCACE,gBAAkB,CACnB,AACD,4BACE,aAAc,AACd,eAAgB,AAChB,YAAa,AACb,8BAA+B,AAC/B,WAAa,CACd,AACD,gCACE,eAAiB,CAClB,AAOD,qFACE,QAAU,CACX,AAGD,yBACE,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,WAAa,CACd,AAGD,+BACE,UAAW,AACX,QAAS,AACT,QAAU,CACX,AAGD,yBACE,kBAAmB,AACnB,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,sBAAuB,AACvB,cAAgB,CACjB,AACD,gCACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,SAAU,AACV,WAAY,AACZ,sBAAwB,AACxB,cAAgB,CACjB,AACD,uCACE,4CAA8C,CAC/C,AACD,qCACE,8CAAgD,CACjD,AACD,8CACE,0BAA4B,CAC7B,AAGD,+BACE,kBAAoB,CACrB,AACD,sCACE,iBAAmB,CACpB,AACD,8BACE,aAAc,AACd,eAAgB,AAChB,kBAAmB,AACnB,cAAgB,CACjB,AAGD,2BACE,cAAe,AACf,kBAAmB,AACnB,oBAAqB,AACrB,kBAAmB,AACnB,eAAgB,AAChB,eAAgB,AAChB,yBAA0B,AAC1B,qBAAsB,AACtB,gBAAkB,CACnB,AACD,gCACE,eAAgB,AAChB,aAAc,AACd,aAAe,CAChB,AAGD,iCACE,kBAAmB,AACnB,UAAW,AACX,cAAgB,CACjB,AAGD,4BACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,sBAAuB,AACvB,iBAAmB,CACpB,AAGD,kDACE,qBAAuB,CACxB,AAGD,oDACE,4CAA8C,CAC/C,AAGD,kCACE,WAAY,AACZ,kBAAmB,AACnB,YAAc,CACf,AAGD,0DACE,aAAe,CAChB,AAGD,4CACE,UAAW,AACX,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,eAAkB,CACnB,AAmBD,kEAjBE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,mBAAoB,AACxB,aAAc,AACd,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,eAAgB,AAChB,mCAA2C,AAE3C,SAAW,CAqBZ,AAnBD,gCAaE,gBAAkB,AAIlB,SAAW,CAEZ,AACD,gCACE,iBAAmB,CACpB,AACD,8BACE,kBAAmB,AACnB,YAAc,CACf","file":"Presion.vue","sourcesContent":["\n.speed-dial[data-v-fa02ab1e] {\n  position: fixed;\n  z-index: 5;\n}\n.chart-head[data-v-fa02ab1e] {\n  margin-right: 1.5rem;\n}\n.chart-subhead[data-v-fa02ab1e] {\n  margin: .5rem 0;\n  padding-left: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-right: 1rem;\n  font-size: 12px;\n  font-weight: 400;\n  background-color: #0071C7;\n  border-radius: 1.5rem;\n  color: #fff;\n}\n.custom-select[data-v-fa02ab1e] {\n  padding: 4px 16px;\n}\n.md-drawer[data-v-fa02ab1e] {\n  height: 100vh;\n  position: fixed;\n  width: 320px;\n  max-width: calc(100vw - 125px);\n  z-index: 100;\n}\n.toolbar-title[data-v-fa02ab1e] {\n  min-height: 44px;\n}\n.md-radio[data-v-fa02ab1e] {\n  margin: 0;\n}\n.md-datepicker[data-v-fa02ab1e] {\n  margin: 0;\n}\n.md-list[data-v-fa02ab1e] {\n  margin: 0;\n}\n\n/* The switch - the box around the slider */\n.switch[data-v-fa02ab1e] {\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  height: 17px;\n}\n\n/* Hide default HTML checkbox */\n.switch input[data-v-fa02ab1e] {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider */\n.slider[data-v-fa02ab1e] {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n}\n.slider[data-v-fa02ab1e]:before {\n  position: absolute;\n  content: \"\";\n  height: 13px;\n  width: 13px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: .4s;\n}\ninput:checked + .slider[data-v-fa02ab1e] {\n  background-color: var(--radio-button-checked);\n}\ninput:focus + .slider[data-v-fa02ab1e] {\n  box-shadow: 0 0 1px var(--radio-button-checked);\n}\ninput:checked + .slider[data-v-fa02ab1e]:before {\n  transform: translateX(13px);\n}\n\n/* Rounded sliders */\n.slider.round[data-v-fa02ab1e] {\n  border-radius: 17px;\n}\n.slider.round[data-v-fa02ab1e]:before {\n  border-radius: 50%;\n}\n.slider-text[data-v-fa02ab1e] {\n  margin: 0 8px;\n  font-size: 12px;\n  position: absolute;\n  cursor: pointer;\n}\n\n/* The container */\n.pe-radio[data-v-fa02ab1e] {\n  display: block;\n  position: relative;\n  padding-left: 17.5px;\n  margin-bottom: 6px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.pe-radio-text[data-v-fa02ab1e] {\n  font-size: 14px;\n  margin: 0 8px;\n  display: block;\n}\n\n/* Hide the browser's default radio button */\n.pe-radio input[data-v-fa02ab1e] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n/* Create a custom radio button */\n.checkmark[data-v-fa02ab1e] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background-color: #eee;\n  border-radius: 50%;\n}\n\n/* On mouse-over, add a grey background color */\n.pe-radio:hover input ~ .checkmark[data-v-fa02ab1e] {\n  background-color: #ccc;\n}\n\n/* When the radio button is checked, add a blue background */\n.pe-radio input:checked ~ .checkmark[data-v-fa02ab1e] {\n  background-color: var(--radio-button-checked);\n}\n\n/* Create the indicator (the dot/circle - hidden when not checked) */\n.checkmark[data-v-fa02ab1e]:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the indicator (dot/circle) when checked */\n.pe-radio input:checked ~ .checkmark[data-v-fa02ab1e]:after {\n  display: block;\n}\n\n/* Style the indicator (dot/circle) */\n.pe-radio .checkmark[data-v-fa02ab1e]:after {\n  top: 4.5px;\n  left: 4.5px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: white;\n}\n.loading-spinner[data-v-fa02ab1e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 315px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  font-size: 14px;\n  background-color: rgba(128, 128, 128, 0.5);\n  /* Gray transparent background */\n  z-index: 1;\n}\n.error-message[data-v-fa02ab1e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 315px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  font-weight: bold;\n  font-size: 14px;\n  background-color: rgba(128, 128, 128, 0.5);\n  /* Gray transparent background */\n  color: red;\n  z-index: 1;\n}\n.chart-wrapper[data-v-fa02ab1e] {\n  position: relative;\n}\n.chart-inner[data-v-fa02ab1e] {\n  position: relative;\n  height: 300px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1006:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.2","C:\\Development\\webclient"]],"_development":true,"_from":"elliptic@6.5.2","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.2","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.2","saveSpec":null,"fetchSpec":"6.5.2"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_spec":"6.5.2","_where":"C:\\Development\\webclient","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 498,
	"./af.js": 498,
	"./ar": 505,
	"./ar-dz": 499,
	"./ar-dz.js": 499,
	"./ar-kw": 500,
	"./ar-kw.js": 500,
	"./ar-ly": 501,
	"./ar-ly.js": 501,
	"./ar-ma": 502,
	"./ar-ma.js": 502,
	"./ar-sa": 503,
	"./ar-sa.js": 503,
	"./ar-tn": 504,
	"./ar-tn.js": 504,
	"./ar.js": 505,
	"./az": 506,
	"./az.js": 506,
	"./be": 507,
	"./be.js": 507,
	"./bg": 508,
	"./bg.js": 508,
	"./bm": 509,
	"./bm.js": 509,
	"./bn": 510,
	"./bn.js": 510,
	"./bo": 511,
	"./bo.js": 511,
	"./br": 512,
	"./br.js": 512,
	"./bs": 513,
	"./bs.js": 513,
	"./ca": 514,
	"./ca.js": 514,
	"./cs": 515,
	"./cs.js": 515,
	"./cv": 516,
	"./cv.js": 516,
	"./cy": 517,
	"./cy.js": 517,
	"./da": 518,
	"./da.js": 518,
	"./de": 521,
	"./de-at": 519,
	"./de-at.js": 519,
	"./de-ch": 520,
	"./de-ch.js": 520,
	"./de.js": 521,
	"./dv": 522,
	"./dv.js": 522,
	"./el": 523,
	"./el.js": 523,
	"./en-au": 524,
	"./en-au.js": 524,
	"./en-ca": 525,
	"./en-ca.js": 525,
	"./en-gb": 526,
	"./en-gb.js": 526,
	"./en-ie": 527,
	"./en-ie.js": 527,
	"./en-il": 528,
	"./en-il.js": 528,
	"./en-in": 529,
	"./en-in.js": 529,
	"./en-nz": 530,
	"./en-nz.js": 530,
	"./en-sg": 531,
	"./en-sg.js": 531,
	"./eo": 532,
	"./eo.js": 532,
	"./es": 535,
	"./es-do": 533,
	"./es-do.js": 533,
	"./es-us": 534,
	"./es-us.js": 534,
	"./es.js": 535,
	"./et": 536,
	"./et.js": 536,
	"./eu": 537,
	"./eu.js": 537,
	"./fa": 538,
	"./fa.js": 538,
	"./fi": 539,
	"./fi.js": 539,
	"./fil": 540,
	"./fil.js": 540,
	"./fo": 541,
	"./fo.js": 541,
	"./fr": 544,
	"./fr-ca": 542,
	"./fr-ca.js": 542,
	"./fr-ch": 543,
	"./fr-ch.js": 543,
	"./fr.js": 544,
	"./fy": 545,
	"./fy.js": 545,
	"./ga": 546,
	"./ga.js": 546,
	"./gd": 547,
	"./gd.js": 547,
	"./gl": 548,
	"./gl.js": 548,
	"./gom-deva": 549,
	"./gom-deva.js": 549,
	"./gom-latn": 550,
	"./gom-latn.js": 550,
	"./gu": 551,
	"./gu.js": 551,
	"./he": 552,
	"./he.js": 552,
	"./hi": 553,
	"./hi.js": 553,
	"./hr": 554,
	"./hr.js": 554,
	"./hu": 555,
	"./hu.js": 555,
	"./hy-am": 556,
	"./hy-am.js": 556,
	"./id": 557,
	"./id.js": 557,
	"./is": 558,
	"./is.js": 558,
	"./it": 560,
	"./it-ch": 559,
	"./it-ch.js": 559,
	"./it.js": 560,
	"./ja": 561,
	"./ja.js": 561,
	"./jv": 562,
	"./jv.js": 562,
	"./ka": 563,
	"./ka.js": 563,
	"./kk": 564,
	"./kk.js": 564,
	"./km": 565,
	"./km.js": 565,
	"./kn": 566,
	"./kn.js": 566,
	"./ko": 567,
	"./ko.js": 567,
	"./ku": 568,
	"./ku.js": 568,
	"./ky": 569,
	"./ky.js": 569,
	"./lb": 570,
	"./lb.js": 570,
	"./lo": 571,
	"./lo.js": 571,
	"./lt": 572,
	"./lt.js": 572,
	"./lv": 573,
	"./lv.js": 573,
	"./me": 574,
	"./me.js": 574,
	"./mi": 575,
	"./mi.js": 575,
	"./mk": 576,
	"./mk.js": 576,
	"./ml": 577,
	"./ml.js": 577,
	"./mn": 578,
	"./mn.js": 578,
	"./mr": 579,
	"./mr.js": 579,
	"./ms": 581,
	"./ms-my": 580,
	"./ms-my.js": 580,
	"./ms.js": 581,
	"./mt": 582,
	"./mt.js": 582,
	"./my": 583,
	"./my.js": 583,
	"./nb": 584,
	"./nb.js": 584,
	"./ne": 585,
	"./ne.js": 585,
	"./nl": 587,
	"./nl-be": 586,
	"./nl-be.js": 586,
	"./nl.js": 587,
	"./nn": 588,
	"./nn.js": 588,
	"./oc-lnc": 589,
	"./oc-lnc.js": 589,
	"./pa-in": 590,
	"./pa-in.js": 590,
	"./pl": 591,
	"./pl.js": 591,
	"./pt": 593,
	"./pt-br": 592,
	"./pt-br.js": 592,
	"./pt.js": 593,
	"./ro": 594,
	"./ro.js": 594,
	"./ru": 595,
	"./ru.js": 595,
	"./sd": 596,
	"./sd.js": 596,
	"./se": 597,
	"./se.js": 597,
	"./si": 598,
	"./si.js": 598,
	"./sk": 599,
	"./sk.js": 599,
	"./sl": 600,
	"./sl.js": 600,
	"./sq": 601,
	"./sq.js": 601,
	"./sr": 603,
	"./sr-cyrl": 602,
	"./sr-cyrl.js": 602,
	"./sr.js": 603,
	"./ss": 604,
	"./ss.js": 604,
	"./sv": 605,
	"./sv.js": 605,
	"./sw": 606,
	"./sw.js": 606,
	"./ta": 607,
	"./ta.js": 607,
	"./te": 608,
	"./te.js": 608,
	"./tet": 609,
	"./tet.js": 609,
	"./tg": 610,
	"./tg.js": 610,
	"./th": 611,
	"./th.js": 611,
	"./tl-ph": 612,
	"./tl-ph.js": 612,
	"./tlh": 613,
	"./tlh.js": 613,
	"./tr": 614,
	"./tr.js": 614,
	"./tzl": 615,
	"./tzl.js": 615,
	"./tzm": 617,
	"./tzm-latn": 616,
	"./tzm-latn.js": 616,
	"./tzm.js": 617,
	"./ug-cn": 618,
	"./ug-cn.js": 618,
	"./uk": 619,
	"./uk.js": 619,
	"./ur": 620,
	"./ur.js": 620,
	"./uz": 622,
	"./uz-latn": 621,
	"./uz-latn.js": 621,
	"./uz.js": 622,
	"./vi": 623,
	"./vi.js": 623,
	"./x-pseudo": 624,
	"./x-pseudo.js": 624,
	"./yo": 625,
	"./yo.js": 625,
	"./zh-cn": 626,
	"./zh-cn.js": 626,
	"./zh-hk": 627,
	"./zh-hk.js": 627,
	"./zh-mo": 628,
	"./zh-mo.js": 628,
	"./zh-tw": 629,
	"./zh-tw.js": 629
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1391;

/***/ }),

/***/ 1393:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 1626:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/foto_login.a4aacdc.png";

/***/ }),

/***/ 1627:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_login.0b91070.png";

/***/ }),

/***/ 1628:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/campo_grafica.2469142.jpg";

/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/campo_indicaciones.dc9ea2c.png";

/***/ }),

/***/ 1630:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXsAAAAnCAMAAADZ2xgBAAAABGdBTUEAALGPC/xhBQAAAF1QTFRFK6dpK6dpK6dpK6dpK6dp5Tk15Tk15Tk1K6dpK6dp5Tk15Tk1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+aglK6dp5Tk1/sq6LwAAABx0Uk5T+h+6Hru68/n5vx67LlyKUzeBbngJShIcJWVAAJHNFSYAAAFeSURBVGje7ZdbcsMgDEXdd5vYxbwtaL3/ZRZsvIFKcej03plMws8ZdFBkPGTkXhmgAO7hHoF7uEfgHu4RuId7BO7hHoF7uEfg/i+4v7y8rZ3l6wb57ifvj0/N/XVd4f7kfDT3r3B/fuej7+/e95cr5v25GZ4fcM/BHRPuEbiHewTu4R6Be7hHhNzHUH8sgYNpDCexpcaKonVuUMcrsu3s+OJA4lLqG7K3qSyMn9LveTuD9CJgaWMFk8gLqt+hNlHiQgpG8yGU0lz7PpXFqHLWDGLatkMS7jdW+Tgt2fcVOs85UOZXyTrAHfLZZk6rdV934r4OHZJ2X6GKDRl9EnA/TbFf985EefdkRy7EGcd375SLtl/3Zs436HveIKuQ8lwkVp3HyenDfaTsbE/ulaz6vcG8gPtyQ1EqcCGm7qS5z94IHKbgs1YTURR274jMKPDnEZj33pgZ71Z4r/2X+QHOlSE46voiGQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 1631:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_PIPE_EAGLE.05bfa7b.png";

/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_PIPE_EAGLE_V.a6a0c20.png";

/***/ }),

/***/ 1633:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/PIPE_EAGLE_SINGLE.8d2ff0b.png";

/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/PIPE_EAGLE_VERTICAL.a99287a.png";

/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/favicon.7fee161.png";

/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon.ecc2da9.ico";

/***/ }),

/***/ 1651:
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","C:\\Development\\webclient"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"C:\\Development\\webclient","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ 1652:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1725)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(1678),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-030d371f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1653:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1766)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(813),
  /* template */
  __webpack_require__(1719),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d6fddac6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1654:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1757)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(1710),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78745261",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1655:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1735)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(1689),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19b0c63f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1727)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(1680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0976a3b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1768)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dffbd7e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1658:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1731)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1685),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14af0ed9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1659:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1751)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1705),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68ea2e87",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1660:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1732)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1686),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14dce9b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1750)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(1704),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c9fceb4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1662:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1740)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(826),
  /* template */
  __webpack_require__(1694),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d9a511f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1663:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1747)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(827),
  /* template */
  __webpack_require__(1701),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50d96a13",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1664:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1728)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(1681),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b79e1cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1665:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1729)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1682),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ebef27e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1761)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1714),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-afb55d82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1770)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1723),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa02ab1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1668:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1763)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1716),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c0391d90",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1669:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1755)
  __webpack_require__(1754)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f5a2cfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1670:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1736)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1690),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ba72a1b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1671:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1726)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(1679),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03179529",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1672:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1752)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(1706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-693d4b3f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1673:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1741)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(1695),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e30d702",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1674:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1753)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(1707),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1675:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1764)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1717),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cc829a0e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1676:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1767)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1720),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-daec1c7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1677:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1730)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(1684),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13815d32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1678:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "bitacora"
    }
  }, [_c('div', {
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-4 col-xs-8 col-xs-offset-2"
  }, [_c('select-c', {
    attrs: {
      "name": "ducto",
      "id": "ducto",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.setVal($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('select-c', {
    attrs: {
      "name": "concepto",
      "id": "concepto",
      "options": _vm.conceptos,
      "placeholder": "CONCEPTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.setVal($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4 col-xs-8 col-xs-offset-2"
  }, [_c('c-input', {
    attrs: {
      "type": "text",
      "name": "registro",
      "cid": "comentario",
      "val": "name",
      "placeholder": "(ingrese comentario)",
      "label": "Registro (ingrese comentario)"
    },
    on: {
      "getVal": function($event) {
        _vm.comentario = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "buttons"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-6 col-sm-5 col-sm-offset-4 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default text-uppercase waves-effect waves-light"
  }, [_vm._v("limpiar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default text-uppercase waves-effect waves-light",
    class: [(_vm.comentario === '' || _vm.ducto === '' || _vm.concepto === '') ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.postBitacora()
      }
    }
  }, [_vm._v("guardar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-1 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'desde')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'hasta')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('select-c', {
    attrs: {
      "name": "ductoGet",
      "id": "ductoGet",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        _vm.ductoGet = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('select-c', {
    attrs: {
      "name": "conceptoGet",
      "id": "conceptoGet",
      "options": _vm.conceptos,
      "placeholder": "CONCEPTO"
    },
    on: {
      "changeSelect": function($event) {
        _vm.conceptoGet = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-sm-offset-0 col-xs-8 col-xs-offset-2",
    attrs: {
      "id": "buscar"
    }
  }, [_c('button', {
    staticClass: "btn btn-default text-uppercase waves-effect waves-light",
    class: [(_vm.desde === '' || _vm.hasta === '' || _vm.ductoGet === '' || _vm.conceptoGet === '') ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.searchBitacora()
      }
    }
  }, [_vm._v("Buscar")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEx),
      expression: "showEx"
    }],
    attrs: {
      "href": ""
    }
  }, [_c('json-ex', {
    attrs: {
      "data": _vm.jsonData,
      "fields": _vm.jsonFields,
      "name": ("Bitacora-" + _vm.ductoGet + "-" + _vm.desde + "-" + _vm.hasta + ".xls"),
      "meta": _vm.jsonMeta
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row tabla-bottom",
    attrs: {
      "id": "tabla"
    }
  }, [_c('c-table', {
    attrs: {
      "id": "bitacora",
      "data": _vm.getBitacora,
      "names": _vm.bitacoraNames,
      "modalTarget": "#bitacora-modal"
    },
    on: {
      "mapMarker": function($event) {
        return _vm.changeMarkers($event)
      }
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "bitacora",
      "markerList": _vm.list
    }
  }, [_c('c-map', {
    attrs: {
      "mcClass": "modal",
      "markerList": _vm.list
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-header', {
    staticClass: "card-header"
  }, [_c('div', [_vm._v("Presión actual")])]), _vm._v(" "), _c('md-card-content', [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-25"
  }, [_c('span', {
    staticClass: "main-text"
  }, [_vm._v("\n              Ducto :\n            ")]), _vm._v(" "), (this.site_info !== null) ? _c('span', {
    staticClass: "detail-text"
  }, [_vm._v("\n             " + _vm._s(this.site_info.section_name) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-30"
  }, [_c('span', {
    staticClass: "main-text"
  }, [_vm._v("\n              Ubicación :\n            ")]), _vm._v(" "), (this.site_info !== null) ? _c('span', {
    staticClass: "detail-text"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": this.map_link
    }
  }, [_vm._v("\n                " + _vm._s(this.site_info.site_lat) + ", " + _vm._s(this.site_info.site_lon) + "\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-40"
  }, [_c('span', {
    staticClass: "main-text"
  }, [_vm._v("\n              Ultima transmisión de datos :\n            ")]), _vm._v(" "), (this.site_info !== null) ? _c('span', {
    staticClass: "detail-text"
  }, [_vm._v("\n              " + _vm._s(this.last_update) + "            \n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-25"
  }, [_c('span', {
    staticClass: "main-text"
  }, [_vm._v("\n              Sitio :\n            ")]), _vm._v(" "), (this.site_info !== null) ? _c('span', {
    staticClass: "detail-text"
  }, [_vm._v("\n             " + _vm._s(this.site_info.site_name) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-30"
  }, [_c('span', {
    staticClass: "main-text"
  }, [_vm._v("\n              Presión actual :\n            ")]), _vm._v(" "), (this.site_info !== null) ? _c('span', {
    staticClass: "detail-text"
  }, [_vm._v("\n              " + _vm._s(this.pressure + ' kg/cm2') + "              \n            ")]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [(this.isChartVisible) ? _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    ref: "realtimeChart",
    attrs: {
      "type": "line",
      "height": "350",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.isEmpty) ? _c('md-empty-state', {
    attrs: {
      "md-rounded": "",
      "md-icon": "warning",
      "md-label": "No hay datos",
      "md-description": "No hay datos disponibles en este momento, vuelva a intentar."
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1680:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: [(this.$store.state.cclick === false) ? 'hidden' : ''],
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "graficas"
    }
  }, [_c('div', {
    attrs: {
      "id": "line-charts"
    }
  }, [_c('line-chart', {
    ref: "chart",
    attrs: {
      "height": 200,
      "chartData": _vm.datacollection,
      "options": _vm.chartOps
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn-chart",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal2-modal"
    }
  }, [_vm._v(" Iniciar sesión")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1681:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.cclass,
    style: (_vm.wStyle),
    attrs: {
      "id": "map-div"
    }
  }, [_c('div', {
    staticClass: "center-block full",
    class: _vm.mcClass,
    style: (_vm.mcStyle),
    attrs: {
      "id": "map_canvas"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "alarm",
    attrs: {
      "muted": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "static/audio/alarm.mp3",
      "type": "audio/mp3"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/audio/alarm.wav",
      "type": "audio/wav"
    }
  }), _vm._v(" Your browser does not support the audio element.\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ 1682:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-input"
  }, _vm._l((_vm.code), function(digit, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.code[index]),
        expression: "code[index]"
      }],
      key: index,
      ref: "inputs",
      refInFor: true,
      attrs: {
        "type": "text",
        "maxlength": "1"
      },
      domProps: {
        "value": (_vm.code[index])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.code, index, $event.target.value)
        }, function($event) {
          return _vm.onInput(index)
        }],
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "backspace", undefined, $event.key, undefined)) { return null; }
          return _vm.onBackspace(index)
        }
      }
    })
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 1683:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.idName
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._t("default", [_vm._v("\n\t\tDownload " + _vm._s(_vm.name) + "\n\t")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1684:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    staticStyle: {
      "width": ""
    },
    attrs: {
      "id": "main",
      "600px;height:400px;": ""
    }
  })])
}]}

/***/ }),

/***/ 1685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "reportes-page"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12",
    staticStyle: {
      "border-right": "2px solid #999"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center",
    attrs: {
      "height": "30px"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "20px",
      "margin-right": "30px",
      "display": "inline"
    }
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        _vm.fecha = $event
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {},
    on: {
      "click": function($event) {
        return _vm.actualizar()
      }
    }
  }, [_vm._v(" ACTUALIZAR ")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.tablaConteo), function(row, key, index) {
    return _c('tr', {
      key: key,
      staticClass: "text-center"
    }, _vm._l((row), function(r, k, i) {
      return _c('td', {
        key: k,
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(" " + _vm._s(r) + " ")])
    }), 0)
  }), _vm._v(" "), _c('tr', {
    staticClass: "organgeTR"
  }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.sitiosTotal) + " ")])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._m(3), _vm._v(" "), _vm._l((_vm.tablaFuera), function(row, key, index) {
    return _c('tr', {
      key: key,
      staticClass: "text-center",
      attrs: {
        "id": 'alarm-' + key
      }
    }, _vm._l((row), function(r, k, i) {
      return _c('td', {
        key: k
      }, [_vm._v(_vm._s(r))])
    }), 0)
  }), _vm._v(" "), _vm._m(4)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "height": "50vh"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_vm._m(6), _vm._v(" "), _vm._l((_vm.tablaInfo), function(row, key, index) {
    return _c('tr', {
      key: key,
      staticClass: "text-center",
      attrs: {
        "id": 'alarm-' + key
      }
    }, _vm._l((row), function(r, k, i) {
      return _c('td', {
        key: k,
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v(" " + _vm._s(r) + " ")])
    }), 0)
  }), _vm._v(" "), _vm._m(7)], 2)])])])]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.info.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center nombre-alarma"
  }, [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Conteo General de Eventos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Ducto")]), _vm._v(" "), _c('td', [_vm._v("Alarmas")]), _vm._v(" "), _c('td', [_vm._v("Sitios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center nombre-alarma"
  }, [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Estaciones Fuera de Línea")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "text-center",
    attrs: {
      "height": "30px"
    }
  }, [_c('td', [_vm._v(" Ducto ")]), _vm._v(" "), _c('td', [_vm._v(" Estación ")]), _vm._v(" "), _c('td', [_vm._v(" Última Recepción ")]), _vm._v(" "), _c('td', [_vm._v(" Horas Activo ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "organgeTR"
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center nombre-alarma"
  }, [_c('th', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Información General Ductos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "text-center",
    attrs: {
      "height": "30px"
    }
  }, [_c('td', [_vm._v(" Ducto ")]), _vm._v(" "), _c('td', [_vm._v(" No. Est ")]), _vm._v(" "), _c('td', [_vm._v(" Km. Inicial ")]), _vm._v(" "), _c('td', [_vm._v(" Km. Final ")]), _vm._v(" "), _c('td', [_vm._v(" Km. Total ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "organgeTR"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("111")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("000")]), _vm._v(" "), _c('td')])
}]}

/***/ }),

/***/ 1686:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "historical-legacy-page"
    }
  }, [(!this.leak_detail) ? _c('div', {
    staticClass: "form-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'desde')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.desdeText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'hasta')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.hastaText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('select-c', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "ductos",
      "id": "ductosHistorico",
      "options": _vm.ductos.map(function (ducto) { return ({
        name: ducto.ducto,
        value: ducto.id
      }); }),
      "index": "text",
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.selectEvent($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect",
    class: [_vm.desde === '' || _vm.ducto === '' || _vm.validation === false ? 'disabled' : ''],
    staticStyle: {
      "margin-left": "0"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("\r\n\t\t\t\t\tBuscar\r\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('json-ex', {
    attrs: {
      "data": _vm.jsonData,
      "fields": _vm.jsonFields,
      "name": ("HDA-" + _vm.desde + "-" + _vm.hasta + ".xls"),
      "meta": _vm.jsonMeta
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('google-maps', {
    ref: "map",
    attrs: {
      "mcStyle": _vm.mcStyle,
      "mcClass": "half",
      "wStyle": _vm.wStyle
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, _vm._l((_vm.jsonFields), function(row, key, index) {
    return (row !== 'Id') ? _c('th', {
      key: key
    }, [_vm._v("\r\n\t\t\t\t\t\t\t" + _vm._s(key) + "\r\n\t\t\t\t\t\t")]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.historicoMiddlePoints) || _vm.historico), function(row, key) {
    return _c('tr', {
      key: key,
      staticClass: "info",
      class: {
        selectedRow: _vm.selectedEventRow && row.id === _vm.selectedEventRow.id
      },
      attrs: {
        "id": 'alarm-' + key
      },
      on: {
        "click": function($event) {
          return _vm.onSelectRow(row)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.fecha))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.hora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lat.toFixedDown(4)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lng.toFixedDown(4)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.km))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.estado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.municipio))])])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.info.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("CONSULTA DE EVENTOS (LEGACY)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])
}]}

/***/ }),

/***/ 1687:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "reportes-page"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-1",
    attrs: {
      "id": "desde"
    }
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'desde')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.desdeText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-1",
    attrs: {
      "id": "hasta"
    }
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'hasta')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.hastaText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-1"
  }, [_c('select-c', {
    attrs: {
      "name": "desde",
      "id": "ducto",
      "placeholder": "DUCTO",
      "options": _vm.ductos
    },
    on: {
      "changeSelect": function($event) {
        return _vm.changeSelected()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2",
    attrs: {
      "id": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    class: [(_vm.desde === '' || _vm.ductoSelected === null || _vm.validation === false) ? 'disabled' : ''],
    attrs: {
      "id": "buscar-btn"
    },
    on: {
      "click": function($event) {
        return _vm.submitInfo()
      }
    }
  }, [_vm._v("\n          Buscar\n        ")])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('button', {
    staticClass: "print_btn",
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("Imprimir")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sitePdf),
      expression: "sitePdf"
    }],
    staticClass: "panel-body-two"
  }, [_c('pdf-div', {
    attrs: {
      "site": _vm.sitePdf,
      "desde": _vm.desde,
      "hasta": _vm.hasta
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.objDucto), function(r, key) {
    return _c('tbody', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.objDucto),
        expression: "objDucto"
      }],
      key: key,
      attrs: {
        "id": 'alarm-' + key
      }
    }, [_c('tr', [_c('td', {
      staticClass: "nombre-alarma",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "colspan": "7"
      }
    }, [_vm._v(" " + _vm._s(r.sites) + " ")])]), _vm._v(" "), _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (r && r.events && r.events.length > 0),
        expression: "r && r.events && r.events.length > 0"
      }]
    }, [_c('td', [_vm._v(_vm._s(r.events[0].id || 'No Info') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.events[0].fecha || 'No Info') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.events[0].lat || 'No Info') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.events[0].lng || 'No Info') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.events[0].km || 'No Info') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.events.length || 'No Info') + " ")]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.serached),
        expression: "serached"
      }],
      staticStyle: {
        "padding-left": "0",
        "text-align": "center"
      }
    }, [_c('i', {
      staticClass: "material-icons prefix file_download",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#comentarioModal"
      },
      on: {
        "click": function($event) {
          return _vm.passName(_vm.objDucto[key])
        }
      }
    }, [_vm._v("file_download")])])])])
  })], 2)])])])]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn-chart2",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }, [_vm._v(" Iniciar sesión")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "range-wrapper"
    }
  }, [_c('div', {
    staticClass: "col-sm-3 col-sm-offset-1 col-xs-3"
  }, [_c('p', {
    staticClass: "text-uppercase"
  }, [_vm._v("rango de km")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-9 color-slider"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "range",
      "name": "range",
      "value": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Lat")]), _vm._v(" "), _c('th', [_vm._v("Lng")]), _vm._v(" "), _c('th', [_vm._v("Km")]), _vm._v(" "), _c('th', [_vm._v("Eventos")]), _vm._v(" "), _c('th', [_vm._v("Descargar")])])])
}]}

/***/ }),

/***/ 1688:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "pdf"
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "row"
    }
  }, [_c('img', {
    staticClass: "logo_leak logo",
    attrs: {
      "width": "200px",
      "src": _vm.logoUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("nota informativa no.")]), _vm._v(" "), _c('div', {
    staticClass: "pdf__info"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Fecha: ")]), _vm._v(" " + _vm._s(_vm.desde) + " a " + _vm._s(_vm.hasta) + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Ducto: ")]), _vm._v(" " + _vm._s(_vm.site && _vm.site.section || '') + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Tramo: ")]), _vm._v(" " + _vm._s(_vm.site && _vm.site.sites || '') + " ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Vista satelital ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.site) ? _c('img', {
    attrs: {
      "id": "img_map",
      "src": ("" + (_vm.site.map))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('custom-line-chart', {
    attrs: {
      "pdesde": _vm.desde,
      "phasta": _vm.hasta,
      "pducto": _vm.site && _vm.site.sectionId || 'ZZ',
      "pestacion": ("" + (_vm.site && _vm.site.sitesIds || '')),
      "cclick": _vm.click
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "imgChart"
    }
  }), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tableholder"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.site) ? _c('tbody', [_vm._l((_vm.site.events), function(r, key) {
    return _c('tr', {
      key: _vm.site.sites + '-' + key,
      attrs: {
        "id": "trw"
      }
    }, [_c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.fecha) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.km) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.lat) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.lng))]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.type === 1 ? 'Apertura' : 'Cierre'))])])
  }), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "trw-mp"
    }
  }, [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" Punto medio")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.middlePoint.km.toFixed(3)) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.middlePoint.lat.toFixed(5)) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.middlePoint.lng.toFixed(5)) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  })])], 2) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Para: ")]), _vm._v(" A quien corresponda ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" De: ")]), _vm._v(" Ingeniería e Instalaciones S.A. de C.V. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    attrs: {
      "id": "header"
    }
  }, [_c('tr', {
    attrs: {
      "id": "trh"
    }
  }, [_c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Fecha Evento")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Kilometro")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Latitud")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Longitud")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Acción")])])])
}]}

/***/ }),

/***/ 1689:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "graficas"
    }
  }, [(_vm.datacollection) ? _c('div', {
    attrs: {
      "id": "line-charts"
    }
  }, [_c('line-chart', {
    ref: "chart",
    attrs: {
      "height": 400,
      "chartData": _vm.datacollection,
      "options": _vm.chartOps
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_GAES_V.51ff744.png";

/***/ }),

/***/ 1690:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('custom-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "ductos",
      "id": "ductos",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.selectedDuctoEvent($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', _vm._l((this.siteData), function(data, id) {
    return _c('md-card', {
      key: id,
      style: ([data.site.comm_online ? {
        'border-color': 'green'
      } : {
        'border-color': 'red'
      }]),
      attrs: {
        "md-with-hover": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.siteClick(data.site)
        }
      }
    }, [_c('md-ripple', [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('i', {
      staticClass: "fa fa-signal box-icons",
      style: ([data.site.comm_online ? {
        'color': 'green'
      } : {
        'color': 'red'
      }]),
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "header-text"
    }, [_vm._v(_vm._s(data.site.name))])]), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('div', {
      staticClass: "box content"
    }, [_c('span', {
      staticClass: "sub-header"
    }, [_vm._v(_vm._s(data.section.name))]), _vm._v(" "), _c('div', {
      staticClass: "md-layout md-gutter"
    }, [_c('div', {
      staticClass: "md-layout-item"
    }, [_c('i', {
      staticClass: "fa fa-map-marker card-icons",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "card-detail-text"
    }, [_vm._v("\n                  " + _vm._s(data.site.city + ', Km ' + data.site.km) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "md-layout md-gutter"
    }, [_c('div', {
      staticClass: "md-layout-item"
    }, [_c('i', {
      staticClass: "fa fa-tint card-icons",
      style: ([data.site.pressure === 0 ? {
        'color': 'red'
      } : {
        'color': 'green'
      }]),
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "card-detail-text"
    }, [_vm._v("\n                    " + _vm._s(data.site.pressure + ' kg/cm2') + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "card-small-text"
    }, [_vm._v("Presión")])]), _vm._v(" "), _c('div', {
      staticClass: "md-layout-item"
    }, [_c('i', {
      staticClass: "fa fa-power-off card-icons",
      style: ([data.site.enabled === 1 ? {
        'color': 'green'
      } : {
        'color': 'red'
      }]),
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "card-detail-text"
    }, [_vm._v("\n                    " + _vm._s(data.site.enabled === 1 ? 'Encendido' : 'Apagado') + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "card-small-text"
    }, [_vm._v("Estado")])])])]), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('div', {
      staticClass: "footer"
    }, [_c('i', {
      staticClass: "fa fa-clock-o box-icons",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "footer-text"
    }, [_vm._v("Último evento: " + _vm._s(data.site.insertTimestamp))])])], 1)])], 1)
  }), 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1691:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "pdf"
    }
  }, _vm._l((_vm.grouped), function(value, key) {
    return _c('div', {
      key: key,
      attrs: {
        "id": "rowcicle"
      }
    }, [_c('div', {
      attrs: {
        "id": "rowlogos"
      }
    }, [_c('img', {
      staticClass: "logo_leak",
      attrs: {
        "id": "leak",
        "width": "200px",
        "src": _vm.logoUrl
      }
    })]), _vm._v(" "), _c('h4', {
      attrs: {
        "id": "h41"
      }
    }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('hr', {
      staticClass: "yellow__hr",
      attrs: {
        "id": "hr1"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pdf__info",
      attrs: {
        "id": "pdf_info"
      }
    }, [_c('p', [_c('span', {
      staticClass: "pdf__titles",
      attrs: {
        "id": "titles"
      }
    }, [_vm._v(" Estación: ")]), _vm._v(" " + _vm._s(key) + " ")]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pdf__titles",
      attrs: {
        "id": "titles"
      }
    }, [_vm._v(" Ducto: ")]), _vm._v(" " + _vm._s(_vm.duct) + " ")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "tablecontainer"
      }
    }, [_c('table', {
      attrs: {
        "id": "tableholder"
      }
    }, [_c('thead', {
      attrs: {
        "id": "header"
      }
    }, [_c('tr', {
      attrs: {
        "id": "trh"
      }
    }, [_c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Fecha de Solicitud")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Mensaje")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Fecha de Recepción")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Presión")]), _vm._v(" "), (_vm.showViewColumn === 'true') ? _c('th', {
      staticClass: "title__td print-hidden",
      attrs: {
        "id": "thh"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((value), function(a) {
      return _c('tr', {
        class: {
          'highlight': a.samePressure
        },
        attrs: {
          "id": "trw"
        }
      }, [_c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.r_ts) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.r_f) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.i_ts) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_c('span', {
        class: {
          'highlight': a.samePressure
        }
      }, [_vm._v(" " + _vm._s(a.p) + " ")])]), _vm._v(" "), (_vm.showViewColumn === 'true') ? _c('td', {
        staticClass: "print-hidden"
      }, [_c('div', {
        staticClass: "center-option"
      }, [_c('i', {
        staticClass: "fa fa-eye",
        attrs: {
          "aria-hidden": "true",
          "title": "Ver detalles"
        },
        on: {
          "click": function($event) {
            return _vm.open(a)
          }
        }
      })])]) : _vm._e()])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "bottom-offset",
      attrs: {
        "id": 'imgChart-' + _vm.filterLettersAndNumbers(key)
      }
    }), _vm._v(" "), _c('div', {
      class: {
        'hide-line-chart': _vm.isChartDisplayed
      },
      attrs: {
        "id": "linechart"
      }
    }, [_c('line-chart', {
      class: _vm.filterLettersAndNumbers(key),
      staticStyle: {
        "opacity": "0.0"
      },
      attrs: {
        "chartData": _vm.getChartDataFromSite({
          key: key,
          value: value
        }),
        "options": _vm.chartOptions,
        "width": 300,
        "height": 200
      },
      on: {
        "onAnimationComplete": _vm.onAnimationComplete
      }
    })], 1)])])
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 1692:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "reportes-page"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-1",
    attrs: {
      "id": "desde"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'desde')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.desdeText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "id": "hasta"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'hasta')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.hastaText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "desde",
      "id": "ducto",
      "placeholder": "DUCTO",
      "options": _vm.ductos
    },
    on: {
      "changeSelect": function($event) {
        return _vm.changeSelected()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "estacion",
      "id": "estacion",
      "placeholder": "ESTACION",
      "options": _vm.estacionesOps
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-0",
    attrs: {
      "id": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    class: [(_vm.desde === '' || _vm.ductoSelected === null || _vm.validation === false) ? 'disabled' : ''],
    attrs: {
      "id": "buscar-btn"
    },
    on: {
      "click": function($event) {
        return _vm.submitInfo()
      }
    }
  }, [_vm._v("\n          Buscar\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDetails),
      expression: "!showDetails"
    }],
    staticClass: "col-md-7 col-xs-12"
  }, [_c('button', {
    staticClass: "print_btn",
    on: {
      "click": function($event) {
        return _vm.Popup()
      }
    }
  }, [_vm._v("Imprimir")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sitePdf),
      expression: "sitePdf"
    }],
    staticClass: "panel-body-two",
    attrs: {
      "id": "panel-body-two"
    }
  }, [_c('pdf-div', {
    attrs: {
      "duct": _vm.ductsender,
      "site": _vm.sitePdf,
      "desde": _vm.desde,
      "hasta": _vm.hasta,
      "chartLimit": "24",
      "isDetails": "false",
      "showViewColumn": "true",
      "header": "Reporte de Poll y Presiones"
    },
    on: {
      "openDetails": function($event) {
        return _vm.openDetails($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }],
    staticClass: "col-md-7 col-xs-12"
  }, [_c('button', {
    staticClass: "print_btn",
    on: {
      "click": function($event) {
        return _vm.showReport()
      }
    }
  }, [_vm._v("Regresar")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }],
    staticClass: "panel-body-two",
    attrs: {
      "id": "panel-body-two"
    }
  }, [_c('pdf-div', {
    attrs: {
      "duct": _vm.ductsender,
      "site": _vm.siteDetailsPdf,
      "desde": _vm.desde,
      "hasta": _vm.hasta,
      "datetimeTag": _vm.datetimeTag,
      "chartLimit": "7",
      "isDetails": "true",
      "showViewColumn": "false",
      "header": "Detalle de Poll y Presiones"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "nombre-alarma",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" Ducto: " + _vm._s(this.ductoNameSelected) + " ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tbody', _vm._l((this.data), function(a, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pdfName(key)))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-eye view-report",
      attrs: {
        "aria-hidden": "true",
        "title": "Ver reporte",
        "data-toggle": "modal",
        "data-target": "#comentarioModal"
      },
      on: {
        "click": function($event) {
          return _vm.open(key)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-file-excel-o view-report",
      attrs: {
        "aria-hidden": "true",
        "title": "Descargar archivo Excel",
        "data-toggle": "modal",
        "data-target": "#comentarioModal"
      },
      on: {
        "click": function($event) {
          return _vm.downloadExcel(key)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-download view-report",
      attrs: {
        "aria-hidden": "true",
        "title": "Descargar archivo CSV",
        "data-toggle": "modal",
        "data-target": "#comentarioModal"
      },
      on: {
        "click": function($event) {
          return _vm.downloadCSV(key)
        }
      }
    })])])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn-chart2",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th')])
}]}

/***/ }),

/***/ 1693:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-2 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        _vm.desde = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        _vm.hasta = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "ducto",
      "id": "ducto",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.setEstaciones($event)
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-3"
  }, [_c('select-c', {
    attrs: {
      "name": "estaciones",
      "id": "estaciones",
      "options": _vm.estaciones,
      "placeholder": "ESTACIONES"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "separacion",
      "id": "separacion",
      "options": _vm.options,
      "placeholder": "SEPARACION"
    }
  })], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "graficas"
    }
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "app"
    }
  }, [_c('line-chart', {
    attrs: {
      "id": "line",
      "data": _vm.line,
      "xkey": "year",
      "ykeys": "[ \"and\", \"ios\", \"win\" ]",
      "line-colors": "[ \"#FF0000\", \"#36A2EB\", \"#FFCE56\" ]",
      "grid": "true",
      "grid-text-weight": "bold",
      "resize": "true"
    }
  })], 1)]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " checkbox col-sm-2",
    attrs: {
      "id": "check"
    }
  }, [_c('label', {
    staticClass: "text-uppercase"
  }, [_c('input', {
    attrs: {
      "id": "auto-refresh",
      "type": "checkbox",
      "value": "true"
    }
  }), _vm._v("auto-refrescar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "id": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light"
  }, [_vm._v("\n          Buscar\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-xs-12 nomen"
  }, [_c('h4', [_vm._v("Nomenclatura")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('hr', {
    staticStyle: {
      "background-color": "red",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "background-color": "#36A2EB",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "background-color": "#FFCE56",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("REP SALAMANCA")]), _vm._v(" "), _c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("VS STA ELENA")]), _vm._v(" "), _c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("VS STA MONICA")])])])
}]}

/***/ }),

/***/ 1694:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "home-container"
    }
  }, [_c('google-maps', {
    ref: "map",
    staticStyle: {
      "padding": "0"
    }
  }), _vm._v(" "), _c('data-table', {
    ref: "home_data_table",
    attrs: {
      "parentRefs": this.$refs
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1695:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-3"
  }, [_c('select-c', {
    attrs: {
      "name": "estaciones",
      "id": "estaciones",
      "options": _vm.options,
      "placeholder": "ESTACIONES"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "separacion",
      "id": "separacion",
      "options": _vm.options,
      "placeholder": "SEPARACIÓN"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.alarmType), function(row, key, index) {
    return _c('tbody', {
      key: key,
      attrs: {
        "id": 'alarm-' + key
      }
    }, [_vm._m(2, true)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('google-maps', {
    attrs: {
      "cclass": "col-md-6 col-xs-12",
      "mcStyle": _vm.mcStyle,
      "mcClass": "half",
      "wStyle": _vm.wStyle
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "graficas"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "app"
    }
  }, [_c('line-chart', {
    attrs: {
      "id": "line",
      "data": _vm.line,
      "xkey": "year",
      "ykeys": "[ \"and\", \"ios\", \"win\" ]",
      "line-colors": "[ \"#FF0000\", \"#36A2EB\", \"#FFCE56\" ]",
      "grid": "true",
      "grid-text-weight": "bold",
      "resize": "true"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "id": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light"
  }, [_vm._v("\n          Buscar\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center nombre-alarma"
  }, [_c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("Fecha\n                  "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Lat")]), _vm._v(" "), _c('th', [_vm._v("Lng")]), _vm._v(" "), _c('th', [_vm._v("Km")]), _vm._v(" "), _c('th', [_vm._v("Tramo")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Asignación")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("2016-07-21\n                  "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('th', [_vm._v("132.5\t")]), _vm._v(" "), _c('th', [_vm._v("-5.2134\t")]), _vm._v(" "), _c('th', [_vm._v("1234")]), _vm._v(" "), _c('th', [_vm._v("toluca-df")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-xs-12 nomen"
  }, [_c('h4', [_vm._v("Nomenclatura")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('hr', {
    staticStyle: {
      "background-color": "red",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "background-color": "#36A2EB",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "background-color": "#FFCE56",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("REP SALAMANCA")]), _vm._v(" "), _c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("VS STA ELENA")]), _vm._v(" "), _c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("VS STA MONICA")])])])
}]}

/***/ }),

/***/ 1696:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "group",
    class: _vm.colorChng
  }, [_c('input', {
    class: _vm.cclass,
    style: (_vm.cstyle),
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "id": _vm.customid,
      "test-val": _vm.val,
      "required": ""
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": function($event) {
        return _vm.validation(_vm.val)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1697:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.cclass,
    style: (_vm.wStyle),
    attrs: {
      "id": "map-div"
    }
  }, [_c('div', {
    staticClass: "center-block full",
    class: _vm.mcClass,
    style: (_vm.mcStyle),
    attrs: {
      "id": "map_canvas"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1698:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "info text-center"
  }, [_c('h4', {
    class: 'text-uppercase ' + (_vm.info.spinner ? '--searching' : (_vm.info.success ? '--success' : '--warning'))
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.info.spinner),
      expression: "!info.spinner"
    }],
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        " + _vm._s(_vm.info.title) + "\n      ")]), _vm._v(" "), (_vm.info.spinner) ? _c('h5', [_c('i', {
    staticClass: "custom-loading-color fa fa-spinner fa-spin fa-4x fa-fw"
  })]) : _c('h5', [_vm._v("\n        " + _vm._s(_vm.info.msg) + "\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.info.spinner),
      expression: "!info.spinner"
    }],
    class: 'btn btn-' + (_vm.info.success ? 'success' : 'danger'),
    attrs: {
      "id": "info-button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Regresar")])])]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "dismiss-button",
      "data-dismiss": "modal"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1699:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(this.$route.path !== '/' && this.$route.path !== '/login' && this.$store.state && this.$store.state.user) ? _c('div', [_c('side-menu')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "router-view"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "loading-general"
    }
  }, [_c('loading', {
    ref: "l_gen_m",
    attrs: {
      "info": {}
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1700:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalValue),
      expression: "internalValue"
    }],
    attrs: {
      "name": _vm.name,
      "id": _vm.id
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.internalValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _vm._l((_vm.options), function(op, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": op.value || op
      }
    }, [_vm._v(_vm._s(op.name || op))])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1701:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-container",
    attrs: {
      "id": "login"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl()
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('md-field', [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('md-field', {
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Contraseña")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "actions md-layout md-alignment-center"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Iniciar Sesión")])], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.modalInfo
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1702:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.name + '-modal',
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    class: _vm.cclass
  }, [_vm._t("default", [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          div.modal-header\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n          div.modal-body\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._v("\n          div.modal-footer\n        ")])])], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1703:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(!_vm.ready) ? _c('div', {
    staticClass: "loading__login"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "info text-center"
  }, [_c('h4', {
    staticClass: "text-uppercase"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        " + _vm._s(_vm.info.msg) + "\n     ")]), _vm._v(" "), _c('h5', [_vm._v("\n        " + _vm._s(_vm.info.subMsg) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "id": "info-button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cerrar")])])]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "dismiss-button",
      "data-dismiss": "modal"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "custom-loading-color fa fa-spinner fa-spin fa-5x fa-fw"
  })])
}]}

/***/ }),

/***/ 1704:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: {
      transparent: !_vm.seen
    },
    style: ([_vm.seen ? {
      '': ''
    } : {
      'height': '44px'
    }]),
    attrs: {
      "id": "data-table"
    }
  }, [_c('div', {
    staticClass: "row text-center",
    class: {
      transparent: true
    }
  }, [_c('button', {
    staticClass: "oc-button",
    on: {
      "click": function($event) {
        _vm.seen = !_vm.seen
      }
    }
  }, [_vm._v("Ocultar/Mostrar")])]), _vm._v(" "), (_vm.seen) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "main-row"
    }
  }, [_c('div', {
    staticClass: "col",
    attrs: {
      "id": "alarmas"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading text-center"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('span', {
    attrs: {
      "id": "no-reconocidas"
    },
    on: {
      "click": function($event) {
        return _vm.recAlarm(0)
      }
    }
  }, [_vm._v(" Alarmas No Reconocidas ")]), _vm._v(" "), _c('span', {
    staticClass: "not-active",
    attrs: {
      "id": "reconocidas"
    },
    on: {
      "click": function($event) {
        return _vm.recAlarm(1)
      }
    }
  }, [_vm._v(" Alarmas Reconocidas ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("Ciudad")]), _vm._v(" "), _c('th', [_vm._v("Latitud")]), _vm._v(" "), _c('th', [_vm._v("Longitud")]), _vm._v(" "), _c('th', [_vm._v("Km")]), _vm._v(" "), _c('th', [_vm._v("Tramo")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Presión")]), _vm._v(" "), (_vm.alarmIndex === 1) ? _c('th', [_vm._v("Reconocimiento")]) : _vm._e(), _vm._v(" "), (_vm.alarmIndex === 1) ? _c('th', [_vm._v("Usuario")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.groupedLeaks), function(group, sectionName) {
    return _c('tbody', {
      key: sectionName
    }, [_c('tr', [_c('td', {
      staticClass: "nombre-alarma",
      attrs: {
        "colspan": _vm.alarmIndex === 1 ? 16 : 14
      }
    }, [_vm._v("Ducto: " + _vm._s(sectionName))])]), _vm._v(" "), _vm._l((group), function(leak) {
      return _c('tr', {
        key: leak.id,
        class: ['info'],
        attrs: {
          "id": ((leak.id) + "-trAlarmaH")
        },
        on: {
          "click": function($event) {
            return _vm.leakClicked(leak)
          }
        }
      }, [_c('td', [_c('router-link', {
        attrs: {
          "to": {
            path: 'historico/' + leak.id
          },
          "target": "_blank"
        }
      }, [_vm._v("Abrir")])], 1), _vm._v(" "), _c('td', {
        staticClass: "table-option"
      }, [(_vm.isAllowedToIdentifyLeak) ? _c('button', {
        attrs: {
          "title": "Identificar fuga"
        },
        on: {
          "click": function($event) {
            return _vm.identifyLeak(leak)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-check-square-o identify-leak",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e(), _vm._v(" "), (!_vm.isAllowedToIdentifyLeak) ? _c('button', {
        attrs: {
          "title": "Ver fuga"
        },
        on: {
          "click": function($event) {
            return _vm.leakClicked(leak)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-eye open-leak",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "table-option",
        attrs: {
          "title": _vm.getLeakDescription(leak)
        }
      }, [_c('i', {
        class: _vm.getIcon(leak),
        style: (_vm.getColor(leak)),
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "table-option"
      }, [_c('button', {
        attrs: {
          "title": "Ubicar fuga"
        },
        on: {
          "click": function($event) {
            return _vm.locateLeak(leak)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-map-marker",
        attrs: {
          "aria-hidden": "true"
        }
      })])]), _vm._v(" "), _c('td', {
        staticClass: "table-option"
      }, [_c('div', {
        attrs: {
          "hidden": ""
        }
      }, [_c('input', {
        attrs: {
          "type": "text",
          "id": ("clipboard_" + (leak.id))
        },
        domProps: {
          "value": _vm.clipboardText(leak)
        }
      })]), _vm._v(" "), _c('button', {
        attrs: {
          "title": "Copiar al porta papeles"
        },
        on: {
          "click": function($event) {
            return _vm.copyToClipboardClick(("clipboard_" + (leak.id)))
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-clipboard",
        attrs: {
          "aria-hidden": "true"
        }
      })])]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(leak.formattedDetectionTimestamp || 'No Timestamp Available'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.states))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.cities))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.lat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.lon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.km))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.formattedSiteName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((Number(leak._type) <= 1 ? 'Apertura' : 'Cierre')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.pressure_1 + ' kg/cm2 - ' + leak.pressure_2 + ' kg/cm2') + " ")]), _vm._v(" "), (_vm.alarmIndex === 1) ? _c('td', [_vm._v(_vm._s(leak.recognized_timestamp))]) : _vm._e(), _vm._v(" "), (_vm.alarmIndex === 1) ? _c('td', [_vm._v(_vm._s(leak.recognized_username))]) : _vm._e()])
    })], 2)
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "comentario"
    }
  }, [_c('div', {
    staticClass: "modal-body row"
  }, [_c('h5', {
    staticClass: "modal-title text-uppercase",
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "id": "lineModalLabel"
    }
  }, [_vm._v("Ubicación en el mapa")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "id": "label-name",
      "for": "comentarios"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comentario),
      expression: "comentario"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "comentarios",
      "placeholder": "Haz un comentario"
    },
    domProps: {
      "value": (_vm.comentario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comentario = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "selectDonde"
    }
  }, [_vm._v("Elige un concepto")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    attrs: {
      "name": "selectDonde",
      "id": "selectDonde"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "disabled",
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select one")]), _vm._v(" "), _vm._l((_vm.conceptos), function(val, key, index) {
    return _c('option', {
      key: key,
      domProps: {
        "value": val.value
      }
    }, [_vm._v(" " + _vm._s(val.name) + " ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group",
      "aria-label": "group button"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "role": "button"
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-delete hidden",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "id": "delImage",
      "data-dismiss": "modal",
      "role": "button"
    }
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    class: [(_vm.comentario === '' || _vm.selected === '') ? 'disabled' : ''],
    attrs: {
      "type": "submit",
      "id": "saveImage",
      "data-action": "save",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.postBitacora()
      }
    }
  }, [_vm._v("Guardar")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("\n                  Fecha"), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ 1705:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-3 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        return _vm.desdeEvent($event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "center-block",
    staticStyle: {
      "position": "absolute",
      "color": "red"
    },
    attrs: {
      "for": "desde"
    }
  }, [_vm._v(" " + _vm._s(_vm.desdeText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        return _vm.hastaEvent($event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "center-block",
    staticStyle: {
      "position": "absolute",
      "color": "red"
    },
    attrs: {
      "for": "hasta"
    }
  }, [_vm._v(" " + _vm._s(_vm.hastaText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('select-c', {
    attrs: {
      "name": "ducto",
      "id": "ducto",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.setEstaciones($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-3 col-xs-8 col-xs-offset-2",
    attrs: {
      "id": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    class: [(_vm.desde === '' || _vm.ductos === [] || _vm.validation === false) ? 'disabled' : ''],
    attrs: {
      "id": "buscar-btn"
    },
    on: {
      "click": function($event) {
        return _vm.GET_DIRECTION_TRENDS()
      }
    }
  }, [_vm._v("\n          Buscar\n        ")])]), _vm._v(" "), (_vm.showNewWindow) ? _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2",
    attrs: {
      "id": ""
    }
  }, [_c('router-link', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "tag": "a",
      "to": ("/barchart/" + _vm.desde + "/" + _vm.hasta + "/" + _vm.ducto + "/" + (_vm.estacion || -1)),
      "target": "_blank",
      "id": "new-window"
    }
  }, [_vm._v("\n          Abrir en nueva ventana\n        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "graficas"
    }
  }, [_c('div', {
    attrs: {
      "id": "line-chart"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('center', [_c('h5', {
    staticStyle: {
      "color": "#0d6768",
      "padding-bottom": "30px"
    }
  }, [_vm._v("Eventos por Tramo")])]), _vm._v(" "), _c('pie-chart-duct', {
    attrs: {
      "chartData": _vm.DuctDatac,
      "width": 300,
      "height": 250
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('center', [_c('h5', {
    staticStyle: {
      "color": "#0d6768",
      "padding-bottom": "30px"
    }
  }, [_vm._v("Eventos por Municipio")])]), _vm._v(" "), _c('pie-chart-city', {
    attrs: {
      "chartData": _vm.CityDatac,
      "width": 300,
      "height": 250
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row container1"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('center', [_c('h5', {
    staticStyle: {
      "color": "#0d6768",
      "padding-bottom": "50px"
    }
  }, [_vm._v("Eventos por Kilometraje")])]), _vm._v(" "), _c('bar-chart', {
    attrs: {
      "chartData": _vm.KMsDatac,
      "options": _vm.chartOps,
      "width": 1000,
      "height": 400
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "id": "graficas"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }, [_vm._v(" Iniciar sesión")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1706:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid unauthorized"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "formulario-top"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("VOLVER!")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title.toUpperCase()))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description.toUpperCase()))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signboard"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  })])
}]}

/***/ }),

/***/ 1707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sidebar-menu', {
    attrs: {
      "width": "300px",
      "menu": _vm.menu,
      "collapsed": _vm.collapsed
    },
    on: {
      "toggle-collapse": _vm.onToggleCollapse,
      "item-click": _vm.onItemClick
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.collapsed) ? [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('img', {
    staticClass: "logo img-fluid",
    attrs: {
      "src": _vm.logoUrlIcon,
      "alt": ""
    }
  })])] : [_c('div', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('img', {
    staticClass: "logo img-fluid",
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "login"
  }, [_vm._v("Bienvenido")]), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('b', [_vm._v(_vm._s(_vm.getUserName))])])])], 1)]], 2)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "toggle-icon"
    },
    slot: "toggle-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrows-h",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "slot": "dropdown-icon"
    },
    slot: "dropdown-icon"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "cambiar-contrasena"
    }
  }, [_c('cambiar-contra')], 1), _vm._v(" "), (_vm.isAdmin) ? _c('modal', {
    attrs: {
      "name": "registrar-usuario"
    }
  }, [_c(_vm.isAdmin ? 'RegistrarUsuario' : null, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('modal', {
    attrs: {
      "name": "actualizar-usuario"
    }
  }, [_c(_vm.isAdmin ? 'ActualizarUsuario' : null, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ayuda"
    }
  }, [_c('ayuda')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "changelog"
    }
  }, [_c('changelog')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('button', {
    ref: "changePassBtn",
    attrs: {
      "onclick": "$('#cambiar-contrasena-modal').modal('show');"
    },
    on: {
      "click": _vm.menuBtnClick
    }
  }), _vm._v(" "), (_vm.isAdmin) ? _c('button', {
    ref: "registerUserBtn",
    attrs: {
      "onclick": "$('#registrar-usuario-modal').modal('show');"
    },
    on: {
      "click": _vm.menuBtnClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('button', {
    ref: "updateUserBtn",
    attrs: {
      "onclick": "$('#actualizar-usuario-modal').modal('show');"
    },
    on: {
      "click": _vm.menuBtnClick
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    ref: "helpBtn",
    attrs: {
      "onclick": "$('#ayuda-modal').modal('show');"
    },
    on: {
      "click": _vm.menuBtnClick
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container md-layout-column"
  }, [_c('md-drawer', {
    staticClass: "md-right",
    attrs: {
      "md-active": _vm.showSidepanel
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showSidepanel = $event
      },
      "update:md-active": function($event) {
        _vm.showSidepanel = $event
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "toolbar-title",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Filtros")])]), _vm._v(" "), _c('md-list', [_c('md-list-item', [_c('div', {
    staticClass: "md-list-item-text"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.onApplyFilter()
      }
    }
  }, [_vm._v("Aplicar")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-list-item-text pressure-range"
  }, [_c('md-subheader', [_vm._v("Rango de fechas")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.dateFrom
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'selectedDateFrom')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.desdeText))]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.dateTo
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'selectedDateTo')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.hastaText))])], 1)]), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-layout-item"
  }, [_c('md-subheader', {
    attrs: {
      "for": "selectedDucto"
    }
  }, [_vm._v("Ducto")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "custom-select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.ductos,
      "max-height": 200,
      "placeholder": "Seleccione el ducto",
      "label": "section_name",
      "track-by": "id_section",
      "selectLabel": "Seleccionar",
      "deselectLabel": "Deseleccionar"
    },
    model: {
      value: (_vm.selectedDucto),
      callback: function($$v) {
        _vm.selectedDucto = $$v
      },
      expression: "selectedDucto"
    }
  })], 1), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-layout-item"
  }, [_c('md-subheader', {
    attrs: {
      "for": "selectedStations"
    }
  }, [_vm._v("Estaciones")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "custom-select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredStations,
      "max-height": 200,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "selectLabel": "◯",
      "selectedLabel": "✔",
      "deselectLabel": "✖",
      "placeholder": "Seleccione las estaciones",
      "label": "site_name",
      "track-by": "id_site",
      "selectGroupLabel": "Seleccionar todo",
      "deselectGroupLabel": "Deseleccionar todo",
      "group-values": "sites",
      "group-label": "section_name",
      "group-select": true
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(values.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(values.length) + "\n              activa(s)")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selectedStations),
      callback: function($$v) {
        _vm.selectedStations = $$v
      },
      expression: "selectedStations"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noOptions"
  }, [_vm._v("Lista vacía")]), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("No se encontraron resultados")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('md-content', [(this.isChartVisible) ? _c('div', {
    staticClass: "chart-container"
  }, _vm._l((this.seriesList), function(row, index) {
    return _c('div', {
      key: row.name,
      attrs: {
        "index": index
      }
    }, [_c('md-toolbar', {
      staticClass: "toolbar-title",
      attrs: {
        "md-elevation": "0"
      }
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(row.name))])]), _vm._v(" "), _c('apexchart', {
      ref: "rows",
      refInFor: true,
      attrs: {
        "height": "300",
        "options": row.options,
        "series": row.series
      }
    }), _vm._v(" "), (row.loading) ? _c('div', {
      staticClass: "loading-spinner"
    }, [_c('div', [_c('p', [_c('i', {
      staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
    })]), _vm._v(" "), _c('p', [_vm._v("Cargando...")])])]) : (row.error) ? _c('div', {
      staticClass: "error-message"
    }, [_c('span', [_vm._v("No fue posible cargar los datos, intente reducir el rango de fechas")])]) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (this.isInitialSetup) ? _c('md-empty-state', {
    attrs: {
      "md-rounded": "",
      "md-icon": "settings",
      "md-label": "Nada que graficar",
      "md-description": "Seleccione las opciones de graficas desde el boton de agregar filtros"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-speed-dial', {
    staticClass: "md-bottom-right",
    attrs: {
      "md-direction": "bottom",
      "md-event": "click"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showSidepanel = true
      }
    }
  }, [_c('md-speed-dial-target', {
    staticClass: "md-primary"
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "reportes-poll-page"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-2 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        _vm.desde = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('select-c', {
    attrs: {
      "name": "ducto",
      "id": "ducto",
      "placeholder": "Ducto",
      "options": _vm.ductos
    },
    on: {
      "changeSelect": function($event) {
        return _vm.chooseEstacion()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('select-c', {
    attrs: {
      "name": "estacion",
      "id": "estacion",
      "placeholder": "Estacion",
      "options": _vm.estacionesOps
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: [],
    staticStyle: {},
    on: {
      "click": function($event) {
        return _vm.actualizar()
      }
    }
  }, [_vm._v(" ACTUALIZAR ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "border-right": "2px solid #999"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table text-center"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.estaciones), function(est, key) {
    return _c('tbody', {
      key: key,
      attrs: {
        "id": 'alarm-' + key
      }
    }, [_c('tr', {
      staticClass: "text-center"
    }, [_c('th', {
      staticStyle: {
        "width": "50%",
        "text-align": "center"
      }
    }, [_vm._v("\n                  " + _vm._s(est.date) + "\n                ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "50%",
        "text-align": "center"
      }
    }, [_vm._v("\n                  " + _vm._s(est.pres) + "\n                ")])])])
  })], 2)])])])]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.info.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center nombre-alarma"
  }, [_c('th', {
    staticStyle: {
      "width": "50% text-align:center!important"
    }
  }, [_vm._v("Fecha\n                  "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50% text-align:center!important"
    }
  }, [_vm._v("Presión")])])])
}]}

/***/ }),

/***/ 1710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body",
    style: (_vm.height)
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": _vm.id
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, _vm._l((_vm.names), function(val, key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "id": _vm.id + '-name-' + key
      }
    }, [_vm._v("\n          " + _vm._s(val.name) + "\n          "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (val.icon),
        expression: "val.icon"
      }],
      staticClass: "fa",
      class: val.icon,
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), 0)]), _vm._v(" "), _vm._l((_vm.data), function(row, key, index) {
    return _c('tbody', {
      key: key,
      attrs: {
        "id": _vm.id + '-body'
      }
    }, [_c('tr', {
      staticClass: "info"
    }, [_c('td', [_vm._v(" " + _vm._s(row.ducto) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.estacion) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['00'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['01'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['02'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['03'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['04'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['05'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['06'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['07'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['08'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['09'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['10'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['11'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['12'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['13'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['14'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['15'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['16'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['17'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['18'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['19'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['20'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['21'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['22'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['23'] || '0000'))])])])
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pdf-content container-fluid",
    attrs: {
      "id": "pdf"
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "row"
    }
  }, [_c('img', {
    staticClass: "logo_leak logo",
    attrs: {
      "width": "200px",
      "src": _vm.logoUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Evento #" + _vm._s(_vm.event && _vm.event.id))]), _vm._v(" "), _c('div', {
    staticClass: "pdf__info"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" De: ")]), _vm._v(" " + _vm._s(_vm.fromCompany) + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Fecha: ")]), _vm._v(" " + _vm._s(_vm.event && _vm.event.fecha) + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Ducto: ")]), _vm._v(" " + _vm._s(_vm.event && _vm.event.ducto) + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Tramo: ")]), _vm._v(" " + _vm._s(_vm.event && _vm.event.tramo) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Ubicación del evento ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "90%"
    }
  }, [(_vm.mapImg) ? _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%",
      "margin": "auto"
    },
    attrs: {
      "id": "img_map",
      "src": ("" + _vm.mapImg)
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "max-width": "100%",
      "height": "25vh",
      "padding": "0px",
      "margin": "0px",
      "border-width": "0px",
      "cursor": "default"
    }
  }, _vm._l((_vm.chartCanvas), function(canvas) {
    return _c('img', {
      staticStyle: {
        "max-width": "100%",
        "max-height": "100%",
        "position": "absolute",
        "left": "0px",
        "top": "0px",
        "width": "1554px",
        "height": "395px",
        "user-select": "none",
        "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)",
        "padding": "0px",
        "margin": "0px",
        "border-width": "0px"
      },
      attrs: {
        "src": canvas.toDataURL()
      }
    })
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tableholder"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.event) ? _c('tbody', [_c('tr', {
    attrs: {
      "id": "trw"
    }
  }, [_c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.fecha) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.km) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.lat) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.lng) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.tipo === 1 ? 'Apertura' : 'Cierre') + " ")])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Para: ")]), _vm._v(" A quien corresponda ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    attrs: {
      "id": "header"
    }
  }, [_c('tr', {
    attrs: {
      "id": "trh"
    }
  }, [_c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Fecha Evento")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Kilometro")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Latitud")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Longitud")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Acción")])])])
}]}

/***/ }),

/***/ 1712:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "pdf"
    }
  }, _vm._l((_vm.grouped), function(value, key) {
    return _c('div', {
      key: key,
      attrs: {
        "id": "rowcicle"
      }
    }, [_c('div', {
      attrs: {
        "id": "rowlogos"
      }
    }, [_c('img', {
      staticClass: "logo_leak",
      attrs: {
        "id": "leak",
        "width": "200px",
        "src": _vm.logoUrl
      }
    })]), _vm._v(" "), _c('h4', {
      attrs: {
        "id": "h41"
      }
    }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('hr', {
      staticClass: "yellow__hr",
      attrs: {
        "id": "hr1"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pdf__info",
      attrs: {
        "id": "pdf_info"
      }
    }, [_c('p', [_c('span', {
      staticClass: "pdf__titles",
      attrs: {
        "id": "titles"
      }
    }, [_vm._v(" Estación: ")]), _vm._v(" " + _vm._s(key) + " ")]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pdf__titles",
      attrs: {
        "id": "titles"
      }
    }, [_vm._v(" Ducto: ")]), _vm._v(" " + _vm._s(_vm.duct) + " ")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "tablecontainer"
      }
    }, [_c('table', {
      attrs: {
        "id": "tableholder"
      }
    }, [_c('thead', {
      attrs: {
        "id": "header"
      }
    }, [_c('tr', {
      attrs: {
        "id": "trh"
      }
    }, [_c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Fecha de Solicitud")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Latitud")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Longitud")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Presión")]), _vm._v(" "), (_vm.showViewColumn === 'true') ? _c('th', {
      staticClass: "title__td print-hidden",
      attrs: {
        "id": "thh"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((value), function(a) {
      return _c('tr', {
        class: {
          'highlight': a.samePressure
        },
        attrs: {
          "id": "trw"
        }
      }, [_c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.i_ts) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.lat) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.lon) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_c('span', {
        class: {
          'highlight': a.samePressure
        }
      }, [_vm._v(" " + _vm._s(a.p) + " ")])]), _vm._v(" "), (_vm.showViewColumn === 'true') ? _c('td', {
        staticClass: "print-hidden"
      }, [_c('div', {
        staticClass: "center-option"
      }, [_c('i', {
        staticClass: "fa fa-eye",
        attrs: {
          "aria-hidden": "true",
          "title": "Ver detalles"
        },
        on: {
          "click": function($event) {
            return _vm.open(a)
          }
        }
      })])]) : _vm._e()])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "bottom-offset",
      attrs: {
        "id": 'imgChart-' + _vm.filterLettersAndNumbers(key)
      }
    }), _vm._v(" "), _c('div', {
      class: {
        'hide-line-chart': _vm.isChartDisplayed
      },
      attrs: {
        "id": "linechart"
      }
    }, [_c('line-chart', {
      class: _vm.filterLettersAndNumbers(key),
      staticStyle: {
        "opacity": "0.0"
      },
      attrs: {
        "chartData": _vm.getChartDataFromSite({
          key: key,
          value: value
        }),
        "options": _vm.chartOptions,
        "width": 300,
        "height": 200
      },
      on: {
        "onAnimationComplete": _vm.onAnimationComplete
      }
    })], 1)])])
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 1713:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "reportes-page"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-1",
    attrs: {
      "id": "desde"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'desde')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.desdeText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "id": "hasta"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'hasta')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.hastaText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "desde",
      "id": "ducto",
      "placeholder": "DUCTO",
      "options": _vm.ductos
    },
    on: {
      "changeSelect": function($event) {
        return _vm.changeSelected()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "estacion",
      "id": "estacion",
      "placeholder": "ESTACION",
      "options": _vm.estacionesOps
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-0",
    attrs: {
      "id": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    class: [(_vm.desde === '' || _vm.ductoSelected === null || _vm.validation === false) ? 'disabled' : ''],
    attrs: {
      "id": "buscar-btn"
    },
    on: {
      "click": function($event) {
        return _vm.submitInfo()
      }
    }
  }, [_vm._v("\n          Buscar\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDetails),
      expression: "!showDetails"
    }],
    staticClass: "col-md-7 col-xs-12"
  }, [_c('button', {
    staticClass: "print_btn",
    on: {
      "click": function($event) {
        return _vm.Popup()
      }
    }
  }, [_vm._v("Imprimir")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sitePdf),
      expression: "sitePdf"
    }],
    staticClass: "panel-body-two",
    attrs: {
      "id": "panel-body-two"
    }
  }, [_c('pdf-pressure-div', {
    attrs: {
      "duct": _vm.ductsender,
      "site": _vm.sitePdf,
      "desde": _vm.desde,
      "hasta": _vm.hasta,
      "chartLimit": "24",
      "isDetails": "false",
      "showViewColumn": "true",
      "header": "Reporte de Presiones"
    },
    on: {
      "openDetails": function($event) {
        return _vm.openDetails($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }],
    staticClass: "col-md-7 col-xs-12"
  }, [_c('button', {
    staticClass: "print_btn",
    on: {
      "click": function($event) {
        return _vm.showReport()
      }
    }
  }, [_vm._v("Regresar")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }],
    staticClass: "panel-body-two",
    attrs: {
      "id": "panel-body-two"
    }
  }, [_c('pdf-pressure-div', {
    attrs: {
      "duct": _vm.ductsender,
      "site": _vm.siteDetailsPdf,
      "desde": _vm.desde,
      "hasta": _vm.hasta,
      "datetimeTag": _vm.datetimeTag,
      "chartLimit": "7",
      "isDetails": "true",
      "showViewColumn": "false",
      "header": "Detalle de Presiones"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "nombre-alarma",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" Ducto: " + _vm._s(this.ductoNameSelected) + " ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tbody', _vm._l((this.data), function(a, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pdfName(key)))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-eye view-report",
      attrs: {
        "aria-hidden": "true",
        "title": "Ver reporte",
        "data-toggle": "modal",
        "data-target": "#comentarioModal"
      },
      on: {
        "click": function($event) {
          return _vm.open(key)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-file-excel-o view-report",
      attrs: {
        "aria-hidden": "true",
        "title": "Descargar archivo Excel",
        "data-toggle": "modal",
        "data-target": "#comentarioModal"
      },
      on: {
        "click": function($event) {
          return _vm.downloadExcel(key)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-download view-report",
      attrs: {
        "aria-hidden": "true",
        "title": "Descargar archivo CSV",
        "data-toggle": "modal",
        "data-target": "#comentarioModal"
      },
      on: {
        "click": function($event) {
          return _vm.downloadCSV(key)
        }
      }
    })])])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn-chart2",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th')])
}]}

/***/ }),

/***/ 1714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-container",
    attrs: {
      "id": "login"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl()
    }
  })]), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'email') ? _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "instructions"
  }, [_vm._v("\n        Para recuperar su contraseña escriba el correo electronico con el que se registro.\n        Si coincide se le enviara un codigo para verificar su cuenta\n      ")]), _vm._v(" "), _c('md-field', [_c('md-input', {
    attrs: {
      "placeholder": _vm.emailHint,
      "autofocus": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions md-layout md-alignment-center"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    },
    on: {
      "click": _vm.requestCode
    }
  }, [_vm._v("Solicitar Codigo")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'code') ? _c('div', {
    staticClass: "form"
  }, [_c('p', {
    staticClass: "instructions"
  }, [_vm._v("\n        Ingrese el código de verificación\n      ")]), _vm._v(" "), _c('code-input', {
    on: {
      "input": _vm.onCodeInput
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions md-layout md-alignment-center"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    },
    on: {
      "click": _vm.verifyCode
    }
  }, [_vm._v("Validar")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'password') ? _c('div', {
    staticClass: "form"
  }, [_c('md-field', [_c('label', [_vm._v("Ingrese su nueva contraseña")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('md-field', [_c('label', [_vm._v("Confirme su nueva contraseña")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions md-layout md-alignment-center"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Actualizar")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'start') ? _c('div', {
    staticClass: "recovery-done"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v("Inicio de sesión")])], 1) : _vm._e(), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'error') ? _c('div', {
    staticClass: "recovery-done"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v("Regresar al inicio")])], 1) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.modalInfo
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1715:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cov-vue-date"
  }, [_c('div', {
    staticClass: "datepickbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date.time),
      expression: "date.time"
    }],
    staticClass: "cov-datepicker",
    style: (_vm.option.inputStyle ? _vm.option.inputStyle : {}),
    attrs: {
      "type": "text",
      "title": "input date",
      "readonly": "readonly",
      "placeholder": _vm.option.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.date.time)
    },
    on: {
      "click": _vm.showCheck,
      "foucus": _vm.showCheck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.date, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
    staticClass: "datepicker-overlay",
    style: ({
      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
    }),
    on: {
      "click": function($event) {
        return _vm.dismiss($event)
      }
    }
  }, [_c('div', {
    staticClass: "cov-date-body",
    style: ({
      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
    })
  }, [_c('div', {
    staticClass: "cov-date-monthly"
  }, [_c('div', {
    staticClass: "cov-date-previous",
    on: {
      "click": function($event) {
        return _vm.nextMonth('pre')
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-caption",
    style: ({
      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
    })
  }, [_c('span', {
    on: {
      "click": _vm.showYear
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.showMonth
    }
  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-next",
    on: {
      "click": function($event) {
        return _vm.nextMonth('next')
      }
    }
  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
    staticClass: "cov-date-box"
  }, [_c('div', {
    staticClass: "cov-picker-box"
  }, [_c('div', {
    staticClass: "week"
  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
    return _c('li', [_vm._v(_vm._s(weekie))])
  }), 0)]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
    return _c('div', {
      staticClass: "day",
      class: {
        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
      },
      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
        background: _vm.option.color.checkedDay
      } : {
        background: '#F50057'
      }) : {}),
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.checkDay(day)
        }
      }
    }, [_vm._v(_vm._s(day.value))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list",
    attrs: {
      "id": "yearList"
    }
  }, _vm._l((_vm.library.year), function(yearItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.setYear(yearItem)
        }
      }
    }, [_vm._v(_vm._s(yearItem))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, _vm._l((_vm.library.month), function(monthItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          return _vm.setMonth(monthItem)
        }
      }
    }, [_vm._v(_vm._s(monthItem))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, [_c('div', {
    staticClass: "watch-box"
  }, [_c('div', {
    staticClass: "hour-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
    return _c('li', {
      staticClass: "hour-item",
      class: {
        'active': hitem.checked
      },
      on: {
        "click": function($event) {
          return _vm.setTime('hour', hitem, _vm.hours)
        }
      }
    }, [_vm._v(_vm._s(hitem.value))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "min-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
    return _c('div', {
      staticClass: "min-item",
      class: {
        'active': mitem.checked
      },
      on: {
        "click": function($event) {
          return _vm.setTime('min', mitem, _vm.mins)
        }
      }
    }, [_vm._v(_vm._s(mitem.value))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showInfo.check = false
      }
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.picked
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1716:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container md-layout-column"
  }, [_c('md-drawer', {
    staticClass: "md-right",
    attrs: {
      "md-active": _vm.showSidepanel
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showSidepanel = $event
      },
      "update:md-active": function($event) {
        _vm.showSidepanel = $event
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "toolbar-title",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Filtros")])]), _vm._v(" "), _c('md-list', [_c('md-list-item', [_c('div', {
    staticClass: "md-list-item-text"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.onApplyFilter()
      }
    }
  }, [_vm._v("Aplicar")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-list-item-text"
  }, [_c('md-subheader', [_vm._v("Rango de minutos")]), _vm._v(" "), _vm._l((this.minutes), function(minute) {
    return _c('label', {
      key: minute,
      staticClass: "pe-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMinutes),
        expression: "selectedMinutes"
      }],
      attrs: {
        "type": "radio",
        "name": "radio"
      },
      domProps: {
        "value": minute,
        "checked": _vm._q(_vm.selectedMinutes, minute)
      },
      on: {
        "change": function($event) {
          _vm.selectedMinutes = minute
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkmark"
    }), _vm._v(" "), _c('span', {
      staticClass: "pe-radio-text"
    }, [_vm._v(_vm._s(minute))])])
  })], 2)]), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-layout-item"
  }, [_c('md-subheader', {
    attrs: {
      "for": "selectedDucto"
    }
  }, [_vm._v("Ducto")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "custom-select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.ductos,
      "max-height": 200,
      "placeholder": "Seleccione el ducto",
      "label": "section_name",
      "track-by": "id_section",
      "selectLabel": "Seleccionar",
      "deselectLabel": "Deseleccionar"
    },
    model: {
      value: (_vm.selectedDucto),
      callback: function($$v) {
        _vm.selectedDucto = $$v
      },
      expression: "selectedDucto"
    }
  })], 1), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-layout-item"
  }, [_c('md-subheader', {
    attrs: {
      "for": "selectedStations"
    }
  }, [_vm._v("Estaciones")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "custom-select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredStations,
      "max-height": 200,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "selectLabel": "◯",
      "selectedLabel": "✔",
      "deselectLabel": "✖",
      "placeholder": "Seleccione las estaciones",
      "label": "site_name",
      "track-by": "id_site",
      "selectGroupLabel": "Seleccionar todo",
      "deselectGroupLabel": "Deseleccionar todo",
      "group-values": "sites",
      "group-label": "section_name",
      "group-select": true
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(values.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(values.length) + "\n              activa(s)")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selectedStations),
      callback: function($$v) {
        _vm.selectedStations = $$v
      },
      expression: "selectedStations"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noOptions"
  }, [_vm._v("Lista vacía")]), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("No se encontraron resultados")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('md-content', [(this.isChartVisible) ? _c('div', {
    staticClass: "chart-container"
  }, [_c('apexchart', {
    attrs: {
      "height": "400",
      "type": "line",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })], 1) : _vm._e(), _vm._v(" "), (!this.isChartVisible) ? _c('md-empty-state', {
    attrs: {
      "md-rounded": "",
      "md-icon": "settings",
      "md-label": "Nada que graficar",
      "md-description": "Seleccione las opciones de graficas desde el boton de agregar filtros"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-speed-dial', {
    staticClass: "md-bottom-right",
    attrs: {
      "md-direction": "bottom",
      "md-event": "click"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showSidepanel = true
      }
    }
  }, [_c('md-speed-dial-target', {
    staticClass: "md-primary"
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1717:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body",
    style: (_vm.height)
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": _vm.id
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, _vm._l((_vm.names), function(val, key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "id": _vm.id + '-name-' + key
      }
    }, [_vm._v("\n            " + _vm._s(val.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _vm._l((_vm.data), function(row, key, index) {
    return _c('tbody', {
      key: key,
      class: _vm.tbClass,
      attrs: {
        "id": 'body-' + key
      }
    }, [_c('tr', {
      staticClass: "info",
      on: {
        "click": function($event) {
          return _vm.toggleTD(row.estacion + '-' + key, key)
        }
      }
    }, _vm._l((row), function(r, k, i) {
      return _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (k !== 'bitArr' && k !== 'estacion'),
          expression: "k !== 'bitArr' && k !== 'estacion'"
        }],
        key: k,
        attrs: {
          "id": _vm.id + '-body-' + k
        }
      }, [_c('p', [_vm._v(" " + _vm._s(r) + " ")])])
    }), 0), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "hidden",
      attrs: {
        "id": "colspan",
        "id": row.estacion + '-' + key,
        "colspan": "15"
      }
    }, [_c('div', {
      staticClass: "container-fluid sub-table"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('table', {
      staticClass: "table",
      attrs: {
        "id": "bits"
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((row.bitArr), function(ba, k, i) {
      return _c('tr', {
        key: k,
        staticClass: "text-center"
      }, [_c('td', [_vm._v(_vm._s(ba.name))]), _vm._v(" "), _c('td', [(ba.val !== 0) ? _c('div', {
        staticClass: "span_switch red"
      }, [_vm._v(" " + _vm._s(ba.val) + " ")]) : _c('div', {
        staticClass: "span_switch green"
      })])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('table', {
      staticClass: "table",
      attrs: {
        "id": "bits"
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
      staticClass: "text-center"
    }, [_vm._v("Batería")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      attrs: {
        "id": ("" + (row.estacion) + key + "Bar")
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "indicator",
      attrs: {
        "src": _vm.imgUrl('campo_params.png')
      }
    }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "text-center"
    }, [_vm._v("USB")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      attrs: {
        "id": ("" + (row.estacion) + key + "Ubs")
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "indicator",
      attrs: {
        "src": _vm.imgUrl('campo_params.png')
      }
    }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "text-center"
    }, [_vm._v("Antena")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      attrs: {
        "id": ("" + (row.estacion) + key + "Ubs")
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "indicator",
      attrs: {
        "src": _vm.imgUrl('campo_params.png')
      }
    }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "text-center"
    }, [_vm._v("RAM")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      attrs: {
        "id": ("" + (row.estacion) + key + "Ubs")
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "indicator",
      attrs: {
        "src": _vm.imgUrl('campo_params.png')
      }
    })])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('table', {
      staticClass: "table",
      attrs: {
        "id": "bits"
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "id": "line-chart"
      }
    }, [_c('select-c', {
      attrs: {
        "name": "tipo",
        "id": "tipo",
        "options": _vm.opts,
        "placeholder": "Tipo de Tabla"
      },
      on: {
        "changeSelect": function($event) {
          return _vm.chooseTipo('LOAD_BATERIA', key)
        }
      }
    }), _vm._v(" "), _c('line-chart', {
      ref: "chart",
      refInFor: true,
      attrs: {
        "id": (key + "-chart"),
        "height": 200,
        "chart-data": _vm.datacollection,
        "options": _vm.chartOps
      }
    })], 1)])])])])])])])])])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btnData",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "loading-modal",
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": {
        modalName: 'loading-modal'
      }
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Bits")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Indicaciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Graficas")])])])
}]}

/***/ }),

/***/ 1718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row center-content"
  }, [_c('div', {
    staticClass: "col-sm-3 datepicker-container"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.selectedDate,
      "option": _vm.datePickerOptions,
      "limit": _vm.disabledDates,
      "placeholder": "Seleccione un dia"
    },
    on: {
      "input": _vm.handleDateChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select-c', {
    attrs: {
      "name": "ducto",
      "id": "ducto",
      "placeholder": "DUCTO",
      "options": _vm.ductos,
      "passSelectedValue": "true"
    },
    on: {
      "onSelectedValue": _vm.onSelectedValue
    },
    model: {
      value: (_vm.selectedDucto),
      callback: function($$v) {
        _vm.selectedDucto = $$v
      },
      expression: "selectedDucto"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 buttons-container"
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    class: [(_vm.selectedDate === null || _vm.selectedDucto === null) ? 'disabled' : ''],
    attrs: {
      "id": "buscar-btn"
    },
    on: {
      "click": _vm.fetchPdf
    }
  }, [_vm._v("\n        Buscar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    class: [_vm.pdfUrl === '' ? 'disabled' : ''],
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v("Imprimir")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    class: [_vm.pdfUrl === '' ? 'disabled' : ''],
    on: {
      "click": _vm.savePdf
    }
  }, [_vm._v("Guardar")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.pdfUrl) ? _c('div', {
    staticClass: "row pdf-container"
  }, [_c('div', {
    staticClass: "iframe-container"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.pdfUrl,
      "width": "100%",
      "height": "100%"
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('p', [_vm._v("Cargando... por favor espere")]), _vm._v(" "), _c('p', [_vm._v("Esto puede tardar unos minutos")]), _vm._v(" "), _c('i', {
    staticClass: "custom-loading-color fa fa-spinner fa-spin fa-4x fa-fw"
  })])
}]}

/***/ }),

/***/ 1719:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "campo"
    }
  }, [_c('div', {
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-md-offset-2 col-xs-10 col-xs-offset-1"
  }, [_c('select-c', {
    attrs: {
      "name": "ducto",
      "id": "ducto-campo",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.ductosEvent($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "tabla"
    }
  }, [_c('c-table', {
    attrs: {
      "id": "campo-dd",
      "data": _vm.data,
      "names": _vm.bitacoraNames,
      "modalTarget": "#campo-dd-modal",
      "height": "height: 35vh;",
      "tbClass": "striped"
    },
    on: {
      "mapMarker": function($event) {
        return _vm.changeMarkers($event)
      }
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "form-bot"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-md-offset-3 col-xs-10 col-xs-offset-1"
  }, [_c('select-c', {
    attrs: {
      "name": "ducto2",
      "id": "ducto2",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        _vm.batId = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-md-offset-0 col-xs-10 col-xs-offset-1"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        _vm.fecha = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons col-md-4 col-md-offset-0 col-xs-10 col-xs-offset-1"
  }, [_c('button', {
    staticClass: "btn btn-default text-uppercase waves-effect waves-light",
    class: [_vm.batId === '' ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.bateriaEvent($event)
      }
    }
  }, [_vm._v("buscar")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('json-ex', {
    attrs: {
      "data": _vm.jsonData,
      "fields": _vm.jsonFields,
      "name": ("CAMP-BATERIA-" + _vm.fecha + ".xls"),
      "meta": _vm.jsonMeta
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row tabla-bottom"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('single-table', {
    attrs: {
      "id": "campo-single",
      "data": _vm.baterias,
      "names": _vm.camposBotNames,
      "modalTarget": "#campo-single-modal",
      "height": "height: 25vh;"
    },
    on: {
      "mapMarker": function($event) {
        return _vm.changeMarkers($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "loading-modal",
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": {
        modalName: 'loading-modal'
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1720:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body",
    style: (_vm.height)
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": _vm.id
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, _vm._l((_vm.names), function(val, key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "id": _vm.id + '-name-' + key
      }
    }, [_vm._v("\n          " + _vm._s(val.name) + "\n          "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (val.icon),
        expression: "val.icon"
      }],
      staticClass: "fa",
      class: val.icon,
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), 0)]), _vm._v(" "), _vm._l((_vm.data), function(row, key, index) {
    return _c('tbody', {
      key: key,
      attrs: {
        "id": _vm.id + '-body'
      }
    }, [_c('tr', {
      staticClass: "info"
    }, _vm._l((row), function(r, k, i) {
      return (k !== 'id') ? _c('td', {
        key: k,
        attrs: {
          "id": _vm.id + '-body-' + k
        }
      }, [_c('div', [(k !== 'alarmaAsignada') ? _c('p', [_vm._v(" " + _vm._s(r) + " ")]) : _vm._e()])]) : _vm._e()
    }), 0)])
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1721:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "configuracion"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.monitoringData.rtu), function(section, key_section, index) {
    return (_vm.sectionHasData(section)) ? _c('tbody', {
      key: key_section
    }, [_c('tr', {
      on: {
        "click": function($event) {
          return _vm.showDucto(("ductos" + (section.id_section)))
        }
      }
    }, [_c('td', {
      staticClass: "nombre-ducto"
    }, [_vm._v(_vm._s(section.section_name))]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto"
    }, [(_vm.sectionHasFailure(section, 'online', 0)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("link_off")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'pressure', 0)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("trending_down")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'battery', 10)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("battery_alert")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'site_door', 1)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("lock_open")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'cabinet_door', 1)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("lock_open")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'gps', 0)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("location_off")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-down pull-right fa-2x",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _vm._l((section.sites), function(site, key_site, index) {
      return (site.timestamp) ? _c('tr', {
        key: key_site,
        class: [("ductos" + (section.id_section)), !site.redraw && 'no-show', !site.enabled && 'site-disabled'],
        staticStyle: {
          "vertical-align": "middle"
        },
        on: {
          "click": function($event) {
            _vm.promptSiteStatus(Object.assign({}, site, {
              id_section: section.id_section,
              key_section: key_section,
              key_site: key_site
            }))
          }
        }
      }, [_c('td', [_vm._v(_vm._s(site.site_name) + " "), (!site.enabled) ? _c('i', {
        staticClass: "material-icons md-24 fail-icon"
      }, [_vm._v("cloud_off")]) : _vm._e()]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'online', 0) ? 'failure' : '']
      }, [_vm._v(_vm._s(site.timestamp))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'pressure', 0) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.pressure))]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.flow))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'battery', 10) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.battery))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'site_door', 1) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.site_door))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'cabinet_door', 1) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.cabinet_door))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'gps', 0) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.gps))])]) : _vm._e()
    }), _vm._v(" "), _c('tr', {
      staticStyle: {
        "height": "10px"
      }
    })], 2) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 leak-table-toggle",
    on: {
      "click": function($event) {
        return _vm.showLeaks()
      }
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "auto",
      "vertical-align": "middle",
      "width": "auto",
      "display": "inline"
    }
  }, [_vm._v("Datos")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down pull-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 leaks-oor no-show",
    staticStyle: {
      "height": "350px",
      "overflow": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.monitoringData.leaks), function(leak, key_leak, index) {
    return _c('tr', {
      key: leak.id_leak,
      class: [],
      staticStyle: {
        "vertical-align": "middle"
      },
      on: {
        "click": function($event) {
          return _vm.promptPublishLeak(leak.id_leak)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(("" + (leak.km))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.lat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.lon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.detection_timestamp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.type === 1 ? 'Apertura' : 'Cierre'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.status === 0 ? 'Generado' : (leak.status === 1 ? ("Publicado por " + (leak.username)) : 'N/A')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.timestamp))])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "10px"
    }
  })], 2)])])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), (_vm.modalType === 0) ? _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.modalType === 1) ? _c('modal', {
    attrs: {
      "name": "comentario"
    }
  }, [_c('div', {
    staticClass: "modal-body row"
  }, [_c('h5', {
    staticClass: "modal-title text-uppercase",
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v(_vm._s(_vm.modalSite.site_name))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('p', {
    staticClass: "modal-title",
    staticStyle: {
      "padding": "15px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(("¿Deseas " + (_vm.modalSite.enabled ? 'deshabilitar el rtu? Dejará de producir información referente a su estado.' : 'habilitar el rtu?'))))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group",
      "aria-label": "group button"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "role": "button"
    }
  }, [_vm._v("Cerrar")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "id": "btn-post-site",
      "data-action": "save",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.postSiteEnabled(_vm.modalSite)
      }
    }
  }, [_vm._v("Continuar")])])])])]) : _vm._e(), _vm._v(" "), (_vm.modalType === 2) ? _c('modal', {
    attrs: {
      "name": "publish"
    }
  }, [_c('div', {
    staticClass: "modal-body row"
  }, [_c('h5', {
    staticClass: "modal-title text-uppercase",
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("Publicación manual de fuga")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('p', {
    staticClass: "modal-title",
    staticStyle: {
      "padding": "15px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s("¿Deseas publicar manualmente la fuga?"))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group",
      "aria-label": "group button"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "role": "button"
    }
  }, [_vm._v("Cerrar")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "id": "btn-post-site",
      "data-action": "save",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.postPublishLeak(_vm.publishLeak)
      }
    }
  }, [_vm._v("Continuar")])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "enable-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#comentario-modal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "publish-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#publish-modal"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('h5', {}, [_vm._v("Estado de RTUs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("Ducto/Sitios")]), _vm._v(" "), _c('th', [_vm._v("Hora evento")]), _vm._v(" "), _c('th', [_vm._v("Presión")]), _vm._v(" "), _c('th', [_vm._v("Flujo")]), _vm._v(" "), _c('th', [_vm._v("Batería")]), _vm._v(" "), _c('th', [_vm._v("Sitio")]), _vm._v(" "), _c('th', [_vm._v("Gabinete")]), _vm._v(" "), _c('th', [_vm._v("GPS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('h5', {}, [_vm._v("Fugas fuera de rango "), _c('span', {
    staticStyle: {
      "fontSize": "0.5em"
    }
  }, [_vm._v("(Últimas 6 horas)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("Km")]), _vm._v(" "), _c('th', [_vm._v("Lat")]), _vm._v(" "), _c('th', [_vm._v("Lon")]), _vm._v(" "), _c('th', [_vm._v("Hora evento")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("Hora captura")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('h5', {}, [_vm._v("Configuración")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-6"
  }, [_c('h6', [_vm._v("Modo manual de detección de fugas")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "fontSize": "1em"
    }
  }, [_vm._v("Deshabilita la publicación de fugas mientras esté encendido")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-6",
    staticStyle: {
      "margin": "auto",
      "text-align": "center",
      "vertical-align": "middle"
    }
  }, [_c('label', {
    staticClass: "switch",
    staticStyle: {
      "margin": "auto",
      "vertical-align": "middle"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "config-leak-manual"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])])])])
}]}

/***/ }),

/***/ 1722:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "historico-page"
    }
  }, [_c('div', [(!this.leak_detail) ? _c('div', {
    staticClass: "col-md-2 col-sm-2 form-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'desde')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.desdeText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'hasta')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.hastaText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('select-c', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "ductos",
      "id": "ductosHistorico",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.selectEvent($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect",
    class: [(_vm.desde === '' || _vm.ducto === '' || _vm.validation === false) ? 'disabled' : ''],
    staticStyle: {
      "margin-left": "0"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("Buscar")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('json-ex', {
    attrs: {
      "data": _vm.jsonData,
      "fields": _vm.jsonFields,
      "name": ("HDA-" + _vm.desde + "-" + _vm.hasta + ".xls"),
      "meta": _vm.jsonMeta
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "3vh"
    }
  }, [_c('label', [_vm._v("PARAMETROS DE GRAFICA")]), _vm._v(" "), _c('select-c', {
    attrs: {
      "name": "tipo",
      "id": "tipo",
      "options": _vm.chartRange,
      "placeholder": "RANGO DE TIEMPO (MIN)"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.selectChartRange($event)
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: !this.leak_detail ? 'col-md-10 col-sm-10 chart-container' : 'chart-container',
    style: (this.leak_detail ? 'width: 100%' : '')
  }, [(_vm.selectedTramo) ? _c('button', {
    staticClass: "btn btn-default waves-effect",
    staticStyle: {
      "float": "right",
      "text-align": "center",
      "opacity": "0.9",
      "margin": "0"
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("\n        Imprimir Reporte\n      ")]) : _vm._e(), _vm._v(" "), (!this.isChartVisible) ? _c('md-empty-state', {
    attrs: {
      "md-icon": "settings",
      "md-label": "Nada que graficar",
      "md-description": "Seleccione un rango de fechas, un ducto y el evento desde la tabla para graficar"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chart-pressure",
    staticStyle: {
      "width": "100%",
      "min-height": "42vh"
    },
    attrs: {
      "id": "pressure-chart-div"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8  col-xs-12"
  }, [_c('google-maps', {
    ref: "map",
    attrs: {
      "mcStyle": _vm.mcStyle,
      "mcClass": "half",
      "wStyle": _vm.wStyle
    },
    on: {
      "marker-clicked": _vm.onMarkerClick
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, _vm._l((_vm.jsonFields), function(row, key, index) {
    return (row !== 'Id') ? _c('th', {
      key: key
    }, [_vm._v(_vm._s(key))]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l(((_vm.isMiddlePoint() && _vm.historicoMiddlePoints || _vm.historico)), function(row, key) {
    return _c('tr', {
      key: key,
      staticClass: "info",
      class: {
        selectedRow: _vm.selectedEventRow && row.id === _vm.selectedEventRow.id
      },
      attrs: {
        "id": 'alarm-' + key
      },
      on: {
        "click": function($event) {
          return _vm.onSelectRow(row)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.section))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.fecha))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.hora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lat.toFixedDown(4)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lng.toFixedDown(4)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.km))]), _vm._v(" "), (_vm.isMiddlePoint()) ? _c('td', [_vm._v(_vm._s(row.tipo))]) : (row.tipo === 1) ? _c('td', [_vm._v("Apertura")]) : _c('td', [_vm._v("Cierre")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.estado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.municipio))])])
  }), 0)])])])])]), _vm._v(" "), _c('pdf-view', {
    attrs: {
      "hidden": "",
      "event": _vm.selectedEventRow,
      "chartRage": _vm.selectedChartRange,
      "mapImg": _vm.pdfMap,
      "chartCanvas": _vm.chartCanvas
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.info.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("CONSULTA DE EVENTOS")])])
}]}

/***/ }),

/***/ 1723:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container md-layout-column"
  }, [_c('md-drawer', {
    staticClass: "md-right",
    attrs: {
      "md-active": _vm.showSidepanel
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showSidepanel = $event
      },
      "update:md-active": function($event) {
        _vm.showSidepanel = $event
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "toolbar-title",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Filtros")])]), _vm._v(" "), _c('md-list', [_c('md-list-item', [_c('div', {
    staticClass: "md-list-item-text"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.onApplyFilter()
      }
    }
  }, [_vm._v("Aplicar")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-list-item-text"
  }, [_c('md-subheader', [_vm._v("Rango de minutos")]), _vm._v(" "), _vm._l((this.minutes), function(minute) {
    return _c('label', {
      key: minute,
      staticClass: "pe-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMinutes),
        expression: "selectedMinutes"
      }],
      attrs: {
        "type": "radio",
        "name": "radio"
      },
      domProps: {
        "value": minute,
        "checked": _vm._q(_vm.selectedMinutes, minute)
      },
      on: {
        "change": function($event) {
          _vm.selectedMinutes = minute
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkmark"
    }), _vm._v(" "), _c('span', {
      staticClass: "pe-radio-text"
    }, [_vm._v(_vm._s(minute))])])
  })], 2)]), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-layout-item"
  }, [_c('md-subheader', {
    attrs: {
      "for": "selectedDucto"
    }
  }, [_vm._v("Ducto")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "custom-select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.ductos,
      "max-height": 200,
      "placeholder": "Seleccione el ducto",
      "label": "section_name",
      "track-by": "id_section",
      "selectLabel": "Seleccionar",
      "deselectLabel": "Deseleccionar"
    },
    model: {
      value: (_vm.selectedDucto),
      callback: function($$v) {
        _vm.selectedDucto = $$v
      },
      expression: "selectedDucto"
    }
  })], 1), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-layout-item"
  }, [_c('md-subheader', {
    attrs: {
      "for": "selectedStations"
    }
  }, [_vm._v("Estaciones")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "custom-select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredStations,
      "max-height": 200,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "selectLabel": "◯",
      "selectedLabel": "✔",
      "deselectLabel": "✖",
      "placeholder": "Seleccione las estaciones",
      "label": "site_name",
      "track-by": "id_site",
      "selectGroupLabel": "Seleccionar todo",
      "deselectGroupLabel": "Deseleccionar todo",
      "group-values": "sites",
      "group-label": "section_name",
      "group-select": true
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(values.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(values.length) + "\n              activa(s)")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selectedStations),
      callback: function($$v) {
        _vm.selectedStations = $$v
      },
      expression: "selectedStations"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noOptions"
  }, [_vm._v("Lista vacía")]), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("No se encontraron resultados")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('md-content', [(this.isChartVisible) ? _c('div', {
    staticClass: "chart-container"
  }, _vm._l((this.seriesList), function(row, index) {
    return _c('div', {
      key: row.name,
      attrs: {
        "index": index
      }
    }, [_c('md-toolbar', {
      staticClass: "toolbar-title",
      attrs: {
        "md-elevation": "0"
      }
    }, [_c('span', {
      staticClass: "md-title chart-head"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('span', {
      staticClass: "chart-subhead"
    }, [_vm._v("\n            Última actualización: " + _vm._s(row.series[0].data.length > 0 ?
      new Date(row.series[0].data[row.series[0].data.length - 1].x).toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      }) :
      'N/A') + "\n        ")])]), _vm._v(" "), _c('apexchart', {
      ref: "rows",
      refInFor: true,
      attrs: {
        "height": "300",
        "options": row.options,
        "series": row.series
      }
    }), _vm._v(" "), (row.loading) ? _c('div', {
      staticClass: "loading-spinner"
    }, [_c('div', [_c('p', [_c('i', {
      staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
    })]), _vm._v(" "), _c('p', [_vm._v("Cargando...")])])]) : (row.error) ? _c('div', {
      staticClass: "error-message"
    }, [_c('span', [_vm._v(_vm._s(row.errorMessage))])]) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (this.isInitialSetup) ? _c('md-empty-state', {
    attrs: {
      "md-rounded": "",
      "md-icon": "settings",
      "md-label": "Nada que graficar",
      "md-description": "Seleccione las opciones de graficas desde el boton de agregar filtros"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-speed-dial', {
    staticClass: "md-bottom-right speed-dial",
    attrs: {
      "md-direction": "bottom",
      "md-event": "click"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showSidepanel = true
      }
    }
  }, [_c('md-speed-dial-target', {
    staticClass: "md-primary"
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1725:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(955);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("582ccd00", content, true, {});

/***/ }),

/***/ 1726:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(956);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("3778d199", content, true, {});

/***/ }),

/***/ 1727:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(957);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("fa391388", content, true, {});

/***/ }),

/***/ 1728:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(958);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("02d96b1e", content, true, {});

/***/ }),

/***/ 1729:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(959);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("14c4c51f", content, true, {});

/***/ }),

/***/ 1730:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(960);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("67642974", content, true, {});

/***/ }),

/***/ 1731:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(961);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("0d06ec4b", content, true, {});

/***/ }),

/***/ 1732:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(962);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("4e7f59c9", content, true, {});

/***/ }),

/***/ 1733:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(963);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("b07d2338", content, true, {});

/***/ }),

/***/ 1734:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(964);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("01dea56b", content, true, {});

/***/ }),

/***/ 1735:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(965);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("1090f84c", content, true, {});

/***/ }),

/***/ 1736:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("492b3f9d", content, true, {});

/***/ }),

/***/ 1737:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(967);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("cb84c154", content, true, {});

/***/ }),

/***/ 1738:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(968);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("fc3d2d38", content, true, {});

/***/ }),

/***/ 1739:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(969);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("711f075e", content, true, {});

/***/ }),

/***/ 1740:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(970);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("07181bd4", content, true, {});

/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(971);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("d3b4096a", content, true, {});

/***/ }),

/***/ 1742:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(972);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("099c44b4", content, true, {});

/***/ }),

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("862bfffa", content, true, {});

/***/ }),

/***/ 1744:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("12b7268e", content, true, {});

/***/ }),

/***/ 1745:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(975);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("4f056b96", content, true, {});

/***/ }),

/***/ 1746:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(976);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("7fa9a1cc", content, true, {});

/***/ }),

/***/ 1747:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(977);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("0741038f", content, true, {});

/***/ }),

/***/ 1748:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(978);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("a4e88286", content, true, {});

/***/ }),

/***/ 1749:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(979);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("e7a74516", content, true, {});

/***/ }),

/***/ 1750:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(980);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("e8bee6f2", content, true, {});

/***/ }),

/***/ 1751:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(981);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("7429850e", content, true, {});

/***/ }),

/***/ 1752:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(982);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("d2fb7dd4", content, true, {});

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(983);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("4ca78d52", content, true, {});

/***/ }),

/***/ 1754:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(984);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("3f312a56", content, true, {});

/***/ }),

/***/ 1755:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(985);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("ae4354b6", content, true, {});

/***/ }),

/***/ 1756:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(986);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("30f178a4", content, true, {});

/***/ }),

/***/ 1757:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(987);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("133db65e", content, true, {});

/***/ }),

/***/ 1758:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(988);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("836b57e2", content, true, {});

/***/ }),

/***/ 1759:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(989);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("3a6e7c04", content, true, {});

/***/ }),

/***/ 1760:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(990);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("00760578", content, true, {});

/***/ }),

/***/ 1761:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(991);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("f7512ee4", content, true, {});

/***/ }),

/***/ 1762:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(992);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("597c4243", content, true, {});

/***/ }),

/***/ 1763:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(993);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("718b2b3e", content, true, {});

/***/ }),

/***/ 1764:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(994);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("65491246", content, true, {});

/***/ }),

/***/ 1765:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(995);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("40357d9d", content, true, {});

/***/ }),

/***/ 1766:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(996);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("08132f97", content, true, {});

/***/ }),

/***/ 1767:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(997);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("094135e6", content, true, {});

/***/ }),

/***/ 1768:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(998);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("40cc0764", content, true, {});

/***/ }),

/***/ 1769:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(999);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("4ac58d32", content, true, {});

/***/ }),

/***/ 1770:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1000);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("46419793", content, true, {});

/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Login/foto_login.png": 1626,
	"./Login/img_login.png": 1627,
	"./campo_grafica.jpg": 1628,
	"./campo_indicaciones.png": 1629,
	"./campo_params.png": 1630,
	"./icons/feedback.png": 708,
	"./icons/feedback.svg": 709,
	"./icons/leak_blue.gif": 710,
	"./icons/leak_blue.png": 711,
	"./icons/leak_blue_old.png": 712,
	"./icons/leak_green.gif": 713,
	"./icons/leak_green.png": 714,
	"./icons/leak_green_old.png": 715,
	"./icons/leak_green_static.png": 716,
	"./icons/leak_red.gif": 717,
	"./icons/leak_red_anim.gif": 718,
	"./icons/leak_red_old.gif": 719,
	"./icons/leak_red_old.png": 720,
	"./icons/pin_blue.png": 721,
	"./icons/pin_green.png": 722,
	"./icons/pin_red.png": 723,
	"./icons/place.png": 724,
	"./icons/place.svg": 725,
	"./icons/place_blue.png": 726,
	"./icons/place_green.png": 727,
	"./icons/place_green.svg": 728,
	"./icons/place_red.gif": 729,
	"./icons/place_red.svg": 730,
	"./icons/place_red_old.png": 731,
	"./icons/place_yellow.png": 732,
	"./logos/GAES_SINGLE.png": 733,
	"./logos/GAES_VERTICAL.png": 734,
	"./logos/Logo_GAES.png": 319,
	"./logos/Logo_GAES_V.png": 169,
	"./logos/Logo_PIPE_EAGLE.png": 1631,
	"./logos/Logo_PIPE_EAGLE_V.png": 1632,
	"./logos/PIPE_EAGLE_SINGLE.png": 1633,
	"./logos/PIPE_EAGLE_VERTICAL.png": 1634,
	"./logos/favicon.png": 1635,
	"./logos/icon.ico": 1636,
	"./logos/logo_pemex_original.png": 320
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1809;

/***/ }),

/***/ 1810:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Historico": 322,
	"./Historico.vue": 322,
	"./PdfDiv": 323,
	"./PdfDiv.vue": 323,
	"./PdfView": 324,
	"./PdfView.vue": 324,
	"./Reportes": 325,
	"./Reportes.vue": 325
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;

/***/ }),

/***/ 1811:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1812:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1813:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1814:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1815:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1816:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1817:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1818:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1819:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1820:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1821:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1822:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1823:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1824:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1825:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(810),
  /* template */
  __webpack_require__(1683),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_axios__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_section__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_leak__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ramda__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_routes__ = __webpack_require__(344);













__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */].Store({
  state: {
    AccessLevel: {
      Admin: 4
    },
    user: null,
    recovery: null,
    modalInfo: {},
    cclick: false,
    chartCurrentData: {},
    activeAlarms: [],
    recogAlarms: [],
    bitacora: {},
    dpDate: {
      showInfo: {
        hour: true
      },
      startTime: {
        time: ''
      },
      endtime: {}
    },
    dpOpsFecha: {
      type: 'min',
      week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      format: 'YYYY-MM-DD HH:mm',
      placeholder: 'Fecha',
      inputStyle: {
        display: 'inline-block',
        padding: '0 10px',
        'line-height': '10px',
        'font-size': '16px',
        'border-bottom': '2px solid gray',
        color: '#5F5F5F',
        'background-color': 'transparent'
      },
      color: {
        header: '#166FB8',
        headerText: '#fff'
      },
      buttons: {
        ok: 'Ok',
        cancel: 'Cancelar',
        clear: 'Clear'
      },
      overlayOpacity: 0.5,
      dismissible: true },
    dpOpsDesde: {
      type: 'min',
      week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      format: 'YYYY-MM-DD HH:mm',
      placeholder: 'Desde',
      inputStyle: {
        display: 'inline-block',
        padding: '0 10px',
        'line-height': '10px',
        'font-size': '16px',
        'border-bottom': '2px solid gray',
        color: '#5F5F5F',
        'background-color': 'transparent'
      },
      color: {
        header: 'var(--date-picker-background-color)',
        headerText: '#fff'
      },
      buttons: {
        ok: 'Ok',
        cancel: 'Cancelar'
      },
      overlayOpacity: 0.5,
      dismissible: true },
    dpOpsHasta: {
      type: 'min',
      week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      format: 'YYYY-MM-DD HH:mm',
      placeholder: 'Hasta',
      inputStyle: {
        display: 'inline-block',
        padding: '0 10px',
        'line-height': '10px',
        'font-size': '16px',
        'border-bottom': '2px solid gray',
        color: '#5F5F5F',
        'background-color': 'transparent'
      },
      color: {
        header: 'var(--date-picker-background-color)',
        headerText: '#fff'
      },
      buttons: {
        ok: 'Ok',
        cancel: 'Cancelar'
      },
      overlayOpacity: 0.5,
      dismissible: true },
    cached_ductos: null,
    transformed_cached_ductos: null,
    transformed_cached_leaks: [],
    last_leak_timestamp: null,
    cached_presion: null,

    fill: true,
    map: undefined,
    historico: null,
    options: [],
    optionsLegacy: [],
    estados: {
      verde: '',
      rojo: '',
      azul: '',
      amarillo: ''
    },
    routes: {},
    ETags: {},
    charts: {},
    monitoring: null,
    axiosSource: null,
    conceptos: null,
    help: null
  },
  actions: {
    LOAD_OPS_LEGACY: function LOAD_OPS_LEGACY(_ref, _params) {
      var _this = this;

      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'legacy/pipelines').then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          console.log('LOAD_OPS_LEGACY API response', response);
          _this.state.optionsLegacy = [];
          response.data.forEach(function (pipeline) {
            return _this.state.optionsLegacy.push(pipeline);
          });
          console.log('optionsLegacy', _this.state.optionsLegacy);
          return resolve(_this.state.optionsLegacy);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },

    GET_OP_LEGACY: function GET_OP_LEGACY(state) {
      return function (param) {
        var arr = [];
        state.optionsLegacy.forEach(function (op, _i) {
          if (!op) return;
          if (op['id'] === param.id) {
            arr.push({
              name: site['ducto'],
              value: site['id']
            });
          }
        });
        console.log('GET_OP_LEGACY', arr);
        return arr;
      };
    },
    LOAD_HISTORICAL_LEGACY: function LOAD_HISTORICAL_LEGACY(_ref2, params) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'legacy/alerts?pipeline=' + params.pipeline + '&startDate=' + params.startDate + '&endDate=' + params.endDate).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          console.log('LOAD_HISTORICAL_LEGACY', response);
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_HISTORICO: function LOAD_HISTORICO(_ref3, params) {
      var commit = _ref3.commit,
          getters = _ref3.getters;

      this.axiosSource = __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].CancelToken.source();
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'leak?current=0&section=' + params.ducto + '&dateFrom=' + params.desde + '&dateTo=' + params.hasta + '&kmFrom=' + params.kmFrom + '&kmTo=' + params.kmTo + '&type=' + params.tipo).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_HISTORICO_ID: function LOAD_HISTORICO_ID(_ref4, params) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      this.axiosSource = __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].CancelToken.source();
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = "https://api.ductos-gaes.com/" + 'leak/' + params.id;
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get(url).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }

          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_HELP_INFO: function LOAD_HELP_INFO(_ref5, params) {
      var commit = _ref5.commit,
          getters = _ref5.getters;

      var user = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].ls.get('user');
      if (user && user.permissions && user.permissions.length === 0) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          return resolve({ code: 200, data: [] });
        });
      }
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = "https://api.ductos-gaes.com/" + 'question_answer';
        var headers = {};


        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'question_answer', { headers: headers }).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            if (response.code === 304) {
              return resolve(getters.GET_HELP);
            }

            throw new Error('Bad data');
          }
          var etag = resp.headers['etag'];
          commit('SET_ETAG', { url: url, etag: etag });
          commit('SET_HELP', response);
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_PRESSURE_BY_ID: function LOAD_PRESSURE_BY_ID(_ref6, params) {
      var _this2 = this;

      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.axiosSource.cancel;
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'pressure?reportId=' + params.reportId + '&chartRange=' + params.chartRange, { cancelToken: _this2.axiosSource.token }).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_REPORTE_POLL: function LOAD_REPORTE_POLL(_ref7, params) {
      var commit = _ref7.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'section/' + params.ducto + '/poll?dateFrom=' + params.desde + '&dateTo=' + params.hasta + '&site=' + params.estacion).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_REPORTE_POOL_DETAILS: function LOAD_REPORTE_POOL_DETAILS(_ref8, params) {
      var commit = _ref8.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'section/' + params.ducto + '/poll_details?dateFrom=' + params.desde + '&site=' + params.estacion).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_REPORTE_PRESSURE: function LOAD_REPORTE_PRESSURE(_ref9, params) {
      var commit = _ref9.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'section/' + params.ducto + '/pressure?dateFrom=' + params.desde + '&dateTo=' + params.hasta + '&site=' + params.estacion).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_REPORTE_PRESSURE_DETAILS: function LOAD_REPORTE_PRESSURE_DETAILS(_ref10, params) {
      var commit = _ref10.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'section/' + params.ducto + '/pressure_details?dateFrom=' + params.desde + '&site=' + params.estacion).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    POST_BITACORA: function POST_BITACORA(_ref11, params) {
      var commit = _ref11.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].post("https://api.ductos-gaes.com/" + 'journal', {
          id_leak: '-1',
          username: params.username,
          id_section: params.id_section,
          id_concept: params.id_concept,
          comment: params.comment
        }).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_BITACORA: function LOAD_BITACORA(_ref12, params) {
      var commit = _ref12.commit,
          getters = _ref12.getters;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = "https://api.ductos-gaes.com/" + 'journal';
        var headers = {};


        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get(url + '?id_section=' + params.ducto + '&id_concept=' + params.concepto + '&dateFrom=' + params.desde + '&dateTo=' + params.hasta).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            if (response.code === 304) {
              return resolve();
            }

            throw new Error('Bad data');
          }
          var etag = resp.headers['etag'];
          commit('SET_ETAG', { url: url, etag: etag });
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_CONCEPTOS: function LOAD_CONCEPTOS(_ref13, params) {
      var commit = _ref13.commit,
          getters = _ref13.getters;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = "https://api.ductos-gaes.com/" + 'journal/concept';
        var headers = {};


        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get(url, { headers: headers }).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            if (response.code === 304) {
              return resolve(getters.GET_CONCEPTOS);
            }

            throw new Error('Bad data');
          }
          var etag = resp.headers['etag'];
          commit('SET_ETAG', { url: url, etag: etag });
          commit('SET_CONCEPTOS', response);
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_DUCTOS: function LOAD_DUCTOS(_ref14) {
      var _this3 = this;

      var commit = _ref14.commit;

      var user = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].ls.get('user');
      if (user && user.permissions && user.permissions.length === 0) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          return resolve({ code: 200, data: [] });
        });
      }
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'site').then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(response.data) !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this3.state.cached_ductos)) {
            commit('SET_DUCTOS', {
              data: response.data
            });
            commit('SET_FILL_STATE', {
              data: true
            });
          } else {
            commit('SET_FILL_STATE', {
              data: false
            });
          }
          return resolve(response);
        }).catch(function (err) {
          commit('SET_DUCTOS', {
            data: _this3.state.cached_ductos
          });
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_DECIMATION: function LOAD_DECIMATION(_ref15, params) {
      var commit = _ref15.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'site/decimation/' + params.section + '/' + params.site).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_DECIMATION_STEP: function LOAD_DECIMATION_STEP(_ref16, params) {
      var commit = _ref16.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'site/decimation_step/' + params.section + '/' + params.site + '/' + params.report_data_id).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_DECIMATION_SITES: function LOAD_DECIMATION_SITES(_ref17, params) {
      var commit = _ref17.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'site/decimation_sites/' + params.minutes + '/' + params.sites_json).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_DECIMATION_DATE_RANGE: function LOAD_DECIMATION_DATE_RANGE(_ref18, params) {
      var commit = _ref18.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'site/decimation_date_range/' + params.dateFrom + '/' + params.dateTo + '/' + params.sites_json).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_FUGAS: function LOAD_FUGAS(_ref19, params) {
      var _this4 = this;

      var commit = _ref19.commit,
          getters = _ref19.getters;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var urlParams = '';
        params = params || {};
        params.last = _this4.state.last_leak_timestamp;
        var count = 0;
        for (var i in params) {
          if (__WEBPACK_IMPORTED_MODULE_10_ramda__["f" /* isNil */](params[i])) {
            continue;
          }
          urlParams = urlParams + (!count ? '?' : '&') + i + '=' + params[i];
          count = count + 1;
        }
        var url = "https://api.ductos-gaes.com/" + 'leak' + urlParams;
        var headers = {};

        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get(url, { headers: headers }).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            if (response.code === 304) {
              return resolve();
            }

            throw new Error('Bad data');
          }
          var etag = resp.headers['etag'];
          commit('SET_ETAG', { url: url, etag: etag });
          var sections = getters.allowedSections;

          commit('SET_FUGAS', {
            data: response.data
          });

          return resolve();
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    IDENTIFY_FUGA: function IDENTIFY_FUGA(_ref20, params) {
      var commit = _ref20.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        params = params || {};
        if (!params.id) {
          return reject('Missing leak id');
        }
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].put("https://api.ductos-gaes.com/" + 'leak/' + params.id, params).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response.data);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_GENERAL: function LOAD_GENERAL(_ref21, params) {
      var commit = _ref21.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + ('section/info?date=' + params.fecha)).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_SITE_INFO: function LOAD_SITE_INFO(_ref22, params) {
      var commit = _ref22.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'site/info/' + params.section + '/' + params.site).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }

          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_OPS: function LOAD_OPS(_ref23, params) {
      var _this5 = this;

      var commit = _ref23.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'section/info').then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          _this5.state.options = [];
          response.data.forEach(function (r) {
            _this5.state.options.push(JSON.parse(r.section_info));
          });
          return resolve(_this5.state.options);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_ESTADOS: function LOAD_ESTADOS(_ref24, params) {
      var commit = _ref24.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = "https://api.ductos-gaes.com/" + ('section?current=' + params.estado);
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get(url).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }

          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_BATERIA: function LOAD_BATERIA(_ref25, params) {
      var commit = _ref25.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + ('section?field=battery&timestamp=-1&id_section=' + params.ducto + '&id_rtu=' + params.estacion + '&start_date=' + params.desde + '&end_date=' + params.hasta)).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }

          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    GET_PRESION: function GET_PRESION(_ref26, params) {
      var commit = _ref26.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var lastTimestamp = params && params.lastTimestamp || -1;
        if (params.ducto === '') {
          return;
        }
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + ('section?field=pressure&timestamp=' + lastTimestamp + '&id_section=' + params.ducto + '&id_rtu=' + params.estacion + '&start_date=' + params.desde + '&end_date=' + params.hasta)).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_PRESION: function LOAD_PRESION(_ref27, params) {
      var _this6 = this;

      var commit = _ref27.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var lastTimestamp = params && params.lastTimestamp || -1;
        if (params.ducto === '') {
          return;
        }
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + ('section?field=pressure&timestamp=' + lastTimestamp + '&id_section=' + params.ducto + '&id_rtu=' + params.estacion + '&start_date=' + params.desde + '&end_date=' + params.hasta)).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(response.data) !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this6.state.cached_presion) && response.data.length !== 0) {
            commit('SET_PRESION', {
              data: response.data
            });
            commit('SET_FILL_STATE', {
              data: true
            });
            return resolve(response);
          } else if (response.data.length === 0) {
            commit('SET_FILL_STATE', {
              data: false
            });
            return resolve('no-data');
          } else {
            commit('SET_FILL_STATE', {
              data: false
            });
            return resolve('same-data');
          }
        }).catch(function (err) {
          commit('SET_PRESION', {
            data: _this6.state.cached_presion
          });
          console.log('error', err);
          return reject(err);
        });
      });
    },
    QUERY_PRESION: function QUERY_PRESION(_ref28, params) {
      var _this7 = this;

      var commit = _ref28.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var lastTimestamp = params && params.lastTimestamp || -1;
        if (params.ducto === '') {
          return;
        }
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].post("https://api.ductos-gaes.com/" + 'section/query', {
          field: 'pressure',
          timestamp: lastTimestamp,
          id_section: params.ducto,
          id_rtu: params.estacion,
          start_date: params.desde,
          end_date: params.hasta
        }).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(response.data) !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this7.state.cached_presion) && response.data.length !== 0) {
            commit('SET_PRESION', {
              data: response.data
            });
            commit('SET_FILL_STATE', {
              data: true
            });
            return resolve(response);
          } else if (response.data.length === 0) {
            commit('SET_FILL_STATE', {
              data: false
            });
            return resolve('no-data');
          } else {
            commit('SET_FILL_STATE', {
              data: false
            });
            return resolve('same-data');
          }
        }).catch(function (err) {
          commit('SET_PRESION', {
            data: _this7.state.cached_presion
          });
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_STATISTICS: function LOAD_STATISTICS(_ref29, params) {
      var _this8 = this;

      var commit = _ref29.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var lastTimestamp = params && params.lastTimestamp || -1;
        if (params.ducto === '') {
          return;
        }
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + ('section?field=pressure&timestamp=' + lastTimestamp + '&id_section=' + params.ducto + '&start_date=' + params.desde + '&end_date=' + params.hasta)).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(response.data) !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this8.state.cached_presion) && response.data.length !== 0) {
            commit('SET_PRESION', {
              data: response.data
            });
            commit('SET_FILL_STATE', {
              data: true
            });
            return resolve(response);
          } else if (response.data.length === 0) {
            commit('SET_FILL_STATE', {
              data: false
            });
            return resolve('no-data');
          } else {
            commit('SET_FILL_STATE', {
              data: false
            });
            return resolve('same-data');
          }
        }).catch(function (err) {
          commit('SET_PRESION', {
            data: _this8.state.cached_presion
          });
          console.log('error', err);
          return reject(err);
        });
      });
    },
    LOAD_PIPELINE_SHAPES: function LOAD_PIPELINE_SHAPES(_ref30, params) {
      var commit = _ref30.commit,
          getters = _ref30.getters;


      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var sections = getters.allowedSections;
        sections.forEach(function (section) {
          var url = "https://api.ductos-gaes.com/" + 'site/getPipeLineShapes?section=' + section;
          var headers = {};


          __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get(url, { headers: headers }).then(function (resp) {
            if (!resp || resp.status !== 200) {
              throw new Error('Bad response');
            }
            var response = resp.data;
            if (!response || response.code !== 200) {
              if (response.code === 304) {
                return resolve();
              }

              throw new Error('Bad data');
            }
            var etag = resp.headers['etag'];
            commit('SET_ETAG', { url: url, etag: etag });
            var sections = getters.allowedSections;
            commit('SET_ROUTE', __WEBPACK_IMPORTED_MODULE_10_ramda__["g" /* pick */](sections, response.data));
            return resolve(__WEBPACK_IMPORTED_MODULE_10_ramda__["g" /* pick */](sections, response.data));
          }).catch(function (err) {
            console.log('error', err);
            return reject(err);
          });
        });
      });
    },
    LOAD_CHART_DATA: function LOAD_CHART_DATA(_ref31, params) {
      var commit = _ref31.commit,
          getters = _ref31.getters;
    },
    GET_MONITORING: function GET_MONITORING(_ref32, params) {
      var commit = _ref32.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'monitoring').then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          commit('SET_MONITORING', {
            data: response.data
          });
          return resolve();
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    POST_MONITORING_SITE_ENABLED: function POST_MONITORING_SITE_ENABLED(_ref33, params) {
      var commit = _ref33.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].put("https://api.ductos-gaes.com/" + ('monitoring/' + params.id_section + '/' + params.id_site), {
          enabled: params.enabled,
          username: params.username
        }).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve();
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    POST_MONITORING_PUBLISH_LEAK: function POST_MONITORING_PUBLISH_LEAK(_ref34, params) {
      var commit = _ref34.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].post("https://api.ductos-gaes.com/" + ('monitoring/leak/' + params.id_leak), {
          username: params.username
        }).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve();
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    POST_MONITORING_SETTING: function POST_MONITORING_SETTING(_ref35, params) {
      var commit = _ref35.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].put("https://api.ductos-gaes.com/" + 'monitoring/settings', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, params, {
          username: params.username
        })).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve();
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    GET_USER_ACCESS_LEVELS: function GET_USER_ACCESS_LEVELS(_ref36, params) {
      var commit = _ref36.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'user/access_levels').then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    GET_USER_SECTIONS: function GET_USER_SECTIONS(_ref37, params) {
      var commit = _ref37.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'user/config_sections').then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    GET_USER_DATA: function GET_USER_DATA(_ref38, params) {
      var commit = _ref38.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + 'user/' + params.username).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    UNLOCK_USER: function UNLOCK_USER(_ref39, params) {
      var commit = _ref39.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].put("https://api.ductos-gaes.com/" + ('user/' + params.username + '/unlock')).then(function (resp) {
          if (!resp || resp.status !== 200) {
            throw new Error('Bad response');
          }
          var response = resp.data;
          if (!response || response.code !== 200) {
            throw new Error('Bad data');
          }
          return resolve(response);
        }).catch(function (err) {
          console.log('error', err);
          return reject(err);
        });
      });
    },
    login: function login(_ref40, params) {
      var commit = _ref40.commit;

      if (!params.username || !params.password) {
        return commit('setModalInfo', {
          ready: true,
          msg: 'Campos Vacios',
          subMsg: 'Favor de llenar los campos faltantes'
        });
      }
      commit('setModalInfo', { ready: false });
      __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].post("https://api.ductos-gaes.com/" + 'user/' + params.username + '/login', { password: params.password }).then(function (response) {
        var code = __WEBPACK_IMPORTED_MODULE_10_ramda__["a" /* path */](['data', 'code'], response);

        if (code !== 200) {
          return commit('setModalInfo', {
            ready: true,
            msg: code === 999 ? 'El usuario tiene una sesión abierta' : 'Fallo en la verificación',
            subMsg: code === 999 ? 'Cierre su sesión anterior o espere 10 minutos' : 'Usuario o contraseña incorrecta',
            resp: __WEBPACK_IMPORTED_MODULE_10_ramda__["h" /* prop */]('data', response)
          });
        }

        document.querySelector('#dismiss-button').click();
        var user = __WEBPACK_IMPORTED_MODULE_10_ramda__["i" /* compose */](function (u) {
          return __WEBPACK_IMPORTED_MODULE_10_ramda__["j" /* assoc */]('config', __WEBPACK_IMPORTED_MODULE_10_ramda__["k" /* tryCatch */](function (u) {
            return JSON.parse(u.config);
          }, __WEBPACK_IMPORTED_MODULE_10_ramda__["l" /* always */]({}))(u), u);
        }, __WEBPACK_IMPORTED_MODULE_10_ramda__["d" /* pathOr */]({}, ['data', 'data']))(response);

        commit('SET_DUPLICATE_SESSION', false);

        var recoveryGuid = __WEBPACK_IMPORTED_MODULE_10_ramda__["a" /* path */](['data', 'data', 'recoveryGuid'], response);

        if (recoveryGuid) {
          commit('CLEAR_USER');
          commit('SET_RECOVERY_DATA', user);
          __WEBPACK_IMPORTED_MODULE_11__router_routes__["a" /* default */].replace('/passwordrecovery');
        } else {
          commit('SET_USER', user);
          commit('CLEAR_RECOVERY_DATA');
          __WEBPACK_IMPORTED_MODULE_11__router_routes__["a" /* default */].replace('/dashboard');
        }
      }).catch(function (err) {
        commit('CLEAR_RECOVERY_DATA');
        console.log('error', err);
        commit('setModalInfo', {
          ready: true,
          msg: 'Fallo en la verificación',
          subMsg: 'Usuario o contraseña incorrecta',
          resp: err
        });
      });
    },
    logout: function logout(_ref41) {
      var commit = _ref41.commit;

      var _logout = function _logout() {
        var id = setTimeout(function () {}, 0);
        while (id--) {
          window.clearTimeout(id);
        }

        var dismissBtn = document.querySelector('#dismiss-button');
        if (dismissBtn) {
          dismissBtn.click();
        }

        commit('CLEAR_USER');
        __WEBPACK_IMPORTED_MODULE_11__router_routes__["a" /* default */].replace('/');
      };

      if (!this.state.user) {
        return _logout();
      }
      commit('setModalInfo', { ready: false });
      __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].post("https://api.ductos-gaes.com/" + 'user/' + __WEBPACK_IMPORTED_MODULE_10_ramda__["a" /* path */](['state', 'user', 'username'], this) + '/logout').then(function (response) {
        if (__WEBPACK_IMPORTED_MODULE_10_ramda__["a" /* path */](['data', 'code'], response) !== 200) {
          return commit('setModalInfo', {
            ready: true,
            msg: 'Error',
            subMsg: 'Se produjo un error al cerrar sesión'
          });
        }
      }).catch(__WEBPACK_IMPORTED_MODULE_10_ramda__["m" /* identity */]).then(_logout);
    },
    requestCode: function requestCode(_ref42, params) {
      var commit = _ref42.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!params.email) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Campo Vacio',
            subMsg: 'Favor de ingresar el correo electrónico'
          });
          return reject(new Error('Email is required'));
        }
        commit('setModalInfo', { ready: false });
        var encodedEmail = Buffer.from(params.email).toString('base64');
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].post("https://api.ductos-gaes.com/" + 'user/' + params.guid + '/request-code', {
          email: encodedEmail,
          guid: params.guid
        }).then(function (response) {
          var isSuccess = __WEBPACK_IMPORTED_MODULE_10_ramda__["a" /* path */](['data', 'desc'], response) === 'Success';
          commit('setModalInfo', {
            ready: true,
            msg: 'Código Enviado',
            subMsg: isSuccess ? 'El código de verificación ha sido enviado a su correo electrónico' : 'No se pudo enviar el código de verificación'
          });
          resolve(isSuccess);
        }).catch(function (err) {
          console.log('error', err);
          commit('setModalInfo', {
            ready: true,
            msg: 'Error',
            subMsg: 'Hubo un error al enviar el código de verificación',
            resp: err
          });
          reject(err);
        });
      });
    },
    verifyCode: function verifyCode(_ref43, params) {
      var commit = _ref43.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!params.code) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Campo Vacio',
            subMsg: 'Favor de ingresar el código'
          });
          return reject(new Error('Code is required'));
        }
        commit('setModalInfo', { ready: false });
        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].post("https://api.ductos-gaes.com/" + 'user/' + params.guid + '/verify', {
          guid: params.guid,
          code: params.code
        }).then(function (response) {
          var isValid = __WEBPACK_IMPORTED_MODULE_10_ramda__["a" /* path */](['data', 'data'], response);
          commit('setModalInfo', {
            ready: true,
            msg: 'Código Verificado',
            subMsg: isValid ? 'El código de verificación es correcto' : 'El código de verificación es incorrecto'
          });
          resolve(isValid);
        }).catch(function (err) {
          console.log('error', err);
          commit('setModalInfo', {
            ready: true,
            msg: 'Error',
            subMsg: 'Hubo un error al verificar el código',
            resp: err
          });
          reject(err);
        });
      });
    },
    resetPassword: function resetPassword(_ref44, params) {
      var commit = _ref44.commit;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!params.password || !params.confirmPassword) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Campos Vacios',
            subMsg: 'Favor de llenar los campos faltantes'
          });
          return reject(new Error('Password and confirm password are required'));
        }
        if (params.password.length < 5) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Contraseña Corta',
            subMsg: 'La contraseña debe tener al menos 5 caracteres'
          });
          return reject(new Error('Password is too short'));
        }
        if (params.password !== params.confirmPassword) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Contraseñas no coinciden',
            subMsg: 'Favor de verificar que las contraseñas coincidan'
          });
          return reject(new Error('Passwords do not match'));
        }
        commit('setModalInfo', { ready: false });

        var encodedPassword = Buffer.from(params.password).toString('base64');

        __WEBPACK_IMPORTED_MODULE_7__common_axios__["a" /* default */].post("https://api.ductos-gaes.com/" + 'user/' + params.guid + '/reset', {
          guid: params.guid,
          password: encodedPassword,
          code: params.code
        }).then(function (response) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Contraseña Cambiada',
            subMsg: 'Se ha cambiado la contraseña con éxito'
          });
          resolve(response);
        }).catch(function (err) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Error',
            subMsg: 'Hubo un error al cambiar la contraseña',
            resp: err
          });
          reject(err);
        });
      });
    },
    clearUser: function clearUser(_ref45) {
      var commit = _ref45.commit;

      commit('CLEAR_USER');
    }
  },
  mutations: {
    SET_DUPLICATE_SESSION: function SET_DUPLICATE_SESSION(state, flag) {
      state.duplicateSession = flag;
    },
    SET_FILL_STATE: function SET_FILL_STATE(state, _ref46) {
      var data = _ref46.data;

      state.fill = data;
    },
    UPDATE_LEAK_STATE: function UPDATE_LEAK_STATE(state, _ref47) {
      var data = _ref47.data;

      state.transformed_cached_ductos[data.section]._sites[data.id].leak = data.val;
    },
    SET_DUCTOS: function SET_DUCTOS(state, _ref48) {
      var data = _ref48.data;

      state.cached_ductos = data;
      var ductsInfo = {};
      var d = state.cached_ductos;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(d).map(function (key, index) {
        var section = __WEBPACK_IMPORTED_MODULE_8__models_section__["a" /* default */].fromData(d[index]);
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(d[index].site).forEach(function (key) {
          section.addSiteFromData(d[index].site[key]);
        });
        ductsInfo[section.id] = section;
      });
      state.transformed_cached_ductos = ductsInfo;
    },
    SET_FUGAS: function SET_FUGAS(state, _ref49) {
      var data = _ref49.data;

      if (!data || data.length <= 0) {
        return;
      }
      state.last_leak_timestamp = data[0].detection_timestamp;

      var transformed_data = [];
      data.forEach(function (item, index) {
        var leak = __WEBPACK_IMPORTED_MODULE_9__models_leak__["a" /* default */].fromData(item);
        transformed_data.push(leak);
      });
      state.transformed_cached_leaks = transformed_data;
    },
    SET_PRESION: function SET_PRESION(state, _ref50) {
      var data = _ref50.data;

      state.cached_presion = data;
    },
    SET_CURRENT_CHART_DATA: function SET_CURRENT_CHART_DATA(state, _ref51) {
      var data = _ref51.data;

      state.chartCurrentData = data;
    },
    SET_USER: function SET_USER(state, payload) {
      state.user = payload;
      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].ls.set('user', state.user);
    },
    CLEAR_USER: function CLEAR_USER(state) {
      this.$store = null;
      state.user = null;
      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].ls.set('user', null);
      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].ls.clear();
    },
    SET_RECOVERY_DATA: function SET_RECOVERY_DATA(state, payload) {
      state.recovery = payload;
    },
    CLEAR_RECOVERY_DATA: function CLEAR_RECOVERY_DATA(state) {
      state.recovery = null;
    },
    UPDATE_ALARM_STATUS: function UPDATE_ALARM_STATUS(state, payload) {},
    SET_ROUTE: function SET_ROUTE(state, route) {
      state.routes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.routes, route);
    },
    SET_ETAG: function SET_ETAG(state, data) {
      state.ETags[data.url] = data.etag;
    },
    SET_CONCEPTOS: function SET_CONCEPTOS(state, data) {
      state.conceptos = data;
    },
    SET_HELP: function SET_HELP(state, data) {
      state.help = data;
    },
    SET_CHART_DATA: function SET_CHART_DATA(state, chart) {
      state.charts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.charts, chart);
    },
    SET_MONITORING: function SET_MONITORING(state, data) {
      var monitoring = data && data.data && data.data.monitoring || [];
      var rtu = monitoring.map(function (d) {
        return JSON.parse(d.section_info);
      });
      var settings = {};
      data && data.data && data.data.settings && data.data.settings.forEach(function (s) {
        settings[s.type] = s.value;
      }) || {};
      var leaks = data && data.data && data.data.leaks || [];

      state.monitoring = {
        rtu: rtu,
        settings: settings,
        leaks: leaks
      };
    },
    setModalInfo: function setModalInfo(state, data) {
      state.modalInfo = __WEBPACK_IMPORTED_MODULE_10_ramda__["n" /* defaultTo */]({}, data);
    }
  },
  getters: {
    authToken: function authToken(state) {
      return function () {
        var user = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].ls.get('user');
        return __WEBPACK_IMPORTED_MODULE_10_ramda__["h" /* prop */]('accessToken', user);
      };
    },
    userName: function userName(state) {
      var user = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].ls.get('user');
      return __WEBPACK_IMPORTED_MODULE_10_ramda__["h" /* prop */]('username', user);
    },
    allowedSections: function allowedSections(state) {
      var user = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].ls.get('user');
      return __WEBPACK_IMPORTED_MODULE_10_ramda__["d" /* pathOr */]([], ['config', 'sections'], user);
    },
    GET_PRESION_SPECIFIC_DATA: function GET_PRESION_SPECIFIC_DATA(state) {
      return function (param) {
        var arr = [];
        state.cached_presion.forEach(function (p) {
          arr.push(p[param]);
        });
        return arr;
      };
    },
    GET_HOME_DUCTOS_TABLE: function GET_HOME_DUCTOS_TABLE(state) {
      if (!state.cached_ductos || !state.transformed_cached_ductos) {
        return;
      }
      return state.transformed_cached_ductos;
    },
    GET_HOME_LEAKS_TABLE: function GET_HOME_LEAKS_TABLE(state) {
      if (!state.transformed_cached_leaks) {
        return;
      }
      return state.transformed_cached_leaks;
    },
    GET_ALL_BITACORA: function GET_ALL_BITACORA(state) {
      return state.db && state.db.bitacora.filter(function (b) {
        return b;
      });
    },
    GET_ALL_CAMPOS: function GET_ALL_CAMPOS(state) {
      return state.db && state.db.campos.filter(function (b) {
        return b;
      });
    },
    GET_ALL_CAMPOS2: function GET_ALL_CAMPOS2(state) {
      return state.db && state.db.camposTable2.filter(function (b) {
        return b;
      });
    },

    GET_OP: function GET_OP(state) {
      return function (param) {
        var arr = [];
        var x = false;
        state.options.forEach(function (op, i) {
          if (!op) return;
          if (param.filteredBy !== 'sites') {
            arr.forEach(function (a) {
              if (op[param.filteredBy] === a) {
                arr.push(op[param.filteredBy] + '-' + op['id_section']);
                x = true;
              }
            });
            if (!x) {
              arr.push({
                name: op[param.filteredBy],
                value: op['id_section']
              });
            }
          } else {
            op['sites'].forEach(function (site, i) {
              if (op['id_section'] === param.ducto) {
                arr.push({
                  name: site['site_name'],
                  value: site['id_site']
                });
              }
            });
            var temp = [];
            arr.forEach(function (elem, pos, arr) {
              var x = 0;
              if (temp.length === 0) {
                temp.push(elem);
              } else {
                temp.forEach(function (e) {
                  e.name === elem.name ? x++ : '';
                });
                if (x === 0) {
                  temp.push(elem);
                }
              }
            });
            arr = temp;
          }
          x = false;
        });
        return arr;
      };
    },
    GET_KM_RANGE: function GET_KM_RANGE(state) {
      return function (params) {
        var result = {};
        state.options.forEach(function (op, i) {
          result[op['id_section']] = {
            min: op['km_init'],
            max: op['km_final']
          };
        });
        return result;
      };
    },
    GET_ETAG: function GET_ETAG(state) {
      return function (url) {
        return state.ETags[url];
      };
    },
    GET_CONCEPTOS: function GET_CONCEPTOS(state) {
      return state.conceptos;
    },
    GET_HELP: function GET_HELP(state) {
      return state.help;
    },
    GET_ROUTES: function GET_ROUTES(state) {
      return state.routes;
    },
    GET_MONITORING: function GET_MONITORING(state) {
      return state.monitoring;
    },
    GET_MONITORING_RTU: function GET_MONITORING_RTU(state) {
      return state.monitoring.rtu;
    },
    GET_MONITORING_SETTINGS: function GET_MONITORING_SETTINGS(state) {
      return state.monitoring.settings;
    },
    GET_MONITORING_LEAKS: function GET_MONITORING_LEAKS(state) {
      return state.monitoring.leaks;
    }
  },
  modules: {}
});
/* harmony default export */ __webpack_exports__["a"] = (store);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(17).Buffer))

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);


var reactiveProp = __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp;




var zoomPluginOpts = {
  zoom: {
    enabled: true,

    mode: 'xy'
  },
  pan: {
    enabled: true,
    mode: 'xy',
    speed: 20,
    threshold: 10
  }
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"].extend({
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    'options': {
      handler: function handler(newOption, oldOption) {
        this._chart.destroy();
        this.renderChart(this.chartData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.options, zoomPluginOpts));
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.addPlugin(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a);

    this.renderChart(this.chartData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.options, zoomPluginOpts));
  }
}));

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(357);






var Leak = function () {
    function Leak() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Leak);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Leak, [{
        key: 'isSameSection',
        value: function isSameSection() {
            return this._id_section_1 === this._id_section_2;
        }
    }, {
        key: 'id',
        get: function get() {
            return this._id;
        }
    }, {
        key: 'btwn',
        get: function get() {
            return this._btwn;
        }
    }, {
        key: 'section1Name',
        get: function get() {
            return this._name_section_1;
        }
    }, {
        key: 'site1Name',
        get: function get() {
            return this._name_site_1;
        }
    }, {
        key: 'section2Name',
        get: function get() {
            return this._name_section_2;
        }
    }, {
        key: 'site2Name',
        get: function get() {
            return this._name_site_2;
        }
    }, {
        key: 'formattedSectionName',
        get: function get() {
            return this.isSameSection() ? this.section1Name : this.section1Name + '/' + this.section2Name;
        }
    }, {
        key: 'formattedSiteName',
        get: function get() {
            return this.site1Name + '/' + this.site2Name;
        }
    }, {
        key: 'km',
        get: function get() {
            return this._km;
        }
    }, {
        key: 'lat',
        get: function get() {
            return this._n_lat || this._lat;
        }
    }, {
        key: 'lon',
        get: function get() {
            return this._n_lon || this._lon;
        }
    }, {
        key: 'formattedCoord',
        get: function get() {
            return this._lat + ', ' + this._lon;
        }
    }, {
        key: 'detectionTimestamp',
        get: function get() {
            return this._detection_timestamp;
        }
    }, {
        key: 'formattedDetectionTimestamp',
        get: function get() {
            return this._detection_timestamp && this._detection_timestamp.replace('Z', '').replace('T', ' ') || '';
        }
    }, {
        key: 'status',
        get: function get() {
            return this._status;
        },
        set: function set(status) {
            this._status = status;
        }
    }, {
        key: 'timestamp',
        get: function get() {
            return this._timestamp;
        }
    }, {
        key: 'type',
        get: function get() {
            return this._type;
        }
    }, {
        key: 'pressure_1',
        get: function get() {
            return this._pressure_1;
        }
    }, {
        key: 'pressure_2',
        get: function get() {
            return this._pressure_2;
        }
    }, {
        key: 'state_1',
        get: function get() {
            return this._state_1;
        }
    }, {
        key: 'state_2',
        get: function get() {
            return this._state_2;
        }
    }, {
        key: 'city_1',
        get: function get() {
            return this._city_1;
        }
    }, {
        key: 'city_2',
        get: function get() {
            return this._city_2;
        }
    }, {
        key: 'offline_status',
        get: function get() {
            return this._offline_status;
        }
    }, {
        key: 'is_operational_movement',
        get: function get() {
            return this._is_operational_movement;
        }
    }, {
        key: 'description',
        get: function get() {
            var desc = 'Ducto: ';
            desc += this.isSameSection() ? this.section1Name : this.section1Name + '/' + this.section2Name;

            desc += '  ';
            desc += this.state_1 === this.state_2 ? 'Estado: ' + this.state_1 : 'Estados : ' + this.state_1 + '/' + this.state_2;
            desc += '  ';
            desc += this.city_1 === this.city_2 ? 'Ciudad: ' + this.city_1 : 'Ciudades : ' + this.city_1 + '/' + this.city_2;

            return desc;
        }
    }, {
        key: 'states',
        get: function get() {
            return this.state_1 === this.state_2 ? this.state_1 : this.state_1 + '/' + this.state_2;
        }
    }, {
        key: 'cities',
        get: function get() {
            return this.city_1 === this.city_2 ? this.city_1 : this.city_1 + '/' + this.city_2;
        }
    }], [{
        key: 'fromData',
        value: function fromData(data) {
            if (!data) {
                return null;
            }

            var leak = new Leak();
            leak._id = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.id_leak) ? Number(data.id_leak) : -1;
            leak._btwn = Leak.validateValue(data.btwn, null);
            leak._id_section_1 = Leak.validateValue(data.section_1_id, null);
            leak._name_section_1 = Leak.validateValue(data.section_1_name, null);
            leak._id_site_1 = Leak.validateValue(data.site_1_id, -1);
            leak._name_site_1 = Leak.validateValue(data.site_1_name, null);
            leak._id_section_2 = Leak.validateValue(data.section_2_id, null);
            leak._name_section_2 = Leak.validateValue(data.section_2_name, null);
            leak._id_site_2 = Leak.validateValue(data.site_2_id, null);
            leak._name_site_2 = Leak.validateValue(data.site_2_name, null);
            leak._km = Leak.validateValue(data.km, 0);
            leak._lat = Leak.validateValue(data.lat, 0);
            leak._lon = Leak.validateValue(data.lon, 0);
            leak._detection_timestamp = Leak.validateValue(data.detection_timestamp, null);
            leak._timestamp = Leak.validateValue(data.timestamp, null);
            leak._status = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.status) ? Number(data.status) : -1;
            leak._type = Leak.validateValue(data.type, 0);
            leak._n_lat = Leak.validateValue(data.n_lat, 0);
            leak._n_lon = Leak.validateValue(data.n_lon, 0);
            leak._pressure_2 = Leak.validateValue(data.pressure_2, 0);
            leak._pressure_1 = Leak.validateValue(data.pressure_1, 0);
            leak._state_1 = Leak.validateValue(data.state_1, null);
            leak._state_2 = Leak.validateValue(data.state_2, null);
            leak._city_1 = Leak.validateValue(data.city_1, null);
            leak._city_2 = Leak.validateValue(data.city_2, null);
            leak._offline_status = Leak.validateValue(data.offline_status, null);
            leak._is_operational_movement = Leak.validateValue(data.is_operational_movement, null);

            return leak;
        }
    }, {
        key: 'validateValue',
        value: function validateValue(value, defaultValue) {
            return value !== undefined && value !== null ? value : defaultValue;
        }
    }]);

    return Leak;
}();

/* harmony default export */ __webpack_exports__["a"] = (Leak);


Leak.Status = {
    PROCESSED: -1,
    NEW: 0,
    SYSTEM_IDENTIFIED: 1,
    RECOGNIZED: 2,
    IN_DAILY_REPORT: 3
};

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1748)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1702),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59e5df89",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_GAES.51ff744.png";

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_pemex_original.0bbb223.png";

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1769)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1722),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f1ff1b3e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1734)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-195b8fc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1758)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a8a8e030",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1733)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1687),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18f81f81",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1737)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1691),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-218db49c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1759)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a9c628d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1738)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(1692),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ad23b5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1739)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(1693),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c99c86a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1760)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(1713),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aac9873c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1765)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d6789794",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1756)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(1709),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73cc693a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1743)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1697),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44d40890",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_Login__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home_Home__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Historico_Historico__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Historico_Historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Historico_Historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HistoricalLegacy__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HistoricalLegacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_HistoricalLegacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Historico_Reportes__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Historico_Reportes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Historico_Reportes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Presion_Presion__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Presion_Presion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Presion_Presion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Presion_PresionNormal__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Presion_PresionNormal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Presion_PresionNormal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Presion_PresionRange__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Presion_PresionRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Presion_PresionRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Bitacora_Bitacora__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Bitacora_Bitacora___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Bitacora_Bitacora__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Campo_Campo__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Campo_Campo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Campo_Campo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Direccion_Tendencias__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Direccion_Tendencias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Direccion_Tendencias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Direccion_General__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Direccion_General___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Direccion_General__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Reportes_Poll__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Reportes_Poll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Reportes_Poll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Reportes_Pressure__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Reportes_Pressure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Reportes_Pressure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Reportes_PressureReport__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Reportes_PressureReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Reportes_PressureReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Reportes_Reportepoll__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Reportes_Reportepoll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Reportes_Reportepoll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Reportes_Presion__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Reportes_Presion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Reportes_Presion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Volumetria_Volumetria__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Volumetria_Volumetria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Volumetria_Volumetria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Configuracion_Configuracion__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Configuracion_Configuracion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Configuracion_Configuracion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Salud_Salud__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Salud_Salud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Salud_Salud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Sitio_sitio__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Sitio_sitio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Sitio_sitio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Unauthorized_Unauthorized__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Unauthorized_Unauthorized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Unauthorized_Unauthorized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Charts_CustomLineChart__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Charts_CustomLineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Charts_CustomLineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_PasswordRecovery_PasswordRecovery__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_PasswordRecovery_PasswordRecovery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_PasswordRecovery_PasswordRecovery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_test__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_test__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__gards__ = __webpack_require__(808);





























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login_Login___default.a
  }, {
    path: '/passwordrecovery',
    name: 'Recuperar contraseña',
    component: __WEBPACK_IMPORTED_MODULE_25__components_PasswordRecovery_PasswordRecovery___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].recoveryGard
  }, {
    path: '/linechart',
    name: 'Line',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Charts_CustomLineChart___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home_Home___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].dashboardGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/historico',
    name: 'Historico',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Historico_Historico___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].historicAlarmGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/historico-legacy',
    name: 'Historico Legacy',
    component: __WEBPACK_IMPORTED_MODULE_5__components_HistoricalLegacy___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].historicAlarmGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/historico/:id',
    name: 'Historico',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Historico_Historico___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].historicDetailAlarmGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/historico/reportes',
    name: 'Reportes',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Historico_Reportes___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].historicReportGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/presion',
    name: 'Presión',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Presion_Presion___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].presionGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/presionrange',
    name: 'Presión por rango de tiempo',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Presion_PresionRange___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].presionGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/presionnormal',
    name: 'Presión normalizada',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Presion_PresionNormal___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].presionGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/bitacora',
    name: 'Bitacora',
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].binnacleGard,
    component: __WEBPACK_IMPORTED_MODULE_10__components_Bitacora_Bitacora___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/campo',
    name: 'Campo',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Campo_Campo___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].campGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/direccion/tendencias',
    name: 'Tendencias',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Direccion_Tendencias___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].dirTrendGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/direccion/general',
    name: 'General',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Direccion_General___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].dirGeneralGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/reporte/pressure',
    name: 'ReportePressure',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Reportes_Pressure___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].reportPollGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/reporte/pressurereport',
    name: 'PressureReport',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Reportes_PressureReport___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].reportPollGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/reporte/poll',
    name: 'Poll',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Reportes_Poll___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].reportPollGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/reporte/Reportepoll',
    name: 'Reportepoll',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Reportes_Reportepoll___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].reportTablePollGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/reporte/presion',
    name: 'ReportePresion',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Reportes_Presion___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/volumetria',
    name: 'Volumetria',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Volumetria_Volumetria___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/configuracion',
    name: 'Configuracion',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Configuracion_Configuracion___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].monitorGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/salud',
    name: 'Salud',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Salud_Salud___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].healthGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/sitio/:section/:site',
    name: 'Sitio',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Sitio_sitio___default.a,
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__gards__["a" /* default */].healthGard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/test',
    name: 'test',
    component: __WEBPACK_IMPORTED_MODULE_26__components_test___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/unauthorized',
    name: 'Nopage',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Unauthorized_Unauthorized___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login_Login___default.a
  }],
  mode: 'history'
}));

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(209);





__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
    var token = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.authToken();
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
}, function (error) {
    console.log('interceptor:request:error', error);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var status = __WEBPACK_IMPORTED_MODULE_3_ramda__["a" /* path */](['response', 'status'], error);
    if (__WEBPACK_IMPORTED_MODULE_3_ramda__["b" /* includes */](status, [401, 403]) && !__WEBPACK_IMPORTED_MODULE_3_ramda__["c" /* test */](/\/user\/.+\/logout/g, __WEBPACK_IMPORTED_MODULE_3_ramda__["d" /* pathOr */]('', ['response', 'config', 'url'], error))) {
        if (__WEBPACK_IMPORTED_MODULE_3_ramda__["e" /* pathEq */](['response', 'data', 'reason'], 'Whitelist', error)) {
            alert('No tiene permiso para acceder al sistema. Comuníquese con el proveedor.');
        }
        return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('logout');
    }
    if (__WEBPACK_IMPORTED_MODULE_3_ramda__["b" /* includes */](status, [409]) && !__WEBPACK_IMPORTED_MODULE_3_ramda__["c" /* test */](/\/user\/.+\/logout/g, error)) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_DUPLICATE_SESSION', true);
        return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('logout');
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1746)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1700),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e3a5d60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);





var crypto = __webpack_require__(954);
var https = __webpack_require__(1294);

var Utils = function () {
    function Utils() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Utils);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Utils, null, [{
        key: 'hashString',
        value: function hashString(algo, value, output) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                try {
                    output = output || 'hex';
                    resolve(crypto.createHash(algo).update(value).digest('hex'));
                } catch (error) {
                    reject(error);
                }
            });
        }
    }, {
        key: 'randomRassword',
        value: function randomRassword(len) {
            len = len || Utils.Config.RANDOM_PASS_MAX_LEN;
            var possible = 'abcdefghijklmnopqrstuwxyzABCDEFGHIJKLMNOPQRSTUWXYZ0123456789._!';
            var pass = '';
            for (var i = 0; i < len; i++) {
                pass += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return pass;
        }
    }, {
        key: 'hashPassword',
        value: function hashPassword(password) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var config = Utils.Config.Hash;
                crypto.randomBytes(config.saltBytes, function (err, salt) {
                    if (err) {
                        return reject(err);
                    }

                    salt = salt.toString(config.encoding);
                    crypto.pbkdf2(password, salt, config.iterations, config.hashBytes, config.algo, function (err, hash) {
                        if (err) {
                            return reject(err);
                        }

                        return resolve({ hash: hash.toString(config.encoding), salt: salt });
                    });
                });
            });
        }
    }, {
        key: 'verifyPassword',
        value: function verifyPassword(password, hash, salt) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var config = Utils.Config.Hash;
                crypto.pbkdf2(password, salt, config.iterations, config.hashBytes, config.algo, function (err, verify) {
                    verify = verify.toString(config.encoding);
                    if (verify === hash) {
                        resolve();
                    } else {
                        reject('Verification failed');
                    }
                });
            });
        }
    }, {
        key: 'verifyPasswords',
        value: function verifyPasswords(passwords, pwdToCheck) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (passwords.length <= 0) {
                    return reject('No match');
                }

                var pwd = passwords[0];
                passwords.splice(0, 1);

                if (!pwd.hash || !pwd.salt) {
                    return Utils.verifyPasswords(passwords, pwdToCheck).then(function (result) {
                        return resolve(result);
                    }).catch(function (err) {
                        return reject(err);
                    });
                }

                Utils.verifyPassword(pwdToCheck, pwd.hash, pwd.salt, function (err, pass) {
                    if (err) {
                        return Utils.verifyPasswords(passwords, pwdToCheck).then(function (result) {
                            return resolve(result);
                        }).catch(function (err) {
                            return reject(err);
                        });
                    } else {
                        return resolve({ index: passwords.length, pwd: pwd });
                    }
                });
            });
        }
    }, {
        key: 'isArray',
        value: function isArray(checkVar) {
            return Object.prototype.toString.call(checkVar) === '[object Array]';
        }
    }, {
        key: 'isNumber',
        value: function isNumber(val) {
            return val !== null && val !== undefined && (typeof val === 'number' || !isNaN(val));
        }
    }, {
        key: 'getFBUserFriends',
        value: function getFBUserFriends(url, feedCallback) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                https.get(url, function (res) {
                    var statusCode = res && res.statusCode;

                    if (statusCode !== 200) {
                        console.error('Request Failed.\n' + ('Status Code: ' + statusCode));

                        res.resume();
                        return reject(res);
                    }

                    res.setEncoding('utf8');
                    var rawData = '';
                    res.on('data', function (chunk) {
                        rawData += chunk;
                    });
                    res.on('end', function () {
                        try {
                            var json = JSON.parse(rawData);
                            feedCallback(json);
                            if (json.paging && json.paging.next) {
                                return Utils.getFBUserFriends(json.paging.next, feedCallback).then(function () {
                                    return resolve();
                                }).catch(function (e) {
                                    return reject(e);
                                });
                            }
                            return resolve();
                        } catch (e) {
                            console.error(e.message);
                            return reject(e);
                        }
                    });
                }).on('error', function (e) {
                    console.error('Got error: ' + e.message);
                    return reject(e);
                });
            });
        }
    }, {
        key: 'BufferFrom',
        value: function BufferFrom(str, encode) {
            encode = encode || 'binary';

            try {
                return Buffer.from(str, encode);
            } catch (e) {
                return new Buffer(str, encode);
            }
        }
    }]);

    return Utils;
}();

/* harmony default export */ __webpack_exports__["a"] = (Utils);


Utils.Config = {
    RANDOM_PASS_MAX_LEN: 8,
    Hash: {
        hashBytes: 32,

        saltBytes: 16,

        iterations: 1000,
        algo: 'sha512',
        encoding: 'hex' }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(17).Buffer))

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);


var reactiveProp = __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"].extend({
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"],
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.renderChart(this.chartData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.options, {
      animation: {
        duration: 0,
        onComplete: function onComplete() {
          _this.$emit('onAnimationComplete');
        }
      }
    }));
  }
}));

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {Object.defineProperty(exports,"__esModule",{value:true});exports.CFB=exports.SSF=exports.stream=exports.utils=exports.writeFileXLSX=exports.writeXLSX=exports.writeFileAsync=exports.writeFileSync=exports.writeFile=exports.write=exports.readFileSync=exports.readFile=exports.read=exports.parse_zip=exports.parse_xlscfb=exports.version=exports.set_fs=exports.set_cptable=undefined;var _defineProperty=__webpack_require__(236);var _defineProperty2=_interopRequireDefault(_defineProperty);var _map=__webpack_require__(857);var _map2=_interopRequireDefault(_map);var _log=__webpack_require__(858);var _log2=_interopRequireDefault(_log);var _stringify=__webpack_require__(62);var _stringify2=_interopRequireDefault(_stringify);var _keys=__webpack_require__(34);var _keys2=_interopRequireDefault(_keys);var _create=__webpack_require__(859);var _create2=_interopRequireDefault(_create);var _typeof2=__webpack_require__(362);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var XLSX={};XLSX.version='0.18.5';var current_codepage=1200,current_ansi=1252;var VALID_ANSI=[874,932,936,949,950,1250,1251,1252,1253,1254,1255,1256,1257,1258,10000];var CS2CP={0:1252,1:65001,2:65001,77:10000,128:932,129:949,130:1361,134:936,136:950,161:1253,162:1254,163:1258,177:1255,178:1256,186:1257,204:1251,222:874,238:1250,255:1252,69:6969};var set_ansi=function set_ansi(cp){if(VALID_ANSI.indexOf(cp)==-1)return;current_ansi=CS2CP[0]=cp;};function reset_ansi(){set_ansi(1252);}var set_cp=function set_cp(cp){current_codepage=cp;set_ansi(cp);};function reset_cp(){set_cp(1200);reset_ansi();}function char_codes(data){var o=[];for(var i=0,len=data.length;i<len;++i){o[i]=data.charCodeAt(i);}return o;}function utf16leread(data){var o=[];for(var i=0;i<data.length>>1;++i){o[i]=String.fromCharCode(data.charCodeAt(2*i)+(data.charCodeAt(2*i+1)<<8));}return o.join("");}function utf16beread(data){var o=[];for(var i=0;i<data.length>>1;++i){o[i]=String.fromCharCode(data.charCodeAt(2*i+1)+(data.charCodeAt(2*i)<<8));}return o.join("");}var debom=function debom(data){var c1=data.charCodeAt(0),c2=data.charCodeAt(1);if(c1==0xFF&&c2==0xFE)return utf16leread(data.slice(2));if(c1==0xFE&&c2==0xFF)return utf16beread(data.slice(2));if(c1==0xFEFF)return data.slice(1);return data;};var _getchar=function _gc1(x){return String.fromCharCode(x);};var _getansi=function _ga1(x){return String.fromCharCode(x);};var $cptable;function set_cptable(cptable){$cptable=cptable;set_cp=function set_cp(cp){current_codepage=cp;set_ansi(cp);};debom=function debom(data){if(data.charCodeAt(0)===0xFF&&data.charCodeAt(1)===0xFE){return $cptable.utils.decode(1200,char_codes(data.slice(2)));}return data;};_getchar=function _gc2(x){if(current_codepage===1200)return String.fromCharCode(x);return $cptable.utils.decode(current_codepage,[x&255,x>>8])[0];};_getansi=function _ga2(x){return $cptable.utils.decode(current_ansi,[x])[0];};cpdoit();}exports.set_cptable=set_cptable;var DENSE=null;var DIF_XL=true;var Base64_map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";function Base64_encode(input){var o="";var c1=0,c2=0,c3=0,e1=0,e2=0,e3=0,e4=0;for(var i=0;i<input.length;){c1=input.charCodeAt(i++);e1=c1>>2;c2=input.charCodeAt(i++);e2=(c1&3)<<4|c2>>4;c3=input.charCodeAt(i++);e3=(c2&15)<<2|c3>>6;e4=c3&63;if(isNaN(c2)){e3=e4=64;}else if(isNaN(c3)){e4=64;}o+=Base64_map.charAt(e1)+Base64_map.charAt(e2)+Base64_map.charAt(e3)+Base64_map.charAt(e4);}return o;}function Base64_decode(input){var o="";var c1=0,c2=0,c3=0,e1=0,e2=0,e3=0,e4=0;input=input.replace(/[^\w\+\/\=]/g,"");for(var i=0;i<input.length;){e1=Base64_map.indexOf(input.charAt(i++));e2=Base64_map.indexOf(input.charAt(i++));c1=e1<<2|e2>>4;o+=String.fromCharCode(c1);e3=Base64_map.indexOf(input.charAt(i++));c2=(e2&15)<<4|e3>>2;if(e3!==64){o+=String.fromCharCode(c2);}e4=Base64_map.indexOf(input.charAt(i++));c3=(e3&3)<<6|e4;if(e4!==64){o+=String.fromCharCode(c3);}}return o;}var has_buf=function(){return typeof Buffer!=='undefined'&&typeof process!=='undefined'&&typeof process.versions!=='undefined'&&!!process.versions.node;}();var Buffer_from=function(){if(typeof Buffer!=='undefined'){var nbfs=!Buffer.from;if(!nbfs)try{Buffer.from("foo","utf8");}catch(e){nbfs=true;}return nbfs?function(buf,enc){return enc?new Buffer(buf,enc):new Buffer(buf);}:Buffer.from.bind(Buffer);}return function(){};}();function new_raw_buf(len){if(has_buf)return Buffer.alloc?Buffer.alloc(len):new Buffer(len);return typeof Uint8Array!="undefined"?new Uint8Array(len):new Array(len);}function new_unsafe_buf(len){if(has_buf)return Buffer.allocUnsafe?Buffer.allocUnsafe(len):new Buffer(len);return typeof Uint8Array!="undefined"?new Uint8Array(len):new Array(len);}var s2a=function s2a(s){if(has_buf)return Buffer_from(s,"binary");return s.split("").map(function(x){return x.charCodeAt(0)&0xff;});};function s2ab(s){if(typeof ArrayBuffer==='undefined')return s2a(s);var buf=new ArrayBuffer(s.length),view=new Uint8Array(buf);for(var i=0;i!=s.length;++i){view[i]=s.charCodeAt(i)&0xFF;}return buf;}function a2s(data){if(Array.isArray(data))return data.map(function(c){return String.fromCharCode(c);}).join("");var o=[];for(var i=0;i<data.length;++i){o[i]=String.fromCharCode(data[i]);}return o.join("");}function a2u(data){if(typeof Uint8Array==='undefined')throw new Error("Unsupported");return new Uint8Array(data);}function ab2a(data){if(typeof ArrayBuffer=='undefined')throw new Error("Unsupported");if(data instanceof ArrayBuffer)return ab2a(new Uint8Array(data));var o=new Array(data.length);for(var i=0;i<data.length;++i){o[i]=data[i];}return o;}var bconcat=has_buf?function(bufs){return Buffer.concat(bufs.map(function(buf){return Buffer.isBuffer(buf)?buf:Buffer_from(buf);}));}:function(bufs){if(typeof Uint8Array!=="undefined"){var i=0,maxlen=0;for(i=0;i<bufs.length;++i){maxlen+=bufs[i].length;}var o=new Uint8Array(maxlen);var len=0;for(i=0,maxlen=0;i<bufs.length;maxlen+=len,++i){len=bufs[i].length;if(bufs[i]instanceof Uint8Array)o.set(bufs[i],maxlen);else if(typeof bufs[i]=="string"){throw"wtf";}else o.set(new Uint8Array(bufs[i]),maxlen);}return o;}return[].concat.apply([],bufs.map(function(buf){return Array.isArray(buf)?buf:[].slice.call(buf);}));};function utf8decode(content){var out=[],widx=0,L=content.length+250;var o=new_raw_buf(content.length+255);for(var ridx=0;ridx<content.length;++ridx){var c=content.charCodeAt(ridx);if(c<0x80)o[widx++]=c;else if(c<0x800){o[widx++]=192|c>>6&31;o[widx++]=128|c&63;}else if(c>=0xD800&&c<0xE000){c=(c&1023)+64;var d=content.charCodeAt(++ridx)&1023;o[widx++]=240|c>>8&7;o[widx++]=128|c>>2&63;o[widx++]=128|d>>6&15|(c&3)<<4;o[widx++]=128|d&63;}else{o[widx++]=224|c>>12&15;o[widx++]=128|c>>6&63;o[widx++]=128|c&63;}if(widx>L){out.push(o.slice(0,widx));widx=0;o=new_raw_buf(65535);L=65530;}}out.push(o.slice(0,widx));return bconcat(out);}var chr0=/\u0000/g,chr1=/[\u0001-\u0006]/g;function _strrev(x){var o="",i=x.length-1;while(i>=0){o+=x.charAt(i--);}return o;}function pad0(v,d){var t=""+v;return t.length>=d?t:fill('0',d-t.length)+t;}function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}function rpad_(v,d){var t=""+v;return t.length>=d?t:t+fill(' ',d-t.length);}function pad0r1(v,d){var t=""+Math.round(v);return t.length>=d?t:fill('0',d-t.length)+t;}function pad0r2(v,d){var t=""+v;return t.length>=d?t:fill('0',d-t.length)+t;}var p2_32=Math.pow(2,32);function pad0r(v,d){if(v>p2_32||v<-p2_32)return pad0r1(v,d);var i=Math.round(v);return pad0r2(i,d);}function SSF_isgeneral(s,i){i=i||0;return s.length>=7+i&&(s.charCodeAt(i)|32)===103&&(s.charCodeAt(i+1)|32)===101&&(s.charCodeAt(i+2)|32)===110&&(s.charCodeAt(i+3)|32)===101&&(s.charCodeAt(i+4)|32)===114&&(s.charCodeAt(i+5)|32)===97&&(s.charCodeAt(i+6)|32)===108;}var days=[['Sun','Sunday'],['Mon','Monday'],['Tue','Tuesday'],['Wed','Wednesday'],['Thu','Thursday'],['Fri','Friday'],['Sat','Saturday']];var months=[['J','Jan','January'],['F','Feb','February'],['M','Mar','March'],['A','Apr','April'],['M','May','May'],['J','Jun','June'],['J','Jul','July'],['A','Aug','August'],['S','Sep','September'],['O','Oct','October'],['N','Nov','November'],['D','Dec','December']];function SSF_init_table(t){if(!t)t={};t[0]='General';t[1]='0';t[2]='0.00';t[3]='#,##0';t[4]='#,##0.00';t[9]='0%';t[10]='0.00%';t[11]='0.00E+00';t[12]='# ?/?';t[13]='# ??/??';t[14]='m/d/yy';t[15]='d-mmm-yy';t[16]='d-mmm';t[17]='mmm-yy';t[18]='h:mm AM/PM';t[19]='h:mm:ss AM/PM';t[20]='h:mm';t[21]='h:mm:ss';t[22]='m/d/yy h:mm';t[37]='#,##0 ;(#,##0)';t[38]='#,##0 ;[Red](#,##0)';t[39]='#,##0.00;(#,##0.00)';t[40]='#,##0.00;[Red](#,##0.00)';t[45]='mm:ss';t[46]='[h]:mm:ss';t[47]='mmss.0';t[48]='##0.0E+0';t[49]='@';t[56]='"上午/下午 "hh"時"mm"分"ss"秒 "';return t;}var table_fmt={0:'General',1:'0',2:'0.00',3:'#,##0',4:'#,##0.00',9:'0%',10:'0.00%',11:'0.00E+00',12:'# ?/?',13:'# ??/??',14:'m/d/yy',15:'d-mmm-yy',16:'d-mmm',17:'mmm-yy',18:'h:mm AM/PM',19:'h:mm:ss AM/PM',20:'h:mm',21:'h:mm:ss',22:'m/d/yy h:mm',37:'#,##0 ;(#,##0)',38:'#,##0 ;[Red](#,##0)',39:'#,##0.00;(#,##0.00)',40:'#,##0.00;[Red](#,##0.00)',45:'mm:ss',46:'[h]:mm:ss',47:'mmss.0',48:'##0.0E+0',49:'@',56:'"上午/下午 "hh"時"mm"分"ss"秒 "'};var SSF_default_map={5:37,6:38,7:39,8:40,23:0,24:0,25:0,26:0,27:14,28:14,29:14,30:14,31:14,50:14,51:14,52:14,53:14,54:14,55:14,56:14,57:14,58:14,59:1,60:2,61:3,62:4,67:9,68:10,69:12,70:13,71:14,72:14,73:15,74:16,75:17,76:20,77:21,78:22,79:45,80:46,81:47,82:0};var SSF_default_str={5:'"$"#,##0_);\\("$"#,##0\\)',63:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',41:'_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'};function SSF_frac(x,D,mixed){var sgn=x<0?-1:1;var B=x*sgn;var P_2=0,P_1=1,P=0;var Q_2=1,Q_1=0,Q=0;var A=Math.floor(B);while(Q_1<D){A=Math.floor(B);P=A*P_1+P_2;Q=A*Q_1+Q_2;if(B-A<0.00000005)break;B=1/(B-A);P_2=P_1;P_1=P;Q_2=Q_1;Q_1=Q;}if(Q>D){if(Q_1>D){Q=Q_2;P=P_2;}else{Q=Q_1;P=P_1;}}if(!mixed)return[0,sgn*P,Q];var q=Math.floor(sgn*P/Q);return[q,sgn*P-q*Q,Q];}function SSF_parse_date_code(v,opts,b2){if(v>2958465||v<0)return null;var date=v|0,time=Math.floor(86400*(v-date)),dow=0;var dout=[];var out={D:date,T:time,u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(out.u)<1e-6)out.u=0;if(opts&&opts.date1904)date+=1462;if(out.u>0.9999){out.u=0;if(++time==86400){out.T=time=0;++date;++out.D;}}if(date===60){dout=b2?[1317,10,29]:[1900,2,29];dow=3;}else if(date===0){dout=b2?[1317,8,29]:[1900,1,0];dow=6;}else{if(date>60)--date;var d=new Date(1900,0,1);d.setDate(d.getDate()+date-1);dout=[d.getFullYear(),d.getMonth()+1,d.getDate()];dow=d.getDay();if(date<60)dow=(dow+6)%7;if(b2)dow=SSF_fix_hijri(d,dout);}out.y=dout[0];out.m=dout[1];out.d=dout[2];out.S=time%60;time=Math.floor(time/60);out.M=time%60;time=Math.floor(time/60);out.H=time;out.q=dow;return out;}var SSFbasedate=new Date(1899,11,31,0,0,0);var SSFdnthresh=SSFbasedate.getTime();var SSFbase1904=new Date(1900,2,1,0,0,0);function datenum_local(v,date1904){var epoch=v.getTime();if(date1904)epoch-=1461*24*60*60*1000;else if(v>=SSFbase1904)epoch+=24*60*60*1000;return(epoch-(SSFdnthresh+(v.getTimezoneOffset()-SSFbasedate.getTimezoneOffset())*60000))/(24*60*60*1000);}function SSF_strip_decimal(o){return o.indexOf(".")==-1?o:o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/,"$1");}function SSF_normalize_exp(o){if(o.indexOf("E")==-1)return o;return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");}function SSF_small_exp(v){var w=v<0?12:11;var o=SSF_strip_decimal(v.toFixed(12));if(o.length<=w)return o;o=v.toPrecision(10);if(o.length<=w)return o;return v.toExponential(5);}function SSF_large_exp(v){var o=SSF_strip_decimal(v.toFixed(11));return o.length>(v<0?12:11)||o==="0"||o==="-0"?v.toPrecision(6):o;}function SSF_general_num(v){var V=Math.floor(Math.log(Math.abs(v))*Math.LOG10E),o;if(V>=-4&&V<=-1)o=v.toPrecision(10+V);else if(Math.abs(V)<=9)o=SSF_small_exp(v);else if(V===10)o=v.toFixed(10).substr(0,12);else o=SSF_large_exp(v);return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));}function SSF_general(v,opts){switch(typeof v==="undefined"?"undefined":(0,_typeof3.default)(v)){case'string':return v;case'boolean':return v?"TRUE":"FALSE";case'number':return(v|0)===v?v.toString(10):SSF_general_num(v);case'undefined':return"";case'object':if(v==null)return"";if(v instanceof Date)return SSF_format(14,datenum_local(v,opts&&opts.date1904),opts);}throw new Error("unsupported value in General format: "+v);}function SSF_fix_hijri(date,o){o[0]-=581;var dow=date.getDay();if(date<60)dow=(dow+6)%7;return dow;}function SSF_write_date(type,fmt,val,ss0){var o="",ss=0,tt=0,y=val.y,out,outl=0;switch(type){case 98:y=val.y+543;case 121:switch(fmt.length){case 1:case 2:out=y%100;outl=2;break;default:out=y%10000;outl=4;break;}break;case 109:switch(fmt.length){case 1:case 2:out=val.m;outl=fmt.length;break;case 3:return months[val.m-1][1];case 5:return months[val.m-1][0];default:return months[val.m-1][2];}break;case 100:switch(fmt.length){case 1:case 2:out=val.d;outl=fmt.length;break;case 3:return days[val.q][0];default:return days[val.q][1];}break;case 104:switch(fmt.length){case 1:case 2:out=1+(val.H+11)%12;outl=fmt.length;break;default:throw'bad hour format: '+fmt;}break;case 72:switch(fmt.length){case 1:case 2:out=val.H;outl=fmt.length;break;default:throw'bad hour format: '+fmt;}break;case 77:switch(fmt.length){case 1:case 2:out=val.M;outl=fmt.length;break;default:throw'bad minute format: '+fmt;}break;case 115:if(fmt!='s'&&fmt!='ss'&&fmt!='.0'&&fmt!='.00'&&fmt!='.000')throw'bad second format: '+fmt;if(val.u===0&&(fmt=="s"||fmt=="ss"))return pad0(val.S,fmt.length);if(ss0>=2)tt=ss0===3?1000:100;else tt=ss0===1?10:1;ss=Math.round(tt*(val.S+val.u));if(ss>=60*tt)ss=0;if(fmt==='s')return ss===0?"0":""+ss/tt;o=pad0(ss,2+ss0);if(fmt==='ss')return o.substr(0,2);return"."+o.substr(2,fmt.length-1);case 90:switch(fmt){case'[h]':case'[hh]':out=val.D*24+val.H;break;case'[m]':case'[mm]':out=(val.D*24+val.H)*60+val.M;break;case'[s]':case'[ss]':out=((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u);break;default:throw'bad abstime format: '+fmt;}outl=fmt.length===3?1:2;break;case 101:out=y;outl=1;break;}var outstr=outl>0?pad0(out,outl):"";return outstr;}function commaify(s){var w=3;if(s.length<=w)return s;var j=s.length%w,o=s.substr(0,j);for(;j!=s.length;j+=w){o+=(o.length>0?",":"")+s.substr(j,w);}return o;}var pct1=/%/g;function write_num_pct(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_cm(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44){--idx;}return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_exp(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return"0.0E+0";else if(val<0)return"-"+write_num_exp(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf('E');var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(o.indexOf("e")===-1){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);while(o.substr(0,2)==="0."){o=o.charAt(0)+o.substr(2,period)+"."+o.substr(2+period);o=o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");}o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}var frac1=/# (\?+)( ?)\/( ?)(\d+)/;function write_num_f1(r,aval,sign){var den=parseInt(r[4],10),rr=Math.round(aval*den),base=Math.floor(rr/den);var myn=rr-base*den,myd=den;return sign+(base===0?"":""+base)+" "+(myn===0?fill(" ",r[1].length+1+r[4].length):pad_(myn,r[1].length)+r[2]+"/"+r[3]+pad0(myd,r[4].length));}function write_num_f2(r,aval,sign){return sign+(aval===0?"":""+aval)+fill(" ",r[1].length+2+r[4].length);}var dec1=/^#*0*\.([0#]+)/;var closeparen=/\).*[0#]/;var phone=/\(###\) ###\\?-####/;function hashq(str){var o="",cc;for(var i=0;i!=str.length;++i){switch(cc=str.charCodeAt(i)){case 35:break;case 63:o+=" ";break;case 48:o+="0";break;default:o+=String.fromCharCode(cc);}}return o;}function rnd(val,d){var dd=Math.pow(10,d);return""+Math.round(val*dd)/dd;}function dec(val,d){var _frac=val-Math.floor(val),dd=Math.pow(10,d);if(d<(''+Math.round(_frac*dd)).length)return 0;return Math.round(_frac*dd);}function carry(val,d){if(d<(''+Math.round((val-Math.floor(val))*Math.pow(10,d))).length){return 1;}return 0;}function flr(val){if(val<2147483647&&val>-2147483648)return""+(val>=0?val|0:val-1|0);return""+Math.floor(val);}function write_num_flt(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_flt('n',ffmt,val);return'('+write_num_flt('n',ffmt,-val)+')';}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm(type,fmt,val);if(fmt.indexOf('%')!==-1)return write_num_pct(type,fmt,val);if(fmt.indexOf('E')!==-1)return write_num_exp(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0r(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=pad0r(val,0);if(o==="0")o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f1(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0r(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=rnd(val,r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+rnd(aval,r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(pad0r(aval,0));if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_flt(type,fmt,-val):commaify(""+(Math.floor(val)+carry(val,r[1].length)))+"."+pad0(dec(val,r[1].length),r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_flt(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));}if(fmt.match(phone)){o=write_num_flt(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(r[4].length,7);ff=SSF_frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=SSF_frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=pad0r(val,0);if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0?]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){ri=dec(val,r[1].length);return val<0?"-"+write_num_flt(type,fmt,-val):commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(ri,r[1].length);}switch(fmt){case"###,##0.00":return write_num_flt(type,"#,##0.00",val);case"###,###":case"##,###":case"#,###":var x=commaify(pad0r(aval,0));return x!=="0"?sign+x:"";case"###,###.00":return write_num_flt(type,"###,##0.00",val).replace(/^0\./,".");case"#,###.00":return write_num_flt(type,"#,##0.00",val).replace(/^0\./,".");default:}throw new Error("unsupported format |"+fmt+"|");}function write_num_cm2(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44){--idx;}return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_pct2(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_exp2(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return"0.0E+0";else if(val<0)return"-"+write_num_exp2(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf('E');var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(!o.match(/[Ee]/)){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}function write_num_int(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_int('n',ffmt,val);return'('+write_num_int('n',ffmt,-val)+')';}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm2(type,fmt,val);if(fmt.indexOf('%')!==-1)return write_num_pct2(type,fmt,val);if(fmt.indexOf('E')!==-1)return write_num_exp2(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=""+val;if(val===0)o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f2(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=(""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));o=o.replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+(""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(""+aval);if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val)+"."+fill('0',r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_int(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_int(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));}if(fmt.match(phone)){o=write_num_int(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(r[4].length,7);ff=SSF_frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=SSF_frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=""+val;if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(0,r[1].length);}switch(fmt){case"###,###":case"##,###":case"#,###":var x=commaify(""+aval);return x!=="0"?sign+x:"";default:if(fmt.match(/\.[0#?]*$/))return write_num_int(type,fmt.slice(0,fmt.lastIndexOf(".")),val)+hashq(fmt.slice(fmt.lastIndexOf(".")));}throw new Error("unsupported format |"+fmt+"|");}function write_num(type,fmt,val){return(val|0)===val?write_num_int(type,fmt,val):write_num_flt(type,fmt,val);}function SSF_split_fmt(fmt){var out=[];var in_str=false;for(var i=0,j=0;i<fmt.length;++i){switch(fmt.charCodeAt(i)){case 34:in_str=!in_str;break;case 95:case 42:case 92:++i;break;case 59:out[out.length]=fmt.substr(j,i-j);j=i+1;}}out[out.length]=fmt.substr(j);if(in_str===true)throw new Error("Format |"+fmt+"| unterminated string ");return out;}var SSF_abstime=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function fmt_is_date(fmt){var i=0,c="",o="";while(i<fmt.length){switch(c=fmt.charAt(i)){case'G':if(SSF_isgeneral(fmt,i))i+=6;i++;break;case'"':for(;fmt.charCodeAt(++i)!==34&&i<fmt.length;){}++i;break;case'\\':i+=2;break;case'_':i+=2;break;case'@':++i;break;case'B':case'b':if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2")return true;case'M':case'D':case'Y':case'H':case'S':case'E':case'm':case'd':case'y':case'h':case's':case'e':case'g':return true;case'A':case'a':case'上':if(fmt.substr(i,3).toUpperCase()==="A/P")return true;if(fmt.substr(i,5).toUpperCase()==="AM/PM")return true;if(fmt.substr(i,5).toUpperCase()==="上午/下午")return true;++i;break;case'[':o=c;while(fmt.charAt(i++)!==']'&&i<fmt.length){o+=fmt.charAt(i);}if(o.match(SSF_abstime))return true;break;case'.':case'0':case'#':while(i<fmt.length&&("0#?.,E+-%".indexOf(c=fmt.charAt(++i))>-1||c=='\\'&&fmt.charAt(i+1)=="-"&&"0#".indexOf(fmt.charAt(i+2))>-1)){}break;case'?':while(fmt.charAt(++i)===c){}break;case'*':++i;if(fmt.charAt(i)==' '||fmt.charAt(i)=='*')++i;break;case'(':case')':++i;break;case'1':case'2':case'3':case'4':case'5':case'6':case'7':case'8':case'9':while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1){}break;case' ':++i;break;default:++i;break;}}return false;}function eval_fmt(fmt,v,opts,flen){var out=[],o="",i=0,c="",lst='t',dt,j,cc;var hr='H';while(i<fmt.length){switch(c=fmt.charAt(i)){case'G':if(!SSF_isgeneral(fmt,i))throw new Error('unrecognized character '+c+' in '+fmt);out[out.length]={t:'G',v:'General'};i+=7;break;case'"':for(o="";(cc=fmt.charCodeAt(++i))!==34&&i<fmt.length;){o+=String.fromCharCode(cc);}out[out.length]={t:'t',v:o};++i;break;case'\\':var w=fmt.charAt(++i),t=w==="("||w===")"?w:'t';out[out.length]={t:t,v:w};++i;break;case'_':out[out.length]={t:'t',v:" "};i+=2;break;case'@':out[out.length]={t:'T',v:v};++i;break;case'B':case'b':if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2"){if(dt==null){dt=SSF_parse_date_code(v,opts,fmt.charAt(i+1)==="2");if(dt==null)return"";}out[out.length]={t:'X',v:fmt.substr(i,2)};lst=c;i+=2;break;}case'M':case'D':case'Y':case'H':case'S':case'E':c=c.toLowerCase();case'm':case'd':case'y':case'h':case's':case'e':case'g':if(v<0)return"";if(dt==null){dt=SSF_parse_date_code(v,opts);if(dt==null)return"";}o=c;while(++i<fmt.length&&fmt.charAt(i).toLowerCase()===c){o+=c;}if(c==='m'&&lst.toLowerCase()==='h')c='M';if(c==='h')c=hr;out[out.length]={t:c,v:o};lst=c;break;case'A':case'a':case'上':var q={t:c,v:c};if(dt==null)dt=SSF_parse_date_code(v,opts);if(fmt.substr(i,3).toUpperCase()==="A/P"){if(dt!=null)q.v=dt.H>=12?"P":"A";q.t='T';hr='h';i+=3;}else if(fmt.substr(i,5).toUpperCase()==="AM/PM"){if(dt!=null)q.v=dt.H>=12?"PM":"AM";q.t='T';i+=5;hr='h';}else if(fmt.substr(i,5).toUpperCase()==="上午/下午"){if(dt!=null)q.v=dt.H>=12?"下午":"上午";q.t='T';i+=5;hr='h';}else{q.t="t";++i;}if(dt==null&&q.t==='T')return"";out[out.length]=q;lst=c;break;case'[':o=c;while(fmt.charAt(i++)!==']'&&i<fmt.length){o+=fmt.charAt(i);}if(o.slice(-1)!==']')throw'unterminated "[" block: |'+o+'|';if(o.match(SSF_abstime)){if(dt==null){dt=SSF_parse_date_code(v,opts);if(dt==null)return"";}out[out.length]={t:'Z',v:o.toLowerCase()};lst=o.charAt(1);}else if(o.indexOf("$")>-1){o=(o.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!fmt_is_date(fmt))out[out.length]={t:'t',v:o};}break;case'.':if(dt!=null){o=c;while(++i<fmt.length&&(c=fmt.charAt(i))==="0"){o+=c;}out[out.length]={t:'s',v:o};break;}case'0':case'#':o=c;while(++i<fmt.length&&"0#?.,E+-%".indexOf(c=fmt.charAt(i))>-1){o+=c;}out[out.length]={t:'n',v:o};break;case'?':o=c;while(fmt.charAt(++i)===c){o+=c;}out[out.length]={t:c,v:o};lst=c;break;case'*':++i;if(fmt.charAt(i)==' '||fmt.charAt(i)=='*')++i;break;case'(':case')':out[out.length]={t:flen===1?'t':c,v:c};++i;break;case'1':case'2':case'3':case'4':case'5':case'6':case'7':case'8':case'9':o=c;while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1){o+=fmt.charAt(i);}out[out.length]={t:'D',v:o};break;case' ':out[out.length]={t:c,v:c};++i;break;case'$':out[out.length]={t:'t',v:'$'};++i;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c)===-1)throw new Error('unrecognized character '+c+' in '+fmt);out[out.length]={t:'t',v:c};++i;break;}}var bt=0,ss0=0,ssm;for(i=out.length-1,lst='t';i>=0;--i){switch(out[i].t){case'h':case'H':out[i].t=hr;lst='h';if(bt<1)bt=1;break;case's':if(ssm=out[i].v.match(/\.0+$/))ss0=Math.max(ss0,ssm[0].length-1);if(bt<3)bt=3;case'd':case'y':case'M':case'e':lst=out[i].t;break;case'm':if(lst==='s'){out[i].t='M';if(bt<2)bt=2;}break;case'X':break;case'Z':if(bt<1&&out[i].v.match(/[Hh]/))bt=1;if(bt<2&&out[i].v.match(/[Mm]/))bt=2;if(bt<3&&out[i].v.match(/[Ss]/))bt=3;}}switch(bt){case 0:break;case 1:if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}if(dt.M>=60){dt.M=0;++dt.H;}break;case 2:if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}break;}var nstr="",jj;for(i=0;i<out.length;++i){switch(out[i].t){case't':case'T':case' ':case'D':break;case'X':out[i].v="";out[i].t=";";break;case'd':case'm':case'y':case'h':case'H':case'M':case's':case'e':case'b':case'Z':out[i].v=SSF_write_date(out[i].t.charCodeAt(0),out[i].v,dt,ss0);out[i].t='t';break;case'n':case'?':jj=i+1;while(out[jj]!=null&&((c=out[jj].t)==="?"||c==="D"||(c===" "||c==="t")&&out[jj+1]!=null&&(out[jj+1].t==='?'||out[jj+1].t==="t"&&out[jj+1].v==='/')||out[i].t==='('&&(c===' '||c==='n'||c===')')||c==='t'&&(out[jj].v==='/'||out[jj].v===' '&&out[jj+1]!=null&&out[jj+1].t=='?'))){out[i].v+=out[jj].v;out[jj]={v:"",t:";"};++jj;}nstr+=out[i].v;i=jj-1;break;case'G':out[i].t='t';out[i].v=SSF_general(v,opts);break;}}var vv="",myv,ostr;if(nstr.length>0){if(nstr.charCodeAt(0)==40){myv=v<0&&nstr.charCodeAt(0)===45?-v:v;ostr=write_num('n',nstr,myv);}else{myv=v<0&&flen>1?-v:v;ostr=write_num('n',nstr,myv);if(myv<0&&out[0]&&out[0].t=='t'){ostr=ostr.substr(1);out[0].v="-"+out[0].v;}}jj=ostr.length-1;var decpt=out.length;for(i=0;i<out.length;++i){if(out[i]!=null&&out[i].t!='t'&&out[i].v.indexOf(".")>-1){decpt=i;break;}}var lasti=out.length;if(decpt===out.length&&ostr.indexOf("E")===-1){for(i=out.length-1;i>=0;--i){if(out[i]==null||'n?'.indexOf(out[i].t)===-1)continue;if(jj>=out[i].v.length-1){jj-=out[i].v.length;out[i].v=ostr.substr(jj+1,out[i].v.length);}else if(jj<0)out[i].v="";else{out[i].v=ostr.substr(0,jj+1);jj=-1;}out[i].t='t';lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;}else if(decpt!==out.length&&ostr.indexOf("E")===-1){jj=ostr.indexOf(".")-1;for(i=decpt;i>=0;--i){if(out[i]==null||'n?'.indexOf(out[i].t)===-1)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;vv=out[i].v.substr(j+1);for(;j>=0;--j){if(jj>=0&&(out[i].v.charAt(j)==="0"||out[i].v.charAt(j)==="#"))vv=ostr.charAt(jj--)+vv;}out[i].v=vv;out[i].t='t';lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;jj=ostr.indexOf(".")+1;for(i=decpt;i<out.length;++i){if(out[i]==null||'n?('.indexOf(out[i].t)===-1&&i!==decpt)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;vv=out[i].v.substr(0,j);for(;j<out[i].v.length;++j){if(jj<ostr.length)vv+=ostr.charAt(jj++);}out[i].v=vv;out[i].t='t';lasti=i;}}}for(i=0;i<out.length;++i){if(out[i]!=null&&'n?'.indexOf(out[i].t)>-1){myv=flen>1&&v<0&&i>0&&out[i-1].v==="-"?-v:v;out[i].v=write_num(out[i].t,out[i].v,myv);out[i].t='t';}}var retval="";for(i=0;i!==out.length;++i){if(out[i]!=null)retval+=out[i].v;}return retval;}var cfregex2=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function chkcond(v,rr){if(rr==null)return false;var thresh=parseFloat(rr[2]);switch(rr[1]){case"=":if(v==thresh)return true;break;case">":if(v>thresh)return true;break;case"<":if(v<thresh)return true;break;case"<>":if(v!=thresh)return true;break;case">=":if(v>=thresh)return true;break;case"<=":if(v<=thresh)return true;break;}return false;}function choose_fmt(f,v){var fmt=SSF_split_fmt(f);var l=fmt.length,lat=fmt[l-1].indexOf("@");if(l<4&&lat>-1)--l;if(fmt.length>4)throw new Error("cannot find right format for |"+fmt.join("|")+"|");if(typeof v!=="number")return[4,fmt.length===4||lat>-1?fmt[fmt.length-1]:"@"];switch(fmt.length){case 1:fmt=lat>-1?["General","General","General",fmt[0]]:[fmt[0],fmt[0],fmt[0],"@"];break;case 2:fmt=lat>-1?[fmt[0],fmt[0],fmt[0],fmt[1]]:[fmt[0],fmt[1],fmt[0],"@"];break;case 3:fmt=lat>-1?[fmt[0],fmt[1],fmt[0],fmt[2]]:[fmt[0],fmt[1],fmt[2],"@"];break;case 4:break;}var ff=v>0?fmt[0]:v<0?fmt[1]:fmt[2];if(fmt[0].indexOf("[")===-1&&fmt[1].indexOf("[")===-1)return[l,ff];if(fmt[0].match(/\[[=<>]/)!=null||fmt[1].match(/\[[=<>]/)!=null){var m1=fmt[0].match(cfregex2);var m2=fmt[1].match(cfregex2);return chkcond(v,m1)?[l,fmt[0]]:chkcond(v,m2)?[l,fmt[1]]:[l,fmt[m1!=null&&m2!=null?2:1]];}return[l,ff];}function SSF_format(fmt,v,o){if(o==null)o={};var sfmt="";switch(typeof fmt==="undefined"?"undefined":(0,_typeof3.default)(fmt)){case"string":if(fmt=="m/d/yy"&&o.dateNF)sfmt=o.dateNF;else sfmt=fmt;break;case"number":if(fmt==14&&o.dateNF)sfmt=o.dateNF;else sfmt=(o.table!=null?o.table:table_fmt)[fmt];if(sfmt==null)sfmt=o.table&&o.table[SSF_default_map[fmt]]||table_fmt[SSF_default_map[fmt]];if(sfmt==null)sfmt=SSF_default_str[fmt]||"General";break;}if(SSF_isgeneral(sfmt,0))return SSF_general(v,o);if(v instanceof Date)v=datenum_local(v,o.date1904);var f=choose_fmt(sfmt,v);if(SSF_isgeneral(f[1]))return SSF_general(v,o);if(v===true)v="TRUE";else if(v===false)v="FALSE";else if(v===""||v==null)return"";return eval_fmt(f[1],v,o,f[0]);}function SSF_load(fmt,idx){if(typeof idx!='number'){idx=+idx||-1;for(var i=0;i<0x0188;++i){if(table_fmt[i]==undefined){if(idx<0)idx=i;continue;}if(table_fmt[i]==fmt){idx=i;break;}}if(idx<0)idx=0x187;}table_fmt[idx]=fmt;return idx;}function SSF_load_table(tbl){for(var i=0;i!=0x0188;++i){if(tbl[i]!==undefined)SSF_load(tbl[i],i);}}function make_ssf(){table_fmt=SSF_init_table();}var SSF={format:SSF_format,load:SSF_load,_table:table_fmt,load_table:SSF_load_table,parse_date_code:SSF_parse_date_code,is_date:fmt_is_date,get_table:function get_table(){return SSF._table=table_fmt;}};var SSFImplicit={"5":'"$"#,##0_);\\("$"#,##0\\)',"6":'"$"#,##0_);[Red]\\("$"#,##0\\)',"7":'"$"#,##0.00_);\\("$"#,##0.00\\)',"8":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"23":'General',"24":'General',"25":'General',"26":'General',"27":'m/d/yy',"28":'m/d/yy',"29":'m/d/yy',"30":'m/d/yy',"31":'m/d/yy',"32":'h:mm:ss',"33":'h:mm:ss',"34":'h:mm:ss',"35":'h:mm:ss',"36":'m/d/yy',"41":'_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',"42":'_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',"43":'_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',"44":'_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',"50":'m/d/yy',"51":'m/d/yy',"52":'m/d/yy',"53":'m/d/yy',"54":'m/d/yy',"55":'m/d/yy',"56":'m/d/yy',"57":'m/d/yy',"58":'m/d/yy',"59":'0',"60":'0.00',"61":'#,##0',"62":'#,##0.00',"63":'"$"#,##0_);\\("$"#,##0\\)',"64":'"$"#,##0_);[Red]\\("$"#,##0\\)',"65":'"$"#,##0.00_);\\("$"#,##0.00\\)',"66":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"67":'0%',"68":'0.00%',"69":'# ?/?',"70":'# ??/??',"71":'m/d/yy',"72":'m/d/yy',"73":'d-mmm-yy',"74":'d-mmm',"75":'mmm-yy',"76":'h:mm',"77":'h:mm:ss',"78":'m/d/yy h:mm',"79":'mm:ss',"80":'[h]:mm:ss',"81":'mmss.0'};var dateNFregex=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;function dateNF_regex(dateNF){var fmt=typeof dateNF=="number"?table_fmt[dateNF]:dateNF;fmt=fmt.replace(dateNFregex,"(\\d+)");return new RegExp("^"+fmt+"$");}function dateNF_fix(str,dateNF,match){var Y=-1,m=-1,d=-1,H=-1,M=-1,S=-1;(dateNF.match(dateNFregex)||[]).forEach(function(n,i){var v=parseInt(match[i+1],10);switch(n.toLowerCase().charAt(0)){case'y':Y=v;break;case'd':d=v;break;case'h':H=v;break;case's':S=v;break;case'm':if(H>=0)M=v;else m=v;break;}});if(S>=0&&M==-1&&m>=0){M=m;m=-1;}var datestr=(""+(Y>=0?Y:new Date().getFullYear())).slice(-4)+"-"+("00"+(m>=1?m:1)).slice(-2)+"-"+("00"+(d>=1?d:1)).slice(-2);if(datestr.length==7)datestr="0"+datestr;if(datestr.length==8)datestr="20"+datestr;var timestr=("00"+(H>=0?H:0)).slice(-2)+":"+("00"+(M>=0?M:0)).slice(-2)+":"+("00"+(S>=0?S:0)).slice(-2);if(H==-1&&M==-1&&S==-1)return datestr;if(Y==-1&&m==-1&&d==-1)return timestr;return datestr+"T"+timestr;}var CRC32=function(){var CRC32={};CRC32.version='1.2.0';function signed_crc_table(){var c=0,table=new Array(256);for(var n=0;n!=256;++n){c=n;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;table[n]=c;}return typeof Int32Array!=='undefined'?new Int32Array(table):table;}var T0=signed_crc_table();function slice_by_16_tables(T){var c=0,v=0,n=0,table=typeof Int32Array!=='undefined'?new Int32Array(4096):new Array(4096);for(n=0;n!=256;++n){table[n]=T[n];}for(n=0;n!=256;++n){v=T[n];for(c=256+n;c<4096;c+=256){v=table[c]=v>>>8^T[v&0xFF];}}var out=[];for(n=1;n!=16;++n){out[n-1]=typeof Int32Array!=='undefined'?table.subarray(n*256,n*256+256):table.slice(n*256,n*256+256);}return out;}var TT=slice_by_16_tables(T0);var T1=TT[0],T2=TT[1],T3=TT[2],T4=TT[3],T5=TT[4];var T6=TT[5],T7=TT[6],T8=TT[7],T9=TT[8],Ta=TT[9];var Tb=TT[10],Tc=TT[11],Td=TT[12],Te=TT[13],Tf=TT[14];function crc32_bstr(bstr,seed){var C=seed^-1;for(var i=0,L=bstr.length;i<L;){C=C>>>8^T0[(C^bstr.charCodeAt(i++))&0xFF];}return~C;}function crc32_buf(B,seed){var C=seed^-1,L=B.length-15,i=0;for(;i<L;){C=Tf[B[i++]^C&255]^Te[B[i++]^C>>8&255]^Td[B[i++]^C>>16&255]^Tc[B[i++]^C>>>24]^Tb[B[i++]]^Ta[B[i++]]^T9[B[i++]]^T8[B[i++]]^T7[B[i++]]^T6[B[i++]]^T5[B[i++]]^T4[B[i++]]^T3[B[i++]]^T2[B[i++]]^T1[B[i++]]^T0[B[i++]];}L+=15;while(i<L){C=C>>>8^T0[(C^B[i++])&0xFF];}return~C;}function crc32_str(str,seed){var C=seed^-1;for(var i=0,L=str.length,c=0,d=0;i<L;){c=str.charCodeAt(i++);if(c<0x80){C=C>>>8^T0[(C^c)&0xFF];}else if(c<0x800){C=C>>>8^T0[(C^(192|c>>6&31))&0xFF];C=C>>>8^T0[(C^(128|c&63))&0xFF];}else if(c>=0xD800&&c<0xE000){c=(c&1023)+64;d=str.charCodeAt(i++)&1023;C=C>>>8^T0[(C^(240|c>>8&7))&0xFF];C=C>>>8^T0[(C^(128|c>>2&63))&0xFF];C=C>>>8^T0[(C^(128|d>>6&15|(c&3)<<4))&0xFF];C=C>>>8^T0[(C^(128|d&63))&0xFF];}else{C=C>>>8^T0[(C^(224|c>>12&15))&0xFF];C=C>>>8^T0[(C^(128|c>>6&63))&0xFF];C=C>>>8^T0[(C^(128|c&63))&0xFF];}}return~C;}CRC32.table=T0;CRC32.bstr=crc32_bstr;CRC32.buf=crc32_buf;CRC32.str=crc32_str;return CRC32;}();var CFB=function _CFB(){var exports={};exports.version='1.2.1';function namecmp(l,r){var L=l.split("/"),R=r.split("/");for(var i=0,c=0,Z=Math.min(L.length,R.length);i<Z;++i){if(c=L[i].length-R[i].length)return c;if(L[i]!=R[i])return L[i]<R[i]?-1:1;}return L.length-R.length;}function dirname(p){if(p.charAt(p.length-1)=="/")return p.slice(0,-1).indexOf("/")===-1?p:dirname(p.slice(0,-1));var c=p.lastIndexOf("/");return c===-1?p:p.slice(0,c+1);}function filename(p){if(p.charAt(p.length-1)=="/")return filename(p.slice(0,-1));var c=p.lastIndexOf("/");return c===-1?p:p.slice(c+1);}function write_dos_date(buf,date){if(typeof date==="string")date=new Date(date);var hms=date.getHours();hms=hms<<6|date.getMinutes();hms=hms<<5|date.getSeconds()>>>1;buf.write_shift(2,hms);var ymd=date.getFullYear()-1980;ymd=ymd<<4|date.getMonth()+1;ymd=ymd<<5|date.getDate();buf.write_shift(2,ymd);}function parse_dos_date(buf){var hms=buf.read_shift(2)&0xFFFF;var ymd=buf.read_shift(2)&0xFFFF;var val=new Date();var d=ymd&0x1F;ymd>>>=5;var m=ymd&0x0F;ymd>>>=4;val.setMilliseconds(0);val.setFullYear(ymd+1980);val.setMonth(m-1);val.setDate(d);var S=hms&0x1F;hms>>>=5;var M=hms&0x3F;hms>>>=6;val.setHours(hms);val.setMinutes(M);val.setSeconds(S<<1);return val;}function parse_extra_field(blob){prep_blob(blob,0);var o={};var flags=0;while(blob.l<=blob.length-4){var type=blob.read_shift(2);var sz=blob.read_shift(2),tgt=blob.l+sz;var p={};switch(type){case 0x5455:{flags=blob.read_shift(1);if(flags&1)p.mtime=blob.read_shift(4);if(sz>5){if(flags&2)p.atime=blob.read_shift(4);if(flags&4)p.ctime=blob.read_shift(4);}if(p.mtime)p.mt=new Date(p.mtime*1000);}break;}blob.l=tgt;o[type]=p;}return o;}var fs;function get_fs(){return fs||(fs={});}function parse(file,options){if(file[0]==0x50&&file[1]==0x4b)return parse_zip(file,options);if((file[0]|0x20)==0x6d&&(file[1]|0x20)==0x69)return parse_mad(file,options);if(file.length<512)throw new Error("CFB file size "+file.length+" < 512");var mver=3;var ssz=512;var nmfs=0;var difat_sec_cnt=0;var dir_start=0;var minifat_start=0;var difat_start=0;var fat_addrs=[];var blob=file.slice(0,512);prep_blob(blob,0);var mv=check_get_mver(blob);mver=mv[0];switch(mver){case 3:ssz=512;break;case 4:ssz=4096;break;case 0:if(mv[1]==0)return parse_zip(file,options);default:throw new Error("Major Version: Expected 3 or 4 saw "+mver);}if(ssz!==512){blob=file.slice(0,ssz);prep_blob(blob,28);}var header=file.slice(0,ssz);check_shifts(blob,mver);var dir_cnt=blob.read_shift(4,'i');if(mver===3&&dir_cnt!==0)throw new Error('# Directory Sectors: Expected 0 saw '+dir_cnt);blob.l+=4;dir_start=blob.read_shift(4,'i');blob.l+=4;blob.chk('00100000','Mini Stream Cutoff Size: ');minifat_start=blob.read_shift(4,'i');nmfs=blob.read_shift(4,'i');difat_start=blob.read_shift(4,'i');difat_sec_cnt=blob.read_shift(4,'i');for(var q=-1,j=0;j<109;++j){q=blob.read_shift(4,'i');if(q<0)break;fat_addrs[j]=q;}var sectors=sectorify(file,ssz);sleuth_fat(difat_start,difat_sec_cnt,sectors,ssz,fat_addrs);var sector_list=make_sector_list(sectors,dir_start,fat_addrs,ssz);sector_list[dir_start].name="!Directory";if(nmfs>0&&minifat_start!==ENDOFCHAIN)sector_list[minifat_start].name="!MiniFAT";sector_list[fat_addrs[0]].name="!FAT";sector_list.fat_addrs=fat_addrs;sector_list.ssz=ssz;var files={},Paths=[],FileIndex=[],FullPaths=[];read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex,minifat_start);build_full_paths(FileIndex,FullPaths,Paths);Paths.shift();var o={FileIndex:FileIndex,FullPaths:FullPaths};if(options&&options.raw)o.raw={header:header,sectors:sectors};return o;}function check_get_mver(blob){if(blob[blob.l]==0x50&&blob[blob.l+1]==0x4b)return[0,0];blob.chk(HEADER_SIGNATURE,'Header Signature: ');blob.l+=16;var mver=blob.read_shift(2,'u');return[blob.read_shift(2,'u'),mver];}function check_shifts(blob,mver){var shift=0x09;blob.l+=2;switch(shift=blob.read_shift(2)){case 0x09:if(mver!=3)throw new Error('Sector Shift: Expected 9 saw '+shift);break;case 0x0c:if(mver!=4)throw new Error('Sector Shift: Expected 12 saw '+shift);break;default:throw new Error('Sector Shift: Expected 9 or 12 saw '+shift);}blob.chk('0600','Mini Sector Shift: ');blob.chk('000000000000','Reserved: ');}function sectorify(file,ssz){var nsectors=Math.ceil(file.length/ssz)-1;var sectors=[];for(var i=1;i<nsectors;++i){sectors[i-1]=file.slice(i*ssz,(i+1)*ssz);}sectors[nsectors-1]=file.slice(nsectors*ssz);return sectors;}function build_full_paths(FI,FP,Paths){var i=0,L=0,R=0,C=0,j=0,pl=Paths.length;var dad=[],q=[];for(;i<pl;++i){dad[i]=q[i]=i;FP[i]=Paths[i];}for(;j<q.length;++j){i=q[j];L=FI[i].L;R=FI[i].R;C=FI[i].C;if(dad[i]===i){if(L!==-1&&dad[L]!==L)dad[i]=dad[L];if(R!==-1&&dad[R]!==R)dad[i]=dad[R];}if(C!==-1)dad[C]=i;if(L!==-1&&i!=dad[i]){dad[L]=dad[i];if(q.lastIndexOf(L)<j)q.push(L);}if(R!==-1&&i!=dad[i]){dad[R]=dad[i];if(q.lastIndexOf(R)<j)q.push(R);}}for(i=1;i<pl;++i){if(dad[i]===i){if(R!==-1&&dad[R]!==R)dad[i]=dad[R];else if(L!==-1&&dad[L]!==L)dad[i]=dad[L];}}for(i=1;i<pl;++i){if(FI[i].type===0)continue;j=i;if(j!=dad[j])do{j=dad[j];FP[i]=FP[j]+"/"+FP[i];}while(j!==0&&-1!==dad[j]&&j!=dad[j]);dad[i]=-1;}FP[0]+="/";for(i=1;i<pl;++i){if(FI[i].type!==2)FP[i]+="/";}}function get_mfat_entry(entry,payload,mini){var start=entry.start,size=entry.size;var o=[];var idx=start;while(mini&&size>0&&idx>=0){o.push(payload.slice(idx*MSSZ,idx*MSSZ+MSSZ));size-=MSSZ;idx=__readInt32LE(mini,idx*4);}if(o.length===0)return new_buf(0);return bconcat(o).slice(0,entry.size);}function sleuth_fat(idx,cnt,sectors,ssz,fat_addrs){var q=ENDOFCHAIN;if(idx===ENDOFCHAIN){if(cnt!==0)throw new Error("DIFAT chain shorter than expected");}else if(idx!==-1){var sector=sectors[idx],m=(ssz>>>2)-1;if(!sector)return;for(var i=0;i<m;++i){if((q=__readInt32LE(sector,i*4))===ENDOFCHAIN)break;fat_addrs.push(q);}sleuth_fat(__readInt32LE(sector,ssz-4),cnt-1,sectors,ssz,fat_addrs);}}function get_sector_list(sectors,start,fat_addrs,ssz,chkd){var buf=[],buf_chain=[];if(!chkd)chkd=[];var modulus=ssz-1,j=0,jj=0;for(j=start;j>=0;){chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw new Error("FAT boundary crossed: "+j+" 4 "+ssz);if(!sectors[addr])break;j=__readInt32LE(sectors[addr],jj);}return{nodes:buf,data:__toBuffer([buf_chain])};}function make_sector_list(sectors,dir_start,fat_addrs,ssz){var sl=sectors.length,sector_list=[];var chkd=[],buf=[],buf_chain=[];var modulus=ssz-1,i=0,j=0,k=0,jj=0;for(i=0;i<sl;++i){buf=[];k=i+dir_start;if(k>=sl)k-=sl;if(chkd[k])continue;buf_chain=[];var seen=[];for(j=k;j>=0;){seen[j]=true;chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw new Error("FAT boundary crossed: "+j+" 4 "+ssz);if(!sectors[addr])break;j=__readInt32LE(sectors[addr],jj);if(seen[j])break;}sector_list[k]={nodes:buf,data:__toBuffer([buf_chain])};}return sector_list;}function read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex,mini){var minifat_store=0,pl=Paths.length?2:0;var sector=sector_list[dir_start].data;var i=0,namelen=0,name;for(;i<sector.length;i+=128){var blob=sector.slice(i,i+128);prep_blob(blob,64);namelen=blob.read_shift(2);name=__utf16le(blob,0,namelen-pl);Paths.push(name);var o={name:name,type:blob.read_shift(1),color:blob.read_shift(1),L:blob.read_shift(4,'i'),R:blob.read_shift(4,'i'),C:blob.read_shift(4,'i'),clsid:blob.read_shift(16),state:blob.read_shift(4,'i'),start:0,size:0};var ctime=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(ctime!==0)o.ct=read_date(blob,blob.l-8);var mtime=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(mtime!==0)o.mt=read_date(blob,blob.l-8);o.start=blob.read_shift(4,'i');o.size=blob.read_shift(4,'i');if(o.size<0&&o.start<0){o.size=o.type=0;o.start=ENDOFCHAIN;o.name="";}if(o.type===5){minifat_store=o.start;if(nmfs>0&&minifat_store!==ENDOFCHAIN)sector_list[minifat_store].name="!StreamData";}else if(o.size>=4096){o.storage='fat';if(sector_list[o.start]===undefined)sector_list[o.start]=get_sector_list(sectors,o.start,sector_list.fat_addrs,sector_list.ssz);sector_list[o.start].name=o.name;o.content=sector_list[o.start].data.slice(0,o.size);}else{o.storage='minifat';if(o.size<0)o.size=0;else if(minifat_store!==ENDOFCHAIN&&o.start!==ENDOFCHAIN&&sector_list[minifat_store]){o.content=get_mfat_entry(o,sector_list[minifat_store].data,(sector_list[mini]||{}).data);}}if(o.content)prep_blob(o.content,0);files[name]=o;FileIndex.push(o);}}function read_date(blob,offset){return new Date((__readUInt32LE(blob,offset+4)/1e7*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7-11644473600)*1000);}function read_file(filename,options){get_fs();return parse(fs.readFileSync(filename),options);}function read(blob,options){var type=options&&options.type;if(!type){if(has_buf&&Buffer.isBuffer(blob))type="buffer";}switch(type||"base64"){case"file":return read_file(blob,options);case"base64":return parse(s2a(Base64_decode(blob)),options);case"binary":return parse(s2a(blob),options);}return parse(blob,options);}function init_cfb(cfb,opts){var o=opts||{},root=o.root||"Root Entry";if(!cfb.FullPaths)cfb.FullPaths=[];if(!cfb.FileIndex)cfb.FileIndex=[];if(cfb.FullPaths.length!==cfb.FileIndex.length)throw new Error("inconsistent CFB structure");if(cfb.FullPaths.length===0){cfb.FullPaths[0]=root+"/";cfb.FileIndex[0]={name:root,type:5};}if(o.CLSID)cfb.FileIndex[0].clsid=o.CLSID;seed_cfb(cfb);}function seed_cfb(cfb){var nm="\x01Sh33tJ5";if(CFB.find(cfb,"/"+nm))return;var p=new_buf(4);p[0]=55;p[1]=p[3]=50;p[2]=54;cfb.FileIndex.push({name:nm,type:2,content:p,size:4,L:69,R:69,C:69});cfb.FullPaths.push(cfb.FullPaths[0]+nm);rebuild_cfb(cfb);}function rebuild_cfb(cfb,f){init_cfb(cfb);var gc=false,s=false;for(var i=cfb.FullPaths.length-1;i>=0;--i){var _file=cfb.FileIndex[i];switch(_file.type){case 0:if(s)gc=true;else{cfb.FileIndex.pop();cfb.FullPaths.pop();}break;case 1:case 2:case 5:s=true;if(isNaN(_file.R*_file.L*_file.C))gc=true;if(_file.R>-1&&_file.L>-1&&_file.R==_file.L)gc=true;break;default:gc=true;break;}}if(!gc&&!f)return;var now=new Date(1987,1,19),j=0;var fullPaths=_create2.default?(0,_create2.default)(null):{};var data=[];for(i=0;i<cfb.FullPaths.length;++i){fullPaths[cfb.FullPaths[i]]=true;if(cfb.FileIndex[i].type===0)continue;data.push([cfb.FullPaths[i],cfb.FileIndex[i]]);}for(i=0;i<data.length;++i){var dad=dirname(data[i][0]);s=fullPaths[dad];if(!s){data.push([dad,{name:filename(dad).replace("/",""),type:1,clsid:HEADER_CLSID,ct:now,mt:now,content:null}]);fullPaths[dad]=true;}}data.sort(function(x,y){return namecmp(x[0],y[0]);});cfb.FullPaths=[];cfb.FileIndex=[];for(i=0;i<data.length;++i){cfb.FullPaths[i]=data[i][0];cfb.FileIndex[i]=data[i][1];}for(i=0;i<data.length;++i){var elt=cfb.FileIndex[i];var nm=cfb.FullPaths[i];elt.name=filename(nm).replace("/","");elt.L=elt.R=elt.C=-(elt.color=1);elt.size=elt.content?elt.content.length:0;elt.start=0;elt.clsid=elt.clsid||HEADER_CLSID;if(i===0){elt.C=data.length>1?1:-1;elt.size=0;elt.type=5;}else if(nm.slice(-1)=="/"){for(j=i+1;j<data.length;++j){if(dirname(cfb.FullPaths[j])==nm)break;}elt.C=j>=data.length?-1:j;for(j=i+1;j<data.length;++j){if(dirname(cfb.FullPaths[j])==dirname(nm))break;}elt.R=j>=data.length?-1:j;elt.type=1;}else{if(dirname(cfb.FullPaths[i+1]||"")==dirname(nm))elt.R=i+1;elt.type=2;}}}function _write(cfb,options){var _opts=options||{};if(_opts.fileType=='mad')return write_mad(cfb,_opts);rebuild_cfb(cfb);switch(_opts.fileType){case'zip':return write_zip(cfb,_opts);}var L=function(cfb){var mini_size=0,fat_size=0;for(var i=0;i<cfb.FileIndex.length;++i){var file=cfb.FileIndex[i];if(!file.content)continue;var flen=file.content.length;if(flen>0){if(flen<0x1000)mini_size+=flen+0x3F>>6;else fat_size+=flen+0x01FF>>9;}}var dir_cnt=cfb.FullPaths.length+3>>2;var mini_cnt=mini_size+7>>3;var mfat_cnt=mini_size+0x7F>>7;var fat_base=mini_cnt+fat_size+dir_cnt+mfat_cnt;var fat_cnt=fat_base+0x7F>>7;var difat_cnt=fat_cnt<=109?0:Math.ceil((fat_cnt-109)/0x7F);while(fat_base+fat_cnt+difat_cnt+0x7F>>7>fat_cnt){difat_cnt=++fat_cnt<=109?0:Math.ceil((fat_cnt-109)/0x7F);}var L=[1,difat_cnt,fat_cnt,mfat_cnt,dir_cnt,fat_size,mini_size,0];cfb.FileIndex[0].size=mini_size<<6;L[7]=(cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+(L[6]+7>>3);return L;}(cfb);var o=new_buf(L[7]<<9);var i=0,T=0;{for(i=0;i<8;++i){o.write_shift(1,HEADER_SIG[i]);}for(i=0;i<8;++i){o.write_shift(2,0);}o.write_shift(2,0x003E);o.write_shift(2,0x0003);o.write_shift(2,0xFFFE);o.write_shift(2,0x0009);o.write_shift(2,0x0006);for(i=0;i<3;++i){o.write_shift(2,0);}o.write_shift(4,0);o.write_shift(4,L[2]);o.write_shift(4,L[0]+L[1]+L[2]+L[3]-1);o.write_shift(4,0);o.write_shift(4,1<<12);o.write_shift(4,L[3]?L[0]+L[1]+L[2]-1:ENDOFCHAIN);o.write_shift(4,L[3]);o.write_shift(-4,L[1]?L[0]-1:ENDOFCHAIN);o.write_shift(4,L[1]);for(i=0;i<109;++i){o.write_shift(-4,i<L[2]?L[1]+i:-1);}}if(L[1]){for(T=0;T<L[1];++T){for(;i<236+T*127;++i){o.write_shift(-4,i<L[2]?L[1]+i:-1);}o.write_shift(-4,T===L[1]-1?ENDOFCHAIN:T+1);}}var chainit=function chainit(w){for(T+=w;i<T-1;++i){o.write_shift(-4,i+1);}if(w){++i;o.write_shift(-4,ENDOFCHAIN);}};T=i=0;for(T+=L[1];i<T;++i){o.write_shift(-4,consts.DIFSECT);}for(T+=L[2];i<T;++i){o.write_shift(-4,consts.FATSECT);}chainit(L[3]);chainit(L[4]);var j=0,flen=0;var file=cfb.FileIndex[0];for(;j<cfb.FileIndex.length;++j){file=cfb.FileIndex[j];if(!file.content)continue;flen=file.content.length;if(flen<0x1000)continue;file.start=T;chainit(flen+0x01FF>>9);}chainit(L[6]+7>>3);while(o.l&0x1FF){o.write_shift(-4,consts.ENDOFCHAIN);}T=i=0;for(j=0;j<cfb.FileIndex.length;++j){file=cfb.FileIndex[j];if(!file.content)continue;flen=file.content.length;if(!flen||flen>=0x1000)continue;file.start=T;chainit(flen+0x3F>>6);}while(o.l&0x1FF){o.write_shift(-4,consts.ENDOFCHAIN);}for(i=0;i<L[4]<<2;++i){var nm=cfb.FullPaths[i];if(!nm||nm.length===0){for(j=0;j<17;++j){o.write_shift(4,0);}for(j=0;j<3;++j){o.write_shift(4,-1);}for(j=0;j<12;++j){o.write_shift(4,0);}continue;}file=cfb.FileIndex[i];if(i===0)file.start=file.size?file.start-1:ENDOFCHAIN;var _nm=i===0&&_opts.root||file.name;flen=2*(_nm.length+1);o.write_shift(64,_nm,"utf16le");o.write_shift(2,flen);o.write_shift(1,file.type);o.write_shift(1,file.color);o.write_shift(-4,file.L);o.write_shift(-4,file.R);o.write_shift(-4,file.C);if(!file.clsid)for(j=0;j<4;++j){o.write_shift(4,0);}else o.write_shift(16,file.clsid,"hex");o.write_shift(4,file.state||0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,file.start);o.write_shift(4,file.size);o.write_shift(4,0);}for(i=1;i<cfb.FileIndex.length;++i){file=cfb.FileIndex[i];if(file.size>=0x1000){o.l=file.start+1<<9;if(has_buf&&Buffer.isBuffer(file.content)){file.content.copy(o,o.l,0,file.size);o.l+=file.size+511&-512;}else{for(j=0;j<file.size;++j){o.write_shift(1,file.content[j]);}for(;j&0x1FF;++j){o.write_shift(1,0);}}}}for(i=1;i<cfb.FileIndex.length;++i){file=cfb.FileIndex[i];if(file.size>0&&file.size<0x1000){if(has_buf&&Buffer.isBuffer(file.content)){file.content.copy(o,o.l,0,file.size);o.l+=file.size+63&-64;}else{for(j=0;j<file.size;++j){o.write_shift(1,file.content[j]);}for(;j&0x3F;++j){o.write_shift(1,0);}}}}if(has_buf){o.l=o.length;}else{while(o.l<o.length){o.write_shift(1,0);}}return o;}function find(cfb,path){var UCFullPaths=cfb.FullPaths.map(function(x){return x.toUpperCase();});var UCPaths=UCFullPaths.map(function(x){var y=x.split("/");return y[y.length-(x.slice(-1)=="/"?2:1)];});var k=false;if(path.charCodeAt(0)===47){k=true;path=UCFullPaths[0].slice(0,-1)+path;}else k=path.indexOf("/")!==-1;var UCPath=path.toUpperCase();var w=k===true?UCFullPaths.indexOf(UCPath):UCPaths.indexOf(UCPath);if(w!==-1)return cfb.FileIndex[w];var m=!UCPath.match(chr1);UCPath=UCPath.replace(chr0,'');if(m)UCPath=UCPath.replace(chr1,'!');for(w=0;w<UCFullPaths.length;++w){if((m?UCFullPaths[w].replace(chr1,'!'):UCFullPaths[w]).replace(chr0,'')==UCPath)return cfb.FileIndex[w];if((m?UCPaths[w].replace(chr1,'!'):UCPaths[w]).replace(chr0,'')==UCPath)return cfb.FileIndex[w];}return null;}var MSSZ=64;var ENDOFCHAIN=-2;var HEADER_SIGNATURE='d0cf11e0a1b11ae1';var HEADER_SIG=[0xD0,0xCF,0x11,0xE0,0xA1,0xB1,0x1A,0xE1];var HEADER_CLSID='00000000000000000000000000000000';var consts={MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:ENDOFCHAIN,FREESECT:-1,HEADER_SIGNATURE:HEADER_SIGNATURE,HEADER_MINOR_VERSION:'3e00',MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:HEADER_CLSID,EntryTypes:['unknown','storage','stream','lockbytes','property','root']};function write_file(cfb,filename,options){get_fs();var o=_write(cfb,options);fs.writeFileSync(filename,o);}function a2s(o){var out=new Array(o.length);for(var i=0;i<o.length;++i){out[i]=String.fromCharCode(o[i]);}return out.join("");}function write(cfb,options){var o=_write(cfb,options);switch(options&&options.type||"buffer"){case"file":get_fs();fs.writeFileSync(options.filename,o);return o;case"binary":return typeof o=="string"?o:a2s(o);case"base64":return Base64_encode(typeof o=="string"?o:a2s(o));case"buffer":if(has_buf)return Buffer.isBuffer(o)?o:Buffer_from(o);case"array":return typeof o=="string"?s2a(o):o;}return o;}var _zlib;function use_zlib(zlib){try{var InflateRaw=zlib.InflateRaw;var InflRaw=new InflateRaw();InflRaw._processChunk(new Uint8Array([3,0]),InflRaw._finishFlushFlag);if(InflRaw.bytesRead)_zlib=zlib;else throw new Error("zlib does not expose bytesRead");}catch(e){console.error("cannot use native zlib: "+(e.message||e));}}function _inflateRawSync(payload,usz){if(!_zlib)return _inflate(payload,usz);var InflateRaw=_zlib.InflateRaw;var InflRaw=new InflateRaw();var out=InflRaw._processChunk(payload.slice(payload.l),InflRaw._finishFlushFlag);payload.l+=InflRaw.bytesRead;return out;}function _deflateRawSync(payload){return _zlib?_zlib.deflateRawSync(payload):_deflate(payload);}var CLEN_ORDER=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var LEN_LN=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258];var DST_LN=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];function bit_swap_8(n){var t=(n<<1|n<<11)&0x22110|(n<<5|n<<15)&0x88440;return(t>>16|t>>8|t)&0xFF;}var use_typed_arrays=typeof Uint8Array!=='undefined';var bitswap8=use_typed_arrays?new Uint8Array(1<<8):[];for(var q=0;q<1<<8;++q){bitswap8[q]=bit_swap_8(q);}function bit_swap_n(n,b){var rev=bitswap8[n&0xFF];if(b<=8)return rev>>>8-b;rev=rev<<8|bitswap8[n>>8&0xFF];if(b<=16)return rev>>>16-b;rev=rev<<8|bitswap8[n>>16&0xFF];return rev>>>24-b;}function read_bits_2(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=6?0:buf[h+1]<<8))>>>w&0x03;}function read_bits_3(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=5?0:buf[h+1]<<8))>>>w&0x07;}function read_bits_4(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=4?0:buf[h+1]<<8))>>>w&0x0F;}function read_bits_5(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=3?0:buf[h+1]<<8))>>>w&0x1F;}function read_bits_7(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=1?0:buf[h+1]<<8))>>>w&0x7F;}function read_bits_n(buf,bl,n){var w=bl&7,h=bl>>>3,f=(1<<n)-1;var v=buf[h]>>>w;if(n<8-w)return v&f;v|=buf[h+1]<<8-w;if(n<16-w)return v&f;v|=buf[h+2]<<16-w;if(n<24-w)return v&f;v|=buf[h+3]<<24-w;return v&f;}function write_bits_3(buf,bl,v){var w=bl&7,h=bl>>>3;if(w<=5)buf[h]|=(v&7)<<w;else{buf[h]|=v<<w&0xFF;buf[h+1]=(v&7)>>8-w;}return bl+3;}function write_bits_1(buf,bl,v){var w=bl&7,h=bl>>>3;v=(v&1)<<w;buf[h]|=v;return bl+1;}function write_bits_8(buf,bl,v){var w=bl&7,h=bl>>>3;v<<=w;buf[h]|=v&0xFF;v>>>=8;buf[h+1]=v;return bl+8;}function write_bits_16(buf,bl,v){var w=bl&7,h=bl>>>3;v<<=w;buf[h]|=v&0xFF;v>>>=8;buf[h+1]=v&0xFF;buf[h+2]=v>>>8;return bl+16;}function realloc(b,sz){var L=b.length,M=2*L>sz?2*L:sz+5,i=0;if(L>=sz)return b;if(has_buf){var o=new_unsafe_buf(M);if(b.copy)b.copy(o);else for(;i<b.length;++i){o[i]=b[i];}return o;}else if(use_typed_arrays){var a=new Uint8Array(M);if(a.set)a.set(b);else for(;i<L;++i){a[i]=b[i];}return a;}b.length=M;return b;}function zero_fill_array(n){var o=new Array(n);for(var i=0;i<n;++i){o[i]=0;}return o;}function build_tree(clens,cmap,MAX){var maxlen=1,w=0,i=0,j=0,ccode=0,L=clens.length;var bl_count=use_typed_arrays?new Uint16Array(32):zero_fill_array(32);for(i=0;i<32;++i){bl_count[i]=0;}for(i=L;i<MAX;++i){clens[i]=0;}L=clens.length;var ctree=use_typed_arrays?new Uint16Array(L):zero_fill_array(L);for(i=0;i<L;++i){bl_count[w=clens[i]]++;if(maxlen<w)maxlen=w;ctree[i]=0;}bl_count[0]=0;for(i=1;i<=maxlen;++i){bl_count[i+16]=ccode=ccode+bl_count[i-1]<<1;}for(i=0;i<L;++i){ccode=clens[i];if(ccode!=0)ctree[i]=bl_count[ccode+16]++;}var cleni=0;for(i=0;i<L;++i){cleni=clens[i];if(cleni!=0){ccode=bit_swap_n(ctree[i],maxlen)>>maxlen-cleni;for(j=(1<<maxlen+4-cleni)-1;j>=0;--j){cmap[ccode|j<<cleni]=cleni&15|i<<4;}}}return maxlen;}var fix_lmap=use_typed_arrays?new Uint16Array(512):zero_fill_array(512);var fix_dmap=use_typed_arrays?new Uint16Array(32):zero_fill_array(32);if(!use_typed_arrays){for(var i=0;i<512;++i){fix_lmap[i]=0;}for(i=0;i<32;++i){fix_dmap[i]=0;}}(function(){var dlens=[];var i=0;for(;i<32;i++){dlens.push(5);}build_tree(dlens,fix_dmap,32);var clens=[];i=0;for(;i<=143;i++){clens.push(8);}for(;i<=255;i++){clens.push(9);}for(;i<=279;i++){clens.push(7);}for(;i<=287;i++){clens.push(8);}build_tree(clens,fix_lmap,288);})();var _deflateRaw=function _deflateRawIIFE(){var DST_LN_RE=use_typed_arrays?new Uint8Array(0x8000):[];var j=0,k=0;for(;j<DST_LN.length-1;++j){for(;k<DST_LN[j+1];++k){DST_LN_RE[k]=j;}}for(;k<32768;++k){DST_LN_RE[k]=29;}var LEN_LN_RE=use_typed_arrays?new Uint8Array(0x103):[];for(j=0,k=0;j<LEN_LN.length-1;++j){for(;k<LEN_LN[j+1];++k){LEN_LN_RE[k]=j;}}function write_stored(data,out){var boff=0;while(boff<data.length){var L=Math.min(0xFFFF,data.length-boff);var h=boff+L==data.length;out.write_shift(1,+h);out.write_shift(2,L);out.write_shift(2,~L&0xFFFF);while(L-->0){out[out.l++]=data[boff++];}}return out.l;}function write_huff_fixed(data,out){var bl=0;var boff=0;var addrs=use_typed_arrays?new Uint16Array(0x8000):[];while(boff<data.length){var L=Math.min(0xFFFF,data.length-boff);if(L<10){bl=write_bits_3(out,bl,+!!(boff+L==data.length));if(bl&7)bl+=8-(bl&7);out.l=bl/8|0;out.write_shift(2,L);out.write_shift(2,~L&0xFFFF);while(L-->0){out[out.l++]=data[boff++];}bl=out.l*8;continue;}bl=write_bits_3(out,bl,+!!(boff+L==data.length)+2);var hash=0;while(L-->0){var d=data[boff];hash=(hash<<5^d)&0x7FFF;var match=-1,mlen=0;if(match=addrs[hash]){match|=boff&~0x7FFF;if(match>boff)match-=0x8000;if(match<boff)while(data[match+mlen]==data[boff+mlen]&&mlen<250){++mlen;}}if(mlen>2){d=LEN_LN_RE[mlen];if(d<=22)bl=write_bits_8(out,bl,bitswap8[d+1]>>1)-1;else{write_bits_8(out,bl,3);bl+=5;write_bits_8(out,bl,bitswap8[d-23]>>5);bl+=3;}var len_eb=d<8?0:d-4>>2;if(len_eb>0){write_bits_16(out,bl,mlen-LEN_LN[d]);bl+=len_eb;}d=DST_LN_RE[boff-match];bl=write_bits_8(out,bl,bitswap8[d]>>3);bl-=3;var dst_eb=d<4?0:d-2>>1;if(dst_eb>0){write_bits_16(out,bl,boff-match-DST_LN[d]);bl+=dst_eb;}for(var q=0;q<mlen;++q){addrs[hash]=boff&0x7FFF;hash=(hash<<5^data[boff])&0x7FFF;++boff;}L-=mlen-1;}else{if(d<=143)d=d+48;else bl=write_bits_1(out,bl,1);bl=write_bits_8(out,bl,bitswap8[d]);addrs[hash]=boff&0x7FFF;++boff;}}bl=write_bits_8(out,bl,0)-1;}out.l=(bl+7)/8|0;return out.l;}return function _deflateRaw(data,out){if(data.length<8)return write_stored(data,out);return write_huff_fixed(data,out);};}();function _deflate(data){var buf=new_buf(50+Math.floor(data.length*1.1));var off=_deflateRaw(data,buf);return buf.slice(0,off);}var dyn_lmap=use_typed_arrays?new Uint16Array(32768):zero_fill_array(32768);var dyn_dmap=use_typed_arrays?new Uint16Array(32768):zero_fill_array(32768);var dyn_cmap=use_typed_arrays?new Uint16Array(128):zero_fill_array(128);var dyn_len_1=1,dyn_len_2=1;function dyn(data,boff){var _HLIT=read_bits_5(data,boff)+257;boff+=5;var _HDIST=read_bits_5(data,boff)+1;boff+=5;var _HCLEN=read_bits_4(data,boff)+4;boff+=4;var w=0;var clens=use_typed_arrays?new Uint8Array(19):zero_fill_array(19);var ctree=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var maxlen=1;var bl_count=use_typed_arrays?new Uint8Array(8):zero_fill_array(8);var next_code=use_typed_arrays?new Uint8Array(8):zero_fill_array(8);var L=clens.length;for(var i=0;i<_HCLEN;++i){clens[CLEN_ORDER[i]]=w=read_bits_3(data,boff);if(maxlen<w)maxlen=w;bl_count[w]++;boff+=3;}var ccode=0;bl_count[0]=0;for(i=1;i<=maxlen;++i){next_code[i]=ccode=ccode+bl_count[i-1]<<1;}for(i=0;i<L;++i){if((ccode=clens[i])!=0)ctree[i]=next_code[ccode]++;}var cleni=0;for(i=0;i<L;++i){cleni=clens[i];if(cleni!=0){ccode=bitswap8[ctree[i]]>>8-cleni;for(var j=(1<<7-cleni)-1;j>=0;--j){dyn_cmap[ccode|j<<cleni]=cleni&7|i<<3;}}}var hcodes=[];maxlen=1;for(;hcodes.length<_HLIT+_HDIST;){ccode=dyn_cmap[read_bits_7(data,boff)];boff+=ccode&7;switch(ccode>>>=3){case 16:w=3+read_bits_2(data,boff);boff+=2;ccode=hcodes[hcodes.length-1];while(w-->0){hcodes.push(ccode);}break;case 17:w=3+read_bits_3(data,boff);boff+=3;while(w-->0){hcodes.push(0);}break;case 18:w=11+read_bits_7(data,boff);boff+=7;while(w-->0){hcodes.push(0);}break;default:hcodes.push(ccode);if(maxlen<ccode)maxlen=ccode;break;}}var h1=hcodes.slice(0,_HLIT),h2=hcodes.slice(_HLIT);for(i=_HLIT;i<286;++i){h1[i]=0;}for(i=_HDIST;i<30;++i){h2[i]=0;}dyn_len_1=build_tree(h1,dyn_lmap,286);dyn_len_2=build_tree(h2,dyn_dmap,30);return boff;}function inflate(data,usz){if(data[0]==3&&!(data[1]&0x3)){return[new_raw_buf(usz),2];}var boff=0;var header=0;var outbuf=new_unsafe_buf(usz?usz:1<<18);var woff=0;var OL=outbuf.length>>>0;var max_len_1=0,max_len_2=0;while((header&1)==0){header=read_bits_3(data,boff);boff+=3;if(header>>>1==0){if(boff&7)boff+=8-(boff&7);var sz=data[boff>>>3]|data[(boff>>>3)+1]<<8;boff+=32;if(sz>0){if(!usz&&OL<woff+sz){outbuf=realloc(outbuf,woff+sz);OL=outbuf.length;}while(sz-->0){outbuf[woff++]=data[boff>>>3];boff+=8;}}continue;}else if(header>>1==1){max_len_1=9;max_len_2=5;}else{boff=dyn(data,boff);max_len_1=dyn_len_1;max_len_2=dyn_len_2;}for(;;){if(!usz&&OL<woff+32767){outbuf=realloc(outbuf,woff+32767);OL=outbuf.length;}var bits=read_bits_n(data,boff,max_len_1);var code=header>>>1==1?fix_lmap[bits]:dyn_lmap[bits];boff+=code&15;code>>>=4;if((code>>>8&0xFF)===0)outbuf[woff++]=code;else if(code==256)break;else{code-=257;var len_eb=code<8?0:code-4>>2;if(len_eb>5)len_eb=0;var tgt=woff+LEN_LN[code];if(len_eb>0){tgt+=read_bits_n(data,boff,len_eb);boff+=len_eb;}bits=read_bits_n(data,boff,max_len_2);code=header>>>1==1?fix_dmap[bits]:dyn_dmap[bits];boff+=code&15;code>>>=4;var dst_eb=code<4?0:code-2>>1;var dst=DST_LN[code];if(dst_eb>0){dst+=read_bits_n(data,boff,dst_eb);boff+=dst_eb;}if(!usz&&OL<tgt){outbuf=realloc(outbuf,tgt+100);OL=outbuf.length;}while(woff<tgt){outbuf[woff]=outbuf[woff-dst];++woff;}}}}if(usz)return[outbuf,boff+7>>>3];return[outbuf.slice(0,woff),boff+7>>>3];}function _inflate(payload,usz){var data=payload.slice(payload.l||0);var out=inflate(data,usz);payload.l+=out[1];return out[0];}function warn_or_throw(wrn,msg){if(wrn){if(typeof console!=='undefined')console.error(msg);}else throw new Error(msg);}function parse_zip(file,options){var blob=file;prep_blob(blob,0);var FileIndex=[],FullPaths=[];var o={FileIndex:FileIndex,FullPaths:FullPaths};init_cfb(o,{root:options.root});var i=blob.length-4;while((blob[i]!=0x50||blob[i+1]!=0x4b||blob[i+2]!=0x05||blob[i+3]!=0x06)&&i>=0){--i;}blob.l=i+4;blob.l+=4;var fcnt=blob.read_shift(2);blob.l+=6;var start_cd=blob.read_shift(4);blob.l=start_cd;for(i=0;i<fcnt;++i){blob.l+=20;var csz=blob.read_shift(4);var usz=blob.read_shift(4);var namelen=blob.read_shift(2);var efsz=blob.read_shift(2);var fcsz=blob.read_shift(2);blob.l+=8;var offset=blob.read_shift(4);var EF=parse_extra_field(blob.slice(blob.l+namelen,blob.l+namelen+efsz));blob.l+=namelen+efsz+fcsz;var L=blob.l;blob.l=offset+4;parse_local_file(blob,csz,usz,o,EF);blob.l=L;}return o;}function parse_local_file(blob,csz,usz,o,EF){blob.l+=2;var flags=blob.read_shift(2);var meth=blob.read_shift(2);var date=parse_dos_date(blob);if(flags&0x2041)throw new Error("Unsupported ZIP encryption");var crc32=blob.read_shift(4);var _csz=blob.read_shift(4);var _usz=blob.read_shift(4);var namelen=blob.read_shift(2);var efsz=blob.read_shift(2);var name="";for(var i=0;i<namelen;++i){name+=String.fromCharCode(blob[blob.l++]);}if(efsz){var ef=parse_extra_field(blob.slice(blob.l,blob.l+efsz));if((ef[0x5455]||{}).mt)date=ef[0x5455].mt;if(((EF||{})[0x5455]||{}).mt)date=EF[0x5455].mt;}blob.l+=efsz;var data=blob.slice(blob.l,blob.l+_csz);switch(meth){case 8:data=_inflateRawSync(blob,_usz);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+meth);}var wrn=false;if(flags&8){crc32=blob.read_shift(4);if(crc32==0x08074b50){crc32=blob.read_shift(4);wrn=true;}_csz=blob.read_shift(4);_usz=blob.read_shift(4);}if(_csz!=csz)warn_or_throw(wrn,"Bad compressed size: "+csz+" != "+_csz);if(_usz!=usz)warn_or_throw(wrn,"Bad uncompressed size: "+usz+" != "+_usz);cfb_add(o,name,data,{unsafe:true,mt:date});}function write_zip(cfb,options){var _opts=options||{};var out=[],cdirs=[];var o=new_buf(1);var method=_opts.compression?8:0,flags=0;var desc=false;if(desc)flags|=8;var i=0,j=0;var start_cd=0,fcnt=0;var root=cfb.FullPaths[0],fp=root,fi=cfb.FileIndex[0];var crcs=[];var sz_cd=0;for(i=1;i<cfb.FullPaths.length;++i){fp=cfb.FullPaths[i].slice(root.length);fi=cfb.FileIndex[i];if(!fi.size||!fi.content||fp=="\x01Sh33tJ5")continue;var start=start_cd;var namebuf=new_buf(fp.length);for(j=0;j<fp.length;++j){namebuf.write_shift(1,fp.charCodeAt(j)&0x7F);}namebuf=namebuf.slice(0,namebuf.l);crcs[fcnt]=CRC32.buf(fi.content,0);var outbuf=fi.content;if(method==8)outbuf=_deflateRawSync(outbuf);o=new_buf(30);o.write_shift(4,0x04034b50);o.write_shift(2,20);o.write_shift(2,flags);o.write_shift(2,method);if(fi.mt)write_dos_date(o,fi.mt);else o.write_shift(4,0);o.write_shift(-4,flags&8?0:crcs[fcnt]);o.write_shift(4,flags&8?0:outbuf.length);o.write_shift(4,flags&8?0:fi.content.length);o.write_shift(2,namebuf.length);o.write_shift(2,0);start_cd+=o.length;out.push(o);start_cd+=namebuf.length;out.push(namebuf);start_cd+=outbuf.length;out.push(outbuf);if(flags&8){o=new_buf(12);o.write_shift(-4,crcs[fcnt]);o.write_shift(4,outbuf.length);o.write_shift(4,fi.content.length);start_cd+=o.l;out.push(o);}o=new_buf(46);o.write_shift(4,0x02014b50);o.write_shift(2,0);o.write_shift(2,20);o.write_shift(2,flags);o.write_shift(2,method);o.write_shift(4,0);o.write_shift(-4,crcs[fcnt]);o.write_shift(4,outbuf.length);o.write_shift(4,fi.content.length);o.write_shift(2,namebuf.length);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(4,0);o.write_shift(4,start);sz_cd+=o.l;cdirs.push(o);sz_cd+=namebuf.length;cdirs.push(namebuf);++fcnt;}o=new_buf(22);o.write_shift(4,0x06054b50);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,fcnt);o.write_shift(2,fcnt);o.write_shift(4,sz_cd);o.write_shift(4,start_cd);o.write_shift(2,0);return bconcat([bconcat(out),bconcat(cdirs),o]);}var ContentTypeMap={"htm":"text/html","xml":"text/xml","gif":"image/gif","jpg":"image/jpeg","png":"image/png","mso":"application/x-mso","thmx":"application/vnd.ms-officetheme","sh33tj5":"application/octet-stream"};function get_content_type(fi,fp){if(fi.ctype)return fi.ctype;var ext=fi.name||"",m=ext.match(/\.([^\.]+)$/);if(m&&ContentTypeMap[m[1]])return ContentTypeMap[m[1]];if(fp){m=(ext=fp).match(/[\.\\]([^\.\\])+$/);if(m&&ContentTypeMap[m[1]])return ContentTypeMap[m[1]];}return"application/octet-stream";}function write_base64_76(bstr){var data=Base64_encode(bstr);var o=[];for(var i=0;i<data.length;i+=76){o.push(data.slice(i,i+76));}return o.join("\r\n")+"\r\n";}function write_quoted_printable(text){var encoded=text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g,function(c){var w=c.charCodeAt(0).toString(16).toUpperCase();return"="+(w.length==1?"0"+w:w);});encoded=encoded.replace(/ $/mg,"=20").replace(/\t$/mg,"=09");if(encoded.charAt(0)=="\n")encoded="=0D"+encoded.slice(1);encoded=encoded.replace(/\r(?!\n)/mg,"=0D").replace(/\n\n/mg,"\n=0A").replace(/([^\r\n])\n/mg,"$1=0A");var o=[],split=encoded.split("\r\n");for(var si=0;si<split.length;++si){var str=split[si];if(str.length==0){o.push("");continue;}for(var i=0;i<str.length;){var end=76;var tmp=str.slice(i,i+end);if(tmp.charAt(end-1)=="=")end--;else if(tmp.charAt(end-2)=="=")end-=2;else if(tmp.charAt(end-3)=="=")end-=3;tmp=str.slice(i,i+end);i+=end;if(i<str.length)tmp+="=";o.push(tmp);}}return o.join("\r\n");}function parse_quoted_printable(data){var o=[];for(var di=0;di<data.length;++di){var line=data[di];while(di<=data.length&&line.charAt(line.length-1)=="="){line=line.slice(0,line.length-1)+data[++di];}o.push(line);}for(var oi=0;oi<o.length;++oi){o[oi]=o[oi].replace(/[=][0-9A-Fa-f]{2}/g,function($$){return String.fromCharCode(parseInt($$.slice(1),16));});}return s2a(o.join("\r\n"));}function parse_mime(cfb,data,root){var fname="",cte="",ctype="",fdata;var di=0;for(;di<10;++di){var line=data[di];if(!line||line.match(/^\s*$/))break;var m=line.match(/^(.*?):\s*([^\s].*)$/);if(m)switch(m[1].toLowerCase()){case"content-location":fname=m[2].trim();break;case"content-type":ctype=m[2].trim();break;case"content-transfer-encoding":cte=m[2].trim();break;}}++di;switch(cte.toLowerCase()){case'base64':fdata=s2a(Base64_decode(data.slice(di).join("")));break;case'quoted-printable':fdata=parse_quoted_printable(data.slice(di));break;default:throw new Error("Unsupported Content-Transfer-Encoding "+cte);}var file=cfb_add(cfb,fname.slice(root.length),fdata,{unsafe:true});if(ctype)file.ctype=ctype;}function parse_mad(file,options){if(a2s(file.slice(0,13)).toLowerCase()!="mime-version:")throw new Error("Unsupported MAD header");var root=options&&options.root||"";var data=(has_buf&&Buffer.isBuffer(file)?file.toString("binary"):a2s(file)).split("\r\n");var di=0,row="";for(di=0;di<data.length;++di){row=data[di];if(!/^Content-Location:/i.test(row))continue;row=row.slice(row.indexOf("file"));if(!root)root=row.slice(0,row.lastIndexOf("/")+1);if(row.slice(0,root.length)==root)continue;while(root.length>0){root=root.slice(0,root.length-1);root=root.slice(0,root.lastIndexOf("/")+1);if(row.slice(0,root.length)==root)break;}}var mboundary=(data[1]||"").match(/boundary="(.*?)"/);if(!mboundary)throw new Error("MAD cannot find boundary");var boundary="--"+(mboundary[1]||"");var FileIndex=[],FullPaths=[];var o={FileIndex:FileIndex,FullPaths:FullPaths};init_cfb(o);var start_di,fcnt=0;for(di=0;di<data.length;++di){var line=data[di];if(line!==boundary&&line!==boundary+"--")continue;if(fcnt++)parse_mime(o,data.slice(start_di,di),root);start_di=di;}return o;}function write_mad(cfb,options){var opts=options||{};var boundary=opts.boundary||"SheetJS";boundary='------='+boundary;var out=['MIME-Version: 1.0','Content-Type: multipart/related; boundary="'+boundary.slice(2)+'"','','',''];var root=cfb.FullPaths[0],fp=root,fi=cfb.FileIndex[0];for(var i=1;i<cfb.FullPaths.length;++i){fp=cfb.FullPaths[i].slice(root.length);fi=cfb.FileIndex[i];if(!fi.size||!fi.content||fp=="\x01Sh33tJ5")continue;fp=fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g,function(c){return"_x"+c.charCodeAt(0).toString(16)+"_";}).replace(/[\u0080-\uFFFF]/g,function(u){return"_u"+u.charCodeAt(0).toString(16)+"_";});var ca=fi.content;var cstr=has_buf&&Buffer.isBuffer(ca)?ca.toString("binary"):a2s(ca);var dispcnt=0,L=Math.min(1024,cstr.length),cc=0;for(var csl=0;csl<=L;++csl){if((cc=cstr.charCodeAt(csl))>=0x20&&cc<0x80)++dispcnt;}var qp=dispcnt>=L*4/5;out.push(boundary);out.push('Content-Location: '+(opts.root||'file:///C:/SheetJS/')+fp);out.push('Content-Transfer-Encoding: '+(qp?'quoted-printable':'base64'));out.push('Content-Type: '+get_content_type(fi,fp));out.push('');out.push(qp?write_quoted_printable(cstr):write_base64_76(cstr));}out.push(boundary+'--\r\n');return out.join("\r\n");}function cfb_new(opts){var o={};init_cfb(o,opts);return o;}function cfb_add(cfb,name,content,opts){var unsafe=opts&&opts.unsafe;if(!unsafe)init_cfb(cfb);var file=!unsafe&&CFB.find(cfb,name);if(!file){var fpath=cfb.FullPaths[0];if(name.slice(0,fpath.length)==fpath)fpath=name;else{if(fpath.slice(-1)!="/")fpath+="/";fpath=(fpath+name).replace("//","/");}file={name:filename(name),type:2};cfb.FileIndex.push(file);cfb.FullPaths.push(fpath);if(!unsafe)CFB.utils.cfb_gc(cfb);}file.content=content;file.size=content?content.length:0;if(opts){if(opts.CLSID)file.clsid=opts.CLSID;if(opts.mt)file.mt=opts.mt;if(opts.ct)file.ct=opts.ct;}return file;}function cfb_del(cfb,name){init_cfb(cfb);var file=CFB.find(cfb,name);if(file)for(var j=0;j<cfb.FileIndex.length;++j){if(cfb.FileIndex[j]==file){cfb.FileIndex.splice(j,1);cfb.FullPaths.splice(j,1);return true;}}return false;}function cfb_mov(cfb,old_name,new_name){init_cfb(cfb);var file=CFB.find(cfb,old_name);if(file)for(var j=0;j<cfb.FileIndex.length;++j){if(cfb.FileIndex[j]==file){cfb.FileIndex[j].name=filename(new_name);cfb.FullPaths[j]=new_name;return true;}}return false;}function cfb_gc(cfb){rebuild_cfb(cfb,true);}exports.find=find;exports.read=read;exports.parse=parse;exports.write=write;exports.writeFile=write_file;exports.utils={cfb_new:cfb_new,cfb_add:cfb_add,cfb_del:cfb_del,cfb_mov:cfb_mov,cfb_gc:cfb_gc,ReadShift:ReadShift,CheckField:CheckField,prep_blob:prep_blob,bconcat:bconcat,use_zlib:use_zlib,_deflateRaw:_deflate,_inflateRaw:_inflate,consts:consts};return exports;}();var _fs=void 0;function set_fs(fs){_fs=fs;}exports.set_fs=set_fs;function blobify(data){if(typeof data==="string")return s2ab(data);if(Array.isArray(data))return a2u(data);return data;}function write_dl(fname,payload,enc){if(typeof _fs!=='undefined'&&_fs.writeFileSync)return enc?_fs.writeFileSync(fname,payload,enc):_fs.writeFileSync(fname,payload);if(typeof Deno!=='undefined'){if(enc&&typeof payload=="string")switch(enc){case"utf8":payload=new TextEncoder(enc).encode(payload);break;case"binary":payload=s2ab(payload);break;default:throw new Error("Unsupported encoding "+enc);}return Deno.writeFileSync(fname,payload);}var data=enc=="utf8"?utf8write(payload):payload;if(typeof IE_SaveFile!=='undefined')return IE_SaveFile(data,fname);if(typeof Blob!=='undefined'){var blob=new Blob([blobify(data)],{type:"application/octet-stream"});if(typeof navigator!=='undefined'&&navigator.msSaveBlob)return navigator.msSaveBlob(blob,fname);if(typeof saveAs!=='undefined')return saveAs(blob,fname);if(typeof URL!=='undefined'&&typeof document!=='undefined'&&document.createElement&&URL.createObjectURL){var url=URL.createObjectURL(blob);if((typeof chrome==="undefined"?"undefined":(0,_typeof3.default)(chrome))==='object'&&typeof(chrome.downloads||{}).download=="function"){if(URL.revokeObjectURL&&typeof setTimeout!=='undefined')setTimeout(function(){URL.revokeObjectURL(url);},60000);return chrome.downloads.download({url:url,filename:fname,saveAs:true});}var a=document.createElement("a");if(a.download!=null){a.download=fname;a.href=url;document.body.appendChild(a);a.click();document.body.removeChild(a);if(URL.revokeObjectURL&&typeof setTimeout!=='undefined')setTimeout(function(){URL.revokeObjectURL(url);},60000);return url;}}}if(typeof $!=='undefined'&&typeof File!=='undefined'&&typeof Folder!=='undefined')try{var out=File(fname);out.open("w");out.encoding="binary";if(Array.isArray(payload))payload=a2s(payload);out.write(payload);out.close();return payload;}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e;}throw new Error("cannot save file "+fname);}function read_binary(path){if(typeof _fs!=='undefined')return _fs.readFileSync(path);if(typeof Deno!=='undefined')return Deno.readFileSync(path);if(typeof $!=='undefined'&&typeof File!=='undefined'&&typeof Folder!=='undefined')try{var infile=File(path);infile.open("r");infile.encoding="binary";var data=infile.read();infile.close();return data;}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e;}throw new Error("Cannot access file "+path);}function keys(o){var ks=(0,_keys2.default)(o),o2=[];for(var i=0;i<ks.length;++i){if(Object.prototype.hasOwnProperty.call(o,ks[i]))o2.push(ks[i]);}return o2;}function evert_key(obj,key){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i){if(o[obj[K[i]][key]]==null)o[obj[K[i]][key]]=K[i];}return o;}function evert(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i){o[obj[K[i]]]=K[i];}return o;}function evert_num(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i){o[obj[K[i]]]=parseInt(K[i],10);}return o;}function evert_arr(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i){if(o[obj[K[i]]]==null)o[obj[K[i]]]=[];o[obj[K[i]]].push(K[i]);}return o;}var basedate=new Date(1899,11,30,0,0,0);function datenum(v,date1904){var epoch=v.getTime();if(date1904)epoch-=1462*24*60*60*1000;var dnthresh=basedate.getTime()+(v.getTimezoneOffset()-basedate.getTimezoneOffset())*60000;return(epoch-dnthresh)/(24*60*60*1000);}var refdate=new Date();var dnthresh=basedate.getTime()+(refdate.getTimezoneOffset()-basedate.getTimezoneOffset())*60000;var refoffset=refdate.getTimezoneOffset();function numdate(v){var out=new Date();out.setTime(v*24*60*60*1000+dnthresh);if(out.getTimezoneOffset()!==refoffset){out.setTime(out.getTime()+(out.getTimezoneOffset()-refoffset)*60000);}return out;}function parse_isodur(s){var sec=0,mt=0,time=false;var m=s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!m)throw new Error("|"+s+"| is not an ISO8601 Duration");for(var i=1;i!=m.length;++i){if(!m[i])continue;mt=1;if(i>3)time=true;switch(m[i].slice(m[i].length-1)){case'Y':throw new Error("Unsupported ISO Duration Field: "+m[i].slice(m[i].length-1));case'D':mt*=24;case'H':mt*=60;case'M':if(!time)throw new Error("Unsupported ISO Duration Field: M");else mt*=60;case'S':break;}sec+=mt*parseInt(m[i],10);}return sec;}var good_pd_date_1=new Date('2017-02-19T19:06:09.000Z');var good_pd_date=isNaN(good_pd_date_1.getFullYear())?new Date('2/19/17'):good_pd_date_1;var good_pd=good_pd_date.getFullYear()==2017;function parseDate(str,fixdate){var d=new Date(str);if(good_pd){if(fixdate>0)d.setTime(d.getTime()+d.getTimezoneOffset()*60*1000);else if(fixdate<0)d.setTime(d.getTime()-d.getTimezoneOffset()*60*1000);return d;}if(str instanceof Date)return str;if(good_pd_date.getFullYear()==1917&&!isNaN(d.getFullYear())){var s=d.getFullYear();if(str.indexOf(""+s)>-1)return d;d.setFullYear(d.getFullYear()+100);return d;}var n=str.match(/\d+/g)||["2017","2","19","0","0","0"];var out=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(str.indexOf("Z")>-1)out=new Date(out.getTime()-out.getTimezoneOffset()*60*1000);return out;}function cc2str(arr,debomit){if(has_buf&&Buffer.isBuffer(arr)){if(debomit){if(arr[0]==0xFF&&arr[1]==0xFE)return utf8write(arr.slice(2).toString("utf16le"));if(arr[1]==0xFE&&arr[2]==0xFF)return utf8write(utf16beread(arr.slice(2).toString("binary")));}return arr.toString("binary");}if(typeof TextDecoder!=="undefined")try{if(debomit){if(arr[0]==0xFF&&arr[1]==0xFE)return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));if(arr[0]==0xFE&&arr[1]==0xFF)return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));}var rev={"\u20AC":"\x80","\u201A":"\x82","\u0192":"\x83","\u201E":"\x84","\u2026":"\x85","\u2020":"\x86","\u2021":"\x87","\u02C6":"\x88","\u2030":"\x89","\u0160":"\x8a","\u2039":"\x8b","\u0152":"\x8c","\u017D":"\x8e","\u2018":"\x91","\u2019":"\x92","\u201C":"\x93","\u201D":"\x94","\u2022":"\x95","\u2013":"\x96","\u2014":"\x97","\u02DC":"\x98","\u2122":"\x99","\u0161":"\x9a","\u203A":"\x9b","\u0153":"\x9c","\u017E":"\x9e","\u0178":"\x9f"};if(Array.isArray(arr))arr=new Uint8Array(arr);return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g,function(c){return rev[c]||c;});}catch(e){}var o=[];for(var i=0;i!=arr.length;++i){o.push(String.fromCharCode(arr[i]));}return o.join("");}function dup(o){if(typeof JSON!='undefined'&&!Array.isArray(o))return JSON.parse((0,_stringify2.default)(o));if((typeof o==="undefined"?"undefined":(0,_typeof3.default)(o))!='object'||o==null)return o;if(o instanceof Date)return new Date(o.getTime());var out={};for(var k in o){if(Object.prototype.hasOwnProperty.call(o,k))out[k]=dup(o[k]);}return out;}function fill(c,l){var o="";while(o.length<l){o+=c;}return o;}function fuzzynum(s){var v=Number(s);if(!isNaN(v))return isFinite(v)?v:NaN;if(!/\d/.test(s))return v;var wt=1;var ss=s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){wt*=100;return"";});if(!isNaN(v=Number(ss)))return v/wt;ss=ss.replace(/[(](.*)[)]/,function($$,$1){wt=-wt;return $1;});if(!isNaN(v=Number(ss)))return v/wt;return v;}var lower_months=['january','february','march','april','may','june','july','august','september','october','november','december'];function fuzzydate(s){var o=new Date(s),n=new Date(NaN);var y=o.getYear(),m=o.getMonth(),d=o.getDate();if(isNaN(d))return n;var lower=s.toLowerCase();if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)){lower=lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");if(lower.length>3&&lower_months.indexOf(lower)==-1)return n;}else if(lower.match(/[a-z]/))return n;if(y<0||y>8099)return n;if((m>0||d>1)&&y!=101)return o;if(s.match(/[^-0-9:,\/\\]/))return n;return o;}var split_regex=function(){var safe_split_regex="abacaba".split(/(:?b)/i).length==5;return function split_regex(str,re,def){if(safe_split_regex||typeof re=="string")return str.split(re);var p=str.split(re),o=[p[0]];for(var i=1;i<p.length;++i){o.push(def);o.push(p[i]);}return o;};}();function getdatastr(data){if(!data)return null;if(data.content&&data.type)return cc2str(data.content,true);if(data.data)return debom(data.data);if(data.asNodeBuffer&&has_buf)return debom(data.asNodeBuffer().toString('binary'));if(data.asBinary)return debom(data.asBinary());if(data._data&&data._data.getContent)return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));return null;}function getdatabin(data){if(!data)return null;if(data.data)return char_codes(data.data);if(data.asNodeBuffer&&has_buf)return data.asNodeBuffer();if(data._data&&data._data.getContent){var o=data._data.getContent();if(typeof o=="string")return char_codes(o);return Array.prototype.slice.call(o);}if(data.content&&data.type)return data.content;return null;}function getdata(data){return data&&data.name.slice(-4)===".bin"?getdatabin(data):getdatastr(data);}function safegetzipfile(zip,file){var k=zip.FullPaths||keys(zip.files);var f=file.toLowerCase().replace(/[\/]/g,'\\'),g=f.replace(/\\/g,'\/');for(var i=0;i<k.length;++i){var n=k[i].replace(/^Root Entry[\/]/,"").toLowerCase();if(f==n||g==n)return zip.files?zip.files[k[i]]:zip.FileIndex[i];}return null;}function getzipfile(zip,file){var o=safegetzipfile(zip,file);if(o==null)throw new Error("Cannot find file "+file+" in zip");return o;}function getzipdata(zip,file,safe){if(!safe)return getdata(getzipfile(zip,file));if(!file)return null;try{return getzipdata(zip,file);}catch(e){return null;}}function getzipstr(zip,file,safe){if(!safe)return getdatastr(getzipfile(zip,file));if(!file)return null;try{return getzipstr(zip,file);}catch(e){return null;}}function getzipbin(zip,file,safe){if(!safe)return getdatabin(getzipfile(zip,file));if(!file)return null;try{return getzipbin(zip,file);}catch(e){return null;}}function zipentries(zip){var k=zip.FullPaths||keys(zip.files),o=[];for(var i=0;i<k.length;++i){if(k[i].slice(-1)!='/')o.push(k[i].replace(/^Root Entry[\/]/,""));}return o.sort();}function zip_add_file(zip,path,content){if(zip.FullPaths){if(typeof content=="string"){var res;if(has_buf)res=Buffer_from(content);else res=utf8decode(content);return CFB.utils.cfb_add(zip,path,res);}CFB.utils.cfb_add(zip,path,content);}else zip.file(path,content);}function zip_new(){return CFB.utils.cfb_new();}function zip_read(d,o){switch(o.type){case"base64":return CFB.read(d,{type:"base64"});case"binary":return CFB.read(d,{type:"binary"});case"buffer":case"array":return CFB.read(d,{type:"buffer"});}throw new Error("Unrecognized type "+o.type);}function resolve_path(path,base){if(path.charAt(0)=="/")return path.slice(1);var result=base.split('/');if(base.slice(-1)!="/")result.pop();var target=path.split('/');while(target.length!==0){var step=target.shift();if(step==='..')result.pop();else if(step!=='.')result.push(step);}return result.join('/');}var XML_HEADER='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg,tagregex2=/<[^>]*>/g;var tagregex=XML_HEADER.match(tagregex1)?tagregex1:tagregex2;var nsregex=/<\w*:/,nsregex2=/<(\/?)\w+:/;function parsexmltag(tag,skip_root,skip_LC){var z={};var eq=0,c=0;for(;eq!==tag.length;++eq){if((c=tag.charCodeAt(eq))===32||c===10||c===13)break;}if(!skip_root)z[0]=tag.slice(0,eq);if(eq===tag.length)return z;var m=tag.match(attregexg),j=0,v="",i=0,q="",cc="",quot=1;if(m)for(i=0;i!=m.length;++i){cc=m[i];for(c=0;c!=cc.length;++c){if(cc.charCodeAt(c)===61)break;}q=cc.slice(0,c).trim();while(cc.charCodeAt(c+1)==32){++c;}quot=(eq=cc.charCodeAt(c+1))==34||eq==39?1:0;v=cc.slice(c+1+quot,cc.length-quot);for(j=0;j!=q.length;++j){if(q.charCodeAt(j)===58)break;}if(j===q.length){if(q.indexOf("_")>0)q=q.slice(0,q.indexOf("_"));z[q]=v;if(!skip_LC)z[q.toLowerCase()]=v;}else{var k=(j===5&&q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);if(z[k]&&q.slice(j-3,j)=="ext")continue;z[k]=v;if(!skip_LC)z[k.toLowerCase()]=v;}}return z;}function strip_ns(x){return x.replace(nsregex2,"<$1");}var encodings={'&quot;':'"','&apos;':"'",'&gt;':'>','&lt;':'<','&amp;':'&'};var rencoding=evert(encodings);var unescapexml=function(){var encregex=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig,coderegex=/_x([\da-fA-F]{4})_/ig;return function unescapexml(text){var s=text+'',i=s.indexOf("<![CDATA[");if(i==-1)return s.replace(encregex,function($$,$1){return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$;}).replace(coderegex,function(m,c){return String.fromCharCode(parseInt(c,16));});var j=s.indexOf("]]>");return unescapexml(s.slice(0,i))+s.slice(i+9,j)+unescapexml(s.slice(j+3));};}();var decregex=/[&<>'"]/g,charegex=/[\u0000-\u0008\u000b-\u001f]/g;function escapexml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(charegex,function(s){return"_x"+("000"+s.charCodeAt(0).toString(16)).slice(-4)+"_";});}function escapexmltag(text){return escapexml(text).replace(/ /g,"_x0020_");}var htmlcharegex=/[\u0000-\u001f]/g;function escapehtml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(/\n/g,"<br/>").replace(htmlcharegex,function(s){return"&#x"+("000"+s.charCodeAt(0).toString(16)).slice(-4)+";";});}function escapexlml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(htmlcharegex,function(s){return"&#x"+s.charCodeAt(0).toString(16).toUpperCase()+";";});}var xlml_fixstr=function(){var entregex=/&#(\d+);/g;function entrepl($$,$1){return String.fromCharCode(parseInt($1,10));}return function xlml_fixstr(str){return str.replace(entregex,entrepl);};}();function xlml_unfixstr(str){return str.replace(/(\r\n|[\r\n])/g,"\&#10;");}function parsexmlbool(value){switch(value){case 1:case true:case'1':case'true':case'TRUE':return true;default:return false;}}function utf8reada(orig){var out="",i=0,c=0,d=0,e=0,f=0,w=0;while(i<orig.length){c=orig.charCodeAt(i++);if(c<128){out+=String.fromCharCode(c);continue;}d=orig.charCodeAt(i++);if(c>191&&c<224){f=(c&31)<<6;f|=d&63;out+=String.fromCharCode(f);continue;}e=orig.charCodeAt(i++);if(c<240){out+=String.fromCharCode((c&15)<<12|(d&63)<<6|e&63);continue;}f=orig.charCodeAt(i++);w=((c&7)<<18|(d&63)<<12|(e&63)<<6|f&63)-65536;out+=String.fromCharCode(0xD800+(w>>>10&1023));out+=String.fromCharCode(0xDC00+(w&1023));}return out;}function utf8readb(data){var out=new_raw_buf(2*data.length),w,i,j=1,k=0,ww=0,c;for(i=0;i<data.length;i+=j){j=1;if((c=data.charCodeAt(i))<128)w=c;else if(c<224){w=(c&31)*64+(data.charCodeAt(i+1)&63);j=2;}else if(c<240){w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63);j=3;}else{j=4;w=(c&7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);w-=65536;ww=0xD800+(w>>>10&1023);w=0xDC00+(w&1023);}if(ww!==0){out[k++]=ww&255;out[k++]=ww>>>8;ww=0;}out[k++]=w%256;out[k++]=w>>>8;}return out.slice(0,k).toString('ucs2');}function utf8readc(data){return Buffer_from(data,'binary').toString('utf8');}var utf8corpus="foo bar baz\xE2\x98\x83\xF0\x9F\x8D\xA3";var utf8read=has_buf&&(utf8readc(utf8corpus)==utf8reada(utf8corpus)&&utf8readc||utf8readb(utf8corpus)==utf8reada(utf8corpus)&&utf8readb)||utf8reada;var utf8write=has_buf?function(data){return Buffer_from(data,'utf8').toString("binary");}:function(orig){var out=[],i=0,c=0,d=0;while(i<orig.length){c=orig.charCodeAt(i++);switch(true){case c<128:out.push(String.fromCharCode(c));break;case c<2048:out.push(String.fromCharCode(192+(c>>6)));out.push(String.fromCharCode(128+(c&63)));break;case c>=55296&&c<57344:c-=55296;d=orig.charCodeAt(i++)-56320+(c<<10);out.push(String.fromCharCode(240+(d>>18&7)));out.push(String.fromCharCode(144+(d>>12&63)));out.push(String.fromCharCode(128+(d>>6&63)));out.push(String.fromCharCode(128+(d&63)));break;default:out.push(String.fromCharCode(224+(c>>12)));out.push(String.fromCharCode(128+(c>>6&63)));out.push(String.fromCharCode(128+(c&63)));}}return out.join("");};var matchtag=function(){var mtcache={};return function matchtag(f,g){var t=f+"|"+(g||"");if(mtcache[t])return mtcache[t];return mtcache[t]=new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',g||"");};}();var htmldecode=function(){var entities=[['nbsp',' '],['middot','·'],['quot','"'],['apos',"'"],['gt','>'],['lt','<'],['amp','&']].map(function(x){return[new RegExp('&'+x[0]+';',"ig"),x[1]];});return function htmldecode(str){var o=str.replace(/^[\t\n\r ]+/,"").replace(/[\t\n\r ]+$/,"").replace(/>\s+/g,">").replace(/\s+</g,"<").replace(/[\t\n\r ]+/g," ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");for(var i=0;i<entities.length;++i){o=o.replace(entities[i][0],entities[i][1]);}return o;};}();var vtregex=function(){var vt_cache={};return function vt_regex(bt){if(vt_cache[bt]!==undefined)return vt_cache[bt];return vt_cache[bt]=new RegExp("<(?:vt:)?"+bt+">([\\s\\S]*?)</(?:vt:)?"+bt+">",'g');};}();var vtvregex=/<\/?(?:vt:)?variant>/g,vtmregex=/<(?:vt:)([^>]*)>([\s\S]*)</;function parseVector(data,opts){var h=parsexmltag(data);var matches=data.match(vtregex(h.baseType))||[];var res=[];if(matches.length!=h.size){if(opts.WTF)throw new Error("unexpected vector length "+matches.length+" != "+h.size);return res;}matches.forEach(function(x){var v=x.replace(vtvregex,"").match(vtmregex);if(v)res.push({v:utf8read(v[2]),t:v[1]});});return res;}var wtregex=/(^\s|\s$|\n)/;function writetag(f,g){return'<'+f+(g.match(wtregex)?' xml:space="preserve"':"")+'>'+g+'</'+f+'>';}function wxt_helper(h){return keys(h).map(function(k){return" "+k+'="'+h[k]+'"';}).join("");}function writextag(f,g,h){return'<'+f+(h!=null?wxt_helper(h):"")+(g!=null?(g.match(wtregex)?' xml:space="preserve"':"")+'>'+g+'</'+f:"/")+'>';}function write_w3cdtf(d,t){try{return d.toISOString().replace(/\.\d*/,"");}catch(e){if(t)throw e;}return"";}function write_vt(s,xlsx){switch(typeof s==="undefined"?"undefined":(0,_typeof3.default)(s)){case'string':var o=writextag('vt:lpwstr',escapexml(s));if(xlsx)o=o.replace(/&quot;/g,"_x0022_");return o;case'number':return writextag((s|0)==s?'vt:i4':'vt:r8',escapexml(String(s)));case'boolean':return writextag('vt:bool',s?'true':'false');}if(s instanceof Date)return writextag('vt:filetime',write_w3cdtf(s));throw new Error("Unable to serialize "+s);}function xlml_normalize(d){if(has_buf&&Buffer.isBuffer(d))return d.toString('utf8');if(typeof d==='string')return d;if(typeof Uint8Array!=='undefined'&&d instanceof Uint8Array)return utf8read(a2s(ab2a(d)));throw new Error("Bad input format: expected Buffer or string");}var xlmlregex=/<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;var XMLNS={CORE_PROPS:'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',CUST_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",EXT_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",CT:'http://schemas.openxmlformats.org/package/2006/content-types',RELS:'http://schemas.openxmlformats.org/package/2006/relationships',TCMNT:'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments','dc':'http://purl.org/dc/elements/1.1/','dcterms':'http://purl.org/dc/terms/','dcmitype':'http://purl.org/dc/dcmitype/','mx':'http://schemas.microsoft.com/office/mac/excel/2008/main','r':'http://schemas.openxmlformats.org/officeDocument/2006/relationships','sjs':'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties','vt':'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes','xsi':'http://www.w3.org/2001/XMLSchema-instance','xsd':'http://www.w3.org/2001/XMLSchema'};var XMLNS_main=['http://schemas.openxmlformats.org/spreadsheetml/2006/main','http://purl.oclc.org/ooxml/spreadsheetml/main','http://schemas.microsoft.com/office/excel/2006/main','http://schemas.microsoft.com/office/excel/2006/2'];var XLMLNS={'o':'urn:schemas-microsoft-com:office:office','x':'urn:schemas-microsoft-com:office:excel','ss':'urn:schemas-microsoft-com:office:spreadsheet','dt':'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882','mv':'http://macVmlSchemaUri','v':'urn:schemas-microsoft-com:vml','html':'http://www.w3.org/TR/REC-html40'};function read_double_le(b,idx){var s=1-2*(b[idx+7]>>>7);var e=((b[idx+7]&0x7f)<<4)+(b[idx+6]>>>4&0x0f);var m=b[idx+6]&0x0f;for(var i=5;i>=0;--i){m=m*256+b[idx+i];}if(e==0x7ff)return m==0?s*Infinity:NaN;if(e==0)e=-1022;else{e-=1023;m+=Math.pow(2,52);}return s*Math.pow(2,e-52)*m;}function write_double_le(b,v,idx){var bs=(v<0||1/v==-Infinity?1:0)<<7,e=0,m=0;var av=bs?-v:v;if(!isFinite(av)){e=0x7ff;m=isNaN(v)?0x6969:0;}else if(av==0)e=m=0;else{e=Math.floor(Math.log(av)/Math.LN2);m=av*Math.pow(2,52-e);if(e<=-1023&&(!isFinite(m)||m<Math.pow(2,52))){e=-1022;}else{m-=Math.pow(2,52);e+=1023;}}for(var i=0;i<=5;++i,m/=256){b[idx+i]=m&0xff;}b[idx+6]=(e&0x0f)<<4|m&0xf;b[idx+7]=e>>4|bs;}var ___toBuffer=function ___toBuffer(bufs){var x=[],w=10240;for(var i=0;i<bufs[0].length;++i){if(bufs[0][i])for(var j=0,L=bufs[0][i].length;j<L;j+=w){x.push.apply(x,bufs[0][i].slice(j,j+w));}}return x;};var __toBuffer=has_buf?function(bufs){return bufs[0].length>0&&Buffer.isBuffer(bufs[0][0])?Buffer.concat(bufs[0].map(function(x){return Buffer.isBuffer(x)?x:Buffer_from(x);})):___toBuffer(bufs);}:___toBuffer;var ___utf16le=function ___utf16le(b,s,e){var ss=[];for(var i=s;i<e;i+=2){ss.push(String.fromCharCode(__readUInt16LE(b,i)));}return ss.join("").replace(chr0,'');};var __utf16le=has_buf?function(b,s,e){if(!Buffer.isBuffer(b))return ___utf16le(b,s,e);return b.toString('utf16le',s,e).replace(chr0,'');}:___utf16le;var ___hexlify=function ___hexlify(b,s,l){var ss=[];for(var i=s;i<s+l;++i){ss.push(("0"+b[i].toString(16)).slice(-2));}return ss.join("");};var __hexlify=has_buf?function(b,s,l){return Buffer.isBuffer(b)?b.toString('hex',s,s+l):___hexlify(b,s,l);}:___hexlify;var ___utf8=function ___utf8(b,s,e){var ss=[];for(var i=s;i<e;i++){ss.push(String.fromCharCode(__readUInt8(b,i)));}return ss.join("");};var __utf8=has_buf?function utf8_b(b,s,e){return Buffer.isBuffer(b)?b.toString('utf8',s,e):___utf8(b,s,e);}:___utf8;var ___lpstr=function ___lpstr(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var __lpstr=___lpstr;var ___cpstr=function ___cpstr(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var __cpstr=___cpstr;var ___lpwstr=function ___lpwstr(b,i){var len=2*__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var __lpwstr=___lpwstr;var ___lpp4=function lpp4_(b,i){var len=__readUInt32LE(b,i);return len>0?__utf16le(b,i+4,i+4+len):"";};var __lpp4=___lpp4;var ___8lpp4=function ___8lpp4(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len):"";};var __8lpp4=___8lpp4;var ___double=function ___double(b,idx){return read_double_le(b,idx);};var __double=___double;var is_buf=function is_buf_a(a){return Array.isArray(a)||typeof Uint8Array!=="undefined"&&a instanceof Uint8Array;};if(has_buf){__lpstr=function lpstr_b(b,i){if(!Buffer.isBuffer(b))return ___lpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString('utf8',i+4,i+4+len-1):"";};__cpstr=function cpstr_b(b,i){if(!Buffer.isBuffer(b))return ___cpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString('utf8',i+4,i+4+len-1):"";};__lpwstr=function lpwstr_b(b,i){if(!Buffer.isBuffer(b))return ___lpwstr(b,i);var len=2*b.readUInt32LE(i);return b.toString('utf16le',i+4,i+4+len-1);};__lpp4=function lpp4_b(b,i){if(!Buffer.isBuffer(b))return ___lpp4(b,i);var len=b.readUInt32LE(i);return b.toString('utf16le',i+4,i+4+len);};__8lpp4=function lpp4_8b(b,i){if(!Buffer.isBuffer(b))return ___8lpp4(b,i);var len=b.readUInt32LE(i);return b.toString('utf8',i+4,i+4+len);};__double=function double_(b,i){if(Buffer.isBuffer(b))return b.readDoubleLE(i);return ___double(b,i);};is_buf=function is_buf_b(a){return Buffer.isBuffer(a)||Array.isArray(a)||typeof Uint8Array!=="undefined"&&a instanceof Uint8Array;};}function cpdoit(){__utf16le=function __utf16le(b,s,e){return $cptable.utils.decode(1200,b.slice(s,e)).replace(chr0,'');};__utf8=function __utf8(b,s,e){return $cptable.utils.decode(65001,b.slice(s,e));};__lpstr=function __lpstr(b,i){var len=__readUInt32LE(b,i);return len>0?$cptable.utils.decode(current_ansi,b.slice(i+4,i+4+len-1)):"";};__cpstr=function __cpstr(b,i){var len=__readUInt32LE(b,i);return len>0?$cptable.utils.decode(current_codepage,b.slice(i+4,i+4+len-1)):"";};__lpwstr=function __lpwstr(b,i){var len=2*__readUInt32LE(b,i);return len>0?$cptable.utils.decode(1200,b.slice(i+4,i+4+len-1)):"";};__lpp4=function __lpp4(b,i){var len=__readUInt32LE(b,i);return len>0?$cptable.utils.decode(1200,b.slice(i+4,i+4+len)):"";};__8lpp4=function __8lpp4(b,i){var len=__readUInt32LE(b,i);return len>0?$cptable.utils.decode(65001,b.slice(i+4,i+4+len)):"";};}if(typeof $cptable!=='undefined')cpdoit();var __readUInt8=function __readUInt8(b,idx){return b[idx];};var __readUInt16LE=function __readUInt16LE(b,idx){return b[idx+1]*(1<<8)+b[idx];};var __readInt16LE=function __readInt16LE(b,idx){var u=b[idx+1]*(1<<8)+b[idx];return u<0x8000?u:(0xffff-u+1)*-1;};var __readUInt32LE=function __readUInt32LE(b,idx){return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx];};var __readInt32LE=function __readInt32LE(b,idx){return b[idx+3]<<24|b[idx+2]<<16|b[idx+1]<<8|b[idx];};var __readInt32BE=function __readInt32BE(b,idx){return b[idx]<<24|b[idx+1]<<16|b[idx+2]<<8|b[idx+3];};function ReadShift(size,t){var o="",oI,oR,oo=[],w,vv,i,loc;switch(t){case'dbcs':loc=this.l;if(has_buf&&Buffer.isBuffer(this))o=this.slice(this.l,this.l+2*size).toString("utf16le");else for(i=0;i<size;++i){o+=String.fromCharCode(__readUInt16LE(this,loc));loc+=2;}size*=2;break;case'utf8':o=__utf8(this,this.l,this.l+size);break;case'utf16le':size*=2;o=__utf16le(this,this.l,this.l+size);break;case'wstr':if(typeof $cptable!=='undefined')o=$cptable.utils.decode(current_codepage,this.slice(this.l,this.l+2*size));else return ReadShift.call(this,size,'dbcs');size=2*size;break;case'lpstr-ansi':o=__lpstr(this,this.l);size=4+__readUInt32LE(this,this.l);break;case'lpstr-cp':o=__cpstr(this,this.l);size=4+__readUInt32LE(this,this.l);break;case'lpwstr':o=__lpwstr(this,this.l);size=4+2*__readUInt32LE(this,this.l);break;case'lpp4':size=4+__readUInt32LE(this,this.l);o=__lpp4(this,this.l);if(size&0x02)size+=2;break;case'8lpp4':size=4+__readUInt32LE(this,this.l);o=__8lpp4(this,this.l);if(size&0x03)size+=4-(size&0x03);break;case'cstr':size=0;o="";while((w=__readUInt8(this,this.l+size++))!==0){oo.push(_getchar(w));}o=oo.join("");break;case'_wstr':size=0;o="";while((w=__readUInt16LE(this,this.l+size))!==0){oo.push(_getchar(w));size+=2;}size+=2;o=oo.join("");break;case'dbcs-cont':o="";loc=this.l;for(i=0;i<size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?'dbcs-cont':'sbcs-cont');return oo.join("")+vv;}oo.push(_getchar(__readUInt16LE(this,loc)));loc+=2;}o=oo.join("");size*=2;break;case'cpstr':if(typeof $cptable!=='undefined'){o=$cptable.utils.decode(current_codepage,this.slice(this.l,this.l+size));break;}case'sbcs-cont':o="";loc=this.l;for(i=0;i!=size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?'dbcs-cont':'sbcs-cont');return oo.join("")+vv;}oo.push(_getchar(__readUInt8(this,loc)));loc+=1;}o=oo.join("");break;default:switch(size){case 1:oI=__readUInt8(this,this.l);this.l++;return oI;case 2:oI=(t==='i'?__readInt16LE:__readUInt16LE)(this,this.l);this.l+=2;return oI;case 4:case-4:if(t==='i'||(this[this.l+3]&0x80)===0){oI=(size>0?__readInt32LE:__readInt32BE)(this,this.l);this.l+=4;return oI;}else{oR=__readUInt32LE(this,this.l);this.l+=4;}return oR;case 8:case-8:if(t==='f'){if(size==8)oR=__double(this,this.l);else oR=__double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0);this.l+=8;return oR;}else size=8;case 16:o=__hexlify(this,this.l,size);break;}}this.l+=size;return o;}var __writeUInt32LE=function __writeUInt32LE(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>>8&0xFF;b[idx+2]=val>>>16&0xFF;b[idx+3]=val>>>24&0xFF;};var __writeInt32LE=function __writeInt32LE(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>8&0xFF;b[idx+2]=val>>16&0xFF;b[idx+3]=val>>24&0xFF;};var __writeUInt16LE=function __writeUInt16LE(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>>8&0xFF;};function WriteShift(t,val,f){var size=0,i=0;if(f==='dbcs'){for(i=0;i!=val.length;++i){__writeUInt16LE(this,val.charCodeAt(i),this.l+2*i);}size=2*val.length;}else if(f==='sbcs'){if(typeof $cptable!=='undefined'&&current_ansi==874){for(i=0;i!=val.length;++i){var cppayload=$cptable.utils.encode(current_ansi,val.charAt(i));this[this.l+i]=cppayload[0];}}else{val=val.replace(/[^\x00-\x7F]/g,"_");for(i=0;i!=val.length;++i){this[this.l+i]=val.charCodeAt(i)&0xFF;}}size=val.length;}else if(f==='hex'){for(;i<t;++i){this[this.l++]=parseInt(val.slice(2*i,2*i+2),16)||0;}return this;}else if(f==='utf16le'){var end=Math.min(this.l+t,this.length);for(i=0;i<Math.min(val.length,t);++i){var cc=val.charCodeAt(i);this[this.l++]=cc&0xff;this[this.l++]=cc>>8;}while(this.l<end){this[this.l++]=0;}return this;}else switch(t){case 1:size=1;this[this.l]=val&0xFF;break;case 2:size=2;this[this.l]=val&0xFF;val>>>=8;this[this.l+1]=val&0xFF;break;case 3:size=3;this[this.l]=val&0xFF;val>>>=8;this[this.l+1]=val&0xFF;val>>>=8;this[this.l+2]=val&0xFF;break;case 4:size=4;__writeUInt32LE(this,val,this.l);break;case 8:size=8;if(f==='f'){write_double_le(this,val,this.l);break;}case 16:break;case-4:size=4;__writeInt32LE(this,val,this.l);break;}this.l+=size;return this;}function CheckField(hexstr,fld){var m=__hexlify(this,this.l,hexstr.length>>1);if(m!==hexstr)throw new Error(fld+'Expected '+hexstr+' saw '+m);this.l+=hexstr.length>>1;}function prep_blob(blob,pos){blob.l=pos;blob.read_shift=ReadShift;blob.chk=CheckField;blob.write_shift=WriteShift;}function parsenoop(blob,length){blob.l+=length;}function new_buf(sz){var o=new_raw_buf(sz);prep_blob(o,0);return o;}function recordhopper(data,cb,opts){if(!data)return;var tmpbyte,cntbyte,length;prep_blob(data,data.l||0);var L=data.length,RT=0,tgt=0;while(data.l<L){RT=data.read_shift(1);if(RT&0x80)RT=(RT&0x7F)+((data.read_shift(1)&0x7F)<<7);var R=XLSBRecordEnum[RT]||XLSBRecordEnum[0xFFFF];tmpbyte=data.read_shift(1);length=tmpbyte&0x7F;for(cntbyte=1;cntbyte<4&&tmpbyte&0x80;++cntbyte){length+=((tmpbyte=data.read_shift(1))&0x7F)<<7*cntbyte;}tgt=data.l+length;var d=R.f&&R.f(data,length,opts);data.l=tgt;if(cb(d,R,RT))return;}}function buf_array(){var bufs=[],blksz=has_buf?256:2048;var newblk=function ba_newblk(sz){var o=new_buf(sz);prep_blob(o,0);return o;};var curbuf=newblk(blksz);var endbuf=function ba_endbuf(){if(!curbuf)return;if(curbuf.length>curbuf.l){curbuf=curbuf.slice(0,curbuf.l);curbuf.l=curbuf.length;}if(curbuf.length>0)bufs.push(curbuf);curbuf=null;};var next=function ba_next(sz){if(curbuf&&sz<curbuf.length-curbuf.l)return curbuf;endbuf();return curbuf=newblk(Math.max(sz+1,blksz));};var end=function ba_end(){endbuf();return bconcat(bufs);};var push=function ba_push(buf){endbuf();curbuf=buf;if(curbuf.l==null)curbuf.l=curbuf.length;next(blksz);};return{next:next,push:push,end:end,_bufs:bufs};}function write_record(ba,type,payload,length){var t=+type,l;if(isNaN(t))return;if(!length)length=XLSBRecordEnum[t].p||(payload||[]).length||0;l=1+(t>=0x80?1:0)+1;if(length>=0x80)++l;if(length>=0x4000)++l;if(length>=0x200000)++l;var o=ba.next(l);if(t<=0x7F)o.write_shift(1,t);else{o.write_shift(1,(t&0x7F)+0x80);o.write_shift(1,t>>7);}for(var i=0;i!=4;++i){if(length>=0x80){o.write_shift(1,(length&0x7F)+0x80);length>>=7;}else{o.write_shift(1,length);break;}}if(length>0&&is_buf(payload))ba.push(payload);}function shift_cell_xls(cell,tgt,opts){var out=dup(cell);if(tgt.s){if(out.cRel)out.c+=tgt.s.c;if(out.rRel)out.r+=tgt.s.r;}else{if(out.cRel)out.c+=tgt.c;if(out.rRel)out.r+=tgt.r;}if(!opts||opts.biff<12){while(out.c>=0x100){out.c-=0x100;}while(out.r>=0x10000){out.r-=0x10000;}}return out;}function shift_range_xls(cell,range,opts){var out=dup(cell);out.s=shift_cell_xls(out.s,range.s,opts);out.e=shift_cell_xls(out.e,range.s,opts);return out;}function encode_cell_xls(c,biff){if(c.cRel&&c.c<0){c=dup(c);while(c.c<0){c.c+=biff>8?0x4000:0x100;}}if(c.rRel&&c.r<0){c=dup(c);while(c.r<0){c.r+=biff>8?0x100000:biff>5?0x10000:0x4000;}}var s=encode_cell(c);if(!c.cRel&&c.cRel!=null)s=fix_col(s);if(!c.rRel&&c.rRel!=null)s=fix_row(s);return s;}function encode_range_xls(r,opts){if(r.s.r==0&&!r.s.rRel){if(r.e.r==(opts.biff>=12?0xFFFFF:opts.biff>=8?0x10000:0x4000)&&!r.e.rRel){return(r.s.cRel?"":"$")+encode_col(r.s.c)+":"+(r.e.cRel?"":"$")+encode_col(r.e.c);}}if(r.s.c==0&&!r.s.cRel){if(r.e.c==(opts.biff>=12?0x3FFF:0xFF)&&!r.e.cRel){return(r.s.rRel?"":"$")+encode_row(r.s.r)+":"+(r.e.rRel?"":"$")+encode_row(r.e.r);}}return encode_cell_xls(r.s,opts.biff)+":"+encode_cell_xls(r.e,opts.biff);}function decode_row(rowstr){return parseInt(unfix_row(rowstr),10)-1;}function encode_row(row){return""+(row+1);}function fix_row(cstr){return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2");}function unfix_row(cstr){return cstr.replace(/\$(\d+)$/,"$1");}function decode_col(colstr){var c=unfix_col(colstr),d=0,i=0;for(;i!==c.length;++i){d=26*d+c.charCodeAt(i)-64;}return d-1;}function encode_col(col){if(col<0)throw new Error("invalid column "+col);var s="";for(++col;col;col=Math.floor((col-1)/26)){s=String.fromCharCode((col-1)%26+65)+s;}return s;}function fix_col(cstr){return cstr.replace(/^([A-Z])/,"$$$1");}function unfix_col(cstr){return cstr.replace(/^\$([A-Z])/,"$1");}function split_cell(cstr){return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",");}function decode_cell(cstr){var R=0,C=0;for(var i=0;i<cstr.length;++i){var cc=cstr.charCodeAt(i);if(cc>=48&&cc<=57)R=10*R+(cc-48);else if(cc>=65&&cc<=90)C=26*C+(cc-64);}return{c:C-1,r:R-1};}function encode_cell(cell){var col=cell.c+1;var s="";for(;col;col=(col-1)/26|0){s=String.fromCharCode((col-1)%26+65)+s;}return s+(cell.r+1);}function decode_range(range){var idx=range.indexOf(":");if(idx==-1)return{s:decode_cell(range),e:decode_cell(range)};return{s:decode_cell(range.slice(0,idx)),e:decode_cell(range.slice(idx+1))};}function encode_range(cs,ce){if(typeof ce==='undefined'||typeof ce==='number'){return encode_range(cs.s,cs.e);}if(typeof cs!=='string')cs=encode_cell(cs);if(typeof ce!=='string')ce=encode_cell(ce);return cs==ce?cs:cs+":"+ce;}function safe_decode_range(range){var o={s:{c:0,r:0},e:{c:0,r:0}};var idx=0,i=0,cc=0;var len=range.length;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}o.s.c=--idx;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc;}o.s.r=--idx;if(i===len||cc!=10){o.e.c=o.s.c;o.e.r=o.s.r;return o;}++i;for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}o.e.c=--idx;for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc;}o.e.r=--idx;return o;}function safe_format_cell(cell,v){var q=cell.t=='d'&&v instanceof Date;if(cell.z!=null)try{return cell.w=SSF_format(cell.z,q?datenum(v):v);}catch(e){}try{return cell.w=SSF_format((cell.XF||{}).numFmtId||(q?14:0),q?datenum(v):v);}catch(e){return''+v;}}function format_cell(cell,v,o){if(cell==null||cell.t==null||cell.t=='z')return"";if(cell.w!==undefined)return cell.w;if(cell.t=='d'&&!cell.z&&o&&o.dateNF)cell.z=o.dateNF;if(cell.t=="e")return BErr[cell.v]||cell.v;if(v==undefined)return safe_format_cell(cell,cell.v);return safe_format_cell(cell,v);}function sheet_to_workbook(sheet,opts){var n=opts&&opts.sheet?opts.sheet:"Sheet1";var sheets={};sheets[n]=sheet;return{SheetNames:[n],Sheets:sheets};}function sheet_add_aoa(_ws,data,opts){var o=opts||{};var dense=_ws?Array.isArray(_ws):o.dense;if(DENSE!=null&&dense==null)dense=DENSE;var ws=_ws||(dense?[]:{});var _R=0,_C=0;if(ws&&o.origin!=null){if(typeof o.origin=='number')_R=o.origin;else{var _origin=typeof o.origin=="string"?decode_cell(o.origin):o.origin;_R=_origin.r;_C=_origin.c;}if(!ws["!ref"])ws["!ref"]="A1:A1";}var range={s:{c:10000000,r:10000000},e:{c:0,r:0}};if(ws['!ref']){var _range=safe_decode_range(ws['!ref']);range.s.c=_range.s.c;range.s.r=_range.s.r;range.e.c=Math.max(range.e.c,_range.e.c);range.e.r=Math.max(range.e.r,_range.e.r);if(_R==-1)range.e.r=_R=_range.e.r+1;}for(var R=0;R!=data.length;++R){if(!data[R])continue;if(!Array.isArray(data[R]))throw new Error("aoa_to_sheet expects an array of arrays");for(var C=0;C!=data[R].length;++C){if(typeof data[R][C]==='undefined')continue;var cell={v:data[R][C]};var __R=_R+R,__C=_C+C;if(range.s.r>__R)range.s.r=__R;if(range.s.c>__C)range.s.c=__C;if(range.e.r<__R)range.e.r=__R;if(range.e.c<__C)range.e.c=__C;if(data[R][C]&&(0,_typeof3.default)(data[R][C])==='object'&&!Array.isArray(data[R][C])&&!(data[R][C]instanceof Date))cell=data[R][C];else{if(Array.isArray(cell.v)){cell.f=data[R][C][1];cell.v=cell.v[0];}if(cell.v===null){if(cell.f)cell.t='n';else if(o.nullError){cell.t='e';cell.v=0;}else if(!o.sheetStubs)continue;else cell.t='z';}else if(typeof cell.v==='number')cell.t='n';else if(typeof cell.v==='boolean')cell.t='b';else if(cell.v instanceof Date){cell.z=o.dateNF||table_fmt[14];if(o.cellDates){cell.t='d';cell.w=SSF_format(cell.z,datenum(cell.v));}else{cell.t='n';cell.v=datenum(cell.v);cell.w=SSF_format(cell.z,cell.v);}}else cell.t='s';}if(dense){if(!ws[__R])ws[__R]=[];if(ws[__R][__C]&&ws[__R][__C].z)cell.z=ws[__R][__C].z;ws[__R][__C]=cell;}else{var cell_ref=encode_cell({c:__C,r:__R});if(ws[cell_ref]&&ws[cell_ref].z)cell.z=ws[cell_ref].z;ws[cell_ref]=cell;}}}if(range.s.c<10000000)ws['!ref']=encode_range(range);return ws;}function aoa_to_sheet(data,opts){return sheet_add_aoa(null,data,opts);}function parse_Int32LE(data){return data.read_shift(4,'i');}function write_UInt32LE(x,o){if(!o)o=new_buf(4);o.write_shift(4,x);return o;}function parse_XLWideString(data){var cchCharacters=data.read_shift(4);return cchCharacters===0?"":data.read_shift(cchCharacters,'dbcs');}function write_XLWideString(data,o){var _null=false;if(o==null){_null=true;o=new_buf(4+2*data.length);}o.write_shift(4,data.length);if(data.length>0)o.write_shift(0,data,'dbcs');return _null?o.slice(0,o.l):o;}function parse_StrRun(data){return{ich:data.read_shift(2),ifnt:data.read_shift(2)};}function write_StrRun(run,o){if(!o)o=new_buf(4);o.write_shift(2,run.ich||0);o.write_shift(2,run.ifnt||0);return o;}function parse_RichStr(data,length){var start=data.l;var flags=data.read_shift(1);var str=parse_XLWideString(data);var rgsStrRun=[];var z={t:str,h:str};if((flags&1)!==0){var dwSizeStrRun=data.read_shift(4);for(var i=0;i!=dwSizeStrRun;++i){rgsStrRun.push(parse_StrRun(data));}z.r=rgsStrRun;}else z.r=[{ich:0,ifnt:0}];data.l=start+length;return z;}function write_RichStr(str,o){var _null=false;if(o==null){_null=true;o=new_buf(15+4*str.t.length);}o.write_shift(1,0);write_XLWideString(str.t,o);return _null?o.slice(0,o.l):o;}var parse_BrtCommentText=parse_RichStr;function write_BrtCommentText(str,o){var _null=false;if(o==null){_null=true;o=new_buf(23+4*str.t.length);}o.write_shift(1,1);write_XLWideString(str.t,o);o.write_shift(4,1);write_StrRun({ich:0,ifnt:0},o);return _null?o.slice(0,o.l):o;}function parse_XLSBCell(data){var col=data.read_shift(4);var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;data.l++;return{c:col,iStyleRef:iStyleRef};}function write_XLSBCell(cell,o){if(o==null)o=new_buf(8);o.write_shift(-4,cell.c);o.write_shift(3,cell.iStyleRef||cell.s);o.write_shift(1,0);return o;}function parse_XLSBShortCell(data){var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;data.l++;return{c:-1,iStyleRef:iStyleRef};}function write_XLSBShortCell(cell,o){if(o==null)o=new_buf(4);o.write_shift(3,cell.iStyleRef||cell.s);o.write_shift(1,0);return o;}var parse_XLSBCodeName=parse_XLWideString;var write_XLSBCodeName=write_XLWideString;function parse_XLNullableWideString(data){var cchCharacters=data.read_shift(4);return cchCharacters===0||cchCharacters===0xFFFFFFFF?"":data.read_shift(cchCharacters,'dbcs');}function write_XLNullableWideString(data,o){var _null=false;if(o==null){_null=true;o=new_buf(127);}o.write_shift(4,data.length>0?data.length:0xFFFFFFFF);if(data.length>0)o.write_shift(0,data,'dbcs');return _null?o.slice(0,o.l):o;}var parse_XLNameWideString=parse_XLWideString;var parse_RelID=parse_XLNullableWideString;var write_RelID=write_XLNullableWideString;function parse_RkNumber(data){var b=data.slice(data.l,data.l+4);var fX100=b[0]&1,fInt=b[0]&2;data.l+=4;var RK=fInt===0?__double([0,0,0,0,b[0]&0xFC,b[1],b[2],b[3]],0):__readInt32LE(b,0)>>2;return fX100?RK/100:RK;}function write_RkNumber(data,o){if(o==null)o=new_buf(4);var fX100=0,fInt=0,d100=data*100;if(data==(data|0)&&data>=-(1<<29)&&data<1<<29){fInt=1;}else if(d100==(d100|0)&&d100>=-(1<<29)&&d100<1<<29){fInt=1;fX100=1;}if(fInt)o.write_shift(-4,((fX100?d100:data)<<2)+(fX100+2));else throw new Error("unsupported RkNumber "+data);}function parse_RfX(data){var cell={s:{},e:{}};cell.s.r=data.read_shift(4);cell.e.r=data.read_shift(4);cell.s.c=data.read_shift(4);cell.e.c=data.read_shift(4);return cell;}function write_RfX(r,o){if(!o)o=new_buf(16);o.write_shift(4,r.s.r);o.write_shift(4,r.e.r);o.write_shift(4,r.s.c);o.write_shift(4,r.e.c);return o;}var parse_UncheckedRfX=parse_RfX;var write_UncheckedRfX=write_RfX;function parse_Xnum(data){if(data.length-data.l<8)throw"XLS Xnum Buffer underflow";return data.read_shift(8,'f');}function write_Xnum(data,o){return(o||new_buf(8)).write_shift(8,data,'f');}function parse_BrtColor(data){var out={};var d=data.read_shift(1);var xColorType=d>>>1;var index=data.read_shift(1);var nTS=data.read_shift(2,'i');var bR=data.read_shift(1);var bG=data.read_shift(1);var bB=data.read_shift(1);data.l++;switch(xColorType){case 0:out.auto=1;break;case 1:out.index=index;var icv=XLSIcv[index];if(icv)out.rgb=rgb2Hex(icv);break;case 2:out.rgb=rgb2Hex([bR,bG,bB]);break;case 3:out.theme=index;break;}if(nTS!=0)out.tint=nTS>0?nTS/32767:nTS/32768;return out;}function write_BrtColor(color,o){if(!o)o=new_buf(8);if(!color||color.auto){o.write_shift(4,0);o.write_shift(4,0);return o;}if(color.index!=null){o.write_shift(1,0x02);o.write_shift(1,color.index);}else if(color.theme!=null){o.write_shift(1,0x06);o.write_shift(1,color.theme);}else{o.write_shift(1,0x05);o.write_shift(1,0);}var nTS=color.tint||0;if(nTS>0)nTS*=32767;else if(nTS<0)nTS*=32768;o.write_shift(2,nTS);if(!color.rgb||color.theme!=null){o.write_shift(2,0);o.write_shift(1,0);o.write_shift(1,0);}else{var rgb=color.rgb||'FFFFFF';if(typeof rgb=='number')rgb=("000000"+rgb.toString(16)).slice(-6);o.write_shift(1,parseInt(rgb.slice(0,2),16));o.write_shift(1,parseInt(rgb.slice(2,4),16));o.write_shift(1,parseInt(rgb.slice(4,6),16));o.write_shift(1,0xFF);}return o;}function parse_FontFlags(data){var d=data.read_shift(1);data.l++;var out={fBold:d&0x01,fItalic:d&0x02,fUnderline:d&0x04,fStrikeout:d&0x08,fOutline:d&0x10,fShadow:d&0x20,fCondense:d&0x40,fExtend:d&0x80};return out;}function write_FontFlags(font,o){if(!o)o=new_buf(2);var grbit=(font.italic?0x02:0)|(font.strike?0x08:0)|(font.outline?0x10:0)|(font.shadow?0x20:0)|(font.condense?0x40:0)|(font.extend?0x80:0);o.write_shift(1,grbit);o.write_shift(1,0);return o;}function parse_ClipboardFormatOrString(o,w){var ClipFmt={2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};var m=o.read_shift(4);switch(m){case 0x00000000:return"";case 0xffffffff:case 0xfffffffe:return ClipFmt[o.read_shift(4)]||"";}if(m>0x190)throw new Error("Unsupported Clipboard: "+m.toString(16));o.l-=4;return o.read_shift(0,w==1?"lpstr":"lpwstr");}function parse_ClipboardFormatOrAnsiString(o){return parse_ClipboardFormatOrString(o,1);}function parse_ClipboardFormatOrUnicodeString(o){return parse_ClipboardFormatOrString(o,2);}var VT_I2=0x0002;var VT_I4=0x0003;var VT_BOOL=0x000B;var VT_VARIANT=0x000C;var VT_UI4=0x0013;var VT_LPSTR=0x001E;var VT_FILETIME=0x0040;var VT_BLOB=0x0041;var VT_CF=0x0047;var VT_VECTOR=0x1000;var VT_VECTOR_VARIANT=0x100C;var VT_VECTOR_LPSTR=0x101E;var VT_STRING=0x0050;var VT_USTR=0x0051;var VT_CUSTOM=[VT_STRING,VT_USTR];var DocSummaryPIDDSI={0x01:{n:'CodePage',t:VT_I2},0x02:{n:'Category',t:VT_STRING},0x03:{n:'PresentationFormat',t:VT_STRING},0x04:{n:'ByteCount',t:VT_I4},0x05:{n:'LineCount',t:VT_I4},0x06:{n:'ParagraphCount',t:VT_I4},0x07:{n:'SlideCount',t:VT_I4},0x08:{n:'NoteCount',t:VT_I4},0x09:{n:'HiddenCount',t:VT_I4},0x0a:{n:'MultimediaClipCount',t:VT_I4},0x0b:{n:'ScaleCrop',t:VT_BOOL},0x0c:{n:'HeadingPairs',t:VT_VECTOR_VARIANT},0x0d:{n:'TitlesOfParts',t:VT_VECTOR_LPSTR},0x0e:{n:'Manager',t:VT_STRING},0x0f:{n:'Company',t:VT_STRING},0x10:{n:'LinksUpToDate',t:VT_BOOL},0x11:{n:'CharacterCount',t:VT_I4},0x13:{n:'SharedDoc',t:VT_BOOL},0x16:{n:'HyperlinksChanged',t:VT_BOOL},0x17:{n:'AppVersion',t:VT_I4,p:'version'},0x18:{n:'DigSig',t:VT_BLOB},0x1A:{n:'ContentType',t:VT_STRING},0x1B:{n:'ContentStatus',t:VT_STRING},0x1C:{n:'Language',t:VT_STRING},0x1D:{n:'Version',t:VT_STRING},0xFF:{},0x80000000:{n:'Locale',t:VT_UI4},0x80000003:{n:'Behavior',t:VT_UI4},0x72627262:{}};var SummaryPIDSI={0x01:{n:'CodePage',t:VT_I2},0x02:{n:'Title',t:VT_STRING},0x03:{n:'Subject',t:VT_STRING},0x04:{n:'Author',t:VT_STRING},0x05:{n:'Keywords',t:VT_STRING},0x06:{n:'Comments',t:VT_STRING},0x07:{n:'Template',t:VT_STRING},0x08:{n:'LastAuthor',t:VT_STRING},0x09:{n:'RevNumber',t:VT_STRING},0x0A:{n:'EditTime',t:VT_FILETIME},0x0B:{n:'LastPrinted',t:VT_FILETIME},0x0C:{n:'CreatedDate',t:VT_FILETIME},0x0D:{n:'ModifiedDate',t:VT_FILETIME},0x0E:{n:'PageCount',t:VT_I4},0x0F:{n:'WordCount',t:VT_I4},0x10:{n:'CharCount',t:VT_I4},0x11:{n:'Thumbnail',t:VT_CF},0x12:{n:'Application',t:VT_STRING},0x13:{n:'DocSecurity',t:VT_I4},0xFF:{},0x80000000:{n:'Locale',t:VT_UI4},0x80000003:{n:'Behavior',t:VT_UI4},0x72627262:{}};var CountryEnum={0x0001:"US",0x0002:"CA",0x0003:"",0x0007:"RU",0x0014:"EG",0x001E:"GR",0x001F:"NL",0x0020:"BE",0x0021:"FR",0x0022:"ES",0x0024:"HU",0x0027:"IT",0x0029:"CH",0x002B:"AT",0x002C:"GB",0x002D:"DK",0x002E:"SE",0x002F:"NO",0x0030:"PL",0x0031:"DE",0x0034:"MX",0x0037:"BR",0x003d:"AU",0x0040:"NZ",0x0042:"TH",0x0051:"JP",0x0052:"KR",0x0054:"VN",0x0056:"CN",0x005A:"TR",0x0069:"JS",0x00D5:"DZ",0x00D8:"MA",0x00DA:"LY",0x015F:"PT",0x0162:"IS",0x0166:"FI",0x01A4:"CZ",0x0376:"TW",0x03C1:"LB",0x03C2:"JO",0x03C3:"SY",0x03C4:"IQ",0x03C5:"KW",0x03C6:"SA",0x03CB:"AE",0x03CC:"IL",0x03CE:"QA",0x03D5:"IR",0xFFFF:"US"};var XLSFillPattern=[null,'solid','mediumGray','darkGray','lightGray','darkHorizontal','darkVertical','darkDown','darkUp','darkGrid','darkTrellis','lightHorizontal','lightVertical','lightDown','lightUp','lightGrid','lightTrellis','gray125','gray0625'];function rgbify(arr){return arr.map(function(x){return[x>>16&255,x>>8&255,x&255];});}var _XLSIcv=rgbify([0x000000,0xFFFFFF,0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,0x000000,0xFFFFFF,0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,0x800000,0x008000,0x000080,0x808000,0x800080,0x008080,0xC0C0C0,0x808080,0x9999FF,0x993366,0xFFFFCC,0xCCFFFF,0x660066,0xFF8080,0x0066CC,0xCCCCFF,0x000080,0xFF00FF,0xFFFF00,0x00FFFF,0x800080,0x800000,0x008080,0x0000FF,0x00CCFF,0xCCFFFF,0xCCFFCC,0xFFFF99,0x99CCFF,0xFF99CC,0xCC99FF,0xFFCC99,0x3366FF,0x33CCCC,0x99CC00,0xFFCC00,0xFF9900,0xFF6600,0x666699,0x969696,0x003366,0x339966,0x003300,0x333300,0x993300,0x993366,0x333399,0x333333,0xFFFFFF,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000,0x000000]);var XLSIcv=dup(_XLSIcv);var BErr={0x00:"#NULL!",0x07:"#DIV/0!",0x0F:"#VALUE!",0x17:"#REF!",0x1D:"#NAME?",0x24:"#NUM!",0x2A:"#N/A",0x2B:"#GETTING_DATA",0xFF:"#WTF?"};var RBErr={"#NULL!":0x00,"#DIV/0!":0x07,"#VALUE!":0x0F,"#REF!":0x17,"#NAME?":0x1D,"#NUM!":0x24,"#N/A":0x2A,"#GETTING_DATA":0x2B,"#WTF?":0xFF};var ct2type={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.sheet.macroEnabled.main+xml":"workbooks","application/vnd.ms-excel.sheet.binary.macroEnabled.main":"workbooks","application/vnd.ms-excel.addin.macroEnabled.main+xml":"workbooks","application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":"workbooks","application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":"sheets","application/vnd.ms-excel.worksheet":"sheets","application/vnd.ms-excel.binIndexWs":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":"charts","application/vnd.ms-excel.chartsheet":"charts","application/vnd.ms-excel.macrosheet+xml":"macros","application/vnd.ms-excel.macrosheet":"macros","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":"dialogs","application/vnd.ms-excel.dialogsheet":"dialogs","application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml":"strs","application/vnd.ms-excel.sharedStrings":"strs","application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":"styles","application/vnd.ms-excel.styles":"styles","application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops","application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":"comments","application/vnd.ms-excel.comments":"comments","application/vnd.ms-excel.threadedcomments+xml":"threadedcomments","application/vnd.ms-excel.person+xml":"people","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"metadata","application/vnd.ms-excel.sheetMetadata":"metadata","application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO","application/vnd.ms-office.chartcolorstyle+xml":"TODO","application/vnd.ms-office.chartstyle+xml":"TODO","application/vnd.ms-office.chartex+xml":"TODO","application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO","application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO","application/vnd.ms-excel.attachedToolbars":"TODO","application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO","application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links","application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO","application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO","application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO","application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO","application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO","application/vnd.ms-excel.wsSortMap":"TODO","application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO","application/vnd.openxmlformats-officedocument.theme+xml":"themes","application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO","application/vnd.ms-excel.Timeline+xml":"TODO","application/vnd.ms-excel.TimelineCache+xml":"TODO","application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"TODO","application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO","application/vnd.ms-excel.controlproperties+xml":"TODO","application/vnd.openxmlformats-officedocument.model+data":"TODO","application/vnd.ms-excel.Survey+xml":"TODO","application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO","application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO","image/png":"TODO","sheet":"js"};var CT_LIST={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},metadata:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",xlsb:"application/vnd.ms-excel.sheetMetadata"},styles:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};function new_ct(){return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],threadedcomments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],metadata:[],people:[],TODO:[],xmlns:""};}function parse_ct(data){var ct=new_ct();if(!data||!data.match)return ct;var ctext={};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0].replace(nsregex,"<")){case'<?xml':break;case'<Types':ct.xmlns=y['xmlns'+(y[0].match(/<(\w+):/)||["",""])[1]];break;case'<Default':ctext[y.Extension]=y.ContentType;break;case'<Override':if(ct[ct2type[y.ContentType]]!==undefined)ct[ct2type[y.ContentType]].push(y.PartName);break;}});if(ct.xmlns!==XMLNS.CT)throw new Error("Unknown Namespace: "+ct.xmlns);ct.calcchain=ct.calcchains.length>0?ct.calcchains[0]:"";ct.sst=ct.strs.length>0?ct.strs[0]:"";ct.style=ct.styles.length>0?ct.styles[0]:"";ct.defaults=ctext;delete ct.calcchains;return ct;}function write_ct(ct,opts){var type2ct=evert_arr(ct2type);var o=[],v;o[o.length]=XML_HEADER;o[o.length]=writextag('Types',null,{'xmlns':XMLNS.CT,'xmlns:xsd':XMLNS.xsd,'xmlns:xsi':XMLNS.xsi});o=o.concat([['xml','application/xml'],['bin','application/vnd.ms-excel.sheet.binary.macroEnabled.main'],['vml','application/vnd.openxmlformats-officedocument.vmlDrawing'],['data','application/vnd.openxmlformats-officedocument.model+data'],['bmp','image/bmp'],['png','image/png'],['gif','image/gif'],['emf','image/x-emf'],['wmf','image/x-wmf'],['jpg','image/jpeg'],['jpeg','image/jpeg'],['tif','image/tiff'],['tiff','image/tiff'],['pdf','application/pdf'],['rels','application/vnd.openxmlformats-package.relationships+xml']].map(function(x){return writextag('Default',null,{'Extension':x[0],'ContentType':x[1]});}));var f1=function f1(w){if(ct[w]&&ct[w].length>0){v=ct[w][0];o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':CT_LIST[w][opts.bookType]||CT_LIST[w]['xlsx']});}};var f2=function f2(w){(ct[w]||[]).forEach(function(v){o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':CT_LIST[w][opts.bookType]||CT_LIST[w]['xlsx']});});};var f3=function f3(t){(ct[t]||[]).forEach(function(v){o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':type2ct[t][0]});});};f1('workbooks');f2('sheets');f2('charts');f3('themes');['strs','styles'].forEach(f1);['coreprops','extprops','custprops'].forEach(f3);f3('vba');f3('comments');f3('threadedcomments');f3('drawings');f2('metadata');f3('people');if(o.length>2){o[o.length]='</Types>';o[1]=o[1].replace("/>",">");}return o.join("");}var RELS={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",XPATH:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",XMISS:"http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",XLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",CXML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",CXMLP:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",CMNT:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",CORE_PROPS:"http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",EXT_PROPS:'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',CUST_PROPS:'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',SST:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",STY:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",THEME:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",CHART:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",CHARTEX:"http://schemas.microsoft.com/office/2014/relationships/chartEx",CS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",WS:["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"],DS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",MS:"http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",IMG:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",DRAW:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",XLMETA:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",TCMNT:"http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",PEOPLE:"http://schemas.microsoft.com/office/2017/10/relationships/person",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};function get_rels_path(file){var n=file.lastIndexOf("/");return file.slice(0,n+1)+'_rels/'+file.slice(n+1)+".rels";}function parse_rels(data,currentFilePath){var rels={"!id":{}};if(!data)return rels;if(currentFilePath.charAt(0)!=='/'){currentFilePath='/'+currentFilePath;}var hash={};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);if(y[0]==='<Relationship'){var rel={};rel.Type=y.Type;rel.Target=y.Target;rel.Id=y.Id;if(y.TargetMode)rel.TargetMode=y.TargetMode;var canonictarget=y.TargetMode==='External'?y.Target:resolve_path(y.Target,currentFilePath);rels[canonictarget]=rel;hash[y.Id]=rel;}});rels["!id"]=hash;return rels;}function write_rels(rels){var o=[XML_HEADER,writextag('Relationships',null,{'xmlns':XMLNS.RELS})];keys(rels['!id']).forEach(function(rid){o[o.length]=writextag('Relationship',null,rels['!id'][rid]);});if(o.length>2){o[o.length]='</Relationships>';o[1]=o[1].replace("/>",">");}return o.join("");}function add_rels(rels,rId,f,type,relobj,targetmode){if(!relobj)relobj={};if(!rels['!id'])rels['!id']={};if(!rels['!idx'])rels['!idx']=1;if(rId<0)for(rId=rels['!idx'];rels['!id']['rId'+rId];++rId){}rels['!idx']=rId+1;relobj.Id='rId'+rId;relobj.Type=type;relobj.Target=f;if(targetmode)relobj.TargetMode=targetmode;else if([RELS.HLINK,RELS.XPATH,RELS.XMISS].indexOf(relobj.Type)>-1)relobj.TargetMode="External";if(rels['!id'][relobj.Id])throw new Error("Cannot rewrite rId "+rId);rels['!id'][relobj.Id]=relobj;rels[('/'+relobj.Target).replace("//","/")]=relobj;return rId;}var CT_ODS="application/vnd.oasis.opendocument.spreadsheet";function parse_manifest(d,opts){var str=xlml_normalize(d);var Rn;var FEtag;while(Rn=xlmlregex.exec(str)){switch(Rn[3]){case'manifest':break;case'file-entry':FEtag=parsexmltag(Rn[0],false);if(FEtag.path=='/'&&FEtag.type!==CT_ODS)throw new Error("This OpenDocument is not a spreadsheet");break;case'encryption-data':case'algorithm':case'start-key-generation':case'key-derivation':throw new Error("Unsupported ODS Encryption");default:if(opts&&opts.WTF)throw Rn;}}}function write_manifest(manifest){var o=[XML_HEADER];o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var i=0;i<manifest.length;++i){o.push('  <manifest:file-entry manifest:full-path="'+manifest[i][0]+'" manifest:media-type="'+manifest[i][1]+'"/>\n');}o.push('</manifest:manifest>');return o.join("");}function write_rdf_type(file,res,tag){return['  <rdf:Description rdf:about="'+file+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(tag||"odf")+'#'+res+'"/>\n','  </rdf:Description>\n'].join("");}function write_rdf_has(base,file){return['  <rdf:Description rdf:about="'+base+'">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+file+'"/>\n','  </rdf:Description>\n'].join("");}function write_rdf(rdf){var o=[XML_HEADER];o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var i=0;i!=rdf.length;++i){o.push(write_rdf_type(rdf[i][0],rdf[i][1]));o.push(write_rdf_has("",rdf[i][0]));}o.push(write_rdf_type("","Document","pkg"));o.push('</rdf:RDF>');return o.join("");}function write_meta_ods(){return'<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet'+'JS '+XLSX.version+'</meta:generator></office:meta></office:document-meta>';}var CORE_PROPS=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate",'date'],["dcterms:modified","ModifiedDate",'date']];var CORE_PROPS_REGEX=function(){var r=new Array(CORE_PROPS.length);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i];var g="(?:"+f[0].slice(0,f[0].indexOf(":"))+":)"+f[0].slice(f[0].indexOf(":")+1);r[i]=new RegExp("<"+g+"[^>]*>([\\s\\S]*?)<\/"+g+">");}return r;}();function parse_core_props(data){var p={};data=utf8read(data);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i],cur=data.match(CORE_PROPS_REGEX[i]);if(cur!=null&&cur.length>0)p[f[1]]=unescapexml(cur[1]);if(f[2]==='date'&&p[f[1]])p[f[1]]=parseDate(p[f[1]]);}return p;}function cp_doit(f,g,h,o,p){if(p[f]!=null||g==null||g==="")return;p[f]=g;g=escapexml(g);o[o.length]=h?writextag(f,g,h):writetag(f,g);}function write_core_props(cp,_opts){var opts=_opts||{};var o=[XML_HEADER,writextag('cp:coreProperties',null,{'xmlns:cp':XMLNS.CORE_PROPS,'xmlns:dc':XMLNS.dc,'xmlns:dcterms':XMLNS.dcterms,'xmlns:dcmitype':XMLNS.dcmitype,'xmlns:xsi':XMLNS.xsi})],p={};if(!cp&&!opts.Props)return o.join("");if(cp){if(cp.CreatedDate!=null)cp_doit("dcterms:created",typeof cp.CreatedDate==="string"?cp.CreatedDate:write_w3cdtf(cp.CreatedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);if(cp.ModifiedDate!=null)cp_doit("dcterms:modified",typeof cp.ModifiedDate==="string"?cp.ModifiedDate:write_w3cdtf(cp.ModifiedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);}for(var i=0;i!=CORE_PROPS.length;++i){var f=CORE_PROPS[i];var v=opts.Props&&opts.Props[f[1]]!=null?opts.Props[f[1]]:cp?cp[f[1]]:null;if(v===true)v="1";else if(v===false)v="0";else if(typeof v=="number")v=String(v);if(v!=null)cp_doit(f[0],v,null,o,p);}if(o.length>2){o[o.length]='</cp:coreProperties>';o[1]=o[1].replace("/>",">");}return o.join("");}var EXT_PROPS=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];var PseudoPropsPairs=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function load_props_pairs(HP,TOP,props,opts){var v=[];if(typeof HP=="string")v=parseVector(HP,opts);else for(var j=0;j<HP.length;++j){v=v.concat(HP[j].map(function(hp){return{v:hp};}));}var parts=typeof TOP=="string"?parseVector(TOP,opts).map(function(x){return x.v;}):TOP;var idx=0,len=0;if(parts.length>0)for(var i=0;i!==v.length;i+=2){len=+v[i+1].v;switch(v[i].v){case"Worksheets":case"工作表":case"Листы":case"أوراق العمل":case"ワークシート":case"גליונות עבודה":case"Arbeitsblätter":case"Çalışma Sayfaları":case"Feuilles de calcul":case"Fogli di lavoro":case"Folhas de cálculo":case"Planilhas":case"Regneark":case"Hojas de cálculo":case"Werkbladen":props.Worksheets=len;props.SheetNames=parts.slice(idx,idx+len);break;case"Named Ranges":case"Rangos con nombre":case"名前付き一覧":case"Benannte Bereiche":case"Navngivne områder":props.NamedRanges=len;props.DefinedNames=parts.slice(idx,idx+len);break;case"Charts":case"Diagramme":props.Chartsheets=len;props.ChartNames=parts.slice(idx,idx+len);break;}idx+=len;}}function parse_ext_props(data,p,opts){var q={};if(!p)p={};data=utf8read(data);EXT_PROPS.forEach(function(f){var xml=(data.match(matchtag(f[0]))||[])[1];switch(f[2]){case"string":if(xml)p[f[1]]=unescapexml(xml);break;case"bool":p[f[1]]=xml==="true";break;case"raw":var cur=data.match(new RegExp("<"+f[0]+"[^>]*>([\\s\\S]*?)<\/"+f[0]+">"));if(cur&&cur.length>0)q[f[1]]=cur[1];break;}});if(q.HeadingPairs&&q.TitlesOfParts)load_props_pairs(q.HeadingPairs,q.TitlesOfParts,p,opts);return p;}function write_ext_props(cp){var o=[],W=writextag;if(!cp)cp={};cp.Application="SheetJS";o[o.length]=XML_HEADER;o[o.length]=writextag('Properties',null,{'xmlns':XMLNS.EXT_PROPS,'xmlns:vt':XMLNS.vt});EXT_PROPS.forEach(function(f){if(cp[f[1]]===undefined)return;var v;switch(f[2]){case'string':v=escapexml(String(cp[f[1]]));break;case'bool':v=cp[f[1]]?'true':'false';break;}if(v!==undefined)o[o.length]=W(f[0],v);});o[o.length]=W('HeadingPairs',W('vt:vector',W('vt:variant','<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant',W('vt:i4',String(cp.Worksheets))),{size:2,baseType:"variant"}));o[o.length]=W('TitlesOfParts',W('vt:vector',cp.SheetNames.map(function(s){return"<vt:lpstr>"+escapexml(s)+"</vt:lpstr>";}).join(""),{size:cp.Worksheets,baseType:"lpstr"}));if(o.length>2){o[o.length]='</Properties>';o[1]=o[1].replace("/>",">");}return o.join("");}var custregex=/<[^>]+>[^<]*/g;function parse_cust_props(data,opts){var p={},name="";var m=data.match(custregex);if(m)for(var i=0;i!=m.length;++i){var x=m[i],y=parsexmltag(x);switch(y[0]){case'<?xml':break;case'<Properties':break;case'<property':name=unescapexml(y.name);break;case'</property>':name=null;break;default:if(x.indexOf('<vt:')===0){var toks=x.split('>');var type=toks[0].slice(4),text=toks[1];switch(type){case'lpstr':case'bstr':case'lpwstr':p[name]=unescapexml(text);break;case'bool':p[name]=parsexmlbool(text);break;case'i1':case'i2':case'i4':case'i8':case'int':case'uint':p[name]=parseInt(text,10);break;case'r4':case'r8':case'decimal':p[name]=parseFloat(text);break;case'filetime':case'date':p[name]=parseDate(text);break;case'cy':case'error':p[name]=unescapexml(text);break;default:if(type.slice(-1)=='/')break;if(opts.WTF&&typeof console!=='undefined')console.warn('Unexpected',x,type,toks);}}else if(x.slice(0,2)==="</"){}else if(opts.WTF)throw new Error(x);}}return p;}function write_cust_props(cp){var o=[XML_HEADER,writextag('Properties',null,{'xmlns':XMLNS.CUST_PROPS,'xmlns:vt':XMLNS.vt})];if(!cp)return o.join("");var pid=1;keys(cp).forEach(function custprop(k){++pid;o[o.length]=writextag('property',write_vt(cp[k],true),{'fmtid':'{D5CDD505-2E9C-101B-9397-08002B2CF9AE}','pid':pid,'name':escapexml(k)});});if(o.length>2){o[o.length]='</Properties>';o[1]=o[1].replace("/>",">");}return o.join("");}var XLMLDocPropsMap={Title:'Title',Subject:'Subject',Author:'Author',Keywords:'Keywords',Comments:'Description',LastAuthor:'LastAuthor',RevNumber:'Revision',Application:'AppName',LastPrinted:'LastPrinted',CreatedDate:'Created',ModifiedDate:'LastSaved',Category:'Category',Manager:'Manager',Company:'Company',AppVersion:'Version',ContentStatus:'ContentStatus',Identifier:'Identifier',Language:'Language'};var evert_XLMLDPM;function xlml_set_prop(Props,tag,val){if(!evert_XLMLDPM)evert_XLMLDPM=evert(XLMLDocPropsMap);tag=evert_XLMLDPM[tag]||tag;Props[tag]=val;}function xlml_write_docprops(Props,opts){var o=[];keys(XLMLDocPropsMap).map(function(m){for(var i=0;i<CORE_PROPS.length;++i){if(CORE_PROPS[i][1]==m)return CORE_PROPS[i];}for(i=0;i<EXT_PROPS.length;++i){if(EXT_PROPS[i][1]==m)return EXT_PROPS[i];}throw m;}).forEach(function(p){if(Props[p[1]]==null)return;var m=opts&&opts.Props&&opts.Props[p[1]]!=null?opts.Props[p[1]]:Props[p[1]];switch(p[2]){case'date':m=new Date(m).toISOString().replace(/\.\d*Z/,"Z");break;}if(typeof m=='number')m=String(m);else if(m===true||m===false){m=m?"1":"0";}else if(m instanceof Date)m=new Date(m).toISOString().replace(/\.\d*Z/,"");o.push(writetag(XLMLDocPropsMap[p[1]]||p[1],m));});return writextag('DocumentProperties',o.join(""),{xmlns:XLMLNS.o});}function xlml_write_custprops(Props,Custprops){var BLACKLIST=["Worksheets","SheetNames"];var T='CustomDocumentProperties';var o=[];if(Props)keys(Props).forEach(function(k){if(!Object.prototype.hasOwnProperty.call(Props,k))return;for(var i=0;i<CORE_PROPS.length;++i){if(k==CORE_PROPS[i][1])return;}for(i=0;i<EXT_PROPS.length;++i){if(k==EXT_PROPS[i][1])return;}for(i=0;i<BLACKLIST.length;++i){if(k==BLACKLIST[i])return;}var m=Props[k];var t="string";if(typeof m=='number'){t="float";m=String(m);}else if(m===true||m===false){t="boolean";m=m?"1":"0";}else m=String(m);o.push(writextag(escapexmltag(k),m,{"dt:dt":t}));});if(Custprops)keys(Custprops).forEach(function(k){if(!Object.prototype.hasOwnProperty.call(Custprops,k))return;if(Props&&Object.prototype.hasOwnProperty.call(Props,k))return;var m=Custprops[k];var t="string";if(typeof m=='number'){t="float";m=String(m);}else if(m===true||m===false){t="boolean";m=m?"1":"0";}else if(m instanceof Date){t="dateTime.tz";m=m.toISOString();}else m=String(m);o.push(writextag(escapexmltag(k),m,{"dt:dt":t}));});return'<'+T+' xmlns="'+XLMLNS.o+'">'+o.join("")+'</'+T+'>';}function parse_FILETIME(blob){var dwLowDateTime=blob.read_shift(4),dwHighDateTime=blob.read_shift(4);return new Date((dwHighDateTime/1e7*Math.pow(2,32)+dwLowDateTime/1e7-11644473600)*1000).toISOString().replace(/\.000/,"");}function write_FILETIME(time){var date=typeof time=="string"?new Date(Date.parse(time)):time;var t=date.getTime()/1000+11644473600;var l=t%Math.pow(2,32),h=(t-l)/Math.pow(2,32);l*=1e7;h*=1e7;var w=l/Math.pow(2,32)|0;if(w>0){l=l%Math.pow(2,32);h+=w;}var o=new_buf(8);o.write_shift(4,l);o.write_shift(4,h);return o;}function parse_lpstr(blob,type,pad){var start=blob.l;var str=blob.read_shift(0,'lpstr-cp');if(pad)while(blob.l-start&3){++blob.l;}return str;}function parse_lpwstr(blob,type,pad){var str=blob.read_shift(0,'lpwstr');if(pad)blob.l+=4-(str.length+1&3)&3;return str;}function parse_VtStringBase(blob,stringType,pad){if(stringType===0x1F)return parse_lpwstr(blob);return parse_lpstr(blob,stringType,pad);}function parse_VtString(blob,t,pad){return parse_VtStringBase(blob,t,pad===false?0:4);}function parse_VtUnalignedString(blob,t){if(!t)throw new Error("VtUnalignedString must have positive length");return parse_VtStringBase(blob,t,0);}function parse_VtVecLpwstrValue(blob){var length=blob.read_shift(4);var ret=[];for(var i=0;i!=length;++i){var start=blob.l;ret[i]=blob.read_shift(0,'lpwstr').replace(chr0,'');if(blob.l-start&0x02)blob.l+=2;}return ret;}function parse_VtVecUnalignedLpstrValue(blob){var length=blob.read_shift(4);var ret=[];for(var i=0;i!=length;++i){ret[i]=blob.read_shift(0,'lpstr-cp').replace(chr0,'');}return ret;}function parse_VtHeadingPair(blob){var start=blob.l;var headingString=parse_TypedPropertyValue(blob,VT_USTR);if(blob[blob.l]==0x00&&blob[blob.l+1]==0x00&&blob.l-start&0x02)blob.l+=2;var headerParts=parse_TypedPropertyValue(blob,VT_I4);return[headingString,headerParts];}function parse_VtVecHeadingPairValue(blob){var cElements=blob.read_shift(4);var out=[];for(var i=0;i<cElements/2;++i){out.push(parse_VtHeadingPair(blob));}return out;}function parse_dictionary(blob,CodePage){var cnt=blob.read_shift(4);var dict={};for(var j=0;j!=cnt;++j){var pid=blob.read_shift(4);var len=blob.read_shift(4);dict[pid]=blob.read_shift(len,CodePage===0x4B0?'utf16le':'utf8').replace(chr0,'').replace(chr1,'!');if(CodePage===0x4B0&&len%2)blob.l+=2;}if(blob.l&3)blob.l=blob.l>>2+1<<2;return dict;}function parse_BLOB(blob){var size=blob.read_shift(4);var bytes=blob.slice(blob.l,blob.l+size);blob.l+=size;if((size&3)>0)blob.l+=4-(size&3)&3;return bytes;}function parse_ClipboardData(blob){var o={};o.Size=blob.read_shift(4);blob.l+=o.Size+3-(o.Size-1)%4;return o;}function parse_TypedPropertyValue(blob,type,_opts){var t=blob.read_shift(2),ret,opts=_opts||{};blob.l+=2;if(type!==VT_VARIANT)if(t!==type&&VT_CUSTOM.indexOf(type)===-1&&!((type&0xFFFE)==0x101E&&(t&0xFFFE)==0x101E))throw new Error('Expected type '+type+' saw '+t);switch(type===VT_VARIANT?t:type){case 0x02:ret=blob.read_shift(2,'i');if(!opts.raw)blob.l+=2;return ret;case 0x03:ret=blob.read_shift(4,'i');return ret;case 0x0B:return blob.read_shift(4)!==0x0;case 0x13:ret=blob.read_shift(4);return ret;case 0x1E:return parse_lpstr(blob,t,4).replace(chr0,'');case 0x1F:return parse_lpwstr(blob);case 0x40:return parse_FILETIME(blob);case 0x41:return parse_BLOB(blob);case 0x47:return parse_ClipboardData(blob);case 0x50:return parse_VtString(blob,t,!opts.raw).replace(chr0,'');case 0x51:return parse_VtUnalignedString(blob,t).replace(chr0,'');case 0x100C:return parse_VtVecHeadingPairValue(blob);case 0x101E:case 0x101F:return t==0x101F?parse_VtVecLpwstrValue(blob):parse_VtVecUnalignedLpstrValue(blob);default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+t);}}function write_TypedPropertyValue(type,value){var o=new_buf(4),p=new_buf(4);o.write_shift(4,type==0x50?0x1F:type);switch(type){case 0x03:p.write_shift(-4,value);break;case 0x05:p=new_buf(8);p.write_shift(8,value,'f');break;case 0x0B:p.write_shift(4,value?0x01:0x00);break;case 0x40:p=write_FILETIME(value);break;case 0x1F:case 0x50:p=new_buf(4+2*(value.length+1)+(value.length%2?0:2));p.write_shift(4,value.length+1);p.write_shift(0,value,"dbcs");while(p.l!=p.length){p.write_shift(1,0);}break;default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+value);}return bconcat([o,p]);}function parse_PropertySet(blob,PIDSI){var start_addr=blob.l;var size=blob.read_shift(4);var NumProps=blob.read_shift(4);var Props=[],i=0;var CodePage=0;var Dictionary=-1,DictObj={};for(i=0;i!=NumProps;++i){var PropID=blob.read_shift(4);var Offset=blob.read_shift(4);Props[i]=[PropID,Offset+start_addr];}Props.sort(function(x,y){return x[1]-y[1];});var PropH={};for(i=0;i!=NumProps;++i){if(blob.l!==Props[i][1]){var fail=true;if(i>0&&PIDSI)switch(PIDSI[Props[i-1][0]].t){case 0x02:if(blob.l+2===Props[i][1]){blob.l+=2;fail=false;}break;case 0x50:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false;}break;case 0x100C:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false;}break;}if((!PIDSI||i==0)&&blob.l<=Props[i][1]){fail=false;blob.l=Props[i][1];}if(fail)throw new Error("Read Error: Expected address "+Props[i][1]+' at '+blob.l+' :'+i);}if(PIDSI){var piddsi=PIDSI[Props[i][0]];PropH[piddsi.n]=parse_TypedPropertyValue(blob,piddsi.t,{raw:true});if(piddsi.p==='version')PropH[piddsi.n]=String(PropH[piddsi.n]>>16)+"."+("0000"+String(PropH[piddsi.n]&0xFFFF)).slice(-4);if(piddsi.n=="CodePage")switch(PropH[piddsi.n]){case 0:PropH[piddsi.n]=1252;case 874:case 932:case 936:case 949:case 950:case 1250:case 1251:case 1253:case 1254:case 1255:case 1256:case 1257:case 1258:case 10000:case 1200:case 1201:case 1252:case 65000:case-536:case 65001:case-535:set_cp(CodePage=PropH[piddsi.n]>>>0&0xFFFF);break;default:throw new Error("Unsupported CodePage: "+PropH[piddsi.n]);}}else{if(Props[i][0]===0x1){CodePage=PropH.CodePage=parse_TypedPropertyValue(blob,VT_I2);set_cp(CodePage);if(Dictionary!==-1){var oldpos=blob.l;blob.l=Props[Dictionary][1];DictObj=parse_dictionary(blob,CodePage);blob.l=oldpos;}}else if(Props[i][0]===0){if(CodePage===0){Dictionary=i;blob.l=Props[i+1][1];continue;}DictObj=parse_dictionary(blob,CodePage);}else{var name=DictObj[Props[i][0]];var val;switch(blob[blob.l]){case 0x41:blob.l+=4;val=parse_BLOB(blob);break;case 0x1E:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]).replace(/\u0000+$/,"");break;case 0x1F:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]).replace(/\u0000+$/,"");break;case 0x03:blob.l+=4;val=blob.read_shift(4,'i');break;case 0x13:blob.l+=4;val=blob.read_shift(4);break;case 0x05:blob.l+=4;val=blob.read_shift(8,'f');break;case 0x0B:blob.l+=4;val=parsebool(blob,4);break;case 0x40:blob.l+=4;val=parseDate(parse_FILETIME(blob));break;default:throw new Error("unparsed value: "+blob[blob.l]);}PropH[name]=val;}}}blob.l=start_addr+size;return PropH;}var XLSPSSkip=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"];function guess_property_type(val){switch(typeof val==="undefined"?"undefined":(0,_typeof3.default)(val)){case"boolean":return 0x0B;case"number":return(val|0)==val?0x03:0x05;case"string":return 0x1F;case"object":if(val instanceof Date)return 0x40;break;}return-1;}function write_PropertySet(entries,RE,PIDSI){var hdr=new_buf(8),piao=[],prop=[];var sz=8,i=0;var pr=new_buf(8),pio=new_buf(8);pr.write_shift(4,0x0002);pr.write_shift(4,0x04B0);pio.write_shift(4,0x0001);prop.push(pr);piao.push(pio);sz+=8+pr.length;if(!RE){pio=new_buf(8);pio.write_shift(4,0);piao.unshift(pio);var bufs=[new_buf(4)];bufs[0].write_shift(4,entries.length);for(i=0;i<entries.length;++i){var value=entries[i][0];pr=new_buf(4+4+2*(value.length+1)+(value.length%2?0:2));pr.write_shift(4,i+2);pr.write_shift(4,value.length+1);pr.write_shift(0,value,"dbcs");while(pr.l!=pr.length){pr.write_shift(1,0);}bufs.push(pr);}pr=bconcat(bufs);prop.unshift(pr);sz+=8+pr.length;}for(i=0;i<entries.length;++i){if(RE&&!RE[entries[i][0]])continue;if(XLSPSSkip.indexOf(entries[i][0])>-1||PseudoPropsPairs.indexOf(entries[i][0])>-1)continue;if(entries[i][1]==null)continue;var val=entries[i][1],idx=0;if(RE){idx=+RE[entries[i][0]];var pinfo=PIDSI[idx];if(pinfo.p=="version"&&typeof val=="string"){var arr=val.split(".");val=(+arr[0]<<16)+(+arr[1]||0);}pr=write_TypedPropertyValue(pinfo.t,val);}else{var T=guess_property_type(val);if(T==-1){T=0x1F;val=String(val);}pr=write_TypedPropertyValue(T,val);}prop.push(pr);pio=new_buf(8);pio.write_shift(4,!RE?2+i:idx);piao.push(pio);sz+=8+pr.length;}var w=8*(prop.length+1);for(i=0;i<prop.length;++i){piao[i].write_shift(4,w);w+=prop[i].length;}hdr.write_shift(4,sz);hdr.write_shift(4,prop.length);return bconcat([hdr].concat(piao).concat(prop));}function parse_PropertySetStream(file,PIDSI,clsid){var blob=file.content;if(!blob)return{};prep_blob(blob,0);var NumSets,FMTID0,FMTID1,Offset0,Offset1=0;blob.chk('feff','Byte Order: ');blob.read_shift(2);var SystemIdentifier=blob.read_shift(4);var CLSID=blob.read_shift(16);if(CLSID!==CFB.utils.consts.HEADER_CLSID&&CLSID!==clsid)throw new Error("Bad PropertySet CLSID "+CLSID);NumSets=blob.read_shift(4);if(NumSets!==1&&NumSets!==2)throw new Error("Unrecognized #Sets: "+NumSets);FMTID0=blob.read_shift(16);Offset0=blob.read_shift(4);if(NumSets===1&&Offset0!==blob.l)throw new Error("Length mismatch: "+Offset0+" !== "+blob.l);else if(NumSets===2){FMTID1=blob.read_shift(16);Offset1=blob.read_shift(4);}var PSet0=parse_PropertySet(blob,PIDSI);var rval={SystemIdentifier:SystemIdentifier};for(var y in PSet0){rval[y]=PSet0[y];}rval.FMTID=FMTID0;if(NumSets===1)return rval;if(Offset1-blob.l==2)blob.l+=2;if(blob.l!==Offset1)throw new Error("Length mismatch 2: "+blob.l+" !== "+Offset1);var PSet1;try{PSet1=parse_PropertySet(blob,null);}catch(e){}for(y in PSet1){rval[y]=PSet1[y];}rval.FMTID=[FMTID0,FMTID1];return rval;}function write_PropertySetStream(entries,clsid,RE,PIDSI,entries2,clsid2){var hdr=new_buf(entries2?68:48);var bufs=[hdr];hdr.write_shift(2,0xFFFE);hdr.write_shift(2,0x0000);hdr.write_shift(4,0x32363237);hdr.write_shift(16,CFB.utils.consts.HEADER_CLSID,"hex");hdr.write_shift(4,entries2?2:1);hdr.write_shift(16,clsid,"hex");hdr.write_shift(4,entries2?68:48);var ps0=write_PropertySet(entries,RE,PIDSI);bufs.push(ps0);if(entries2){var ps1=write_PropertySet(entries2,null,null);hdr.write_shift(16,clsid2,"hex");hdr.write_shift(4,68+ps0.length);bufs.push(ps1);}return bconcat(bufs);}function parsenoop2(blob,length){blob.read_shift(length);return null;}function writezeroes(n,o){if(!o)o=new_buf(n);for(var j=0;j<n;++j){o.write_shift(1,0);}return o;}function parslurp(blob,length,cb){var arr=[],target=blob.l+length;while(blob.l<target){arr.push(cb(blob,target-blob.l));}if(target!==blob.l)throw new Error("Slurp error");return arr;}function parsebool(blob,length){return blob.read_shift(length)===0x1;}function writebool(v,o){if(!o)o=new_buf(2);o.write_shift(2,+!!v);return o;}function parseuint16(blob){return blob.read_shift(2,'u');}function writeuint16(v,o){if(!o)o=new_buf(2);o.write_shift(2,v);return o;}function parseuint16a(blob,length){return parslurp(blob,length,parseuint16);}function parse_Bes(blob){var v=blob.read_shift(1),t=blob.read_shift(1);return t===0x01?v:v===0x01;}function write_Bes(v,t,o){if(!o)o=new_buf(2);o.write_shift(1,t=='e'?+v:+!!v);o.write_shift(1,t=='e'?1:0);return o;}function parse_ShortXLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts&&opts.biff>=12?2:1);var encoding='sbcs-cont';var cp=current_codepage;if(opts&&opts.biff>=8)current_codepage=1200;if(!opts||opts.biff==8){var fHighByte=blob.read_shift(1);if(fHighByte){encoding='dbcs-cont';}}else if(opts.biff==12){encoding='wstr';}if(opts.biff>=2&&opts.biff<=5)encoding='cpstr';var o=cch?blob.read_shift(cch,encoding):"";current_codepage=cp;return o;}function parse_XLUnicodeRichExtendedString(blob){var cp=current_codepage;current_codepage=1200;var cch=blob.read_shift(2),flags=blob.read_shift(1);var fExtSt=flags&0x4,fRichSt=flags&0x8;var width=1+(flags&0x1);var cRun=0,cbExtRst;var z={};if(fRichSt)cRun=blob.read_shift(2);if(fExtSt)cbExtRst=blob.read_shift(4);var encoding=width==2?'dbcs-cont':'sbcs-cont';var msg=cch===0?"":blob.read_shift(cch,encoding);if(fRichSt)blob.l+=4*cRun;if(fExtSt)blob.l+=cbExtRst;z.t=msg;if(!fRichSt){z.raw="<t>"+z.t+"</t>";z.r=z.t;}current_codepage=cp;return z;}function write_XLUnicodeRichExtendedString(xlstr){var str=xlstr.t||"",nfmts=1;var hdr=new_buf(3+(nfmts>1?2:0));hdr.write_shift(2,str.length);hdr.write_shift(1,(nfmts>1?0x08:0x00)|0x01);if(nfmts>1)hdr.write_shift(2,nfmts);var otext=new_buf(2*str.length);otext.write_shift(2*str.length,str,'utf16le');var out=[hdr,otext];return bconcat(out);}function parse_XLUnicodeStringNoCch(blob,cch,opts){var retval;if(opts){if(opts.biff>=2&&opts.biff<=5)return blob.read_shift(cch,'cpstr');if(opts.biff>=12)return blob.read_shift(cch,'dbcs-cont');}var fHighByte=blob.read_shift(1);if(fHighByte===0){retval=blob.read_shift(cch,'sbcs-cont');}else{retval=blob.read_shift(cch,'dbcs-cont');}return retval;}function parse_XLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts&&opts.biff==2?1:2);if(cch===0){blob.l++;return"";}return parse_XLUnicodeStringNoCch(blob,cch,opts);}function parse_XLUnicodeString2(blob,length,opts){if(opts.biff>5)return parse_XLUnicodeString(blob,length,opts);var cch=blob.read_shift(1);if(cch===0){blob.l++;return"";}return blob.read_shift(cch,opts.biff<=4||!blob.lens?'cpstr':'sbcs-cont');}function write_XLUnicodeString(str,opts,o){if(!o)o=new_buf(3+2*str.length);o.write_shift(2,str.length);o.write_shift(1,1);o.write_shift(31,str,'utf16le');return o;}function parse_ControlInfo(blob){var flags=blob.read_shift(1);blob.l++;var accel=blob.read_shift(2);blob.l+=2;return[flags,accel];}function parse_URLMoniker(blob){var len=blob.read_shift(4),start=blob.l;var extra=false;if(len>24){blob.l+=len-24;if(blob.read_shift(16)==="795881f43b1d7f48af2c825dc4852763")extra=true;blob.l=start;}var url=blob.read_shift((extra?len-24:len)>>1,'utf16le').replace(chr0,"");if(extra)blob.l+=24;return url;}function parse_FileMoniker(blob){var cAnti=blob.read_shift(2);var preamble="";while(cAnti-->0){preamble+="../";}var ansiPath=blob.read_shift(0,'lpstr-ansi');blob.l+=2;if(blob.read_shift(2)!=0xDEAD)throw new Error("Bad FileMoniker");var sz=blob.read_shift(4);if(sz===0)return preamble+ansiPath.replace(/\\/g,"/");var bytes=blob.read_shift(4);if(blob.read_shift(2)!=3)throw new Error("Bad FileMoniker");var unicodePath=blob.read_shift(bytes>>1,'utf16le').replace(chr0,"");return preamble+unicodePath;}function parse_HyperlinkMoniker(blob,length){var clsid=blob.read_shift(16);length-=16;switch(clsid){case"e0c9ea79f9bace118c8200aa004ba90b":return parse_URLMoniker(blob,length);case"0303000000000000c000000000000046":return parse_FileMoniker(blob,length);default:throw new Error("Unsupported Moniker "+clsid);}}function parse_HyperlinkString(blob){var len=blob.read_shift(4);var o=len>0?blob.read_shift(len,'utf16le').replace(chr0,""):"";return o;}function write_HyperlinkString(str,o){if(!o)o=new_buf(6+str.length*2);o.write_shift(4,1+str.length);for(var i=0;i<str.length;++i){o.write_shift(2,str.charCodeAt(i));}o.write_shift(2,0);return o;}function parse_Hyperlink(blob,length){var end=blob.l+length;var sVer=blob.read_shift(4);if(sVer!==2)throw new Error("Unrecognized streamVersion: "+sVer);var flags=blob.read_shift(2);blob.l+=2;var displayName,targetFrameName,moniker,oleMoniker,Loc="",guid,fileTime;if(flags&0x0010)displayName=parse_HyperlinkString(blob,end-blob.l);if(flags&0x0080)targetFrameName=parse_HyperlinkString(blob,end-blob.l);if((flags&0x0101)===0x0101)moniker=parse_HyperlinkString(blob,end-blob.l);if((flags&0x0101)===0x0001)oleMoniker=parse_HyperlinkMoniker(blob,end-blob.l);if(flags&0x0008)Loc=parse_HyperlinkString(blob,end-blob.l);if(flags&0x0020)guid=blob.read_shift(16);if(flags&0x0040)fileTime=parse_FILETIME(blob);blob.l=end;var target=targetFrameName||moniker||oleMoniker||"";if(target&&Loc)target+="#"+Loc;if(!target)target="#"+Loc;if(flags&0x0002&&target.charAt(0)=="/"&&target.charAt(1)!="/")target="file://"+target;var out={Target:target};if(guid)out.guid=guid;if(fileTime)out.time=fileTime;if(displayName)out.Tooltip=displayName;return out;}function write_Hyperlink(hl){var out=new_buf(512),i=0;var Target=hl.Target;if(Target.slice(0,7)=="file://")Target=Target.slice(7);var hashidx=Target.indexOf("#");var F=hashidx>-1?0x1f:0x17;switch(Target.charAt(0)){case"#":F=0x1c;break;case".":F&=~2;break;}out.write_shift(4,2);out.write_shift(4,F);var data=[8,6815827,6619237,4849780,83];for(i=0;i<data.length;++i){out.write_shift(4,data[i]);}if(F==0x1C){Target=Target.slice(1);write_HyperlinkString(Target,out);}else if(F&0x02){data="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(i=0;i<data.length;++i){out.write_shift(1,parseInt(data[i],16));}var Pretarget=hashidx>-1?Target.slice(0,hashidx):Target;out.write_shift(4,2*(Pretarget.length+1));for(i=0;i<Pretarget.length;++i){out.write_shift(2,Pretarget.charCodeAt(i));}out.write_shift(2,0);if(F&0x08)write_HyperlinkString(hashidx>-1?Target.slice(hashidx+1):"",out);}else{data="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");for(i=0;i<data.length;++i){out.write_shift(1,parseInt(data[i],16));}var P=0;while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\"){++P;}out.write_shift(2,P);out.write_shift(4,Target.length-3*P+1);for(i=0;i<Target.length-3*P;++i){out.write_shift(1,Target.charCodeAt(i+3*P)&0xFF);}out.write_shift(1,0);out.write_shift(2,0xFFFF);out.write_shift(2,0xDEAD);for(i=0;i<6;++i){out.write_shift(4,0);}}return out.slice(0,out.l);}function parse_LongRGBA(blob){var r=blob.read_shift(1),g=blob.read_shift(1),b=blob.read_shift(1),a=blob.read_shift(1);return[r,g,b,a];}function parse_LongRGB(blob,length){var x=parse_LongRGBA(blob,length);x[3]=0;return x;}function parse_XLSCell(blob){var rw=blob.read_shift(2);var col=blob.read_shift(2);var ixfe=blob.read_shift(2);return{r:rw,c:col,ixfe:ixfe};}function write_XLSCell(R,C,ixfe,o){if(!o)o=new_buf(6);o.write_shift(2,R);o.write_shift(2,C);o.write_shift(2,ixfe||0);return o;}function parse_frtHeader(blob){var rt=blob.read_shift(2);var flags=blob.read_shift(2);blob.l+=8;return{type:rt,flags:flags};}function parse_OptXLUnicodeString(blob,length,opts){return length===0?"":parse_XLUnicodeString2(blob,length,opts);}function parse_XTI(blob,length,opts){var w=opts.biff>8?4:2;var iSupBook=blob.read_shift(w),itabFirst=blob.read_shift(w,'i'),itabLast=blob.read_shift(w,'i');return[iSupBook,itabFirst,itabLast];}function parse_RkRec(blob){var ixfe=blob.read_shift(2);var RK=parse_RkNumber(blob);return[ixfe,RK];}function parse_AddinUdf(blob,length,opts){blob.l+=4;length-=4;var l=blob.l+length;var udfName=parse_ShortXLUnicodeString(blob,length,opts);var cb=blob.read_shift(2);l-=blob.l;if(cb!==l)throw new Error("Malformed AddinUdf: padding = "+l+" != "+cb);blob.l+=cb;return udfName;}function parse_Ref8U(blob){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(2);var colLast=blob.read_shift(2);return{s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}};}function write_Ref8U(r,o){if(!o)o=new_buf(8);o.write_shift(2,r.s.r);o.write_shift(2,r.e.r);o.write_shift(2,r.s.c);o.write_shift(2,r.e.c);return o;}function parse_RefU(blob){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(1);var colLast=blob.read_shift(1);return{s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}};}var parse_Ref=parse_RefU;function parse_FtCmo(blob){blob.l+=4;var ot=blob.read_shift(2);var id=blob.read_shift(2);var flags=blob.read_shift(2);blob.l+=12;return[id,ot,flags];}function parse_FtNts(blob){var out={};blob.l+=4;blob.l+=16;out.fSharedNote=blob.read_shift(2);blob.l+=4;return out;}function parse_FtCf(blob){var out={};blob.l+=4;blob.cf=blob.read_shift(2);return out;}function parse_FtSkip(blob){blob.l+=2;blob.l+=blob.read_shift(2);}var FtTab={0x00:parse_FtSkip,0x04:parse_FtSkip,0x05:parse_FtSkip,0x06:parse_FtSkip,0x07:parse_FtCf,0x08:parse_FtSkip,0x09:parse_FtSkip,0x0A:parse_FtSkip,0x0B:parse_FtSkip,0x0C:parse_FtSkip,0x0D:parse_FtNts,0x0E:parse_FtSkip,0x0F:parse_FtSkip,0x10:parse_FtSkip,0x11:parse_FtSkip,0x12:parse_FtSkip,0x13:parse_FtSkip,0x14:parse_FtSkip,0x15:parse_FtCmo};function parse_FtArray(blob,length){var tgt=blob.l+length;var fts=[];while(blob.l<tgt){var ft=blob.read_shift(2);blob.l-=2;try{fts.push(FtTab[ft](blob,tgt-blob.l));}catch(e){blob.l=tgt;return fts;}}if(blob.l!=tgt)blob.l=tgt;return fts;}function parse_BOF(blob,length){var o={BIFFVer:0,dt:0};o.BIFFVer=blob.read_shift(2);length-=2;if(length>=2){o.dt=blob.read_shift(2);blob.l-=2;}switch(o.BIFFVer){case 0x0600:case 0x0500:case 0x0400:case 0x0300:case 0x0200:case 0x0002:case 0x0007:break;default:if(length>6)throw new Error("Unexpected BIFF Ver "+o.BIFFVer);}blob.read_shift(length);return o;}function write_BOF(wb,t,o){var h=0x0600,w=16;switch(o.bookType){case'biff8':break;case'biff5':h=0x0500;w=8;break;case'biff4':h=0x0004;w=6;break;case'biff3':h=0x0003;w=6;break;case'biff2':h=0x0002;w=4;break;case'xla':break;default:throw new Error("unsupported BIFF version");}var out=new_buf(w);out.write_shift(2,h);out.write_shift(2,t);if(w>4)out.write_shift(2,0x7262);if(w>6)out.write_shift(2,0x07CD);if(w>8){out.write_shift(2,0xC009);out.write_shift(2,0x0001);out.write_shift(2,0x0706);out.write_shift(2,0x0000);}return out;}function parse_InterfaceHdr(blob,length){if(length===0)return 0x04b0;if(blob.read_shift(2)!==0x04b0){}return 0x04b0;}function parse_WriteAccess(blob,length,opts){if(opts.enc){blob.l+=length;return"";}var l=blob.l;var UserName=parse_XLUnicodeString2(blob,0,opts);blob.read_shift(length+l-blob.l);return UserName;}function write_WriteAccess(s,opts){var b8=!opts||opts.biff==8;var o=new_buf(b8?112:54);o.write_shift(opts.biff==8?2:1,7);if(b8)o.write_shift(1,0);o.write_shift(4,0x33336853);o.write_shift(4,0x00534A74|(b8?0:0x20000000));while(o.l<o.length){o.write_shift(1,b8?0:32);}return o;}function parse_WsBool(blob,length,opts){var flags=opts&&opts.biff==8||length==2?blob.read_shift(2):(blob.l+=length,0);return{fDialog:flags&0x10,fBelow:flags&0x40,fRight:flags&0x80};}function parse_BoundSheet8(blob,length,opts){var pos=blob.read_shift(4);var hidden=blob.read_shift(1)&0x03;var dt=blob.read_shift(1);switch(dt){case 0:dt='Worksheet';break;case 1:dt='Macrosheet';break;case 2:dt='Chartsheet';break;case 6:dt='VBAModule';break;}var name=parse_ShortXLUnicodeString(blob,0,opts);if(name.length===0)name="Sheet1";return{pos:pos,hs:hidden,dt:dt,name:name};}function write_BoundSheet8(data,opts){var w=!opts||opts.biff>=8?2:1;var o=new_buf(8+w*data.name.length);o.write_shift(4,data.pos);o.write_shift(1,data.hs||0);o.write_shift(1,data.dt);o.write_shift(1,data.name.length);if(opts.biff>=8)o.write_shift(1,1);o.write_shift(w*data.name.length,data.name,opts.biff<8?'sbcs':'utf16le');var out=o.slice(0,o.l);out.l=o.l;return out;}function parse_SST(blob,length){var end=blob.l+length;var cnt=blob.read_shift(4);var ucnt=blob.read_shift(4);var strs=[];for(var i=0;i!=ucnt&&blob.l<end;++i){strs.push(parse_XLUnicodeRichExtendedString(blob));}strs.Count=cnt;strs.Unique=ucnt;return strs;}function write_SST(sst,opts){var header=new_buf(8);header.write_shift(4,sst.Count);header.write_shift(4,sst.Unique);var strs=[];for(var j=0;j<sst.length;++j){strs[j]=write_XLUnicodeRichExtendedString(sst[j],opts);}var o=bconcat([header].concat(strs));o.parts=[header.length].concat(strs.map(function(str){return str.length;}));return o;}function parse_ExtSST(blob,length){var extsst={};extsst.dsst=blob.read_shift(2);blob.l+=length-2;return extsst;}function parse_Row(blob){var z={};z.r=blob.read_shift(2);z.c=blob.read_shift(2);z.cnt=blob.read_shift(2)-z.c;var miyRw=blob.read_shift(2);blob.l+=4;var flags=blob.read_shift(1);blob.l+=3;if(flags&0x07)z.level=flags&0x07;if(flags&0x20)z.hidden=true;if(flags&0x40)z.hpt=miyRw/20;return z;}function parse_ForceFullCalculation(blob){var header=parse_frtHeader(blob);if(header.type!=0x08A3)throw new Error("Invalid Future Record "+header.type);var fullcalc=blob.read_shift(4);return fullcalc!==0x0;}function parse_RecalcId(blob){blob.read_shift(2);return blob.read_shift(4);}function parse_DefaultRowHeight(blob,length,opts){var f=0;if(!(opts&&opts.biff==2)){f=blob.read_shift(2);}var miyRw=blob.read_shift(2);if(opts&&opts.biff==2){f=1-(miyRw>>15);miyRw&=0x7fff;}var fl={Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};return[fl,miyRw];}function parse_Window1(blob){var xWn=blob.read_shift(2),yWn=blob.read_shift(2),dxWn=blob.read_shift(2),dyWn=blob.read_shift(2);var flags=blob.read_shift(2),iTabCur=blob.read_shift(2),iTabFirst=blob.read_shift(2);var ctabSel=blob.read_shift(2),wTabRatio=blob.read_shift(2);return{Pos:[xWn,yWn],Dim:[dxWn,dyWn],Flags:flags,CurTab:iTabCur,FirstTab:iTabFirst,Selected:ctabSel,TabRatio:wTabRatio};}function write_Window1(){var o=new_buf(18);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0x7260);o.write_shift(2,0x44c0);o.write_shift(2,0x38);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,1);o.write_shift(2,0x01f4);return o;}function parse_Window2(blob,length,opts){if(opts&&opts.biff>=2&&opts.biff<5)return{};var f=blob.read_shift(2);return{RTL:f&0x40};}function write_Window2(view){var o=new_buf(18),f=0x6b6;if(view&&view.RTL)f|=0x40;o.write_shift(2,f);o.write_shift(4,0);o.write_shift(4,64);o.write_shift(4,0);o.write_shift(4,0);return o;}function parse_Pane(){}function parse_Font(blob,length,opts){var o={dyHeight:blob.read_shift(2),fl:blob.read_shift(2)};switch(opts&&opts.biff||8){case 2:break;case 3:case 4:blob.l+=2;break;default:blob.l+=10;break;}o.name=parse_ShortXLUnicodeString(blob,0,opts);return o;}function write_Font(data,opts){var name=data.name||"Arial";var b5=opts&&opts.biff==5,w=b5?15+name.length:16+2*name.length;var o=new_buf(w);o.write_shift(2,(data.sz||12)*20);o.write_shift(4,0);o.write_shift(2,400);o.write_shift(4,0);o.write_shift(2,0);o.write_shift(1,name.length);if(!b5)o.write_shift(1,1);o.write_shift((b5?1:2)*name.length,name,b5?"sbcs":"utf16le");return o;}function parse_LabelSst(blob){var cell=parse_XLSCell(blob);cell.isst=blob.read_shift(4);return cell;}function write_LabelSst(R,C,v,os){var o=new_buf(10);write_XLSCell(R,C,os,o);o.write_shift(4,v);return o;}function parse_Label(blob,length,opts){if(opts.biffguess&&opts.biff==2)opts.biff=5;var target=blob.l+length;var cell=parse_XLSCell(blob,6);if(opts.biff==2)blob.l++;var str=parse_XLUnicodeString(blob,target-blob.l,opts);cell.val=str;return cell;}function write_Label(R,C,v,os,opts){var b8=!opts||opts.biff==8;var o=new_buf(6+2+ +b8+(1+b8)*v.length);write_XLSCell(R,C,os,o);o.write_shift(2,v.length);if(b8)o.write_shift(1,1);o.write_shift((1+b8)*v.length,v,b8?'utf16le':'sbcs');return o;}function parse_Format(blob,length,opts){var numFmtId=blob.read_shift(2);var fmtstr=parse_XLUnicodeString2(blob,0,opts);return[numFmtId,fmtstr];}function write_Format(i,f,opts,o){var b5=opts&&opts.biff==5;if(!o)o=new_buf(b5?3+f.length:5+2*f.length);o.write_shift(2,i);o.write_shift(b5?1:2,f.length);if(!b5)o.write_shift(1,1);o.write_shift((b5?1:2)*f.length,f,b5?'sbcs':'utf16le');var out=o.length>o.l?o.slice(0,o.l):o;if(out.l==null)out.l=out.length;return out;}var parse_BIFF2Format=parse_XLUnicodeString2;function parse_Dimensions(blob,length,opts){var end=blob.l+length;var w=opts.biff==8||!opts.biff?4:2;var r=blob.read_shift(w),R=blob.read_shift(w);var c=blob.read_shift(2),C=blob.read_shift(2);blob.l=end;return{s:{r:r,c:c},e:{r:R,c:C}};}function write_Dimensions(range,opts){var w=opts.biff==8||!opts.biff?4:2;var o=new_buf(2*w+6);o.write_shift(w,range.s.r);o.write_shift(w,range.e.r+1);o.write_shift(2,range.s.c);o.write_shift(2,range.e.c+1);o.write_shift(2,0);return o;}function parse_RK(blob){var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrec=parse_RkRec(blob);return{r:rw,c:col,ixfe:rkrec[0],rknum:rkrec[1]};}function parse_MulRk(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrecs=[];while(blob.l<target){rkrecs.push(parse_RkRec(blob));}if(blob.l!==target)throw new Error("MulRK read error");var lastcol=blob.read_shift(2);if(rkrecs.length!=lastcol-col+1)throw new Error("MulRK length mismatch");return{r:rw,c:col,C:lastcol,rkrec:rkrecs};}function parse_MulBlank(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var ixfes=[];while(blob.l<target){ixfes.push(blob.read_shift(2));}if(blob.l!==target)throw new Error("MulBlank read error");var lastcol=blob.read_shift(2);if(ixfes.length!=lastcol-col+1)throw new Error("MulBlank length mismatch");return{r:rw,c:col,C:lastcol,ixfe:ixfes};}function parse_CellStyleXF(blob,length,style,opts){var o={};var a=blob.read_shift(4),b=blob.read_shift(4);var c=blob.read_shift(4),d=blob.read_shift(2);o.patternType=XLSFillPattern[c>>26];if(!opts.cellStyles)return o;o.alc=a&0x07;o.fWrap=a>>3&0x01;o.alcV=a>>4&0x07;o.fJustLast=a>>7&0x01;o.trot=a>>8&0xFF;o.cIndent=a>>16&0x0F;o.fShrinkToFit=a>>20&0x01;o.iReadOrder=a>>22&0x02;o.fAtrNum=a>>26&0x01;o.fAtrFnt=a>>27&0x01;o.fAtrAlc=a>>28&0x01;o.fAtrBdr=a>>29&0x01;o.fAtrPat=a>>30&0x01;o.fAtrProt=a>>31&0x01;o.dgLeft=b&0x0F;o.dgRight=b>>4&0x0F;o.dgTop=b>>8&0x0F;o.dgBottom=b>>12&0x0F;o.icvLeft=b>>16&0x7F;o.icvRight=b>>23&0x7F;o.grbitDiag=b>>30&0x03;o.icvTop=c&0x7F;o.icvBottom=c>>7&0x7F;o.icvDiag=c>>14&0x7F;o.dgDiag=c>>21&0x0F;o.icvFore=d&0x7F;o.icvBack=d>>7&0x7F;o.fsxButton=d>>14&0x01;return o;}function parse_XF(blob,length,opts){var o={};o.ifnt=blob.read_shift(2);o.numFmtId=blob.read_shift(2);o.flags=blob.read_shift(2);o.fStyle=o.flags>>2&0x01;length-=6;o.data=parse_CellStyleXF(blob,length,o.fStyle,opts);return o;}function write_XF(data,ixfeP,opts,o){var b5=opts&&opts.biff==5;if(!o)o=new_buf(b5?16:20);o.write_shift(2,0);if(data.style){o.write_shift(2,data.numFmtId||0);o.write_shift(2,0xFFF4);}else{o.write_shift(2,data.numFmtId||0);o.write_shift(2,ixfeP<<4);}var f=0;if(data.numFmtId>0&&b5)f|=0x0400;o.write_shift(4,f);o.write_shift(4,0);if(!b5)o.write_shift(4,0);o.write_shift(2,0);return o;}function parse_Guts(blob){blob.l+=4;var out=[blob.read_shift(2),blob.read_shift(2)];if(out[0]!==0)out[0]--;if(out[1]!==0)out[1]--;if(out[0]>7||out[1]>7)throw new Error("Bad Gutters: "+out.join("|"));return out;}function write_Guts(guts){var o=new_buf(8);o.write_shift(4,0);o.write_shift(2,guts[0]?guts[0]+1:0);o.write_shift(2,guts[1]?guts[1]+1:0);return o;}function parse_BoolErr(blob,length,opts){var cell=parse_XLSCell(blob,6);if(opts.biff==2||length==9)++blob.l;var val=parse_Bes(blob,2);cell.val=val;cell.t=val===true||val===false?'b':'e';return cell;}function write_BoolErr(R,C,v,os,opts,t){var o=new_buf(8);write_XLSCell(R,C,os,o);write_Bes(v,t,o);return o;}function parse_Number(blob,length,opts){if(opts.biffguess&&opts.biff==2)opts.biff=5;var cell=parse_XLSCell(blob,6);var xnum=parse_Xnum(blob,8);cell.val=xnum;return cell;}function write_Number(R,C,v,os){var o=new_buf(14);write_XLSCell(R,C,os,o);write_Xnum(v,o);return o;}var parse_XLHeaderFooter=parse_OptXLUnicodeString;function parse_SupBook(blob,length,opts){var end=blob.l+length;var ctab=blob.read_shift(2);var cch=blob.read_shift(2);opts.sbcch=cch;if(cch==0x0401||cch==0x3A01)return[cch,ctab];if(cch<0x01||cch>0xff)throw new Error("Unexpected SupBook type: "+cch);var virtPath=parse_XLUnicodeStringNoCch(blob,cch);var rgst=[];while(end>blob.l){rgst.push(parse_XLUnicodeString(blob));}return[cch,ctab,virtPath,rgst];}function parse_ExternName(blob,length,opts){var flags=blob.read_shift(2);var body;var o={fBuiltIn:flags&0x01,fWantAdvise:flags>>>1&0x01,fWantPict:flags>>>2&0x01,fOle:flags>>>3&0x01,fOleLink:flags>>>4&0x01,cf:flags>>>5&0x3FF,fIcon:flags>>>15&0x01};if(opts.sbcch===0x3A01)body=parse_AddinUdf(blob,length-2,opts);o.body=body||blob.read_shift(length-2);if(typeof body==="string")o.Name=body;return o;}var XLSLblBuiltIn=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function parse_Lbl(blob,length,opts){var target=blob.l+length;var flags=blob.read_shift(2);var chKey=blob.read_shift(1);var cch=blob.read_shift(1);var cce=blob.read_shift(opts&&opts.biff==2?1:2);var itab=0;if(!opts||opts.biff>=5){if(opts.biff!=5)blob.l+=2;itab=blob.read_shift(2);if(opts.biff==5)blob.l+=2;blob.l+=4;}var name=parse_XLUnicodeStringNoCch(blob,cch,opts);if(flags&0x20)name=XLSLblBuiltIn[name.charCodeAt(0)];var npflen=target-blob.l;if(opts&&opts.biff==2)--npflen;var rgce=target==blob.l||cce===0||!(npflen>0)?[]:parse_NameParsedFormula(blob,npflen,opts,cce);return{chKey:chKey,Name:name,itab:itab,rgce:rgce};}function parse_ExternSheet(blob,length,opts){if(opts.biff<8)return parse_BIFF5ExternSheet(blob,length,opts);var o=[],target=blob.l+length,len=blob.read_shift(opts.biff>8?4:2);while(len--!==0){o.push(parse_XTI(blob,opts.biff>8?12:6,opts));}if(blob.l!=target)throw new Error("Bad ExternSheet: "+blob.l+" != "+target);return o;}function parse_BIFF5ExternSheet(blob,length,opts){if(blob[blob.l+1]==0x03)blob[blob.l]++;var o=parse_ShortXLUnicodeString(blob,length,opts);return o.charCodeAt(0)==0x03?o.slice(1):o;}function parse_NameCmt(blob,length,opts){if(opts.biff<8){blob.l+=length;return;}var cchName=blob.read_shift(2);var cchComment=blob.read_shift(2);var name=parse_XLUnicodeStringNoCch(blob,cchName,opts);var comment=parse_XLUnicodeStringNoCch(blob,cchComment,opts);return[name,comment];}function parse_ShrFmla(blob,length,opts){var ref=parse_RefU(blob,6);blob.l++;var cUse=blob.read_shift(1);length-=8;return[parse_SharedParsedFormula(blob,length,opts),cUse,ref];}function parse_Array(blob,length,opts){var ref=parse_Ref(blob,6);switch(opts.biff){case 2:blob.l++;length-=7;break;case 3:case 4:blob.l+=2;length-=8;break;default:blob.l+=6;length-=12;}return[ref,parse_ArrayParsedFormula(blob,length,opts,ref)];}function parse_MTRSettings(blob){var fMTREnabled=blob.read_shift(4)!==0x00;var fUserSetThreadCount=blob.read_shift(4)!==0x00;var cUserThreadCount=blob.read_shift(4);return[fMTREnabled,fUserSetThreadCount,cUserThreadCount];}function parse_NoteSh(blob,length,opts){if(opts.biff<8)return;var row=blob.read_shift(2),col=blob.read_shift(2);var flags=blob.read_shift(2),idObj=blob.read_shift(2);var stAuthor=parse_XLUnicodeString2(blob,0,opts);if(opts.biff<8)blob.read_shift(1);return[{r:row,c:col},stAuthor,idObj,flags];}function parse_Note(blob,length,opts){return parse_NoteSh(blob,length,opts);}function parse_MergeCells(blob,length){var merges=[];var cmcs=blob.read_shift(2);while(cmcs--){merges.push(parse_Ref8U(blob,length));}return merges;}function write_MergeCells(merges){var o=new_buf(2+merges.length*8);o.write_shift(2,merges.length);for(var i=0;i<merges.length;++i){write_Ref8U(merges[i],o);}return o;}function parse_Obj(blob,length,opts){if(opts&&opts.biff<8)return parse_BIFF5Obj(blob,length,opts);var cmo=parse_FtCmo(blob,22);var fts=parse_FtArray(blob,length-22,cmo[1]);return{cmo:cmo,ft:fts};}var parse_BIFF5OT={0x08:function _(blob,length){var tgt=blob.l+length;blob.l+=10;var cf=blob.read_shift(2);blob.l+=4;blob.l+=2;blob.l+=2;blob.l+=2;blob.l+=4;var cchName=blob.read_shift(1);blob.l+=cchName;blob.l=tgt;return{fmt:cf};}};function parse_BIFF5Obj(blob,length,opts){blob.l+=4;var ot=blob.read_shift(2);var id=blob.read_shift(2);var grbit=blob.read_shift(2);blob.l+=2;blob.l+=2;blob.l+=2;blob.l+=2;blob.l+=2;blob.l+=2;blob.l+=2;blob.l+=2;blob.l+=2;blob.l+=6;length-=36;var fts=[];fts.push((parse_BIFF5OT[ot]||parsenoop)(blob,length,opts));return{cmo:[id,ot,grbit],ft:fts};}function parse_TxO(blob,length,opts){var s=blob.l;var texts="";try{blob.l+=4;var ot=(opts.lastobj||{cmo:[0,0]}).cmo[1];var controlInfo;if([0,5,7,11,12,14].indexOf(ot)==-1)blob.l+=6;else controlInfo=parse_ControlInfo(blob,6,opts);var cchText=blob.read_shift(2);blob.read_shift(2);parseuint16(blob,2);var len=blob.read_shift(2);blob.l+=len;for(var i=1;i<blob.lens.length-1;++i){if(blob.l-s!=blob.lens[i])throw new Error("TxO: bad continue record");var hdr=blob[blob.l];var t=parse_XLUnicodeStringNoCch(blob,blob.lens[i+1]-blob.lens[i]-1);texts+=t;if(texts.length>=(hdr?cchText:2*cchText))break;}if(texts.length!==cchText&&texts.length!==cchText*2){throw new Error("cchText: "+cchText+" != "+texts.length);}blob.l=s+length;return{t:texts};}catch(e){blob.l=s+length;return{t:texts};}}function parse_HLink(blob,length){var ref=parse_Ref8U(blob,8);blob.l+=16;var hlink=parse_Hyperlink(blob,length-24);return[ref,hlink];}function write_HLink(hl){var O=new_buf(24);var ref=decode_cell(hl[0]);O.write_shift(2,ref.r);O.write_shift(2,ref.r);O.write_shift(2,ref.c);O.write_shift(2,ref.c);var clsid="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(var i=0;i<16;++i){O.write_shift(1,parseInt(clsid[i],16));}return bconcat([O,write_Hyperlink(hl[1])]);}function parse_HLinkTooltip(blob,length){blob.read_shift(2);var ref=parse_Ref8U(blob,8);var wzTooltip=blob.read_shift((length-10)/2,'dbcs-cont');wzTooltip=wzTooltip.replace(chr0,"");return[ref,wzTooltip];}function write_HLinkTooltip(hl){var TT=hl[1].Tooltip;var O=new_buf(10+2*(TT.length+1));O.write_shift(2,0x0800);var ref=decode_cell(hl[0]);O.write_shift(2,ref.r);O.write_shift(2,ref.r);O.write_shift(2,ref.c);O.write_shift(2,ref.c);for(var i=0;i<TT.length;++i){O.write_shift(2,TT.charCodeAt(i));}O.write_shift(2,0);return O;}function parse_Country(blob){var o=[0,0],d;d=blob.read_shift(2);o[0]=CountryEnum[d]||d;d=blob.read_shift(2);o[1]=CountryEnum[d]||d;return o;}function write_Country(o){if(!o)o=new_buf(4);o.write_shift(2,0x01);o.write_shift(2,0x01);return o;}function parse_ClrtClient(blob){var ccv=blob.read_shift(2);var o=[];while(ccv-->0){o.push(parse_LongRGB(blob,8));}return o;}function parse_Palette(blob){var ccv=blob.read_shift(2);var o=[];while(ccv-->0){o.push(parse_LongRGB(blob,8));}return o;}function parse_XFCRC(blob){blob.l+=2;var o={cxfs:0,crc:0};o.cxfs=blob.read_shift(2);o.crc=blob.read_shift(4);return o;}function parse_ColInfo(blob,length,opts){if(!opts.cellStyles)return parsenoop(blob,length);var w=opts&&opts.biff>=12?4:2;var colFirst=blob.read_shift(w);var colLast=blob.read_shift(w);var coldx=blob.read_shift(w);var ixfe=blob.read_shift(w);var flags=blob.read_shift(2);if(w==2)blob.l+=2;var o={s:colFirst,e:colLast,w:coldx,ixfe:ixfe,flags:flags};if(opts.biff>=5||!opts.biff)o.level=flags>>8&0x7;return o;}function write_ColInfo(col,idx){var o=new_buf(12);o.write_shift(2,idx);o.write_shift(2,idx);o.write_shift(2,col.width*256);o.write_shift(2,0);var f=0;if(col.hidden)f|=1;o.write_shift(1,f);f=col.level||0;o.write_shift(1,f);o.write_shift(2,0);return o;}function parse_Setup(blob,length){var o={};if(length<32)return o;blob.l+=16;o.header=parse_Xnum(blob,8);o.footer=parse_Xnum(blob,8);blob.l+=2;return o;}function parse_ShtProps(blob,length,opts){var def={area:false};if(opts.biff!=5){blob.l+=length;return def;}var d=blob.read_shift(1);blob.l+=3;if(d&0x10)def.area=true;return def;}function write_RRTabId(n){var out=new_buf(2*n);for(var i=0;i<n;++i){out.write_shift(2,i+1);}return out;}var parse_Blank=parse_XLSCell;var parse_Scl=parseuint16a;var parse_String=parse_XLUnicodeString;function parse_ImData(blob){var cf=blob.read_shift(2);var env=blob.read_shift(2);var lcb=blob.read_shift(4);var o={fmt:cf,env:env,len:lcb,data:blob.slice(blob.l,blob.l+lcb)};blob.l+=lcb;return o;}function parse_BIFF2STR(blob,length,opts){if(opts.biffguess&&opts.biff==5)opts.biff=2;var cell=parse_XLSCell(blob,6);++blob.l;var str=parse_XLUnicodeString2(blob,length-7,opts);cell.t='str';cell.val=str;return cell;}function parse_BIFF2NUM(blob){var cell=parse_XLSCell(blob,6);++blob.l;var num=parse_Xnum(blob,8);cell.t='n';cell.val=num;return cell;}function write_BIFF2NUM(r,c,val){var out=new_buf(15);write_BIFF2Cell(out,r,c);out.write_shift(8,val,'f');return out;}function parse_BIFF2INT(blob){var cell=parse_XLSCell(blob,6);++blob.l;var num=blob.read_shift(2);cell.t='n';cell.val=num;return cell;}function write_BIFF2INT(r,c,val){var out=new_buf(9);write_BIFF2Cell(out,r,c);out.write_shift(2,val);return out;}function parse_BIFF2STRING(blob){var cch=blob.read_shift(1);if(cch===0){blob.l++;return"";}return blob.read_shift(cch,'sbcs-cont');}function parse_BIFF2FONTXTRA(blob,length){blob.l+=6;blob.l+=2;blob.l+=1;blob.l+=3;blob.l+=1;blob.l+=length-13;}function parse_RString(blob,length,opts){var end=blob.l+length;var cell=parse_XLSCell(blob,6);var cch=blob.read_shift(2);var str=parse_XLUnicodeStringNoCch(blob,cch,opts);blob.l=end;cell.t='str';cell.val=str;return cell;}var DBF_SUPPORTED_VERSIONS=[0x02,0x03,0x30,0x31,0x83,0x8B,0x8C,0xF5];var DBF=function(){var dbf_codepage_map={0x01:437,0x02:850,0x03:1252,0x04:10000,0x64:852,0x65:866,0x66:865,0x67:861,0x68:895,0x69:620,0x6A:737,0x6B:857,0x78:950,0x79:949,0x7A:936,0x7B:932,0x7C:874,0x7D:1255,0x7E:1256,0x96:10007,0x97:10029,0x98:10006,0xC8:1250,0xC9:1251,0xCA:1254,0xCB:1253,0x00:20127,0x08:865,0x09:437,0x0A:850,0x0B:437,0x0D:437,0x0E:850,0x0F:437,0x10:850,0x11:437,0x12:850,0x13:932,0x14:850,0x15:437,0x16:850,0x17:865,0x18:437,0x19:437,0x1A:850,0x1B:437,0x1C:863,0x1D:850,0x1F:852,0x22:852,0x23:852,0x24:860,0x25:850,0x26:866,0x37:850,0x40:852,0x4D:936,0x4E:949,0x4F:950,0x50:874,0x57:1252,0x58:1252,0x59:1252,0x6C:863,0x86:737,0x87:852,0x88:857,0xCC:1257,0xFF:16969};var dbf_reverse_map=evert({0x01:437,0x02:850,0x03:1252,0x04:10000,0x64:852,0x65:866,0x66:865,0x67:861,0x68:895,0x69:620,0x6A:737,0x6B:857,0x78:950,0x79:949,0x7A:936,0x7B:932,0x7C:874,0x7D:1255,0x7E:1256,0x96:10007,0x97:10029,0x98:10006,0xC8:1250,0xC9:1251,0xCA:1254,0xCB:1253,0x00:20127});function dbf_to_aoa(buf,opts){var out=[];var d=new_raw_buf(1);switch(opts.type){case'base64':d=s2a(Base64_decode(buf));break;case'binary':d=s2a(buf);break;case'buffer':case'array':d=buf;break;}prep_blob(d,0);var ft=d.read_shift(1);var memo=!!(ft&0x88);var vfp=false,l7=false;switch(ft){case 0x02:break;case 0x03:break;case 0x30:vfp=true;memo=true;break;case 0x31:vfp=true;memo=true;break;case 0x83:break;case 0x8B:break;case 0x8C:l7=true;break;case 0xF5:break;default:throw new Error("DBF Unsupported Version: "+ft.toString(16));}var nrow=0,fpos=0x0209;if(ft==0x02)nrow=d.read_shift(2);d.l+=3;if(ft!=0x02)nrow=d.read_shift(4);if(nrow>1048576)nrow=1e6;if(ft!=0x02)fpos=d.read_shift(2);var rlen=d.read_shift(2);var current_cp=opts.codepage||1252;if(ft!=0x02){d.l+=16;d.read_shift(1);if(d[d.l]!==0)current_cp=dbf_codepage_map[d[d.l]];d.l+=1;d.l+=2;}if(l7)d.l+=36;var fields=[],field={};var hend=Math.min(d.length,ft==0x02?0x209:fpos-10-(vfp?264:0));var ww=l7?32:11;while(d.l<hend&&d[d.l]!=0x0d){field={};field.name=$cptable.utils.decode(current_cp,d.slice(d.l,d.l+ww)).replace(/[\u0000\r\n].*$/g,"");d.l+=ww;field.type=String.fromCharCode(d.read_shift(1));if(ft!=0x02&&!l7)field.offset=d.read_shift(4);field.len=d.read_shift(1);if(ft==0x02)field.offset=d.read_shift(2);field.dec=d.read_shift(1);if(field.name.length)fields.push(field);if(ft!=0x02)d.l+=l7?13:14;switch(field.type){case'B':if((!vfp||field.len!=8)&&opts.WTF)console.log('Skipping '+field.name+':'+field.type);break;case'G':case'P':if(opts.WTF)console.log('Skipping '+field.name+':'+field.type);break;case'+':case'0':case'@':case'C':case'D':case'F':case'I':case'L':case'M':case'N':case'O':case'T':case'Y':break;default:throw new Error('Unknown Field Type: '+field.type);}}if(d[d.l]!==0x0D)d.l=fpos-1;if(d.read_shift(1)!==0x0D)throw new Error("DBF Terminator not found "+d.l+" "+d[d.l]);d.l=fpos;var R=0,C=0;out[0]=[];for(C=0;C!=fields.length;++C){out[0][C]=fields[C].name;}while(nrow-->0){if(d[d.l]===0x2A){d.l+=rlen;continue;}++d.l;out[++R]=[];C=0;for(C=0;C!=fields.length;++C){var dd=d.slice(d.l,d.l+fields[C].len);d.l+=fields[C].len;prep_blob(dd,0);var s=$cptable.utils.decode(current_cp,dd);switch(fields[C].type){case'C':if(s.trim().length)out[R][C]=s.replace(/\s+$/,"");break;case'D':if(s.length===8)out[R][C]=new Date(+s.slice(0,4),+s.slice(4,6)-1,+s.slice(6,8));else out[R][C]=s;break;case'F':out[R][C]=parseFloat(s.trim());break;case'+':case'I':out[R][C]=l7?dd.read_shift(-4,'i')^0x80000000:dd.read_shift(4,'i');break;case'L':switch(s.trim().toUpperCase()){case'Y':case'T':out[R][C]=true;break;case'N':case'F':out[R][C]=false;break;case'':case'?':break;default:throw new Error("DBF Unrecognized L:|"+s+"|");}break;case'M':if(!memo)throw new Error("DBF Unexpected MEMO for type "+ft.toString(16));out[R][C]="##MEMO##"+(l7?parseInt(s.trim(),10):dd.read_shift(4));break;case'N':s=s.replace(/\u0000/g,"").trim();if(s&&s!=".")out[R][C]=+s||0;break;case'@':out[R][C]=new Date(dd.read_shift(-8,'f')-0x388317533400);break;case'T':out[R][C]=new Date((dd.read_shift(4)-0x253D8C)*0x5265C00+dd.read_shift(4));break;case'Y':out[R][C]=dd.read_shift(4,'i')/1e4+dd.read_shift(4,'i')/1e4*Math.pow(2,32);break;case'O':out[R][C]=-dd.read_shift(-8,'f');break;case'B':if(vfp&&fields[C].len==8){out[R][C]=dd.read_shift(8,'f');break;}case'G':case'P':dd.l+=fields[C].len;break;case'0':if(fields[C].name==='_NullFlags')break;default:throw new Error("DBF Unsupported data type "+fields[C].type);}}}if(ft!=0x02)if(d.l<d.length&&d[d.l++]!=0x1A)throw new Error("DBF EOF Marker missing "+(d.l-1)+" of "+d.length+" "+d[d.l-1].toString(16));if(opts&&opts.sheetRows)out=out.slice(0,opts.sheetRows);opts.DBF=fields;return out;}function dbf_to_sheet(buf,opts){var o=opts||{};if(!o.dateNF)o.dateNF="yyyymmdd";var ws=aoa_to_sheet(dbf_to_aoa(buf,o),o);ws["!cols"]=o.DBF.map(function(field){return{wch:field.len,DBF:field};});delete o.DBF;return ws;}function dbf_to_workbook(buf,opts){try{return sheet_to_workbook(dbf_to_sheet(buf,opts),opts);}catch(e){if(opts&&opts.WTF)throw e;}return{SheetNames:[],Sheets:{}};}var _RLEN={'B':8,'C':250,'L':1,'D':8,'?':0,'':0};function sheet_to_dbf(ws,opts){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write DBF to JS string");var ba=buf_array();var aoa=sheet_to_json(ws,{header:1,raw:true,cellDates:true});var headers=aoa[0],data=aoa.slice(1),cols=ws["!cols"]||[];var i=0,j=0,hcnt=0,rlen=1;for(i=0;i<headers.length;++i){if(((cols[i]||{}).DBF||{}).name){headers[i]=cols[i].DBF.name;++hcnt;continue;}if(headers[i]==null)continue;++hcnt;if(typeof headers[i]==='number')headers[i]=headers[i].toString(10);if(typeof headers[i]!=='string')throw new Error("DBF Invalid column name "+headers[i]+" |"+(0,_typeof3.default)(headers[i])+"|");if(headers.indexOf(headers[i])!==i)for(j=0;j<1024;++j){if(headers.indexOf(headers[i]+"_"+j)==-1){headers[i]+="_"+j;break;}}}var range=safe_decode_range(ws['!ref']);var coltypes=[];var colwidths=[];var coldecimals=[];for(i=0;i<=range.e.c-range.s.c;++i){var guess='',_guess='',maxlen=0;var col=[];for(j=0;j<data.length;++j){if(data[j][i]!=null)col.push(data[j][i]);}if(col.length==0||headers[i]==null){coltypes[i]='?';continue;}for(j=0;j<col.length;++j){switch((0,_typeof3.default)(col[j])){case'number':_guess='B';break;case'string':_guess='C';break;case'boolean':_guess='L';break;case'object':_guess=col[j]instanceof Date?'D':'C';break;default:_guess='C';}maxlen=Math.max(maxlen,String(col[j]).length);guess=guess&&guess!=_guess?'C':_guess;}if(maxlen>250)maxlen=250;_guess=((cols[i]||{}).DBF||{}).type;if(_guess=='C'){if(cols[i].DBF.len>maxlen)maxlen=cols[i].DBF.len;}if(guess=='B'&&_guess=='N'){guess='N';coldecimals[i]=cols[i].DBF.dec;maxlen=cols[i].DBF.len;}colwidths[i]=guess=='C'||_guess=='N'?maxlen:_RLEN[guess]||0;rlen+=colwidths[i];coltypes[i]=guess;}var h=ba.next(32);h.write_shift(4,0x13021130);h.write_shift(4,data.length);h.write_shift(2,296+32*hcnt);h.write_shift(2,rlen);for(i=0;i<4;++i){h.write_shift(4,0);}h.write_shift(4,0x00000000|(+dbf_reverse_map[current_ansi]||0x03)<<8);for(i=0,j=0;i<headers.length;++i){if(headers[i]==null)continue;var hf=ba.next(32);var _f=(headers[i].slice(-10)+"\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0,11);hf.write_shift(1,_f,"sbcs");hf.write_shift(1,coltypes[i]=='?'?'C':coltypes[i],"sbcs");hf.write_shift(4,j);hf.write_shift(1,colwidths[i]||_RLEN[coltypes[i]]||0);hf.write_shift(1,coldecimals[i]||0);hf.write_shift(1,0x02);hf.write_shift(4,0);hf.write_shift(1,0);hf.write_shift(4,0);hf.write_shift(4,0);j+=colwidths[i]||_RLEN[coltypes[i]]||0;}var hb=ba.next(264);hb.write_shift(4,0x0000000D);for(i=0;i<65;++i){hb.write_shift(4,0x00000000);}for(i=0;i<data.length;++i){var rout=ba.next(rlen);rout.write_shift(1,0);for(j=0;j<headers.length;++j){if(headers[j]==null)continue;switch(coltypes[j]){case'L':rout.write_shift(1,data[i][j]==null?0x3F:data[i][j]?0x54:0x46);break;case'B':rout.write_shift(8,data[i][j]||0,'f');break;case'N':var _n="0";if(typeof data[i][j]=="number")_n=data[i][j].toFixed(coldecimals[j]||0);for(hcnt=0;hcnt<colwidths[j]-_n.length;++hcnt){rout.write_shift(1,0x20);}rout.write_shift(1,_n,"sbcs");break;case'D':if(!data[i][j])rout.write_shift(8,"00000000","sbcs");else{rout.write_shift(4,("0000"+data[i][j].getFullYear()).slice(-4),"sbcs");rout.write_shift(2,("00"+(data[i][j].getMonth()+1)).slice(-2),"sbcs");rout.write_shift(2,("00"+data[i][j].getDate()).slice(-2),"sbcs");}break;case'C':var _s=String(data[i][j]!=null?data[i][j]:"").slice(0,colwidths[j]);rout.write_shift(1,_s,"sbcs");for(hcnt=0;hcnt<colwidths[j]-_s.length;++hcnt){rout.write_shift(1,0x20);}break;}}}ba.next(1).write_shift(1,0x1A);return ba.end();}return{to_workbook:dbf_to_workbook,to_sheet:dbf_to_sheet,from_sheet:sheet_to_dbf};}();var SYLK=function(){var sylk_escapes={AA:'À',BA:'Á',CA:'Â',DA:195,HA:'Ä',JA:197,AE:'È',BE:'É',CE:'Ê',HE:'Ë',AI:'Ì',BI:'Í',CI:'Î',HI:'Ï',AO:'Ò',BO:'Ó',CO:'Ô',DO:213,HO:'Ö',AU:'Ù',BU:'Ú',CU:'Û',HU:'Ü',Aa:'à',Ba:'á',Ca:'â',Da:227,Ha:'ä',Ja:229,Ae:'è',Be:'é',Ce:'ê',He:'ë',Ai:'ì',Bi:'í',Ci:'î',Hi:'ï',Ao:'ò',Bo:'ó',Co:'ô',Do:245,Ho:'ö',Au:'ù',Bu:'ú',Cu:'û',Hu:'ü',KC:'Ç',Kc:'ç',q:'æ',z:'œ',a:'Æ',j:'Œ',DN:209,Dn:241,Hy:255,S:169,c:170,R:174,"B ":180,0:176,1:177,2:178,3:179,5:181,6:182,7:183,Q:185,k:186,b:208,i:216,l:222,s:240,y:248,"!":161,'"':162,"#":163,"(":164,"%":165,"'":167,"H ":168,"+":171,";":187,"<":188,"=":189,">":190,"?":191,"{":223};var sylk_char_regex=new RegExp("\x1BN("+keys(sylk_escapes).join("|").replace(/\|\|\|/,"|\\||").replace(/([?()+])/g,"\\$1")+"|\\|)","gm");var sylk_char_fn=function sylk_char_fn(_,$1){var o=sylk_escapes[$1];return typeof o=="number"?_getansi(o):o;};var decode_sylk_char=function decode_sylk_char($$,$1,$2){var newcc=$1.charCodeAt(0)-0x20<<4|$2.charCodeAt(0)-0x30;return newcc==59?$$:_getansi(newcc);};sylk_escapes["|"]=254;function sylk_to_aoa(d,opts){switch(opts.type){case'base64':return sylk_to_aoa_str(Base64_decode(d),opts);case'binary':return sylk_to_aoa_str(d,opts);case'buffer':return sylk_to_aoa_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return sylk_to_aoa_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function sylk_to_aoa_str(str,opts){var records=str.split(/[\n\r]+/),R=-1,C=-1,ri=0,rj=0,arr=[];var formats=[];var next_cell_format=null;var sht={},rowinfo=[],colinfo=[],cw=[];var Mval=0,j;if(+opts.codepage>=0)set_cp(+opts.codepage);for(;ri!==records.length;++ri){Mval=0;var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g,decode_sylk_char).replace(sylk_char_regex,sylk_char_fn);var record=rstr.replace(/;;/g,"\0").split(";").map(function(x){return x.replace(/\u0000/g,";");});var RT=record[0],val;if(rstr.length>0)switch(RT){case'ID':break;case'E':break;case'B':break;case'O':break;case'W':break;case'P':if(record[1].charAt(0)=='P')formats.push(rstr.slice(3).replace(/;;/g,";"));break;case'C':var C_seen_K=false,C_seen_X=false,C_seen_S=false,C_seen_E=false,_R=-1,_C=-1;for(rj=1;rj<record.length;++rj){switch(record[rj].charAt(0)){case'A':break;case'X':C=parseInt(record[rj].slice(1))-1;C_seen_X=true;break;case'Y':R=parseInt(record[rj].slice(1))-1;if(!C_seen_X)C=0;for(j=arr.length;j<=R;++j){arr[j]=[];}break;case'K':val=record[rj].slice(1);if(val.charAt(0)==='"')val=val.slice(1,val.length-1);else if(val==='TRUE')val=true;else if(val==='FALSE')val=false;else if(!isNaN(fuzzynum(val))){val=fuzzynum(val);if(next_cell_format!==null&&fmt_is_date(next_cell_format))val=numdate(val);}else if(!isNaN(fuzzydate(val).getDate())){val=parseDate(val);}if(typeof $cptable!=='undefined'&&typeof val=="string"&&(opts||{}).type!="string"&&(opts||{}).codepage)val=$cptable.utils.decode(opts.codepage,val);C_seen_K=true;break;case'E':C_seen_E=true;var formula=rc_to_a1(record[rj].slice(1),{r:R,c:C});arr[R][C]=[arr[R][C],formula];break;case'S':C_seen_S=true;arr[R][C]=[arr[R][C],"S5S"];break;case'G':break;case'R':_R=parseInt(record[rj].slice(1))-1;break;case'C':_C=parseInt(record[rj].slice(1))-1;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}}if(C_seen_K){if(arr[R][C]&&arr[R][C].length==2)arr[R][C][0]=val;else arr[R][C]=val;next_cell_format=null;}if(C_seen_S){if(C_seen_E)throw new Error("SYLK shared formula cannot have own formula");var shrbase=_R>-1&&arr[_R][_C];if(!shrbase||!shrbase[1])throw new Error("SYLK shared formula cannot find base");arr[R][C][1]=shift_formula_str(shrbase[1],{r:R-_R,c:C-_C});}break;case'F':var F_seen=0;for(rj=1;rj<record.length;++rj){switch(record[rj].charAt(0)){case'X':C=parseInt(record[rj].slice(1))-1;++F_seen;break;case'Y':R=parseInt(record[rj].slice(1))-1;for(j=arr.length;j<=R;++j){arr[j]=[];}break;case'M':Mval=parseInt(record[rj].slice(1))/20;break;case'F':break;case'G':break;case'P':next_cell_format=formats[parseInt(record[rj].slice(1))];break;case'S':break;case'D':break;case'N':break;case'W':cw=record[rj].slice(1).split(" ");for(j=parseInt(cw[0],10);j<=parseInt(cw[1],10);++j){Mval=parseInt(cw[2],10);colinfo[j-1]=Mval===0?{hidden:true}:{wch:Mval};process_col(colinfo[j-1]);}break;case'C':C=parseInt(record[rj].slice(1))-1;if(!colinfo[C])colinfo[C]={};break;case'R':R=parseInt(record[rj].slice(1))-1;if(!rowinfo[R])rowinfo[R]={};if(Mval>0){rowinfo[R].hpt=Mval;rowinfo[R].hpx=pt2px(Mval);}else if(Mval===0)rowinfo[R].hidden=true;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}}if(F_seen<1)next_cell_format=null;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}}if(rowinfo.length>0)sht['!rows']=rowinfo;if(colinfo.length>0)sht['!cols']=colinfo;if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return[arr,sht];}function sylk_to_sheet(d,opts){var aoasht=sylk_to_aoa(d,opts);var aoa=aoasht[0],ws=aoasht[1];var o=aoa_to_sheet(aoa,opts);keys(ws).forEach(function(k){o[k]=ws[k];});return o;}function sylk_to_workbook(d,opts){return sheet_to_workbook(sylk_to_sheet(d,opts),opts);}function write_ws_cell_sylk(cell,ws,R,C){var o="C;Y"+(R+1)+";X"+(C+1)+";K";switch(cell.t){case'n':o+=cell.v||0;if(cell.f&&!cell.F)o+=";E"+a1_to_rc(cell.f,{r:R,c:C});break;case'b':o+=cell.v?"TRUE":"FALSE";break;case'e':o+=cell.w||cell.v;break;case'd':o+='"'+(cell.w||cell.v)+'"';break;case's':o+='"'+cell.v.replace(/"/g,"").replace(/;/g,";;")+'"';break;}return o;}function write_ws_cols_sylk(out,cols){cols.forEach(function(col,i){var rec="F;W"+(i+1)+" "+(i+1)+" ";if(col.hidden)rec+="0";else{if(typeof col.width=='number'&&!col.wpx)col.wpx=width2px(col.width);if(typeof col.wpx=='number'&&!col.wch)col.wch=px2char(col.wpx);if(typeof col.wch=='number')rec+=Math.round(col.wch);}if(rec.charAt(rec.length-1)!=" ")out.push(rec);});}function write_ws_rows_sylk(out,rows){rows.forEach(function(row,i){var rec="F;";if(row.hidden)rec+="M0;";else if(row.hpt)rec+="M"+20*row.hpt+";";else if(row.hpx)rec+="M"+20*px2pt(row.hpx)+";";if(rec.length>2)out.push(rec+"R"+(i+1));});}function sheet_to_sylk(ws,opts){var preamble=["ID;PWXL;N;E"],o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);var RS="\r\n";preamble.push("P;PGeneral");preamble.push("F;P0;DG0G8;M255");if(ws['!cols'])write_ws_cols_sylk(preamble,ws['!cols']);if(ws['!rows'])write_ws_rows_sylk(preamble,ws['!rows']);preamble.push("B;Y"+(r.e.r-r.s.r+1)+";X"+(r.e.c-r.s.c+1)+";D"+[r.s.c,r.s.r,r.e.c,r.e.r].join(" "));for(var R=r.s.r;R<=r.e.r;++R){for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null&&(!cell.f||cell.F))continue;o.push(write_ws_cell_sylk(cell,ws,R,C,opts));}}return preamble.join(RS)+RS+o.join(RS)+RS+"E"+RS;}return{to_workbook:sylk_to_workbook,to_sheet:sylk_to_sheet,from_sheet:sheet_to_sylk};}();var DIF=function(){function dif_to_aoa(d,opts){switch(opts.type){case'base64':return dif_to_aoa_str(Base64_decode(d),opts);case'binary':return dif_to_aoa_str(d,opts);case'buffer':return dif_to_aoa_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return dif_to_aoa_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function dif_to_aoa_str(str,opts){var records=str.split('\n'),R=-1,C=-1,ri=0,arr=[];for(;ri!==records.length;++ri){if(records[ri].trim()==='BOT'){arr[++R]=[];C=0;continue;}if(R<0)continue;var metadata=records[ri].trim().split(",");var type=metadata[0],value=metadata[1];++ri;var data=records[ri]||"";while((data.match(/["]/g)||[]).length&1&&ri<records.length-1){data+="\n"+records[++ri];}data=data.trim();switch(+type){case-1:if(data==='BOT'){arr[++R]=[];C=0;continue;}else if(data!=='EOD')throw new Error("Unrecognized DIF special command "+data);break;case 0:if(data==='TRUE')arr[R][C]=true;else if(data==='FALSE')arr[R][C]=false;else if(!isNaN(fuzzynum(value)))arr[R][C]=fuzzynum(value);else if(!isNaN(fuzzydate(value).getDate()))arr[R][C]=parseDate(value);else arr[R][C]=value;++C;break;case 1:data=data.slice(1,data.length-1);data=data.replace(/""/g,'"');if(DIF_XL&&data&&data.match(/^=".*"$/))data=data.slice(2,-1);arr[R][C++]=data!==''?data:null;break;}if(data==='EOD')break;}if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return arr;}function dif_to_sheet(str,opts){return aoa_to_sheet(dif_to_aoa(str,opts),opts);}function dif_to_workbook(str,opts){return sheet_to_workbook(dif_to_sheet(str,opts),opts);}var sheet_to_dif=function(){var push_field=function pf(o,topic,v,n,s){o.push(topic);o.push(v+","+n);o.push('"'+s.replace(/"/g,'""')+'"');};var push_value=function po(o,type,v,s){o.push(type+","+v);o.push(type==1?'"'+s.replace(/"/g,'""')+'"':s);};return function sheet_to_dif(ws){var o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);push_field(o,"TABLE",0,1,"sheetjs");push_field(o,"VECTORS",0,r.e.r-r.s.r+1,"");push_field(o,"TUPLES",0,r.e.c-r.s.c+1,"");push_field(o,"DATA",0,0,"");for(var R=r.s.r;R<=r.e.r;++R){push_value(o,-1,0,"BOT");for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell){push_value(o,1,0,"");continue;}switch(cell.t){case'n':var val=DIF_XL?cell.w:cell.v;if(!val&&cell.v!=null)val=cell.v;if(val==null){if(DIF_XL&&cell.f&&!cell.F)push_value(o,1,0,"="+cell.f);else push_value(o,1,0,"");}else push_value(o,0,val,"V");break;case'b':push_value(o,0,cell.v?1:0,cell.v?"TRUE":"FALSE");break;case's':push_value(o,1,0,!DIF_XL||isNaN(cell.v)?cell.v:'="'+cell.v+'"');break;case'd':if(!cell.w)cell.w=SSF_format(cell.z||table_fmt[14],datenum(parseDate(cell.v)));if(DIF_XL)push_value(o,0,cell.w,"V");else push_value(o,1,0,cell.w);break;default:push_value(o,1,0,"");}}}push_value(o,-1,0,"EOD");var RS="\r\n";var oo=o.join(RS);return oo;};}();return{to_workbook:dif_to_workbook,to_sheet:dif_to_sheet,from_sheet:sheet_to_dif};}();var ETH=function(){function decode(s){return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n");}function encode(s){return s.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n");}function eth_to_aoa(str,opts){var records=str.split('\n'),R=-1,C=-1,ri=0,arr=[];for(;ri!==records.length;++ri){var record=records[ri].trim().split(":");if(record[0]!=='cell')continue;var addr=decode_cell(record[1]);if(arr.length<=addr.r)for(R=arr.length;R<=addr.r;++R){if(!arr[R])arr[R]=[];}R=addr.r;C=addr.c;switch(record[2]){case't':arr[R][C]=decode(record[3]);break;case'v':arr[R][C]=+record[3];break;case'vtf':var _f=record[record.length-1];case'vtc':switch(record[3]){case'nl':arr[R][C]=+record[4]?true:false;break;default:arr[R][C]=+record[4];break;}if(record[2]=='vtf')arr[R][C]=[arr[R][C],_f];}}if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return arr;}function eth_to_sheet(d,opts){return aoa_to_sheet(eth_to_aoa(d,opts),opts);}function eth_to_workbook(d,opts){return sheet_to_workbook(eth_to_sheet(d,opts),opts);}var header=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n");var sep=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n";var meta=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n");var end="--SocialCalcSpreadsheetControlSave--";function sheet_to_eth_data(ws){if(!ws||!ws['!ref'])return"";var o=[],oo=[],cell,coord="";var r=decode_range(ws['!ref']);var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){for(var C=r.s.c;C<=r.e.c;++C){coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null||cell.t==='z')continue;oo=["cell",coord,'t'];switch(cell.t){case's':case'str':oo.push(encode(cell.v));break;case'n':if(!cell.f){oo[2]='v';oo[3]=cell.v;}else{oo[2]='vtf';oo[3]='n';oo[4]=cell.v;oo[5]=encode(cell.f);}break;case'b':oo[2]='vt'+(cell.f?'f':'c');oo[3]='nl';oo[4]=cell.v?"1":"0";oo[5]=encode(cell.f||(cell.v?'TRUE':'FALSE'));break;case'd':var t=datenum(parseDate(cell.v));oo[2]='vtc';oo[3]='nd';oo[4]=""+t;oo[5]=cell.w||SSF_format(cell.z||table_fmt[14],t);break;case'e':continue;}o.push(oo.join(":"));}}o.push("sheet:c:"+(r.e.c-r.s.c+1)+":r:"+(r.e.r-r.s.r+1)+":tvf:1");o.push("valueformat:1:text-wiki");return o.join("\n");}function sheet_to_eth(ws){return[header,sep,meta,sep,sheet_to_eth_data(ws),end].join("\n");}return{to_workbook:eth_to_workbook,to_sheet:eth_to_sheet,from_sheet:sheet_to_eth};}();var PRN=function(){function set_text_arr(data,arr,R,C,o){if(o.raw)arr[R][C]=data;else if(data===""){}else if(data==='TRUE')arr[R][C]=true;else if(data==='FALSE')arr[R][C]=false;else if(!isNaN(fuzzynum(data)))arr[R][C]=fuzzynum(data);else if(!isNaN(fuzzydate(data).getDate()))arr[R][C]=parseDate(data);else arr[R][C]=data;}function prn_to_aoa_str(f,opts){var o=opts||{};var arr=[];if(!f||f.length===0)return arr;var lines=f.split(/[\r\n]/);var L=lines.length-1;while(L>=0&&lines[L].length===0){--L;}var start=10,idx=0;var R=0;for(;R<=L;++R){idx=lines[R].indexOf(" ");if(idx==-1)idx=lines[R].length;else idx++;start=Math.max(start,idx);}for(R=0;R<=L;++R){arr[R]=[];var C=0;set_text_arr(lines[R].slice(0,start).trim(),arr,R,C,o);for(C=1;C<=(lines[R].length-start)/10+1;++C){set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);}}if(o.sheetRows)arr=arr.slice(0,o.sheetRows);return arr;}var guess_seps={0x2C:',',0x09:"\t",0x3B:';',0x7C:'|'};var guess_sep_weights={0x2C:3,0x09:2,0x3B:1,0x7C:0};function guess_sep(str){var cnt={},instr=false,end=0,cc=0;for(;end<str.length;++end){if((cc=str.charCodeAt(end))==0x22)instr=!instr;else if(!instr&&cc in guess_seps)cnt[cc]=(cnt[cc]||0)+1;}cc=[];for(end in cnt){if(Object.prototype.hasOwnProperty.call(cnt,end)){cc.push([cnt[end],end]);}}if(!cc.length){cnt=guess_sep_weights;for(end in cnt){if(Object.prototype.hasOwnProperty.call(cnt,end)){cc.push([cnt[end],end]);}}}cc.sort(function(a,b){return a[0]-b[0]||guess_sep_weights[a[1]]-guess_sep_weights[b[1]];});return guess_seps[cc.pop()[1]]||0x2C;}function dsv_to_sheet_str(str,opts){var o=opts||{};var sep="";if(DENSE!=null&&o.dense==null)o.dense=DENSE;var ws=o.dense?[]:{};var range={s:{c:0,r:0},e:{c:0,r:0}};if(str.slice(0,4)=="sep="){if(str.charCodeAt(5)==13&&str.charCodeAt(6)==10){sep=str.charAt(4);str=str.slice(7);}else if(str.charCodeAt(5)==13||str.charCodeAt(5)==10){sep=str.charAt(4);str=str.slice(6);}else sep=guess_sep(str.slice(0,1024));}else if(o&&o.FS)sep=o.FS;else sep=guess_sep(str.slice(0,1024));var R=0,C=0,v=0;var start=0,end=0,sepcc=sep.charCodeAt(0),instr=false,cc=0,startcc=str.charCodeAt(0);str=str.replace(/\r\n/mg,"\n");var _re=o.dateNF!=null?dateNF_regex(o.dateNF):null;function finish_cell(){var s=str.slice(start,end);var cell={};if(s.charAt(0)=='"'&&s.charAt(s.length-1)=='"')s=s.slice(1,-1).replace(/""/g,'"');if(s.length===0)cell.t='z';else if(o.raw){cell.t='s';cell.v=s;}else if(s.trim().length===0){cell.t='s';cell.v=s;}else if(s.charCodeAt(0)==0x3D){if(s.charCodeAt(1)==0x22&&s.charCodeAt(s.length-1)==0x22){cell.t='s';cell.v=s.slice(2,-1).replace(/""/g,'"');}else if(fuzzyfmla(s)){cell.t='n';cell.f=s.slice(1);}else{cell.t='s';cell.v=s;}}else if(s=="TRUE"){cell.t='b';cell.v=true;}else if(s=="FALSE"){cell.t='b';cell.v=false;}else if(!isNaN(v=fuzzynum(s))){cell.t='n';if(o.cellText!==false)cell.w=s;cell.v=v;}else if(!isNaN(fuzzydate(s).getDate())||_re&&s.match(_re)){cell.z=o.dateNF||table_fmt[14];var k=0;if(_re&&s.match(_re)){s=dateNF_fix(s,o.dateNF,s.match(_re)||[]);k=1;}if(o.cellDates){cell.t='d';cell.v=parseDate(s,k);}else{cell.t='n';cell.v=datenum(parseDate(s,k));}if(o.cellText!==false)cell.w=SSF_format(cell.z,cell.v instanceof Date?datenum(cell.v):cell.v);if(!o.cellNF)delete cell.z;}else{cell.t='s';cell.v=s;}if(cell.t=='z'){}else if(o.dense){if(!ws[R])ws[R]=[];ws[R][C]=cell;}else ws[encode_cell({c:C,r:R})]=cell;start=end+1;startcc=str.charCodeAt(start);if(range.e.c<C)range.e.c=C;if(range.e.r<R)range.e.r=R;if(cc==sepcc)++C;else{C=0;++R;if(o.sheetRows&&o.sheetRows<=R)return true;}}outer:for(;end<str.length;++end){switch(cc=str.charCodeAt(end)){case 0x22:if(startcc===0x22)instr=!instr;break;case sepcc:case 0x0a:case 0x0d:if(!instr&&finish_cell())break outer;break;default:break;}}if(end-start>0)finish_cell();ws['!ref']=encode_range(range);return ws;}function prn_to_sheet_str(str,opts){if(!(opts&&opts.PRN))return dsv_to_sheet_str(str,opts);if(opts.FS)return dsv_to_sheet_str(str,opts);if(str.slice(0,4)=="sep=")return dsv_to_sheet_str(str,opts);if(str.indexOf("\t")>=0||str.indexOf(",")>=0||str.indexOf(";")>=0)return dsv_to_sheet_str(str,opts);return aoa_to_sheet(prn_to_aoa_str(str,opts),opts);}function prn_to_sheet(d,opts){var str="",bytes=opts.type=='string'?[0,0,0,0]:firstbyte(d,opts);switch(opts.type){case'base64':str=Base64_decode(d);break;case'binary':str=d;break;case'buffer':if(opts.codepage==65001)str=d.toString('utf8');else if(opts.codepage&&typeof $cptable!=='undefined')str=$cptable.utils.decode(opts.codepage,d);else str=has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d);break;case'array':str=cc2str(d);break;case'string':str=d;break;default:throw new Error("Unrecognized type "+opts.type);}if(bytes[0]==0xEF&&bytes[1]==0xBB&&bytes[2]==0xBF)str=utf8read(str.slice(3));else if(opts.type!='string'&&opts.type!='buffer'&&opts.codepage==65001)str=utf8read(str);else if(opts.type=='binary'&&typeof $cptable!=='undefined'&&opts.codepage)str=$cptable.utils.decode(opts.codepage,$cptable.utils.encode(28591,str));if(str.slice(0,19)=="socialcalc:version:")return ETH.to_sheet(opts.type=='string'?str:utf8read(str),opts);return prn_to_sheet_str(str,opts);}function prn_to_workbook(d,opts){return sheet_to_workbook(prn_to_sheet(d,opts),opts);}function sheet_to_prn(ws){var o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){var oo=[];for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null){oo.push("          ");continue;}var w=(cell.w||(format_cell(cell),cell.w)||"").slice(0,10);while(w.length<10){w+=" ";}oo.push(w+(C===0?" ":""));}o.push(oo.join(""));}return o.join("\n");}return{to_workbook:prn_to_workbook,to_sheet:prn_to_sheet,from_sheet:sheet_to_prn};}();function read_wb_ID(d,opts){var o=opts||{},OLD_WTF=!!o.WTF;o.WTF=true;try{var out=SYLK.to_workbook(d,o);o.WTF=OLD_WTF;return out;}catch(e){o.WTF=OLD_WTF;if(!e.message.match(/SYLK bad record ID/)&&OLD_WTF)throw e;return PRN.to_workbook(d,opts);}}var WK_=function(){function lotushopper(data,cb,opts){if(!data)return;prep_blob(data,data.l||0);var Enum=opts.Enum||WK1Enum;while(data.l<data.length){var RT=data.read_shift(2);var R=Enum[RT]||Enum[0xFFFF];var length=data.read_shift(2);var tgt=data.l+length;var d=R.f&&R.f(data,length,opts);data.l=tgt;if(cb(d,R,RT))return;}}function lotus_to_workbook(d,opts){switch(opts.type){case'base64':return lotus_to_workbook_buf(s2a(Base64_decode(d)),opts);case'binary':return lotus_to_workbook_buf(s2a(d),opts);case'buffer':case'array':return lotus_to_workbook_buf(d,opts);}throw"Unsupported type "+opts.type;}function lotus_to_workbook_buf(d,opts){if(!d)return d;var o=opts||{};if(DENSE!=null&&o.dense==null)o.dense=DENSE;var s=o.dense?[]:{},n="Sheet1",next_n="",sidx=0;var sheets={},snames=[],realnames=[];var refguess={s:{r:0,c:0},e:{r:0,c:0}};var sheetRows=o.sheetRows||0;if(d[2]==0x00){if(d[3]==0x08||d[3]==0x09){if(d.length>=16&&d[14]==0x05&&d[15]===0x6c)throw new Error("Unsupported Works 3 for Mac file");}}if(d[2]==0x02){o.Enum=WK1Enum;lotushopper(d,function(val,R,RT){switch(RT){case 0x00:o.vers=val;if(val>=0x1000)o.qpro=true;break;case 0x06:refguess=val;break;case 0xCC:if(val)next_n=val;break;case 0xDE:next_n=val;break;case 0x0F:case 0x33:if(!o.qpro)val[1].v=val[1].v.slice(1);case 0x0D:case 0x0E:case 0x10:if(RT==0x0E&&(val[2]&0x70)==0x70&&(val[2]&0x0F)>1&&(val[2]&0x0F)<15){val[1].z=o.dateNF||table_fmt[14];if(o.cellDates){val[1].t='d';val[1].v=numdate(val[1].v);}}if(o.qpro){if(val[3]>sidx){s["!ref"]=encode_range(refguess);sheets[n]=s;snames.push(n);s=o.dense?[]:{};refguess={s:{r:0,c:0},e:{r:0,c:0}};sidx=val[3];n=next_n||"Sheet"+(sidx+1);next_n="";}}var tmpcell=o.dense?(s[val[0].r]||[])[val[0].c]:s[encode_cell(val[0])];if(tmpcell){tmpcell.t=val[1].t;tmpcell.v=val[1].v;if(val[1].z!=null)tmpcell.z=val[1].z;if(val[1].f!=null)tmpcell.f=val[1].f;break;}if(o.dense){if(!s[val[0].r])s[val[0].r]=[];s[val[0].r][val[0].c]=val[1];}else s[encode_cell(val[0])]=val[1];break;default:}},o);}else if(d[2]==0x1A||d[2]==0x0E){o.Enum=WK3Enum;if(d[2]==0x0E){o.qpro=true;d.l=0;}lotushopper(d,function(val,R,RT){switch(RT){case 0xCC:n=val;break;case 0x16:val[1].v=val[1].v.slice(1);case 0x17:case 0x18:case 0x19:case 0x25:case 0x27:case 0x28:if(val[3]>sidx){s["!ref"]=encode_range(refguess);sheets[n]=s;snames.push(n);s=o.dense?[]:{};refguess={s:{r:0,c:0},e:{r:0,c:0}};sidx=val[3];n="Sheet"+(sidx+1);}if(sheetRows>0&&val[0].r>=sheetRows)break;if(o.dense){if(!s[val[0].r])s[val[0].r]=[];s[val[0].r][val[0].c]=val[1];}else s[encode_cell(val[0])]=val[1];if(refguess.e.c<val[0].c)refguess.e.c=val[0].c;if(refguess.e.r<val[0].r)refguess.e.r=val[0].r;break;case 0x1B:if(val[0x36b0])realnames[val[0x36b0][0]]=val[0x36b0][1];break;case 0x0601:realnames[val[0]]=val[1];if(val[0]==sidx)n=val[1];break;default:break;}},o);}else throw new Error("Unrecognized LOTUS BOF "+d[2]);s["!ref"]=encode_range(refguess);sheets[next_n||n]=s;snames.push(next_n||n);if(!realnames.length)return{SheetNames:snames,Sheets:sheets};var osheets={},rnames=[];for(var i=0;i<realnames.length;++i){if(sheets[snames[i]]){rnames.push(realnames[i]||snames[i]);osheets[realnames[i]]=sheets[realnames[i]]||sheets[snames[i]];}else{rnames.push(realnames[i]);osheets[realnames[i]]={"!ref":"A1"};}}return{SheetNames:rnames,Sheets:osheets};}function sheet_to_wk1(ws,opts){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write WK1 to JS string");var ba=buf_array();var range=safe_decode_range(ws["!ref"]);var dense=Array.isArray(ws);var cols=[];write_biff_rec(ba,0x00,write_BOF_WK1(0x0406));write_biff_rec(ba,0x06,write_RANGE(range));var max_R=Math.min(range.e.r,8191);for(var R=range.s.r;R<=max_R;++R){var rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);var ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell||cell.t=="z")continue;if(cell.t=="n"){if((cell.v|0)==cell.v&&cell.v>=-32768&&cell.v<=32767)write_biff_rec(ba,0x0d,write_INTEGER(R,C,cell.v));else write_biff_rec(ba,0x0e,write_NUMBER(R,C,cell.v));}else{var str=format_cell(cell);write_biff_rec(ba,0x0F,write_LABEL(R,C,str.slice(0,239)));}}}write_biff_rec(ba,0x01);return ba.end();}function book_to_wk3(wb,opts){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write WK3 to JS string");var ba=buf_array();write_biff_rec(ba,0x00,write_BOF_WK3(wb));for(var i=0,cnt=0;i<wb.SheetNames.length;++i){if((wb.Sheets[wb.SheetNames[i]]||{})["!ref"])write_biff_rec(ba,0x1b,write_XFORMAT_SHEETNAME(wb.SheetNames[i],cnt++));}var wsidx=0;for(i=0;i<wb.SheetNames.length;++i){var ws=wb.Sheets[wb.SheetNames[i]];if(!ws||!ws["!ref"])continue;var range=safe_decode_range(ws["!ref"]);var dense=Array.isArray(ws);var cols=[];var max_R=Math.min(range.e.r,8191);for(var R=range.s.r;R<=max_R;++R){var rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);var ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell||cell.t=="z")continue;if(cell.t=="n"){write_biff_rec(ba,0x17,write_NUMBER_17(R,C,wsidx,cell.v));}else{var str=format_cell(cell);write_biff_rec(ba,0x16,write_LABEL_16(R,C,wsidx,str.slice(0,239)));}}}++wsidx;}write_biff_rec(ba,0x01);return ba.end();}function write_BOF_WK1(v){var out=new_buf(2);out.write_shift(2,v);return out;}function write_BOF_WK3(wb){var out=new_buf(26);out.write_shift(2,0x1000);out.write_shift(2,0x0004);out.write_shift(4,0x0000);var rows=0,cols=0,wscnt=0;for(var i=0;i<wb.SheetNames.length;++i){var name=wb.SheetNames[i];var ws=wb.Sheets[name];if(!ws||!ws["!ref"])continue;++wscnt;var range=decode_range(ws["!ref"]);if(rows<range.e.r)rows=range.e.r;if(cols<range.e.c)cols=range.e.c;}if(rows>8191)rows=8191;out.write_shift(2,rows);out.write_shift(1,wscnt);out.write_shift(1,cols);out.write_shift(2,0x00);out.write_shift(2,0x00);out.write_shift(1,0x01);out.write_shift(1,0x02);out.write_shift(4,0);out.write_shift(4,0);return out;}function parse_RANGE(blob,length,opts){var o={s:{c:0,r:0},e:{c:0,r:0}};if(length==8&&opts.qpro){o.s.c=blob.read_shift(1);blob.l++;o.s.r=blob.read_shift(2);o.e.c=blob.read_shift(1);blob.l++;o.e.r=blob.read_shift(2);return o;}o.s.c=blob.read_shift(2);o.s.r=blob.read_shift(2);if(length==12&&opts.qpro)blob.l+=2;o.e.c=blob.read_shift(2);o.e.r=blob.read_shift(2);if(length==12&&opts.qpro)blob.l+=2;if(o.s.c==0xFFFF)o.s.c=o.e.c=o.s.r=o.e.r=0;return o;}function write_RANGE(range){var out=new_buf(8);out.write_shift(2,range.s.c);out.write_shift(2,range.s.r);out.write_shift(2,range.e.c);out.write_shift(2,range.e.r);return out;}function parse_cell(blob,length,opts){var o=[{c:0,r:0},{t:'n',v:0},0,0];if(opts.qpro&&opts.vers!=0x5120){o[0].c=blob.read_shift(1);o[3]=blob.read_shift(1);o[0].r=blob.read_shift(2);blob.l+=2;}else{o[2]=blob.read_shift(1);o[0].c=blob.read_shift(2);o[0].r=blob.read_shift(2);}return o;}function parse_LABEL(blob,length,opts){var tgt=blob.l+length;var o=parse_cell(blob,length,opts);o[1].t='s';if(opts.vers==0x5120){blob.l++;var len=blob.read_shift(1);o[1].v=blob.read_shift(len,'utf8');return o;}if(opts.qpro)blob.l++;o[1].v=blob.read_shift(tgt-blob.l,'cstr');return o;}function write_LABEL(R,C,s){var o=new_buf(7+s.length);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(1,0x27);for(var i=0;i<o.length;++i){var cc=s.charCodeAt(i);o.write_shift(1,cc>=0x80?0x5F:cc);}o.write_shift(1,0);return o;}function parse_INTEGER(blob,length,opts){var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(2,'i');return o;}function write_INTEGER(R,C,v){var o=new_buf(7);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(2,v,'i');return o;}function parse_NUMBER(blob,length,opts){var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(8,'f');return o;}function write_NUMBER(R,C,v){var o=new_buf(13);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(8,v,'f');return o;}function parse_FORMULA(blob,length,opts){var tgt=blob.l+length;var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(8,'f');if(opts.qpro)blob.l=tgt;else{var flen=blob.read_shift(2);wk1_fmla_to_csf(blob.slice(blob.l,blob.l+flen),o);blob.l+=flen;}return o;}function wk1_parse_rc(B,V,col){var rel=V&0x8000;V&=~0x8000;V=(rel?B:0)+(V>=0x2000?V-0x4000:V);return(rel?"":"$")+(col?encode_col(V):encode_row(V));}var FuncTab={0x33:["FALSE",0],0x34:["TRUE",0],0x46:["LEN",1],0x50:["SUM",69],0x51:["AVERAGEA",69],0x52:["COUNTA",69],0x53:["MINA",69],0x54:["MAXA",69],0x6F:["T",1]};var BinOpTab=["","","","","","","","","","+","-","*","/","^","=","<>","<=",">=","<",">","","","","","&","","","","","","",""];function wk1_fmla_to_csf(blob,o){prep_blob(blob,0);var out=[],argc=0,R="",C="",argL="",argR="";while(blob.l<blob.length){var cc=blob[blob.l++];switch(cc){case 0x00:out.push(blob.read_shift(8,'f'));break;case 0x01:{C=wk1_parse_rc(o[0].c,blob.read_shift(2),true);R=wk1_parse_rc(o[0].r,blob.read_shift(2),false);out.push(C+R);}break;case 0x02:{var c=wk1_parse_rc(o[0].c,blob.read_shift(2),true);var r=wk1_parse_rc(o[0].r,blob.read_shift(2),false);C=wk1_parse_rc(o[0].c,blob.read_shift(2),true);R=wk1_parse_rc(o[0].r,blob.read_shift(2),false);out.push(c+r+":"+C+R);}break;case 0x03:if(blob.l<blob.length){console.error("WK1 premature formula end");return;}break;case 0x04:out.push("("+out.pop()+")");break;case 0x05:out.push(blob.read_shift(2));break;case 0x06:{var Z="";while(cc=blob[blob.l++]){Z+=String.fromCharCode(cc);}out.push('"'+Z.replace(/"/g,'""')+'"');}break;case 0x08:out.push("-"+out.pop());break;case 0x17:out.push("+"+out.pop());break;case 0x16:out.push("NOT("+out.pop()+")");break;case 0x14:case 0x15:{argR=out.pop();argL=out.pop();out.push(["AND","OR"][cc-0x14]+"("+argL+","+argR+")");}break;default:if(cc<0x20&&BinOpTab[cc]){argR=out.pop();argL=out.pop();out.push(argL+BinOpTab[cc]+argR);}else if(FuncTab[cc]){argc=FuncTab[cc][1];if(argc==69)argc=blob[blob.l++];if(argc>out.length){console.error("WK1 bad formula parse 0x"+cc.toString(16)+":|"+out.join("|")+"|");return;}var args=out.slice(-argc);out.length-=argc;out.push(FuncTab[cc][0]+"("+args.join(",")+")");}else if(cc<=0x07)return console.error("WK1 invalid opcode "+cc.toString(16));else if(cc<=0x18)return console.error("WK1 unsupported op "+cc.toString(16));else if(cc<=0x1E)return console.error("WK1 invalid opcode "+cc.toString(16));else if(cc<=0x73)return console.error("WK1 unsupported function opcode "+cc.toString(16));else return console.error("WK1 unrecognized opcode "+cc.toString(16));}}if(out.length==1)o[1].f=""+out[0];else console.error("WK1 bad formula parse |"+out.join("|")+"|");}function parse_cell_3(blob){var o=[{c:0,r:0},{t:'n',v:0},0];o[0].r=blob.read_shift(2);o[3]=blob[blob.l++];o[0].c=blob[blob.l++];return o;}function parse_LABEL_16(blob,length){var o=parse_cell_3(blob,length);o[1].t='s';o[1].v=blob.read_shift(length-4,'cstr');return o;}function write_LABEL_16(R,C,wsidx,s){var o=new_buf(6+s.length);o.write_shift(2,R);o.write_shift(1,wsidx);o.write_shift(1,C);o.write_shift(1,0x27);for(var i=0;i<s.length;++i){var cc=s.charCodeAt(i);o.write_shift(1,cc>=0x80?0x5F:cc);}o.write_shift(1,0);return o;}function parse_NUMBER_18(blob,length){var o=parse_cell_3(blob,length);o[1].v=blob.read_shift(2);var v=o[1].v>>1;if(o[1].v&0x1){switch(v&0x07){case 0:v=(v>>3)*5000;break;case 1:v=(v>>3)*500;break;case 2:v=(v>>3)/20;break;case 3:v=(v>>3)/200;break;case 4:v=(v>>3)/2000;break;case 5:v=(v>>3)/20000;break;case 6:v=(v>>3)/16;break;case 7:v=(v>>3)/64;break;}}o[1].v=v;return o;}function parse_NUMBER_17(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(4);var v2=blob.read_shift(4);var e=blob.read_shift(2);if(e==0xFFFF){if(v1===0&&v2===0xC0000000){o[1].t="e";o[1].v=0x0F;}else if(v1===0&&v2===0xD0000000){o[1].t="e";o[1].v=0x2A;}else o[1].v=0;return o;}var s=e&0x8000;e=(e&0x7FFF)-16446;o[1].v=(1-s*2)*(v2*Math.pow(2,e+32)+v1*Math.pow(2,e));return o;}function write_NUMBER_17(R,C,wsidx,v){var o=new_buf(14);o.write_shift(2,R);o.write_shift(1,wsidx);o.write_shift(1,C);if(v==0){o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,0xFFFF);return o;}var s=0,e=0,v1=0,v2=0;if(v<0){s=1;v=-v;}e=(0,_log2.default)(v)|0;v/=Math.pow(2,e-31);v2=v>>>0;if((v2&0x80000000)==0){v/=2;++e;v2=v>>>0;}v-=v2;v2|=0x80000000;v2>>>=0;v*=Math.pow(2,32);v1=v>>>0;o.write_shift(4,v1);o.write_shift(4,v2);e+=0x3FFF+(s?0x8000:0);o.write_shift(2,e);return o;}function parse_FORMULA_19(blob,length){var o=parse_NUMBER_17(blob,14);blob.l+=length-14;return o;}function parse_NUMBER_25(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(4);o[1].v=v1>>6;return o;}function parse_NUMBER_27(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(8,'f');o[1].v=v1;return o;}function parse_FORMULA_28(blob,length){var o=parse_NUMBER_27(blob,14);blob.l+=length-10;return o;}function parse_SHEETNAMECS(blob,length){return blob[blob.l+length-1]==0?blob.read_shift(length,'cstr'):"";}function parse_SHEETNAMELP(blob,length){var len=blob[blob.l++];if(len>length-1)len=length-1;var o="";while(o.length<len){o+=String.fromCharCode(blob[blob.l++]);}return o;}function parse_SHEETINFOQP(blob,length,opts){if(!opts.qpro||length<21)return;var id=blob.read_shift(1);blob.l+=17;blob.l+=1;blob.l+=2;var nm=blob.read_shift(length-21,'cstr');return[id,nm];}function parse_XFORMAT(blob,length){var o={},tgt=blob.l+length;while(blob.l<tgt){var dt=blob.read_shift(2);if(dt==0x36b0){o[dt]=[0,""];o[dt][0]=blob.read_shift(2);while(blob[blob.l]){o[dt][1]+=String.fromCharCode(blob[blob.l]);blob.l++;}blob.l++;}}return o;}function write_XFORMAT_SHEETNAME(name,wsidx){var out=new_buf(5+name.length);out.write_shift(2,0x36b0);out.write_shift(2,wsidx);for(var i=0;i<name.length;++i){var cc=name.charCodeAt(i);out[out.l++]=cc>0x7F?0x5F:cc;}out[out.l++]=0;return out;}var WK1Enum={0x0000:{n:"BOF",f:parseuint16},0x0001:{n:"EOF"},0x0002:{n:"CALCMODE"},0x0003:{n:"CALCORDER"},0x0004:{n:"SPLIT"},0x0005:{n:"SYNC"},0x0006:{n:"RANGE",f:parse_RANGE},0x0007:{n:"WINDOW1"},0x0008:{n:"COLW1"},0x0009:{n:"WINTWO"},0x000A:{n:"COLW2"},0x000B:{n:"NAME"},0x000C:{n:"BLANK"},0x000D:{n:"INTEGER",f:parse_INTEGER},0x000E:{n:"NUMBER",f:parse_NUMBER},0x000F:{n:"LABEL",f:parse_LABEL},0x0010:{n:"FORMULA",f:parse_FORMULA},0x0018:{n:"TABLE"},0x0019:{n:"ORANGE"},0x001A:{n:"PRANGE"},0x001B:{n:"SRANGE"},0x001C:{n:"FRANGE"},0x001D:{n:"KRANGE1"},0x0020:{n:"HRANGE"},0x0023:{n:"KRANGE2"},0x0024:{n:"PROTEC"},0x0025:{n:"FOOTER"},0x0026:{n:"HEADER"},0x0027:{n:"SETUP"},0x0028:{n:"MARGINS"},0x0029:{n:"LABELFMT"},0x002A:{n:"TITLES"},0x002B:{n:"SHEETJS"},0x002D:{n:"GRAPH"},0x002E:{n:"NGRAPH"},0x002F:{n:"CALCCOUNT"},0x0030:{n:"UNFORMATTED"},0x0031:{n:"CURSORW12"},0x0032:{n:"WINDOW"},0x0033:{n:"STRING",f:parse_LABEL},0x0037:{n:"PASSWORD"},0x0038:{n:"LOCKED"},0x003C:{n:"QUERY"},0x003D:{n:"QUERYNAME"},0x003E:{n:"PRINT"},0x003F:{n:"PRINTNAME"},0x0040:{n:"GRAPH2"},0x0041:{n:"GRAPHNAME"},0x0042:{n:"ZOOM"},0x0043:{n:"SYMSPLIT"},0x0044:{n:"NSROWS"},0x0045:{n:"NSCOLS"},0x0046:{n:"RULER"},0x0047:{n:"NNAME"},0x0048:{n:"ACOMM"},0x0049:{n:"AMACRO"},0x004A:{n:"PARSE"},0x0066:{n:"PRANGES??"},0x0067:{n:"RRANGES??"},0x0068:{n:"FNAME??"},0x0069:{n:"MRANGES??"},0x00CC:{n:"SHEETNAMECS",f:parse_SHEETNAMECS},0x00DE:{n:"SHEETNAMELP",f:parse_SHEETNAMELP},0xFFFF:{n:""}};var WK3Enum={0x0000:{n:"BOF"},0x0001:{n:"EOF"},0x0002:{n:"PASSWORD"},0x0003:{n:"CALCSET"},0x0004:{n:"WINDOWSET"},0x0005:{n:"SHEETCELLPTR"},0x0006:{n:"SHEETLAYOUT"},0x0007:{n:"COLUMNWIDTH"},0x0008:{n:"HIDDENCOLUMN"},0x0009:{n:"USERRANGE"},0x000A:{n:"SYSTEMRANGE"},0x000B:{n:"ZEROFORCE"},0x000C:{n:"SORTKEYDIR"},0x000D:{n:"FILESEAL"},0x000E:{n:"DATAFILLNUMS"},0x000F:{n:"PRINTMAIN"},0x0010:{n:"PRINTSTRING"},0x0011:{n:"GRAPHMAIN"},0x0012:{n:"GRAPHSTRING"},0x0013:{n:"??"},0x0014:{n:"ERRCELL"},0x0015:{n:"NACELL"},0x0016:{n:"LABEL16",f:parse_LABEL_16},0x0017:{n:"NUMBER17",f:parse_NUMBER_17},0x0018:{n:"NUMBER18",f:parse_NUMBER_18},0x0019:{n:"FORMULA19",f:parse_FORMULA_19},0x001A:{n:"FORMULA1A"},0x001B:{n:"XFORMAT",f:parse_XFORMAT},0x001C:{n:"DTLABELMISC"},0x001D:{n:"DTLABELCELL"},0x001E:{n:"GRAPHWINDOW"},0x001F:{n:"CPA"},0x0020:{n:"LPLAUTO"},0x0021:{n:"QUERY"},0x0022:{n:"HIDDENSHEET"},0x0023:{n:"??"},0x0025:{n:"NUMBER25",f:parse_NUMBER_25},0x0026:{n:"??"},0x0027:{n:"NUMBER27",f:parse_NUMBER_27},0x0028:{n:"FORMULA28",f:parse_FORMULA_28},0x008E:{n:"??"},0x0093:{n:"??"},0x0096:{n:"??"},0x0097:{n:"??"},0x0098:{n:"??"},0x0099:{n:"??"},0x009A:{n:"??"},0x009B:{n:"??"},0x009C:{n:"??"},0x00A3:{n:"??"},0x00AE:{n:"??"},0x00AF:{n:"??"},0x00B0:{n:"??"},0x00B1:{n:"??"},0x00B8:{n:"??"},0x00B9:{n:"??"},0x00BA:{n:"??"},0x00BB:{n:"??"},0x00BC:{n:"??"},0x00C3:{n:"??"},0x00C9:{n:"??"},0x00CC:{n:"SHEETNAMECS",f:parse_SHEETNAMECS},0x00CD:{n:"??"},0x00CE:{n:"??"},0x00CF:{n:"??"},0x00D0:{n:"??"},0x0100:{n:"??"},0x0103:{n:"??"},0x0104:{n:"??"},0x0105:{n:"??"},0x0106:{n:"??"},0x0107:{n:"??"},0x0109:{n:"??"},0x010A:{n:"??"},0x010B:{n:"??"},0x010C:{n:"??"},0x010E:{n:"??"},0x010F:{n:"??"},0x0180:{n:"??"},0x0185:{n:"??"},0x0186:{n:"??"},0x0189:{n:"??"},0x018C:{n:"??"},0x0200:{n:"??"},0x0202:{n:"??"},0x0201:{n:"??"},0x0204:{n:"??"},0x0205:{n:"??"},0x0280:{n:"??"},0x0281:{n:"??"},0x0282:{n:"??"},0x0283:{n:"??"},0x0284:{n:"??"},0x0285:{n:"??"},0x0286:{n:"??"},0x0287:{n:"??"},0x0288:{n:"??"},0x0292:{n:"??"},0x0293:{n:"??"},0x0294:{n:"??"},0x0295:{n:"??"},0x0296:{n:"??"},0x0299:{n:"??"},0x029A:{n:"??"},0x0300:{n:"??"},0x0304:{n:"??"},0x0601:{n:"SHEETINFOQP",f:parse_SHEETINFOQP},0x0640:{n:"??"},0x0642:{n:"??"},0x0701:{n:"??"},0x0702:{n:"??"},0x0703:{n:"??"},0x0704:{n:"??"},0x0780:{n:"??"},0x0800:{n:"??"},0x0801:{n:"??"},0x0804:{n:"??"},0x0A80:{n:"??"},0x2AF6:{n:"??"},0x3231:{n:"??"},0x6E49:{n:"??"},0x6F44:{n:"??"},0xFFFF:{n:""}};return{sheet_to_wk1:sheet_to_wk1,book_to_wk3:book_to_wk3,to_workbook:lotus_to_workbook};}();function parse_rpr(rpr){var font={},m=rpr.match(tagregex),i=0;var pass=false;if(m)for(;i!=m.length;++i){var y=parsexmltag(m[i]);switch(y[0].replace(/\w*:/g,"")){case'<condense':break;case'<extend':break;case'<shadow':if(!y.val)break;case'<shadow>':case'<shadow/>':font.shadow=1;break;case'</shadow>':break;case'<charset':if(y.val=='1')break;font.cp=CS2CP[parseInt(y.val,10)];break;case'<outline':if(!y.val)break;case'<outline>':case'<outline/>':font.outline=1;break;case'</outline>':break;case'<rFont':font.name=y.val;break;case'<sz':font.sz=y.val;break;case'<strike':if(!y.val)break;case'<strike>':case'<strike/>':font.strike=1;break;case'</strike>':break;case'<u':if(!y.val)break;switch(y.val){case'double':font.uval="double";break;case'singleAccounting':font.uval="single-accounting";break;case'doubleAccounting':font.uval="double-accounting";break;}case'<u>':case'<u/>':font.u=1;break;case'</u>':break;case'<b':if(y.val=='0')break;case'<b>':case'<b/>':font.b=1;break;case'</b>':break;case'<i':if(y.val=='0')break;case'<i>':case'<i/>':font.i=1;break;case'</i>':break;case'<color':if(y.rgb)font.color=y.rgb.slice(2,8);break;case'<color>':case'<color/>':case'</color>':break;case'<family':font.family=y.val;break;case'<family>':case'<family/>':case'</family>':break;case'<vertAlign':font.valign=y.val;break;case'<vertAlign>':case'<vertAlign/>':case'</vertAlign>':break;case'<scheme':break;case'<scheme>':case'<scheme/>':case'</scheme>':break;case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(y[0].charCodeAt(1)!==47&&!pass)throw new Error('Unrecognized rich format '+y[0]);}}return font;}var parse_rs=function(){var tregex=matchtag("t"),rpregex=matchtag("rPr");function parse_r(r){var t=r.match(tregex);if(!t)return{t:"s",v:""};var o={t:'s',v:unescapexml(t[1])};var rpr=r.match(rpregex);if(rpr)o.s=parse_rpr(rpr[1]);return o;}var rregex=/<(?:\w+:)?r>/g,rend=/<\/(?:\w+:)?r>/;return function parse_rs(rs){return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r){return r.v;});};}();var rs_to_html=function parse_rs_factory(){var nlregex=/(\r\n|\n)/g;function parse_rpr2(font,intro,outro){var style=[];if(font.u)style.push("text-decoration: underline;");if(font.uval)style.push("text-underline-style:"+font.uval+";");if(font.sz)style.push("font-size:"+font.sz+"pt;");if(font.outline)style.push("text-effect: outline;");if(font.shadow)style.push("text-shadow: auto;");intro.push('<span style="'+style.join("")+'">');if(font.b){intro.push("<b>");outro.push("</b>");}if(font.i){intro.push("<i>");outro.push("</i>");}if(font.strike){intro.push("<s>");outro.push("</s>");}var align=font.valign||"";if(align=="superscript"||align=="super")align="sup";else if(align=="subscript")align="sub";if(align!=""){intro.push("<"+align+">");outro.push("</"+align+">");}outro.push("</span>");return font;}function r_to_html(r){var terms=[[],r.v,[]];if(!r.v)return"";if(r.s)parse_rpr2(r.s,terms[0],terms[2]);return terms[0].join("")+terms[1].replace(nlregex,'<br/>')+terms[2].join("");}return function parse_rs(rs){return rs.map(r_to_html).join("");};}();var sitregex=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,sirregex=/<(?:\w+:)?r>/;var sirphregex=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function parse_si(x,opts){var html=opts?opts.cellHTML:true;var z={};if(!x)return{t:""};if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)){z.t=unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));z.r=utf8read(x);if(html)z.h=escapehtml(z.t);}else if(x.match(sirregex)){z.r=utf8read(x);z.t=unescapexml(utf8read((x.replace(sirphregex,'').match(sitregex)||[]).join("").replace(tagregex,"")));if(html)z.h=rs_to_html(parse_rs(z.r));}return z;}var sstr0=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;var sstr1=/<(?:\w+:)?(?:si|sstItem)>/g;var sstr2=/<\/(?:\w+:)?(?:si|sstItem)>/;function parse_sst_xml(data,opts){var s=[],ss="";if(!data)return s;var sst=data.match(sstr0);if(sst){ss=sst[2].replace(sstr1,"").split(sstr2);for(var i=0;i!=ss.length;++i){var o=parse_si(ss[i].trim(),opts);if(o!=null)s[s.length]=o;}sst=parsexmltag(sst[1]);s.Count=sst.count;s.Unique=sst.uniqueCount;}return s;}var straywsregex=/^\s|\s$|[\t\n\r]/;function write_sst_xml(sst,opts){if(!opts.bookSST)return"";var o=[XML_HEADER];o[o.length]=writextag('sst',null,{xmlns:XMLNS_main[0],count:sst.Count,uniqueCount:sst.Unique});for(var i=0;i!=sst.length;++i){if(sst[i]==null)continue;var s=sst[i];var sitag="<si>";if(s.r)sitag+=s.r;else{sitag+="<t";if(!s.t)s.t="";if(s.t.match(straywsregex))sitag+=' xml:space="preserve"';sitag+=">"+escapexml(s.t)+"</t>";}sitag+="</si>";o[o.length]=sitag;}if(o.length>2){o[o.length]='</sst>';o[1]=o[1].replace("/>",">");}return o.join("");}function parse_BrtBeginSst(data){return[data.read_shift(4),data.read_shift(4)];}function parse_sst_bin(data,opts){var s=[];var pass=false;recordhopper(data,function hopper_sst(val,R,RT){switch(RT){case 0x009F:s.Count=val[0];s.Unique=val[1];break;case 0x0013:s.push(val);break;case 0x00A0:return true;case 0x0023:pass=true;break;case 0x0024:pass=false;break;default:if(R.T){}if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}});return s;}function write_BrtBeginSst(sst,o){if(!o)o=new_buf(8);o.write_shift(4,sst.Count);o.write_shift(4,sst.Unique);return o;}var write_BrtSSTItem=write_RichStr;function write_sst_bin(sst){var ba=buf_array();write_record(ba,0x009F,write_BrtBeginSst(sst));for(var i=0;i<sst.length;++i){write_record(ba,0x0013,write_BrtSSTItem(sst[i]));}write_record(ba,0x00A0);return ba.end();}function _JS2ANSI(str){if(typeof $cptable!=='undefined')return $cptable.utils.encode(current_ansi,str);var o=[],oo=str.split("");for(var i=0;i<oo.length;++i){o[i]=oo[i].charCodeAt(0);}return o;}function parse_CRYPTOVersion(blob,length){var o={};o.Major=blob.read_shift(2);o.Minor=blob.read_shift(2);if(length>=4)blob.l+=length-4;return o;}function parse_DataSpaceVersionInfo(blob){var o={};o.id=blob.read_shift(0,'lpp4');o.R=parse_CRYPTOVersion(blob,4);o.U=parse_CRYPTOVersion(blob,4);o.W=parse_CRYPTOVersion(blob,4);return o;}function parse_DataSpaceMapEntry(blob){var len=blob.read_shift(4);var end=blob.l+len-4;var o={};var cnt=blob.read_shift(4);var comps=[];while(cnt-->0){comps.push({t:blob.read_shift(4),v:blob.read_shift(0,'lpp4')});}o.name=blob.read_shift(0,'lpp4');o.comps=comps;if(blob.l!=end)throw new Error("Bad DataSpaceMapEntry: "+blob.l+" != "+end);return o;}function parse_DataSpaceMap(blob){var o=[];blob.l+=4;var cnt=blob.read_shift(4);while(cnt-->0){o.push(parse_DataSpaceMapEntry(blob));}return o;}function parse_DataSpaceDefinition(blob){var o=[];blob.l+=4;var cnt=blob.read_shift(4);while(cnt-->0){o.push(blob.read_shift(0,'lpp4'));}return o;}function parse_TransformInfoHeader(blob){var o={};blob.read_shift(4);blob.l+=4;o.id=blob.read_shift(0,'lpp4');o.name=blob.read_shift(0,'lpp4');o.R=parse_CRYPTOVersion(blob,4);o.U=parse_CRYPTOVersion(blob,4);o.W=parse_CRYPTOVersion(blob,4);return o;}function parse_Primary(blob){var hdr=parse_TransformInfoHeader(blob);hdr.ename=blob.read_shift(0,'8lpp4');hdr.blksz=blob.read_shift(4);hdr.cmode=blob.read_shift(4);if(blob.read_shift(4)!=0x04)throw new Error("Bad !Primary record");return hdr;}function parse_EncryptionHeader(blob,length){var tgt=blob.l+length;var o={};o.Flags=blob.read_shift(4)&0x3F;blob.l+=4;o.AlgID=blob.read_shift(4);var valid=false;switch(o.AlgID){case 0x660E:case 0x660F:case 0x6610:valid=o.Flags==0x24;break;case 0x6801:valid=o.Flags==0x04;break;case 0:valid=o.Flags==0x10||o.Flags==0x04||o.Flags==0x24;break;default:throw'Unrecognized encryption algorithm: '+o.AlgID;}if(!valid)throw new Error("Encryption Flags/AlgID mismatch");o.AlgIDHash=blob.read_shift(4);o.KeySize=blob.read_shift(4);o.ProviderType=blob.read_shift(4);blob.l+=8;o.CSPName=blob.read_shift(tgt-blob.l>>1,'utf16le');blob.l=tgt;return o;}function parse_EncryptionVerifier(blob,length){var o={},tgt=blob.l+length;blob.l+=4;o.Salt=blob.slice(blob.l,blob.l+16);blob.l+=16;o.Verifier=blob.slice(blob.l,blob.l+16);blob.l+=16;blob.read_shift(4);o.VerifierHash=blob.slice(blob.l,tgt);blob.l=tgt;return o;}function parse_EncryptionInfo(blob){var vers=parse_CRYPTOVersion(blob);switch(vers.Minor){case 0x02:return[vers.Minor,parse_EncInfoStd(blob,vers)];case 0x03:return[vers.Minor,parse_EncInfoExt(blob,vers)];case 0x04:return[vers.Minor,parse_EncInfoAgl(blob,vers)];}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+vers.Minor);}function parse_EncInfoStd(blob){var flags=blob.read_shift(4);if((flags&0x3F)!=0x24)throw new Error("EncryptionInfo mismatch");var sz=blob.read_shift(4);var hdr=parse_EncryptionHeader(blob,sz);var verifier=parse_EncryptionVerifier(blob,blob.length-blob.l);return{t:"Std",h:hdr,v:verifier};}function parse_EncInfoExt(){throw new Error("File is password-protected: ECMA-376 Extensible");}function parse_EncInfoAgl(blob){var KeyData=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];blob.l+=4;var xml=blob.read_shift(blob.length-blob.l,'utf8');var o={};xml.replace(tagregex,function xml_agile(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;case'<encryption':case'</encryption>':break;case'<keyData':KeyData.forEach(function(k){o[k]=y[k];});break;case'<dataIntegrity':o.encryptedHmacKey=y.encryptedHmacKey;o.encryptedHmacValue=y.encryptedHmacValue;break;case'<keyEncryptors>':case'<keyEncryptors':o.encs=[];break;case'</keyEncryptors>':break;case'<keyEncryptor':o.uri=y.uri;break;case'</keyEncryptor>':break;case'<encryptedKey':o.encs.push(y);break;default:throw y[0];}});return o;}function parse_RC4CryptoHeader(blob,length){var o={};var vers=o.EncryptionVersionInfo=parse_CRYPTOVersion(blob,4);length-=4;if(vers.Minor!=2)throw new Error('unrecognized minor version code: '+vers.Minor);if(vers.Major>4||vers.Major<2)throw new Error('unrecognized major version code: '+vers.Major);o.Flags=blob.read_shift(4);length-=4;var sz=blob.read_shift(4);length-=4;o.EncryptionHeader=parse_EncryptionHeader(blob,sz);length-=sz;o.EncryptionVerifier=parse_EncryptionVerifier(blob,length);return o;}function parse_RC4Header(blob){var o={};var vers=o.EncryptionVersionInfo=parse_CRYPTOVersion(blob,4);if(vers.Major!=1||vers.Minor!=1)throw'unrecognized version code '+vers.Major+' : '+vers.Minor;o.Salt=blob.read_shift(16);o.EncryptedVerifier=blob.read_shift(16);o.EncryptedVerifierHash=blob.read_shift(16);return o;}function crypto_CreatePasswordVerifier_Method1(Password){var Verifier=0x0000,PasswordArray;var PasswordDecoded=_JS2ANSI(Password);var len=PasswordDecoded.length+1,i,PasswordByte;var Intermediate1,Intermediate2,Intermediate3;PasswordArray=new_raw_buf(len);PasswordArray[0]=PasswordDecoded.length;for(i=1;i!=len;++i){PasswordArray[i]=PasswordDecoded[i-1];}for(i=len-1;i>=0;--i){PasswordByte=PasswordArray[i];Intermediate1=(Verifier&0x4000)===0x0000?0:1;Intermediate2=Verifier<<1&0x7FFF;Intermediate3=Intermediate1|Intermediate2;Verifier=Intermediate3^PasswordByte;}return Verifier^0xCE4B;}var crypto_CreateXorArray_Method1=function(){var PadArray=[0xBB,0xFF,0xFF,0xBA,0xFF,0xFF,0xB9,0x80,0x00,0xBE,0x0F,0x00,0xBF,0x0F,0x00];var InitialCode=[0xE1F0,0x1D0F,0xCC9C,0x84C0,0x110C,0x0E10,0xF1CE,0x313E,0x1872,0xE139,0xD40F,0x84F9,0x280C,0xA96A,0x4EC3];var XorMatrix=[0xAEFC,0x4DD9,0x9BB2,0x2745,0x4E8A,0x9D14,0x2A09,0x7B61,0xF6C2,0xFDA5,0xEB6B,0xC6F7,0x9DCF,0x2BBF,0x4563,0x8AC6,0x05AD,0x0B5A,0x16B4,0x2D68,0x5AD0,0x0375,0x06EA,0x0DD4,0x1BA8,0x3750,0x6EA0,0xDD40,0xD849,0xA0B3,0x5147,0xA28E,0x553D,0xAA7A,0x44D5,0x6F45,0xDE8A,0xAD35,0x4A4B,0x9496,0x390D,0x721A,0xEB23,0xC667,0x9CEF,0x29FF,0x53FE,0xA7FC,0x5FD9,0x47D3,0x8FA6,0x0F6D,0x1EDA,0x3DB4,0x7B68,0xF6D0,0xB861,0x60E3,0xC1C6,0x93AD,0x377B,0x6EF6,0xDDEC,0x45A0,0x8B40,0x06A1,0x0D42,0x1A84,0x3508,0x6A10,0xAA51,0x4483,0x8906,0x022D,0x045A,0x08B4,0x1168,0x76B4,0xED68,0xCAF1,0x85C3,0x1BA7,0x374E,0x6E9C,0x3730,0x6E60,0xDCC0,0xA9A1,0x4363,0x86C6,0x1DAD,0x3331,0x6662,0xCCC4,0x89A9,0x0373,0x06E6,0x0DCC,0x1021,0x2042,0x4084,0x8108,0x1231,0x2462,0x48C4];var Ror=function Ror(Byte){return(Byte/2|Byte*128)&0xFF;};var XorRor=function XorRor(byte1,byte2){return Ror(byte1^byte2);};var CreateXorKey_Method1=function CreateXorKey_Method1(Password){var XorKey=InitialCode[Password.length-1];var CurrentElement=0x68;for(var i=Password.length-1;i>=0;--i){var Char=Password[i];for(var j=0;j!=7;++j){if(Char&0x40)XorKey^=XorMatrix[CurrentElement];Char*=2;--CurrentElement;}}return XorKey;};return function(password){var Password=_JS2ANSI(password);var XorKey=CreateXorKey_Method1(Password);var Index=Password.length;var ObfuscationArray=new_raw_buf(16);for(var i=0;i!=16;++i){ObfuscationArray[i]=0x00;}var Temp,PasswordLastChar,PadIndex;if((Index&1)===1){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[0],Temp);--Index;Temp=XorKey&0xFF;PasswordLastChar=Password[Password.length-1];ObfuscationArray[Index]=XorRor(PasswordLastChar,Temp);}while(Index>0){--Index;Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;Temp=XorKey&0xFF;ObfuscationArray[Index]=XorRor(Password[Index],Temp);}Index=15;PadIndex=15-Password.length;while(PadIndex>0){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[PadIndex],Temp);--Index;--PadIndex;Temp=XorKey&0xFF;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;--PadIndex;}return ObfuscationArray;};}();var crypto_DecryptData_Method1=function crypto_DecryptData_Method1(password,Data,XorArrayIndex,XorArray,O){if(!O)O=Data;if(!XorArray)XorArray=crypto_CreateXorArray_Method1(password);var Index,Value;for(Index=0;Index!=Data.length;++Index){Value=Data[Index];Value^=XorArray[XorArrayIndex];Value=(Value>>5|Value<<3)&0xFF;O[Index]=Value;++XorArrayIndex;}return[O,XorArrayIndex,XorArray];};var crypto_MakeXorDecryptor=function crypto_MakeXorDecryptor(password){var XorArrayIndex=0,XorArray=crypto_CreateXorArray_Method1(password);return function(Data){var O=crypto_DecryptData_Method1("",Data,XorArrayIndex,XorArray);XorArrayIndex=O[1];return O[0];};};function parse_XORObfuscation(blob,length,opts,out){var o={key:parseuint16(blob),verificationBytes:parseuint16(blob)};if(opts.password)o.verifier=crypto_CreatePasswordVerifier_Method1(opts.password);out.valid=o.verificationBytes===o.verifier;if(out.valid)out.insitu=crypto_MakeXorDecryptor(opts.password);return o;}function parse_FilePassHeader(blob,length,oo){var o=oo||{};o.Info=blob.read_shift(2);blob.l-=2;if(o.Info===1)o.Data=parse_RC4Header(blob,length);else o.Data=parse_RC4CryptoHeader(blob,length);return o;}function parse_FilePass(blob,length,opts){var o={Type:opts.biff>=8?blob.read_shift(2):0};if(o.Type)parse_FilePassHeader(blob,length-2,o);else parse_XORObfuscation(blob,opts.biff>=8?length:length-2,opts,o);return o;}var RTF=function(){function rtf_to_sheet(d,opts){switch(opts.type){case'base64':return rtf_to_sheet_str(Base64_decode(d),opts);case'binary':return rtf_to_sheet_str(d,opts);case'buffer':return rtf_to_sheet_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return rtf_to_sheet_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function rtf_to_sheet_str(str,opts){var o=opts||{};var ws=o.dense?[]:{};var rows=str.match(/\\trowd.*?\\row\b/g);if(!rows.length)throw new Error("RTF missing table");var range={s:{c:0,r:0},e:{c:0,r:rows.length-1}};rows.forEach(function(rowtf,R){if(Array.isArray(ws))ws[R]=[];var rtfre=/\\\w+\b/g;var last_index=0;var res;var C=-1;while(res=rtfre.exec(rowtf)){switch(res[0]){case"\\cell":var data=rowtf.slice(last_index,rtfre.lastIndex-res[0].length);if(data[0]==" ")data=data.slice(1);++C;if(data.length){var cell={v:data,t:"s"};if(Array.isArray(ws))ws[R][C]=cell;else ws[encode_cell({r:R,c:C})]=cell;}break;}last_index=rtfre.lastIndex;}if(C>range.e.c)range.e.c=C;});ws['!ref']=encode_range(range);return ws;}function rtf_to_workbook(d,opts){return sheet_to_workbook(rtf_to_sheet(d,opts),opts);}function sheet_to_rtf(ws){var o=["{\\rtf1\\ansi"];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){o.push("\\trowd\\trautofit1");for(var C=r.s.c;C<=r.e.c;++C){o.push("\\cellx"+(C+1));}o.push("\\pard\\intbl");for(C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null&&(!cell.f||cell.F))continue;o.push(" "+(cell.w||(format_cell(cell),cell.w)));o.push("\\cell");}o.push("\\pard\\intbl\\row");}return o.join("")+"}";}return{to_workbook:rtf_to_workbook,to_sheet:rtf_to_sheet,from_sheet:sheet_to_rtf};}();function hex2RGB(h){var o=h.slice(h[0]==="#"?1:0).slice(0,6);return[parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];}function rgb2Hex(rgb){for(var i=0,o=1;i!=3;++i){o=o*256+(rgb[i]>255?255:rgb[i]<0?0:rgb[i]);}return o.toString(16).toUpperCase().slice(1);}function rgb2HSL(rgb){var R=rgb[0]/255,G=rgb[1]/255,B=rgb[2]/255;var M=Math.max(R,G,B),m=Math.min(R,G,B),C=M-m;if(C===0)return[0,0,R];var H6=0,S=0,L2=M+m;S=C/(L2>1?2-L2:L2);switch(M){case R:H6=((G-B)/C+6)%6;break;case G:H6=(B-R)/C+2;break;case B:H6=(R-G)/C+4;break;}return[H6/6,S,L2/2];}function hsl2RGB(hsl){var H=hsl[0],S=hsl[1],L=hsl[2];var C=S*2*(L<0.5?L:1-L),m=L-C/2;var rgb=[m,m,m],h6=6*H;var X;if(S!==0)switch(h6|0){case 0:case 6:X=C*h6;rgb[0]+=C;rgb[1]+=X;break;case 1:X=C*(2-h6);rgb[0]+=X;rgb[1]+=C;break;case 2:X=C*(h6-2);rgb[1]+=C;rgb[2]+=X;break;case 3:X=C*(4-h6);rgb[1]+=X;rgb[2]+=C;break;case 4:X=C*(h6-4);rgb[2]+=C;rgb[0]+=X;break;case 5:X=C*(6-h6);rgb[2]+=X;rgb[0]+=C;break;}for(var i=0;i!=3;++i){rgb[i]=Math.round(rgb[i]*255);}return rgb;}function rgb_tint(hex,tint){if(tint===0)return hex;var hsl=rgb2HSL(hex2RGB(hex));if(tint<0)hsl[2]=hsl[2]*(1+tint);else hsl[2]=1-(1-hsl[2])*(1-tint);return rgb2Hex(hsl2RGB(hsl));}var DEF_MDW=6,MAX_MDW=15,MIN_MDW=1,MDW=DEF_MDW;function width2px(width){return Math.floor((width+Math.round(128/MDW)/256)*MDW);}function px2char(px){return Math.floor((px-5)/MDW*100+0.5)/100;}function char2width(chr){return Math.round((chr*MDW+5)/MDW*256)/256;}function cycle_width(collw){return char2width(px2char(width2px(collw)));}function find_mdw_colw(collw){var delta=Math.abs(collw-cycle_width(collw)),_MDW=MDW;if(delta>0.005)for(MDW=MIN_MDW;MDW<MAX_MDW;++MDW){if(Math.abs(collw-cycle_width(collw))<=delta){delta=Math.abs(collw-cycle_width(collw));_MDW=MDW;}}MDW=_MDW;}function process_col(coll){if(coll.width){coll.wpx=width2px(coll.width);coll.wch=px2char(coll.wpx);coll.MDW=MDW;}else if(coll.wpx){coll.wch=px2char(coll.wpx);coll.width=char2width(coll.wch);coll.MDW=MDW;}else if(typeof coll.wch=='number'){coll.width=char2width(coll.wch);coll.wpx=width2px(coll.width);coll.MDW=MDW;}if(coll.customWidth)delete coll.customWidth;}var DEF_PPI=96,PPI=DEF_PPI;function px2pt(px){return px*96/PPI;}function pt2px(pt){return pt*PPI/96;}var XLMLPatternTypeMap={"None":"none","Solid":"solid","Gray50":"mediumGray","Gray75":"darkGray","Gray25":"lightGray","HorzStripe":"darkHorizontal","VertStripe":"darkVertical","ReverseDiagStripe":"darkDown","DiagStripe":"darkUp","DiagCross":"darkGrid","ThickDiagCross":"darkTrellis","ThinHorzStripe":"lightHorizontal","ThinVertStripe":"lightVertical","ThinReverseDiagStripe":"lightDown","ThinHorzCross":"lightGrid"};function parse_borders(t,styles,themes,opts){styles.Borders=[];var border={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<borders':case'<borders>':case'</borders>':break;case'<border':case'<border>':case'<border/>':border={};if(y.diagonalUp)border.diagonalUp=parsexmlbool(y.diagonalUp);if(y.diagonalDown)border.diagonalDown=parsexmlbool(y.diagonalDown);styles.Borders.push(border);break;case'</border>':break;case'<left/>':break;case'<left':case'<left>':break;case'</left>':break;case'<right/>':break;case'<right':case'<right>':break;case'</right>':break;case'<top/>':break;case'<top':case'<top>':break;case'</top>':break;case'<bottom/>':break;case'<bottom':case'<bottom>':break;case'</bottom>':break;case'<diagonal':case'<diagonal>':case'<diagonal/>':break;case'</diagonal>':break;case'<horizontal':case'<horizontal>':case'<horizontal/>':break;case'</horizontal>':break;case'<vertical':case'<vertical>':case'<vertical/>':break;case'</vertical>':break;case'<start':case'<start>':case'<start/>':break;case'</start>':break;case'<end':case'<end>':case'<end/>':break;case'</end>':break;case'<color':case'<color>':break;case'<color/>':case'</color>':break;case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in borders');}}});}function parse_fills(t,styles,themes,opts){styles.Fills=[];var fill={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<fills':case'<fills>':case'</fills>':break;case'<fill>':case'<fill':case'<fill/>':fill={};styles.Fills.push(fill);break;case'</fill>':break;case'<gradientFill>':break;case'<gradientFill':case'</gradientFill>':styles.Fills.push(fill);fill={};break;case'<patternFill':case'<patternFill>':if(y.patternType)fill.patternType=y.patternType;break;case'<patternFill/>':case'</patternFill>':break;case'<bgColor':if(!fill.bgColor)fill.bgColor={};if(y.indexed)fill.bgColor.indexed=parseInt(y.indexed,10);if(y.theme)fill.bgColor.theme=parseInt(y.theme,10);if(y.tint)fill.bgColor.tint=parseFloat(y.tint);if(y.rgb)fill.bgColor.rgb=y.rgb.slice(-6);break;case'<bgColor/>':case'</bgColor>':break;case'<fgColor':if(!fill.fgColor)fill.fgColor={};if(y.theme)fill.fgColor.theme=parseInt(y.theme,10);if(y.tint)fill.fgColor.tint=parseFloat(y.tint);if(y.rgb!=null)fill.fgColor.rgb=y.rgb.slice(-6);break;case'<fgColor/>':case'</fgColor>':break;case'<stop':case'<stop/>':break;case'</stop>':break;case'<color':case'<color/>':break;case'</color>':break;case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in fills');}}});}function parse_fonts(t,styles,themes,opts){styles.Fonts=[];var font={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<fonts':case'<fonts>':case'</fonts>':break;case'<font':case'<font>':break;case'</font>':case'<font/>':styles.Fonts.push(font);font={};break;case'<name':if(y.val)font.name=utf8read(y.val);break;case'<name/>':case'</name>':break;case'<b':font.bold=y.val?parsexmlbool(y.val):1;break;case'<b/>':font.bold=1;break;case'<i':font.italic=y.val?parsexmlbool(y.val):1;break;case'<i/>':font.italic=1;break;case'<u':switch(y.val){case"none":font.underline=0x00;break;case"single":font.underline=0x01;break;case"double":font.underline=0x02;break;case"singleAccounting":font.underline=0x21;break;case"doubleAccounting":font.underline=0x22;break;}break;case'<u/>':font.underline=1;break;case'<strike':font.strike=y.val?parsexmlbool(y.val):1;break;case'<strike/>':font.strike=1;break;case'<outline':font.outline=y.val?parsexmlbool(y.val):1;break;case'<outline/>':font.outline=1;break;case'<shadow':font.shadow=y.val?parsexmlbool(y.val):1;break;case'<shadow/>':font.shadow=1;break;case'<condense':font.condense=y.val?parsexmlbool(y.val):1;break;case'<condense/>':font.condense=1;break;case'<extend':font.extend=y.val?parsexmlbool(y.val):1;break;case'<extend/>':font.extend=1;break;case'<sz':if(y.val)font.sz=+y.val;break;case'<sz/>':case'</sz>':break;case'<vertAlign':if(y.val)font.vertAlign=y.val;break;case'<vertAlign/>':case'</vertAlign>':break;case'<family':if(y.val)font.family=parseInt(y.val,10);break;case'<family/>':case'</family>':break;case'<scheme':if(y.val)font.scheme=y.val;break;case'<scheme/>':case'</scheme>':break;case'<charset':if(y.val=='1')break;y.codepage=CS2CP[parseInt(y.val,10)];break;case'<color':if(!font.color)font.color={};if(y.auto)font.color.auto=parsexmlbool(y.auto);if(y.rgb)font.color.rgb=y.rgb.slice(-6);else if(y.indexed){font.color.index=parseInt(y.indexed,10);var icv=XLSIcv[font.color.index];if(font.color.index==81)icv=XLSIcv[1];if(!icv)icv=XLSIcv[1];font.color.rgb=icv[0].toString(16)+icv[1].toString(16)+icv[2].toString(16);}else if(y.theme){font.color.theme=parseInt(y.theme,10);if(y.tint)font.color.tint=parseFloat(y.tint);if(y.theme&&themes.themeElements&&themes.themeElements.clrScheme){font.color.rgb=rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb,font.color.tint||0);}}break;case'<color/>':case'</color>':break;case'<AlternateContent':pass=true;break;case'</AlternateContent>':pass=false;break;case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in fonts');}}});}function parse_numFmts(t,styles,opts){styles.NumberFmt=[];var k=keys(table_fmt);for(var i=0;i<k.length;++i){styles.NumberFmt[k[i]]=table_fmt[k[i]];}var m=t[0].match(tagregex);if(!m)return;for(i=0;i<m.length;++i){var y=parsexmltag(m[i]);switch(strip_ns(y[0])){case'<numFmts':case'</numFmts>':case'<numFmts/>':case'<numFmts>':break;case'<numFmt':{var f=unescapexml(utf8read(y.formatCode)),j=parseInt(y.numFmtId,10);styles.NumberFmt[j]=f;if(j>0){if(j>0x188){for(j=0x188;j>0x3c;--j){if(styles.NumberFmt[j]==null)break;}styles.NumberFmt[j]=f;}SSF_load(f,j);}}break;case'</numFmt>':break;default:if(opts.WTF)throw new Error('unrecognized '+y[0]+' in numFmts');}}}function write_numFmts(NF){var o=["<numFmts>"];[[5,8],[23,26],[41,44],[50,392]].forEach(function(r){for(var i=r[0];i<=r[1];++i){if(NF[i]!=null)o[o.length]=writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])});}});if(o.length===1)return"";o[o.length]="</numFmts>";o[0]=writextag('numFmts',null,{count:o.length-2}).replace("/>",">");return o.join("");}var cellXF_uint=["numFmtId","fillId","fontId","borderId","xfId"];var cellXF_bool=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];function parse_cellXfs(t,styles,opts){styles.CellXf=[];var xf;var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x),i=0;switch(strip_ns(y[0])){case'<cellXfs':case'<cellXfs>':case'<cellXfs/>':case'</cellXfs>':break;case'<xf':case'<xf/>':xf=y;delete xf[0];for(i=0;i<cellXF_uint.length;++i){if(xf[cellXF_uint[i]])xf[cellXF_uint[i]]=parseInt(xf[cellXF_uint[i]],10);}for(i=0;i<cellXF_bool.length;++i){if(xf[cellXF_bool[i]])xf[cellXF_bool[i]]=parsexmlbool(xf[cellXF_bool[i]]);}if(styles.NumberFmt&&xf.numFmtId>0x188){for(i=0x188;i>0x3c;--i){if(styles.NumberFmt[xf.numFmtId]==styles.NumberFmt[i]){xf.numFmtId=i;break;}}}styles.CellXf.push(xf);break;case'</xf>':break;case'<alignment':case'<alignment/>':var alignment={};if(y.vertical)alignment.vertical=y.vertical;if(y.horizontal)alignment.horizontal=y.horizontal;if(y.textRotation!=null)alignment.textRotation=y.textRotation;if(y.indent)alignment.indent=y.indent;if(y.wrapText)alignment.wrapText=parsexmlbool(y.wrapText);xf.alignment=alignment;break;case'</alignment>':break;case'<protection':break;case'</protection>':case'<protection/>':break;case'<AlternateContent':pass=true;break;case'</AlternateContent>':pass=false;break;case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in cellXfs');}}});}function write_cellXfs(cellXfs){var o=[];o[o.length]=writextag('cellXfs',null);cellXfs.forEach(function(c){o[o.length]=writextag('xf',null,c);});o[o.length]="</cellXfs>";if(o.length===2)return"";o[0]=writextag('cellXfs',null,{count:o.length-2}).replace("/>",">");return o.join("");}var parse_sty_xml=function make_pstyx(){var numFmtRegex=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;var cellXfRegex=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;var fillsRegex=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;var fontsRegex=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;var bordersRegex=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;return function parse_sty_xml(data,themes,opts){var styles={};if(!data)return styles;data=data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");var t;if(t=data.match(numFmtRegex))parse_numFmts(t,styles,opts);if(t=data.match(fontsRegex))parse_fonts(t,styles,themes,opts);if(t=data.match(fillsRegex))parse_fills(t,styles,themes,opts);if(t=data.match(bordersRegex))parse_borders(t,styles,themes,opts);if(t=data.match(cellXfRegex))parse_cellXfs(t,styles,opts);return styles;};}();function write_sty_xml(wb,opts){var o=[XML_HEADER,writextag('styleSheet',null,{'xmlns':XMLNS_main[0],'xmlns:vt':XMLNS.vt})],w;if(wb.SSF&&(w=write_numFmts(wb.SSF))!=null)o[o.length]=w;o[o.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';o[o.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';o[o.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';o[o.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(w=write_cellXfs(opts.cellXfs))o[o.length]=w;o[o.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';o[o.length]='<dxfs count="0"/>';o[o.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(o.length>2){o[o.length]='</styleSheet>';o[1]=o[1].replace("/>",">");}return o.join("");}function parse_BrtFmt(data,length){var numFmtId=data.read_shift(2);var stFmtCode=parse_XLWideString(data,length-2);return[numFmtId,stFmtCode];}function write_BrtFmt(i,f,o){if(!o)o=new_buf(6+4*f.length);o.write_shift(2,i);write_XLWideString(f,o);var out=o.length>o.l?o.slice(0,o.l):o;if(o.l==null)o.l=o.length;return out;}function parse_BrtFont(data,length,opts){var out={};out.sz=data.read_shift(2)/20;var grbit=parse_FontFlags(data,2,opts);if(grbit.fItalic)out.italic=1;if(grbit.fCondense)out.condense=1;if(grbit.fExtend)out.extend=1;if(grbit.fShadow)out.shadow=1;if(grbit.fOutline)out.outline=1;if(grbit.fStrikeout)out.strike=1;var bls=data.read_shift(2);if(bls===0x02BC)out.bold=1;switch(data.read_shift(2)){case 1:out.vertAlign="superscript";break;case 2:out.vertAlign="subscript";break;}var underline=data.read_shift(1);if(underline!=0)out.underline=underline;var family=data.read_shift(1);if(family>0)out.family=family;var bCharSet=data.read_shift(1);if(bCharSet>0)out.charset=bCharSet;data.l++;out.color=parse_BrtColor(data,8);switch(data.read_shift(1)){case 1:out.scheme="major";break;case 2:out.scheme="minor";break;}out.name=parse_XLWideString(data,length-21);return out;}function write_BrtFont(font,o){if(!o)o=new_buf(25+4*32);o.write_shift(2,font.sz*20);write_FontFlags(font,o);o.write_shift(2,font.bold?0x02BC:0x0190);var sss=0;if(font.vertAlign=="superscript")sss=1;else if(font.vertAlign=="subscript")sss=2;o.write_shift(2,sss);o.write_shift(1,font.underline||0);o.write_shift(1,font.family||0);o.write_shift(1,font.charset||0);o.write_shift(1,0);write_BrtColor(font.color,o);var scheme=0;if(font.scheme=="major")scheme=1;if(font.scheme=="minor")scheme=2;o.write_shift(1,scheme);write_XLWideString(font.name,o);return o.length>o.l?o.slice(0,o.l):o;}var XLSBFillPTNames=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var rev_XLSBFillPTNames;var parse_BrtFill=parsenoop;function write_BrtFill(fill,o){if(!o)o=new_buf(4*3+8*7+16*1);if(!rev_XLSBFillPTNames)rev_XLSBFillPTNames=evert(XLSBFillPTNames);var fls=rev_XLSBFillPTNames[fill.patternType];if(fls==null)fls=0x28;o.write_shift(4,fls);var j=0;if(fls!=0x28){write_BrtColor({auto:1},o);write_BrtColor({auto:1},o);for(;j<12;++j){o.write_shift(4,0);}}else{for(;j<4;++j){o.write_shift(4,0);}for(;j<12;++j){o.write_shift(4,0);}}return o.length>o.l?o.slice(0,o.l):o;}function parse_BrtXF(data,length){var tgt=data.l+length;var ixfeParent=data.read_shift(2);var ifmt=data.read_shift(2);data.l=tgt;return{ixfe:ixfeParent,numFmtId:ifmt};}function write_BrtXF(data,ixfeP,o){if(!o)o=new_buf(16);o.write_shift(2,ixfeP||0);o.write_shift(2,data.numFmtId||0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(1,0);o.write_shift(1,0);var flow=0;o.write_shift(1,flow);o.write_shift(1,0);o.write_shift(1,0);o.write_shift(1,0);return o;}function write_Blxf(data,o){if(!o)o=new_buf(10);o.write_shift(1,0);o.write_shift(1,0);o.write_shift(4,0);o.write_shift(4,0);return o;}var parse_BrtBorder=parsenoop;function write_BrtBorder(border,o){if(!o)o=new_buf(51);o.write_shift(1,0);write_Blxf(null,o);write_Blxf(null,o);write_Blxf(null,o);write_Blxf(null,o);write_Blxf(null,o);return o.length>o.l?o.slice(0,o.l):o;}function write_BrtStyle(style,o){if(!o)o=new_buf(12+4*10);o.write_shift(4,style.xfId);o.write_shift(2,1);o.write_shift(1,+style.builtinId);o.write_shift(1,0);write_XLNullableWideString(style.name||"",o);return o.length>o.l?o.slice(0,o.l):o;}function write_BrtBeginTableStyles(cnt,defTableStyle,defPivotStyle){var o=new_buf(4+256*2*4);o.write_shift(4,cnt);write_XLNullableWideString(defTableStyle,o);write_XLNullableWideString(defPivotStyle,o);return o.length>o.l?o.slice(0,o.l):o;}function parse_sty_bin(data,themes,opts){var styles={};styles.NumberFmt=[];for(var y in table_fmt){styles.NumberFmt[y]=table_fmt[y];}styles.CellXf=[];styles.Fonts=[];var state=[];var pass=false;recordhopper(data,function hopper_sty(val,R,RT){switch(RT){case 0x002C:styles.NumberFmt[val[0]]=val[1];SSF_load(val[1],val[0]);break;case 0x002B:styles.Fonts.push(val);if(val.color.theme!=null&&themes&&themes.themeElements&&themes.themeElements.clrScheme){val.color.rgb=rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb,val.color.tint||0);}break;case 0x0401:break;case 0x002D:break;case 0x002E:break;case 0x002F:if(state[state.length-1]==0x0269){styles.CellXf.push(val);}break;case 0x0030:case 0x01FB:case 0x023C:case 0x01DB:break;case 0x0493:case 0x0836:case 0x046A:case 0x0200:case 0x082F:case 0x0C00:break;case 0x0023:pass=true;break;case 0x0024:pass=false;break;case 0x0025:state.push(RT);pass=true;break;case 0x0026:state.pop();pass=false;break;default:if(R.T>0)state.push(RT);else if(R.T<0)state.pop();else if(!pass||opts.WTF&&state[state.length-1]!=0x0025)throw new Error("Unexpected record 0x"+RT.toString(16));}});return styles;}function write_FMTS_bin(ba,NF){if(!NF)return;var cnt=0;[[5,8],[23,26],[41,44],[50,392]].forEach(function(r){for(var i=r[0];i<=r[1];++i){if(NF[i]!=null)++cnt;}});if(cnt==0)return;write_record(ba,0x0267,write_UInt32LE(cnt));[[5,8],[23,26],[41,44],[50,392]].forEach(function(r){for(var i=r[0];i<=r[1];++i){if(NF[i]!=null)write_record(ba,0x002C,write_BrtFmt(i,NF[i]));}});write_record(ba,0x0268);}function write_FONTS_bin(ba){var cnt=1;if(cnt==0)return;write_record(ba,0x0263,write_UInt32LE(cnt));write_record(ba,0x002B,write_BrtFont({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"}));write_record(ba,0x0264);}function write_FILLS_bin(ba){var cnt=2;if(cnt==0)return;write_record(ba,0x025B,write_UInt32LE(cnt));write_record(ba,0x002D,write_BrtFill({patternType:"none"}));write_record(ba,0x002D,write_BrtFill({patternType:"gray125"}));write_record(ba,0x025C);}function write_BORDERS_bin(ba){var cnt=1;if(cnt==0)return;write_record(ba,0x0265,write_UInt32LE(cnt));write_record(ba,0x002E,write_BrtBorder({}));write_record(ba,0x0266);}function write_CELLSTYLEXFS_bin(ba){var cnt=1;write_record(ba,0x0272,write_UInt32LE(cnt));write_record(ba,0x002F,write_BrtXF({numFmtId:0,fontId:0,fillId:0,borderId:0},0xFFFF));write_record(ba,0x0273);}function write_CELLXFS_bin(ba,data){write_record(ba,0x0269,write_UInt32LE(data.length));data.forEach(function(c){write_record(ba,0x002F,write_BrtXF(c,0));});write_record(ba,0x026A);}function write_STYLES_bin(ba){var cnt=1;write_record(ba,0x026B,write_UInt32LE(cnt));write_record(ba,0x0030,write_BrtStyle({xfId:0,builtinId:0,name:"Normal"}));write_record(ba,0x026C);}function write_DXFS_bin(ba){var cnt=0;write_record(ba,0x01F9,write_UInt32LE(cnt));write_record(ba,0x01FA);}function write_TABLESTYLES_bin(ba){var cnt=0;write_record(ba,0x01FC,write_BrtBeginTableStyles(cnt,"TableStyleMedium9","PivotStyleMedium4"));write_record(ba,0x01FD);}function write_COLORPALETTE_bin(){return;}function write_sty_bin(wb,opts){var ba=buf_array();write_record(ba,0x0116);write_FMTS_bin(ba,wb.SSF);write_FONTS_bin(ba,wb);write_FILLS_bin(ba,wb);write_BORDERS_bin(ba,wb);write_CELLSTYLEXFS_bin(ba,wb);write_CELLXFS_bin(ba,opts.cellXfs);write_STYLES_bin(ba,wb);write_DXFS_bin(ba,wb);write_TABLESTYLES_bin(ba,wb);write_COLORPALETTE_bin(ba,wb);write_record(ba,0x0117);return ba.end();}var XLSXThemeClrScheme=['</a:lt1>','</a:dk1>','</a:lt2>','</a:dk2>','</a:accent1>','</a:accent2>','</a:accent3>','</a:accent4>','</a:accent5>','</a:accent6>','</a:hlink>','</a:folHlink>'];function parse_clrScheme(t,themes,opts){themes.themeElements.clrScheme=[];var color={};(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case'<a:clrScheme':case'</a:clrScheme>':break;case'<a:srgbClr':color.rgb=y.val;break;case'<a:sysClr':color.rgb=y.lastClr;break;case'<a:dk1>':case'</a:dk1>':case'<a:lt1>':case'</a:lt1>':case'<a:dk2>':case'</a:dk2>':case'<a:lt2>':case'</a:lt2>':case'<a:accent1>':case'</a:accent1>':case'<a:accent2>':case'</a:accent2>':case'<a:accent3>':case'</a:accent3>':case'<a:accent4>':case'</a:accent4>':case'<a:accent5>':case'</a:accent5>':case'<a:accent6>':case'</a:accent6>':case'<a:hlink>':case'</a:hlink>':case'<a:folHlink>':case'</a:folHlink>':if(y[0].charAt(1)==='/'){themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])]=color;color={};}else{color.name=y[0].slice(3,y[0].length-1);}break;default:if(opts&&opts.WTF)throw new Error('Unrecognized '+y[0]+' in clrScheme');}});}function parse_fontScheme(){}function parse_fmtScheme(){}var clrsregex=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;var fntsregex=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;var fmtsregex=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;function parse_themeElements(data,themes,opts){themes.themeElements={};var t;[['clrScheme',clrsregex,parse_clrScheme],['fontScheme',fntsregex,parse_fontScheme],['fmtScheme',fmtsregex,parse_fmtScheme]].forEach(function(m){if(!(t=data.match(m[1])))throw new Error(m[0]+' not found in themeElements');m[2](t,themes,opts);});}var themeltregex=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;function parse_theme_xml(data,opts){if(!data||data.length===0)data=write_theme();var t;var themes={};if(!(t=data.match(themeltregex)))throw new Error('themeElements not found in theme');parse_themeElements(t[0],themes,opts);themes.raw=data;return themes;}function write_theme(Themes,opts){if(opts&&opts.themeXLSX)return opts.themeXLSX;if(Themes&&typeof Themes.raw=="string")return Themes.raw;var o=[XML_HEADER];o[o.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';o[o.length]='<a:themeElements>';o[o.length]='<a:clrScheme name="Office">';o[o.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';o[o.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';o[o.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';o[o.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';o[o.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';o[o.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';o[o.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';o[o.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';o[o.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';o[o.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>';o[o.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';o[o.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';o[o.length]='</a:clrScheme>';o[o.length]='<a:fontScheme name="Office">';o[o.length]='<a:majorFont>';o[o.length]='<a:latin typeface="Cambria"/>';o[o.length]='<a:ea typeface=""/>';o[o.length]='<a:cs typeface=""/>';o[o.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';o[o.length]='<a:font script="Hang" typeface="맑은 고딕"/>';o[o.length]='<a:font script="Hans" typeface="宋体"/>';o[o.length]='<a:font script="Hant" typeface="新細明體"/>';o[o.length]='<a:font script="Arab" typeface="Times New Roman"/>';o[o.length]='<a:font script="Hebr" typeface="Times New Roman"/>';o[o.length]='<a:font script="Thai" typeface="Tahoma"/>';o[o.length]='<a:font script="Ethi" typeface="Nyala"/>';o[o.length]='<a:font script="Beng" typeface="Vrinda"/>';o[o.length]='<a:font script="Gujr" typeface="Shruti"/>';o[o.length]='<a:font script="Khmr" typeface="MoolBoran"/>';o[o.length]='<a:font script="Knda" typeface="Tunga"/>';o[o.length]='<a:font script="Guru" typeface="Raavi"/>';o[o.length]='<a:font script="Cans" typeface="Euphemia"/>';o[o.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';o[o.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';o[o.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';o[o.length]='<a:font script="Thaa" typeface="MV Boli"/>';o[o.length]='<a:font script="Deva" typeface="Mangal"/>';o[o.length]='<a:font script="Telu" typeface="Gautami"/>';o[o.length]='<a:font script="Taml" typeface="Latha"/>';o[o.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';o[o.length]='<a:font script="Orya" typeface="Kalinga"/>';o[o.length]='<a:font script="Mlym" typeface="Kartika"/>';o[o.length]='<a:font script="Laoo" typeface="DokChampa"/>';o[o.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';o[o.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';o[o.length]='<a:font script="Viet" typeface="Times New Roman"/>';o[o.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';o[o.length]='<a:font script="Geor" typeface="Sylfaen"/>';o[o.length]='</a:majorFont>';o[o.length]='<a:minorFont>';o[o.length]='<a:latin typeface="Calibri"/>';o[o.length]='<a:ea typeface=""/>';o[o.length]='<a:cs typeface=""/>';o[o.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';o[o.length]='<a:font script="Hang" typeface="맑은 고딕"/>';o[o.length]='<a:font script="Hans" typeface="宋体"/>';o[o.length]='<a:font script="Hant" typeface="新細明體"/>';o[o.length]='<a:font script="Arab" typeface="Arial"/>';o[o.length]='<a:font script="Hebr" typeface="Arial"/>';o[o.length]='<a:font script="Thai" typeface="Tahoma"/>';o[o.length]='<a:font script="Ethi" typeface="Nyala"/>';o[o.length]='<a:font script="Beng" typeface="Vrinda"/>';o[o.length]='<a:font script="Gujr" typeface="Shruti"/>';o[o.length]='<a:font script="Khmr" typeface="DaunPenh"/>';o[o.length]='<a:font script="Knda" typeface="Tunga"/>';o[o.length]='<a:font script="Guru" typeface="Raavi"/>';o[o.length]='<a:font script="Cans" typeface="Euphemia"/>';o[o.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';o[o.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';o[o.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';o[o.length]='<a:font script="Thaa" typeface="MV Boli"/>';o[o.length]='<a:font script="Deva" typeface="Mangal"/>';o[o.length]='<a:font script="Telu" typeface="Gautami"/>';o[o.length]='<a:font script="Taml" typeface="Latha"/>';o[o.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';o[o.length]='<a:font script="Orya" typeface="Kalinga"/>';o[o.length]='<a:font script="Mlym" typeface="Kartika"/>';o[o.length]='<a:font script="Laoo" typeface="DokChampa"/>';o[o.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';o[o.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';o[o.length]='<a:font script="Viet" typeface="Arial"/>';o[o.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';o[o.length]='<a:font script="Geor" typeface="Sylfaen"/>';o[o.length]='</a:minorFont>';o[o.length]='</a:fontScheme>';o[o.length]='<a:fmtScheme name="Office">';o[o.length]='<a:fillStyleLst>';o[o.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:lin ang="16200000" scaled="1"/>';o[o.length]='</a:gradFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:lin ang="16200000" scaled="0"/>';o[o.length]='</a:gradFill>';o[o.length]='</a:fillStyleLst>';o[o.length]='<a:lnStyleLst>';o[o.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='</a:lnStyleLst>';o[o.length]='<a:effectStyleLst>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='</a:effectStyle>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='</a:effectStyle>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';o[o.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';o[o.length]='</a:effectStyle>';o[o.length]='</a:effectStyleLst>';o[o.length]='<a:bgFillStyleLst>';o[o.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';o[o.length]='</a:gradFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';o[o.length]='</a:gradFill>';o[o.length]='</a:bgFillStyleLst>';o[o.length]='</a:fmtScheme>';o[o.length]='</a:themeElements>';o[o.length]='<a:objectDefaults>';o[o.length]='<a:spDef>';o[o.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';o[o.length]='</a:spDef>';o[o.length]='<a:lnDef>';o[o.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';o[o.length]='</a:lnDef>';o[o.length]='</a:objectDefaults>';o[o.length]='<a:extraClrSchemeLst/>';o[o.length]='</a:theme>';return o.join("");}function parse_Theme(blob,length,opts){var end=blob.l+length;var dwThemeVersion=blob.read_shift(4);if(dwThemeVersion===124226)return;if(!opts.cellStyles){blob.l=end;return;}var data=blob.slice(blob.l);blob.l=end;var zip;try{zip=zip_read(data,{type:"array"});}catch(e){return;}var themeXML=getzipstr(zip,"theme/theme/theme1.xml",true);if(!themeXML)return;return parse_theme_xml(themeXML,opts);}function parse_ColorTheme(blob){return blob.read_shift(4);}function parse_FullColorExt(blob){var o={};o.xclrType=blob.read_shift(2);o.nTintShade=blob.read_shift(2);switch(o.xclrType){case 0:blob.l+=4;break;case 1:o.xclrValue=parse_IcvXF(blob,4);break;case 2:o.xclrValue=parse_LongRGBA(blob,4);break;case 3:o.xclrValue=parse_ColorTheme(blob,4);break;case 4:blob.l+=4;break;}blob.l+=8;return o;}function parse_IcvXF(blob,length){return parsenoop(blob,length);}function parse_XFExtGradient(blob,length){return parsenoop(blob,length);}function parse_ExtProp(blob){var extType=blob.read_shift(2);var cb=blob.read_shift(2)-4;var o=[extType];switch(extType){case 0x04:case 0x05:case 0x07:case 0x08:case 0x09:case 0x0A:case 0x0B:case 0x0D:o[1]=parse_FullColorExt(blob,cb);break;case 0x06:o[1]=parse_XFExtGradient(blob,cb);break;case 0x0E:case 0x0F:o[1]=blob.read_shift(cb===1?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+extType+" "+cb);}return o;}function parse_XFExt(blob,length){var end=blob.l+length;blob.l+=2;var ixfe=blob.read_shift(2);blob.l+=2;var cexts=blob.read_shift(2);var ext=[];while(cexts-->0){ext.push(parse_ExtProp(blob,end-blob.l));}return{ixfe:ixfe,ext:ext};}function update_xfext(xf,xfext){xfext.forEach(function(xfe){switch(xfe[0]){case 0x04:break;case 0x05:break;case 0x06:break;case 0x07:break;case 0x08:break;case 0x09:break;case 0x0a:break;case 0x0b:break;case 0x0d:break;case 0x0e:break;case 0x0f:break;}});}function parse_BrtMdtinfo(data,length){return{flags:data.read_shift(4),version:data.read_shift(4),name:parse_XLWideString(data,length-8)};}function write_BrtMdtinfo(data){var o=new_buf(12+2*data.name.length);o.write_shift(4,data.flags);o.write_shift(4,data.version);write_XLWideString(data.name,o);return o.slice(0,o.l);}function parse_BrtMdb(data){var out=[];var cnt=data.read_shift(4);while(cnt-->0){out.push([data.read_shift(4),data.read_shift(4)]);}return out;}function write_BrtMdb(mdb){var o=new_buf(4+8*mdb.length);o.write_shift(4,mdb.length);for(var i=0;i<mdb.length;++i){o.write_shift(4,mdb[i][0]);o.write_shift(4,mdb[i][1]);}return o;}function write_BrtBeginEsfmd(cnt,name){var o=new_buf(8+2*name.length);o.write_shift(4,cnt);write_XLWideString(name,o);return o.slice(0,o.l);}function parse_BrtBeginEsmdb(data){data.l+=4;return data.read_shift(4)!=0;}function write_BrtBeginEsmdb(cnt,cm){var o=new_buf(8);o.write_shift(4,cnt);o.write_shift(4,cm?1:0);return o;}function parse_xlmeta_bin(data,name,_opts){var out={Types:[],Cell:[],Value:[]};var opts=_opts||{};var state=[];var pass=false;var metatype=2;recordhopper(data,function(val,R,RT){switch(RT){case 335:out.Types.push({name:val.name});break;case 51:val.forEach(function(r){if(metatype==1)out.Cell.push({type:out.Types[r[0]-1].name,index:r[1]});else if(metatype==0)out.Value.push({type:out.Types[r[0]-1].name,index:r[1]});});break;case 337:metatype=val?1:0;break;case 338:metatype=2;break;case 35:state.push(RT);pass=true;break;case 36:state.pop();pass=false;break;default:if(R.T){}else if(!pass||opts.WTF&&state[state.length-1]!=35)throw new Error("Unexpected record 0x"+RT.toString(16));}});return out;}function write_xlmeta_bin(){var ba=buf_array();write_record(ba,332);write_record(ba,334,write_UInt32LE(1));write_record(ba,335,write_BrtMdtinfo({name:"XLDAPR",version:12e4,flags:3496657072}));write_record(ba,336);write_record(ba,339,write_BrtBeginEsfmd(1,"XLDAPR"));write_record(ba,52);write_record(ba,35,write_UInt32LE(514));write_record(ba,4096,write_UInt32LE(0));write_record(ba,4097,writeuint16(1));write_record(ba,36);write_record(ba,53);write_record(ba,340);write_record(ba,337,write_BrtBeginEsmdb(1,true));write_record(ba,51,write_BrtMdb([[1,0]]));write_record(ba,338);write_record(ba,333);return ba.end();}function parse_xlmeta_xml(data,name,opts){var out={Types:[],Cell:[],Value:[]};if(!data)return out;var pass=false;var metatype=2;var lastmeta;data.replace(tagregex,function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case"<?xml":break;case"<metadata":case"</metadata>":break;case"<metadataTypes":case"</metadataTypes>":break;case"<metadataType":out.Types.push({name:y.name});break;case"</metadataType>":break;case"<futureMetadata":for(var j=0;j<out.Types.length;++j){if(out.Types[j].name==y.name)lastmeta=out.Types[j];}break;case"</futureMetadata>":break;case"<bk>":break;case"</bk>":break;case"<rc":if(metatype==1)out.Cell.push({type:out.Types[y.t-1].name,index:+y.v});else if(metatype==0)out.Value.push({type:out.Types[y.t-1].name,index:+y.v});break;case"</rc>":break;case"<cellMetadata":metatype=1;break;case"</cellMetadata>":metatype=2;break;case"<valueMetadata":metatype=0;break;case"</valueMetadata>":metatype=2;break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":pass=true;break;case"</ext>":pass=false;break;case"<rvb":if(!lastmeta)break;if(!lastmeta.offsets)lastmeta.offsets=[];lastmeta.offsets.push(+y.i);break;default:if(!pass&&opts.WTF)throw new Error("unrecognized "+y[0]+" in metadata");}return x;});return out;}function write_xlmeta_xml(){var o=[XML_HEADER];o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');return o.join("");}function parse_cc_xml(data){var d=[];if(!data)return d;var i=1;(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case'<?xml':break;case'<calcChain':case'<calcChain>':case'</calcChain>':break;case'<c':delete y[0];if(y.i)i=y.i;else y.i=i;d.push(y);break;}});return d;}function parse_BrtCalcChainItem$(data){var out={};out.i=data.read_shift(4);var cell={};cell.r=data.read_shift(4);cell.c=data.read_shift(4);out.r=encode_cell(cell);var flags=data.read_shift(1);if(flags&0x2)out.l='1';if(flags&0x8)out.a='1';return out;}function parse_cc_bin(data,name,opts){var out=[];var pass=false;recordhopper(data,function hopper_cc(val,R,RT){switch(RT){case 0x003F:out.push(val);break;default:if(R.T){}else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}});return out;}function parse_xlink_xml(){}function parse_xlink_bin(data,rel,name,_opts){if(!data)return data;var opts=_opts||{};var pass=false,end=false;recordhopper(data,function xlink_parse(val,R,RT){if(end)return;switch(RT){case 0x0167:case 0x016B:case 0x016C:case 0x016E:case 0x016F:case 0x0170:case 0x0171:case 0x0172:case 0x0173:case 0x01D8:case 0x0241:case 0x0242:case 0x0243:case 0x0244:case 0x0245:case 0x0246:case 0x0247:case 0x0248:case 0x0249:case 0x024A:case 0x024B:break;case 0x0023:pass=true;break;case 0x0024:pass=false;break;default:if(R.T){}else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}},opts);}function parse_drawing(data,rels){if(!data)return"??";var id=(data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];return rels['!id'][id].Target;}var _shapeid=1024;function write_comments_vml(rId,comments){var csize=[21600,21600];var bbox=["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");var o=[writextag("xml",null,{'xmlns:v':XLMLNS.v,'xmlns:o':XLMLNS.o,'xmlns:x':XLMLNS.x,'xmlns:mv':XLMLNS.mv}).replace(/\/>/,">"),writextag("o:shapelayout",writextag("o:idmap",null,{'v:ext':"edit",'data':rId}),{'v:ext':"edit"}),writextag("v:shapetype",[writextag("v:stroke",null,{joinstyle:"miter"}),writextag("v:path",null,{gradientshapeok:"t",'o:connecttype':"rect"})].join(""),{id:"_x0000_t202",'o:spt':202,coordsize:csize.join(","),path:bbox})];while(_shapeid<rId*1000){_shapeid+=1000;}comments.forEach(function(x){var c=decode_cell(x[0]);var fillopts={'color2':"#BEFF82",'type':"gradient"};if(fillopts.type=="gradient")fillopts.angle="-180";var fillparm=fillopts.type=="gradient"?writextag("o:fill",null,{type:"gradientUnscaled",'v:ext':"view"}):null;var fillxml=writextag('v:fill',fillparm,fillopts);var shadata={on:"t",'obscured':"t"};++_shapeid;o=o.concat(['<v:shape'+wxt_helper({id:'_x0000_s'+_shapeid,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(x[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+'>',fillxml,writextag("v:shadow",null,shadata),writextag("v:path",null,{'o:connecttype':"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">','<x:MoveWithCells/>','<x:SizeWithCells/>',writetag('x:Anchor',[c.c+1,0,c.r+1,0,c.c+3,20,c.r+5,20].join(",")),writetag('x:AutoFill',"False"),writetag('x:Row',String(c.r)),writetag('x:Column',String(c.c)),x[1].hidden?'':'<x:Visible/>','</x:ClientData>','</v:shape>']);});o.push('</xml>');return o.join("");}function sheet_insert_comments(sheet,comments,threaded,people){var dense=Array.isArray(sheet);var cell;comments.forEach(function(comment){var r=decode_cell(comment.ref);if(dense){if(!sheet[r.r])sheet[r.r]=[];cell=sheet[r.r][r.c];}else cell=sheet[comment.ref];if(!cell){cell={t:"z"};if(dense)sheet[r.r][r.c]=cell;else sheet[comment.ref]=cell;var range=safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");if(range.s.r>r.r)range.s.r=r.r;if(range.e.r<r.r)range.e.r=r.r;if(range.s.c>r.c)range.s.c=r.c;if(range.e.c<r.c)range.e.c=r.c;var encoded=encode_range(range);if(encoded!==sheet["!ref"])sheet["!ref"]=encoded;}if(!cell.c)cell.c=[];var o={a:comment.author,t:comment.t,r:comment.r,T:threaded};if(comment.h)o.h=comment.h;for(var i=cell.c.length-1;i>=0;--i){if(!threaded&&cell.c[i].T)return;if(threaded&&!cell.c[i].T)cell.c.splice(i,1);}if(threaded&&people)for(i=0;i<people.length;++i){if(o.a==people[i].id){o.a=people[i].name||o.a;break;}}cell.c.push(o);});}function parse_comments_xml(data,opts){if(data.match(/<(?:\w+:)?comments *\/>/))return[];var authors=[];var commentList=[];var authtag=data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);if(authtag&&authtag[1])authtag[1].split(/<\/\w*:?author>/).forEach(function(x){if(x===""||x.trim()==="")return;var a=x.match(/<(?:\w+:)?author[^>]*>(.*)/);if(a)authors.push(a[1]);});var cmnttag=data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);if(cmnttag&&cmnttag[1])cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x){if(x===""||x.trim()==="")return;var cm=x.match(/<(?:\w+:)?comment[^>]*>/);if(!cm)return;var y=parsexmltag(cm[0]);var comment={author:y.authorId&&authors[y.authorId]||"sheetjsghost",ref:y.ref,guid:y.guid};var cell=decode_cell(y.ref);if(opts.sheetRows&&opts.sheetRows<=cell.r)return;var textMatch=x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);var rt=!!textMatch&&!!textMatch[1]&&parse_si(textMatch[1])||{r:"",t:"",h:""};comment.r=rt.r;if(rt.r=="<t></t>")rt.t=rt.h="";comment.t=(rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");if(opts.cellHTML)comment.h=rt.h;commentList.push(comment);});return commentList;}function write_comments_xml(data){var o=[XML_HEADER,writextag('comments',null,{'xmlns':XMLNS_main[0]})];var iauthor=[];o.push("<authors>");data.forEach(function(x){x[1].forEach(function(w){var a=escapexml(w.a);if(iauthor.indexOf(a)==-1){iauthor.push(a);o.push("<author>"+a+"</author>");}if(w.T&&w.ID&&iauthor.indexOf("tc="+w.ID)==-1){iauthor.push("tc="+w.ID);o.push("<author>"+"tc="+w.ID+"</author>");}});});if(iauthor.length==0){iauthor.push("SheetJ5");o.push("<author>SheetJ5</author>");}o.push("</authors>");o.push("<commentList>");data.forEach(function(d){var lastauthor=0,ts=[];if(d[1][0]&&d[1][0].T&&d[1][0].ID)lastauthor=iauthor.indexOf("tc="+d[1][0].ID);else d[1].forEach(function(c){if(c.a)lastauthor=iauthor.indexOf(escapexml(c.a));ts.push(c.t||"");});o.push('<comment ref="'+d[0]+'" authorId="'+lastauthor+'"><text>');if(ts.length<=1)o.push(writetag("t",escapexml(ts[0]||"")));else{var t="Comment:\n    "+ts[0]+"\n";for(var i=1;i<ts.length;++i){t+="Reply:\n    "+ts[i]+"\n";}o.push(writetag("t",escapexml(t)));}o.push('</text></comment>');});o.push("</commentList>");if(o.length>2){o[o.length]='</comments>';o[1]=o[1].replace("/>",">");}return o.join("");}function parse_tcmnt_xml(data,opts){var out=[];var pass=false,comment={},tidx=0;data.replace(tagregex,function xml_tcmnt(x,idx){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;case'<ThreadedComments':break;case'</ThreadedComments>':break;case'<threadedComment':comment={author:y.personId,guid:y.id,ref:y.ref,T:1};break;case'</threadedComment>':if(comment.t!=null)out.push(comment);break;case'<text>':case'<text':tidx=idx+x.length;break;case'</text>':comment.t=data.slice(tidx,idx).replace(/\r\n/g,"\n").replace(/\r/g,"\n");break;case'<mentions':case'<mentions>':pass=true;break;case'</mentions>':pass=false;break;case'<extLst':case'<extLst>':case'</extLst>':case'<extLst/>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(!pass&&opts.WTF)throw new Error('unrecognized '+y[0]+' in threaded comments');}return x;});return out;}function write_tcmnt_xml(comments,people,opts){var o=[XML_HEADER,writextag('ThreadedComments',null,{'xmlns':XMLNS.TCMNT}).replace(/[\/]>/,">")];comments.forEach(function(carr){var rootid="";(carr[1]||[]).forEach(function(c,idx){if(!c.T){delete c.ID;return;}if(c.a&&people.indexOf(c.a)==-1)people.push(c.a);var tcopts={ref:carr[0],id:"{54EE7951-7262-4200-6969-"+("000000000000"+opts.tcid++).slice(-12)+"}"};if(idx==0)rootid=tcopts.id;else tcopts.parentId=rootid;c.ID=tcopts.id;if(c.a)tcopts.personId="{54EE7950-7262-4200-6969-"+("000000000000"+people.indexOf(c.a)).slice(-12)+"}";o.push(writextag('threadedComment',writetag('text',c.t||""),tcopts));});});o.push('</ThreadedComments>');return o.join("");}function parse_people_xml(data,opts){var out=[];var pass=false;data.replace(tagregex,function xml_tcmnt(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;case'<personList':break;case'</personList>':break;case'<person':out.push({name:y.displayname,id:y.id});break;case'</person>':break;case'<extLst':case'<extLst>':case'</extLst>':case'<extLst/>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(!pass&&opts.WTF)throw new Error('unrecognized '+y[0]+' in threaded comments');}return x;});return out;}function write_people_xml(people){var o=[XML_HEADER,writextag('personList',null,{'xmlns':XMLNS.TCMNT,'xmlns:x':XMLNS_main[0]}).replace(/[\/]>/,">")];people.forEach(function(person,idx){o.push(writextag('person',null,{displayName:person,id:"{54EE7950-7262-4200-6969-"+("000000000000"+idx).slice(-12)+"}",userId:person,providerId:"None"}));});o.push("</personList>");return o.join("");}function parse_BrtBeginComment(data){var out={};out.iauthor=data.read_shift(4);var rfx=parse_UncheckedRfX(data,16);out.rfx=rfx.s;out.ref=encode_cell(rfx.s);data.l+=16;return out;}function write_BrtBeginComment(data,o){if(o==null)o=new_buf(36);o.write_shift(4,data[1].iauthor);write_UncheckedRfX(data[0],o);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);return o;}var parse_BrtCommentAuthor=parse_XLWideString;function write_BrtCommentAuthor(data){return write_XLWideString(data.slice(0,54));}function parse_comments_bin(data,opts){var out=[];var authors=[];var c={};var pass=false;recordhopper(data,function hopper_cmnt(val,R,RT){switch(RT){case 0x0278:authors.push(val);break;case 0x027B:c=val;break;case 0x027D:c.t=val.t;c.h=val.h;c.r=val.r;break;case 0x027C:c.author=authors[c.iauthor];delete c.iauthor;if(opts.sheetRows&&c.rfx&&opts.sheetRows<=c.rfx.r)break;if(!c.t)c.t="";delete c.rfx;out.push(c);break;case 0x0C00:break;case 0x0023:pass=true;break;case 0x0024:pass=false;break;case 0x0025:break;case 0x0026:break;default:if(R.T){}else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}});return out;}function write_comments_bin(data){var ba=buf_array();var iauthor=[];write_record(ba,0x0274);write_record(ba,0x0276);data.forEach(function(comment){comment[1].forEach(function(c){if(iauthor.indexOf(c.a)>-1)return;iauthor.push(c.a.slice(0,54));write_record(ba,0x0278,write_BrtCommentAuthor(c.a));});});write_record(ba,0x0277);write_record(ba,0x0279);data.forEach(function(comment){comment[1].forEach(function(c){c.iauthor=iauthor.indexOf(c.a);var range={s:decode_cell(comment[0]),e:decode_cell(comment[0])};write_record(ba,0x027B,write_BrtBeginComment([range,c]));if(c.t&&c.t.length>0)write_record(ba,0x027D,write_BrtCommentText(c));write_record(ba,0x027C);delete c.iauthor;});});write_record(ba,0x027A);write_record(ba,0x0275);return ba.end();}var CT_VBA="application/vnd.ms-office.vbaProject";function make_vba_xls(cfb){var newcfb=CFB.utils.cfb_new({root:"R"});cfb.FullPaths.forEach(function(p,i){if(p.slice(-1)==="/"||!p.match(/_VBA_PROJECT_CUR/))return;var newpath=p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,"");CFB.utils.cfb_add(newcfb,newpath,cfb.FileIndex[i].content);});return CFB.write(newcfb);}function fill_vba_xls(cfb,vba){vba.FullPaths.forEach(function(p,i){if(i==0)return;var newpath=p.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/");if(newpath.slice(-1)!=="/")CFB.utils.cfb_add(cfb,newpath,vba.FileIndex[i].content);});}var VBAFMTS=["xlsb","xlsm","xlam","biff8","xla"];function parse_ds_bin(){return{'!type':'dialog'};}function parse_ds_xml(){return{'!type':'dialog'};}function parse_ms_bin(){return{'!type':'macro'};}function parse_ms_xml(){return{'!type':'macro'};}var rc_to_a1=function(){var rcregex=/(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;var rcbase={r:0,c:0};function rcfunc($$,$1,$2,$3){var cRel=false,rRel=false;if($2.length==0)rRel=true;else if($2.charAt(0)=="["){rRel=true;$2=$2.slice(1,-1);}if($3.length==0)cRel=true;else if($3.charAt(0)=="["){cRel=true;$3=$3.slice(1,-1);}var R=$2.length>0?parseInt($2,10)|0:0,C=$3.length>0?parseInt($3,10)|0:0;if(cRel)C+=rcbase.c;else--C;if(rRel)R+=rcbase.r;else--R;return $1+(cRel?"":"$")+encode_col(C)+(rRel?"":"$")+encode_row(R);}return function rc_to_a1(fstr,base){rcbase=base;return fstr.replace(rcregex,rcfunc);};}();var crefregex=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;var a1_to_rc=function(){return function a1_to_rc(fstr,base){return fstr.replace(crefregex,function($0,$1,$2,$3,$4,$5){var c=decode_col($3)-($2?0:base.c);var r=decode_row($5)-($4?0:base.r);var R=r==0?"":!$4?"["+r+"]":r+1;var C=c==0?"":!$2?"["+c+"]":c+1;return $1+"R"+R+"C"+C;});};}();function shift_formula_str(f,delta){return f.replace(crefregex,function($0,$1,$2,$3,$4,$5){return $1+($2=="$"?$2+$3:encode_col(decode_col($3)+delta.c))+($4=="$"?$4+$5:encode_row(decode_row($5)+delta.r));});}function shift_formula_xlsx(f,range,cell){var r=decode_range(range),s=r.s,c=decode_cell(cell);var delta={r:c.r-s.r,c:c.c-s.c};return shift_formula_str(f,delta);}function fuzzyfmla(f){if(f.length==1)return false;return true;}function _xlfn(f){return f.replace(/_xlfn\./g,"");}function parseread1(blob){blob.l+=1;return;}function parse_ColRelU(blob,length){var c=blob.read_shift(length==1?1:2);return[c&0x3FFF,c>>14&1,c>>15&1];}function parse_RgceArea(blob,length,opts){var w=2;if(opts){if(opts.biff>=2&&opts.biff<=5)return parse_RgceArea_BIFF2(blob,length,opts);else if(opts.biff==12)w=4;}var r=blob.read_shift(w),R=blob.read_shift(w);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return{s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}};}function parse_RgceArea_BIFF2(blob){var r=parse_ColRelU(blob,2),R=parse_ColRelU(blob,2);var c=blob.read_shift(1);var C=blob.read_shift(1);return{s:{r:r[0],c:c,cRel:r[1],rRel:r[2]},e:{r:R[0],c:C,cRel:R[1],rRel:R[2]}};}function parse_RgceAreaRel(blob,length,opts){if(opts.biff<8)return parse_RgceArea_BIFF2(blob,length,opts);var r=blob.read_shift(opts.biff==12?4:2),R=blob.read_shift(opts.biff==12?4:2);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return{s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}};}function parse_RgceLoc(blob,length,opts){if(opts&&opts.biff>=2&&opts.biff<=5)return parse_RgceLoc_BIFF2(blob,length,opts);var r=blob.read_shift(opts&&opts.biff==12?4:2);var c=parse_ColRelU(blob,2);return{r:r,c:c[0],cRel:c[1],rRel:c[2]};}function parse_RgceLoc_BIFF2(blob){var r=parse_ColRelU(blob,2);var c=blob.read_shift(1);return{r:r[0],c:c,cRel:r[1],rRel:r[2]};}function parse_RgceElfLoc(blob){var r=blob.read_shift(2);var c=blob.read_shift(2);return{r:r,c:c&0xFF,fQuoted:!!(c&0x4000),cRel:c>>15,rRel:c>>15};}function parse_RgceLocRel(blob,length,opts){var biff=opts&&opts.biff?opts.biff:8;if(biff>=2&&biff<=5)return parse_RgceLocRel_BIFF2(blob,length,opts);var r=blob.read_shift(biff>=12?4:2);var cl=blob.read_shift(2);var cRel=(cl&0x4000)>>14,rRel=(cl&0x8000)>>15;cl&=0x3FFF;if(rRel==1)while(r>0x7FFFF){r-=0x100000;}if(cRel==1)while(cl>0x1FFF){cl=cl-0x4000;}return{r:r,c:cl,cRel:cRel,rRel:rRel};}function parse_RgceLocRel_BIFF2(blob){var rl=blob.read_shift(2);var c=blob.read_shift(1);var rRel=(rl&0x8000)>>15,cRel=(rl&0x4000)>>14;rl&=0x3FFF;if(rRel==1&&rl>=0x2000)rl=rl-0x4000;if(cRel==1&&c>=0x80)c=c-0x100;return{r:rl,c:c,cRel:cRel,rRel:rRel};}function parse_PtgArea(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var area=parse_RgceArea(blob,opts.biff>=2&&opts.biff<=5?6:8,opts);return[type,area];}function parse_PtgArea3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2,'i');var w=8;if(opts)switch(opts.biff){case 5:blob.l+=12;w=6;break;case 12:w=12;break;}var area=parse_RgceArea(blob,w,opts);return[type,ixti,area];}function parse_PtgAreaErr(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;blob.l+=opts&&opts.biff>8?12:opts.biff<8?6:8;return[type];}function parse_PtgAreaErr3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2);var w=8;if(opts)switch(opts.biff){case 5:blob.l+=12;w=6;break;case 12:w=12;break;}blob.l+=w;return[type,ixti];}function parse_PtgAreaN(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var area=parse_RgceAreaRel(blob,length-1,opts);return[type,area];}function parse_PtgArray(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;blob.l+=opts.biff==2?6:opts.biff==12?14:7;return[type];}function parse_PtgAttrBaxcel(blob){var bitSemi=blob[blob.l+1]&0x01;var bitBaxcel=1;blob.l+=4;return[bitSemi,bitBaxcel];}function parse_PtgAttrChoose(blob,length,opts){blob.l+=2;var offset=blob.read_shift(opts&&opts.biff==2?1:2);var o=[];for(var i=0;i<=offset;++i){o.push(blob.read_shift(opts&&opts.biff==2?1:2));}return o;}function parse_PtgAttrGoto(blob,length,opts){var bitGoto=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitGoto,blob.read_shift(opts&&opts.biff==2?1:2)];}function parse_PtgAttrIf(blob,length,opts){var bitIf=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitIf,blob.read_shift(opts&&opts.biff==2?1:2)];}function parse_PtgAttrIfError(blob){var bitIf=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitIf,blob.read_shift(2)];}function parse_PtgAttrSemi(blob,length,opts){var bitSemi=blob[blob.l+1]&0xFF?1:0;blob.l+=opts&&opts.biff==2?3:4;return[bitSemi];}function parse_PtgAttrSpaceType(blob){var type=blob.read_shift(1),cch=blob.read_shift(1);return[type,cch];}function parse_PtgAttrSpace(blob){blob.read_shift(2);return parse_PtgAttrSpaceType(blob,2);}function parse_PtgAttrSpaceSemi(blob){blob.read_shift(2);return parse_PtgAttrSpaceType(blob,2);}function parse_PtgRef(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var loc=parse_RgceLoc(blob,0,opts);return[type,loc];}function parse_PtgRefN(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var loc=parse_RgceLocRel(blob,0,opts);return[type,loc];}function parse_PtgRef3d(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var ixti=blob.read_shift(2);if(opts&&opts.biff==5)blob.l+=12;var loc=parse_RgceLoc(blob,0,opts);return[type,ixti,loc];}function parse_PtgFunc(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var iftab=blob.read_shift(opts&&opts.biff<=3?1:2);return[FtabArgc[iftab],Ftab[iftab],type];}function parse_PtgFuncVar(blob,length,opts){var type=blob[blob.l++];var cparams=blob.read_shift(1),tab=opts&&opts.biff<=3?[type==0x58?-1:0,blob.read_shift(1)]:parsetab(blob);return[cparams,(tab[0]===0?Ftab:Cetab)[tab[1]]];}function parsetab(blob){return[blob[blob.l+1]>>7,blob.read_shift(2)&0x7FFF];}function parse_PtgAttrSum(blob,length,opts){blob.l+=opts&&opts.biff==2?3:4;return;}function parse_PtgExp(blob,length,opts){blob.l++;if(opts&&opts.biff==12)return[blob.read_shift(4,'i'),0];var row=blob.read_shift(2);var col=blob.read_shift(opts&&opts.biff==2?1:2);return[row,col];}function parse_PtgErr(blob){blob.l++;return BErr[blob.read_shift(1)];}function parse_PtgInt(blob){blob.l++;return blob.read_shift(2);}function parse_PtgBool(blob){blob.l++;return blob.read_shift(1)!==0;}function parse_PtgNum(blob){blob.l++;return parse_Xnum(blob,8);}function parse_PtgStr(blob,length,opts){blob.l++;return parse_ShortXLUnicodeString(blob,length-1,opts);}function parse_SerAr(blob,biff){var val=[blob.read_shift(1)];if(biff==12)switch(val[0]){case 0x02:val[0]=0x04;break;case 0x04:val[0]=0x10;break;case 0x00:val[0]=0x01;break;case 0x01:val[0]=0x02;break;}switch(val[0]){case 0x04:val[1]=parsebool(blob,1)?'TRUE':'FALSE';if(biff!=12)blob.l+=7;break;case 0x25:case 0x10:val[1]=BErr[blob[blob.l]];blob.l+=biff==12?4:8;break;case 0x00:blob.l+=8;break;case 0x01:val[1]=parse_Xnum(blob,8);break;case 0x02:val[1]=parse_XLUnicodeString2(blob,0,{biff:biff>0&&biff<8?2:biff});break;default:throw new Error("Bad SerAr: "+val[0]);}return val;}function parse_PtgExtraMem(blob,cce,opts){var count=blob.read_shift(opts.biff==12?4:2);var out=[];for(var i=0;i!=count;++i){out.push((opts.biff==12?parse_UncheckedRfX:parse_Ref8U)(blob,8));}return out;}function parse_PtgExtraArray(blob,length,opts){var rows=0,cols=0;if(opts.biff==12){rows=blob.read_shift(4);cols=blob.read_shift(4);}else{cols=1+blob.read_shift(1);rows=1+blob.read_shift(2);}if(opts.biff>=2&&opts.biff<8){--rows;if(--cols==0)cols=0x100;}for(var i=0,o=[];i!=rows&&(o[i]=[]);++i){for(var j=0;j!=cols;++j){o[i][j]=parse_SerAr(blob,opts.biff);}}return o;}function parse_PtgName(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;var w=!opts||opts.biff>=8?4:2;var nameindex=blob.read_shift(w);switch(opts.biff){case 2:blob.l+=5;break;case 3:case 4:blob.l+=8;break;case 5:blob.l+=12;break;}return[type,0,nameindex];}function parse_PtgNameX(blob,length,opts){if(opts.biff==5)return parse_PtgNameX_BIFF5(blob,length,opts);var type=blob.read_shift(1)>>>5&0x03;var ixti=blob.read_shift(2);var nameindex=blob.read_shift(4);return[type,ixti,nameindex];}function parse_PtgNameX_BIFF5(blob){var type=blob.read_shift(1)>>>5&0x03;var ixti=blob.read_shift(2,'i');blob.l+=8;var nameindex=blob.read_shift(2);blob.l+=12;return[type,ixti,nameindex];}function parse_PtgMemArea(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;blob.l+=opts&&opts.biff==2?3:4;var cce=blob.read_shift(opts&&opts.biff==2?1:2);return[type,cce];}function parse_PtgMemFunc(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(opts&&opts.biff==2?1:2);return[type,cce];}function parse_PtgRefErr(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;blob.l+=4;if(opts.biff<8)blob.l--;if(opts.biff==12)blob.l+=2;return[type];}function parse_PtgRefErr3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2);var w=4;if(opts)switch(opts.biff){case 5:w=15;break;case 12:w=6;break;}blob.l+=w;return[type,ixti];}var parse_PtgMemErr=parsenoop;var parse_PtgMemNoMem=parsenoop;var parse_PtgTbl=parsenoop;function parse_PtgElfLoc(blob,length,opts){blob.l+=2;return[parse_RgceElfLoc(blob,4,opts)];}function parse_PtgElfNoop(blob){blob.l+=6;return[];}var parse_PtgElfCol=parse_PtgElfLoc;var parse_PtgElfColS=parse_PtgElfNoop;var parse_PtgElfColSV=parse_PtgElfNoop;var parse_PtgElfColV=parse_PtgElfLoc;function parse_PtgElfLel(blob){blob.l+=2;return[parseuint16(blob),blob.read_shift(2)&0x01];}var parse_PtgElfRadical=parse_PtgElfLoc;var parse_PtgElfRadicalLel=parse_PtgElfLel;var parse_PtgElfRadicalS=parse_PtgElfNoop;var parse_PtgElfRw=parse_PtgElfLoc;var parse_PtgElfRwV=parse_PtgElfLoc;var PtgListRT=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];function parse_PtgList(blob){blob.l+=2;var ixti=blob.read_shift(2);var flags=blob.read_shift(2);var idx=blob.read_shift(4);var c=blob.read_shift(2);var C=blob.read_shift(2);var rt=PtgListRT[flags>>2&0x1F];return{ixti:ixti,coltype:flags&0x3,rt:rt,idx:idx,c:c,C:C};}function parse_PtgSxName(blob){blob.l+=2;return[blob.read_shift(4)];}function parse_PtgSheet(blob,length,opts){blob.l+=5;blob.l+=2;blob.l+=opts.biff==2?1:4;return["PTGSHEET"];}function parse_PtgEndSheet(blob,length,opts){blob.l+=opts.biff==2?4:5;return["PTGENDSHEET"];}function parse_PtgMemAreaN(blob){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(2);return[type,cce];}function parse_PtgMemNoMemN(blob){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(2);return[type,cce];}function parse_PtgAttrNoop(blob){blob.l+=4;return[0,0];}var PtgTypes={0x01:{n:'PtgExp',f:parse_PtgExp},0x02:{n:'PtgTbl',f:parse_PtgTbl},0x03:{n:'PtgAdd',f:parseread1},0x04:{n:'PtgSub',f:parseread1},0x05:{n:'PtgMul',f:parseread1},0x06:{n:'PtgDiv',f:parseread1},0x07:{n:'PtgPower',f:parseread1},0x08:{n:'PtgConcat',f:parseread1},0x09:{n:'PtgLt',f:parseread1},0x0A:{n:'PtgLe',f:parseread1},0x0B:{n:'PtgEq',f:parseread1},0x0C:{n:'PtgGe',f:parseread1},0x0D:{n:'PtgGt',f:parseread1},0x0E:{n:'PtgNe',f:parseread1},0x0F:{n:'PtgIsect',f:parseread1},0x10:{n:'PtgUnion',f:parseread1},0x11:{n:'PtgRange',f:parseread1},0x12:{n:'PtgUplus',f:parseread1},0x13:{n:'PtgUminus',f:parseread1},0x14:{n:'PtgPercent',f:parseread1},0x15:{n:'PtgParen',f:parseread1},0x16:{n:'PtgMissArg',f:parseread1},0x17:{n:'PtgStr',f:parse_PtgStr},0x1A:{n:'PtgSheet',f:parse_PtgSheet},0x1B:{n:'PtgEndSheet',f:parse_PtgEndSheet},0x1C:{n:'PtgErr',f:parse_PtgErr},0x1D:{n:'PtgBool',f:parse_PtgBool},0x1E:{n:'PtgInt',f:parse_PtgInt},0x1F:{n:'PtgNum',f:parse_PtgNum},0x20:{n:'PtgArray',f:parse_PtgArray},0x21:{n:'PtgFunc',f:parse_PtgFunc},0x22:{n:'PtgFuncVar',f:parse_PtgFuncVar},0x23:{n:'PtgName',f:parse_PtgName},0x24:{n:'PtgRef',f:parse_PtgRef},0x25:{n:'PtgArea',f:parse_PtgArea},0x26:{n:'PtgMemArea',f:parse_PtgMemArea},0x27:{n:'PtgMemErr',f:parse_PtgMemErr},0x28:{n:'PtgMemNoMem',f:parse_PtgMemNoMem},0x29:{n:'PtgMemFunc',f:parse_PtgMemFunc},0x2A:{n:'PtgRefErr',f:parse_PtgRefErr},0x2B:{n:'PtgAreaErr',f:parse_PtgAreaErr},0x2C:{n:'PtgRefN',f:parse_PtgRefN},0x2D:{n:'PtgAreaN',f:parse_PtgAreaN},0x2E:{n:'PtgMemAreaN',f:parse_PtgMemAreaN},0x2F:{n:'PtgMemNoMemN',f:parse_PtgMemNoMemN},0x39:{n:'PtgNameX',f:parse_PtgNameX},0x3A:{n:'PtgRef3d',f:parse_PtgRef3d},0x3B:{n:'PtgArea3d',f:parse_PtgArea3d},0x3C:{n:'PtgRefErr3d',f:parse_PtgRefErr3d},0x3D:{n:'PtgAreaErr3d',f:parse_PtgAreaErr3d},0xFF:{}};var PtgDupes={0x40:0x20,0x60:0x20,0x41:0x21,0x61:0x21,0x42:0x22,0x62:0x22,0x43:0x23,0x63:0x23,0x44:0x24,0x64:0x24,0x45:0x25,0x65:0x25,0x46:0x26,0x66:0x26,0x47:0x27,0x67:0x27,0x48:0x28,0x68:0x28,0x49:0x29,0x69:0x29,0x4A:0x2A,0x6A:0x2A,0x4B:0x2B,0x6B:0x2B,0x4C:0x2C,0x6C:0x2C,0x4D:0x2D,0x6D:0x2D,0x4E:0x2E,0x6E:0x2E,0x4F:0x2F,0x6F:0x2F,0x58:0x22,0x78:0x22,0x59:0x39,0x79:0x39,0x5A:0x3A,0x7A:0x3A,0x5B:0x3B,0x7B:0x3B,0x5C:0x3C,0x7C:0x3C,0x5D:0x3D,0x7D:0x3D};var Ptg18={0x01:{n:'PtgElfLel',f:parse_PtgElfLel},0x02:{n:'PtgElfRw',f:parse_PtgElfRw},0x03:{n:'PtgElfCol',f:parse_PtgElfCol},0x06:{n:'PtgElfRwV',f:parse_PtgElfRwV},0x07:{n:'PtgElfColV',f:parse_PtgElfColV},0x0A:{n:'PtgElfRadical',f:parse_PtgElfRadical},0x0B:{n:'PtgElfRadicalS',f:parse_PtgElfRadicalS},0x0D:{n:'PtgElfColS',f:parse_PtgElfColS},0x0F:{n:'PtgElfColSV',f:parse_PtgElfColSV},0x10:{n:'PtgElfRadicalLel',f:parse_PtgElfRadicalLel},0x19:{n:'PtgList',f:parse_PtgList},0x1D:{n:'PtgSxName',f:parse_PtgSxName},0xFF:{}};var Ptg19={0x00:{n:'PtgAttrNoop',f:parse_PtgAttrNoop},0x01:{n:'PtgAttrSemi',f:parse_PtgAttrSemi},0x02:{n:'PtgAttrIf',f:parse_PtgAttrIf},0x04:{n:'PtgAttrChoose',f:parse_PtgAttrChoose},0x08:{n:'PtgAttrGoto',f:parse_PtgAttrGoto},0x10:{n:'PtgAttrSum',f:parse_PtgAttrSum},0x20:{n:'PtgAttrBaxcel',f:parse_PtgAttrBaxcel},0x21:{n:'PtgAttrBaxcel',f:parse_PtgAttrBaxcel},0x40:{n:'PtgAttrSpace',f:parse_PtgAttrSpace},0x41:{n:'PtgAttrSpaceSemi',f:parse_PtgAttrSpaceSemi},0x80:{n:'PtgAttrIfError',f:parse_PtgAttrIfError},0xFF:{}};function parse_RgbExtra(blob,length,rgce,opts){if(opts.biff<8)return parsenoop(blob,length);var target=blob.l+length;var o=[];for(var i=0;i!==rgce.length;++i){switch(rgce[i][0]){case'PtgArray':rgce[i][1]=parse_PtgExtraArray(blob,0,opts);o.push(rgce[i][1]);break;case'PtgMemArea':rgce[i][2]=parse_PtgExtraMem(blob,rgce[i][1],opts);o.push(rgce[i][2]);break;case'PtgExp':if(opts&&opts.biff==12){rgce[i][1][1]=blob.read_shift(4);o.push(rgce[i][1]);}break;case'PtgList':case'PtgElfRadicalS':case'PtgElfColS':case'PtgElfColSV':throw"Unsupported "+rgce[i][0];default:break;}}length=target-blob.l;if(length!==0)o.push(parsenoop(blob,length));return o;}function parse_Rgce(blob,length,opts){var target=blob.l+length;var R,id,ptgs=[];while(target!=blob.l){length=target-blob.l;id=blob[blob.l];R=PtgTypes[id]||PtgTypes[PtgDupes[id]];if(id===0x18||id===0x19)R=(id===0x18?Ptg18:Ptg19)[blob[blob.l+1]];if(!R||!R.f){parsenoop(blob,length);}else{ptgs.push([R.n,R.f(blob,length,opts)]);}}return ptgs;}function stringify_array(f){var o=[];for(var i=0;i<f.length;++i){var x=f[i],r=[];for(var j=0;j<x.length;++j){var y=x[j];if(y)switch(y[0]){case 0x02:r.push('"'+y[1].replace(/"/g,'""')+'"');break;default:r.push(y[1]);}else r.push("");}o.push(r.join(","));}return o.join(";");}var PtgBinOp={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};function formula_quote_sheet_name(sname,opts){if(!sname&&!(opts&&opts.biff<=5&&opts.biff>=2))throw new Error("empty sheet name");if(/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname))return"'"+sname+"'";return sname;}function get_ixti_raw(supbooks,ixti,opts){if(!supbooks)return"SH33TJSERR0";if(opts.biff>8&&(!supbooks.XTI||!supbooks.XTI[ixti]))return supbooks.SheetNames[ixti];if(!supbooks.XTI)return"SH33TJSERR6";var XTI=supbooks.XTI[ixti];if(opts.biff<8){if(ixti>10000)ixti-=65536;if(ixti<0)ixti=-ixti;return ixti==0?"":supbooks.XTI[ixti-1];}if(!XTI)return"SH33TJSERR1";var o="";if(opts.biff>8)switch(supbooks[XTI[0]][0]){case 0x0165:o=XTI[1]==-1?"#REF":supbooks.SheetNames[XTI[1]];return XTI[1]==XTI[2]?o:o+":"+supbooks.SheetNames[XTI[2]];case 0x0166:if(opts.SID!=null)return supbooks.SheetNames[opts.SID];return"SH33TJSSAME"+supbooks[XTI[0]][0];case 0x0163:default:return"SH33TJSSRC"+supbooks[XTI[0]][0];}switch(supbooks[XTI[0]][0][0]){case 0x0401:o=XTI[1]==-1?"#REF":supbooks.SheetNames[XTI[1]]||"SH33TJSERR3";return XTI[1]==XTI[2]?o:o+":"+supbooks.SheetNames[XTI[2]];case 0x3A01:return supbooks[XTI[0]].slice(1).map(function(name){return name.Name;}).join(";;");default:if(!supbooks[XTI[0]][0][3])return"SH33TJSERR2";o=XTI[1]==-1?"#REF":supbooks[XTI[0]][0][3][XTI[1]]||"SH33TJSERR4";return XTI[1]==XTI[2]?o:o+":"+supbooks[XTI[0]][0][3][XTI[2]];}}function get_ixti(supbooks,ixti,opts){var ixtiraw=get_ixti_raw(supbooks,ixti,opts);return ixtiraw=="#REF"?ixtiraw:formula_quote_sheet_name(ixtiraw,opts);}function stringify_formula(formula,range,cell,supbooks,opts){var biff=opts&&opts.biff||8;var _range={s:{c:0,r:0},e:{c:0,r:0}};var stack=[],e1,e2,c,ixti=0,nameidx=0,r,sname="";if(!formula[0]||!formula[0][0])return"";var last_sp=-1,sp="";for(var ff=0,fflen=formula[0].length;ff<fflen;++ff){var f=formula[0][ff];switch(f[0]){case'PtgUminus':stack.push("-"+stack.pop());break;case'PtgUplus':stack.push("+"+stack.pop());break;case'PtgPercent':stack.push(stack.pop()+"%");break;case'PtgAdd':case'PtgConcat':case'PtgDiv':case'PtgEq':case'PtgGe':case'PtgGt':case'PtgLe':case'PtgLt':case'PtgMul':case'PtgNe':case'PtgPower':case'PtgSub':e1=stack.pop();e2=stack.pop();if(last_sp>=0){switch(formula[0][last_sp][1][0]){case 0:sp=fill(" ",formula[0][last_sp][1][1]);break;case 1:sp=fill("\r",formula[0][last_sp][1][1]);break;default:sp="";if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+formula[0][last_sp][1][0]);}e2=e2+sp;last_sp=-1;}stack.push(e2+PtgBinOp[f[0]]+e1);break;case'PtgIsect':e1=stack.pop();e2=stack.pop();stack.push(e2+" "+e1);break;case'PtgUnion':e1=stack.pop();e2=stack.pop();stack.push(e2+","+e1);break;case'PtgRange':e1=stack.pop();e2=stack.pop();stack.push(e2+":"+e1);break;case'PtgAttrChoose':break;case'PtgAttrGoto':break;case'PtgAttrIf':break;case'PtgAttrIfError':break;case'PtgRef':c=shift_cell_xls(f[1][1],_range,opts);stack.push(encode_cell_xls(c,biff));break;case'PtgRefN':c=cell?shift_cell_xls(f[1][1],cell,opts):f[1][1];stack.push(encode_cell_xls(c,biff));break;case'PtgRef3d':ixti=f[1][1];c=shift_cell_xls(f[1][2],_range,opts);sname=get_ixti(supbooks,ixti,opts);var w=sname;stack.push(sname+"!"+encode_cell_xls(c,biff));break;case'PtgFunc':case'PtgFuncVar':var argc=f[1][0],func=f[1][1];if(!argc)argc=0;argc&=0x7F;var args=argc==0?[]:stack.slice(-argc);stack.length-=argc;if(func==='User')func=args.shift();stack.push(func+"("+args.join(",")+")");break;case'PtgBool':stack.push(f[1]?"TRUE":"FALSE");break;case'PtgInt':stack.push(f[1]);break;case'PtgNum':stack.push(String(f[1]));break;case'PtgStr':stack.push('"'+f[1].replace(/"/g,'""')+'"');break;case'PtgErr':stack.push(f[1]);break;case'PtgAreaN':r=shift_range_xls(f[1][1],cell?{s:cell}:_range,opts);stack.push(encode_range_xls(r,opts));break;case'PtgArea':r=shift_range_xls(f[1][1],_range,opts);stack.push(encode_range_xls(r,opts));break;case'PtgArea3d':ixti=f[1][1];r=f[1][2];sname=get_ixti(supbooks,ixti,opts);stack.push(sname+"!"+encode_range_xls(r,opts));break;case'PtgAttrSum':stack.push("SUM("+stack.pop()+")");break;case'PtgAttrBaxcel':case'PtgAttrSemi':break;case'PtgName':nameidx=f[1][2];var lbl=(supbooks.names||[])[nameidx-1]||(supbooks[0]||[])[nameidx];var name=lbl?lbl.Name:"SH33TJSNAME"+String(nameidx);if(name&&name.slice(0,6)=="_xlfn."&&!opts.xlfn)name=name.slice(6);stack.push(name);break;case'PtgNameX':var bookidx=f[1][1];nameidx=f[1][2];var externbook;if(opts.biff<=5){if(bookidx<0)bookidx=-bookidx;if(supbooks[bookidx])externbook=supbooks[bookidx][nameidx];}else{var o="";if(((supbooks[bookidx]||[])[0]||[])[0]==0x3A01){}else if(((supbooks[bookidx]||[])[0]||[])[0]==0x0401){if(supbooks[bookidx][nameidx]&&supbooks[bookidx][nameidx].itab>0){o=supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1]+"!";}}else o=supbooks.SheetNames[nameidx-1]+"!";if(supbooks[bookidx]&&supbooks[bookidx][nameidx])o+=supbooks[bookidx][nameidx].Name;else if(supbooks[0]&&supbooks[0][nameidx])o+=supbooks[0][nameidx].Name;else{var ixtidata=(get_ixti_raw(supbooks,bookidx,opts)||"").split(";;");if(ixtidata[nameidx-1])o=ixtidata[nameidx-1];else o+="SH33TJSERRX";}stack.push(o);break;}if(!externbook)externbook={Name:"SH33TJSERRY"};stack.push(externbook.Name);break;case'PtgParen':var lp='(',rp=')';if(last_sp>=0){sp="";switch(formula[0][last_sp][1][0]){case 2:lp=fill(" ",formula[0][last_sp][1][1])+lp;break;case 3:lp=fill("\r",formula[0][last_sp][1][1])+lp;break;case 4:rp=fill(" ",formula[0][last_sp][1][1])+rp;break;case 5:rp=fill("\r",formula[0][last_sp][1][1])+rp;break;default:if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+formula[0][last_sp][1][0]);}last_sp=-1;}stack.push(lp+stack.pop()+rp);break;case'PtgRefErr':stack.push('#REF!');break;case'PtgRefErr3d':stack.push('#REF!');break;case'PtgExp':c={c:f[1][1],r:f[1][0]};var q={c:cell.c,r:cell.r};if(supbooks.sharedf[encode_cell(c)]){var parsedf=supbooks.sharedf[encode_cell(c)];stack.push(stringify_formula(parsedf,_range,q,supbooks,opts));}else{var fnd=false;for(e1=0;e1!=supbooks.arrayf.length;++e1){e2=supbooks.arrayf[e1];if(c.c<e2[0].s.c||c.c>e2[0].e.c)continue;if(c.r<e2[0].s.r||c.r>e2[0].e.r)continue;stack.push(stringify_formula(e2[1],_range,q,supbooks,opts));fnd=true;break;}if(!fnd)stack.push(f[1]);}break;case'PtgArray':stack.push("{"+stringify_array(f[1])+"}");break;case'PtgMemArea':break;case'PtgAttrSpace':case'PtgAttrSpaceSemi':last_sp=ff;break;case'PtgTbl':break;case'PtgMemErr':break;case'PtgMissArg':stack.push("");break;case'PtgAreaErr':stack.push("#REF!");break;case'PtgAreaErr3d':stack.push("#REF!");break;case'PtgList':stack.push("Table"+f[1].idx+"[#"+f[1].rt+"]");break;case'PtgMemAreaN':case'PtgMemNoMemN':case'PtgAttrNoop':case'PtgSheet':case'PtgEndSheet':break;case'PtgMemFunc':break;case'PtgMemNoMem':break;case'PtgElfCol':case'PtgElfColS':case'PtgElfColSV':case'PtgElfColV':case'PtgElfLel':case'PtgElfRadical':case'PtgElfRadicalLel':case'PtgElfRadicalS':case'PtgElfRw':case'PtgElfRwV':throw new Error("Unsupported ELFs");case'PtgSxName':throw new Error('Unrecognized Formula Token: '+String(f));default:throw new Error('Unrecognized Formula Token: '+String(f));}var PtgNonDisp=['PtgAttrSpace','PtgAttrSpaceSemi','PtgAttrGoto'];if(opts.biff!=3)if(last_sp>=0&&PtgNonDisp.indexOf(formula[0][ff][0])==-1){f=formula[0][last_sp];var _left=true;switch(f[1][0]){case 4:_left=false;case 0:sp=fill(" ",f[1][1]);break;case 5:_left=false;case 1:sp=fill("\r",f[1][1]);break;default:sp="";if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+f[1][0]);}stack.push((_left?sp:"")+stack.pop()+(_left?"":sp));last_sp=-1;}}if(stack.length>1&&opts.WTF)throw new Error("bad formula stack");return stack[0];}function parse_ArrayParsedFormula(blob,length,opts){var target=blob.l+length,len=opts.biff==2?1:2;var rgcb,cce=blob.read_shift(len);if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce,opts);if(length!==cce+len)rgcb=parse_RgbExtra(blob,length-cce-len,rgce,opts);blob.l=target;return[rgce,rgcb];}function parse_XLSCellParsedFormula(blob,length,opts){var target=blob.l+length,len=opts.biff==2?1:2;var rgcb,cce=blob.read_shift(len);if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce,opts);if(length!==cce+len)rgcb=parse_RgbExtra(blob,length-cce-len,rgce,opts);blob.l=target;return[rgce,rgcb];}function parse_NameParsedFormula(blob,length,opts,cce){var target=blob.l+length;var rgce=parse_Rgce(blob,cce,opts);var rgcb;if(target!==blob.l)rgcb=parse_RgbExtra(blob,target-blob.l,rgce,opts);return[rgce,rgcb];}function parse_SharedParsedFormula(blob,length,opts){var target=blob.l+length;var rgcb,cce=blob.read_shift(2);var rgce=parse_Rgce(blob,cce,opts);if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];if(length!==cce+2)rgcb=parse_RgbExtra(blob,target-cce-2,rgce,opts);return[rgce,rgcb];}function parse_FormulaValue(blob){var b;if(__readUInt16LE(blob,blob.l+6)!==0xFFFF)return[parse_Xnum(blob),'n'];switch(blob[blob.l]){case 0x00:blob.l+=8;return["String",'s'];case 0x01:b=blob[blob.l+2]===0x1;blob.l+=8;return[b,'b'];case 0x02:b=blob[blob.l+2];blob.l+=8;return[b,'e'];case 0x03:blob.l+=8;return["",'s'];}return[];}function write_FormulaValue(value){if(value==null){var o=new_buf(8);o.write_shift(1,0x03);o.write_shift(1,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0xFFFF);return o;}else if(typeof value=="number")return write_Xnum(value);return write_Xnum(0);}function parse_Formula(blob,length,opts){var end=blob.l+length;var cell=parse_XLSCell(blob,6);if(opts.biff==2)++blob.l;var val=parse_FormulaValue(blob,8);var flags=blob.read_shift(1);if(opts.biff!=2){blob.read_shift(1);if(opts.biff>=5){blob.read_shift(4);}}var cbf=parse_XLSCellParsedFormula(blob,end-blob.l,opts);return{cell:cell,val:val[0],formula:cbf,shared:flags>>3&1,tt:val[1]};}function write_Formula(cell,R,C,opts,os){var o1=write_XLSCell(R,C,os);var o2=write_FormulaValue(cell.v);var o3=new_buf(6);var flags=0x01|0x20;o3.write_shift(2,flags);o3.write_shift(4,0);var bf=new_buf(cell.bf.length);for(var i=0;i<cell.bf.length;++i){bf[i]=cell.bf[i];}var out=bconcat([o1,o2,o3,bf]);return out;}function parse_XLSBParsedFormula(data,length,opts){var cce=data.read_shift(4);var rgce=parse_Rgce(data,cce,opts);var cb=data.read_shift(4);var rgcb=cb>0?parse_RgbExtra(data,cb,rgce,opts):null;return[rgce,rgcb];}var parse_XLSBArrayParsedFormula=parse_XLSBParsedFormula;var parse_XLSBCellParsedFormula=parse_XLSBParsedFormula;var parse_XLSBNameParsedFormula=parse_XLSBParsedFormula;var parse_XLSBSharedParsedFormula=parse_XLSBParsedFormula;var Cetab={0:"BEEP",1:"OPEN",2:"OPEN.LINKS",3:"CLOSE.ALL",4:"SAVE",5:"SAVE.AS",6:"FILE.DELETE",7:"PAGE.SETUP",8:"PRINT",9:"PRINTER.SETUP",10:"QUIT",11:"NEW.WINDOW",12:"ARRANGE.ALL",13:"WINDOW.SIZE",14:"WINDOW.MOVE",15:"FULL",16:"CLOSE",17:"RUN",22:"SET.PRINT.AREA",23:"SET.PRINT.TITLES",24:"SET.PAGE.BREAK",25:"REMOVE.PAGE.BREAK",26:"FONT",27:"DISPLAY",28:"PROTECT.DOCUMENT",29:"PRECISION",30:"A1.R1C1",31:"CALCULATE.NOW",32:"CALCULATION",34:"DATA.FIND",35:"EXTRACT",36:"DATA.DELETE",37:"SET.DATABASE",38:"SET.CRITERIA",39:"SORT",40:"DATA.SERIES",41:"TABLE",42:"FORMAT.NUMBER",43:"ALIGNMENT",44:"STYLE",45:"BORDER",46:"CELL.PROTECTION",47:"COLUMN.WIDTH",48:"UNDO",49:"CUT",50:"COPY",51:"PASTE",52:"CLEAR",53:"PASTE.SPECIAL",54:"EDIT.DELETE",55:"INSERT",56:"FILL.RIGHT",57:"FILL.DOWN",61:"DEFINE.NAME",62:"CREATE.NAMES",63:"FORMULA.GOTO",64:"FORMULA.FIND",65:"SELECT.LAST.CELL",66:"SHOW.ACTIVE.CELL",67:"GALLERY.AREA",68:"GALLERY.BAR",69:"GALLERY.COLUMN",70:"GALLERY.LINE",71:"GALLERY.PIE",72:"GALLERY.SCATTER",73:"COMBINATION",74:"PREFERRED",75:"ADD.OVERLAY",76:"GRIDLINES",77:"SET.PREFERRED",78:"AXES",79:"LEGEND",80:"ATTACH.TEXT",81:"ADD.ARROW",82:"SELECT.CHART",83:"SELECT.PLOT.AREA",84:"PATTERNS",85:"MAIN.CHART",86:"OVERLAY",87:"SCALE",88:"FORMAT.LEGEND",89:"FORMAT.TEXT",90:"EDIT.REPEAT",91:"PARSE",92:"JUSTIFY",93:"HIDE",94:"UNHIDE",95:"WORKSPACE",96:"FORMULA",97:"FORMULA.FILL",98:"FORMULA.ARRAY",99:"DATA.FIND.NEXT",100:"DATA.FIND.PREV",101:"FORMULA.FIND.NEXT",102:"FORMULA.FIND.PREV",103:"ACTIVATE",104:"ACTIVATE.NEXT",105:"ACTIVATE.PREV",106:"UNLOCKED.NEXT",107:"UNLOCKED.PREV",108:"COPY.PICTURE",109:"SELECT",110:"DELETE.NAME",111:"DELETE.FORMAT",112:"VLINE",113:"HLINE",114:"VPAGE",115:"HPAGE",116:"VSCROLL",117:"HSCROLL",118:"ALERT",119:"NEW",120:"CANCEL.COPY",121:"SHOW.CLIPBOARD",122:"MESSAGE",124:"PASTE.LINK",125:"APP.ACTIVATE",126:"DELETE.ARROW",127:"ROW.HEIGHT",128:"FORMAT.MOVE",129:"FORMAT.SIZE",130:"FORMULA.REPLACE",131:"SEND.KEYS",132:"SELECT.SPECIAL",133:"APPLY.NAMES",134:"REPLACE.FONT",135:"FREEZE.PANES",136:"SHOW.INFO",137:"SPLIT",138:"ON.WINDOW",139:"ON.DATA",140:"DISABLE.INPUT",142:"OUTLINE",143:"LIST.NAMES",144:"FILE.CLOSE",145:"SAVE.WORKBOOK",146:"DATA.FORM",147:"COPY.CHART",148:"ON.TIME",149:"WAIT",150:"FORMAT.FONT",151:"FILL.UP",152:"FILL.LEFT",153:"DELETE.OVERLAY",155:"SHORT.MENUS",159:"SET.UPDATE.STATUS",161:"COLOR.PALETTE",162:"DELETE.STYLE",163:"WINDOW.RESTORE",164:"WINDOW.MAXIMIZE",166:"CHANGE.LINK",167:"CALCULATE.DOCUMENT",168:"ON.KEY",169:"APP.RESTORE",170:"APP.MOVE",171:"APP.SIZE",172:"APP.MINIMIZE",173:"APP.MAXIMIZE",174:"BRING.TO.FRONT",175:"SEND.TO.BACK",185:"MAIN.CHART.TYPE",186:"OVERLAY.CHART.TYPE",187:"SELECT.END",188:"OPEN.MAIL",189:"SEND.MAIL",190:"STANDARD.FONT",191:"CONSOLIDATE",192:"SORT.SPECIAL",193:"GALLERY.3D.AREA",194:"GALLERY.3D.COLUMN",195:"GALLERY.3D.LINE",196:"GALLERY.3D.PIE",197:"VIEW.3D",198:"GOAL.SEEK",199:"WORKGROUP",200:"FILL.GROUP",201:"UPDATE.LINK",202:"PROMOTE",203:"DEMOTE",204:"SHOW.DETAIL",206:"UNGROUP",207:"OBJECT.PROPERTIES",208:"SAVE.NEW.OBJECT",209:"SHARE",210:"SHARE.NAME",211:"DUPLICATE",212:"APPLY.STYLE",213:"ASSIGN.TO.OBJECT",214:"OBJECT.PROTECTION",215:"HIDE.OBJECT",216:"SET.EXTRACT",217:"CREATE.PUBLISHER",218:"SUBSCRIBE.TO",219:"ATTRIBUTES",220:"SHOW.TOOLBAR",222:"PRINT.PREVIEW",223:"EDIT.COLOR",224:"SHOW.LEVELS",225:"FORMAT.MAIN",226:"FORMAT.OVERLAY",227:"ON.RECALC",228:"EDIT.SERIES",229:"DEFINE.STYLE",240:"LINE.PRINT",243:"ENTER.DATA",249:"GALLERY.RADAR",250:"MERGE.STYLES",251:"EDITION.OPTIONS",252:"PASTE.PICTURE",253:"PASTE.PICTURE.LINK",254:"SPELLING",256:"ZOOM",259:"INSERT.OBJECT",260:"WINDOW.MINIMIZE",265:"SOUND.NOTE",266:"SOUND.PLAY",267:"FORMAT.SHAPE",268:"EXTEND.POLYGON",269:"FORMAT.AUTO",272:"GALLERY.3D.BAR",273:"GALLERY.3D.SURFACE",274:"FILL.AUTO",276:"CUSTOMIZE.TOOLBAR",277:"ADD.TOOL",278:"EDIT.OBJECT",279:"ON.DOUBLECLICK",280:"ON.ENTRY",281:"WORKBOOK.ADD",282:"WORKBOOK.MOVE",283:"WORKBOOK.COPY",284:"WORKBOOK.OPTIONS",285:"SAVE.WORKSPACE",288:"CHART.WIZARD",289:"DELETE.TOOL",290:"MOVE.TOOL",291:"WORKBOOK.SELECT",292:"WORKBOOK.ACTIVATE",293:"ASSIGN.TO.TOOL",295:"COPY.TOOL",296:"RESET.TOOL",297:"CONSTRAIN.NUMERIC",298:"PASTE.TOOL",302:"WORKBOOK.NEW",305:"SCENARIO.CELLS",306:"SCENARIO.DELETE",307:"SCENARIO.ADD",308:"SCENARIO.EDIT",309:"SCENARIO.SHOW",310:"SCENARIO.SHOW.NEXT",311:"SCENARIO.SUMMARY",312:"PIVOT.TABLE.WIZARD",313:"PIVOT.FIELD.PROPERTIES",314:"PIVOT.FIELD",315:"PIVOT.ITEM",316:"PIVOT.ADD.FIELDS",318:"OPTIONS.CALCULATION",319:"OPTIONS.EDIT",320:"OPTIONS.VIEW",321:"ADDIN.MANAGER",322:"MENU.EDITOR",323:"ATTACH.TOOLBARS",324:"VBAActivate",325:"OPTIONS.CHART",328:"VBA.INSERT.FILE",330:"VBA.PROCEDURE.DEFINITION",336:"ROUTING.SLIP",338:"ROUTE.DOCUMENT",339:"MAIL.LOGON",342:"INSERT.PICTURE",343:"EDIT.TOOL",344:"GALLERY.DOUGHNUT",350:"CHART.TREND",352:"PIVOT.ITEM.PROPERTIES",354:"WORKBOOK.INSERT",355:"OPTIONS.TRANSITION",356:"OPTIONS.GENERAL",370:"FILTER.ADVANCED",373:"MAIL.ADD.MAILER",374:"MAIL.DELETE.MAILER",375:"MAIL.REPLY",376:"MAIL.REPLY.ALL",377:"MAIL.FORWARD",378:"MAIL.NEXT.LETTER",379:"DATA.LABEL",380:"INSERT.TITLE",381:"FONT.PROPERTIES",382:"MACRO.OPTIONS",383:"WORKBOOK.HIDE",384:"WORKBOOK.UNHIDE",385:"WORKBOOK.DELETE",386:"WORKBOOK.NAME",388:"GALLERY.CUSTOM",390:"ADD.CHART.AUTOFORMAT",391:"DELETE.CHART.AUTOFORMAT",392:"CHART.ADD.DATA",393:"AUTO.OUTLINE",394:"TAB.ORDER",395:"SHOW.DIALOG",396:"SELECT.ALL",397:"UNGROUP.SHEETS",398:"SUBTOTAL.CREATE",399:"SUBTOTAL.REMOVE",400:"RENAME.OBJECT",412:"WORKBOOK.SCROLL",413:"WORKBOOK.NEXT",414:"WORKBOOK.PREV",415:"WORKBOOK.TAB.SPLIT",416:"FULL.SCREEN",417:"WORKBOOK.PROTECT",420:"SCROLLBAR.PROPERTIES",421:"PIVOT.SHOW.PAGES",422:"TEXT.TO.COLUMNS",423:"FORMAT.CHARTTYPE",424:"LINK.FORMAT",425:"TRACER.DISPLAY",430:"TRACER.NAVIGATE",431:"TRACER.CLEAR",432:"TRACER.ERROR",433:"PIVOT.FIELD.GROUP",434:"PIVOT.FIELD.UNGROUP",435:"CHECKBOX.PROPERTIES",436:"LABEL.PROPERTIES",437:"LISTBOX.PROPERTIES",438:"EDITBOX.PROPERTIES",439:"PIVOT.REFRESH",440:"LINK.COMBO",441:"OPEN.TEXT",442:"HIDE.DIALOG",443:"SET.DIALOG.FOCUS",444:"ENABLE.OBJECT",445:"PUSHBUTTON.PROPERTIES",446:"SET.DIALOG.DEFAULT",447:"FILTER",448:"FILTER.SHOW.ALL",449:"CLEAR.OUTLINE",450:"FUNCTION.WIZARD",451:"ADD.LIST.ITEM",452:"SET.LIST.ITEM",453:"REMOVE.LIST.ITEM",454:"SELECT.LIST.ITEM",455:"SET.CONTROL.VALUE",456:"SAVE.COPY.AS",458:"OPTIONS.LISTS.ADD",459:"OPTIONS.LISTS.DELETE",460:"SERIES.AXES",461:"SERIES.X",462:"SERIES.Y",463:"ERRORBAR.X",464:"ERRORBAR.Y",465:"FORMAT.CHART",466:"SERIES.ORDER",467:"MAIL.LOGOFF",468:"CLEAR.ROUTING.SLIP",469:"APP.ACTIVATE.MICROSOFT",470:"MAIL.EDIT.MAILER",471:"ON.SHEET",472:"STANDARD.WIDTH",473:"SCENARIO.MERGE",474:"SUMMARY.INFO",475:"FIND.FILE",476:"ACTIVE.CELL.FONT",477:"ENABLE.TIPWIZARD",478:"VBA.MAKE.ADDIN",480:"INSERTDATATABLE",481:"WORKGROUP.OPTIONS",482:"MAIL.SEND.MAILER",485:"AUTOCORRECT",489:"POST.DOCUMENT",491:"PICKLIST",493:"VIEW.SHOW",494:"VIEW.DEFINE",495:"VIEW.DELETE",509:"SHEET.BACKGROUND",510:"INSERT.MAP.OBJECT",511:"OPTIONS.MENONO",517:"MSOCHECKS",518:"NORMAL",519:"LAYOUT",520:"RM.PRINT.AREA",521:"CLEAR.PRINT.AREA",522:"ADD.PRINT.AREA",523:"MOVE.BRK",545:"HIDECURR.NOTE",546:"HIDEALL.NOTES",547:"DELETE.NOTE",548:"TRAVERSE.NOTES",549:"ACTIVATE.NOTES",620:"PROTECT.REVISIONS",621:"UNPROTECT.REVISIONS",647:"OPTIONS.ME",653:"WEB.PUBLISH",667:"NEWWEBQUERY",673:"PIVOT.TABLE.CHART",753:"OPTIONS.SAVE",755:"OPTIONS.SPELL",808:"HIDEALL.INKANNOTS"};var Ftab={0:"COUNT",1:"IF",2:"ISNA",3:"ISERROR",4:"SUM",5:"AVERAGE",6:"MIN",7:"MAX",8:"ROW",9:"COLUMN",10:"NA",11:"NPV",12:"STDEV",13:"DOLLAR",14:"FIXED",15:"SIN",16:"COS",17:"TAN",18:"ATAN",19:"PI",20:"SQRT",21:"EXP",22:"LN",23:"LOG10",24:"ABS",25:"INT",26:"SIGN",27:"ROUND",28:"LOOKUP",29:"INDEX",30:"REPT",31:"MID",32:"LEN",33:"VALUE",34:"TRUE",35:"FALSE",36:"AND",37:"OR",38:"NOT",39:"MOD",40:"DCOUNT",41:"DSUM",42:"DAVERAGE",43:"DMIN",44:"DMAX",45:"DSTDEV",46:"VAR",47:"DVAR",48:"TEXT",49:"LINEST",50:"TREND",51:"LOGEST",52:"GROWTH",53:"GOTO",54:"HALT",55:"RETURN",56:"PV",57:"FV",58:"NPER",59:"PMT",60:"RATE",61:"MIRR",62:"IRR",63:"RAND",64:"MATCH",65:"DATE",66:"TIME",67:"DAY",68:"MONTH",69:"YEAR",70:"WEEKDAY",71:"HOUR",72:"MINUTE",73:"SECOND",74:"NOW",75:"AREAS",76:"ROWS",77:"COLUMNS",78:"OFFSET",79:"ABSREF",80:"RELREF",81:"ARGUMENT",82:"SEARCH",83:"TRANSPOSE",84:"ERROR",85:"STEP",86:"TYPE",87:"ECHO",88:"SET.NAME",89:"CALLER",90:"DEREF",91:"WINDOWS",92:"SERIES",93:"DOCUMENTS",94:"ACTIVE.CELL",95:"SELECTION",96:"RESULT",97:"ATAN2",98:"ASIN",99:"ACOS",100:"CHOOSE",101:"HLOOKUP",102:"VLOOKUP",103:"LINKS",104:"INPUT",105:"ISREF",106:"GET.FORMULA",107:"GET.NAME",108:"SET.VALUE",109:"LOG",110:"EXEC",111:"CHAR",112:"LOWER",113:"UPPER",114:"PROPER",115:"LEFT",116:"RIGHT",117:"EXACT",118:"TRIM",119:"REPLACE",120:"SUBSTITUTE",121:"CODE",122:"NAMES",123:"DIRECTORY",124:"FIND",125:"CELL",126:"ISERR",127:"ISTEXT",128:"ISNUMBER",129:"ISBLANK",130:"T",131:"N",132:"FOPEN",133:"FCLOSE",134:"FSIZE",135:"FREADLN",136:"FREAD",137:"FWRITELN",138:"FWRITE",139:"FPOS",140:"DATEVALUE",141:"TIMEVALUE",142:"SLN",143:"SYD",144:"DDB",145:"GET.DEF",146:"REFTEXT",147:"TEXTREF",148:"INDIRECT",149:"REGISTER",150:"CALL",151:"ADD.BAR",152:"ADD.MENU",153:"ADD.COMMAND",154:"ENABLE.COMMAND",155:"CHECK.COMMAND",156:"RENAME.COMMAND",157:"SHOW.BAR",158:"DELETE.MENU",159:"DELETE.COMMAND",160:"GET.CHART.ITEM",161:"DIALOG.BOX",162:"CLEAN",163:"MDETERM",164:"MINVERSE",165:"MMULT",166:"FILES",167:"IPMT",168:"PPMT",169:"COUNTA",170:"CANCEL.KEY",171:"FOR",172:"WHILE",173:"BREAK",174:"NEXT",175:"INITIATE",176:"REQUEST",177:"POKE",178:"EXECUTE",179:"TERMINATE",180:"RESTART",181:"HELP",182:"GET.BAR",183:"PRODUCT",184:"FACT",185:"GET.CELL",186:"GET.WORKSPACE",187:"GET.WINDOW",188:"GET.DOCUMENT",189:"DPRODUCT",190:"ISNONTEXT",191:"GET.NOTE",192:"NOTE",193:"STDEVP",194:"VARP",195:"DSTDEVP",196:"DVARP",197:"TRUNC",198:"ISLOGICAL",199:"DCOUNTA",200:"DELETE.BAR",201:"UNREGISTER",204:"USDOLLAR",205:"FINDB",206:"SEARCHB",207:"REPLACEB",208:"LEFTB",209:"RIGHTB",210:"MIDB",211:"LENB",212:"ROUNDUP",213:"ROUNDDOWN",214:"ASC",215:"DBCS",216:"RANK",219:"ADDRESS",220:"DAYS360",221:"TODAY",222:"VDB",223:"ELSE",224:"ELSE.IF",225:"END.IF",226:"FOR.CELL",227:"MEDIAN",228:"SUMPRODUCT",229:"SINH",230:"COSH",231:"TANH",232:"ASINH",233:"ACOSH",234:"ATANH",235:"DGET",236:"CREATE.OBJECT",237:"VOLATILE",238:"LAST.ERROR",239:"CUSTOM.UNDO",240:"CUSTOM.REPEAT",241:"FORMULA.CONVERT",242:"GET.LINK.INFO",243:"TEXT.BOX",244:"INFO",245:"GROUP",246:"GET.OBJECT",247:"DB",248:"PAUSE",251:"RESUME",252:"FREQUENCY",253:"ADD.TOOLBAR",254:"DELETE.TOOLBAR",255:"User",256:"RESET.TOOLBAR",257:"EVALUATE",258:"GET.TOOLBAR",259:"GET.TOOL",260:"SPELLING.CHECK",261:"ERROR.TYPE",262:"APP.TITLE",263:"WINDOW.TITLE",264:"SAVE.TOOLBAR",265:"ENABLE.TOOL",266:"PRESS.TOOL",267:"REGISTER.ID",268:"GET.WORKBOOK",269:"AVEDEV",270:"BETADIST",271:"GAMMALN",272:"BETAINV",273:"BINOMDIST",274:"CHIDIST",275:"CHIINV",276:"COMBIN",277:"CONFIDENCE",278:"CRITBINOM",279:"EVEN",280:"EXPONDIST",281:"FDIST",282:"FINV",283:"FISHER",284:"FISHERINV",285:"FLOOR",286:"GAMMADIST",287:"GAMMAINV",288:"CEILING",289:"HYPGEOMDIST",290:"LOGNORMDIST",291:"LOGINV",292:"NEGBINOMDIST",293:"NORMDIST",294:"NORMSDIST",295:"NORMINV",296:"NORMSINV",297:"STANDARDIZE",298:"ODD",299:"PERMUT",300:"POISSON",301:"TDIST",302:"WEIBULL",303:"SUMXMY2",304:"SUMX2MY2",305:"SUMX2PY2",306:"CHITEST",307:"CORREL",308:"COVAR",309:"FORECAST",310:"FTEST",311:"INTERCEPT",312:"PEARSON",313:"RSQ",314:"STEYX",315:"SLOPE",316:"TTEST",317:"PROB",318:"DEVSQ",319:"GEOMEAN",320:"HARMEAN",321:"SUMSQ",322:"KURT",323:"SKEW",324:"ZTEST",325:"LARGE",326:"SMALL",327:"QUARTILE",328:"PERCENTILE",329:"PERCENTRANK",330:"MODE",331:"TRIMMEAN",332:"TINV",334:"MOVIE.COMMAND",335:"GET.MOVIE",336:"CONCATENATE",337:"POWER",338:"PIVOT.ADD.DATA",339:"GET.PIVOT.TABLE",340:"GET.PIVOT.FIELD",341:"GET.PIVOT.ITEM",342:"RADIANS",343:"DEGREES",344:"SUBTOTAL",345:"SUMIF",346:"COUNTIF",347:"COUNTBLANK",348:"SCENARIO.GET",349:"OPTIONS.LISTS.GET",350:"ISPMT",351:"DATEDIF",352:"DATESTRING",353:"NUMBERSTRING",354:"ROMAN",355:"OPEN.DIALOG",356:"SAVE.DIALOG",357:"VIEW.GET",358:"GETPIVOTDATA",359:"HYPERLINK",360:"PHONETIC",361:"AVERAGEA",362:"MAXA",363:"MINA",364:"STDEVPA",365:"VARPA",366:"STDEVA",367:"VARA",368:"BAHTTEXT",369:"THAIDAYOFWEEK",370:"THAIDIGIT",371:"THAIMONTHOFYEAR",372:"THAINUMSOUND",373:"THAINUMSTRING",374:"THAISTRINGLENGTH",375:"ISTHAIDIGIT",376:"ROUNDBAHTDOWN",377:"ROUNDBAHTUP",378:"THAIYEAR",379:"RTD",380:"CUBEVALUE",381:"CUBEMEMBER",382:"CUBEMEMBERPROPERTY",383:"CUBERANKEDMEMBER",384:"HEX2BIN",385:"HEX2DEC",386:"HEX2OCT",387:"DEC2BIN",388:"DEC2HEX",389:"DEC2OCT",390:"OCT2BIN",391:"OCT2HEX",392:"OCT2DEC",393:"BIN2DEC",394:"BIN2OCT",395:"BIN2HEX",396:"IMSUB",397:"IMDIV",398:"IMPOWER",399:"IMABS",400:"IMSQRT",401:"IMLN",402:"IMLOG2",403:"IMLOG10",404:"IMSIN",405:"IMCOS",406:"IMEXP",407:"IMARGUMENT",408:"IMCONJUGATE",409:"IMAGINARY",410:"IMREAL",411:"COMPLEX",412:"IMSUM",413:"IMPRODUCT",414:"SERIESSUM",415:"FACTDOUBLE",416:"SQRTPI",417:"QUOTIENT",418:"DELTA",419:"GESTEP",420:"ISEVEN",421:"ISODD",422:"MROUND",423:"ERF",424:"ERFC",425:"BESSELJ",426:"BESSELK",427:"BESSELY",428:"BESSELI",429:"XIRR",430:"XNPV",431:"PRICEMAT",432:"YIELDMAT",433:"INTRATE",434:"RECEIVED",435:"DISC",436:"PRICEDISC",437:"YIELDDISC",438:"TBILLEQ",439:"TBILLPRICE",440:"TBILLYIELD",441:"PRICE",442:"YIELD",443:"DOLLARDE",444:"DOLLARFR",445:"NOMINAL",446:"EFFECT",447:"CUMPRINC",448:"CUMIPMT",449:"EDATE",450:"EOMONTH",451:"YEARFRAC",452:"COUPDAYBS",453:"COUPDAYS",454:"COUPDAYSNC",455:"COUPNCD",456:"COUPNUM",457:"COUPPCD",458:"DURATION",459:"MDURATION",460:"ODDLPRICE",461:"ODDLYIELD",462:"ODDFPRICE",463:"ODDFYIELD",464:"RANDBETWEEN",465:"WEEKNUM",466:"AMORDEGRC",467:"AMORLINC",468:"CONVERT",724:"SHEETJS",469:"ACCRINT",470:"ACCRINTM",471:"WORKDAY",472:"NETWORKDAYS",473:"GCD",474:"MULTINOMIAL",475:"LCM",476:"FVSCHEDULE",477:"CUBEKPIMEMBER",478:"CUBESET",479:"CUBESETCOUNT",480:"IFERROR",481:"COUNTIFS",482:"SUMIFS",483:"AVERAGEIF",484:"AVERAGEIFS"};var FtabArgc={2:1,3:1,10:0,15:1,16:1,17:1,18:1,19:0,20:1,21:1,22:1,23:1,24:1,25:1,26:1,27:2,30:2,31:3,32:1,33:1,34:0,35:0,38:1,39:2,40:3,41:3,42:3,43:3,44:3,45:3,47:3,48:2,53:1,61:3,63:0,65:3,66:3,67:1,68:1,69:1,70:1,71:1,72:1,73:1,74:0,75:1,76:1,77:1,79:2,80:2,83:1,85:0,86:1,89:0,90:1,94:0,95:0,97:2,98:1,99:1,101:3,102:3,105:1,106:1,108:2,111:1,112:1,113:1,114:1,117:2,118:1,119:4,121:1,126:1,127:1,128:1,129:1,130:1,131:1,133:1,134:1,135:1,136:2,137:2,138:2,140:1,141:1,142:3,143:4,144:4,161:1,162:1,163:1,164:1,165:2,172:1,175:2,176:2,177:3,178:2,179:1,184:1,186:1,189:3,190:1,195:3,196:3,197:1,198:1,199:3,201:1,207:4,210:3,211:1,212:2,213:2,214:1,215:1,225:0,229:1,230:1,231:1,232:1,233:1,234:1,235:3,244:1,247:4,252:2,257:1,261:1,271:1,273:4,274:2,275:2,276:2,277:3,278:3,279:1,280:3,281:3,282:3,283:1,284:1,285:2,286:4,287:3,288:2,289:4,290:3,291:3,292:3,293:4,294:1,295:3,296:1,297:3,298:1,299:2,300:3,301:3,302:4,303:2,304:2,305:2,306:2,307:2,308:2,309:3,310:2,311:2,312:2,313:2,314:2,315:2,316:4,325:2,326:2,327:2,328:2,331:2,332:2,337:2,342:1,343:1,346:2,347:1,350:4,351:3,352:1,353:2,360:1,368:1,369:1,370:1,371:1,372:1,373:1,374:1,375:1,376:1,377:1,378:1,382:3,385:1,392:1,393:1,396:2,397:2,398:2,399:1,400:1,401:1,402:1,403:1,404:1,405:1,406:1,407:1,408:1,409:1,410:1,414:4,415:1,416:1,417:2,420:1,421:1,422:2,424:1,425:2,426:2,427:2,428:2,430:3,438:3,439:3,440:3,443:2,444:2,445:2,446:2,447:6,448:6,449:2,450:2,464:2,468:3,476:2,479:1,480:2,65535:0};function ods_to_csf_formula(f){if(f.slice(0,3)=="of:")f=f.slice(3);if(f.charCodeAt(0)==61){f=f.slice(1);if(f.charCodeAt(0)==61)f=f.slice(1);}f=f.replace(/COM\.MICROSOFT\./g,"");f=f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function($$,$1){return $1.replace(/\./g,"");});f=f.replace(/\[.(#[A-Z]*[?!])\]/g,"$1");return f.replace(/[;~]/g,",").replace(/\|/g,";");}function csf_to_ods_formula(f){var o="of:="+f.replace(crefregex,"$1[.$2$3$4$5]").replace(/\]:\[/g,":");return o.replace(/;/g,"|").replace(/,/g,";");}function ods_to_csf_3D(r){var a=r.split(":");var s=a[0].split(".")[0];return[s,a[0].split(".")[1]+(a.length>1?":"+(a[1].split(".")[1]||a[1].split(".")[0]):"")];}function csf_to_ods_3D(r){return r.replace(/\./,"!");}var strs={};var _ssfopts={};var browser_has_Map=typeof _map2.default!=='undefined';function get_sst_id(sst,str,rev){var i=0,len=sst.length;if(rev){if(browser_has_Map?rev.has(str):Object.prototype.hasOwnProperty.call(rev,str)){var revarr=browser_has_Map?rev.get(str):rev[str];for(;i<revarr.length;++i){if(sst[revarr[i]].t===str){sst.Count++;return revarr[i];}}}}else for(;i<len;++i){if(sst[i].t===str){sst.Count++;return i;}}sst[len]={t:str};sst.Count++;sst.Unique++;if(rev){if(browser_has_Map){if(!rev.has(str))rev.set(str,[]);rev.get(str).push(len);}else{if(!Object.prototype.hasOwnProperty.call(rev,str))rev[str]=[];rev[str].push(len);}}return len;}function col_obj_w(C,col){var p={min:C+1,max:C+1};var wch=-1;if(col.MDW)MDW=col.MDW;if(col.width!=null)p.customWidth=1;else if(col.wpx!=null)wch=px2char(col.wpx);else if(col.wch!=null)wch=col.wch;if(wch>-1){p.width=char2width(wch);p.customWidth=1;}else if(col.width!=null)p.width=col.width;if(col.hidden)p.hidden=true;if(col.level!=null){p.outlineLevel=p.level=col.level;}return p;}function default_margins(margins,mode){if(!margins)return;var defs=[0.7,0.7,0.75,0.75,0.3,0.3];if(mode=='xlml')defs=[1,1,1,1,0.5,0.5];if(margins.left==null)margins.left=defs[0];if(margins.right==null)margins.right=defs[1];if(margins.top==null)margins.top=defs[2];if(margins.bottom==null)margins.bottom=defs[3];if(margins.header==null)margins.header=defs[4];if(margins.footer==null)margins.footer=defs[5];}function get_cell_style(styles,cell,opts){var z=opts.revssf[cell.z!=null?cell.z:"General"];var i=0x3c,len=styles.length;if(z==null&&opts.ssf){for(;i<0x188;++i){if(opts.ssf[i]==null){SSF_load(cell.z,i);opts.ssf[i]=cell.z;opts.revssf[cell.z]=z=i;break;}}}for(i=0;i!=len;++i){if(styles[i].numFmtId===z)return i;}styles[len]={numFmtId:z,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return len;}function safe_format(p,fmtid,fillid,opts,themes,styles){try{if(opts.cellNF)p.z=table_fmt[fmtid];}catch(e){if(opts.WTF)throw e;}if(p.t==='z'&&!opts.cellStyles)return;if(p.t==='d'&&typeof p.v==='string')p.v=parseDate(p.v);if((!opts||opts.cellText!==false)&&p.t!=='z')try{if(table_fmt[fmtid]==null)SSF_load(SSFImplicit[fmtid]||"General",fmtid);if(p.t==='e')p.w=p.w||BErr[p.v];else if(fmtid===0){if(p.t==='n'){if((p.v|0)===p.v)p.w=p.v.toString(10);else p.w=SSF_general_num(p.v);}else if(p.t==='d'){var dd=datenum(p.v);if((dd|0)===dd)p.w=dd.toString(10);else p.w=SSF_general_num(dd);}else if(p.v===undefined)return"";else p.w=SSF_general(p.v,_ssfopts);}else if(p.t==='d')p.w=SSF_format(fmtid,datenum(p.v),_ssfopts);else p.w=SSF_format(fmtid,p.v,_ssfopts);}catch(e){if(opts.WTF)throw e;}if(!opts.cellStyles)return;if(fillid!=null)try{p.s=styles.Fills[fillid];if(p.s.fgColor&&p.s.fgColor.theme&&!p.s.fgColor.rgb){p.s.fgColor.rgb=rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb,p.s.fgColor.tint||0);if(opts.WTF)p.s.fgColor.raw_rgb=themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;}if(p.s.bgColor&&p.s.bgColor.theme){p.s.bgColor.rgb=rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb,p.s.bgColor.tint||0);if(opts.WTF)p.s.bgColor.raw_rgb=themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;}}catch(e){if(opts.WTF&&styles.Fills)throw e;}}function check_ws(ws,sname,i){if(ws&&ws['!ref']){var range=safe_decode_range(ws['!ref']);if(range.e.c<range.s.c||range.e.r<range.s.r)throw new Error("Bad range ("+i+"): "+ws['!ref']);}}function parse_ws_xml_dim(ws,s){var d=safe_decode_range(s);if(d.s.r<=d.e.r&&d.s.c<=d.e.c&&d.s.r>=0&&d.s.c>=0)ws["!ref"]=encode_range(d);}var mergecregex=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;var sheetdataregex=/<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;var hlinkregex=/<(?:\w:)?hyperlink [^>]*>/mg;var dimregex=/"(\w*:\w*)"/;var colregex=/<(?:\w:)?col\b[^>]*[\/]?>/g;var afregex=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;var marginregex=/<(?:\w:)?pageMargins[^>]*\/>/g;var sheetprregex=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;var sheetprregex2=/<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;var svsregex=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;function parse_ws_xml(data,opts,idx,rels,wb,themes,styles){if(!data)return data;if(!rels)rels={'!id':{}};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var s=opts.dense?[]:{};var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var data1="",data2="";var mtch=data.match(sheetdataregex);if(mtch){data1=data.slice(0,mtch.index);data2=data.slice(mtch.index+mtch[0].length);}else data1=data2=data;var sheetPr=data1.match(sheetprregex);if(sheetPr)parse_ws_xml_sheetpr(sheetPr[0],s,wb,idx);else if(sheetPr=data1.match(sheetprregex2))parse_ws_xml_sheetpr2(sheetPr[0],sheetPr[1]||"",s,wb,idx,styles,themes);var ridx=(data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;if(ridx>0){var ref=data1.slice(ridx,ridx+50).match(dimregex);if(ref)parse_ws_xml_dim(s,ref[1]);}var svs=data1.match(svsregex);if(svs&&svs[1])parse_ws_xml_sheetviews(svs[1],wb);var columns=[];if(opts.cellStyles){var cols=data1.match(colregex);if(cols)parse_ws_xml_cols(columns,cols);}if(mtch)parse_ws_xml_data(mtch[1],s,opts,refguess,themes,styles);var afilter=data2.match(afregex);if(afilter)s['!autofilter']=parse_ws_xml_autofilter(afilter[0]);var merges=[];var _merge=data2.match(mergecregex);if(_merge)for(ridx=0;ridx!=_merge.length;++ridx){merges[ridx]=safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));}var hlink=data2.match(hlinkregex);if(hlink)parse_ws_xml_hlinks(s,hlink,rels);var margins=data2.match(marginregex);if(margins)s['!margins']=parse_ws_xml_margins(parsexmltag(margins[0]));if(!s["!ref"]&&refguess.e.c>=refguess.s.c&&refguess.e.r>=refguess.s.r)s["!ref"]=encode_range(refguess);if(opts.sheetRows>0&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<=+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref);}}if(columns.length>0)s["!cols"]=columns;if(merges.length>0)s["!merges"]=merges;return s;}function write_ws_xml_merges(merges){if(merges.length===0)return"";var o='<mergeCells count="'+merges.length+'">';for(var i=0;i!=merges.length;++i){o+='<mergeCell ref="'+encode_range(merges[i])+'"/>';}return o+'</mergeCells>';}function parse_ws_xml_sheetpr(sheetPr,s,wb,idx){var data=parsexmltag(sheetPr);if(!wb.Sheets[idx])wb.Sheets[idx]={};if(data.codeName)wb.Sheets[idx].CodeName=unescapexml(utf8read(data.codeName));}function parse_ws_xml_sheetpr2(sheetPr,body,s,wb,idx){parse_ws_xml_sheetpr(sheetPr.slice(0,sheetPr.indexOf(">")),s,wb,idx);}function write_ws_xml_sheetpr(ws,wb,idx,opts,o){var needed=false;var props={},payload=null;if(opts.bookType!=='xlsx'&&wb.vbaraw){var cname=wb.SheetNames[idx];try{if(wb.Workbook)cname=wb.Workbook.Sheets[idx].CodeName||cname;}catch(e){}needed=true;props.codeName=utf8write(escapexml(cname));}if(ws&&ws["!outline"]){var outlineprops={summaryBelow:1,summaryRight:1};if(ws["!outline"].above)outlineprops.summaryBelow=0;if(ws["!outline"].left)outlineprops.summaryRight=0;payload=(payload||"")+writextag('outlinePr',null,outlineprops);}if(!needed&&!payload)return;o[o.length]=writextag('sheetPr',payload,props);}var sheetprot_deffalse=["objects","scenarios","selectLockedCells","selectUnlockedCells"];var sheetprot_deftrue=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];function write_ws_xml_protection(sp){var o={sheet:1};sheetprot_deffalse.forEach(function(n){if(sp[n]!=null&&sp[n])o[n]="1";});sheetprot_deftrue.forEach(function(n){if(sp[n]!=null&&!sp[n])o[n]="0";});if(sp.password)o.password=crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();return writextag('sheetProtection',null,o);}function parse_ws_xml_hlinks(s,data,rels){var dense=Array.isArray(s);for(var i=0;i!=data.length;++i){var val=parsexmltag(utf8read(data[i]),true);if(!val.ref)return;var rel=((rels||{})['!id']||[])[val.id];if(rel){val.Target=rel.Target;if(val.location)val.Target+="#"+unescapexml(val.location);}else{val.Target="#"+unescapexml(val.location);rel={Target:val.Target,TargetMode:'Internal'};}val.Rel=rel;if(val.tooltip){val.Tooltip=val.tooltip;delete val.tooltip;}var rng=safe_decode_range(val.ref);for(var R=rng.s.r;R<=rng.e.r;++R){for(var C=rng.s.c;C<=rng.e.c;++C){var addr=encode_cell({c:C,r:R});if(dense){if(!s[R])s[R]=[];if(!s[R][C])s[R][C]={t:"z",v:undefined};s[R][C].l=val;}else{if(!s[addr])s[addr]={t:"z",v:undefined};s[addr].l=val;}}}}}function parse_ws_xml_margins(margin){var o={};["left","right","top","bottom","header","footer"].forEach(function(k){if(margin[k])o[k]=parseFloat(margin[k]);});return o;}function write_ws_xml_margins(margin){default_margins(margin);return writextag('pageMargins',null,margin);}function parse_ws_xml_cols(columns,cols){var seencol=false;for(var coli=0;coli!=cols.length;++coli){var coll=parsexmltag(cols[coli],true);if(coll.hidden)coll.hidden=parsexmlbool(coll.hidden);var colm=parseInt(coll.min,10)-1,colM=parseInt(coll.max,10)-1;if(coll.outlineLevel)coll.level=+coll.outlineLevel||0;delete coll.min;delete coll.max;coll.width=+coll.width;if(!seencol&&coll.width){seencol=true;find_mdw_colw(coll.width);}process_col(coll);while(colm<=colM){columns[colm++]=dup(coll);}}}function write_ws_xml_cols(ws,cols){var o=["<cols>"],col;for(var i=0;i!=cols.length;++i){if(!(col=cols[i]))continue;o[o.length]=writextag('col',null,col_obj_w(i,col));}o[o.length]="</cols>";return o.join("");}function parse_ws_xml_autofilter(data){var o={ref:(data.match(/ref="([^"]*)"/)||[])[1]};return o;}function write_ws_xml_autofilter(data,ws,wb,idx){var ref=typeof data.ref=="string"?data.ref:encode_range(data.ref);if(!wb.Workbook)wb.Workbook={Sheets:[]};if(!wb.Workbook.Names)wb.Workbook.Names=[];var names=wb.Workbook.Names;var range=decode_range(ref);if(range.s.r==range.e.r){range.e.r=decode_range(ws["!ref"]).e.r;ref=encode_range(range);}for(var i=0;i<names.length;++i){var name=names[i];if(name.Name!='_xlnm._FilterDatabase')continue;if(name.Sheet!=idx)continue;name.Ref="'"+wb.SheetNames[idx]+"'!"+ref;break;}if(i==names.length)names.push({Name:'_xlnm._FilterDatabase',Sheet:idx,Ref:"'"+wb.SheetNames[idx]+"'!"+ref});return writextag("autoFilter",null,{ref:ref});}var sviewregex=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;function parse_ws_xml_sheetviews(data,wb){if(!wb.Views)wb.Views=[{}];(data.match(sviewregex)||[]).forEach(function(r,i){var tag=parsexmltag(r);if(!wb.Views[i])wb.Views[i]={};if(+tag.zoomScale)wb.Views[i].zoom=+tag.zoomScale;if(parsexmlbool(tag.rightToLeft))wb.Views[i].RTL=true;});}function write_ws_xml_sheetviews(ws,opts,idx,wb){var sview={workbookViewId:"0"};if((((wb||{}).Workbook||{}).Views||[])[0])sview.rightToLeft=wb.Workbook.Views[0].RTL?"1":"0";return writextag("sheetViews",writextag("sheetView",null,sview),{});}function write_ws_xml_cell(cell,ref,ws,opts){if(cell.c)ws['!comments'].push([ref,cell.c]);if(cell.v===undefined&&typeof cell.f!=="string"||cell.t==='z'&&!cell.f)return"";var vv="";var oldt=cell.t,oldv=cell.v;if(cell.t!=="z")switch(cell.t){case'b':vv=cell.v?"1":"0";break;case'n':vv=''+cell.v;break;case'e':vv=BErr[cell.v];break;case'd':if(opts&&opts.cellDates)vv=parseDate(cell.v,-1).toISOString();else{cell=dup(cell);cell.t='n';vv=''+(cell.v=datenum(parseDate(cell.v)));}if(typeof cell.z==='undefined')cell.z=table_fmt[14];break;default:vv=cell.v;break;}var v=writetag('v',escapexml(vv)),o={r:ref};var os=get_cell_style(opts.cellXfs,cell,opts);if(os!==0)o.s=os;switch(cell.t){case'n':break;case'd':o.t="d";break;case'b':o.t="b";break;case'e':o.t="e";break;case'z':break;default:if(cell.v==null){delete cell.t;break;}if(cell.v.length>32767)throw new Error("Text length must not exceed 32767 characters");if(opts&&opts.bookSST){v=writetag('v',''+get_sst_id(opts.Strings,cell.v,opts.revStrings));o.t="s";break;}o.t="str";break;}if(cell.t!=oldt){cell.t=oldt;cell.v=oldv;}if(typeof cell.f=="string"&&cell.f){var ff=cell.F&&cell.F.slice(0,ref.length)==ref?{t:"array",ref:cell.F}:null;v=writextag('f',escapexml(cell.f),ff)+(cell.v!=null?v:"");}if(cell.l)ws['!links'].push([ref,cell.l]);if(cell.D)o.cm=1;return writextag('c',v,o);}var parse_ws_xml_data=function(){var cellregex=/<(?:\w+:)?c[ \/>]/,rowregex=/<\/(?:\w+:)?row>/;var rregex=/r=["']([^"']*)["']/,isregex=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;var refregex=/ref=["']([^"']*)["']/;var match_v=matchtag("v"),match_f=matchtag("f");return function parse_ws_xml_data(sdata,s,opts,guess,themes,styles){var ri=0,x="",cells=[],cref=[],idx=0,i=0,cc=0,d="",p;var tag,tagr=0,tagc=0;var sstr,ftag;var fmtid=0,fillid=0;var do_format=Array.isArray(styles.CellXf),cf;var arrayf=[];var sharedf=[];var dense=Array.isArray(s);var rows=[],rowobj={},rowrite=false;var sheetStubs=!!opts.sheetStubs;for(var marr=sdata.split(rowregex),mt=0,marrlen=marr.length;mt!=marrlen;++mt){x=marr[mt].trim();var xlen=x.length;if(xlen===0)continue;var rstarti=0;outa:for(ri=0;ri<xlen;++ri){switch(x[ri]){case">":if(x[ri-1]!="/"){++ri;break outa;}if(opts&&opts.cellStyles){tag=parsexmltag(x.slice(rstarti,ri),true);tagr=tag.r!=null?parseInt(tag.r,10):tagr+1;tagc=-1;if(opts.sheetRows&&opts.sheetRows<tagr)continue;rowobj={};rowrite=false;if(tag.ht){rowrite=true;rowobj.hpt=parseFloat(tag.ht);rowobj.hpx=pt2px(rowobj.hpt);}if(tag.hidden=="1"){rowrite=true;rowobj.hidden=true;}if(tag.outlineLevel!=null){rowrite=true;rowobj.level=+tag.outlineLevel;}if(rowrite)rows[tagr-1]=rowobj;}break;case"<":rstarti=ri;break;}}if(rstarti>=ri)break;tag=parsexmltag(x.slice(rstarti,ri),true);tagr=tag.r!=null?parseInt(tag.r,10):tagr+1;tagc=-1;if(opts.sheetRows&&opts.sheetRows<tagr)continue;if(guess.s.r>tagr-1)guess.s.r=tagr-1;if(guess.e.r<tagr-1)guess.e.r=tagr-1;if(opts&&opts.cellStyles){rowobj={};rowrite=false;if(tag.ht){rowrite=true;rowobj.hpt=parseFloat(tag.ht);rowobj.hpx=pt2px(rowobj.hpt);}if(tag.hidden=="1"){rowrite=true;rowobj.hidden=true;}if(tag.outlineLevel!=null){rowrite=true;rowobj.level=+tag.outlineLevel;}if(rowrite)rows[tagr-1]=rowobj;}cells=x.slice(ri).split(cellregex);for(var rslice=0;rslice!=cells.length;++rslice){if(cells[rslice].trim().charAt(0)!="<")break;}cells=cells.slice(rslice);for(ri=0;ri!=cells.length;++ri){x=cells[ri].trim();if(x.length===0)continue;cref=x.match(rregex);idx=ri;i=0;cc=0;x="<c "+(x.slice(0,1)=="<"?">":"")+x;if(cref!=null&&cref.length===2){idx=0;d=cref[1];for(i=0;i!=d.length;++i){if((cc=d.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}--idx;tagc=idx;}else++tagc;for(i=0;i!=x.length;++i){if(x.charCodeAt(i)===62)break;}++i;tag=parsexmltag(x.slice(0,i),true);if(!tag.r)tag.r=encode_cell({r:tagr-1,c:tagc});d=x.slice(i);p={t:""};if((cref=d.match(match_v))!=null&&cref[1]!=='')p.v=unescapexml(cref[1]);if(opts.cellFormula){if((cref=d.match(match_f))!=null&&cref[1]!==''){p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g,"\n");if(!opts.xlfn)p.f=_xlfn(p.f);if(cref[0].indexOf('t="array"')>-1){p.F=(d.match(refregex)||[])[1];if(p.F.indexOf(":")>-1)arrayf.push([safe_decode_range(p.F),p.F]);}else if(cref[0].indexOf('t="shared"')>-1){ftag=parsexmltag(cref[0]);var ___f=unescapexml(utf8read(cref[1]));if(!opts.xlfn)___f=_xlfn(___f);sharedf[parseInt(ftag.si,10)]=[ftag,___f,tag.r];}}else if(cref=d.match(/<f[^>]*\/>/)){ftag=parsexmltag(cref[0]);if(sharedf[ftag.si])p.f=shift_formula_xlsx(sharedf[ftag.si][1],sharedf[ftag.si][2],tag.r);}var _tag=decode_cell(tag.r);for(i=0;i<arrayf.length;++i){if(_tag.r>=arrayf[i][0].s.r&&_tag.r<=arrayf[i][0].e.r)if(_tag.c>=arrayf[i][0].s.c&&_tag.c<=arrayf[i][0].e.c)p.F=arrayf[i][1];}}if(tag.t==null&&p.v===undefined){if(p.f||p.F){p.v=0;p.t="n";}else if(!sheetStubs)continue;else p.t="z";}else p.t=tag.t||"n";if(guess.s.c>tagc)guess.s.c=tagc;if(guess.e.c<tagc)guess.e.c=tagc;switch(p.t){case'n':if(p.v==""||p.v==null){if(!sheetStubs)continue;p.t='z';}else p.v=parseFloat(p.v);break;case's':if(typeof p.v=='undefined'){if(!sheetStubs)continue;p.t='z';}else{sstr=strs[parseInt(p.v,10)];p.v=sstr.t;p.r=sstr.r;if(opts.cellHTML)p.h=sstr.h;}break;case'str':p.t="s";p.v=p.v!=null?utf8read(p.v):'';if(opts.cellHTML)p.h=escapehtml(p.v);break;case'inlineStr':cref=d.match(isregex);p.t='s';if(cref!=null&&(sstr=parse_si(cref[1]))){p.v=sstr.t;if(opts.cellHTML)p.h=sstr.h;}else p.v="";break;case'b':p.v=parsexmlbool(p.v);break;case'd':if(opts.cellDates)p.v=parseDate(p.v,1);else{p.v=datenum(parseDate(p.v,1));p.t='n';}break;case'e':if(!opts||opts.cellText!==false)p.w=p.v;p.v=RBErr[p.v];break;}fmtid=fillid=0;cf=null;if(do_format&&tag.s!==undefined){cf=styles.CellXf[tag.s];if(cf!=null){if(cf.numFmtId!=null)fmtid=cf.numFmtId;if(opts.cellStyles){if(cf.fillId!=null)fillid=cf.fillId;}}}safe_format(p,fmtid,fillid,opts,themes,styles);if(opts.cellDates&&do_format&&p.t=='n'&&fmt_is_date(table_fmt[fmtid])){p.t='d';p.v=numdate(p.v);}if(tag.cm&&opts.xlmeta){var cm=(opts.xlmeta.Cell||[])[+tag.cm-1];if(cm&&cm.type=='XLDAPR')p.D=true;}if(dense){var _r=decode_cell(tag.r);if(!s[_r.r])s[_r.r]=[];s[_r.r][_r.c]=p;}else s[tag.r]=p;}}if(rows.length>0)s['!rows']=rows;};}();function write_ws_xml_data(ws,opts,idx,wb){var o=[],r=[],range=safe_decode_range(ws['!ref']),cell="",ref,rr="",cols=[],R=0,C=0,rows=ws['!rows'];var dense=Array.isArray(ws);var params={r:rr},row,height=-1;for(C=range.s.c;C<=range.e.c;++C){cols[C]=encode_col(C);}for(R=range.s.r;R<=range.e.r;++R){r=[];rr=encode_row(R);for(C=range.s.c;C<=range.e.c;++C){ref=cols[C]+rr;var _cell=dense?(ws[R]||[])[C]:ws[ref];if(_cell===undefined)continue;if((cell=write_ws_xml_cell(_cell,ref,ws,opts,idx,wb))!=null)r.push(cell);}if(r.length>0||rows&&rows[R]){params={r:rr};if(rows&&rows[R]){row=rows[R];if(row.hidden)params.hidden=1;height=-1;if(row.hpx)height=px2pt(row.hpx);else if(row.hpt)height=row.hpt;if(height>-1){params.ht=height;params.customHeight=1;}if(row.level){params.outlineLevel=row.level;}}o[o.length]=writextag('row',r.join(""),params);}}if(rows)for(;R<rows.length;++R){if(rows&&rows[R]){params={r:R+1};row=rows[R];if(row.hidden)params.hidden=1;height=-1;if(row.hpx)height=px2pt(row.hpx);else if(row.hpt)height=row.hpt;if(height>-1){params.ht=height;params.customHeight=1;}if(row.level){params.outlineLevel=row.level;}o[o.length]=writextag('row',"",params);}}return o.join("");}function write_ws_xml(idx,opts,wb,rels){var o=[XML_HEADER,writextag('worksheet',null,{'xmlns':XMLNS_main[0],'xmlns:r':XMLNS.r})];var s=wb.SheetNames[idx],sidx=0,rdata="";var ws=wb.Sheets[s];if(ws==null)ws={};var ref=ws['!ref']||'A1';var range=safe_decode_range(ref);if(range.e.c>0x3FFF||range.e.r>0xFFFFF){if(opts.WTF)throw new Error("Range "+ref+" exceeds format limit A1:XFD1048576");range.e.c=Math.min(range.e.c,0x3FFF);range.e.r=Math.min(range.e.c,0xFFFFF);ref=encode_range(range);}if(!rels)rels={};ws['!comments']=[];var _drawing=[];write_ws_xml_sheetpr(ws,wb,idx,opts,o);o[o.length]=writextag('dimension',null,{'ref':ref});o[o.length]=write_ws_xml_sheetviews(ws,opts,idx,wb);if(opts.sheetFormat)o[o.length]=writextag('sheetFormatPr',null,{defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',baseColWidth:opts.sheetFormat.baseColWidth||'10',outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'});if(ws['!cols']!=null&&ws['!cols'].length>0)o[o.length]=write_ws_xml_cols(ws,ws['!cols']);o[sidx=o.length]='<sheetData/>';ws['!links']=[];if(ws['!ref']!=null){rdata=write_ws_xml_data(ws,opts,idx,wb,rels);if(rdata.length>0)o[o.length]=rdata;}if(o.length>sidx+1){o[o.length]='</sheetData>';o[sidx]=o[sidx].replace("/>",">");}if(ws['!protect'])o[o.length]=write_ws_xml_protection(ws['!protect']);if(ws['!autofilter']!=null)o[o.length]=write_ws_xml_autofilter(ws['!autofilter'],ws,wb,idx);if(ws['!merges']!=null&&ws['!merges'].length>0)o[o.length]=write_ws_xml_merges(ws['!merges']);var relc=-1,rel,rId=-1;if(ws['!links'].length>0){o[o.length]="<hyperlinks>";ws['!links'].forEach(function(l){if(!l[1].Target)return;rel={"ref":l[0]};if(l[1].Target.charAt(0)!="#"){rId=add_rels(rels,-1,escapexml(l[1].Target).replace(/#.*$/,""),RELS.HLINK);rel["r:id"]="rId"+rId;}if((relc=l[1].Target.indexOf("#"))>-1)rel.location=escapexml(l[1].Target.slice(relc+1));if(l[1].Tooltip)rel.tooltip=escapexml(l[1].Tooltip);o[o.length]=writextag("hyperlink",null,rel);});o[o.length]="</hyperlinks>";}delete ws['!links'];if(ws['!margins']!=null)o[o.length]=write_ws_xml_margins(ws['!margins']);if(!opts||opts.ignoreEC||opts.ignoreEC==void 0)o[o.length]=writetag("ignoredErrors",writextag("ignoredError",null,{numberStoredAsText:1,sqref:ref}));if(_drawing.length>0){rId=add_rels(rels,-1,"../drawings/drawing"+(idx+1)+".xml",RELS.DRAW);o[o.length]=writextag("drawing",null,{"r:id":"rId"+rId});ws['!drawing']=_drawing;}if(ws['!comments'].length>0){rId=add_rels(rels,-1,"../drawings/vmlDrawing"+(idx+1)+".vml",RELS.VML);o[o.length]=writextag("legacyDrawing",null,{"r:id":"rId"+rId});ws['!legacy']=rId;}if(o.length>1){o[o.length]='</worksheet>';o[1]=o[1].replace("/>",">");}return o.join("");}function parse_BrtRowHdr(data,length){var z={};var tgt=data.l+length;z.r=data.read_shift(4);data.l+=4;var miyRw=data.read_shift(2);data.l+=1;var flags=data.read_shift(1);data.l=tgt;if(flags&0x07)z.level=flags&0x07;if(flags&0x10)z.hidden=true;if(flags&0x20)z.hpt=miyRw/20;return z;}function write_BrtRowHdr(R,range,ws){var o=new_buf(17+8*16);var row=(ws['!rows']||[])[R]||{};o.write_shift(4,R);o.write_shift(4,0);var miyRw=0x0140;if(row.hpx)miyRw=px2pt(row.hpx)*20;else if(row.hpt)miyRw=row.hpt*20;o.write_shift(2,miyRw);o.write_shift(1,0);var flags=0x0;if(row.level)flags|=row.level;if(row.hidden)flags|=0x10;if(row.hpx||row.hpt)flags|=0x20;o.write_shift(1,flags);o.write_shift(1,0);var ncolspan=0,lcs=o.l;o.l+=4;var caddr={r:R,c:0};for(var i=0;i<16;++i){if(range.s.c>i+1<<10||range.e.c<i<<10)continue;var first=-1,last=-1;for(var j=i<<10;j<i+1<<10;++j){caddr.c=j;var cell=Array.isArray(ws)?(ws[caddr.r]||[])[caddr.c]:ws[encode_cell(caddr)];if(cell){if(first<0)first=j;last=j;}}if(first<0)continue;++ncolspan;o.write_shift(4,first);o.write_shift(4,last);}var l=o.l;o.l=lcs;o.write_shift(4,ncolspan);o.l=l;return o.length>o.l?o.slice(0,o.l):o;}function write_row_header(ba,ws,range,R){var o=write_BrtRowHdr(R,range,ws);if(o.length>17||(ws['!rows']||[])[R])write_record(ba,0x0000,o);}var parse_BrtWsDim=parse_UncheckedRfX;var write_BrtWsDim=write_UncheckedRfX;function parse_BrtWsFmtInfo(){}function parse_BrtWsProp(data,length){var z={};var f=data[data.l];++data.l;z.above=!(f&0x40);z.left=!(f&0x80);data.l+=18;z.name=parse_XLSBCodeName(data,length-19);return z;}function write_BrtWsProp(str,outl,o){if(o==null)o=new_buf(84+4*str.length);var f=0xC0;if(outl){if(outl.above)f&=~0x40;if(outl.left)f&=~0x80;}o.write_shift(1,f);for(var i=1;i<3;++i){o.write_shift(1,0);}write_BrtColor({auto:1},o);o.write_shift(-4,-1);o.write_shift(-4,-1);write_XLSBCodeName(str,o);return o.slice(0,o.l);}function parse_BrtCellBlank(data){var cell=parse_XLSBCell(data);return[cell];}function write_BrtCellBlank(cell,ncell,o){if(o==null)o=new_buf(8);return write_XLSBCell(ncell,o);}function parse_BrtShortBlank(data){var cell=parse_XLSBShortCell(data);return[cell];}function write_BrtShortBlank(cell,ncell,o){if(o==null)o=new_buf(4);return write_XLSBShortCell(ncell,o);}function parse_BrtCellBool(data){var cell=parse_XLSBCell(data);var fBool=data.read_shift(1);return[cell,fBool,'b'];}function write_BrtCellBool(cell,ncell,o){if(o==null)o=new_buf(9);write_XLSBCell(ncell,o);o.write_shift(1,cell.v?1:0);return o;}function parse_BrtShortBool(data){var cell=parse_XLSBShortCell(data);var fBool=data.read_shift(1);return[cell,fBool,'b'];}function write_BrtShortBool(cell,ncell,o){if(o==null)o=new_buf(5);write_XLSBShortCell(ncell,o);o.write_shift(1,cell.v?1:0);return o;}function parse_BrtCellError(data){var cell=parse_XLSBCell(data);var bError=data.read_shift(1);return[cell,bError,'e'];}function write_BrtCellError(cell,ncell,o){if(o==null)o=new_buf(9);write_XLSBCell(ncell,o);o.write_shift(1,cell.v);return o;}function parse_BrtShortError(data){var cell=parse_XLSBShortCell(data);var bError=data.read_shift(1);return[cell,bError,'e'];}function write_BrtShortError(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);o.write_shift(1,cell.v);o.write_shift(2,0);o.write_shift(1,0);return o;}function parse_BrtCellIsst(data){var cell=parse_XLSBCell(data);var isst=data.read_shift(4);return[cell,isst,'s'];}function write_BrtCellIsst(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBCell(ncell,o);o.write_shift(4,ncell.v);return o;}function parse_BrtShortIsst(data){var cell=parse_XLSBShortCell(data);var isst=data.read_shift(4);return[cell,isst,'s'];}function write_BrtShortIsst(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);o.write_shift(4,ncell.v);return o;}function parse_BrtCellReal(data){var cell=parse_XLSBCell(data);var value=parse_Xnum(data);return[cell,value,'n'];}function write_BrtCellReal(cell,ncell,o){if(o==null)o=new_buf(16);write_XLSBCell(ncell,o);write_Xnum(cell.v,o);return o;}function parse_BrtShortReal(data){var cell=parse_XLSBShortCell(data);var value=parse_Xnum(data);return[cell,value,'n'];}function write_BrtShortReal(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBShortCell(ncell,o);write_Xnum(cell.v,o);return o;}function parse_BrtCellRk(data){var cell=parse_XLSBCell(data);var value=parse_RkNumber(data);return[cell,value,'n'];}function write_BrtCellRk(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBCell(ncell,o);write_RkNumber(cell.v,o);return o;}function parse_BrtShortRk(data){var cell=parse_XLSBShortCell(data);var value=parse_RkNumber(data);return[cell,value,'n'];}function write_BrtShortRk(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);write_RkNumber(cell.v,o);return o;}function parse_BrtCellRString(data){var cell=parse_XLSBCell(data);var value=parse_RichStr(data);return[cell,value,'is'];}function parse_BrtCellSt(data){var cell=parse_XLSBCell(data);var value=parse_XLWideString(data);return[cell,value,'str'];}function write_BrtCellSt(cell,ncell,o){if(o==null)o=new_buf(12+4*cell.v.length);write_XLSBCell(ncell,o);write_XLWideString(cell.v,o);return o.length>o.l?o.slice(0,o.l):o;}function parse_BrtShortSt(data){var cell=parse_XLSBShortCell(data);var value=parse_XLWideString(data);return[cell,value,'str'];}function write_BrtShortSt(cell,ncell,o){if(o==null)o=new_buf(8+4*cell.v.length);write_XLSBShortCell(ncell,o);write_XLWideString(cell.v,o);return o.length>o.l?o.slice(0,o.l):o;}function parse_BrtFmlaBool(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=data.read_shift(1);var o=[cell,value,'b'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null,cell,opts.supbooks,opts);}else data.l=end;return o;}function parse_BrtFmlaError(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=data.read_shift(1);var o=[cell,value,'e'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null,cell,opts.supbooks,opts);}else data.l=end;return o;}function parse_BrtFmlaNum(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=parse_Xnum(data);var o=[cell,value,'n'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null,cell,opts.supbooks,opts);}else data.l=end;return o;}function parse_BrtFmlaString(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=parse_XLWideString(data);var o=[cell,value,'str'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null,cell,opts.supbooks,opts);}else data.l=end;return o;}var parse_BrtMergeCell=parse_UncheckedRfX;var write_BrtMergeCell=write_UncheckedRfX;function write_BrtBeginMergeCells(cnt,o){if(o==null)o=new_buf(4);o.write_shift(4,cnt);return o;}function parse_BrtHLink(data,length){var end=data.l+length;var rfx=parse_UncheckedRfX(data,16);var relId=parse_XLNullableWideString(data);var loc=parse_XLWideString(data);var tooltip=parse_XLWideString(data);var display=parse_XLWideString(data);data.l=end;var o={rfx:rfx,relId:relId,loc:loc,display:display};if(tooltip)o.Tooltip=tooltip;return o;}function write_BrtHLink(l,rId){var o=new_buf(50+4*(l[1].Target.length+(l[1].Tooltip||"").length));write_UncheckedRfX({s:decode_cell(l[0]),e:decode_cell(l[0])},o);write_RelID("rId"+rId,o);var locidx=l[1].Target.indexOf("#");var loc=locidx==-1?"":l[1].Target.slice(locidx+1);write_XLWideString(loc||"",o);write_XLWideString(l[1].Tooltip||"",o);write_XLWideString("",o);return o.slice(0,o.l);}function parse_BrtPane(){}function parse_BrtArrFmla(data,length,opts){var end=data.l+length;var rfx=parse_RfX(data,16);var fAlwaysCalc=data.read_shift(1);var o=[rfx];o[2]=fAlwaysCalc;if(opts.cellFormula){var formula=parse_XLSBArrayParsedFormula(data,end-data.l,opts);o[1]=formula;}else data.l=end;return o;}function parse_BrtShrFmla(data,length,opts){var end=data.l+length;var rfx=parse_UncheckedRfX(data,16);var o=[rfx];if(opts.cellFormula){var formula=parse_XLSBSharedParsedFormula(data,end-data.l,opts);o[1]=formula;data.l=end;}else data.l=end;return o;}function write_BrtColInfo(C,col,o){if(o==null)o=new_buf(18);var p=col_obj_w(C,col);o.write_shift(-4,C);o.write_shift(-4,C);o.write_shift(4,(p.width||10)*256);o.write_shift(4,0);var flags=0;if(col.hidden)flags|=0x01;if(typeof p.width=='number')flags|=0x02;if(col.level)flags|=col.level<<8;o.write_shift(2,flags);return o;}var BrtMarginKeys=["left","right","top","bottom","header","footer"];function parse_BrtMargins(data){var margins={};BrtMarginKeys.forEach(function(k){margins[k]=parse_Xnum(data,8);});return margins;}function write_BrtMargins(margins,o){if(o==null)o=new_buf(6*8);default_margins(margins);BrtMarginKeys.forEach(function(k){write_Xnum(margins[k],o);});return o;}function parse_BrtBeginWsView(data){var f=data.read_shift(2);data.l+=28;return{RTL:f&0x20};}function write_BrtBeginWsView(ws,Workbook,o){if(o==null)o=new_buf(30);var f=0x39c;if((((Workbook||{}).Views||[])[0]||{}).RTL)f|=0x20;o.write_shift(2,f);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(1,0);o.write_shift(1,0);o.write_shift(2,0);o.write_shift(2,100);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(4,0);return o;}function write_BrtCellIgnoreEC(ref){var o=new_buf(24);o.write_shift(4,4);o.write_shift(4,1);write_UncheckedRfX(ref,o);return o;}function write_BrtSheetProtection(sp,o){if(o==null)o=new_buf(16*4+2);o.write_shift(2,sp.password?crypto_CreatePasswordVerifier_Method1(sp.password):0);o.write_shift(4,1);[["objects",false],["scenarios",false],["formatCells",true],["formatColumns",true],["formatRows",true],["insertColumns",true],["insertRows",true],["insertHyperlinks",true],["deleteColumns",true],["deleteRows",true],["selectLockedCells",false],["sort",true],["autoFilter",true],["pivotTables",true],["selectUnlockedCells",false]].forEach(function(n){if(n[1])o.write_shift(4,sp[n[0]]!=null&&!sp[n[0]]?1:0);else o.write_shift(4,sp[n[0]]!=null&&sp[n[0]]?0:1);});return o;}function parse_BrtDVal(){}function parse_BrtDVal14(){}function parse_ws_bin(data,_opts,idx,rels,wb,themes,styles){if(!data)return data;var opts=_opts||{};if(!rels)rels={'!id':{}};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var s=opts.dense?[]:{};var ref;var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var state=[];var pass=false,end=false;var row,p,cf,R,C,addr,sstr,rr,cell;var merges=[];opts.biff=12;opts['!row']=0;var ai=0,af=false;var arrayf=[];var sharedf={};var supbooks=opts.supbooks||wb.supbooks||[[]];supbooks.sharedf=sharedf;supbooks.arrayf=arrayf;supbooks.SheetNames=wb.SheetNames||wb.Sheets.map(function(x){return x.name;});if(!opts.supbooks){opts.supbooks=supbooks;if(wb.Names)for(var i=0;i<wb.Names.length;++i){supbooks[0][i+1]=wb.Names[i];}}var colinfo=[],rowinfo=[];var seencol=false;XLSBRecordEnum[0x0010]={n:"BrtShortReal",f:parse_BrtShortReal};var cm,vm;recordhopper(data,function ws_parse(val,RR,RT){if(end)return;switch(RT){case 0x0094:ref=val;break;case 0x0000:row=val;if(opts.sheetRows&&opts.sheetRows<=row.r)end=true;rr=encode_row(R=row.r);opts['!row']=row.r;if(val.hidden||val.hpt||val.level!=null){if(val.hpt)val.hpx=pt2px(val.hpt);rowinfo[val.r]=val;}break;case 0x0002:case 0x0003:case 0x0004:case 0x0005:case 0x0006:case 0x0007:case 0x0008:case 0x0009:case 0x000A:case 0x000B:case 0x000D:case 0x000E:case 0x000F:case 0x0010:case 0x0011:case 0x0012:case 0x003E:p={t:val[2]};switch(val[2]){case'n':p.v=val[1];break;case's':sstr=strs[val[1]];p.v=sstr.t;p.r=sstr.r;break;case'b':p.v=val[1]?true:false;break;case'e':p.v=val[1];if(opts.cellText!==false)p.w=BErr[p.v];break;case'str':p.t='s';p.v=val[1];break;case'is':p.t='s';p.v=val[1].t;break;}if(cf=styles.CellXf[val[0].iStyleRef])safe_format(p,cf.numFmtId,null,opts,themes,styles);C=val[0].c==-1?C+1:val[0].c;if(opts.dense){if(!s[R])s[R]=[];s[R][C]=p;}else s[encode_col(C)+rr]=p;if(opts.cellFormula){af=false;for(ai=0;ai<arrayf.length;++ai){var aii=arrayf[ai];if(row.r>=aii[0].s.r&&row.r<=aii[0].e.r)if(C>=aii[0].s.c&&C<=aii[0].e.c){p.F=encode_range(aii[0]);af=true;}}if(!af&&val.length>3)p.f=val[3];}if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;if(opts.cellDates&&cf&&p.t=='n'&&fmt_is_date(table_fmt[cf.numFmtId])){var _d=SSF_parse_date_code(p.v);if(_d){p.t='d';p.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}if(cm){if(cm.type=='XLDAPR')p.D=true;cm=void 0;}if(vm)vm=void 0;break;case 0x0001:case 0x000C:if(!opts.sheetStubs||pass)break;p={t:'z',v:void 0};C=val[0].c==-1?C+1:val[0].c;if(opts.dense){if(!s[R])s[R]=[];s[R][C]=p;}else s[encode_col(C)+rr]=p;if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;if(cm){if(cm.type=='XLDAPR')p.D=true;cm=void 0;}if(vm)vm=void 0;break;case 0x00B0:merges.push(val);break;case 0x0031:{cm=((opts.xlmeta||{}).Cell||[])[val-1];}break;case 0x01EE:var rel=rels['!id'][val.relId];if(rel){val.Target=rel.Target;if(val.loc)val.Target+="#"+val.loc;val.Rel=rel;}else if(val.relId==''){val.Target="#"+val.loc;}for(R=val.rfx.s.r;R<=val.rfx.e.r;++R){for(C=val.rfx.s.c;C<=val.rfx.e.c;++C){if(opts.dense){if(!s[R])s[R]=[];if(!s[R][C])s[R][C]={t:'z',v:undefined};s[R][C].l=val;}else{addr=encode_cell({c:C,r:R});if(!s[addr])s[addr]={t:'z',v:undefined};s[addr].l=val;}}}break;case 0x01AA:if(!opts.cellFormula)break;arrayf.push(val);cell=opts.dense?s[R][C]:s[encode_col(C)+rr];cell.f=stringify_formula(val[1],refguess,{r:row.r,c:C},supbooks,opts);cell.F=encode_range(val[0]);break;case 0x01AB:if(!opts.cellFormula)break;sharedf[encode_cell(val[0].s)]=val[1];cell=opts.dense?s[R][C]:s[encode_col(C)+rr];cell.f=stringify_formula(val[1],refguess,{r:row.r,c:C},supbooks,opts);break;case 0x003C:if(!opts.cellStyles)break;while(val.e>=val.s){colinfo[val.e--]={width:val.w/256,hidden:!!(val.flags&0x01),level:val.level};if(!seencol){seencol=true;find_mdw_colw(val.w/256);}process_col(colinfo[val.e+1]);}break;case 0x00A1:s['!autofilter']={ref:encode_range(val)};break;case 0x01DC:s['!margins']=val;break;case 0x0093:if(!wb.Sheets[idx])wb.Sheets[idx]={};if(val.name)wb.Sheets[idx].CodeName=val.name;if(val.above||val.left)s['!outline']={above:val.above,left:val.left};break;case 0x0089:if(!wb.Views)wb.Views=[{}];if(!wb.Views[0])wb.Views[0]={};if(val.RTL)wb.Views[0].RTL=true;break;case 0x01E5:break;case 0x0040:case 0x041D:break;case 0x0097:break;case 0x0098:case 0x00AF:case 0x0284:case 0x0271:case 0x0232:case 0x018C:case 0x0458:case 0x047A:case 0x01D7:case 0x041A:case 0x0289:case 0x0451:case 0x024D:case 0x025F:case 0x0234:case 0x041F:case 0x00A8:case 0x00AE:case 0x049C:case 0x01F3:case 0x01FB:case 0x0226:case 0x00AB:case 0x00A7:case 0x0499:case 0x00A9:case 0x049D:case 0x0227:case 0x0228:case 0x0295:case 0x027F:case 0x01DE:case 0x0219:case 0x01DD:case 0x0218:case 0x044F:case 0x02A8:case 0x0450:case 0x0400:case 0x0297:case 0x0217:case 0x02A6:case 0x01F8:case 0x0413:case 0x01AC:case 0x00AA:case 0x0C00:case 0x0032:case 0x0816:case 0x0415:break;case 0x0023:pass=true;break;case 0x0024:pass=false;break;case 0x0025:state.push(RT);pass=true;break;case 0x0026:state.pop();pass=false;break;default:if(RR.T){}else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}},opts);delete opts.supbooks;delete opts['!row'];if(!s["!ref"]&&(refguess.s.r<2000000||ref&&(ref.e.r>0||ref.e.c>0||ref.s.r>0||ref.s.c>0)))s["!ref"]=encode_range(ref||refguess);if(opts.sheetRows&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<=+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref);}}if(merges.length>0)s["!merges"]=merges;if(colinfo.length>0)s["!cols"]=colinfo;if(rowinfo.length>0)s["!rows"]=rowinfo;return s;}function write_ws_bin_cell(ba,cell,R,C,opts,ws,last_seen){if(cell.v===undefined)return false;var vv="";switch(cell.t){case'b':vv=cell.v?"1":"0";break;case'd':cell=dup(cell);cell.z=cell.z||table_fmt[14];cell.v=datenum(parseDate(cell.v));cell.t='n';break;case'n':case'e':vv=''+cell.v;break;default:vv=cell.v;break;}var o={r:R,c:C};o.s=get_cell_style(opts.cellXfs,cell,opts);if(cell.l)ws['!links'].push([encode_cell(o),cell.l]);if(cell.c)ws['!comments'].push([encode_cell(o),cell.c]);switch(cell.t){case's':case'str':if(opts.bookSST){vv=get_sst_id(opts.Strings,cell.v,opts.revStrings);o.t="s";o.v=vv;if(last_seen)write_record(ba,0x0012,write_BrtShortIsst(cell,o));else write_record(ba,0x0007,write_BrtCellIsst(cell,o));}else{o.t="str";if(last_seen)write_record(ba,0x0011,write_BrtShortSt(cell,o));else write_record(ba,0x0006,write_BrtCellSt(cell,o));}return true;case'n':if(cell.v==(cell.v|0)&&cell.v>-1000&&cell.v<1000){if(last_seen)write_record(ba,0x000D,write_BrtShortRk(cell,o));else write_record(ba,0x0002,write_BrtCellRk(cell,o));}else{if(last_seen)write_record(ba,0x0010,write_BrtShortReal(cell,o));else write_record(ba,0x0005,write_BrtCellReal(cell,o));}return true;case'b':o.t="b";if(last_seen)write_record(ba,0x000F,write_BrtShortBool(cell,o));else write_record(ba,0x0004,write_BrtCellBool(cell,o));return true;case'e':o.t="e";if(last_seen)write_record(ba,0x000E,write_BrtShortError(cell,o));else write_record(ba,0x0003,write_BrtCellError(cell,o));return true;}if(last_seen)write_record(ba,0x000C,write_BrtShortBlank(cell,o));else write_record(ba,0x0001,write_BrtCellBlank(cell,o));return true;}function write_CELLTABLE(ba,ws,idx,opts){var range=safe_decode_range(ws['!ref']||"A1"),ref,rr="",cols=[];write_record(ba,0x0091);var dense=Array.isArray(ws);var cap=range.e.r;if(ws['!rows'])cap=Math.max(range.e.r,ws['!rows'].length-1);for(var R=range.s.r;R<=cap;++R){rr=encode_row(R);write_row_header(ba,ws,range,R);var last_seen=false;if(R<=range.e.r)for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell){last_seen=false;continue;}last_seen=write_ws_bin_cell(ba,cell,R,C,opts,ws,last_seen);}}write_record(ba,0x0092);}function write_MERGECELLS(ba,ws){if(!ws||!ws['!merges'])return;write_record(ba,0x00B1,write_BrtBeginMergeCells(ws['!merges'].length));ws['!merges'].forEach(function(m){write_record(ba,0x00B0,write_BrtMergeCell(m));});write_record(ba,0x00B2);}function write_COLINFOS(ba,ws){if(!ws||!ws['!cols'])return;write_record(ba,0x0186);ws['!cols'].forEach(function(m,i){if(m)write_record(ba,0x003C,write_BrtColInfo(i,m));});write_record(ba,0x0187);}function write_IGNOREECS(ba,ws){if(!ws||!ws['!ref'])return;write_record(ba,0x0288);write_record(ba,0x0289,write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));write_record(ba,0x028A);}function write_HLINKS(ba,ws,rels){ws['!links'].forEach(function(l){if(!l[1].Target)return;var rId=add_rels(rels,-1,l[1].Target.replace(/#.*$/,""),RELS.HLINK);write_record(ba,0x01EE,write_BrtHLink(l,rId));});delete ws['!links'];}function write_LEGACYDRAWING(ba,ws,idx,rels){if(ws['!comments'].length>0){var rId=add_rels(rels,-1,"../drawings/vmlDrawing"+(idx+1)+".vml",RELS.VML);write_record(ba,0x0227,write_RelID("rId"+rId));ws['!legacy']=rId;}}function write_AUTOFILTER(ba,ws,wb,idx){if(!ws['!autofilter'])return;var data=ws['!autofilter'];var ref=typeof data.ref==="string"?data.ref:encode_range(data.ref);if(!wb.Workbook)wb.Workbook={Sheets:[]};if(!wb.Workbook.Names)wb.Workbook.Names=[];var names=wb.Workbook.Names;var range=decode_range(ref);if(range.s.r==range.e.r){range.e.r=decode_range(ws["!ref"]).e.r;ref=encode_range(range);}for(var i=0;i<names.length;++i){var name=names[i];if(name.Name!='_xlnm._FilterDatabase')continue;if(name.Sheet!=idx)continue;name.Ref="'"+wb.SheetNames[idx]+"'!"+ref;break;}if(i==names.length)names.push({Name:'_xlnm._FilterDatabase',Sheet:idx,Ref:"'"+wb.SheetNames[idx]+"'!"+ref});write_record(ba,0x00A1,write_UncheckedRfX(safe_decode_range(ref)));write_record(ba,0x00A2);}function write_WSVIEWS2(ba,ws,Workbook){write_record(ba,0x0085);{write_record(ba,0x0089,write_BrtBeginWsView(ws,Workbook));write_record(ba,0x008A);}write_record(ba,0x0086);}function write_WSFMTINFO(){}function write_SHEETPROTECT(ba,ws){if(!ws['!protect'])return;write_record(ba,0x0217,write_BrtSheetProtection(ws['!protect']));}function write_ws_bin(idx,opts,wb,rels){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var c=s;try{if(wb&&wb.Workbook)c=wb.Workbook.Sheets[idx].CodeName||c;}catch(e){}var r=safe_decode_range(ws['!ref']||"A1");if(r.e.c>0x3FFF||r.e.r>0xFFFFF){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:XFD1048576");r.e.c=Math.min(r.e.c,0x3FFF);r.e.r=Math.min(r.e.c,0xFFFFF);}ws['!links']=[];ws['!comments']=[];write_record(ba,0x0081);if(wb.vbaraw||ws['!outline'])write_record(ba,0x0093,write_BrtWsProp(c,ws['!outline']));write_record(ba,0x0094,write_BrtWsDim(r));write_WSVIEWS2(ba,ws,wb.Workbook);write_WSFMTINFO(ba,ws);write_COLINFOS(ba,ws,idx,opts,wb);write_CELLTABLE(ba,ws,idx,opts,wb);write_SHEETPROTECT(ba,ws);write_AUTOFILTER(ba,ws,wb,idx);write_MERGECELLS(ba,ws);write_HLINKS(ba,ws,rels);if(ws['!margins'])write_record(ba,0x01DC,write_BrtMargins(ws['!margins']));if(!opts||opts.ignoreEC||opts.ignoreEC==void 0)write_IGNOREECS(ba,ws);write_LEGACYDRAWING(ba,ws,idx,rels);write_record(ba,0x0082);return ba.end();}function parse_Cache(data){var col=[];var num=data.match(/^<c:numCache>/);var f;(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt){var q=pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);if(!q)return;col[+q[1]]=num?+q[2]:q[2];});var nf=unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F){f=F.replace(/<.*?>/g,"");});return[col,nf,f];}function parse_chart(data,name,opts,rels,wb,csheet){var cs=csheet||{"!type":"chart"};if(!data)return csheet;var C=0,R=0,col="A";var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc){var cache=parse_Cache(nc);refguess.s.r=refguess.s.c=0;refguess.e.c=C;col=encode_col(C);cache[0].forEach(function(n,i){cs[col+encode_row(i)]={t:'n',v:n,z:cache[1]};R=i;});if(refguess.e.r<R)refguess.e.r=R;++C;});if(C>0)cs["!ref"]=encode_range(refguess);return cs;}function parse_cs_xml(data,opts,idx,rels,wb){if(!data)return data;if(!rels)rels={'!id':{}};var s={'!type':"chart",'!drawel':null,'!rel':""};var m;var sheetPr=data.match(sheetprregex);if(sheetPr)parse_ws_xml_sheetpr(sheetPr[0],s,wb,idx);if(m=data.match(/drawing r:id="(.*?)"/))s['!rel']=m[1];if(rels['!id'][s['!rel']])s['!drawel']=rels['!id'][s['!rel']];return s;}function write_cs_xml(idx,opts,wb,rels){var o=[XML_HEADER,writextag('chartsheet',null,{'xmlns':XMLNS_main[0],'xmlns:r':XMLNS.r})];o[o.length]=writextag("drawing",null,{"r:id":"rId1"});add_rels(rels,-1,"../drawings/drawing"+(idx+1)+".xml",RELS.DRAW);if(o.length>2){o[o.length]='</chartsheet>';o[1]=o[1].replace("/>",">");}return o.join("");}function parse_BrtCsProp(data,length){data.l+=10;var name=parse_XLWideString(data,length-10);return{name:name};}function parse_cs_bin(data,opts,idx,rels,wb){if(!data)return data;if(!rels)rels={'!id':{}};var s={'!type':"chart",'!drawel':null,'!rel':""};var state=[];var pass=false;recordhopper(data,function cs_parse(val,R,RT){switch(RT){case 0x0226:s['!rel']=val;break;case 0x028B:if(!wb.Sheets[idx])wb.Sheets[idx]={};if(val.name)wb.Sheets[idx].CodeName=val.name;break;case 0x0232:case 0x028C:case 0x029D:case 0x02A7:case 0x0227:case 0x0228:case 0x01DC:case 0x0C00:break;case 0x0023:pass=true;break;case 0x0024:pass=false;break;case 0x0025:state.push(RT);break;case 0x0026:state.pop();break;default:if(R.T>0)state.push(RT);else if(R.T<0)state.pop();else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}},opts);if(rels['!id'][s['!rel']])s['!drawel']=rels['!id'][s['!rel']];return s;}function write_cs_bin(){var ba=buf_array();write_record(ba,0x0081);write_record(ba,0x0082);return ba.end();}var WBPropsDef=[['allowRefreshQuery',false,"bool"],['autoCompressPictures',true,"bool"],['backupFile',false,"bool"],['checkCompatibility',false,"bool"],['CodeName',''],['date1904',false,"bool"],['defaultThemeVersion',0,"int"],['filterPrivacy',false,"bool"],['hidePivotFieldList',false,"bool"],['promptedSolutions',false,"bool"],['publishItems',false,"bool"],['refreshAllConnections',false,"bool"],['saveExternalLinkValues',true,"bool"],['showBorderUnselectedTables',true,"bool"],['showInkAnnotation',true,"bool"],['showObjects','all'],['showPivotChartFilter',false,"bool"],['updateLinks','userSet']];var WBViewDef=[['activeTab',0,"int"],['autoFilterDateGrouping',true,"bool"],['firstSheet',0,"int"],['minimized',false,"bool"],['showHorizontalScroll',true,"bool"],['showSheetTabs',true,"bool"],['showVerticalScroll',true,"bool"],['tabRatio',600,"int"],['visibility','visible']];var SheetDef=[];var CalcPrDef=[['calcCompleted','true'],['calcMode','auto'],['calcOnSave','true'],['concurrentCalc','true'],['fullCalcOnLoad','false'],['fullPrecision','true'],['iterate','false'],['iterateCount','100'],['iterateDelta','0.001'],['refMode','A1']];function push_defaults_array(target,defaults){for(var j=0;j!=target.length;++j){var w=target[j];for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(w[z[0]]==null)w[z[0]]=z[1];else switch(z[2]){case"bool":if(typeof w[z[0]]=="string")w[z[0]]=parsexmlbool(w[z[0]]);break;case"int":if(typeof w[z[0]]=="string")w[z[0]]=parseInt(w[z[0]],10);break;}}}}function push_defaults(target,defaults){for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(target[z[0]]==null)target[z[0]]=z[1];else switch(z[2]){case"bool":if(typeof target[z[0]]=="string")target[z[0]]=parsexmlbool(target[z[0]]);break;case"int":if(typeof target[z[0]]=="string")target[z[0]]=parseInt(target[z[0]],10);break;}}}function parse_wb_defaults(wb){push_defaults(wb.WBProps,WBPropsDef);push_defaults(wb.CalcPr,CalcPrDef);push_defaults_array(wb.WBView,WBViewDef);push_defaults_array(wb.Sheets,SheetDef);_ssfopts.date1904=parsexmlbool(wb.WBProps.date1904);}function safe1904(wb){if(!wb.Workbook)return"false";if(!wb.Workbook.WBProps)return"false";return parsexmlbool(wb.Workbook.WBProps.date1904)?"true":"false";}var badchars="][*?\/\\".split("");function check_ws_name(n,safe){if(n.length>31){if(safe)return false;throw new Error("Sheet names cannot exceed 31 chars");}var _good=true;badchars.forEach(function(c){if(n.indexOf(c)==-1)return;if(!safe)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");_good=false;});return _good;}function check_wb_names(N,S,codes){N.forEach(function(n,i){check_ws_name(n);for(var j=0;j<i;++j){if(n==N[j])throw new Error("Duplicate Sheet Name: "+n);}if(codes){var cn=S&&S[i]&&S[i].CodeName||n;if(cn.charCodeAt(0)==95&&cn.length>22)throw new Error("Bad Code Name: Worksheet"+cn);}});}function check_wb(wb){if(!wb||!wb.SheetNames||!wb.Sheets)throw new Error("Invalid Workbook");if(!wb.SheetNames.length)throw new Error("Workbook is empty");var Sheets=wb.Workbook&&wb.Workbook.Sheets||[];check_wb_names(wb.SheetNames,Sheets,!!wb.vbaraw);for(var i=0;i<wb.SheetNames.length;++i){check_ws(wb.Sheets[wb.SheetNames[i]],wb.SheetNames[i],i);}}var wbnsregex=/<\w+:workbook/;function parse_wb_xml(data,opts){if(!data)throw new Error("Could not find file");var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""};var pass=false,xmlns="xmlns";var dname={},dnstart=0;data.replace(tagregex,function xml_wb(x,idx){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;case'<workbook':if(x.match(wbnsregex))xmlns="xmlns"+x.match(/<(\w+):/)[1];wb.xmlns=y[xmlns];break;case'</workbook>':break;case'<fileVersion':delete y[0];wb.AppVersion=y;break;case'<fileVersion/>':case'</fileVersion>':break;case'<fileSharing':break;case'<fileSharing/>':break;case'<workbookPr':case'<workbookPr/>':WBPropsDef.forEach(function(w){if(y[w[0]]==null)return;switch(w[2]){case"bool":wb.WBProps[w[0]]=parsexmlbool(y[w[0]]);break;case"int":wb.WBProps[w[0]]=parseInt(y[w[0]],10);break;default:wb.WBProps[w[0]]=y[w[0]];}});if(y.codeName)wb.WBProps.CodeName=utf8read(y.codeName);break;case'</workbookPr>':break;case'<workbookProtection':break;case'<workbookProtection/>':break;case'<bookViews':case'<bookViews>':case'</bookViews>':break;case'<workbookView':case'<workbookView/>':delete y[0];wb.WBView.push(y);break;case'</workbookView>':break;case'<sheets':case'<sheets>':case'</sheets>':break;case'<sheet':switch(y.state){case"hidden":y.Hidden=1;break;case"veryHidden":y.Hidden=2;break;default:y.Hidden=0;}delete y.state;y.name=unescapexml(utf8read(y.name));delete y[0];wb.Sheets.push(y);break;case'</sheet>':break;case'<functionGroups':case'<functionGroups/>':break;case'<functionGroup':break;case'<externalReferences':case'</externalReferences>':case'<externalReferences>':break;case'<externalReference':break;case'<definedNames/>':break;case'<definedNames>':case'<definedNames':pass=true;break;case'</definedNames>':pass=false;break;case'<definedName':{dname={};dname.Name=utf8read(y.name);if(y.comment)dname.Comment=y.comment;if(y.localSheetId)dname.Sheet=+y.localSheetId;if(parsexmlbool(y.hidden||"0"))dname.Hidden=true;dnstart=idx+x.length;}break;case'</definedName>':{dname.Ref=unescapexml(utf8read(data.slice(dnstart,idx)));wb.Names.push(dname);}break;case'<definedName/>':break;case'<calcPr':delete y[0];wb.CalcPr=y;break;case'<calcPr/>':delete y[0];wb.CalcPr=y;break;case'</calcPr>':break;case'<oleSize':break;case'<customWorkbookViews>':case'</customWorkbookViews>':case'<customWorkbookViews':break;case'<customWorkbookView':case'</customWorkbookView>':break;case'<pivotCaches>':case'</pivotCaches>':case'<pivotCaches':break;case'<pivotCache':break;case'<smartTagPr':case'<smartTagPr/>':break;case'<smartTagTypes':case'<smartTagTypes>':case'</smartTagTypes>':break;case'<smartTagType':break;case'<webPublishing':case'<webPublishing/>':break;case'<fileRecoveryPr':case'<fileRecoveryPr/>':break;case'<webPublishObjects>':case'<webPublishObjects':case'</webPublishObjects>':break;case'<webPublishObject':break;case'<extLst':case'<extLst>':case'</extLst>':case'<extLst/>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;case'<ArchID':break;case'<AlternateContent':case'<AlternateContent>':pass=true;break;case'</AlternateContent>':pass=false;break;case'<revisionPtr':break;default:if(!pass&&opts.WTF)throw new Error('unrecognized '+y[0]+' in workbook');}return x;});if(XMLNS_main.indexOf(wb.xmlns)===-1)throw new Error("Unknown Namespace: "+wb.xmlns);parse_wb_defaults(wb);return wb;}function write_wb_xml(wb){var o=[XML_HEADER];o[o.length]=writextag('workbook',null,{'xmlns':XMLNS_main[0],'xmlns:r':XMLNS.r});var write_names=wb.Workbook&&(wb.Workbook.Names||[]).length>0;var workbookPr={codeName:"ThisWorkbook"};if(wb.Workbook&&wb.Workbook.WBProps){WBPropsDef.forEach(function(x){if(wb.Workbook.WBProps[x[0]]==null)return;if(wb.Workbook.WBProps[x[0]]==x[1])return;workbookPr[x[0]]=wb.Workbook.WBProps[x[0]];});if(wb.Workbook.WBProps.CodeName){workbookPr.codeName=wb.Workbook.WBProps.CodeName;delete workbookPr.CodeName;}}o[o.length]=writextag('workbookPr',null,workbookPr);var sheets=wb.Workbook&&wb.Workbook.Sheets||[];var i=0;if(sheets&&sheets[0]&&!!sheets[0].Hidden){o[o.length]="<bookViews>";for(i=0;i!=wb.SheetNames.length;++i){if(!sheets[i])break;if(!sheets[i].Hidden)break;}if(i==wb.SheetNames.length)i=0;o[o.length]='<workbookView firstSheet="'+i+'" activeTab="'+i+'"/>';o[o.length]="</bookViews>";}o[o.length]="<sheets>";for(i=0;i!=wb.SheetNames.length;++i){var sht={name:escapexml(wb.SheetNames[i].slice(0,31))};sht.sheetId=""+(i+1);sht["r:id"]="rId"+(i+1);if(sheets[i])switch(sheets[i].Hidden){case 1:sht.state="hidden";break;case 2:sht.state="veryHidden";break;}o[o.length]=writextag('sheet',null,sht);}o[o.length]="</sheets>";if(write_names){o[o.length]="<definedNames>";if(wb.Workbook&&wb.Workbook.Names)wb.Workbook.Names.forEach(function(n){var d={name:n.Name};if(n.Comment)d.comment=n.Comment;if(n.Sheet!=null)d.localSheetId=""+n.Sheet;if(n.Hidden)d.hidden="1";if(!n.Ref)return;o[o.length]=writextag('definedName',escapexml(n.Ref),d);});o[o.length]="</definedNames>";}if(o.length>2){o[o.length]='</workbook>';o[1]=o[1].replace("/>",">");}return o.join("");}function parse_BrtBundleSh(data,length){var z={};z.Hidden=data.read_shift(4);z.iTabID=data.read_shift(4);z.strRelID=parse_RelID(data,length-8);z.name=parse_XLWideString(data);return z;}function write_BrtBundleSh(data,o){if(!o)o=new_buf(127);o.write_shift(4,data.Hidden);o.write_shift(4,data.iTabID);write_RelID(data.strRelID,o);write_XLWideString(data.name.slice(0,31),o);return o.length>o.l?o.slice(0,o.l):o;}function parse_BrtWbProp(data,length){var o={};var flags=data.read_shift(4);o.defaultThemeVersion=data.read_shift(4);var strName=length>8?parse_XLWideString(data):"";if(strName.length>0)o.CodeName=strName;o.autoCompressPictures=!!(flags&0x10000);o.backupFile=!!(flags&0x40);o.checkCompatibility=!!(flags&0x1000);o.date1904=!!(flags&0x01);o.filterPrivacy=!!(flags&0x08);o.hidePivotFieldList=!!(flags&0x400);o.promptedSolutions=!!(flags&0x10);o.publishItems=!!(flags&0x800);o.refreshAllConnections=!!(flags&0x40000);o.saveExternalLinkValues=!!(flags&0x80);o.showBorderUnselectedTables=!!(flags&0x04);o.showInkAnnotation=!!(flags&0x20);o.showObjects=["all","placeholders","none"][flags>>13&0x03];o.showPivotChartFilter=!!(flags&0x8000);o.updateLinks=["userSet","never","always"][flags>>8&0x03];return o;}function write_BrtWbProp(data,o){if(!o)o=new_buf(72);var flags=0;if(data){if(data.filterPrivacy)flags|=0x08;}o.write_shift(4,flags);o.write_shift(4,0);write_XLSBCodeName(data&&data.CodeName||"ThisWorkbook",o);return o.slice(0,o.l);}function parse_BrtFRTArchID$(data,length){var o={};data.read_shift(4);o.ArchID=data.read_shift(4);data.l+=length-8;return o;}function parse_BrtName(data,length,opts){var end=data.l+length;data.l+=4;data.l+=1;var itab=data.read_shift(4);var name=parse_XLNameWideString(data);var formula=parse_XLSBNameParsedFormula(data,0,opts);var comment=parse_XLNullableWideString(data);data.l=end;var out={Name:name,Ptg:formula};if(itab<0xFFFFFFF)out.Sheet=itab;if(comment)out.Comment=comment;return out;}function parse_wb_bin(data,opts){var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var state=[];var pass=false;if(!opts)opts={};opts.biff=12;var Names=[];var supbooks=[[]];supbooks.SheetNames=[];supbooks.XTI=[];XLSBRecordEnum[0x0010]={n:"BrtFRTArchID$",f:parse_BrtFRTArchID$};recordhopper(data,function hopper_wb(val,R,RT){switch(RT){case 0x009C:supbooks.SheetNames.push(val.name);wb.Sheets.push(val);break;case 0x0099:wb.WBProps=val;break;case 0x0027:if(val.Sheet!=null)opts.SID=val.Sheet;val.Ref=stringify_formula(val.Ptg,null,null,supbooks,opts);delete opts.SID;delete val.Ptg;Names.push(val);break;case 0x040C:break;case 0x0165:case 0x0166:case 0x0163:case 0x029B:if(!supbooks[0].length)supbooks[0]=[RT,val];else supbooks.push([RT,val]);supbooks[supbooks.length-1].XTI=[];break;case 0x016A:if(supbooks.length===0){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].XTI=supbooks[supbooks.length-1].XTI.concat(val);supbooks.XTI=supbooks.XTI.concat(val);break;case 0x0169:break;case 0x0817:case 0x009E:case 0x008F:case 0x0298:case 0x0161:break;case 0x0C00:case 0x0C01:case 0x0216:case 0x02A5:case 0x009D:case 0x0262:case 0x0802:case 0x009B:case 0x0224:case 0x02A4:case 0x0080:case 0x0299:case 0x0850:case 0x084D:case 0x0225:case 0x0805:case 0x0254:case 0x081C:case 0x081B:case 0x0822:case 0x018D:case 0x009A:case 0x045D:case 0x0229:case 0x082B:break;case 0x0023:state.push(RT);pass=true;break;case 0x0024:state.pop();pass=false;break;case 0x0025:state.push(RT);pass=true;break;case 0x0026:state.pop();pass=false;break;case 0x0010:break;default:if(R.T){}else if(!pass||opts.WTF&&state[state.length-1]!=0x0025&&state[state.length-1]!=0x0023)throw new Error("Unexpected record 0x"+RT.toString(16));}},opts);parse_wb_defaults(wb);wb.Names=Names;wb.supbooks=supbooks;return wb;}function write_BUNDLESHS(ba,wb){write_record(ba,0x008F);for(var idx=0;idx!=wb.SheetNames.length;++idx){var viz=wb.Workbook&&wb.Workbook.Sheets&&wb.Workbook.Sheets[idx]&&wb.Workbook.Sheets[idx].Hidden||0;var d={Hidden:viz,iTabID:idx+1,strRelID:'rId'+(idx+1),name:wb.SheetNames[idx]};write_record(ba,0x009C,write_BrtBundleSh(d));}write_record(ba,0x0090);}function write_BrtFileVersion(data,o){if(!o)o=new_buf(127);for(var i=0;i!=4;++i){o.write_shift(4,0);}write_XLWideString("SheetJS",o);write_XLWideString(XLSX.version,o);write_XLWideString(XLSX.version,o);write_XLWideString("7262",o);return o.length>o.l?o.slice(0,o.l):o;}function write_BrtBookView(idx,o){if(!o)o=new_buf(29);o.write_shift(-4,0);o.write_shift(-4,460);o.write_shift(4,28800);o.write_shift(4,17600);o.write_shift(4,500);o.write_shift(4,idx);o.write_shift(4,idx);var flags=0x78;o.write_shift(1,flags);return o.length>o.l?o.slice(0,o.l):o;}function write_BOOKVIEWS(ba,wb){if(!wb.Workbook||!wb.Workbook.Sheets)return;var sheets=wb.Workbook.Sheets;var i=0,vistab=-1,hidden=-1;for(;i<sheets.length;++i){if(!sheets[i]||!sheets[i].Hidden&&vistab==-1)vistab=i;else if(sheets[i].Hidden==1&&hidden==-1)hidden=i;}if(hidden>vistab)return;write_record(ba,0x0087);write_record(ba,0x009E,write_BrtBookView(vistab));write_record(ba,0x0088);}function write_wb_bin(wb,opts){var ba=buf_array();write_record(ba,0x0083);write_record(ba,0x0080,write_BrtFileVersion());write_record(ba,0x0099,write_BrtWbProp(wb.Workbook&&wb.Workbook.WBProps||null));write_BOOKVIEWS(ba,wb,opts);write_BUNDLESHS(ba,wb,opts);write_record(ba,0x0084);return ba.end();}function parse_wb(data,name,opts){if(name.slice(-4)===".bin")return parse_wb_bin(data,opts);return parse_wb_xml(data,opts);}function parse_ws(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ws_bin(data,opts,idx,rels,wb,themes,styles);return parse_ws_xml(data,opts,idx,rels,wb,themes,styles);}function parse_cs(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_cs_bin(data,opts,idx,rels,wb,themes,styles);return parse_cs_xml(data,opts,idx,rels,wb,themes,styles);}function parse_ms(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ms_bin(data,opts,idx,rels,wb,themes,styles);return parse_ms_xml(data,opts,idx,rels,wb,themes,styles);}function parse_ds(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ds_bin(data,opts,idx,rels,wb,themes,styles);return parse_ds_xml(data,opts,idx,rels,wb,themes,styles);}function parse_sty(data,name,themes,opts){if(name.slice(-4)===".bin")return parse_sty_bin(data,themes,opts);return parse_sty_xml(data,themes,opts);}function parse_theme(data,name,opts){return parse_theme_xml(data,opts);}function parse_sst(data,name,opts){if(name.slice(-4)===".bin")return parse_sst_bin(data,opts);return parse_sst_xml(data,opts);}function parse_cmnt(data,name,opts){if(name.slice(-4)===".bin")return parse_comments_bin(data,opts);return parse_comments_xml(data,opts);}function parse_cc(data,name,opts){if(name.slice(-4)===".bin")return parse_cc_bin(data,name,opts);return parse_cc_xml(data,name,opts);}function parse_xlink(data,rel,name,opts){if(name.slice(-4)===".bin")return parse_xlink_bin(data,rel,name,opts);return parse_xlink_xml(data,rel,name,opts);}function parse_xlmeta(data,name,opts){if(name.slice(-4)===".bin")return parse_xlmeta_bin(data,name,opts);return parse_xlmeta_xml(data,name,opts);}function write_wb(wb,name,opts){return(name.slice(-4)===".bin"?write_wb_bin:write_wb_xml)(wb,opts);}function write_ws(data,name,opts,wb,rels){return(name.slice(-4)===".bin"?write_ws_bin:write_ws_xml)(data,opts,wb,rels);}function write_cs(data,name,opts,wb,rels){return(name.slice(-4)===".bin"?write_cs_bin:write_cs_xml)(data,opts,wb,rels);}function write_sty(data,name,opts){return(name.slice(-4)===".bin"?write_sty_bin:write_sty_xml)(data,opts);}function write_sst(data,name,opts){return(name.slice(-4)===".bin"?write_sst_bin:write_sst_xml)(data,opts);}function write_cmnt(data,name,opts){return(name.slice(-4)===".bin"?write_comments_bin:write_comments_xml)(data,opts);}function write_xlmeta(name){return(name.slice(-4)===".bin"?write_xlmeta_bin:write_xlmeta_xml)();}var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;function xlml_parsexmltag(tag,skip_root){var words=tag.split(/\s+/);var z=[];if(!skip_root)z[0]=words[0];if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].slice(1,y[2].length-1);else{if(y[1].slice(0,6)==="xmlns:")w="xmlns"+y[1].slice(6);else w=y[1].slice(j+1);z[w]=y[2].slice(1,y[2].length-1);}}return z;}function xlml_parsexmltagobj(tag){var words=tag.split(/\s+/);var z={};if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].slice(1,y[2].length-1);else{if(y[1].slice(0,6)==="xmlns:")w="xmlns"+y[1].slice(6);else w=y[1].slice(j+1);z[w]=y[2].slice(1,y[2].length-1);}}return z;}var XLMLFormatMap;function xlml_format(format,value){var fmt=XLMLFormatMap[format]||unescapexml(format);if(fmt==="General")return SSF_general(value);return SSF_format(fmt,value);}function xlml_set_custprop(Custprops,key,cp,val){var oval=val;switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":oval=parsexmlbool(val);break;case"i2":case"int":oval=parseInt(val,10);break;case"r4":case"float":oval=parseFloat(val);break;case"date":case"dateTime.tz":oval=parseDate(val);break;case"i8":case"string":case"fixed":case"uuid":case"bin.base64":break;default:throw new Error("bad custprop:"+cp[0]);}Custprops[unescapexml(key)]=oval;}function safe_format_xlml(cell,nf,o){if(cell.t==='z')return;if(!o||o.cellText!==false)try{if(cell.t==='e'){cell.w=cell.w||BErr[cell.v];}else if(nf==="General"){if(cell.t==='n'){if((cell.v|0)===cell.v)cell.w=cell.v.toString(10);else cell.w=SSF_general_num(cell.v);}else cell.w=SSF_general(cell.v);}else cell.w=xlml_format(nf||"General",cell.v);}catch(e){if(o.WTF)throw e;}try{var z=XLMLFormatMap[nf]||nf||"General";if(o.cellNF)cell.z=z;if(o.cellDates&&cell.t=='n'&&fmt_is_date(z)){var _d=SSF_parse_date_code(cell.v);if(_d){cell.t='d';cell.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}}catch(e){if(o.WTF)throw e;}}function process_style_xlml(styles,stag,opts){if(opts.cellStyles){if(stag.Interior){var I=stag.Interior;if(I.Pattern)I.patternType=XLMLPatternTypeMap[I.Pattern]||I.Pattern;}}styles[stag.ID]=stag;}function parse_xlml_data(xml,ss,data,cell,base,styles,csty,row,arrayf,o){var nf="General",sid=cell.StyleID,S={};o=o||{};var interiors=[];var i=0;if(sid===undefined&&row)sid=row.StyleID;if(sid===undefined&&csty)sid=csty.StyleID;while(styles[sid]!==undefined){if(styles[sid].nf)nf=styles[sid].nf;if(styles[sid].Interior)interiors.push(styles[sid].Interior);if(!styles[sid].Parent)break;sid=styles[sid].Parent;}switch(data.Type){case'Boolean':cell.t='b';cell.v=parsexmlbool(xml);break;case'String':cell.t='s';cell.r=xlml_fixstr(unescapexml(xml));cell.v=xml.indexOf("<")>-1?unescapexml(ss||xml).replace(/<.*?>/g,""):cell.r;break;case'DateTime':if(xml.slice(-1)!="Z")xml+="Z";cell.v=(parseDate(xml)-new Date(Date.UTC(1899,11,30)))/(24*60*60*1000);if(cell.v!==cell.v)cell.v=unescapexml(xml);else if(cell.v<60)cell.v=cell.v-1;if(!nf||nf=="General")nf="yyyy-mm-dd";case'Number':if(cell.v===undefined)cell.v=+xml;if(!cell.t)cell.t='n';break;case'Error':cell.t='e';cell.v=RBErr[xml];if(o.cellText!==false)cell.w=xml;break;default:if(xml==""&&ss==""){cell.t='z';}else{cell.t='s';cell.v=xlml_fixstr(ss||xml);}break;}safe_format_xlml(cell,nf,o);if(o.cellFormula!==false){if(cell.Formula){var fstr=unescapexml(cell.Formula);if(fstr.charCodeAt(0)==61)fstr=fstr.slice(1);cell.f=rc_to_a1(fstr,base);delete cell.Formula;if(cell.ArrayRange=="RC")cell.F=rc_to_a1("RC:RC",base);else if(cell.ArrayRange){cell.F=rc_to_a1(cell.ArrayRange,base);arrayf.push([safe_decode_range(cell.F),cell.F]);}}else{for(i=0;i<arrayf.length;++i){if(base.r>=arrayf[i][0].s.r&&base.r<=arrayf[i][0].e.r)if(base.c>=arrayf[i][0].s.c&&base.c<=arrayf[i][0].e.c)cell.F=arrayf[i][1];}}}if(o.cellStyles){interiors.forEach(function(x){if(!S.patternType&&x.patternType)S.patternType=x.patternType;});cell.s=S;}if(cell.StyleID!==undefined)cell.ixfe=cell.StyleID;}function xlml_clean_comment(comment){comment.t=comment.v||"";comment.t=comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");comment.v=comment.w=comment.ixfe=undefined;}function parse_xlml_xml(d,_opts){var opts=_opts||{};make_ssf();var str=debom(xlml_normalize(d));if(opts.type=='binary'||opts.type=='array'||opts.type=='base64'){if(typeof $cptable!=='undefined')str=$cptable.utils.decode(65001,char_codes(str));else str=utf8read(str);}var opening=str.slice(0,1024).toLowerCase(),ishtml=false;opening=opening.replace(/".*?"/g,"");if((opening.indexOf(">")&1023)>Math.min(opening.indexOf(",")&1023,opening.indexOf(";")&1023)){var _o=dup(opts);_o.type="string";return PRN.to_workbook(str,_o);}if(opening.indexOf("<?xml")==-1)["html","table","head","meta","script","style","div"].forEach(function(tag){if(opening.indexOf("<"+tag)>=0)ishtml=true;});if(ishtml)return html_to_workbook(str,opts);XLMLFormatMap={"General Number":"General","General Date":table_fmt[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":table_fmt[15],"Short Date":table_fmt[14],"Long Time":table_fmt[19],"Medium Time":table_fmt[18],"Short Time":table_fmt[20],"Currency":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"Fixed":table_fmt[2],"Standard":table_fmt[4],"Percent":table_fmt[10],"Scientific":table_fmt[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var Rn;var state=[],tmp;if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var sheets={},sheetnames=[],cursheet=opts.dense?[]:{},sheetname="";var cell={},row={};var dtag=xlml_parsexmltag('<Data ss:Type="String">'),didx=0;var c=0,r=0;var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var styles={},stag={};var ss="",fidx=0;var merges=[];var Props={},Custprops={},pidx=0,cp=[];var comments=[],comment={};var cstys=[],csty,seencol=false;var arrayf=[];var rowinfo=[],rowobj={},cc=0,rr=0;var Workbook={Sheets:[],WBProps:{date1904:false}},wsprops={};xlmlregex.lastIndex=0;str=str.replace(/<!--([\s\S]*?)-->/mg,"");var raw_Rn3="";while(Rn=xlmlregex.exec(str)){switch(Rn[3]=(raw_Rn3=Rn[3]).toLowerCase()){case'data':if(raw_Rn3=="data"){if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;}if(state[state.length-1][1])break;if(Rn[1]==='/')parse_xlml_data(str.slice(didx,Rn.index),ss,dtag,state[state.length-1][0]=="comment"?comment:cell,{c:c,r:r},styles,cstys[c],row,arrayf,opts);else{ss="";dtag=xlml_parsexmltag(Rn[0]);didx=Rn.index+Rn[0].length;}break;case'cell':if(Rn[1]==='/'){if(comments.length>0)cell.c=comments;if((!opts.sheetRows||opts.sheetRows>r)&&cell.v!==undefined){if(opts.dense){if(!cursheet[r])cursheet[r]=[];cursheet[r][c]=cell;}else cursheet[encode_col(c)+encode_row(r)]=cell;}if(cell.HRef){cell.l={Target:unescapexml(cell.HRef)};if(cell.HRefScreenTip)cell.l.Tooltip=cell.HRefScreenTip;delete cell.HRef;delete cell.HRefScreenTip;}if(cell.MergeAcross||cell.MergeDown){cc=c+(parseInt(cell.MergeAcross,10)|0);rr=r+(parseInt(cell.MergeDown,10)|0);merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});}if(!opts.sheetStubs){if(cell.MergeAcross)c=cc+1;else++c;}else if(cell.MergeAcross||cell.MergeDown){for(var cma=c;cma<=cc;++cma){for(var cmd=r;cmd<=rr;++cmd){if(cma>c||cmd>r){if(opts.dense){if(!cursheet[cmd])cursheet[cmd]=[];cursheet[cmd][cma]={t:'z'};}else cursheet[encode_col(cma)+encode_row(cmd)]={t:'z'};}}}c=cc+1;}else++c;}else{cell=xlml_parsexmltagobj(Rn[0]);if(cell.Index)c=+cell.Index-1;if(c<refguess.s.c)refguess.s.c=c;if(c>refguess.e.c)refguess.e.c=c;if(Rn[0].slice(-2)==="/>")++c;comments=[];}break;case'row':if(Rn[1]==='/'||Rn[0].slice(-2)==="/>"){if(r<refguess.s.r)refguess.s.r=r;if(r>refguess.e.r)refguess.e.r=r;if(Rn[0].slice(-2)==="/>"){row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1;}c=0;++r;}else{row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1;rowobj={};if(row.AutoFitHeight=="0"||row.Height){rowobj.hpx=parseInt(row.Height,10);rowobj.hpt=px2pt(rowobj.hpx);rowinfo[r]=rowobj;}if(row.Hidden=="1"){rowobj.hidden=true;rowinfo[r]=rowobj;}}break;case'worksheet':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));sheetnames.push(sheetname);if(refguess.s.r<=refguess.e.r&&refguess.s.c<=refguess.e.c){cursheet["!ref"]=encode_range(refguess);if(opts.sheetRows&&opts.sheetRows<=refguess.e.r){cursheet["!fullref"]=cursheet["!ref"];refguess.e.r=opts.sheetRows-1;cursheet["!ref"]=encode_range(refguess);}}if(merges.length)cursheet["!merges"]=merges;if(cstys.length>0)cursheet["!cols"]=cstys;if(rowinfo.length>0)cursheet["!rows"]=rowinfo;sheets[sheetname]=cursheet;}else{refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};r=c=0;state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);sheetname=unescapexml(tmp.Name);cursheet=opts.dense?[]:{};merges=[];arrayf=[];rowinfo=[];wsprops={name:sheetname,Hidden:0};Workbook.Sheets.push(wsprops);}break;case'table':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].slice(-2)=="/>")break;else{state.push([Rn[3],false]);cstys=[];seencol=false;}break;case'style':if(Rn[1]==='/')process_style_xlml(styles,stag,opts);else stag=xlml_parsexmltag(Rn[0]);break;case'numberformat':stag.nf=unescapexml(xlml_parsexmltag(Rn[0]).Format||"General");if(XLMLFormatMap[stag.nf])stag.nf=XLMLFormatMap[stag.nf];for(var ssfidx=0;ssfidx!=0x188;++ssfidx){if(table_fmt[ssfidx]==stag.nf)break;}if(ssfidx==0x188)for(ssfidx=0x39;ssfidx!=0x188;++ssfidx){if(table_fmt[ssfidx]==null){SSF_load(stag.nf,ssfidx);break;}}break;case'column':if(state[state.length-1][0]!=='table')break;csty=xlml_parsexmltag(Rn[0]);if(csty.Hidden){csty.hidden=true;delete csty.Hidden;}if(csty.Width)csty.wpx=parseInt(csty.Width,10);if(!seencol&&csty.wpx>10){seencol=true;MDW=DEF_MDW;for(var _col=0;_col<cstys.length;++_col){if(cstys[_col])process_col(cstys[_col]);}}if(seencol)process_col(csty);cstys[csty.Index-1||cstys.length]=csty;for(var i=0;i<+csty.Span;++i){cstys[cstys.length]=dup(csty);}break;case'namedrange':if(Rn[1]==='/')break;if(!Workbook.Names)Workbook.Names=[];var _NamedRange=parsexmltag(Rn[0]);var _DefinedName={Name:_NamedRange.Name,Ref:rc_to_a1(_NamedRange.RefersTo.slice(1),{r:0,c:0})};if(Workbook.Sheets.length>0)_DefinedName.Sheet=Workbook.Sheets.length-1;Workbook.Names.push(_DefinedName);break;case'namedcell':break;case'b':break;case'i':break;case'u':break;case's':break;case'em':break;case'h2':break;case'h3':break;case'sub':break;case'sup':break;case'span':break;case'alignment':break;case'borders':break;case'border':break;case'font':if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")ss+=str.slice(fidx,Rn.index);else fidx=Rn.index+Rn[0].length;break;case'interior':if(!opts.cellStyles)break;stag.Interior=xlml_parsexmltag(Rn[0]);break;case'protection':break;case'author':case'title':case'description':case'created':case'keywords':case'subject':case'category':case'company':case'lastauthor':case'lastsaved':case'lastprinted':case'version':case'revision':case'totaltime':case'hyperlinkbase':case'manager':case'contentstatus':case'identifier':case'language':case'appname':if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_prop(Props,raw_Rn3,str.slice(pidx,Rn.index));else pidx=Rn.index+Rn[0].length;break;case'paragraphs':break;case'styles':case'workbook':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else state.push([Rn[3],false]);break;case'comment':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));xlml_clean_comment(comment);comments.push(comment);}else{state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);comment={a:tmp.Author};}break;case'autofilter':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){var AutoFilter=xlml_parsexmltag(Rn[0]);cursheet['!autofilter']={ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"")};state.push([Rn[3],true]);}break;case'name':break;case'datavalidation':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else{if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);}break;case'pixelsperinch':break;case'componentoptions':case'documentproperties':case'customdocumentproperties':case'officedocumentsettings':case'pivottable':case'pivotcache':case'names':case'mapinfo':case'pagebreaks':case'querytable':case'sorting':case'schema':case'conditionalformatting':case'smarttagtype':case'smarttags':case'excelworkbook':case'workbookoptions':case'worksheetoptions':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;case'null':break;default:if(state.length==0&&Rn[3]=="document")return parse_fods(str,opts);if(state.length==0&&Rn[3]=="uof")return parse_fods(str,opts);var seen=true;switch(state[state.length-1][0]){case'officedocumentsettings':switch(Rn[3]){case'allowpng':break;case'removepersonalinformation':break;case'downloadcomponents':break;case'locationofcomponents':break;case'colors':break;case'color':break;case'index':break;case'rgb':break;case'targetscreensize':break;case'readonlyrecommended':break;default:seen=false;}break;case'componentoptions':switch(Rn[3]){case'toolbar':break;case'hideofficelogo':break;case'spreadsheetautofit':break;case'label':break;case'caption':break;case'maxheight':break;case'maxwidth':break;case'nextsheetnumber':break;default:seen=false;}break;case'excelworkbook':switch(Rn[3]){case'date1904':Workbook.WBProps.date1904=true;break;case'windowheight':break;case'windowwidth':break;case'windowtopx':break;case'windowtopy':break;case'tabratio':break;case'protectstructure':break;case'protectwindow':break;case'protectwindows':break;case'activesheet':break;case'displayinknotes':break;case'firstvisiblesheet':break;case'supbook':break;case'sheetname':break;case'sheetindex':break;case'sheetindexfirst':break;case'sheetindexlast':break;case'dll':break;case'acceptlabelsinformulas':break;case'donotsavelinkvalues':break;case'iteration':break;case'maxiterations':break;case'maxchange':break;case'path':break;case'xct':break;case'count':break;case'selectedsheets':break;case'calculation':break;case'uncalced':break;case'startupprompt':break;case'crn':break;case'externname':break;case'formula':break;case'colfirst':break;case'collast':break;case'wantadvise':break;case'boolean':break;case'error':break;case'text':break;case'ole':break;case'noautorecover':break;case'publishobjects':break;case'donotcalculatebeforesave':break;case'number':break;case'refmoder1c1':break;case'embedsavesmarttags':break;default:seen=false;}break;case'workbookoptions':switch(Rn[3]){case'owcversion':break;case'height':break;case'width':break;default:seen=false;}break;case'worksheetoptions':switch(Rn[3]){case'visible':if(Rn[0].slice(-2)==="/>"){}else if(Rn[1]==="/")switch(str.slice(pidx,Rn.index)){case"SheetHidden":wsprops.Hidden=1;break;case"SheetVeryHidden":wsprops.Hidden=2;break;}else pidx=Rn.index+Rn[0].length;break;case'header':if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');if(!isNaN(+parsexmltag(Rn[0]).Margin))cursheet['!margins'].header=+parsexmltag(Rn[0]).Margin;break;case'footer':if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');if(!isNaN(+parsexmltag(Rn[0]).Margin))cursheet['!margins'].footer=+parsexmltag(Rn[0]).Margin;break;case'pagemargins':var pagemargins=parsexmltag(Rn[0]);if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');if(!isNaN(+pagemargins.Top))cursheet['!margins'].top=+pagemargins.Top;if(!isNaN(+pagemargins.Left))cursheet['!margins'].left=+pagemargins.Left;if(!isNaN(+pagemargins.Right))cursheet['!margins'].right=+pagemargins.Right;if(!isNaN(+pagemargins.Bottom))cursheet['!margins'].bottom=+pagemargins.Bottom;break;case'displayrighttoleft':if(!Workbook.Views)Workbook.Views=[];if(!Workbook.Views[0])Workbook.Views[0]={};Workbook.Views[0].RTL=true;break;case'freezepanes':break;case'frozennosplit':break;case'splithorizontal':case'splitvertical':break;case'donotdisplaygridlines':break;case'activerow':break;case'activecol':break;case'toprowbottompane':break;case'leftcolumnrightpane':break;case'unsynced':break;case'print':break;case'printerrors':break;case'panes':break;case'scale':break;case'pane':break;case'number':break;case'layout':break;case'pagesetup':break;case'selected':break;case'protectobjects':break;case'enableselection':break;case'protectscenarios':break;case'validprinterinfo':break;case'horizontalresolution':break;case'verticalresolution':break;case'numberofcopies':break;case'activepane':break;case'toprowvisible':break;case'leftcolumnvisible':break;case'fittopage':break;case'rangeselection':break;case'papersizeindex':break;case'pagelayoutzoom':break;case'pagebreakzoom':break;case'filteron':break;case'fitwidth':break;case'fitheight':break;case'commentslayout':break;case'zoom':break;case'lefttoright':break;case'gridlines':break;case'allowsort':break;case'allowfilter':break;case'allowinsertrows':break;case'allowdeleterows':break;case'allowinsertcols':break;case'allowdeletecols':break;case'allowinserthyperlinks':break;case'allowformatcells':break;case'allowsizecols':break;case'allowsizerows':break;case'nosummaryrowsbelowdetail':if(!cursheet["!outline"])cursheet["!outline"]={};cursheet["!outline"].above=true;break;case'tabcolorindex':break;case'donotdisplayheadings':break;case'showpagelayoutzoom':break;case'nosummarycolumnsrightdetail':if(!cursheet["!outline"])cursheet["!outline"]={};cursheet["!outline"].left=true;break;case'blackandwhite':break;case'donotdisplayzeros':break;case'displaypagebreak':break;case'rowcolheadings':break;case'donotdisplayoutline':break;case'noorientation':break;case'allowusepivottables':break;case'zeroheight':break;case'viewablerange':break;case'selection':break;case'protectcontents':break;default:seen=false;}break;case'pivottable':case'pivotcache':switch(Rn[3]){case'immediateitemsondrop':break;case'showpagemultipleitemlabel':break;case'compactrowindent':break;case'location':break;case'pivotfield':break;case'orientation':break;case'layoutform':break;case'layoutsubtotallocation':break;case'layoutcompactrow':break;case'position':break;case'pivotitem':break;case'datatype':break;case'datafield':break;case'sourcename':break;case'parentfield':break;case'ptlineitems':break;case'ptlineitem':break;case'countofsameitems':break;case'item':break;case'itemtype':break;case'ptsource':break;case'cacheindex':break;case'consolidationreference':break;case'filename':break;case'reference':break;case'nocolumngrand':break;case'norowgrand':break;case'blanklineafteritems':break;case'hidden':break;case'subtotal':break;case'basefield':break;case'mapchilditems':break;case'function':break;case'refreshonfileopen':break;case'printsettitles':break;case'mergelabels':break;case'defaultversion':break;case'refreshname':break;case'refreshdate':break;case'refreshdatecopy':break;case'versionlastrefresh':break;case'versionlastupdate':break;case'versionupdateablemin':break;case'versionrefreshablemin':break;case'calculation':break;default:seen=false;}break;case'pagebreaks':switch(Rn[3]){case'colbreaks':break;case'colbreak':break;case'rowbreaks':break;case'rowbreak':break;case'colstart':break;case'colend':break;case'rowend':break;default:seen=false;}break;case'autofilter':switch(Rn[3]){case'autofiltercolumn':break;case'autofiltercondition':break;case'autofilterand':break;case'autofilteror':break;default:seen=false;}break;case'querytable':switch(Rn[3]){case'id':break;case'autoformatfont':break;case'autoformatpattern':break;case'querysource':break;case'querytype':break;case'enableredirections':break;case'refreshedinxl9':break;case'urlstring':break;case'htmltables':break;case'connection':break;case'commandtext':break;case'refreshinfo':break;case'notitles':break;case'nextid':break;case'columninfo':break;case'overwritecells':break;case'donotpromptforfile':break;case'textwizardsettings':break;case'source':break;case'number':break;case'decimal':break;case'thousandseparator':break;case'trailingminusnumbers':break;case'formatsettings':break;case'fieldtype':break;case'delimiters':break;case'tab':break;case'comma':break;case'autoformatname':break;case'versionlastedit':break;case'versionlastrefresh':break;default:seen=false;}break;case'datavalidation':switch(Rn[3]){case'range':break;case'type':break;case'min':break;case'max':break;case'sort':break;case'descending':break;case'order':break;case'casesensitive':break;case'value':break;case'errorstyle':break;case'errormessage':break;case'errortitle':break;case'inputmessage':break;case'inputtitle':break;case'combohide':break;case'inputhide':break;case'condition':break;case'qualifier':break;case'useblank':break;case'value1':break;case'value2':break;case'format':break;case'cellrangelist':break;default:seen=false;}break;case'sorting':case'conditionalformatting':switch(Rn[3]){case'range':break;case'type':break;case'min':break;case'max':break;case'sort':break;case'descending':break;case'order':break;case'casesensitive':break;case'value':break;case'errorstyle':break;case'errormessage':break;case'errortitle':break;case'cellrangelist':break;case'inputmessage':break;case'inputtitle':break;case'combohide':break;case'inputhide':break;case'condition':break;case'qualifier':break;case'useblank':break;case'value1':break;case'value2':break;case'format':break;default:seen=false;}break;case'mapinfo':case'schema':case'data':switch(Rn[3]){case'map':break;case'entry':break;case'range':break;case'xpath':break;case'field':break;case'xsdtype':break;case'filteron':break;case'aggregate':break;case'elementtype':break;case'attributetype':break;case'schema':case'element':case'complextype':case'datatype':case'all':case'attribute':case'extends':break;case'row':break;default:seen=false;}break;case'smarttags':break;default:seen=false;break;}if(seen)break;if(Rn[3].match(/!\[CDATA/))break;if(!state[state.length-1][1])throw'Unrecognized tag: '+Rn[3]+"|"+state.join("|");if(state[state.length-1][0]==='customdocumentproperties'){if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_custprop(Custprops,raw_Rn3,cp,str.slice(pidx,Rn.index));else{cp=Rn;pidx=Rn.index+Rn[0].length;}break;}if(opts.WTF)throw'Unrecognized tag: '+Rn[3]+"|"+state.join("|");}}var out={};if(!opts.bookSheets&&!opts.bookProps)out.Sheets=sheets;out.SheetNames=sheetnames;out.Workbook=Workbook;out.SSF=dup(table_fmt);out.Props=Props;out.Custprops=Custprops;return out;}function parse_xlml(data,opts){fix_read_opts(opts=opts||{});switch(opts.type||"base64"){case"base64":return parse_xlml_xml(Base64_decode(data),opts);case"binary":case"buffer":case"file":return parse_xlml_xml(data,opts);case"array":return parse_xlml_xml(a2s(data),opts);}}function write_props_xlml(wb,opts){var o=[];if(wb.Props)o.push(xlml_write_docprops(wb.Props,opts));if(wb.Custprops)o.push(xlml_write_custprops(wb.Props,wb.Custprops,opts));return o.join("");}function write_wb_xlml(){return"";}function write_sty_xlml(wb,opts){var styles=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];opts.cellXfs.forEach(function(xf,id){var payload=[];payload.push(writextag('NumberFormat',null,{"ss:Format":escapexml(table_fmt[xf.numFmtId])}));var o={"ss:ID":"s"+(21+id)};styles.push(writextag('Style',payload.join(""),o));});return writextag("Styles",styles.join(""));}function write_name_xlml(n){return writextag("NamedRange",null,{"ss:Name":n.Name,"ss:RefersTo":"="+a1_to_rc(n.Ref,{r:0,c:0})});}function write_names_xlml(wb){if(!((wb||{}).Workbook||{}).Names)return"";var names=wb.Workbook.Names;var out=[];for(var i=0;i<names.length;++i){var n=names[i];if(n.Sheet!=null)continue;if(n.Name.match(/^_xlfn\./))continue;out.push(write_name_xlml(n));}return writextag("Names",out.join(""));}function write_ws_xlml_names(ws,opts,idx,wb){if(!ws)return"";if(!((wb||{}).Workbook||{}).Names)return"";var names=wb.Workbook.Names;var out=[];for(var i=0;i<names.length;++i){var n=names[i];if(n.Sheet!=idx)continue;if(n.Name.match(/^_xlfn\./))continue;out.push(write_name_xlml(n));}return out.join("");}function write_ws_xlml_wsopts(ws,opts,idx,wb){if(!ws)return"";var o=[];if(ws['!margins']){o.push("<PageSetup>");if(ws['!margins'].header)o.push(writextag("Header",null,{'x:Margin':ws['!margins'].header}));if(ws['!margins'].footer)o.push(writextag("Footer",null,{'x:Margin':ws['!margins'].footer}));o.push(writextag("PageMargins",null,{'x:Bottom':ws['!margins'].bottom||"0.75",'x:Left':ws['!margins'].left||"0.7",'x:Right':ws['!margins'].right||"0.7",'x:Top':ws['!margins'].top||"0.75"}));o.push("</PageSetup>");}if(wb&&wb.Workbook&&wb.Workbook.Sheets&&wb.Workbook.Sheets[idx]){if(wb.Workbook.Sheets[idx].Hidden)o.push(writextag("Visible",wb.Workbook.Sheets[idx].Hidden==1?"SheetHidden":"SheetVeryHidden",{}));else{for(var i=0;i<idx;++i){if(wb.Workbook.Sheets[i]&&!wb.Workbook.Sheets[i].Hidden)break;}if(i==idx)o.push("<Selected/>");}}if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL)o.push("<DisplayRightToLeft/>");if(ws['!protect']){o.push(writetag("ProtectContents","True"));if(ws['!protect'].objects)o.push(writetag("ProtectObjects","True"));if(ws['!protect'].scenarios)o.push(writetag("ProtectScenarios","True"));if(ws['!protect'].selectLockedCells!=null&&!ws['!protect'].selectLockedCells)o.push(writetag("EnableSelection","NoSelection"));else if(ws['!protect'].selectUnlockedCells!=null&&!ws['!protect'].selectUnlockedCells)o.push(writetag("EnableSelection","UnlockedCells"));[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(x){if(ws['!protect'][x[0]])o.push("<"+x[1]+"/>");});}if(o.length==0)return"";return writextag("WorksheetOptions",o.join(""),{xmlns:XLMLNS.x});}function write_ws_xlml_comment(comments){return comments.map(function(c){var t=xlml_unfixstr(c.t||"");var d=writextag("ss:Data",t,{"xmlns":"http://www.w3.org/TR/REC-html40"});return writextag("Comment",d,{"ss:Author":c.a});}).join("");}function write_ws_xlml_cell(cell,ref,ws,opts,idx,wb,addr){if(!cell||cell.v==undefined&&cell.f==undefined)return"";var attr={};if(cell.f)attr["ss:Formula"]="="+escapexml(a1_to_rc(cell.f,addr));if(cell.F&&cell.F.slice(0,ref.length)==ref){var end=decode_cell(cell.F.slice(ref.length+1));attr["ss:ArrayRange"]="RC:R"+(end.r==addr.r?"":"["+(end.r-addr.r)+"]")+"C"+(end.c==addr.c?"":"["+(end.c-addr.c)+"]");}if(cell.l&&cell.l.Target){attr["ss:HRef"]=escapexml(cell.l.Target);if(cell.l.Tooltip)attr["x:HRefScreenTip"]=escapexml(cell.l.Tooltip);}if(ws['!merges']){var marr=ws['!merges'];for(var mi=0;mi!=marr.length;++mi){if(marr[mi].s.c!=addr.c||marr[mi].s.r!=addr.r)continue;if(marr[mi].e.c>marr[mi].s.c)attr['ss:MergeAcross']=marr[mi].e.c-marr[mi].s.c;if(marr[mi].e.r>marr[mi].s.r)attr['ss:MergeDown']=marr[mi].e.r-marr[mi].s.r;}}var t="",p="";switch(cell.t){case'z':if(!opts.sheetStubs)return"";break;case'n':t='Number';p=String(cell.v);break;case'b':t='Boolean';p=cell.v?"1":"0";break;case'e':t='Error';p=BErr[cell.v];break;case'd':t='DateTime';p=new Date(cell.v).toISOString();if(cell.z==null)cell.z=cell.z||table_fmt[14];break;case's':t='String';p=escapexlml(cell.v||"");break;}var os=get_cell_style(opts.cellXfs,cell,opts);attr["ss:StyleID"]="s"+(21+os);attr["ss:Index"]=addr.c+1;var _v=cell.v!=null?p:"";var m=cell.t=='z'?"":'<Data ss:Type="'+t+'">'+_v+'</Data>';if((cell.c||[]).length>0)m+=write_ws_xlml_comment(cell.c);return writextag("Cell",m,attr);}function write_ws_xlml_row(R,row){var o='<Row ss:Index="'+(R+1)+'"';if(row){if(row.hpt&&!row.hpx)row.hpx=pt2px(row.hpt);if(row.hpx)o+=' ss:AutoFitHeight="0" ss:Height="'+row.hpx+'"';if(row.hidden)o+=' ss:Hidden="1"';}return o+'>';}function write_ws_xlml_table(ws,opts,idx,wb){if(!ws['!ref'])return"";var range=safe_decode_range(ws['!ref']);var marr=ws['!merges']||[],mi=0;var o=[];if(ws['!cols'])ws['!cols'].forEach(function(n,i){process_col(n);var w=!!n.width;var p=col_obj_w(i,n);var k={"ss:Index":i+1};if(w)k['ss:Width']=width2px(p.width);if(n.hidden)k['ss:Hidden']="1";o.push(writextag("Column",null,k));});var dense=Array.isArray(ws);for(var R=range.s.r;R<=range.e.r;++R){var row=[write_ws_xlml_row(R,(ws['!rows']||[])[R])];for(var C=range.s.c;C<=range.e.c;++C){var skip=false;for(mi=0;mi!=marr.length;++mi){if(marr[mi].s.c>C)continue;if(marr[mi].s.r>R)continue;if(marr[mi].e.c<C)continue;if(marr[mi].e.r<R)continue;if(marr[mi].s.c!=C||marr[mi].s.r!=R)skip=true;break;}if(skip)continue;var addr={r:R,c:C};var ref=encode_cell(addr),cell=dense?(ws[R]||[])[C]:ws[ref];row.push(write_ws_xlml_cell(cell,ref,ws,opts,idx,wb,addr));}row.push("</Row>");if(row.length>2)o.push(row.join(""));}return o.join("");}function write_ws_xlml(idx,opts,wb){var o=[];var s=wb.SheetNames[idx];var ws=wb.Sheets[s];var t=ws?write_ws_xlml_names(ws,opts,idx,wb):"";if(t.length>0)o.push("<Names>"+t+"</Names>");t=ws?write_ws_xlml_table(ws,opts,idx,wb):"";if(t.length>0)o.push("<Table>"+t+"</Table>");o.push(write_ws_xlml_wsopts(ws,opts,idx,wb));return o.join("");}function write_xlml(wb,opts){if(!opts)opts={};if(!wb.SSF)wb.SSF=dup(table_fmt);if(wb.SSF){make_ssf();SSF_load_table(wb.SSF);opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});}var d=[];d.push(write_props_xlml(wb,opts));d.push(write_wb_xlml(wb,opts));d.push("");d.push("");for(var i=0;i<wb.SheetNames.length;++i){d.push(writextag("Worksheet",write_ws_xlml(i,opts,wb),{"ss:Name":escapexml(wb.SheetNames[i])}));}d[2]=write_sty_xlml(wb,opts);d[3]=write_names_xlml(wb,opts);return XML_HEADER+writextag("Workbook",d.join(""),{'xmlns':XLMLNS.ss,'xmlns:o':XLMLNS.o,'xmlns:x':XLMLNS.x,'xmlns:ss':XLMLNS.ss,'xmlns:dt':XLMLNS.dt,'xmlns:html':XLMLNS.html});}function parse_compobj(obj){var v={};var o=obj.content;o.l=28;v.AnsiUserType=o.read_shift(0,"lpstr-ansi");v.AnsiClipboardFormat=parse_ClipboardFormatOrAnsiString(o);if(o.length-o.l<=4)return v;var m=o.read_shift(4);if(m==0||m>40)return v;o.l-=4;v.Reserved1=o.read_shift(0,"lpstr-ansi");if(o.length-o.l<=4)return v;m=o.read_shift(4);if(m!==0x71b239f4)return v;v.UnicodeClipboardFormat=parse_ClipboardFormatOrUnicodeString(o);m=o.read_shift(4);if(m==0||m>40)return v;o.l-=4;v.Reserved2=o.read_shift(0,"lpwstr");}var CONTINUE_RT=[0x003c,0x043c,0x0812,0x0875,0x087f];function slurp(RecordType,R,blob,length,opts){var l=length;var bufs=[];var d=blob.slice(blob.l,blob.l+l);if(opts&&opts.enc&&opts.enc.insitu&&d.length>0)switch(RecordType){case 0x0009:case 0x0209:case 0x0409:case 0x0809:case 0x002f:case 0x0195:case 0x00e1:case 0x0196:case 0x0138:case 0x0194:case 0x000a:break;case 0x0085:break;default:opts.enc.insitu(d);}bufs.push(d);blob.l+=l;var nextrt=__readUInt16LE(blob,blob.l),next=XLSRecordEnum[nextrt];var start=0;while(next!=null&&CONTINUE_RT.indexOf(nextrt)>-1){l=__readUInt16LE(blob,blob.l+2);start=blob.l+4;if(nextrt==0x0812)start+=4;else if(nextrt==0x0875||nextrt==0x087f){start+=12;}d=blob.slice(start,blob.l+4+l);bufs.push(d);blob.l+=4+l;next=XLSRecordEnum[nextrt=__readUInt16LE(blob,blob.l)];}var b=bconcat(bufs);prep_blob(b,0);var ll=0;b.lens=[];for(var j=0;j<bufs.length;++j){b.lens.push(ll);ll+=bufs[j].length;}if(b.length<length)throw"XLS Record 0x"+RecordType.toString(16)+" Truncated: "+b.length+" < "+length;return R.f(b,b.length,opts);}function safe_format_xf(p,opts,date1904){if(p.t==='z')return;if(!p.XF)return;var fmtid=0;try{fmtid=p.z||p.XF.numFmtId||0;if(opts.cellNF)p.z=table_fmt[fmtid];}catch(e){if(opts.WTF)throw e;}if(!opts||opts.cellText!==false)try{if(p.t==='e'){p.w=p.w||BErr[p.v];}else if(fmtid===0||fmtid=="General"){if(p.t==='n'){if((p.v|0)===p.v)p.w=p.v.toString(10);else p.w=SSF_general_num(p.v);}else p.w=SSF_general(p.v);}else p.w=SSF_format(fmtid,p.v,{date1904:!!date1904,dateNF:opts&&opts.dateNF});}catch(e){if(opts.WTF)throw e;}if(opts.cellDates&&fmtid&&p.t=='n'&&fmt_is_date(table_fmt[fmtid]||String(fmtid))){var _d=SSF_parse_date_code(p.v);if(_d){p.t='d';p.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}}function make_cell(val,ixfe,t){return{v:val,ixfe:ixfe,t:t};}function parse_workbook(blob,options){var wb={opts:{}};var Sheets={};if(DENSE!=null&&options.dense==null)options.dense=DENSE;var out=options.dense?[]:{};var Directory={};var range={};var last_formula=null;var sst=[];var cur_sheet="";var Preamble={};var lastcell,last_cell="",cc,cmnt,rngC,rngR;var sharedf={};var arrayf=[];var temp_val;var country;var XFs=[];var palette=[];var Workbook={Sheets:[],WBProps:{date1904:false},Views:[{}]},wsprops={};var get_rgb=function getrgb(icv){if(icv<8)return XLSIcv[icv];if(icv<64)return palette[icv-8]||XLSIcv[icv];return XLSIcv[icv];};var process_cell_style=function pcs(cell,line,options){var xfd=line.XF.data;if(!xfd||!xfd.patternType||!options||!options.cellStyles)return;line.s={};line.s.patternType=xfd.patternType;var t;if(t=rgb2Hex(get_rgb(xfd.icvFore))){line.s.fgColor={rgb:t};}if(t=rgb2Hex(get_rgb(xfd.icvBack))){line.s.bgColor={rgb:t};}};var addcell=function addcell(cell,line,options){if(file_depth>1)return;if(options.sheetRows&&cell.r>=options.sheetRows)return;if(options.cellStyles&&line.XF&&line.XF.data)process_cell_style(cell,line,options);delete line.ixfe;delete line.XF;lastcell=cell;last_cell=encode_cell(cell);if(!range||!range.s||!range.e)range={s:{r:0,c:0},e:{r:0,c:0}};if(cell.r<range.s.r)range.s.r=cell.r;if(cell.c<range.s.c)range.s.c=cell.c;if(cell.r+1>range.e.r)range.e.r=cell.r+1;if(cell.c+1>range.e.c)range.e.c=cell.c+1;if(options.cellFormula&&line.f){for(var afi=0;afi<arrayf.length;++afi){if(arrayf[afi][0].s.c>cell.c||arrayf[afi][0].s.r>cell.r)continue;if(arrayf[afi][0].e.c<cell.c||arrayf[afi][0].e.r<cell.r)continue;line.F=encode_range(arrayf[afi][0]);if(arrayf[afi][0].s.c!=cell.c||arrayf[afi][0].s.r!=cell.r)delete line.f;if(line.f)line.f=""+stringify_formula(arrayf[afi][1],range,cell,supbooks,opts);break;}}{if(options.dense){if(!out[cell.r])out[cell.r]=[];out[cell.r][cell.c]=line;}else out[last_cell]=line;}};var opts={enc:false,sbcch:0,snames:[],sharedf:sharedf,arrayf:arrayf,rrtabid:[],lastuser:"",biff:8,codepage:0,winlocked:0,cellStyles:!!options&&!!options.cellStyles,WTF:!!options&&!!options.wtf};if(options.password)opts.password=options.password;var themes;var merges=[];var objects=[];var colinfo=[],rowinfo=[];var seencol=false;var supbooks=[];supbooks.SheetNames=opts.snames;supbooks.sharedf=opts.sharedf;supbooks.arrayf=opts.arrayf;supbooks.names=[];supbooks.XTI=[];var last_RT=0;var file_depth=0;var BIFF2Fmt=0,BIFF2FmtTable=[];var FilterDatabases=[];var last_lbl;opts.codepage=1200;set_cp(1200);var seen_codepage=false;while(blob.l<blob.length-1){var s=blob.l;var RecordType=blob.read_shift(2);if(RecordType===0&&last_RT===0x000a)break;var length=blob.l===blob.length?0:blob.read_shift(2);var R=XLSRecordEnum[RecordType];if(R&&R.f){if(options.bookSheets){if(last_RT===0x0085&&RecordType!==0x0085)break;}last_RT=RecordType;if(R.r===2||R.r==12){var rt=blob.read_shift(2);length-=2;if(!opts.enc&&rt!==RecordType&&((rt&0xFF)<<8|rt>>8)!==RecordType)throw new Error("rt mismatch: "+rt+"!="+RecordType);if(R.r==12){blob.l+=10;length-=10;}}var val={};if(RecordType===0x000a)val=R.f(blob,length,opts);else val=slurp(RecordType,R,blob,length,opts);if(file_depth==0&&[0x0009,0x0209,0x0409,0x0809].indexOf(last_RT)===-1)continue;switch(RecordType){case 0x0022:wb.opts.Date1904=Workbook.WBProps.date1904=val;break;case 0x0086:wb.opts.WriteProtect=true;break;case 0x002f:if(!opts.enc)blob.l=0;opts.enc=val;if(!options.password)throw new Error("File is password-protected");if(val.valid==null)throw new Error("Encryption scheme unsupported");if(!val.valid)throw new Error("Password is incorrect");break;case 0x005c:opts.lastuser=val;break;case 0x0042:var cpval=Number(val);switch(cpval){case 0x5212:cpval=1200;break;case 0x8000:cpval=10000;break;case 0x8001:cpval=1252;break;}set_cp(opts.codepage=cpval);seen_codepage=true;break;case 0x013d:opts.rrtabid=val;break;case 0x0019:opts.winlocked=val;break;case 0x01b7:wb.opts["RefreshAll"]=val;break;case 0x000c:wb.opts["CalcCount"]=val;break;case 0x0010:wb.opts["CalcDelta"]=val;break;case 0x0011:wb.opts["CalcIter"]=val;break;case 0x000d:wb.opts["CalcMode"]=val;break;case 0x000e:wb.opts["CalcPrecision"]=val;break;case 0x005f:wb.opts["CalcSaveRecalc"]=val;break;case 0x000f:opts.CalcRefMode=val;break;case 0x08a3:wb.opts.FullCalc=val;break;case 0x0081:if(val.fDialog)out["!type"]="dialog";if(!val.fBelow)(out["!outline"]||(out["!outline"]={})).above=true;if(!val.fRight)(out["!outline"]||(out["!outline"]={})).left=true;break;case 0x00e0:XFs.push(val);break;case 0x01ae:supbooks.push([val]);supbooks[supbooks.length-1].XTI=[];break;case 0x0023:case 0x0223:supbooks[supbooks.length-1].push(val);break;case 0x0018:case 0x0218:last_lbl={Name:val.Name,Ref:stringify_formula(val.rgce,range,null,supbooks,opts)};if(val.itab>0)last_lbl.Sheet=val.itab-1;supbooks.names.push(last_lbl);if(!supbooks[0]){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].push(val);if(val.Name=="_xlnm._FilterDatabase"&&val.itab>0)if(val.rgce&&val.rgce[0]&&val.rgce[0][0]&&val.rgce[0][0][0]=='PtgArea3d')FilterDatabases[val.itab-1]={ref:encode_range(val.rgce[0][0][1][2])};break;case 0x0016:opts.ExternCount=val;break;case 0x0017:if(supbooks.length==0){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].XTI=supbooks[supbooks.length-1].XTI.concat(val);supbooks.XTI=supbooks.XTI.concat(val);break;case 0x0894:if(opts.biff<8)break;if(last_lbl!=null)last_lbl.Comment=val[1];break;case 0x0012:out["!protect"]=val;break;case 0x0013:if(val!==0&&opts.WTF)console.error("Password verifier: "+val);break;case 0x0085:{Directory[val.pos]=val;opts.snames.push(val.name);}break;case 0x000a:{if(--file_depth)break;if(range.e){if(range.e.r>0&&range.e.c>0){range.e.r--;range.e.c--;out["!ref"]=encode_range(range);if(options.sheetRows&&options.sheetRows<=range.e.r){var tmpri=range.e.r;range.e.r=options.sheetRows-1;out["!fullref"]=out["!ref"];out["!ref"]=encode_range(range);range.e.r=tmpri;}range.e.r++;range.e.c++;}if(merges.length>0)out["!merges"]=merges;if(objects.length>0)out["!objects"]=objects;if(colinfo.length>0)out["!cols"]=colinfo;if(rowinfo.length>0)out["!rows"]=rowinfo;Workbook.Sheets.push(wsprops);}if(cur_sheet==="")Preamble=out;else Sheets[cur_sheet]=out;out=options.dense?[]:{};}break;case 0x0009:case 0x0209:case 0x0409:case 0x0809:{if(opts.biff===8)opts.biff={0x0009:2,0x0209:3,0x0409:4}[RecordType]||{0x0200:2,0x0300:3,0x0400:4,0x0500:5,0x0600:8,0x0002:2,0x0007:2}[val.BIFFVer]||8;opts.biffguess=val.BIFFVer==0;if(val.BIFFVer==0&&val.dt==0x1000){opts.biff=5;seen_codepage=true;set_cp(opts.codepage=28591);}if(opts.biff==8&&val.BIFFVer==0&&val.dt==16)opts.biff=2;if(file_depth++)break;out=options.dense?[]:{};if(opts.biff<8&&!seen_codepage){seen_codepage=true;set_cp(opts.codepage=options.codepage||1252);}if(opts.biff<5||val.BIFFVer==0&&val.dt==0x1000){if(cur_sheet==="")cur_sheet="Sheet1";range={s:{r:0,c:0},e:{r:0,c:0}};var fakebs8={pos:blob.l-length,name:cur_sheet};Directory[fakebs8.pos]=fakebs8;opts.snames.push(cur_sheet);}else cur_sheet=(Directory[s]||{name:""}).name;if(val.dt==0x20)out["!type"]="chart";if(val.dt==0x40)out["!type"]="macro";merges=[];objects=[];opts.arrayf=arrayf=[];colinfo=[];rowinfo=[];seencol=false;wsprops={Hidden:(Directory[s]||{hs:0}).hs,name:cur_sheet};}break;case 0x0203:case 0x0003:case 0x0002:{if(out["!type"]=="chart")if(options.dense?(out[val.r]||[])[val.c]:out[encode_cell({c:val.c,r:val.r})])++val.c;temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe]||{},v:val.val,t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case 0x0005:case 0x0205:{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.val,t:val.t};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case 0x027e:{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.rknum,t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case 0x00bd:{for(var j=val.c;j<=val.C;++j){var ixfe=val.rkrec[j-val.c][0];temp_val={ixfe:ixfe,XF:XFs[ixfe],v:val.rkrec[j-val.c][1],t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:j,r:val.r},temp_val,options);}}break;case 0x0006:case 0x0206:case 0x0406:{if(val.val=='String'){last_formula=val;break;}temp_val=make_cell(val.val,val.cell.ixfe,val.tt);temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula){var _f=val.formula;if(_f&&_f[0]&&_f[0][0]&&_f[0][0][0]=='PtgExp'){var _fr=_f[0][0][1][0],_fc=_f[0][0][1][1];var _fe=encode_cell({r:_fr,c:_fc});if(sharedf[_fe])temp_val.f=""+stringify_formula(val.formula,range,val.cell,supbooks,opts);else temp_val.F=((options.dense?(out[_fr]||[])[_fc]:out[_fe])||{}).F;}else temp_val.f=""+stringify_formula(val.formula,range,val.cell,supbooks,opts);}if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(val.cell,temp_val,options);last_formula=val;}break;case 0x0007:case 0x0207:{if(last_formula){last_formula.val=val;temp_val=make_cell(val,last_formula.cell.ixfe,'s');temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula){temp_val.f=""+stringify_formula(last_formula.formula,range,last_formula.cell,supbooks,opts);}if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(last_formula.cell,temp_val,options);last_formula=null;}else throw new Error("String record expects Formula");}break;case 0x0021:case 0x0221:{arrayf.push(val);var _arraystart=encode_cell(val[0].s);cc=options.dense?(out[val[0].s.r]||[])[val[0].s.c]:out[_arraystart];if(options.cellFormula&&cc){if(!last_formula)break;if(!_arraystart||!cc)break;cc.f=""+stringify_formula(val[1],range,val[0],supbooks,opts);cc.F=encode_range(val[0]);}}break;case 0x04bc:{if(!options.cellFormula)break;if(last_cell){if(!last_formula)break;sharedf[encode_cell(last_formula.cell)]=val[0];cc=options.dense?(out[last_formula.cell.r]||[])[last_formula.cell.c]:out[encode_cell(last_formula.cell)];(cc||{}).f=""+stringify_formula(val[0],range,lastcell,supbooks,opts);}}break;case 0x00fd:temp_val=make_cell(sst[val.isst].t,val.ixfe,'s');if(sst[val.isst].h)temp_val.h=sst[val.isst].h;temp_val.XF=XFs[temp_val.ixfe];if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case 0x0201:if(options.sheetStubs){temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],t:'z'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case 0x00be:if(options.sheetStubs){for(var _j=val.c;_j<=val.C;++_j){var _ixfe=val.ixfe[_j-val.c];temp_val={ixfe:_ixfe,XF:XFs[_ixfe],t:'z'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:_j,r:val.r},temp_val,options);}}break;case 0x00d6:case 0x0204:case 0x0004:temp_val=make_cell(val.val,val.ixfe,'s');temp_val.XF=XFs[temp_val.ixfe];if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case 0x0000:case 0x0200:{if(file_depth===1)range=val;}break;case 0x00fc:{sst=val;}break;case 0x041e:{if(opts.biff==4){BIFF2FmtTable[BIFF2Fmt++]=val[1];for(var b4idx=0;b4idx<BIFF2Fmt+163;++b4idx){if(table_fmt[b4idx]==val[1])break;}if(b4idx>=163)SSF_load(val[1],BIFF2Fmt+163);}else SSF_load(val[1],val[0]);}break;case 0x001e:{BIFF2FmtTable[BIFF2Fmt++]=val;for(var b2idx=0;b2idx<BIFF2Fmt+163;++b2idx){if(table_fmt[b2idx]==val)break;}if(b2idx>=163)SSF_load(val,BIFF2Fmt+163);}break;case 0x00e5:merges=merges.concat(val);break;case 0x005d:objects[val.cmo[0]]=opts.lastobj=val;break;case 0x01b6:opts.lastobj.TxO=val;break;case 0x007f:opts.lastobj.ImData=val;break;case 0x01b8:{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR){for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC){cc=options.dense?(out[rngR]||[])[rngC]:out[encode_cell({c:rngC,r:rngR})];if(cc)cc.l=val[1];}}}break;case 0x0800:{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR){for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC){cc=options.dense?(out[rngR]||[])[rngC]:out[encode_cell({c:rngC,r:rngR})];if(cc&&cc.l)cc.l.Tooltip=val[1];}}}break;case 0x001c:{if(opts.biff<=5&&opts.biff>=2)break;cc=options.dense?(out[val[0].r]||[])[val[0].c]:out[encode_cell(val[0])];var noteobj=objects[val[2]];if(!cc){if(options.dense){if(!out[val[0].r])out[val[0].r]=[];cc=out[val[0].r][val[0].c]={t:"z"};}else{cc=out[encode_cell(val[0])]={t:"z"};}range.e.r=Math.max(range.e.r,val[0].r);range.s.r=Math.min(range.s.r,val[0].r);range.e.c=Math.max(range.e.c,val[0].c);range.s.c=Math.min(range.s.c,val[0].c);}if(!cc.c)cc.c=[];cmnt={a:val[1],t:noteobj.TxO.t};cc.c.push(cmnt);}break;case 0x087d:update_xfext(XFs[val.ixfe],val.ext);break;case 0x007d:{if(!opts.cellStyles)break;while(val.e>=val.s){colinfo[val.e--]={width:val.w/256,level:val.level||0,hidden:!!(val.flags&1)};if(!seencol){seencol=true;find_mdw_colw(val.w/256);}process_col(colinfo[val.e+1]);}}break;case 0x0208:{var rowobj={};if(val.level!=null){rowinfo[val.r]=rowobj;rowobj.level=val.level;}if(val.hidden){rowinfo[val.r]=rowobj;rowobj.hidden=true;}if(val.hpt){rowinfo[val.r]=rowobj;rowobj.hpt=val.hpt;rowobj.hpx=pt2px(val.hpt);}}break;case 0x0026:case 0x0027:case 0x0028:case 0x0029:if(!out['!margins'])default_margins(out['!margins']={});out['!margins'][{0x26:"left",0x27:"right",0x28:"top",0x29:"bottom"}[RecordType]]=val;break;case 0x00a1:if(!out['!margins'])default_margins(out['!margins']={});out['!margins'].header=val.header;out['!margins'].footer=val.footer;break;case 0x023e:if(val.RTL)Workbook.Views[0].RTL=true;break;case 0x0092:palette=val;break;case 0x0896:themes=val;break;case 0x008c:country=val;break;case 0x01ba:{if(!cur_sheet)Workbook.WBProps.CodeName=val||"ThisWorkbook";else wsprops.CodeName=val||wsprops.name;}break;}}else{if(!R)console.error("Missing Info for XLS Record 0x"+RecordType.toString(16));blob.l+=length;}}wb.SheetNames=keys(Directory).sort(function(a,b){return Number(a)-Number(b);}).map(function(x){return Directory[x].name;});if(!options.bookSheets)wb.Sheets=Sheets;if(!wb.SheetNames.length&&Preamble["!ref"]){wb.SheetNames.push("Sheet1");if(wb.Sheets)wb.Sheets["Sheet1"]=Preamble;}else wb.Preamble=Preamble;if(wb.Sheets)FilterDatabases.forEach(function(r,i){wb.Sheets[wb.SheetNames[i]]['!autofilter']=r;});wb.Strings=sst;wb.SSF=dup(table_fmt);if(opts.enc)wb.Encryption=opts.enc;if(themes)wb.Themes=themes;wb.Metadata={};if(country!==undefined)wb.Metadata.Country=country;if(supbooks.names.length>0)Workbook.Names=supbooks.names;wb.Workbook=Workbook;return wb;}var PSCLSID={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function parse_xls_props(cfb,props,o){var DSI=CFB.find(cfb,'/!DocumentSummaryInformation');if(DSI&&DSI.size>0)try{var DocSummary=parse_PropertySetStream(DSI,DocSummaryPIDDSI,PSCLSID.DSI);for(var d in DocSummary){props[d]=DocSummary[d];}}catch(e){if(o.WTF)throw e;}var SI=CFB.find(cfb,'/!SummaryInformation');if(SI&&SI.size>0)try{var Summary=parse_PropertySetStream(SI,SummaryPIDSI,PSCLSID.SI);for(var s in Summary){if(props[s]==null)props[s]=Summary[s];}}catch(e){if(o.WTF)throw e;}if(props.HeadingPairs&&props.TitlesOfParts){load_props_pairs(props.HeadingPairs,props.TitlesOfParts,props,o);delete props.HeadingPairs;delete props.TitlesOfParts;}}function write_xls_props(wb,cfb){var DSEntries=[],SEntries=[],CEntries=[];var i=0,Keys;var DocSummaryRE=evert_key(DocSummaryPIDDSI,"n");var SummaryRE=evert_key(SummaryPIDSI,"n");if(wb.Props){Keys=keys(wb.Props);for(i=0;i<Keys.length;++i){(Object.prototype.hasOwnProperty.call(DocSummaryRE,Keys[i])?DSEntries:Object.prototype.hasOwnProperty.call(SummaryRE,Keys[i])?SEntries:CEntries).push([Keys[i],wb.Props[Keys[i]]]);}}if(wb.Custprops){Keys=keys(wb.Custprops);for(i=0;i<Keys.length;++i){if(!Object.prototype.hasOwnProperty.call(wb.Props||{},Keys[i]))(Object.prototype.hasOwnProperty.call(DocSummaryRE,Keys[i])?DSEntries:Object.prototype.hasOwnProperty.call(SummaryRE,Keys[i])?SEntries:CEntries).push([Keys[i],wb.Custprops[Keys[i]]]);}}var CEntries2=[];for(i=0;i<CEntries.length;++i){if(XLSPSSkip.indexOf(CEntries[i][0])>-1||PseudoPropsPairs.indexOf(CEntries[i][0])>-1)continue;if(CEntries[i][1]==null)continue;CEntries2.push(CEntries[i]);}if(SEntries.length)CFB.utils.cfb_add(cfb,"/\x05SummaryInformation",write_PropertySetStream(SEntries,PSCLSID.SI,SummaryRE,SummaryPIDSI));if(DSEntries.length||CEntries2.length)CFB.utils.cfb_add(cfb,"/\x05DocumentSummaryInformation",write_PropertySetStream(DSEntries,PSCLSID.DSI,DocSummaryRE,DocSummaryPIDDSI,CEntries2.length?CEntries2:null,PSCLSID.UDI));}function parse_xlscfb(cfb,options){if(!options)options={};fix_read_opts(options);reset_cp();if(options.codepage)set_ansi(options.codepage);var CompObj,WB;if(cfb.FullPaths){if(CFB.find(cfb,'/encryption'))throw new Error("File is password-protected");CompObj=CFB.find(cfb,'!CompObj');WB=CFB.find(cfb,'/Workbook')||CFB.find(cfb,'/Book');}else{switch(options.type){case'base64':cfb=s2a(Base64_decode(cfb));break;case'binary':cfb=s2a(cfb);break;case'buffer':break;case'array':if(!Array.isArray(cfb))cfb=Array.prototype.slice.call(cfb);break;}prep_blob(cfb,0);WB={content:cfb};}var WorkbookP;var _data;if(CompObj)parse_compobj(CompObj);if(options.bookProps&&!options.bookSheets)WorkbookP={};else{var T=has_buf?'buffer':'array';if(WB&&WB.content)WorkbookP=parse_workbook(WB.content,options);else if((_data=CFB.find(cfb,'PerfectOffice_MAIN'))&&_data.content)WorkbookP=WK_.to_workbook(_data.content,(options.type=T,options));else if((_data=CFB.find(cfb,'NativeContent_MAIN'))&&_data.content)WorkbookP=WK_.to_workbook(_data.content,(options.type=T,options));else if((_data=CFB.find(cfb,'MN0'))&&_data.content)throw new Error("Unsupported Works 4 for Mac file");else throw new Error("Cannot find Workbook stream");if(options.bookVBA&&cfb.FullPaths&&CFB.find(cfb,'/_VBA_PROJECT_CUR/VBA/dir'))WorkbookP.vbaraw=make_vba_xls(cfb);}var props={};if(cfb.FullPaths)parse_xls_props(cfb,props,options);WorkbookP.Props=WorkbookP.Custprops=props;if(options.bookFiles)WorkbookP.cfb=cfb;return WorkbookP;}function write_xlscfb(wb,opts){var o=opts||{};var cfb=CFB.utils.cfb_new({root:"R"});var wbpath="/Workbook";switch(o.bookType||"xls"){case"xls":o.bookType="biff8";case"xla":if(!o.bookType)o.bookType="xla";case"biff8":wbpath="/Workbook";o.biff=8;break;case"biff5":wbpath="/Book";o.biff=5;break;default:throw new Error("invalid type "+o.bookType+" for XLS CFB");}CFB.utils.cfb_add(cfb,wbpath,write_biff_buf(wb,o));if(o.biff==8&&(wb.Props||wb.Custprops))write_xls_props(wb,cfb);if(o.biff==8&&wb.vbaraw)fill_vba_xls(cfb,CFB.read(wb.vbaraw,{type:typeof wb.vbaraw=="string"?"binary":"buffer"}));return cfb;}var XLSBRecordEnum={0x0000:{f:parse_BrtRowHdr},0x0001:{f:parse_BrtCellBlank},0x0002:{f:parse_BrtCellRk},0x0003:{f:parse_BrtCellError},0x0004:{f:parse_BrtCellBool},0x0005:{f:parse_BrtCellReal},0x0006:{f:parse_BrtCellSt},0x0007:{f:parse_BrtCellIsst},0x0008:{f:parse_BrtFmlaString},0x0009:{f:parse_BrtFmlaNum},0x000A:{f:parse_BrtFmlaBool},0x000B:{f:parse_BrtFmlaError},0x000C:{f:parse_BrtShortBlank},0x000D:{f:parse_BrtShortRk},0x000E:{f:parse_BrtShortError},0x000F:{f:parse_BrtShortBool},0x0010:{f:parse_BrtShortReal},0x0011:{f:parse_BrtShortSt},0x0012:{f:parse_BrtShortIsst},0x0013:{f:parse_RichStr},0x0014:{},0x0015:{},0x0016:{},0x0017:{},0x0018:{},0x0019:{},0x001A:{},0x001B:{},0x001C:{},0x001D:{},0x001E:{},0x001F:{},0x0020:{},0x0021:{},0x0022:{},0x0023:{T:1},0x0024:{T:-1},0x0025:{T:1},0x0026:{T:-1},0x0027:{f:parse_BrtName},0x0028:{},0x002A:{},0x002B:{f:parse_BrtFont},0x002C:{f:parse_BrtFmt},0x002D:{f:parse_BrtFill},0x002E:{f:parse_BrtBorder},0x002F:{f:parse_BrtXF},0x0030:{},0x0031:{f:parse_Int32LE},0x0032:{},0x0033:{f:parse_BrtMdb},0x0034:{T:1},0x0035:{T:-1},0x0036:{T:1},0x0037:{T:-1},0x0038:{T:1},0x0039:{T:-1},0x003A:{},0x003B:{},0x003C:{f:parse_ColInfo},0x003E:{f:parse_BrtCellRString},0x003F:{f:parse_BrtCalcChainItem$},0x0040:{f:parse_BrtDVal},0x0041:{},0x0042:{},0x0043:{},0x0044:{},0x0045:{},0x0046:{},0x0080:{},0x0081:{T:1},0x0082:{T:-1},0x0083:{T:1,f:parsenoop,p:0},0x0084:{T:-1},0x0085:{T:1},0x0086:{T:-1},0x0087:{T:1},0x0088:{T:-1},0x0089:{T:1,f:parse_BrtBeginWsView},0x008A:{T:-1},0x008B:{T:1},0x008C:{T:-1},0x008D:{T:1},0x008E:{T:-1},0x008F:{T:1},0x0090:{T:-1},0x0091:{T:1},0x0092:{T:-1},0x0093:{f:parse_BrtWsProp},0x0094:{f:parse_BrtWsDim,p:16},0x0097:{f:parse_BrtPane},0x0098:{},0x0099:{f:parse_BrtWbProp},0x009A:{},0x009B:{},0x009C:{f:parse_BrtBundleSh},0x009D:{},0x009E:{},0x009F:{T:1,f:parse_BrtBeginSst},0x00A0:{T:-1},0x00A1:{T:1,f:parse_UncheckedRfX},0x00A2:{T:-1},0x00A3:{T:1},0x00A4:{T:-1},0x00A5:{T:1},0x00A6:{T:-1},0x00A7:{},0x00A8:{},0x00A9:{},0x00AA:{},0x00AB:{},0x00AC:{T:1},0x00AD:{T:-1},0x00AE:{},0x00AF:{},0x00B0:{f:parse_BrtMergeCell},0x00B1:{T:1},0x00B2:{T:-1},0x00B3:{T:1},0x00B4:{T:-1},0x00B5:{T:1},0x00B6:{T:-1},0x00B7:{T:1},0x00B8:{T:-1},0x00B9:{T:1},0x00BA:{T:-1},0x00BB:{T:1},0x00BC:{T:-1},0x00BD:{T:1},0x00BE:{T:-1},0x00BF:{T:1},0x00C0:{T:-1},0x00C1:{T:1},0x00C2:{T:-1},0x00C3:{T:1},0x00C4:{T:-1},0x00C5:{T:1},0x00C6:{T:-1},0x00C7:{T:1},0x00C8:{T:-1},0x00C9:{T:1},0x00CA:{T:-1},0x00CB:{T:1},0x00CC:{T:-1},0x00CD:{T:1},0x00CE:{T:-1},0x00CF:{T:1},0x00D0:{T:-1},0x00D1:{T:1},0x00D2:{T:-1},0x00D3:{T:1},0x00D4:{T:-1},0x00D5:{T:1},0x00D6:{T:-1},0x00D7:{T:1},0x00D8:{T:-1},0x00D9:{T:1},0x00DA:{T:-1},0x00DB:{T:1},0x00DC:{T:-1},0x00DD:{T:1},0x00DE:{T:-1},0x00DF:{T:1},0x00E0:{T:-1},0x00E1:{T:1},0x00E2:{T:-1},0x00E3:{T:1},0x00E4:{T:-1},0x00E5:{T:1},0x00E6:{T:-1},0x00E7:{T:1},0x00E8:{T:-1},0x00E9:{T:1},0x00EA:{T:-1},0x00EB:{T:1},0x00EC:{T:-1},0x00ED:{T:1},0x00EE:{T:-1},0x00EF:{T:1},0x00F0:{T:-1},0x00F1:{T:1},0x00F2:{T:-1},0x00F3:{T:1},0x00F4:{T:-1},0x00F5:{T:1},0x00F6:{T:-1},0x00F7:{T:1},0x00F8:{T:-1},0x00F9:{T:1},0x00FA:{T:-1},0x00FB:{T:1},0x00FC:{T:-1},0x00FD:{T:1},0x00FE:{T:-1},0x00FF:{T:1},0x0100:{T:-1},0x0101:{T:1},0x0102:{T:-1},0x0103:{T:1},0x0104:{T:-1},0x0105:{T:1},0x0106:{T:-1},0x0107:{T:1},0x0108:{T:-1},0x0109:{T:1},0x010A:{T:-1},0x010B:{T:1},0x010C:{T:-1},0x010D:{T:1},0x010E:{T:-1},0x010F:{T:1},0x0110:{T:-1},0x0111:{T:1},0x0112:{T:-1},0x0113:{T:1},0x0114:{T:-1},0x0115:{},0x0116:{T:1},0x0117:{T:-1},0x0118:{T:1},0x0119:{T:-1},0x011A:{T:1},0x011B:{T:1},0x011C:{T:-1},0x011D:{T:1},0x011E:{T:-1},0x011F:{T:1},0x0120:{T:-1},0x0121:{T:1},0x0122:{T:-1},0x0123:{T:1},0x0124:{T:-1},0x0125:{T:1},0x0126:{T:-1},0x0127:{T:1},0x0128:{T:-1},0x0129:{T:1},0x012A:{T:-1},0x012B:{T:1},0x012C:{T:-1},0x012D:{T:1},0x012E:{T:-1},0x012F:{T:1},0x0130:{T:-1},0x0131:{T:1},0x0132:{T:-1},0x0133:{T:1},0x0134:{T:-1},0x0135:{T:1},0x0136:{T:-1},0x0137:{T:1},0x0138:{T:-1},0x0139:{T:-1},0x013A:{T:1},0x013B:{T:-1},0x013C:{T:1},0x013D:{T:-1},0x013E:{T:1},0x013F:{T:-1},0x0140:{T:1},0x0141:{T:-1},0x0142:{T:1},0x0143:{T:-1},0x0144:{T:1},0x0145:{T:-1},0x0146:{T:1},0x0147:{T:-1},0x0148:{T:1},0x0149:{T:-1},0x014A:{T:1},0x014B:{T:-1},0x014C:{T:1},0x014D:{T:-1},0x014E:{T:1},0x014F:{f:parse_BrtMdtinfo},0x0150:{T:-1},0x0151:{f:parse_BrtBeginEsmdb,T:1},0x0152:{T:-1},0x0153:{T:1},0x0154:{T:-1},0x0155:{T:1},0x0156:{T:-1},0x0157:{T:1},0x0158:{T:-1},0x0159:{T:1},0x015A:{T:-1},0x015B:{T:1},0x015C:{T:-1},0x015D:{T:1},0x015E:{T:-1},0x015F:{},0x0160:{},0x0161:{T:1},0x0162:{T:-1},0x0163:{f:parse_RelID},0x0165:{},0x0166:{},0x0167:{},0x0168:{T:1},0x0169:{},0x016A:{f:parse_ExternSheet},0x016B:{},0x016C:{},0x016E:{},0x016F:{},0x0170:{},0x0171:{},0x0172:{},0x0173:{},0x0174:{T:1},0x0175:{T:-1},0x0176:{T:1},0x0177:{T:-1},0x0178:{T:1},0x0179:{T:-1},0x017A:{T:1},0x017B:{T:-1},0x017C:{T:1},0x017D:{T:-1},0x017E:{T:1},0x017F:{T:-1},0x0180:{T:1},0x0181:{T:-1},0x0182:{T:1},0x0183:{T:-1},0x0184:{T:1},0x0185:{T:-1},0x0186:{T:1},0x0187:{T:-1},0x0188:{T:1},0x0189:{T:-1},0x018A:{T:1},0x018B:{T:-1},0x018C:{},0x018D:{},0x018E:{},0x018F:{},0x0190:{},0x0191:{T:1},0x0193:{},0x0194:{},0x0195:{},0x0196:{},0x0197:{},0x0198:{},0x0199:{},0x019A:{},0x019B:{},0x019C:{},0x019D:{},0x019E:{},0x019F:{},0x01A0:{},0x01A1:{},0x01A2:{},0x01A3:{},0x01A4:{},0x01A5:{},0x01A6:{T:1},0x01A7:{T:1},0x01A8:{T:-1},0x01A9:{T:-1},0x01AA:{f:parse_BrtArrFmla},0x01AB:{f:parse_BrtShrFmla},0x01AC:{},0x01AD:{T:1},0x01AE:{T:-1},0x01AF:{T:1},0x01B0:{T:-1},0x01B1:{T:1},0x01B2:{T:-1},0x01B3:{T:1},0x01B4:{T:-1},0x01B5:{T:1},0x01B6:{T:-1},0x01B7:{T:1},0x01B8:{T:-1},0x01B9:{T:1},0x01BA:{T:-1},0x01BB:{T:1},0x01BC:{T:-1},0x01BD:{T:1},0x01BE:{T:-1},0x01BF:{T:1},0x01C0:{T:-1},0x01C1:{T:1},0x01C2:{T:-1},0x01C3:{T:1},0x01C4:{T:-1},0x01C5:{T:1},0x01C6:{T:-1},0x01C7:{T:1},0x01C8:{T:-1},0x01C9:{T:1},0x01CA:{T:-1},0x01CB:{T:1},0x01CC:{T:-1},0x01CD:{T:1},0x01CE:{T:-1},0x01CF:{T:1},0x01D0:{T:-1},0x01D1:{T:1},0x01D2:{T:-1},0x01D3:{T:1},0x01D4:{T:-1},0x01D5:{T:1},0x01D6:{T:-1},0x01D7:{},0x01D8:{},0x01D9:{T:1},0x01DA:{T:-1},0x01DB:{},0x01DC:{f:parse_BrtMargins},0x01DD:{},0x01DE:{},0x01DF:{T:1},0x01E0:{T:-1},0x01E1:{T:1},0x01E2:{T:-1},0x01E3:{T:1},0x01E4:{T:-1},0x01E5:{f:parse_BrtWsFmtInfo},0x01E6:{T:1},0x01E7:{T:-1},0x01E8:{T:1},0x01E9:{T:-1},0x01EA:{T:1},0x01EB:{T:-1},0x01EC:{T:1},0x01ED:{T:-1},0x01EE:{f:parse_BrtHLink},0x01EF:{T:1},0x01F0:{T:-1},0x01F1:{T:1},0x01F2:{T:-1},0x01F3:{},0x01F4:{T:1},0x01F5:{T:-1},0x01F6:{T:1},0x01F7:{T:-1},0x01F8:{},0x01F9:{T:1},0x01FA:{T:-1},0x01FB:{},0x01FC:{T:1},0x01FD:{T:-1},0x01FE:{T:1},0x01FF:{T:-1},0x0200:{},0x0201:{},0x0202:{T:1},0x0203:{T:-1},0x0204:{T:1},0x0205:{T:-1},0x0206:{T:1},0x0207:{T:-1},0x0208:{T:1},0x0209:{T:-1},0x020A:{},0x020B:{},0x020C:{},0x020D:{},0x020E:{},0x020F:{},0x0210:{T:1},0x0211:{T:-1},0x0212:{T:1},0x0213:{T:-1},0x0214:{T:1},0x0215:{T:-1},0x0216:{},0x0217:{},0x0218:{},0x0219:{},0x021A:{T:1},0x021B:{T:-1},0x021C:{T:1},0x021D:{T:-1},0x021E:{T:1},0x0224:{},0x0225:{},0x0226:{f:parse_RelID},0x0227:{},0x0228:{},0x0229:{},0x022A:{T:1},0x022B:{T:-1},0x022C:{T:1},0x022D:{T:-1},0x022E:{T:1},0x022F:{T:-1},0x0230:{T:1},0x0231:{T:-1},0x0232:{},0x0234:{},0x0235:{T:1},0x0236:{T:-1},0x0239:{T:1},0x023A:{T:-1},0x023C:{},0x023D:{T:1},0x023E:{T:-1},0x0241:{},0x0242:{},0x0243:{},0x0244:{},0x0245:{},0x0246:{},0x0247:{},0x0248:{},0x0249:{},0x024A:{},0x024B:{},0x024C:{T:-1},0x024D:{},0x024E:{T:1},0x024F:{T:-1},0x0250:{T:1},0x0251:{T:-1},0x0252:{T:1},0x0253:{T:-1},0x0254:{},0x0255:{T:1},0x0256:{T:-1},0x0257:{T:1},0x0258:{T:-1},0x0259:{T:1},0x025A:{T:-1},0x025B:{T:1},0x025C:{T:-1},0x025D:{T:1},0x025E:{T:-1},0x025F:{},0x0260:{T:1},0x0261:{T:-1},0x0262:{},0x0263:{T:1},0x0264:{T:-1},0x0265:{T:1},0x0266:{T:-1},0x0267:{T:1},0x0268:{T:-1},0x0269:{T:1},0x026A:{T:-1},0x026B:{T:1},0x026C:{T:-1},0x0271:{},0x0272:{T:1},0x0273:{T:-1},0x0274:{T:1},0x0275:{T:-1},0x0276:{T:1},0x0277:{T:-1},0x0278:{f:parse_BrtCommentAuthor},0x0279:{T:1},0x027A:{T:-1},0x027B:{T:1,f:parse_BrtBeginComment},0x027C:{T:-1},0x027D:{f:parse_BrtCommentText},0x027E:{T:1},0x027F:{},0x0280:{T:-1},0x0281:{T:1},0x0282:{T:-1},0x0283:{T:1},0x0284:{},0x0285:{T:-1},0x0286:{T:1},0x0288:{T:1},0x0289:{},0x028A:{T:-1},0x028B:{f:parse_BrtCsProp},0x028C:{},0x028D:{T:1},0x028E:{T:-1},0x028F:{T:1},0x0290:{T:-1},0x0291:{T:1},0x0292:{T:-1},0x0293:{},0x0294:{T:1},0x0295:{},0x0296:{T:-1},0x0297:{},0x0298:{T:1},0x0299:{},0x029A:{T:-1},0x029B:{},0x029C:{},0x029D:{},0x029F:{T:1},0x02A0:{T:-1},0x02A1:{T:1},0x02A2:{T:-1},0x02A3:{},0x02A4:{},0x02A5:{},0x02A6:{},0x02A7:{},0x02A8:{},0x02A9:{},0x0400:{},0x0401:{},0x0402:{T:1},0x0403:{T:-1},0x0404:{T:1},0x0405:{T:-1},0x0406:{},0x0407:{T:1},0x0408:{T:-1},0x0409:{T:1},0x040A:{T:-1},0x040B:{},0x040C:{},0x040D:{},0x040E:{T:1},0x040F:{T:-1},0x0410:{},0x0411:{T:1},0x0412:{T:-1},0x0413:{},0x0414:{},0x0415:{},0x0416:{T:1},0x0417:{T:-1},0x0418:{T:1},0x0419:{T:-1},0x041A:{},0x041B:{T:1},0x041C:{T:1},0x041D:{f:parse_BrtDVal14},0x041E:{T:1},0x041F:{},0x0420:{T:1},0x0421:{T:-1},0x0422:{T:1},0x0423:{T:-1},0x0425:{},0x0426:{T:1},0x0427:{T:-1},0x0428:{T:1},0x0429:{T:-1},0x042A:{T:1},0x042B:{T:-1},0x042C:{T:1},0x042D:{T:-1},0x042E:{T:1},0x042F:{T:-1},0x0430:{T:1},0x0431:{T:-1},0x0433:{T:1},0x0434:{T:-1},0x0435:{T:1},0x0436:{T:-1},0x0437:{T:1},0x0438:{T:-1},0x0439:{T:1},0x043A:{T:-1},0x043B:{T:1},0x043C:{T:-1},0x043D:{},0x043E:{T:1},0x043F:{T:-1},0x0440:{T:1},0x0441:{T:-1},0x0442:{T:1},0x0443:{T:-1},0x0444:{T:1},0x0445:{T:-1},0x0446:{T:1},0x0447:{T:-1},0x0448:{},0x0449:{T:1},0x044A:{},0x044B:{T:-1},0x044C:{T:1},0x044D:{T:-1},0x044E:{},0x044F:{},0x0450:{},0x0451:{},0x0457:{},0x0458:{},0x0459:{T:1},0x045A:{T:-1},0x045B:{T:1},0x045C:{T:-1},0x045D:{},0x045E:{T:1},0x045F:{T:-1},0x0460:{T:1},0x0461:{T:-1},0x0462:{T:1},0x0463:{T:-1},0x0464:{T:1},0x0465:{T:-1},0x0466:{},0x0468:{T:1},0x0469:{T:-1},0x046A:{},0x046B:{T:1},0x046C:{T:-1},0x046D:{T:1},0x046E:{T:-1},0x046F:{T:1},0x0470:{T:-1},0x0471:{T:1},0x0472:{T:-1},0x0473:{T:1},0x0474:{T:-1},0x0475:{},0x0476:{T:1},0x0477:{T:-1},0x0478:{T:1},0x0479:{T:-1},0x047A:{},0x047B:{T:1},0x047C:{T:-1},0x047D:{T:1},0x047E:{T:-1},0x0480:{T:1},0x0481:{T:-1},0x0482:{T:-1},0x0483:{T:-1},0x0484:{T:-1},0x0485:{T:1},0x0486:{T:-1},0x0487:{T:1},0x0488:{T:-1},0x0489:{T:1},0x048A:{T:-1},0x048B:{T:1},0x048C:{T:-1},0x048D:{T:1},0x048E:{T:-1},0x048F:{T:1},0x0490:{T:-1},0x0491:{T:1},0x0492:{T:-1},0x0493:{},0x0494:{T:1},0x0495:{T:-1},0x0499:{},0x049A:{T:1},0x049C:{},0x049D:{},0x049E:{},0x0800:{T:1},0x0801:{T:-1},0x0802:{},0x0803:{T:1},0x0804:{T:-1},0x0805:{},0x0806:{},0x0807:{T:1},0x0808:{T:-1},0x0809:{T:1},0x080A:{T:-1},0x080C:{},0x0813:{},0x0814:{T:1},0x0815:{T:-1},0x0816:{},0x0817:{},0x0818:{T:1},0x0819:{T:-1},0x081B:{},0x081C:{},0x081D:{T:1},0x081E:{T:-1},0x081F:{},0x0820:{T:1},0x0821:{T:-1},0x0822:{},0x0823:{T:1},0x0824:{T:-1},0x0825:{T:1},0x0826:{T:-1},0x0827:{T:1},0x0828:{T:-1},0x0829:{T:1},0x082A:{T:-1},0x082B:{},0x082C:{},0x082D:{T:1},0x082E:{T:-1},0x082F:{},0x0830:{T:1},0x0831:{T:-1},0x0832:{T:1},0x0833:{T:-1},0x0834:{T:1},0x0835:{T:-1},0x0836:{},0x0837:{T:1},0x0838:{T:-1},0x0839:{},0x083A:{T:1},0x083B:{T:-1},0x083C:{},0x083D:{T:1},0x083E:{T:-1},0x083F:{T:1},0x0840:{T:-1},0x0841:{T:1},0x0842:{T:-1},0x0843:{},0x0844:{},0x0845:{},0x0846:{T:1},0x0847:{T:-1},0x0848:{},0x0849:{T:1},0x084A:{T:-1},0x084B:{T:1},0x084C:{T:-1},0x084D:{},0x084E:{T:1},0x084F:{T:-1},0x0850:{},0x0851:{T:1},0x0852:{T:-1},0x0853:{T:1},0x0854:{T:-1},0x0855:{T:1},0x0856:{},0x0857:{},0x0858:{},0x0859:{T:1},0x085A:{T:-1},0x085B:{T:1},0x085C:{T:-1},0x085D:{},0x0C00:{},0x0C01:{},0x1000:{T:1},0x1001:{T:-1},0x138A:{T:1},0x138B:{T:-1},0x13D9:{T:1},0x13DA:{T:-1},0x13DB:{},0x13DC:{T:1},0x13DD:{T:-1},0x13DE:{T:1},0x13DF:{T:-1},0x13E0:{},0x13E1:{},0x13E2:{},0x13E4:{T:1},0x13E5:{T:-1},0x13E6:{},0x13E7:{T:1},0x13E8:{T:-1},0x13E9:{},0x13EB:{},0xFFFF:{n:""}};var XLSRecordEnum={0x0006:{f:parse_Formula},0x000a:{f:parsenoop2},0x000c:{f:parseuint16},0x000d:{f:parseuint16},0x000e:{f:parsebool},0x000f:{f:parsebool},0x0010:{f:parse_Xnum},0x0011:{f:parsebool},0x0012:{f:parsebool},0x0013:{f:parseuint16},0x0014:{f:parse_XLHeaderFooter},0x0015:{f:parse_XLHeaderFooter},0x0017:{f:parse_ExternSheet},0x0018:{f:parse_Lbl},0x0019:{f:parsebool},0x001a:{},0x001b:{},0x001c:{f:parse_Note},0x001d:{},0x0022:{f:parsebool},0x0023:{f:parse_ExternName},0x0026:{f:parse_Xnum},0x0027:{f:parse_Xnum},0x0028:{f:parse_Xnum},0x0029:{f:parse_Xnum},0x002a:{f:parsebool},0x002b:{f:parsebool},0x002f:{f:parse_FilePass},0x0031:{f:parse_Font},0x0033:{f:parseuint16},0x003c:{},0x003d:{f:parse_Window1},0x0040:{f:parsebool},0x0041:{f:parse_Pane},0x0042:{f:parseuint16},0x004d:{},0x0050:{},0x0051:{},0x0052:{},0x0055:{f:parseuint16},0x0059:{},0x005a:{},0x005b:{},0x005c:{f:parse_WriteAccess},0x005d:{f:parse_Obj},0x005e:{},0x005f:{f:parsebool},0x0060:{},0x0061:{},0x0063:{f:parsebool},0x007d:{f:parse_ColInfo},0x0080:{f:parse_Guts},0x0081:{f:parse_WsBool},0x0082:{f:parseuint16},0x0083:{f:parsebool},0x0084:{f:parsebool},0x0085:{f:parse_BoundSheet8},0x0086:{},0x008c:{f:parse_Country},0x008d:{f:parseuint16},0x0090:{},0x0092:{f:parse_Palette},0x0097:{},0x0098:{},0x0099:{},0x009a:{},0x009b:{},0x009c:{f:parseuint16},0x009d:{},0x009e:{},0x00a0:{f:parse_Scl},0x00a1:{f:parse_Setup},0x00ae:{},0x00af:{},0x00b0:{},0x00b1:{},0x00b2:{},0x00b4:{},0x00b5:{},0x00b6:{},0x00b8:{},0x00b9:{},0x00bd:{f:parse_MulRk},0x00be:{f:parse_MulBlank},0x00c1:{f:parsenoop2},0x00c5:{},0x00c6:{},0x00c7:{},0x00c8:{},0x00c9:{},0x00ca:{f:parsebool},0x00cb:{},0x00cc:{},0x00cd:{},0x00ce:{},0x00cf:{},0x00d0:{},0x00d1:{},0x00d2:{},0x00d3:{},0x00d5:{},0x00d7:{},0x00d8:{},0x00d9:{},0x00da:{f:parseuint16},0x00dc:{},0x00dd:{f:parsebool},0x00de:{},0x00e0:{f:parse_XF},0x00e1:{f:parse_InterfaceHdr},0x00e2:{f:parsenoop2},0x00e3:{},0x00e5:{f:parse_MergeCells},0x00e9:{},0x00eb:{},0x00ec:{},0x00ed:{},0x00ef:{},0x00f0:{},0x00f1:{},0x00f2:{},0x00f4:{},0x00f5:{},0x00f6:{},0x00f7:{},0x00f8:{},0x00f9:{},0x00fb:{},0x00fc:{f:parse_SST},0x00fd:{f:parse_LabelSst},0x00ff:{f:parse_ExtSST},0x0100:{},0x0103:{},0x0122:{},0x0137:{},0x0138:{},0x013b:{},0x013d:{f:parseuint16a},0x013e:{},0x013f:{},0x0140:{},0x014a:{},0x014b:{},0x014d:{},0x014e:{},0x014f:{},0x0150:{},0x0151:{},0x0152:{},0x0153:{},0x0154:{},0x015f:{},0x0160:{f:parsebool},0x0161:{f:parsenoop2},0x0191:{},0x0192:{},0x0193:{},0x0194:{},0x0195:{},0x0196:{},0x0197:{},0x0198:{},0x01a9:{},0x01aa:{},0x01ab:{},0x01ac:{},0x01ad:{},0x01ae:{f:parse_SupBook},0x01af:{f:parsebool},0x01b0:{},0x01b1:{},0x01b2:{},0x01b5:{},0x01b6:{f:parse_TxO},0x01b7:{f:parsebool},0x01b8:{f:parse_HLink},0x01b9:{},0x01ba:{f:parse_XLUnicodeString},0x01bb:{},0x01bc:{f:parseuint16},0x01bd:{},0x01be:{},0x01c0:{f:parsenoop2},0x01c1:{f:parse_RecalcId,r:2},0x01c2:{f:parsenoop2},0x0200:{f:parse_Dimensions},0x0201:{f:parse_Blank},0x0203:{f:parse_Number},0x0204:{f:parse_Label},0x0205:{f:parse_BoolErr},0x0207:{f:parse_String},0x0208:{f:parse_Row},0x020b:{},0x0221:{f:parse_Array},0x0225:{f:parse_DefaultRowHeight},0x0236:{},0x023e:{f:parse_Window2},0x027e:{f:parse_RK},0x0293:{},0x0418:{},0x041e:{f:parse_Format},0x043c:{},0x04bc:{f:parse_ShrFmla},0x0800:{f:parse_HLinkTooltip},0x0801:{},0x0802:{},0x0803:{},0x0804:{},0x0805:{},0x0806:{},0x0807:{},0x0808:{},0x0809:{f:parse_BOF},0x080a:{},0x080b:{},0x080c:{},0x080d:{},0x080e:{},0x080f:{},0x0810:{},0x0812:{},0x0813:{},0x0850:{},0x0851:{},0x0852:{},0x0853:{},0x0854:{},0x0855:{},0x0856:{},0x0857:{},0x0858:{},0x0859:{},0x085a:{},0x0862:{},0x0863:{r:12},0x0864:{},0x0865:{},0x0866:{},0x0867:{f:parsenoop2},0x0868:{},0x086a:{},0x086b:{},0x086c:{},0x0871:{},0x0872:{},0x0874:{},0x0875:{},0x0876:{},0x0877:{},0x0878:{},0x0879:{},0x087a:{},0x087b:{},0x087c:{f:parse_XFCRC,r:12},0x087d:{f:parse_XFExt,r:12},0x087e:{},0x087f:{},0x0884:{},0x0885:{},0x0886:{},0x0887:{},0x0888:{},0x0889:{},0x088a:{},0x088b:{},0x088c:{f:parsebool,r:12},0x088d:{},0x088e:{r:12},0x088f:{},0x0890:{},0x0892:{},0x0893:{},0x0894:{f:parse_NameCmt,r:12},0x0895:{},0x0896:{f:parse_Theme,r:12},0x0897:{},0x0898:{},0x0899:{},0x089a:{f:parse_MTRSettings,r:12},0x089b:{f:parsenoop2},0x089c:{},0x089d:{},0x089e:{},0x089f:{},0x08a3:{f:parse_ForceFullCalculation},0x08a4:{},0x08a5:{},0x08a6:{},0x08a7:{},0x1001:{},0x1002:{},0x1003:{},0x1006:{},0x1007:{},0x1009:{},0x100a:{},0x100b:{},0x100c:{},0x100d:{},0x1014:{},0x1015:{},0x1016:{},0x1017:{},0x1018:{},0x1019:{},0x101a:{},0x101b:{},0x101c:{},0x101d:{},0x101e:{},0x101f:{},0x1020:{},0x1021:{},0x1022:{},0x1024:{},0x1025:{},0x1026:{f:parseuint16},0x1027:{},0x1032:{},0x1033:{},0x1034:{},0x1035:{},0x103a:{},0x103c:{},0x103d:{},0x103e:{},0x103f:{},0x1040:{},0x1041:{},0x1043:{},0x1044:{f:parse_ShtProps},0x1045:{},0x1046:{},0x1048:{},0x104a:{},0x104b:{},0x104e:{},0x104f:{},0x1050:{},0x1051:{},0x105b:{},0x105c:{f:parse_ClrtClient},0x105d:{},0x105f:{},0x1060:{},0x1061:{},0x1062:{},0x1063:{},0x1064:{},0x1065:{},0x1066:{},0x1067:{},0x1068:{},0x0000:{f:parse_Dimensions},0x0001:{},0x0002:{f:parse_BIFF2INT},0x0003:{f:parse_BIFF2NUM},0x0004:{f:parse_BIFF2STR},0x0005:{f:parse_BoolErr},0x0007:{f:parse_BIFF2STRING},0x0008:{},0x0009:{f:parse_BOF},0x000b:{},0x0016:{f:parseuint16},0x001e:{f:parse_BIFF2Format},0x001f:{},0x0020:{},0x0021:{f:parse_Array},0x0024:{},0x0025:{f:parse_DefaultRowHeight},0x0032:{f:parse_BIFF2FONTXTRA},0x003e:{},0x0034:{},0x0043:{},0x0044:{f:parseuint16},0x0045:{},0x0056:{},0x007e:{},0x007f:{f:parse_ImData},0x0087:{},0x0088:{},0x0089:{},0x0091:{},0x0094:{},0x0095:{},0x0096:{},0x00a9:{},0x00ab:{},0x00bc:{},0x00bf:{},0x00c0:{},0x00c2:{},0x00c3:{},0x00d6:{f:parse_RString},0x00df:{},0x00ea:{},0x0162:{},0x01a5:{},0x0206:{f:parse_Formula},0x0209:{f:parse_BOF},0x0218:{f:parse_Lbl},0x0223:{f:parse_ExternName},0x0231:{},0x0243:{},0x0406:{f:parse_Formula},0x0409:{f:parse_BOF},0x0443:{},0x086d:{},0x0873:{},0x0881:{},0x08c0:{},0x08c1:{},0x08c2:{},0x08c3:{},0x08c4:{},0x08c5:{},0x08c6:{},0x08c7:{},0x08c8:{},0x08c9:{},0x08ca:{},0x08cb:{},0x08d6:{r:12},0x7262:{}};function write_biff_rec(ba,type,payload,length){var t=type;if(isNaN(t))return;var len=length||(payload||[]).length||0;var o=ba.next(4);o.write_shift(2,t);o.write_shift(2,len);if(len>0&&is_buf(payload))ba.push(payload);}function write_biff_continue(ba,type,payload,length){var len=length||(payload||[]).length||0;if(len<=8224)return write_biff_rec(ba,type,payload,len);var t=type;if(isNaN(t))return;var parts=payload.parts||[],sidx=0;var i=0,w=0;while(w+(parts[sidx]||8224)<=8224){w+=parts[sidx]||8224;sidx++;}var o=ba.next(4);o.write_shift(2,t);o.write_shift(2,w);ba.push(payload.slice(i,i+w));i+=w;while(i<len){o=ba.next(4);o.write_shift(2,0x3c);w=0;while(w+(parts[sidx]||8224)<=8224){w+=parts[sidx]||8224;sidx++;}o.write_shift(2,w);ba.push(payload.slice(i,i+w));i+=w;}}function write_BIFF2Cell(out,r,c){if(!out)out=new_buf(7);out.write_shift(2,r);out.write_shift(2,c);out.write_shift(2,0);out.write_shift(1,0);return out;}function write_BIFF2BERR(r,c,val,t){var out=new_buf(9);write_BIFF2Cell(out,r,c);write_Bes(val,t||'b',out);return out;}function write_BIFF2LABEL(r,c,val){var out=new_buf(8+2*val.length);write_BIFF2Cell(out,r,c);out.write_shift(1,val.length);out.write_shift(val.length,val,'sbcs');return out.l<out.length?out.slice(0,out.l):out;}function write_ws_biff2_cell(ba,cell,R,C){if(cell.v!=null)switch(cell.t){case'd':case'n':var v=cell.t=='d'?datenum(parseDate(cell.v)):cell.v;if(v==(v|0)&&v>=0&&v<65536)write_biff_rec(ba,0x0002,write_BIFF2INT(R,C,v));else write_biff_rec(ba,0x0003,write_BIFF2NUM(R,C,v));return;case'b':case'e':write_biff_rec(ba,0x0005,write_BIFF2BERR(R,C,cell.v,cell.t));return;case's':case'str':write_biff_rec(ba,0x0004,write_BIFF2LABEL(R,C,(cell.v||"").slice(0,255)));return;}write_biff_rec(ba,0x0001,write_BIFF2Cell(null,R,C));}function write_ws_biff2(ba,ws,idx,opts){var dense=Array.isArray(ws);var range=safe_decode_range(ws['!ref']||"A1"),ref,rr="",cols=[];if(range.e.c>0xFF||range.e.r>0x3FFF){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:IV16384");range.e.c=Math.min(range.e.c,0xFF);range.e.r=Math.min(range.e.c,0x3FFF);ref=encode_range(range);}for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell)continue;write_ws_biff2_cell(ba,cell,R,C,opts);}}}function write_biff2_buf(wb,opts){var o=opts||{};if(DENSE!=null&&o.dense==null)o.dense=DENSE;var ba=buf_array();var idx=0;for(var i=0;i<wb.SheetNames.length;++i){if(wb.SheetNames[i]==o.sheet)idx=i;}if(idx==0&&!!o.sheet&&wb.SheetNames[0]!=o.sheet)throw new Error("Sheet not found: "+o.sheet);write_biff_rec(ba,o.biff==4?0x0409:o.biff==3?0x0209:0x0009,write_BOF(wb,0x10,o));write_ws_biff2(ba,wb.Sheets[wb.SheetNames[idx]],idx,o,wb);write_biff_rec(ba,0x000A);return ba.end();}function write_FONTS_biff8(ba,data,opts){write_biff_rec(ba,0x0031,write_Font({sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"},opts));}function write_FMTS_biff8(ba,NF,opts){if(!NF)return;[[5,8],[23,26],[41,44],[50,392]].forEach(function(r){for(var i=r[0];i<=r[1];++i){if(NF[i]!=null)write_biff_rec(ba,0x041E,write_Format(i,NF[i],opts));}});}function write_FEAT(ba,ws){var o=new_buf(19);o.write_shift(4,0x867);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,3);o.write_shift(1,1);o.write_shift(4,0);write_biff_rec(ba,0x0867,o);o=new_buf(39);o.write_shift(4,0x868);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,3);o.write_shift(1,0);o.write_shift(4,0);o.write_shift(2,1);o.write_shift(4,4);o.write_shift(2,0);write_Ref8U(safe_decode_range(ws['!ref']||"A1"),o);o.write_shift(4,4);write_biff_rec(ba,0x0868,o);}function write_CELLXFS_biff8(ba,opts){for(var i=0;i<16;++i){write_biff_rec(ba,0x00e0,write_XF({numFmtId:0,style:true},0,opts));}opts.cellXfs.forEach(function(c){write_biff_rec(ba,0x00e0,write_XF(c,0,opts));});}function write_ws_biff8_hlinks(ba,ws){for(var R=0;R<ws['!links'].length;++R){var HL=ws['!links'][R];write_biff_rec(ba,0x01b8,write_HLink(HL));if(HL[1].Tooltip)write_biff_rec(ba,0x0800,write_HLinkTooltip(HL));}delete ws['!links'];}function write_ws_cols_biff8(ba,cols){if(!cols)return;var cnt=0;cols.forEach(function(col,idx){if(++cnt<=256&&col){write_biff_rec(ba,0x007d,write_ColInfo(col_obj_w(idx,col),idx));}});}function write_ws_biff8_cell(ba,cell,R,C,opts){var os=16+get_cell_style(opts.cellXfs,cell,opts);if(cell.v==null&&!cell.bf){write_biff_rec(ba,0x0201,write_XLSCell(R,C,os));return;}if(cell.bf)write_biff_rec(ba,0x0006,write_Formula(cell,R,C,opts,os));else switch(cell.t){case'd':case'n':var v=cell.t=='d'?datenum(parseDate(cell.v)):cell.v;write_biff_rec(ba,0x0203,write_Number(R,C,v,os,opts));break;case'b':case'e':write_biff_rec(ba,0x0205,write_BoolErr(R,C,cell.v,os,opts,cell.t));break;case's':case'str':if(opts.bookSST){var isst=get_sst_id(opts.Strings,cell.v,opts.revStrings);write_biff_rec(ba,0x00fd,write_LabelSst(R,C,isst,os,opts));}else write_biff_rec(ba,0x0204,write_Label(R,C,(cell.v||"").slice(0,255),os,opts));break;default:write_biff_rec(ba,0x0201,write_XLSCell(R,C,os));}}function write_ws_biff8(idx,opts,wb){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var _WB=(wb||{}).Workbook||{};var _sheet=(_WB.Sheets||[])[idx]||{};var dense=Array.isArray(ws);var b8=opts.biff==8;var ref,rr="",cols=[];var range=safe_decode_range(ws['!ref']||"A1");var MAX_ROWS=b8?65536:16384;if(range.e.c>0xFF||range.e.r>=MAX_ROWS){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:IV16384");range.e.c=Math.min(range.e.c,0xFF);range.e.r=Math.min(range.e.c,MAX_ROWS-1);}write_biff_rec(ba,0x0809,write_BOF(wb,0x10,opts));write_biff_rec(ba,0x000d,writeuint16(1));write_biff_rec(ba,0x000c,writeuint16(100));write_biff_rec(ba,0x000f,writebool(true));write_biff_rec(ba,0x0011,writebool(false));write_biff_rec(ba,0x0010,write_Xnum(0.001));write_biff_rec(ba,0x005f,writebool(true));write_biff_rec(ba,0x002a,writebool(false));write_biff_rec(ba,0x002b,writebool(false));write_biff_rec(ba,0x0082,writeuint16(1));write_biff_rec(ba,0x0080,write_Guts([0,0]));write_biff_rec(ba,0x0083,writebool(false));write_biff_rec(ba,0x0084,writebool(false));if(b8)write_ws_cols_biff8(ba,ws["!cols"]);write_biff_rec(ba,0x200,write_Dimensions(range,opts));if(b8)ws['!links']=[];for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell)continue;write_ws_biff8_cell(ba,cell,R,C,opts);if(b8&&cell.l)ws['!links'].push([ref,cell.l]);}}var cname=_sheet.CodeName||_sheet.name||s;if(b8)write_biff_rec(ba,0x023e,write_Window2((_WB.Views||[])[0]));if(b8&&(ws['!merges']||[]).length)write_biff_rec(ba,0x00e5,write_MergeCells(ws['!merges']));if(b8)write_ws_biff8_hlinks(ba,ws);write_biff_rec(ba,0x01ba,write_XLUnicodeString(cname,opts));if(b8)write_FEAT(ba,ws);write_biff_rec(ba,0x000a);return ba.end();}function write_biff8_global(wb,bufs,opts){var A=buf_array();var _WB=(wb||{}).Workbook||{};var _sheets=_WB.Sheets||[];var _wb=_WB.WBProps||{};var b8=opts.biff==8,b5=opts.biff==5;write_biff_rec(A,0x0809,write_BOF(wb,0x05,opts));if(opts.bookType=="xla")write_biff_rec(A,0x0087);write_biff_rec(A,0x00e1,b8?writeuint16(0x04b0):null);write_biff_rec(A,0x00c1,writezeroes(2));if(b5)write_biff_rec(A,0x00bf);if(b5)write_biff_rec(A,0x00c0);write_biff_rec(A,0x00e2);write_biff_rec(A,0x005c,write_WriteAccess("SheetJS",opts));write_biff_rec(A,0x0042,writeuint16(b8?0x04b0:0x04E4));if(b8)write_biff_rec(A,0x0161,writeuint16(0));if(b8)write_biff_rec(A,0x01c0);write_biff_rec(A,0x013d,write_RRTabId(wb.SheetNames.length));if(b8&&wb.vbaraw)write_biff_rec(A,0x00d3);if(b8&&wb.vbaraw){var cname=_wb.CodeName||"ThisWorkbook";write_biff_rec(A,0x01ba,write_XLUnicodeString(cname,opts));}write_biff_rec(A,0x009c,writeuint16(0x11));write_biff_rec(A,0x0019,writebool(false));write_biff_rec(A,0x0012,writebool(false));write_biff_rec(A,0x0013,writeuint16(0));if(b8)write_biff_rec(A,0x01af,writebool(false));if(b8)write_biff_rec(A,0x01bc,writeuint16(0));write_biff_rec(A,0x003d,write_Window1(opts));write_biff_rec(A,0x0040,writebool(false));write_biff_rec(A,0x008d,writeuint16(0));write_biff_rec(A,0x0022,writebool(safe1904(wb)=="true"));write_biff_rec(A,0x000e,writebool(true));if(b8)write_biff_rec(A,0x01b7,writebool(false));write_biff_rec(A,0x00DA,writeuint16(0));write_FONTS_biff8(A,wb,opts);write_FMTS_biff8(A,wb.SSF,opts);write_CELLXFS_biff8(A,opts);if(b8)write_biff_rec(A,0x0160,writebool(false));var a=A.end();var C=buf_array();if(b8)write_biff_rec(C,0x008C,write_Country());if(b8&&opts.Strings)write_biff_continue(C,0x00FC,write_SST(opts.Strings,opts));write_biff_rec(C,0x000A);var c=C.end();var B=buf_array();var blen=0,j=0;for(j=0;j<wb.SheetNames.length;++j){blen+=(b8?12:11)+(b8?2:1)*wb.SheetNames[j].length;}var start=a.length+blen+c.length;for(j=0;j<wb.SheetNames.length;++j){var _sheet=_sheets[j]||{};write_biff_rec(B,0x0085,write_BoundSheet8({pos:start,hs:_sheet.Hidden||0,dt:0,name:wb.SheetNames[j]},opts));start+=bufs[j].length;}var b=B.end();if(blen!=b.length)throw new Error("BS8 "+blen+" != "+b.length);var out=[];if(a.length)out.push(a);if(b.length)out.push(b);if(c.length)out.push(c);return bconcat(out);}function write_biff8_buf(wb,opts){var o=opts||{};var bufs=[];if(wb&&!wb.SSF){wb.SSF=dup(table_fmt);}if(wb&&wb.SSF){make_ssf();SSF_load_table(wb.SSF);o.revssf=evert_num(wb.SSF);o.revssf[wb.SSF[65535]]=0;o.ssf=wb.SSF;}o.Strings=[];o.Strings.Count=0;o.Strings.Unique=0;fix_write_opts(o);o.cellXfs=[];get_cell_style(o.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};for(var i=0;i<wb.SheetNames.length;++i){bufs[bufs.length]=write_ws_biff8(i,o,wb);}bufs.unshift(write_biff8_global(wb,bufs,o));return bconcat(bufs);}function write_biff_buf(wb,opts){for(var i=0;i<=wb.SheetNames.length;++i){var ws=wb.Sheets[wb.SheetNames[i]];if(!ws||!ws["!ref"])continue;var range=decode_range(ws["!ref"]);if(range.e.c>255){if(typeof console!="undefined"&&console.error)console.error("Worksheet '"+wb.SheetNames[i]+"' extends beyond column IV (255).  Data may be lost.");}}var o=opts||{};switch(o.biff||2){case 8:case 5:return write_biff8_buf(wb,opts);case 4:case 3:case 2:return write_biff2_buf(wb,opts);}throw new Error("invalid type "+o.bookType+" for BIFF");}function html_to_sheet(str,_opts){var opts=_opts||{};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var ws=opts.dense?[]:{};str=str.replace(/<!--.*?-->/g,"");var mtch=str.match(/<table/i);if(!mtch)throw new Error("Invalid HTML: could not find <table>");var mtch2=str.match(/<\/table/i);var i=mtch.index,j=mtch2&&mtch2.index||str.length;var rows=split_regex(str.slice(i,j),/(:?<tr[^>]*>)/i,"<tr>");var R=-1,C=0,RS=0,CS=0;var range={s:{r:10000000,c:10000000},e:{r:0,c:0}};var merges=[];for(i=0;i<rows.length;++i){var row=rows[i].trim();var hd=row.slice(0,3).toLowerCase();if(hd=="<tr"){++R;if(opts.sheetRows&&opts.sheetRows<=R){--R;break;}C=0;continue;}if(hd!="<td"&&hd!="<th")continue;var cells=row.split(/<\/t[dh]>/i);for(j=0;j<cells.length;++j){var cell=cells[j].trim();if(!cell.match(/<t[dh]/i))continue;var m=cell,cc=0;while(m.charAt(0)=="<"&&(cc=m.indexOf(">"))>-1){m=m.slice(cc+1);}for(var midx=0;midx<merges.length;++midx){var _merge=merges[midx];if(_merge.s.c==C&&_merge.s.r<R&&R<=_merge.e.r){C=_merge.e.c+1;midx=-1;}}var tag=parsexmltag(cell.slice(0,cell.indexOf(">")));CS=tag.colspan?+tag.colspan:1;if((RS=+tag.rowspan)>1||CS>1)merges.push({s:{r:R,c:C},e:{r:R+(RS||1)-1,c:C+CS-1}});var _t=tag.t||tag["data-t"]||"";if(!m.length){C+=CS;continue;}m=htmldecode(m);if(range.s.r>R)range.s.r=R;if(range.e.r<R)range.e.r=R;if(range.s.c>C)range.s.c=C;if(range.e.c<C)range.e.c=C;if(!m.length){C+=CS;continue;}var o={t:'s',v:m};if(opts.raw||!m.trim().length||_t=='s'){}else if(m==='TRUE')o={t:'b',v:true};else if(m==='FALSE')o={t:'b',v:false};else if(!isNaN(fuzzynum(m)))o={t:'n',v:fuzzynum(m)};else if(!isNaN(fuzzydate(m).getDate())){o={t:'d',v:parseDate(m)};if(!opts.cellDates)o={t:'n',v:datenum(o.v)};o.z=opts.dateNF||table_fmt[14];}if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]=o;}else ws[encode_cell({r:R,c:C})]=o;C+=CS;}}ws['!ref']=encode_range(range);if(merges.length)ws["!merges"]=merges;return ws;}function make_html_row(ws,r,R,o){var M=ws['!merges']||[];var oo=[];for(var C=r.s.c;C<=r.e.c;++C){var RS=0,CS=0;for(var j=0;j<M.length;++j){if(M[j].s.r>R||M[j].s.c>C)continue;if(M[j].e.r<R||M[j].e.c<C)continue;if(M[j].s.r<R||M[j].s.c<C){RS=-1;break;}RS=M[j].e.r-M[j].s.r+1;CS=M[j].e.c-M[j].s.c+1;break;}if(RS<0)continue;var coord=encode_cell({r:R,c:C});var cell=o.dense?(ws[R]||[])[C]:ws[coord];var w=cell&&cell.v!=null&&(cell.h||escapehtml(cell.w||(format_cell(cell),cell.w)||""))||"";var sp={};if(RS>1)sp.rowspan=RS;if(CS>1)sp.colspan=CS;if(o.editable)w='<span contenteditable="true">'+w+'</span>';else if(cell){sp["data-t"]=cell&&cell.t||'z';if(cell.v!=null)sp["data-v"]=cell.v;if(cell.z!=null)sp["data-z"]=cell.z;if(cell.l&&(cell.l.Target||"#").charAt(0)!="#")w='<a href="'+cell.l.Target+'">'+w+'</a>';}sp.id=(o.id||"sjs")+"-"+coord;oo.push(writextag('td',w,sp));}var preamble="<tr>";return preamble+oo.join("")+"</tr>";}var HTML_BEGIN='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';var HTML_END='</body></html>';function html_to_workbook(str,opts){var mtch=str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);if(!mtch||mtch.length==0)throw new Error("Invalid HTML: could not find <table>");if(mtch.length==1)return sheet_to_workbook(html_to_sheet(mtch[0],opts),opts);var wb=book_new();mtch.forEach(function(s,idx){book_append_sheet(wb,html_to_sheet(s,opts),"Sheet"+(idx+1));});return wb;}function make_html_preamble(ws,R,o){var out=[];return out.join("")+'<table'+(o&&o.id?' id="'+o.id+'"':"")+'>';}function sheet_to_html(ws,opts){var o=opts||{};var header=o.header!=null?o.header:HTML_BEGIN;var footer=o.footer!=null?o.footer:HTML_END;var out=[header];var r=decode_range(ws['!ref']);o.dense=Array.isArray(ws);out.push(make_html_preamble(ws,r,o));for(var R=r.s.r;R<=r.e.r;++R){out.push(make_html_row(ws,r,R,o));}out.push("</table>"+footer);return out.join("");}function sheet_add_dom(ws,table,_opts){var opts=_opts||{};if(DENSE!=null)opts.dense=DENSE;var or_R=0,or_C=0;if(opts.origin!=null){if(typeof opts.origin=='number')or_R=opts.origin;else{var _origin=typeof opts.origin=="string"?decode_cell(opts.origin):opts.origin;or_R=_origin.r;or_C=_origin.c;}}var rows=table.getElementsByTagName('tr');var sheetRows=Math.min(opts.sheetRows||10000000,rows.length);var range={s:{r:0,c:0},e:{r:or_R,c:or_C}};if(ws["!ref"]){var _range=decode_range(ws["!ref"]);range.s.r=Math.min(range.s.r,_range.s.r);range.s.c=Math.min(range.s.c,_range.s.c);range.e.r=Math.max(range.e.r,_range.e.r);range.e.c=Math.max(range.e.c,_range.e.c);if(or_R==-1)range.e.r=or_R=_range.e.r+1;}var merges=[],midx=0;var rowinfo=ws["!rows"]||(ws["!rows"]=[]);var _R=0,R=0,_C=0,C=0,RS=0,CS=0;if(!ws["!cols"])ws['!cols']=[];for(;_R<rows.length&&R<sheetRows;++_R){var row=rows[_R];if(is_dom_element_hidden(row)){if(opts.display)continue;rowinfo[R]={hidden:true};}var elts=row.children;for(_C=C=0;_C<elts.length;++_C){var elt=elts[_C];if(opts.display&&is_dom_element_hidden(elt))continue;var v=elt.hasAttribute('data-v')?elt.getAttribute('data-v'):elt.hasAttribute('v')?elt.getAttribute('v'):htmldecode(elt.innerHTML);var z=elt.getAttribute('data-z')||elt.getAttribute('z');for(midx=0;midx<merges.length;++midx){var m=merges[midx];if(m.s.c==C+or_C&&m.s.r<R+or_R&&R+or_R<=m.e.r){C=m.e.c+1-or_C;midx=-1;}}CS=+elt.getAttribute("colspan")||1;if((RS=+elt.getAttribute("rowspan")||1)>1||CS>1)merges.push({s:{r:R+or_R,c:C+or_C},e:{r:R+or_R+(RS||1)-1,c:C+or_C+(CS||1)-1}});var o={t:'s',v:v};var _t=elt.getAttribute("data-t")||elt.getAttribute("t")||"";if(v!=null){if(v.length==0)o.t=_t||'z';else if(opts.raw||v.trim().length==0||_t=="s"){}else if(v==='TRUE')o={t:'b',v:true};else if(v==='FALSE')o={t:'b',v:false};else if(!isNaN(fuzzynum(v)))o={t:'n',v:fuzzynum(v)};else if(!isNaN(fuzzydate(v).getDate())){o={t:'d',v:parseDate(v)};if(!opts.cellDates)o={t:'n',v:datenum(o.v)};o.z=opts.dateNF||table_fmt[14];}}if(o.z===undefined&&z!=null)o.z=z;var l="",Aelts=elt.getElementsByTagName("A");if(Aelts&&Aelts.length)for(var Aelti=0;Aelti<Aelts.length;++Aelti){if(Aelts[Aelti].hasAttribute("href")){l=Aelts[Aelti].getAttribute("href");if(l.charAt(0)!="#")break;}}if(l&&l.charAt(0)!="#")o.l={Target:l};if(opts.dense){if(!ws[R+or_R])ws[R+or_R]=[];ws[R+or_R][C+or_C]=o;}else ws[encode_cell({c:C+or_C,r:R+or_R})]=o;if(range.e.c<C+or_C)range.e.c=C+or_C;C+=CS;}++R;}if(merges.length)ws['!merges']=(ws["!merges"]||[]).concat(merges);range.e.r=Math.max(range.e.r,R-1+or_R);ws['!ref']=encode_range(range);if(R>=sheetRows)ws['!fullref']=encode_range((range.e.r=rows.length-_R+R-1+or_R,range));return ws;}function parse_dom_table(table,_opts){var opts=_opts||{};var ws=opts.dense?[]:{};return sheet_add_dom(ws,table,_opts);}function table_to_book(table,opts){return sheet_to_workbook(parse_dom_table(table,opts),opts);}function is_dom_element_hidden(element){var display='';var get_computed_style=get_get_computed_style_function(element);if(get_computed_style)display=get_computed_style(element).getPropertyValue('display');if(!display)display=element.style&&element.style.display;return display==='none';}function get_get_computed_style_function(element){if(element.ownerDocument.defaultView&&typeof element.ownerDocument.defaultView.getComputedStyle==='function')return element.ownerDocument.defaultView.getComputedStyle;if(typeof getComputedStyle==='function')return getComputedStyle;return null;}function parse_text_p(text){var fixed=text.replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function($$,$1){return Array(parseInt($1,10)+1).join(" ");}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n");var v=unescapexml(fixed.replace(/<[^>]*>/g,""));return[v];}var number_formats_ods={day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],quarter:["\\Qm","m\\\"th quarter\""]};function parse_content_xml(d,_opts){var opts=_opts||{};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var str=xlml_normalize(d);var state=[],tmp;var tag;var NFtag={name:""},NF="",pidx=0;var sheetag;var rowtag;var Sheets={},SheetNames=[];var ws=opts.dense?[]:{};var Rn,q;var ctag={value:""};var textp="",textpidx=0,textptag;var textR=[];var R=-1,C=-1,range={s:{r:1000000,c:10000000},e:{r:0,c:0}};var row_ol=0;var number_format_map={};var merges=[],mrange={},mR=0,mC=0;var rowinfo=[],rowpeat=1,colpeat=1;var arrayf=[];var WB={Names:[]};var atag={};var _Ref=["",""];var comments=[],comment={};var creator="",creatoridx=0;var isstub=false,intable=false;var i=0;xlmlregex.lastIndex=0;str=str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");while(Rn=xlmlregex.exec(str)){switch(Rn[3]=Rn[3].replace(/_.*$/,"")){case'table':case'工作表':if(Rn[1]==='/'){if(range.e.c>=range.s.c&&range.e.r>=range.s.r)ws['!ref']=encode_range(range);else ws['!ref']="A1:A1";if(opts.sheetRows>0&&opts.sheetRows<=range.e.r){ws['!fullref']=ws['!ref'];range.e.r=opts.sheetRows-1;ws['!ref']=encode_range(range);}if(merges.length)ws['!merges']=merges;if(rowinfo.length)ws["!rows"]=rowinfo;sheetag.name=sheetag['名称']||sheetag.name;if(typeof JSON!=='undefined')(0,_stringify2.default)(sheetag);SheetNames.push(sheetag.name);Sheets[sheetag.name]=ws;intable=false;}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){sheetag=parsexmltag(Rn[0],false);R=C=-1;range.s.r=range.s.c=10000000;range.e.r=range.e.c=0;ws=opts.dense?[]:{};merges=[];rowinfo=[];intable=true;}break;case'table-row-group':if(Rn[1]==="/")--row_ol;else++row_ol;break;case'table-row':case'行':if(Rn[1]==='/'){R+=rowpeat;rowpeat=1;break;}rowtag=parsexmltag(Rn[0],false);if(rowtag['行号'])R=rowtag['行号']-1;else if(R==-1)R=0;rowpeat=+rowtag['number-rows-repeated']||1;if(rowpeat<10)for(i=0;i<rowpeat;++i){if(row_ol>0)rowinfo[R+i]={level:row_ol};}C=-1;break;case'covered-table-cell':if(Rn[1]!=='/')++C;if(opts.sheetStubs){if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]={t:'z'};}else ws[encode_cell({r:R,c:C})]={t:'z'};}textp="";textR=[];break;case'table-cell':case'数据':if(Rn[0].charAt(Rn[0].length-2)==='/'){++C;ctag=parsexmltag(Rn[0],false);colpeat=parseInt(ctag['number-columns-repeated']||"1",10);q={t:'z',v:null};if(ctag.formula&&opts.cellFormula!=false)q.f=ods_to_csf_formula(unescapexml(ctag.formula));if((ctag['数据类型']||ctag['value-type'])=="string"){q.t="s";q.v=unescapexml(ctag['string-value']||"");if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]=q;}else{ws[encode_cell({r:R,c:C})]=q;}}C+=colpeat-1;}else if(Rn[1]!=='/'){++C;textp="";textpidx=0;textR=[];colpeat=1;var rptR=rowpeat?R+rowpeat-1:R;if(C>range.e.c)range.e.c=C;if(C<range.s.c)range.s.c=C;if(R<range.s.r)range.s.r=R;if(rptR>range.e.r)range.e.r=rptR;ctag=parsexmltag(Rn[0],false);comments=[];comment={};q={t:ctag['数据类型']||ctag['value-type'],v:null};if(opts.cellFormula){if(ctag.formula)ctag.formula=unescapexml(ctag.formula);if(ctag['number-matrix-columns-spanned']&&ctag['number-matrix-rows-spanned']){mR=parseInt(ctag['number-matrix-rows-spanned'],10)||0;mC=parseInt(ctag['number-matrix-columns-spanned'],10)||0;mrange={s:{r:R,c:C},e:{r:R+mR-1,c:C+mC-1}};q.F=encode_range(mrange);arrayf.push([mrange,q.F]);}if(ctag.formula)q.f=ods_to_csf_formula(ctag.formula);else for(i=0;i<arrayf.length;++i){if(R>=arrayf[i][0].s.r&&R<=arrayf[i][0].e.r)if(C>=arrayf[i][0].s.c&&C<=arrayf[i][0].e.c)q.F=arrayf[i][1];}}if(ctag['number-columns-spanned']||ctag['number-rows-spanned']){mR=parseInt(ctag['number-rows-spanned'],10)||0;mC=parseInt(ctag['number-columns-spanned'],10)||0;mrange={s:{r:R,c:C},e:{r:R+mR-1,c:C+mC-1}};merges.push(mrange);}if(ctag['number-columns-repeated'])colpeat=parseInt(ctag['number-columns-repeated'],10);switch(q.t){case'boolean':q.t='b';q.v=parsexmlbool(ctag['boolean-value']);break;case'float':q.t='n';q.v=parseFloat(ctag.value);break;case'percentage':q.t='n';q.v=parseFloat(ctag.value);break;case'currency':q.t='n';q.v=parseFloat(ctag.value);break;case'date':q.t='d';q.v=parseDate(ctag['date-value']);if(!opts.cellDates){q.t='n';q.v=datenum(q.v);}q.z='m/d/yy';break;case'time':q.t='n';q.v=parse_isodur(ctag['time-value'])/86400;if(opts.cellDates){q.t='d';q.v=numdate(q.v);}q.z='HH:MM:SS';break;case'number':q.t='n';q.v=parseFloat(ctag['数据数值']);break;default:if(q.t==='string'||q.t==='text'||!q.t){q.t='s';if(ctag['string-value']!=null){textp=unescapexml(ctag['string-value']);textR=[];}}else throw new Error('Unsupported value type '+q.t);}}else{isstub=false;if(q.t==='s'){q.v=textp||'';if(textR.length)q.R=textR;isstub=textpidx==0;}if(atag.Target)q.l=atag;if(comments.length>0){q.c=comments;comments=[];}if(textp&&opts.cellText!==false)q.w=textp;if(isstub){q.t="z";delete q.v;}if(!isstub||opts.sheetStubs){if(!(opts.sheetRows&&opts.sheetRows<=R)){for(var rpt=0;rpt<rowpeat;++rpt){colpeat=parseInt(ctag['number-columns-repeated']||"1",10);if(opts.dense){if(!ws[R+rpt])ws[R+rpt]=[];ws[R+rpt][C]=rpt==0?q:dup(q);while(--colpeat>0){ws[R+rpt][C+colpeat]=dup(q);}}else{ws[encode_cell({r:R+rpt,c:C})]=q;while(--colpeat>0){ws[encode_cell({r:R+rpt,c:C+colpeat})]=dup(q);}}if(range.e.c<=C)range.e.c=C;}}}colpeat=parseInt(ctag['number-columns-repeated']||"1",10);C+=colpeat-1;colpeat=0;q={};textp="";textR=[];}atag={};break;case'document':case'document-content':case'电子表格文档':case'spreadsheet':case'主体':case'scripts':case'styles':case'font-face-decls':case'master-styles':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;case'annotation':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;comment.t=textp;if(textR.length)comment.R=textR;comment.a=creator;comments.push(comment);}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){state.push([Rn[3],false]);}creator="";creatoridx=0;textp="";textpidx=0;textR=[];break;case'creator':if(Rn[1]==='/'){creator=str.slice(creatoridx,Rn.index);}else creatoridx=Rn.index+Rn[0].length;break;case'meta':case'元数据':case'settings':case'config-item-set':case'config-item-map-indexed':case'config-item-map-entry':case'config-item-map-named':case'shapes':case'frame':case'text-box':case'image':case'data-pilot-tables':case'list-style':case'form':case'dde-links':case'event-listeners':case'chart':if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],false]);textp="";textpidx=0;textR=[];break;case'scientific-number':break;case'currency-symbol':break;case'currency-style':break;case'number-style':case'percentage-style':case'date-style':case'time-style':if(Rn[1]==='/'){number_format_map[NFtag.name]=NF;if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){NF="";NFtag=parsexmltag(Rn[0],false);state.push([Rn[3],true]);}break;case'script':break;case'libraries':break;case'automatic-styles':break;case'default-style':case'page-layout':break;case'style':break;case'map':break;case'font-face':break;case'paragraph-properties':break;case'table-properties':break;case'table-column-properties':break;case'table-row-properties':break;case'table-cell-properties':break;case'number':switch(state[state.length-1][0]){case'time-style':case'date-style':tag=parsexmltag(Rn[0],false);NF+=number_formats_ods[Rn[3]][tag.style==='long'?1:0];break;}break;case'fraction':break;case'day':case'month':case'year':case'era':case'day-of-week':case'week-of-year':case'quarter':case'hours':case'minutes':case'seconds':case'am-pm':switch(state[state.length-1][0]){case'time-style':case'date-style':tag=parsexmltag(Rn[0],false);NF+=number_formats_ods[Rn[3]][tag.style==='long'?1:0];break;}break;case'boolean-style':break;case'boolean':break;case'text-style':break;case'text':if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")switch(state[state.length-1][0]){case'number-style':case'date-style':case'time-style':NF+=str.slice(pidx,Rn.index);break;}else pidx=Rn.index+Rn[0].length;break;case'named-range':tag=parsexmltag(Rn[0],false);_Ref=ods_to_csf_3D(tag['cell-range-address']);var nrange={Name:tag.name,Ref:_Ref[0]+'!'+_Ref[1]};if(intable)nrange.Sheet=SheetNames.length;WB.Names.push(nrange);break;case'text-content':break;case'text-properties':break;case'embedded-text':break;case'body':case'电子表格':break;case'forms':break;case'table-column':break;case'table-header-rows':break;case'table-rows':break;case'table-column-group':break;case'table-header-columns':break;case'table-columns':break;case'null-date':break;case'graphic-properties':break;case'calculation-settings':break;case'named-expressions':break;case'label-range':break;case'label-ranges':break;case'named-expression':break;case'sort':break;case'sort-by':break;case'sort-groups':break;case'tab':break;case'line-break':break;case'span':break;case'p':case'文本串':if(['master-styles'].indexOf(state[state.length-1][0])>-1)break;if(Rn[1]==='/'&&(!ctag||!ctag['string-value'])){var ptp=parse_text_p(str.slice(textpidx,Rn.index),textptag);textp=(textp.length>0?textp+"\n":"")+ptp[0];}else{textptag=parsexmltag(Rn[0],false);textpidx=Rn.index+Rn[0].length;}break;case's':break;case'database-range':if(Rn[1]==='/')break;try{_Ref=ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);Sheets[_Ref[0]]['!autofilter']={ref:_Ref[1]};}catch(e){}break;case'date':break;case'object':break;case'title':case'标题':break;case'desc':break;case'binary-data':break;case'table-source':break;case'scenario':break;case'iteration':break;case'content-validations':break;case'content-validation':break;case'help-message':break;case'error-message':break;case'database-ranges':break;case'filter':break;case'filter-and':break;case'filter-or':break;case'filter-condition':break;case'list-level-style-bullet':break;case'list-level-style-number':break;case'list-level-properties':break;case'sender-firstname':case'sender-lastname':case'sender-initials':case'sender-title':case'sender-position':case'sender-email':case'sender-phone-private':case'sender-fax':case'sender-company':case'sender-phone-work':case'sender-street':case'sender-city':case'sender-postal-code':case'sender-country':case'sender-state-or-province':case'author-name':case'author-initials':case'chapter':case'file-name':case'template-name':case'sheet-name':break;case'event-listener':break;case'initial-creator':case'creation-date':case'print-date':case'generator':case'document-statistic':case'user-defined':case'editing-duration':case'editing-cycles':break;case'config-item':break;case'page-number':break;case'page-count':break;case'time':break;case'cell-range-source':break;case'detective':break;case'operation':break;case'highlighted-range':break;case'data-pilot-table':case'source-cell-range':case'source-service':case'data-pilot-field':case'data-pilot-level':case'data-pilot-subtotals':case'data-pilot-subtotal':case'data-pilot-members':case'data-pilot-member':case'data-pilot-display-info':case'data-pilot-sort-info':case'data-pilot-layout-info':case'data-pilot-field-reference':case'data-pilot-groups':case'data-pilot-group':case'data-pilot-group-member':break;case'rect':break;case'dde-connection-decls':case'dde-connection-decl':case'dde-link':case'dde-source':break;case'properties':break;case'property':break;case'a':if(Rn[1]!=='/'){atag=parsexmltag(Rn[0],false);if(!atag.href)break;atag.Target=unescapexml(atag.href);delete atag.href;if(atag.Target.charAt(0)=="#"&&atag.Target.indexOf(".")>-1){_Ref=ods_to_csf_3D(atag.Target.slice(1));atag.Target="#"+_Ref[0]+"!"+_Ref[1];}else if(atag.Target.match(/^\.\.[\\\/]/))atag.Target=atag.Target.slice(3);}break;case'table-protection':break;case'data-pilot-grand-total':break;case'office-document-common-attrs':break;default:switch(Rn[2]){case'dc:':case'calcext:':case'loext:':case'ooo:':case'chartooo:':case'draw:':case'style:':case'chart:':case'form:':case'uof:':case'表:':case'字:':break;default:if(opts.WTF)throw new Error(Rn);}}}var out={Sheets:Sheets,SheetNames:SheetNames,Workbook:WB};if(opts.bookSheets)delete out.Sheets;return out;}function parse_ods(zip,opts){opts=opts||{};if(safegetzipfile(zip,'META-INF/manifest.xml'))parse_manifest(getzipdata(zip,'META-INF/manifest.xml'),opts);var content=getzipstr(zip,'content.xml');if(!content)throw new Error("Missing content.xml in ODS / UOF file");var wb=parse_content_xml(utf8read(content),opts);if(safegetzipfile(zip,'meta.xml'))wb.Props=parse_core_props(getzipdata(zip,'meta.xml'));return wb;}function parse_fods(data,opts){return parse_content_xml(data,opts);}var write_styles_ods=function(){var master_styles=['<office:master-styles>','<style:master-page style:name="mp1" style:page-layout-name="mp1">','<style:header/>','<style:header-left style:display="false"/>','<style:footer/>','<style:footer-left style:display="false"/>','</style:master-page>','</office:master-styles>'].join("");var payload='<office:document-styles '+wxt_helper({'xmlns:office':"urn:oasis:names:tc:opendocument:xmlns:office:1.0",'xmlns:table':"urn:oasis:names:tc:opendocument:xmlns:table:1.0",'xmlns:style':"urn:oasis:names:tc:opendocument:xmlns:style:1.0",'xmlns:text':"urn:oasis:names:tc:opendocument:xmlns:text:1.0",'xmlns:draw':"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",'xmlns:fo':"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",'xmlns:xlink':"http://www.w3.org/1999/xlink",'xmlns:dc':"http://purl.org/dc/elements/1.1/",'xmlns:number':"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",'xmlns:svg':"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",'xmlns:of':"urn:oasis:names:tc:opendocument:xmlns:of:1.2",'office:version':"1.2"})+'>'+master_styles+'</office:document-styles>';return function wso(){return XML_HEADER+payload;};}();var write_content_ods=function(){var write_text_p=function write_text_p(text){return escapexml(text).replace(/  +/g,function($$){return'<text:s text:c="'+$$.length+'"/>';}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"</text:p><text:p>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>");};var null_cell_xml='          <table:table-cell />\n';var covered_cell_xml='          <table:covered-table-cell/>\n';var write_ws=function write_ws(ws,wb,i){var o=[];o.push('      <table:table table:name="'+escapexml(wb.SheetNames[i])+'" table:style-name="ta1">\n');var R=0,C=0,range=decode_range(ws['!ref']||"A1");var marr=ws['!merges']||[],mi=0;var dense=Array.isArray(ws);if(ws["!cols"]){for(C=0;C<=range.e.c;++C){o.push('        <table:table-column'+(ws["!cols"][C]?' table:style-name="co'+ws["!cols"][C].ods+'"':'')+'></table:table-column>\n');}}var H="",ROWS=ws["!rows"]||[];for(R=0;R<range.s.r;++R){H=ROWS[R]?' table:style-name="ro'+ROWS[R].ods+'"':"";o.push('        <table:table-row'+H+'></table:table-row>\n');}for(;R<=range.e.r;++R){H=ROWS[R]?' table:style-name="ro'+ROWS[R].ods+'"':"";o.push('        <table:table-row'+H+'>\n');for(C=0;C<range.s.c;++C){o.push(null_cell_xml);}for(;C<=range.e.c;++C){var skip=false,ct={},textp="";for(mi=0;mi!=marr.length;++mi){if(marr[mi].s.c>C)continue;if(marr[mi].s.r>R)continue;if(marr[mi].e.c<C)continue;if(marr[mi].e.r<R)continue;if(marr[mi].s.c!=C||marr[mi].s.r!=R)skip=true;ct['table:number-columns-spanned']=marr[mi].e.c-marr[mi].s.c+1;ct['table:number-rows-spanned']=marr[mi].e.r-marr[mi].s.r+1;break;}if(skip){o.push(covered_cell_xml);continue;}var ref=encode_cell({r:R,c:C}),cell=dense?(ws[R]||[])[C]:ws[ref];if(cell&&cell.f){ct['table:formula']=escapexml(csf_to_ods_formula(cell.f));if(cell.F){if(cell.F.slice(0,ref.length)==ref){var _Fref=decode_range(cell.F);ct['table:number-matrix-columns-spanned']=_Fref.e.c-_Fref.s.c+1;ct['table:number-matrix-rows-spanned']=_Fref.e.r-_Fref.s.r+1;}}}if(!cell){o.push(null_cell_xml);continue;}switch(cell.t){case'b':textp=cell.v?'TRUE':'FALSE';ct['office:value-type']="boolean";ct['office:boolean-value']=cell.v?'true':'false';break;case'n':textp=cell.w||String(cell.v||0);ct['office:value-type']="float";ct['office:value']=cell.v||0;break;case's':case'str':textp=cell.v==null?"":cell.v;ct['office:value-type']="string";break;case'd':textp=cell.w||parseDate(cell.v).toISOString();ct['office:value-type']="date";ct['office:date-value']=parseDate(cell.v).toISOString();ct['table:style-name']="ce1";break;default:o.push(null_cell_xml);continue;}var text_p=write_text_p(textp);if(cell.l&&cell.l.Target){var _tgt=cell.l.Target;_tgt=_tgt.charAt(0)=="#"?"#"+csf_to_ods_3D(_tgt.slice(1)):_tgt;if(_tgt.charAt(0)!="#"&&!_tgt.match(/^\w+:/))_tgt='../'+_tgt;text_p=writextag('text:a',text_p,{'xlink:href':_tgt.replace(/&/g,"&amp;")});}o.push('          '+writextag('table:table-cell',writextag('text:p',text_p,{}),ct)+'\n');}o.push('        </table:table-row>\n');}o.push('      </table:table>\n');return o.join("");};var write_automatic_styles_ods=function write_automatic_styles_ods(o,wb){o.push(' <office:automatic-styles>\n');o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');o.push('   <number:month number:style="long"/>\n');o.push('   <number:text>/</number:text>\n');o.push('   <number:day number:style="long"/>\n');o.push('   <number:text>/</number:text>\n');o.push('   <number:year/>\n');o.push('  </number:date-style>\n');var cidx=0;wb.SheetNames.map(function(n){return wb.Sheets[n];}).forEach(function(ws){if(!ws)return;if(ws["!cols"]){for(var C=0;C<ws["!cols"].length;++C){if(ws["!cols"][C]){var colobj=ws["!cols"][C];if(colobj.width==null&&colobj.wpx==null&&colobj.wch==null)continue;process_col(colobj);colobj.ods=cidx;var w=ws["!cols"][C].wpx+"px";o.push('  <style:style style:name="co'+cidx+'" style:family="table-column">\n');o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="'+w+'"/>\n');o.push('  </style:style>\n');++cidx;}}}});var ridx=0;wb.SheetNames.map(function(n){return wb.Sheets[n];}).forEach(function(ws){if(!ws)return;if(ws["!rows"]){for(var R=0;R<ws["!rows"].length;++R){if(ws["!rows"][R]){ws["!rows"][R].ods=ridx;var h=ws["!rows"][R].hpx+"px";o.push('  <style:style style:name="ro'+ridx+'" style:family="table-row">\n');o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="'+h+'"/>\n');o.push('  </style:style>\n');++ridx;}}}});o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');o.push('  </style:style>\n');o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');o.push(' </office:automatic-styles>\n');};return function wcx(wb,opts){var o=[XML_HEADER];var attr=wxt_helper({'xmlns:office':"urn:oasis:names:tc:opendocument:xmlns:office:1.0",'xmlns:table':"urn:oasis:names:tc:opendocument:xmlns:table:1.0",'xmlns:style':"urn:oasis:names:tc:opendocument:xmlns:style:1.0",'xmlns:text':"urn:oasis:names:tc:opendocument:xmlns:text:1.0",'xmlns:draw':"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",'xmlns:fo':"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",'xmlns:xlink':"http://www.w3.org/1999/xlink",'xmlns:dc':"http://purl.org/dc/elements/1.1/",'xmlns:meta':"urn:oasis:names:tc:opendocument:xmlns:meta:1.0",'xmlns:number':"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",'xmlns:presentation':"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",'xmlns:svg':"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",'xmlns:chart':"urn:oasis:names:tc:opendocument:xmlns:chart:1.0",'xmlns:dr3d':"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",'xmlns:math':"http://www.w3.org/1998/Math/MathML",'xmlns:form':"urn:oasis:names:tc:opendocument:xmlns:form:1.0",'xmlns:script':"urn:oasis:names:tc:opendocument:xmlns:script:1.0",'xmlns:ooo':"http://openoffice.org/2004/office",'xmlns:ooow':"http://openoffice.org/2004/writer",'xmlns:oooc':"http://openoffice.org/2004/calc",'xmlns:dom':"http://www.w3.org/2001/xml-events",'xmlns:xforms':"http://www.w3.org/2002/xforms",'xmlns:xsd':"http://www.w3.org/2001/XMLSchema",'xmlns:xsi':"http://www.w3.org/2001/XMLSchema-instance",'xmlns:sheet':"urn:oasis:names:tc:opendocument:sh33tjs:1.0",'xmlns:rpt':"http://openoffice.org/2005/report",'xmlns:of':"urn:oasis:names:tc:opendocument:xmlns:of:1.2",'xmlns:xhtml':"http://www.w3.org/1999/xhtml",'xmlns:grddl':"http://www.w3.org/2003/g/data-view#",'xmlns:tableooo':"http://openoffice.org/2009/table",'xmlns:drawooo':"http://openoffice.org/2010/draw",'xmlns:calcext':"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",'xmlns:loext':"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",'xmlns:field':"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",'xmlns:formx':"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",'xmlns:css3t':"http://www.w3.org/TR/css3-text/",'office:version':"1.2"});var fods=wxt_helper({'xmlns:config':"urn:oasis:names:tc:opendocument:xmlns:config:1.0",'office:mimetype':"application/vnd.oasis.opendocument.spreadsheet"});if(opts.bookType=="fods"){o.push('<office:document'+attr+fods+'>\n');o.push(write_meta_ods().replace(/office:document-meta/g,"office:meta"));}else o.push('<office:document-content'+attr+'>\n');write_automatic_styles_ods(o,wb);o.push('  <office:body>\n');o.push('    <office:spreadsheet>\n');for(var i=0;i!=wb.SheetNames.length;++i){o.push(write_ws(wb.Sheets[wb.SheetNames[i]],wb,i,opts));}o.push('    </office:spreadsheet>\n');o.push('  </office:body>\n');if(opts.bookType=="fods")o.push('</office:document>');else o.push('</office:document-content>');return o.join("");};}();function write_ods(wb,opts){if(opts.bookType=="fods")return write_content_ods(wb,opts);var zip=zip_new();var f="";var manifest=[];var rdf=[];f="mimetype";zip_add_file(zip,f,"application/vnd.oasis.opendocument.spreadsheet");f="content.xml";zip_add_file(zip,f,write_content_ods(wb,opts));manifest.push([f,"text/xml"]);rdf.push([f,"ContentFile"]);f="styles.xml";zip_add_file(zip,f,write_styles_ods(wb,opts));manifest.push([f,"text/xml"]);rdf.push([f,"StylesFile"]);f="meta.xml";zip_add_file(zip,f,XML_HEADER+write_meta_ods());manifest.push([f,"text/xml"]);rdf.push([f,"MetadataFile"]);f="manifest.rdf";zip_add_file(zip,f,write_rdf(rdf));manifest.push([f,"application/rdf+xml"]);f="META-INF/manifest.xml";zip_add_file(zip,f,write_manifest(manifest));return zip;}function u8_to_dataview(array){return new DataView(array.buffer,array.byteOffset,array.byteLength);}function u8str(u8){return typeof TextDecoder!="undefined"?new TextDecoder().decode(u8):utf8read(a2s(u8));}function stru8(str){return typeof TextEncoder!="undefined"?new TextEncoder().encode(str):s2a(utf8write(str));}function u8contains(body,search){outer:for(var L=0;L<=body.length-search.length;++L){for(var j=0;j<search.length;++j){if(body[L+j]!=search[j])continue outer;}return true;}return false;}function u8concat(u8a){var len=u8a.reduce(function(acc,x){return acc+x.length;},0);var out=new Uint8Array(len);var off=0;u8a.forEach(function(u8){out.set(u8,off);off+=u8.length;});return out;}function popcnt(x){x-=x>>1&1431655765;x=(x&858993459)+(x>>2&858993459);return(x+(x>>4)&252645135)*16843009>>>24;}function readDecimal128LE(buf,offset){var exp=(buf[offset+15]&127)<<7|buf[offset+14]>>1;var mantissa=buf[offset+14]&1;for(var j=offset+13;j>=offset;--j){mantissa=mantissa*256+buf[j];}return(buf[offset+15]&128?-mantissa:mantissa)*Math.pow(10,exp-6176);}function writeDecimal128LE(buf,offset,value){var exp=Math.floor(value==0?0:Math.LOG10E*Math.log(Math.abs(value)))+6176-20;var mantissa=value/Math.pow(10,exp-6176);buf[offset+15]|=exp>>7;buf[offset+14]|=(exp&127)<<1;for(var i=0;mantissa>=1;++i,mantissa/=256){buf[offset+i]=mantissa&255;}buf[offset+15]|=value>=0?0:128;}function parse_varint49(buf,ptr){var l=ptr?ptr[0]:0;var usz=buf[l]&127;varint:if(buf[l++]>=128){usz|=(buf[l]&127)<<7;if(buf[l++]<128)break varint;usz|=(buf[l]&127)<<14;if(buf[l++]<128)break varint;usz|=(buf[l]&127)<<21;if(buf[l++]<128)break varint;usz+=(buf[l]&127)*Math.pow(2,28);++l;if(buf[l++]<128)break varint;usz+=(buf[l]&127)*Math.pow(2,35);++l;if(buf[l++]<128)break varint;usz+=(buf[l]&127)*Math.pow(2,42);++l;if(buf[l++]<128)break varint;}if(ptr)ptr[0]=l;return usz;}function write_varint49(v){var usz=new Uint8Array(7);usz[0]=v&127;var L=1;sz:if(v>127){usz[L-1]|=128;usz[L]=v>>7&127;++L;if(v<=16383)break sz;usz[L-1]|=128;usz[L]=v>>14&127;++L;if(v<=2097151)break sz;usz[L-1]|=128;usz[L]=v>>21&127;++L;if(v<=268435455)break sz;usz[L-1]|=128;usz[L]=v/256>>>21&127;++L;if(v<=34359738367)break sz;usz[L-1]|=128;usz[L]=v/65536>>>21&127;++L;if(v<=4398046511103)break sz;usz[L-1]|=128;usz[L]=v/16777216>>>21&127;++L;}return usz.slice(0,L);}function varint_to_i32(buf){var l=0,i32=buf[l]&127;varint:if(buf[l++]>=128){i32|=(buf[l]&127)<<7;if(buf[l++]<128)break varint;i32|=(buf[l]&127)<<14;if(buf[l++]<128)break varint;i32|=(buf[l]&127)<<21;if(buf[l++]<128)break varint;i32|=(buf[l]&127)<<28;}return i32;}function parse_shallow(buf){var out=[],ptr=[0];while(ptr[0]<buf.length){var off=ptr[0];var num=parse_varint49(buf,ptr);var type=num&7;num=Math.floor(num/8);var len=0;var res;if(num==0)break;switch(type){case 0:{var l=ptr[0];while(buf[ptr[0]++]>=128){}res=buf.slice(l,ptr[0]);}break;case 5:len=4;res=buf.slice(ptr[0],ptr[0]+len);ptr[0]+=len;break;case 1:len=8;res=buf.slice(ptr[0],ptr[0]+len);ptr[0]+=len;break;case 2:len=parse_varint49(buf,ptr);res=buf.slice(ptr[0],ptr[0]+len);ptr[0]+=len;break;case 3:case 4:default:throw new Error("PB Type ".concat(type," for Field ").concat(num," at offset ").concat(off));}var v={data:res,type:type};if(out[num]==null)out[num]=[v];else out[num].push(v);}return out;}function write_shallow(proto){var out=[];proto.forEach(function(field,idx){field.forEach(function(item){if(!item.data)return;out.push(write_varint49(idx*8+item.type));if(item.type==2)out.push(write_varint49(item.data.length));out.push(item.data);});});return u8concat(out);}function mappa(data,cb){return(data==null?void 0:data.map(function(d){return cb(d.data);}))||[];}function parse_iwa_file(buf){var _a;var out=[],ptr=[0];while(ptr[0]<buf.length){var len=parse_varint49(buf,ptr);var ai=parse_shallow(buf.slice(ptr[0],ptr[0]+len));ptr[0]+=len;var res={id:varint_to_i32(ai[1][0].data),messages:[]};ai[2].forEach(function(b){var mi=parse_shallow(b.data);var fl=varint_to_i32(mi[3][0].data);res.messages.push({meta:mi,data:buf.slice(ptr[0],ptr[0]+fl)});ptr[0]+=fl;});if((_a=ai[3])==null?void 0:_a[0])res.merge=varint_to_i32(ai[3][0].data)>>>0>0;out.push(res);}return out;}function write_iwa_file(ias){var bufs=[];ias.forEach(function(ia){var ai=[];ai[1]=[{data:write_varint49(ia.id),type:0}];ai[2]=[];if(ia.merge!=null)ai[3]=[{data:write_varint49(+!!ia.merge),type:0}];var midata=[];ia.messages.forEach(function(mi){midata.push(mi.data);mi.meta[3]=[{type:0,data:write_varint49(mi.data.length)}];ai[2].push({data:write_shallow(mi.meta),type:2});});var aipayload=write_shallow(ai);bufs.push(write_varint49(aipayload.length));bufs.push(aipayload);midata.forEach(function(mid){return bufs.push(mid);});});return u8concat(bufs);}function parse_snappy_chunk(type,buf){if(type!=0)throw new Error("Unexpected Snappy chunk type ".concat(type));var ptr=[0];var usz=parse_varint49(buf,ptr);var chunks=[];while(ptr[0]<buf.length){var tag=buf[ptr[0]]&3;if(tag==0){var len=buf[ptr[0]++]>>2;if(len<60)++len;else{var c=len-59;len=buf[ptr[0]];if(c>1)len|=buf[ptr[0]+1]<<8;if(c>2)len|=buf[ptr[0]+2]<<16;if(c>3)len|=buf[ptr[0]+3]<<24;len>>>=0;len++;ptr[0]+=c;}chunks.push(buf.slice(ptr[0],ptr[0]+len));ptr[0]+=len;continue;}else{var offset=0,length=0;if(tag==1){length=(buf[ptr[0]]>>2&7)+4;offset=(buf[ptr[0]++]&224)<<3;offset|=buf[ptr[0]++];}else{length=(buf[ptr[0]++]>>2)+1;if(tag==2){offset=buf[ptr[0]]|buf[ptr[0]+1]<<8;ptr[0]+=2;}else{offset=(buf[ptr[0]]|buf[ptr[0]+1]<<8|buf[ptr[0]+2]<<16|buf[ptr[0]+3]<<24)>>>0;ptr[0]+=4;}}chunks=[u8concat(chunks)];if(offset==0)throw new Error("Invalid offset 0");if(offset>chunks[0].length)throw new Error("Invalid offset beyond length");if(length>=offset){chunks.push(chunks[0].slice(-offset));length-=offset;while(length>=chunks[chunks.length-1].length){chunks.push(chunks[chunks.length-1]);length-=chunks[chunks.length-1].length;}}chunks.push(chunks[0].slice(-offset,-offset+length));}}var o=u8concat(chunks);if(o.length!=usz)throw new Error("Unexpected length: ".concat(o.length," != ").concat(usz));return o;}function decompress_iwa_file(buf){var out=[];var l=0;while(l<buf.length){var t=buf[l++];var len=buf[l]|buf[l+1]<<8|buf[l+2]<<16;l+=3;out.push(parse_snappy_chunk(t,buf.slice(l,l+len)));l+=len;}if(l!==buf.length)throw new Error("data is not a valid framed stream!");return u8concat(out);}function compress_iwa_file(buf){var out=[];var l=0;while(l<buf.length){var c=Math.min(buf.length-l,268435455);var frame=new Uint8Array(4);out.push(frame);var usz=write_varint49(c);var L=usz.length;out.push(usz);if(c<=60){L++;out.push(new Uint8Array([c-1<<2]));}else if(c<=256){L+=2;out.push(new Uint8Array([240,c-1&255]));}else if(c<=65536){L+=3;out.push(new Uint8Array([244,c-1&255,c-1>>8&255]));}else if(c<=16777216){L+=4;out.push(new Uint8Array([248,c-1&255,c-1>>8&255,c-1>>16&255]));}else if(c<=4294967296){L+=5;out.push(new Uint8Array([252,c-1&255,c-1>>8&255,c-1>>16&255,c-1>>>24&255]));}out.push(buf.slice(l,l+c));L+=c;frame[0]=0;frame[1]=L&255;frame[2]=L>>8&255;frame[3]=L>>16&255;l+=c;}return u8concat(out);}function parse_old_storage(buf,sst,rsst,v){var dv=u8_to_dataview(buf);var flags=dv.getUint32(4,true);var data_offset=(v>1?12:8)+popcnt(flags&(v>1?3470:398))*4;var ridx=-1,sidx=-1,ieee=NaN,dt=new Date(2001,0,1);if(flags&512){ridx=dv.getUint32(data_offset,true);data_offset+=4;}data_offset+=popcnt(flags&(v>1?12288:4096))*4;if(flags&16){sidx=dv.getUint32(data_offset,true);data_offset+=4;}if(flags&32){ieee=dv.getFloat64(data_offset,true);data_offset+=8;}if(flags&64){dt.setTime(dt.getTime()+dv.getFloat64(data_offset,true)*1e3);data_offset+=8;}var ret;switch(buf[2]){case 0:break;case 2:ret={t:"n",v:ieee};break;case 3:ret={t:"s",v:sst[sidx]};break;case 5:ret={t:"d",v:dt};break;case 6:ret={t:"b",v:ieee>0};break;case 7:ret={t:"n",v:ieee/86400};break;case 8:ret={t:"e",v:0};break;case 9:{if(ridx>-1)ret={t:"s",v:rsst[ridx]};else if(sidx>-1)ret={t:"s",v:sst[sidx]};else if(!isNaN(ieee))ret={t:"n",v:ieee};else throw new Error("Unsupported cell type ".concat(buf.slice(0,4)));}break;default:throw new Error("Unsupported cell type ".concat(buf.slice(0,4)));}return ret;}function parse_new_storage(buf,sst,rsst){var dv=u8_to_dataview(buf);var flags=dv.getUint32(8,true);var data_offset=12;var ridx=-1,sidx=-1,d128=NaN,ieee=NaN,dt=new Date(2001,0,1);if(flags&1){d128=readDecimal128LE(buf,data_offset);data_offset+=16;}if(flags&2){ieee=dv.getFloat64(data_offset,true);data_offset+=8;}if(flags&4){dt.setTime(dt.getTime()+dv.getFloat64(data_offset,true)*1e3);data_offset+=8;}if(flags&8){sidx=dv.getUint32(data_offset,true);data_offset+=4;}if(flags&16){ridx=dv.getUint32(data_offset,true);data_offset+=4;}var ret;switch(buf[1]){case 0:break;case 2:ret={t:"n",v:d128};break;case 3:ret={t:"s",v:sst[sidx]};break;case 5:ret={t:"d",v:dt};break;case 6:ret={t:"b",v:ieee>0};break;case 7:ret={t:"n",v:ieee/86400};break;case 8:ret={t:"e",v:0};break;case 9:{if(ridx>-1)ret={t:"s",v:rsst[ridx]};else throw new Error("Unsupported cell type ".concat(buf[1]," : ").concat(flags&31," : ").concat(buf.slice(0,4)));}break;case 10:ret={t:"n",v:d128};break;default:throw new Error("Unsupported cell type ".concat(buf[1]," : ").concat(flags&31," : ").concat(buf.slice(0,4)));}return ret;}function write_new_storage(cell,sst){var out=new Uint8Array(32),dv=u8_to_dataview(out),l=12,flags=0;out[0]=5;switch(cell.t){case"n":out[1]=2;writeDecimal128LE(out,l,cell.v);flags|=1;l+=16;break;case"b":out[1]=6;dv.setFloat64(l,cell.v?1:0,true);flags|=2;l+=8;break;case"s":if(sst.indexOf(cell.v)==-1)throw new Error("Value ".concat(cell.v," missing from SST!"));out[1]=3;dv.setUint32(l,sst.indexOf(cell.v),true);flags|=8;l+=4;break;default:throw"unsupported cell type "+cell.t;}dv.setUint32(8,flags,true);return out.slice(0,l);}function write_old_storage(cell,sst){var out=new Uint8Array(32),dv=u8_to_dataview(out),l=12,flags=0;out[0]=3;switch(cell.t){case"n":out[2]=2;dv.setFloat64(l,cell.v,true);flags|=32;l+=8;break;case"b":out[2]=6;dv.setFloat64(l,cell.v?1:0,true);flags|=32;l+=8;break;case"s":if(sst.indexOf(cell.v)==-1)throw new Error("Value ".concat(cell.v," missing from SST!"));out[2]=3;dv.setUint32(l,sst.indexOf(cell.v),true);flags|=16;l+=4;break;default:throw"unsupported cell type "+cell.t;}dv.setUint32(4,flags,true);return out.slice(0,l);}function parse_cell_storage(buf,sst,rsst){switch(buf[0]){case 0:case 1:case 2:case 3:return parse_old_storage(buf,sst,rsst,buf[0]);case 5:return parse_new_storage(buf,sst,rsst);default:throw new Error("Unsupported payload version ".concat(buf[0]));}}function parse_TSP_Reference(buf){var pb=parse_shallow(buf);return parse_varint49(pb[1][0].data);}function write_TSP_Reference(idx){var out=[];out[1]=[{type:0,data:write_varint49(idx)}];return write_shallow(out);}function parse_TST_TableDataList(M,root){var pb=parse_shallow(root.data);var type=varint_to_i32(pb[1][0].data);var entries=pb[3];var data=[];(entries||[]).forEach(function(entry){var le=parse_shallow(entry.data);var key=varint_to_i32(le[1][0].data)>>>0;switch(type){case 1:data[key]=u8str(le[3][0].data);break;case 8:{var rt=M[parse_TSP_Reference(le[9][0].data)][0];var rtp=parse_shallow(rt.data);var rtpref=M[parse_TSP_Reference(rtp[1][0].data)][0];var mtype=varint_to_i32(rtpref.meta[1][0].data);if(mtype!=2001)throw new Error("2000 unexpected reference to ".concat(mtype));var tswpsa=parse_shallow(rtpref.data);data[key]=tswpsa[3].map(function(x){return u8str(x.data);}).join("");}break;}});return data;}function parse_TST_TileRowInfo(u8,type){var _a,_b,_c,_d,_e,_f,_g,_h,_i,_j,_k,_l,_m,_n;var pb=parse_shallow(u8);var R=varint_to_i32(pb[1][0].data)>>>0;var cnt=varint_to_i32(pb[2][0].data)>>>0;var wide_offsets=((_b=(_a=pb[8])==null?void 0:_a[0])==null?void 0:_b.data)&&varint_to_i32(pb[8][0].data)>0||false;var used_storage_u8,used_storage;if(((_d=(_c=pb[7])==null?void 0:_c[0])==null?void 0:_d.data)&&type!=0){used_storage_u8=(_f=(_e=pb[7])==null?void 0:_e[0])==null?void 0:_f.data;used_storage=(_h=(_g=pb[6])==null?void 0:_g[0])==null?void 0:_h.data;}else if(((_j=(_i=pb[4])==null?void 0:_i[0])==null?void 0:_j.data)&&type!=1){used_storage_u8=(_l=(_k=pb[4])==null?void 0:_k[0])==null?void 0:_l.data;used_storage=(_n=(_m=pb[3])==null?void 0:_m[0])==null?void 0:_n.data;}else throw"NUMBERS Tile missing ".concat(type," cell storage");var width=wide_offsets?4:1;var used_storage_offsets=u8_to_dataview(used_storage_u8);var offsets=[];for(var C=0;C<used_storage_u8.length/2;++C){var off=used_storage_offsets.getUint16(C*2,true);if(off<65535)offsets.push([C,off]);}if(offsets.length!=cnt)throw"Expected ".concat(cnt," cells, found ").concat(offsets.length);var cells=[];for(C=0;C<offsets.length-1;++C){cells[offsets[C][0]]=used_storage.subarray(offsets[C][1]*width,offsets[C+1][1]*width);}if(offsets.length>=1)cells[offsets[offsets.length-1][0]]=used_storage.subarray(offsets[offsets.length-1][1]*width);return{R:R,cells:cells};}function parse_TST_Tile(M,root){var _a;var pb=parse_shallow(root.data);var storage=((_a=pb==null?void 0:pb[7])==null?void 0:_a[0])?varint_to_i32(pb[7][0].data)>>>0>0?1:0:-1;var ri=mappa(pb[5],function(u8){return parse_TST_TileRowInfo(u8,storage);});return{nrows:varint_to_i32(pb[4][0].data)>>>0,data:ri.reduce(function(acc,x){if(!acc[x.R])acc[x.R]=[];x.cells.forEach(function(cell,C){if(acc[x.R][C])throw new Error("Duplicate cell r=".concat(x.R," c=").concat(C));acc[x.R][C]=cell;});return acc;},[])};}function parse_TST_TableModelArchive(M,root,ws){var _a;var pb=parse_shallow(root.data);var range={s:{r:0,c:0},e:{r:0,c:0}};range.e.r=(varint_to_i32(pb[6][0].data)>>>0)-1;if(range.e.r<0)throw new Error("Invalid row varint ".concat(pb[6][0].data));range.e.c=(varint_to_i32(pb[7][0].data)>>>0)-1;if(range.e.c<0)throw new Error("Invalid col varint ".concat(pb[7][0].data));ws["!ref"]=encode_range(range);var store=parse_shallow(pb[4][0].data);var sst=parse_TST_TableDataList(M,M[parse_TSP_Reference(store[4][0].data)][0]);var rsst=((_a=store[17])==null?void 0:_a[0])?parse_TST_TableDataList(M,M[parse_TSP_Reference(store[17][0].data)][0]):[];var tile=parse_shallow(store[3][0].data);var _R=0;tile[1].forEach(function(t){var tl=parse_shallow(t.data);var ref=M[parse_TSP_Reference(tl[2][0].data)][0];var mtype=varint_to_i32(ref.meta[1][0].data);if(mtype!=6002)throw new Error("6001 unexpected reference to ".concat(mtype));var _tile=parse_TST_Tile(M,ref);_tile.data.forEach(function(row,R){row.forEach(function(buf,C){var addr=encode_cell({r:_R+R,c:C});var res=parse_cell_storage(buf,sst,rsst);if(res)ws[addr]=res;});});_R+=_tile.nrows;});}function parse_TST_TableInfoArchive(M,root){var pb=parse_shallow(root.data);var out={"!ref":"A1"};var tableref=M[parse_TSP_Reference(pb[2][0].data)];var mtype=varint_to_i32(tableref[0].meta[1][0].data);if(mtype!=6001)throw new Error("6000 unexpected reference to ".concat(mtype));parse_TST_TableModelArchive(M,tableref[0],out);return out;}function parse_TN_SheetArchive(M,root){var _a;var pb=parse_shallow(root.data);var out={name:((_a=pb[1])==null?void 0:_a[0])?u8str(pb[1][0].data):"",sheets:[]};var shapeoffs=mappa(pb[2],parse_TSP_Reference);shapeoffs.forEach(function(off){M[off].forEach(function(m){var mtype=varint_to_i32(m.meta[1][0].data);if(mtype==6e3)out.sheets.push(parse_TST_TableInfoArchive(M,m));});});return out;}function parse_TN_DocumentArchive(M,root){var out=book_new();var pb=parse_shallow(root.data);var sheetoffs=mappa(pb[1],parse_TSP_Reference);sheetoffs.forEach(function(off){M[off].forEach(function(m){var mtype=varint_to_i32(m.meta[1][0].data);if(mtype==2){var root2=parse_TN_SheetArchive(M,m);root2.sheets.forEach(function(sheet,idx){book_append_sheet(out,sheet,idx==0?root2.name:root2.name+"_"+idx,true);});}});});if(out.SheetNames.length==0)throw new Error("Empty NUMBERS file");return out;}function parse_numbers_iwa(cfb){var _a,_b,_c,_d;var M={},indices=[];cfb.FullPaths.forEach(function(p){if(p.match(/\.iwpv2/))throw new Error("Unsupported password protection");});cfb.FileIndex.forEach(function(s){if(!s.name.match(/\.iwa$/))return;var o;try{o=decompress_iwa_file(s.content);}catch(e){return console.log("?? "+s.content.length+" "+(e.message||e));}var packets;try{packets=parse_iwa_file(o);}catch(e){return console.log("## "+(e.message||e));}packets.forEach(function(packet){M[packet.id]=packet.messages;indices.push(packet.id);});});if(!indices.length)throw new Error("File has no messages");var docroot=((_d=(_c=(_b=(_a=M==null?void 0:M[1])==null?void 0:_a[0])==null?void 0:_b.meta)==null?void 0:_c[1])==null?void 0:_d[0].data)&&varint_to_i32(M[1][0].meta[1][0].data)==1&&M[1][0];if(!docroot)indices.forEach(function(idx){M[idx].forEach(function(iwam){var mtype=varint_to_i32(iwam.meta[1][0].data)>>>0;if(mtype==1){if(!docroot)docroot=iwam;else throw new Error("Document has multiple roots");}});});if(!docroot)throw new Error("Cannot find Document root");return parse_TN_DocumentArchive(M,docroot);}function write_tile_row(tri,data,SST){var _a,_b,_c,_d;if(!((_a=tri[6])==null?void 0:_a[0])||!((_b=tri[7])==null?void 0:_b[0]))throw"Mutation only works on post-BNC storages!";var wide_offsets=((_d=(_c=tri[8])==null?void 0:_c[0])==null?void 0:_d.data)&&varint_to_i32(tri[8][0].data)>0||false;if(wide_offsets)throw"Math only works with normal offsets";var cnt=0;var dv=u8_to_dataview(tri[7][0].data),last_offset=0,cell_storage=[];var _dv=u8_to_dataview(tri[4][0].data),_last_offset=0,_cell_storage=[];for(var C=0;C<data.length;++C){if(data[C]==null){dv.setUint16(C*2,65535,true);_dv.setUint16(C*2,65535);continue;}dv.setUint16(C*2,last_offset,true);_dv.setUint16(C*2,_last_offset,true);var celload,_celload;switch((0,_typeof3.default)(data[C])){case"string":celload=write_new_storage({t:"s",v:data[C]},SST);_celload=write_old_storage({t:"s",v:data[C]},SST);break;case"number":celload=write_new_storage({t:"n",v:data[C]},SST);_celload=write_old_storage({t:"n",v:data[C]},SST);break;case"boolean":celload=write_new_storage({t:"b",v:data[C]},SST);_celload=write_old_storage({t:"b",v:data[C]},SST);break;default:throw new Error("Unsupported value "+data[C]);}cell_storage.push(celload);last_offset+=celload.length;_cell_storage.push(_celload);_last_offset+=_celload.length;++cnt;}tri[2][0].data=write_varint49(cnt);for(;C<tri[7][0].data.length/2;++C){dv.setUint16(C*2,65535,true);_dv.setUint16(C*2,65535,true);}tri[6][0].data=u8concat(cell_storage);tri[3][0].data=u8concat(_cell_storage);return cnt;}function write_numbers_iwa(wb,opts){if(!opts||!opts.numbers)throw new Error("Must pass a `numbers` option -- check the README");var ws=wb.Sheets[wb.SheetNames[0]];if(wb.SheetNames.length>1)console.error("The Numbers writer currently writes only the first table");var range=decode_range(ws["!ref"]);range.s.r=range.s.c=0;var trunc=false;if(range.e.c>9){trunc=true;range.e.c=9;}if(range.e.r>49){trunc=true;range.e.r=49;}if(trunc)console.error("The Numbers writer is currently limited to ".concat(encode_range(range)));var data=sheet_to_json(ws,{range:range,header:1});var SST=["~Sh33tJ5~"];data.forEach(function(row){return row.forEach(function(cell){if(typeof cell=="string")SST.push(cell);});});var dependents={};var indices=[];var cfb=CFB.read(opts.numbers,{type:"base64"});cfb.FileIndex.map(function(fi,idx){return[fi,cfb.FullPaths[idx]];}).forEach(function(row){var fi=row[0],fp=row[1];if(fi.type!=2)return;if(!fi.name.match(/\.iwa/))return;var old_content=fi.content;var raw1=decompress_iwa_file(old_content);var x2=parse_iwa_file(raw1);x2.forEach(function(packet2){indices.push(packet2.id);dependents[packet2.id]={deps:[],location:fp,type:varint_to_i32(packet2.messages[0].meta[1][0].data)};});});indices.sort(function(x2,y2){return x2-y2;});var indices_varint=indices.filter(function(x2){return x2>1;}).map(function(x2){return[x2,write_varint49(x2)];});cfb.FileIndex.map(function(fi,idx){return[fi,cfb.FullPaths[idx]];}).forEach(function(row){var fi=row[0],fp=row[1];if(!fi.name.match(/\.iwa/))return;var x2=parse_iwa_file(decompress_iwa_file(fi.content));x2.forEach(function(ia){ia.messages.forEach(function(m){indices_varint.forEach(function(ivi){if(ia.messages.some(function(mess){return varint_to_i32(mess.meta[1][0].data)!=11006&&u8contains(mess.data,ivi[1]);})){dependents[ivi[0]].deps.push(ia.id);}});});});});function get_unique_msgid(){for(var i=927262;i<2e6;++i){if(!dependents[i])return i;}throw new Error("Too many messages");}var entry=CFB.find(cfb,dependents[1].location);var x=parse_iwa_file(decompress_iwa_file(entry.content));var docroot;for(var xi=0;xi<x.length;++xi){var packet=x[xi];if(packet.id==1)docroot=packet;}var sheetrootref=parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);entry=CFB.find(cfb,dependents[sheetrootref].location);x=parse_iwa_file(decompress_iwa_file(entry.content));for(xi=0;xi<x.length;++xi){packet=x[xi];if(packet.id==sheetrootref)docroot=packet;}sheetrootref=parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);entry=CFB.find(cfb,dependents[sheetrootref].location);x=parse_iwa_file(decompress_iwa_file(entry.content));for(xi=0;xi<x.length;++xi){packet=x[xi];if(packet.id==sheetrootref)docroot=packet;}sheetrootref=parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);entry=CFB.find(cfb,dependents[sheetrootref].location);x=parse_iwa_file(decompress_iwa_file(entry.content));for(xi=0;xi<x.length;++xi){packet=x[xi];if(packet.id==sheetrootref)docroot=packet;}var pb=parse_shallow(docroot.messages[0].data);{pb[6][0].data=write_varint49(range.e.r+1);pb[7][0].data=write_varint49(range.e.c+1);var cruidsref=parse_TSP_Reference(pb[46][0].data);var oldbucket=CFB.find(cfb,dependents[cruidsref].location);var _x=parse_iwa_file(decompress_iwa_file(oldbucket.content));{for(var j=0;j<_x.length;++j){if(_x[j].id==cruidsref)break;}if(_x[j].id!=cruidsref)throw"Bad ColumnRowUIDMapArchive";var cruids=parse_shallow(_x[j].messages[0].data);cruids[1]=[];cruids[2]=[],cruids[3]=[];for(var C=0;C<=range.e.c;++C){var uuid=[];uuid[1]=uuid[2]=[{type:0,data:write_varint49(C+420690)}];cruids[1].push({type:2,data:write_shallow(uuid)});cruids[2].push({type:0,data:write_varint49(C)});cruids[3].push({type:0,data:write_varint49(C)});}cruids[4]=[];cruids[5]=[],cruids[6]=[];for(var R=0;R<=range.e.r;++R){uuid=[];uuid[1]=uuid[2]=[{type:0,data:write_varint49(R+726270)}];cruids[4].push({type:2,data:write_shallow(uuid)});cruids[5].push({type:0,data:write_varint49(R)});cruids[6].push({type:0,data:write_varint49(R)});}_x[j].messages[0].data=write_shallow(cruids);}oldbucket.content=compress_iwa_file(write_iwa_file(_x));oldbucket.size=oldbucket.content.length;delete pb[46];var store=parse_shallow(pb[4][0].data);{store[7][0].data=write_varint49(range.e.r+1);var row_headers=parse_shallow(store[1][0].data);var row_header_ref=parse_TSP_Reference(row_headers[2][0].data);oldbucket=CFB.find(cfb,dependents[row_header_ref].location);_x=parse_iwa_file(decompress_iwa_file(oldbucket.content));{if(_x[0].id!=row_header_ref)throw"Bad HeaderStorageBucket";var base_bucket=parse_shallow(_x[0].messages[0].data);for(R=0;R<data.length;++R){var _bucket=parse_shallow(base_bucket[2][0].data);_bucket[1][0].data=write_varint49(R);_bucket[4][0].data=write_varint49(data[R].length);base_bucket[2][R]={type:base_bucket[2][0].type,data:write_shallow(_bucket)};}_x[0].messages[0].data=write_shallow(base_bucket);}oldbucket.content=compress_iwa_file(write_iwa_file(_x));oldbucket.size=oldbucket.content.length;var col_header_ref=parse_TSP_Reference(store[2][0].data);oldbucket=CFB.find(cfb,dependents[col_header_ref].location);_x=parse_iwa_file(decompress_iwa_file(oldbucket.content));{if(_x[0].id!=col_header_ref)throw"Bad HeaderStorageBucket";base_bucket=parse_shallow(_x[0].messages[0].data);for(C=0;C<=range.e.c;++C){_bucket=parse_shallow(base_bucket[2][0].data);_bucket[1][0].data=write_varint49(C);_bucket[4][0].data=write_varint49(range.e.r+1);base_bucket[2][C]={type:base_bucket[2][0].type,data:write_shallow(_bucket)};}_x[0].messages[0].data=write_shallow(base_bucket);}oldbucket.content=compress_iwa_file(write_iwa_file(_x));oldbucket.size=oldbucket.content.length;var sstref=parse_TSP_Reference(store[4][0].data);(function(){var sentry=CFB.find(cfb,dependents[sstref].location);var sx=parse_iwa_file(decompress_iwa_file(sentry.content));var sstroot;for(var sxi=0;sxi<sx.length;++sxi){var packet2=sx[sxi];if(packet2.id==sstref)sstroot=packet2;}var sstdata=parse_shallow(sstroot.messages[0].data);{sstdata[3]=[];var newsst=[];SST.forEach(function(str,i){newsst[1]=[{type:0,data:write_varint49(i)}];newsst[2]=[{type:0,data:write_varint49(1)}];newsst[3]=[{type:2,data:stru8(str)}];sstdata[3].push({type:2,data:write_shallow(newsst)});});}sstroot.messages[0].data=write_shallow(sstdata);var sy=write_iwa_file(sx);var raw32=compress_iwa_file(sy);sentry.content=raw32;sentry.size=sentry.content.length;})();var tile=parse_shallow(store[3][0].data);{var t=tile[1][0];delete tile[2];var tl=parse_shallow(t.data);{var tileref=parse_TSP_Reference(tl[2][0].data);(function(){var tentry=CFB.find(cfb,dependents[tileref].location);var tx=parse_iwa_file(decompress_iwa_file(tentry.content));var tileroot;for(var sxi=0;sxi<tx.length;++sxi){var packet2=tx[sxi];if(packet2.id==tileref)tileroot=packet2;}var tiledata=parse_shallow(tileroot.messages[0].data);{delete tiledata[6];delete tile[7];var rowload=new Uint8Array(tiledata[5][0].data);tiledata[5]=[];var cnt=0;for(var R2=0;R2<=range.e.r;++R2){var tilerow=parse_shallow(rowload);cnt+=write_tile_row(tilerow,data[R2],SST);tilerow[1][0].data=write_varint49(R2);tiledata[5].push({data:write_shallow(tilerow),type:2});}tiledata[1]=[{type:0,data:write_varint49(range.e.c+1)}];tiledata[2]=[{type:0,data:write_varint49(range.e.r+1)}];tiledata[3]=[{type:0,data:write_varint49(cnt)}];tiledata[4]=[{type:0,data:write_varint49(range.e.r+1)}];}tileroot.messages[0].data=write_shallow(tiledata);var ty=write_iwa_file(tx);var raw32=compress_iwa_file(ty);tentry.content=raw32;tentry.size=tentry.content.length;})();}t.data=write_shallow(tl);}store[3][0].data=write_shallow(tile);}pb[4][0].data=write_shallow(store);}docroot.messages[0].data=write_shallow(pb);var y=write_iwa_file(x);var raw3=compress_iwa_file(y);entry.content=raw3;entry.size=entry.content.length;return cfb;}function fix_opts_func(defaults){return function fix_opts(opts){for(var i=0;i!=defaults.length;++i){var d=defaults[i];if(opts[d[0]]===undefined)opts[d[0]]=d[1];if(d[2]==='n')opts[d[0]]=Number(opts[d[0]]);}};}function fix_read_opts(opts){fix_opts_func([['cellNF',false],['cellHTML',true],['cellFormula',true],['cellStyles',false],['cellText',true],['cellDates',false],['sheetStubs',false],['sheetRows',0,'n'],['bookDeps',false],['bookSheets',false],['bookProps',false],['bookFiles',false],['bookVBA',false],['password',''],['WTF',false]])(opts);}function fix_write_opts(opts){fix_opts_func([['cellDates',false],['bookSST',false],['bookType','xlsx'],['compression',false],['WTF',false]])(opts);}function get_sheet_type(n){if(RELS.WS.indexOf(n)>-1)return"sheet";if(RELS.CS&&n==RELS.CS)return"chart";if(RELS.DS&&n==RELS.DS)return"dialog";if(RELS.MS&&n==RELS.MS)return"macro";return n&&n.length?n:"sheet";}function safe_parse_wbrels(wbrels,sheets){if(!wbrels)return 0;try{wbrels=sheets.map(function pwbr(w){if(!w.id)w.id=w.strRelID;return[w.name,wbrels['!id'][w.id].Target,get_sheet_type(wbrels['!id'][w.id].Type)];});}catch(e){return null;}return!wbrels||wbrels.length===0?null:wbrels;}function safe_parse_sheet(zip,path,relsPath,sheet,idx,sheetRels,sheets,stype,opts,wb,themes,styles){try{sheetRels[sheet]=parse_rels(getzipstr(zip,relsPath,true),path);var data=getzipdata(zip,path);var _ws;switch(stype){case'sheet':_ws=parse_ws(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;case'chart':_ws=parse_cs(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);if(!_ws||!_ws['!drawel'])break;var dfile=resolve_path(_ws['!drawel'].Target,path);var drelsp=get_rels_path(dfile);var draw=parse_drawing(getzipstr(zip,dfile,true),parse_rels(getzipstr(zip,drelsp,true),dfile));var chartp=resolve_path(draw,dfile);var crelsp=get_rels_path(chartp);_ws=parse_chart(getzipstr(zip,chartp,true),chartp,opts,parse_rels(getzipstr(zip,crelsp,true),chartp),wb,_ws);break;case'macro':_ws=parse_ms(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;case'dialog':_ws=parse_ds(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;default:throw new Error("Unrecognized sheet type "+stype);}sheets[sheet]=_ws;var tcomments=[];if(sheetRels&&sheetRels[sheet])keys(sheetRels[sheet]).forEach(function(n){var dfile="";if(sheetRels[sheet][n].Type==RELS.CMNT){dfile=resolve_path(sheetRels[sheet][n].Target,path);var comments=parse_cmnt(getzipdata(zip,dfile,true),dfile,opts);if(!comments||!comments.length)return;sheet_insert_comments(_ws,comments,false);}if(sheetRels[sheet][n].Type==RELS.TCMNT){dfile=resolve_path(sheetRels[sheet][n].Target,path);tcomments=tcomments.concat(parse_tcmnt_xml(getzipdata(zip,dfile,true),opts));}});if(tcomments&&tcomments.length)sheet_insert_comments(_ws,tcomments,true,opts.people||[]);}catch(e){if(opts.WTF)throw e;}}function strip_front_slash(x){return x.charAt(0)=='/'?x.slice(1):x;}function parse_zip(zip,opts){make_ssf();opts=opts||{};fix_read_opts(opts);if(safegetzipfile(zip,'META-INF/manifest.xml'))return parse_ods(zip,opts);if(safegetzipfile(zip,'objectdata.xml'))return parse_ods(zip,opts);if(safegetzipfile(zip,'Index/Document.iwa')){if(typeof Uint8Array=="undefined")throw new Error('NUMBERS file parsing requires Uint8Array support');if(typeof parse_numbers_iwa!="undefined"){if(zip.FileIndex)return parse_numbers_iwa(zip);var _zip=CFB.utils.cfb_new();zipentries(zip).forEach(function(e){zip_add_file(_zip,e,getzipbin(zip,e));});return parse_numbers_iwa(_zip);}throw new Error('Unsupported NUMBERS file');}if(!safegetzipfile(zip,'[Content_Types].xml')){if(safegetzipfile(zip,'index.xml.gz'))throw new Error('Unsupported NUMBERS 08 file');if(safegetzipfile(zip,'index.xml'))throw new Error('Unsupported NUMBERS 09 file');throw new Error('Unsupported ZIP file');}var entries=zipentries(zip);var dir=parse_ct(getzipstr(zip,'[Content_Types].xml'));var xlsb=false;var sheets,binname;if(dir.workbooks.length===0){binname="xl/workbook.xml";if(getzipdata(zip,binname,true))dir.workbooks.push(binname);}if(dir.workbooks.length===0){binname="xl/workbook.bin";if(!getzipdata(zip,binname,true))throw new Error("Could not find workbook");dir.workbooks.push(binname);xlsb=true;}if(dir.workbooks[0].slice(-3)=="bin")xlsb=true;var themes={};var styles={};if(!opts.bookSheets&&!opts.bookProps){strs=[];if(dir.sst)try{strs=parse_sst(getzipdata(zip,strip_front_slash(dir.sst)),dir.sst,opts);}catch(e){if(opts.WTF)throw e;}if(opts.cellStyles&&dir.themes.length)themes=parse_theme(getzipstr(zip,dir.themes[0].replace(/^\//,''),true)||"",dir.themes[0],opts);if(dir.style)styles=parse_sty(getzipdata(zip,strip_front_slash(dir.style)),dir.style,themes,opts);}dir.links.map(function(link){try{var rels=parse_rels(getzipstr(zip,get_rels_path(strip_front_slash(link))),link);return parse_xlink(getzipdata(zip,strip_front_slash(link)),rels,link,opts);}catch(e){}});var wb=parse_wb(getzipdata(zip,strip_front_slash(dir.workbooks[0])),dir.workbooks[0],opts);var props={},propdata="";if(dir.coreprops.length){propdata=getzipdata(zip,strip_front_slash(dir.coreprops[0]),true);if(propdata)props=parse_core_props(propdata);if(dir.extprops.length!==0){propdata=getzipdata(zip,strip_front_slash(dir.extprops[0]),true);if(propdata)parse_ext_props(propdata,props,opts);}}var custprops={};if(!opts.bookSheets||opts.bookProps){if(dir.custprops.length!==0){propdata=getzipstr(zip,strip_front_slash(dir.custprops[0]),true);if(propdata)custprops=parse_cust_props(propdata,opts);}}var out={};if(opts.bookSheets||opts.bookProps){if(wb.Sheets)sheets=wb.Sheets.map(function pluck(x){return x.name;});else if(props.Worksheets&&props.SheetNames.length>0)sheets=props.SheetNames;if(opts.bookProps){out.Props=props;out.Custprops=custprops;}if(opts.bookSheets&&typeof sheets!=='undefined')out.SheetNames=sheets;if(opts.bookSheets?out.SheetNames:opts.bookProps)return out;}sheets={};var deps={};if(opts.bookDeps&&dir.calcchain)deps=parse_cc(getzipdata(zip,strip_front_slash(dir.calcchain)),dir.calcchain,opts);var i=0;var sheetRels={};var path,relsPath;{var wbsheets=wb.Sheets;props.Worksheets=wbsheets.length;props.SheetNames=[];for(var j=0;j!=wbsheets.length;++j){props.SheetNames[j]=wbsheets[j].name;}}var wbext=xlsb?"bin":"xml";var wbrelsi=dir.workbooks[0].lastIndexOf("/");var wbrelsfile=(dir.workbooks[0].slice(0,wbrelsi+1)+"_rels/"+dir.workbooks[0].slice(wbrelsi+1)+".rels").replace(/^\//,"");if(!safegetzipfile(zip,wbrelsfile))wbrelsfile='xl/_rels/workbook.'+wbext+'.rels';var wbrels=parse_rels(getzipstr(zip,wbrelsfile,true),wbrelsfile.replace(/_rels.*/,"s5s"));if((dir.metadata||[]).length>=1){opts.xlmeta=parse_xlmeta(getzipdata(zip,strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);}if((dir.people||[]).length>=1){opts.people=parse_people_xml(getzipdata(zip,strip_front_slash(dir.people[0])),opts);}if(wbrels)wbrels=safe_parse_wbrels(wbrels,wb.Sheets);var nmode=getzipdata(zip,"xl/worksheets/sheet.xml",true)?1:0;wsloop:for(i=0;i!=props.Worksheets;++i){var stype="sheet";if(wbrels&&wbrels[i]){path='xl/'+wbrels[i][1].replace(/[\/]?xl\//,"");if(!safegetzipfile(zip,path))path=wbrels[i][1];if(!safegetzipfile(zip,path))path=wbrelsfile.replace(/_rels\/.*$/,"")+wbrels[i][1];stype=wbrels[i][2];}else{path='xl/worksheets/sheet'+(i+1-nmode)+"."+wbext;path=path.replace(/sheet0\./,"sheet.");}relsPath=path.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");if(opts&&opts.sheets!=null)switch((0,_typeof3.default)(opts.sheets)){case"number":if(i!=opts.sheets)continue wsloop;break;case"string":if(props.SheetNames[i].toLowerCase()!=opts.sheets.toLowerCase())continue wsloop;break;default:if(Array.isArray&&Array.isArray(opts.sheets)){var snjseen=false;for(var snj=0;snj!=opts.sheets.length;++snj){if(typeof opts.sheets[snj]=="number"&&opts.sheets[snj]==i)snjseen=1;if(typeof opts.sheets[snj]=="string"&&opts.sheets[snj].toLowerCase()==props.SheetNames[i].toLowerCase())snjseen=1;}if(!snjseen)continue wsloop;}}safe_parse_sheet(zip,path,relsPath,props.SheetNames[i],i,sheetRels,sheets,stype,opts,wb,themes,styles);}out={Directory:dir,Workbook:wb,Props:props,Custprops:custprops,Deps:deps,Sheets:sheets,SheetNames:props.SheetNames,Strings:strs,Styles:styles,Themes:themes,SSF:dup(table_fmt)};if(opts&&opts.bookFiles){if(zip.files){out.keys=entries;out.files=zip.files;}else{out.keys=[];out.files={};zip.FullPaths.forEach(function(p,idx){p=p.replace(/^Root Entry[\/]/,"");out.keys.push(p);out.files[p]=zip.FileIndex[idx];});}}if(opts&&opts.bookVBA){if(dir.vba.length>0)out.vbaraw=getzipdata(zip,strip_front_slash(dir.vba[0]),true);else if(dir.defaults&&dir.defaults.bin===CT_VBA)out.vbaraw=getzipdata(zip,'xl/vbaProject.bin',true);}return out;}function parse_xlsxcfb(cfb,_opts){var opts=_opts||{};var f='Workbook',data=CFB.find(cfb,f);try{f='/!DataSpaces/Version';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);parse_DataSpaceVersionInfo(data.content);f='/!DataSpaces/DataSpaceMap';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var dsm=parse_DataSpaceMap(data.content);if(dsm.length!==1||dsm[0].comps.length!==1||dsm[0].comps[0].t!==0||dsm[0].name!=="StrongEncryptionDataSpace"||dsm[0].comps[0].v!=="EncryptedPackage")throw new Error("ECMA-376 Encrypted file bad "+f);f='/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var seds=parse_DataSpaceDefinition(data.content);if(seds.length!=1||seds[0]!="StrongEncryptionTransform")throw new Error("ECMA-376 Encrypted file bad "+f);f='/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);parse_Primary(data.content);}catch(e){}f='/EncryptionInfo';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var einfo=parse_EncryptionInfo(data.content);f='/EncryptedPackage';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);if(einfo[0]==0x04&&typeof decrypt_agile!=='undefined')return decrypt_agile(einfo[1],data.content,opts.password||"",opts);if(einfo[0]==0x02&&typeof decrypt_std76!=='undefined')return decrypt_std76(einfo[1],data.content,opts.password||"",opts);throw new Error("File is password-protected");}function write_zip(wb,opts){if(opts.bookType=="ods")return write_ods(wb,opts);if(opts.bookType=="numbers")return write_numbers_iwa(wb,opts);if(opts.bookType=="xlsb")return write_zip_xlsxb(wb,opts);return write_zip_xlsx(wb,opts);}function write_zip_xlsxb(wb,opts){_shapeid=1024;if(wb&&!wb.SSF){wb.SSF=dup(table_fmt);}if(wb&&wb.SSF){make_ssf();SSF_load_table(wb.SSF);opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;}opts.rels={};opts.wbrels={};opts.Strings=[];opts.Strings.Count=0;opts.Strings.Unique=0;if(browser_has_Map)opts.revStrings=new _map2.default();else{opts.revStrings={};opts.revStrings.foo=[];delete opts.revStrings.foo;}var wbext=opts.bookType=="xlsb"?"bin":"xml";var vbafmt=VBAFMTS.indexOf(opts.bookType)>-1;var ct=new_ct();fix_write_opts(opts=opts||{});var zip=zip_new();var f="",rId=0;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};f="docProps/core.xml";zip_add_file(zip,f,write_core_props(wb.Props,opts));ct.coreprops.push(f);add_rels(opts.rels,2,f,RELS.CORE_PROPS);f="docProps/app.xml";if(wb.Props&&wb.Props.SheetNames){}else if(!wb.Workbook||!wb.Workbook.Sheets)wb.Props.SheetNames=wb.SheetNames;else{var _sn=[];for(var _i=0;_i<wb.SheetNames.length;++_i){if((wb.Workbook.Sheets[_i]||{}).Hidden!=2)_sn.push(wb.SheetNames[_i]);}wb.Props.SheetNames=_sn;}wb.Props.Worksheets=wb.Props.SheetNames.length;zip_add_file(zip,f,write_ext_props(wb.Props,opts));ct.extprops.push(f);add_rels(opts.rels,3,f,RELS.EXT_PROPS);if(wb.Custprops!==wb.Props&&keys(wb.Custprops||{}).length>0){f="docProps/custom.xml";zip_add_file(zip,f,write_cust_props(wb.Custprops,opts));ct.custprops.push(f);add_rels(opts.rels,4,f,RELS.CUST_PROPS);}for(rId=1;rId<=wb.SheetNames.length;++rId){var wsrels={'!id':{}};var ws=wb.Sheets[wb.SheetNames[rId-1]];var _type=(ws||{})["!type"]||"sheet";switch(_type){case"chart":default:f="xl/worksheets/sheet"+rId+"."+wbext;zip_add_file(zip,f,write_ws(rId-1,f,opts,wb,wsrels));ct.sheets.push(f);add_rels(opts.wbrels,-1,"worksheets/sheet"+rId+"."+wbext,RELS.WS[0]);}if(ws){var comments=ws['!comments'];var need_vml=false;var cf="";if(comments&&comments.length>0){cf="xl/comments"+rId+"."+wbext;zip_add_file(zip,cf,write_cmnt(comments,cf,opts));ct.comments.push(cf);add_rels(wsrels,-1,"../comments"+rId+"."+wbext,RELS.CMNT);need_vml=true;}if(ws['!legacy']){if(need_vml)zip_add_file(zip,"xl/drawings/vmlDrawing"+rId+".vml",write_comments_vml(rId,ws['!comments']));}delete ws['!comments'];delete ws['!legacy'];}if(wsrels['!id'].rId1)zip_add_file(zip,get_rels_path(f),write_rels(wsrels));}if(opts.Strings!=null&&opts.Strings.length>0){f="xl/sharedStrings."+wbext;zip_add_file(zip,f,write_sst(opts.Strings,f,opts));ct.strs.push(f);add_rels(opts.wbrels,-1,"sharedStrings."+wbext,RELS.SST);}f="xl/workbook."+wbext;zip_add_file(zip,f,write_wb(wb,f,opts));ct.workbooks.push(f);add_rels(opts.rels,1,f,RELS.WB);f="xl/theme/theme1.xml";zip_add_file(zip,f,write_theme(wb.Themes,opts));ct.themes.push(f);add_rels(opts.wbrels,-1,"theme/theme1.xml",RELS.THEME);f="xl/styles."+wbext;zip_add_file(zip,f,write_sty(wb,f,opts));ct.styles.push(f);add_rels(opts.wbrels,-1,"styles."+wbext,RELS.STY);if(wb.vbaraw&&vbafmt){f="xl/vbaProject.bin";zip_add_file(zip,f,wb.vbaraw);ct.vba.push(f);add_rels(opts.wbrels,-1,"vbaProject.bin",RELS.VBA);}f="xl/metadata."+wbext;zip_add_file(zip,f,write_xlmeta(f));ct.metadata.push(f);add_rels(opts.wbrels,-1,"metadata."+wbext,RELS.XLMETA);zip_add_file(zip,"[Content_Types].xml",write_ct(ct,opts));zip_add_file(zip,'_rels/.rels',write_rels(opts.rels));zip_add_file(zip,'xl/_rels/workbook.'+wbext+'.rels',write_rels(opts.wbrels));delete opts.revssf;delete opts.ssf;return zip;}function write_zip_xlsx(wb,opts){_shapeid=1024;if(wb&&!wb.SSF){wb.SSF=dup(table_fmt);}if(wb&&wb.SSF){make_ssf();SSF_load_table(wb.SSF);opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;}opts.rels={};opts.wbrels={};opts.Strings=[];opts.Strings.Count=0;opts.Strings.Unique=0;if(browser_has_Map)opts.revStrings=new _map2.default();else{opts.revStrings={};opts.revStrings.foo=[];delete opts.revStrings.foo;}var wbext="xml";var vbafmt=VBAFMTS.indexOf(opts.bookType)>-1;var ct=new_ct();fix_write_opts(opts=opts||{});var zip=zip_new();var f="",rId=0;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};f="docProps/core.xml";zip_add_file(zip,f,write_core_props(wb.Props,opts));ct.coreprops.push(f);add_rels(opts.rels,2,f,RELS.CORE_PROPS);f="docProps/app.xml";if(wb.Props&&wb.Props.SheetNames){}else if(!wb.Workbook||!wb.Workbook.Sheets)wb.Props.SheetNames=wb.SheetNames;else{var _sn=[];for(var _i=0;_i<wb.SheetNames.length;++_i){if((wb.Workbook.Sheets[_i]||{}).Hidden!=2)_sn.push(wb.SheetNames[_i]);}wb.Props.SheetNames=_sn;}wb.Props.Worksheets=wb.Props.SheetNames.length;zip_add_file(zip,f,write_ext_props(wb.Props,opts));ct.extprops.push(f);add_rels(opts.rels,3,f,RELS.EXT_PROPS);if(wb.Custprops!==wb.Props&&keys(wb.Custprops||{}).length>0){f="docProps/custom.xml";zip_add_file(zip,f,write_cust_props(wb.Custprops,opts));ct.custprops.push(f);add_rels(opts.rels,4,f,RELS.CUST_PROPS);}var people=["SheetJ5"];opts.tcid=0;for(rId=1;rId<=wb.SheetNames.length;++rId){var wsrels={'!id':{}};var ws=wb.Sheets[wb.SheetNames[rId-1]];var _type=(ws||{})["!type"]||"sheet";switch(_type){case"chart":default:f="xl/worksheets/sheet"+rId+"."+wbext;zip_add_file(zip,f,write_ws_xml(rId-1,opts,wb,wsrels));ct.sheets.push(f);add_rels(opts.wbrels,-1,"worksheets/sheet"+rId+"."+wbext,RELS.WS[0]);}if(ws){var comments=ws['!comments'];var need_vml=false;var cf="";if(comments&&comments.length>0){var needtc=false;comments.forEach(function(carr){carr[1].forEach(function(c){if(c.T==true)needtc=true;});});if(needtc){cf="xl/threadedComments/threadedComment"+rId+"."+wbext;zip_add_file(zip,cf,write_tcmnt_xml(comments,people,opts));ct.threadedcomments.push(cf);add_rels(wsrels,-1,"../threadedComments/threadedComment"+rId+"."+wbext,RELS.TCMNT);}cf="xl/comments"+rId+"."+wbext;zip_add_file(zip,cf,write_comments_xml(comments,opts));ct.comments.push(cf);add_rels(wsrels,-1,"../comments"+rId+"."+wbext,RELS.CMNT);need_vml=true;}if(ws['!legacy']){if(need_vml)zip_add_file(zip,"xl/drawings/vmlDrawing"+rId+".vml",write_comments_vml(rId,ws['!comments']));}delete ws['!comments'];delete ws['!legacy'];}if(wsrels['!id'].rId1)zip_add_file(zip,get_rels_path(f),write_rels(wsrels));}if(opts.Strings!=null&&opts.Strings.length>0){f="xl/sharedStrings."+wbext;zip_add_file(zip,f,write_sst_xml(opts.Strings,opts));ct.strs.push(f);add_rels(opts.wbrels,-1,"sharedStrings."+wbext,RELS.SST);}f="xl/workbook."+wbext;zip_add_file(zip,f,write_wb_xml(wb,opts));ct.workbooks.push(f);add_rels(opts.rels,1,f,RELS.WB);f="xl/theme/theme1.xml";zip_add_file(zip,f,write_theme(wb.Themes,opts));ct.themes.push(f);add_rels(opts.wbrels,-1,"theme/theme1.xml",RELS.THEME);f="xl/styles."+wbext;zip_add_file(zip,f,write_sty_xml(wb,opts));ct.styles.push(f);add_rels(opts.wbrels,-1,"styles."+wbext,RELS.STY);if(wb.vbaraw&&vbafmt){f="xl/vbaProject.bin";zip_add_file(zip,f,wb.vbaraw);ct.vba.push(f);add_rels(opts.wbrels,-1,"vbaProject.bin",RELS.VBA);}f="xl/metadata."+wbext;zip_add_file(zip,f,write_xlmeta_xml());ct.metadata.push(f);add_rels(opts.wbrels,-1,"metadata."+wbext,RELS.XLMETA);if(people.length>1){f="xl/persons/person.xml";zip_add_file(zip,f,write_people_xml(people,opts));ct.people.push(f);add_rels(opts.wbrels,-1,"persons/person.xml",RELS.PEOPLE);}zip_add_file(zip,"[Content_Types].xml",write_ct(ct,opts));zip_add_file(zip,'_rels/.rels',write_rels(opts.rels));zip_add_file(zip,'xl/_rels/workbook.'+wbext+'.rels',write_rels(opts.wbrels));delete opts.revssf;delete opts.ssf;return zip;}function firstbyte(f,o){var x="";switch((o||{}).type||"base64"){case'buffer':return[f[0],f[1],f[2],f[3],f[4],f[5],f[6],f[7]];case'base64':x=Base64_decode(f.slice(0,12));break;case'binary':x=f;break;case'array':return[f[0],f[1],f[2],f[3],f[4],f[5],f[6],f[7]];default:throw new Error("Unrecognized type "+(o&&o.type||"undefined"));}return[x.charCodeAt(0),x.charCodeAt(1),x.charCodeAt(2),x.charCodeAt(3),x.charCodeAt(4),x.charCodeAt(5),x.charCodeAt(6),x.charCodeAt(7)];}function read_cfb(cfb,opts){if(CFB.find(cfb,"EncryptedPackage"))return parse_xlsxcfb(cfb,opts);return parse_xlscfb(cfb,opts);}function read_zip(data,opts){var zip,d=data;var o=opts||{};if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";zip=zip_read(d,o);return parse_zip(zip,o);}function read_plaintext(data,o){var i=0;main:while(i<data.length){switch(data.charCodeAt(i)){case 0x0A:case 0x0D:case 0x20:++i;break;case 0x3C:return parse_xlml(data.slice(i),o);default:break main;}}return PRN.to_workbook(data,o);}function read_plaintext_raw(data,o){var str="",bytes=firstbyte(data,o);switch(o.type){case'base64':str=Base64_decode(data);break;case'binary':str=data;break;case'buffer':str=data.toString('binary');break;case'array':str=cc2str(data);break;default:throw new Error("Unrecognized type "+o.type);}if(bytes[0]==0xEF&&bytes[1]==0xBB&&bytes[2]==0xBF)str=utf8read(str);o.type="binary";return read_plaintext(str,o);}function read_utf16(data,o){var d=data;if(o.type=='base64')d=Base64_decode(d);d=$cptable.utils.decode(1200,d.slice(2),'str');o.type="binary";return read_plaintext(d,o);}function bstrify(data){return!data.match(/[^\x00-\x7F]/)?data:utf8write(data);}function read_prn(data,d,o,str){if(str){o.type="string";return PRN.to_workbook(data,o);}return PRN.to_workbook(d,o);}function readSync(data,opts){reset_cp();var o=opts||{};if(typeof ArrayBuffer!=='undefined'&&data instanceof ArrayBuffer)return readSync(new Uint8Array(data),(o=dup(o),o.type="array",o));if(typeof Uint8Array!=='undefined'&&data instanceof Uint8Array&&!o.type)o.type=typeof Deno!=="undefined"?"buffer":"array";var d=data,n=[0,0,0,0],str=false;if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}_ssfopts={};if(o.dateNF)_ssfopts.dateNF=o.dateNF;if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";if(o.type=="file"){o.type=has_buf?"buffer":"binary";d=read_binary(data);if(typeof Uint8Array!=='undefined'&&!has_buf)o.type="array";}if(o.type=="string"){str=true;o.type="binary";o.codepage=65001;d=bstrify(data);}if(o.type=='array'&&typeof Uint8Array!=='undefined'&&data instanceof Uint8Array&&typeof ArrayBuffer!=='undefined'){var ab=new ArrayBuffer(3),vu=new Uint8Array(ab);vu.foo="bar";if(!vu.foo){o=dup(o);o.type='array';return readSync(ab2a(d),o);}}switch((n=firstbyte(d,o))[0]){case 0xD0:if(n[1]===0xCF&&n[2]===0x11&&n[3]===0xE0&&n[4]===0xA1&&n[5]===0xB1&&n[6]===0x1A&&n[7]===0xE1)return read_cfb(CFB.read(d,o),o);break;case 0x09:if(n[1]<=0x08)return parse_xlscfb(d,o);break;case 0x3C:return parse_xlml(d,o);case 0x49:if(n[1]===0x49&&n[2]===0x2a&&n[3]===0x00)throw new Error("TIFF Image File is not a spreadsheet");if(n[1]===0x44)return read_wb_ID(d,o);break;case 0x54:if(n[1]===0x41&&n[2]===0x42&&n[3]===0x4C)return DIF.to_workbook(d,o);break;case 0x50:return n[1]===0x4B&&n[2]<0x09&&n[3]<0x09?read_zip(d,o):read_prn(data,d,o,str);case 0xEF:return n[3]===0x3C?parse_xlml(d,o):read_prn(data,d,o,str);case 0xFF:if(n[1]===0xFE){return read_utf16(d,o);}else if(n[1]===0x00&&n[2]===0x02&&n[3]===0x00)return WK_.to_workbook(d,o);break;case 0x00:if(n[1]===0x00){if(n[2]>=0x02&&n[3]===0x00)return WK_.to_workbook(d,o);if(n[2]===0x00&&(n[3]===0x08||n[3]===0x09))return WK_.to_workbook(d,o);}break;case 0x03:case 0x83:case 0x8B:case 0x8C:return DBF.to_workbook(d,o);case 0x7B:if(n[1]===0x5C&&n[2]===0x72&&n[3]===0x74)return RTF.to_workbook(d,o);break;case 0x0A:case 0x0D:case 0x20:return read_plaintext_raw(d,o);case 0x89:if(n[1]===0x50&&n[2]===0x4E&&n[3]===0x47)throw new Error("PNG Image File is not a spreadsheet");break;}if(DBF_SUPPORTED_VERSIONS.indexOf(n[0])>-1&&n[2]<=12&&n[3]<=31)return DBF.to_workbook(d,o);return read_prn(data,d,o,str);}function readFileSync(filename,opts){var o=opts||{};o.type='file';return readSync(filename,o);}function write_cfb_ctr(cfb,o){switch(o.type){case"base64":case"binary":break;case"buffer":case"array":o.type="";break;case"file":return write_dl(o.file,CFB.write(cfb,{type:has_buf?'buffer':""}));case"string":throw new Error("'string' output type invalid for '"+o.bookType+"' files");default:throw new Error("Unrecognized type "+o.type);}return CFB.write(cfb,o);}function write_zip_type(wb,opts){var o=dup(opts||{});var z=write_zip(wb,o);return write_zip_denouement(z,o);}function write_zip_typeXLSX(wb,opts){var o=dup(opts||{});var z=write_zip_xlsx(wb,o);return write_zip_denouement(z,o);}function write_zip_denouement(z,o){var oopts={};var ftype=has_buf?"nodebuffer":typeof Uint8Array!=="undefined"?"array":"string";if(o.compression)oopts.compression='DEFLATE';if(o.password)oopts.type=ftype;else switch(o.type){case"base64":oopts.type="base64";break;case"binary":oopts.type="string";break;case"string":throw new Error("'string' output type invalid for '"+o.bookType+"' files");case"buffer":case"file":oopts.type=ftype;break;default:throw new Error("Unrecognized type "+o.type);}var out=z.FullPaths?CFB.write(z,{fileType:"zip",type:{"nodebuffer":"buffer","string":"binary"}[oopts.type]||oopts.type,compression:!!o.compression}):z.generate(oopts);if(typeof Deno!=="undefined"){if(typeof out=="string"){if(o.type=="binary"||o.type=="base64")return out;out=new Uint8Array(s2ab(out));}}if(o.password&&typeof encrypt_agile!=='undefined')return write_cfb_ctr(encrypt_agile(out,o.password),o);if(o.type==="file")return write_dl(o.file,out);return o.type=="string"?utf8read(out):out;}function write_cfb_type(wb,opts){var o=opts||{};var cfb=write_xlscfb(wb,o);return write_cfb_ctr(cfb,o);}function write_string_type(out,opts,bom){if(!bom)bom="";var o=bom+out;switch(opts.type){case"base64":return Base64_encode(utf8write(o));case"binary":return utf8write(o);case"string":return out;case"file":return write_dl(opts.file,o,'utf8');case"buffer":{if(has_buf)return Buffer_from(o,'utf8');else if(typeof TextEncoder!=="undefined")return new TextEncoder().encode(o);else return write_string_type(o,{type:'binary'}).split("").map(function(c){return c.charCodeAt(0);});}}throw new Error("Unrecognized type "+opts.type);}function write_stxt_type(out,opts){switch(opts.type){case"base64":return Base64_encode(out);case"binary":return out;case"string":return out;case"file":return write_dl(opts.file,out,'binary');case"buffer":{if(has_buf)return Buffer_from(out,'binary');else return out.split("").map(function(c){return c.charCodeAt(0);});}}throw new Error("Unrecognized type "+opts.type);}function write_binary_type(out,opts){switch(opts.type){case"string":case"base64":case"binary":var bstr="";for(var i=0;i<out.length;++i){bstr+=String.fromCharCode(out[i]);}return opts.type=='base64'?Base64_encode(bstr):opts.type=='string'?utf8read(bstr):bstr;case"file":return write_dl(opts.file,out);case"buffer":return out;default:throw new Error("Unrecognized type "+opts.type);}}function writeSyncXLSX(wb,opts){reset_cp();check_wb(wb);var o=dup(opts||{});if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}if(o.type=="array"){o.type="binary";var out=writeSyncXLSX(wb,o);o.type="array";return s2ab(out);}return write_zip_typeXLSX(wb,o);}function writeSync(wb,opts){reset_cp();check_wb(wb);var o=dup(opts||{});if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}if(o.type=="array"){o.type="binary";var out=writeSync(wb,o);o.type="array";return s2ab(out);}var idx=0;if(o.sheet){if(typeof o.sheet=="number")idx=o.sheet;else idx=wb.SheetNames.indexOf(o.sheet);if(!wb.SheetNames[idx])throw new Error("Sheet not found: "+o.sheet+" : "+(0,_typeof3.default)(o.sheet));}switch(o.bookType||'xlsb'){case'xml':case'xlml':return write_string_type(write_xlml(wb,o),o);case'slk':case'sylk':return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'htm':case'html':return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]],o),o);case'txt':return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]],o),o);case'csv':return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]],o),o,"\uFEFF");case'dif':return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'dbf':return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'prn':return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'rtf':return write_string_type(RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'eth':return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'fods':return write_string_type(write_ods(wb,o),o);case'wk1':return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]],o),o);case'wk3':return write_binary_type(WK_.book_to_wk3(wb,o),o);case'biff2':if(!o.biff)o.biff=2;case'biff3':if(!o.biff)o.biff=3;case'biff4':if(!o.biff)o.biff=4;return write_binary_type(write_biff_buf(wb,o),o);case'biff5':if(!o.biff)o.biff=5;case'biff8':case'xla':case'xls':if(!o.biff)o.biff=8;return write_cfb_type(wb,o);case'xlsx':case'xlsm':case'xlam':case'xlsb':case'numbers':case'ods':return write_zip_type(wb,o);default:throw new Error("Unrecognized bookType |"+o.bookType+"|");}}function resolve_book_type(o){if(o.bookType)return;var _BT={"xls":"biff8","htm":"html","slk":"sylk","socialcalc":"eth","Sh33tJS":"WTF"};var ext=o.file.slice(o.file.lastIndexOf(".")).toLowerCase();if(ext.match(/^\.[a-z]+$/))o.bookType=ext.slice(1);o.bookType=_BT[o.bookType]||o.bookType;}function writeFileSync(wb,filename,opts){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);return writeSync(wb,o);}function writeFileSyncXLSX(wb,filename,opts){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);return writeSyncXLSX(wb,o);}function writeFileAsync(filename,wb,opts,cb){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);o.type='buffer';var _cb=cb;if(!(_cb instanceof Function))_cb=opts;return _fs.writeFile(filename,writeSync(wb,o),_cb);}function make_json_row(sheet,r,R,cols,header,hdr,dense,o){var rr=encode_row(R);var defval=o.defval,raw=o.raw||!Object.prototype.hasOwnProperty.call(o,"raw");var isempty=true;var row=header===1?[]:{};if(header!==1){if(_defineProperty2.default)try{Object.defineProperty(row,'__rowNum__',{value:R,enumerable:false});}catch(e){row.__rowNum__=R;}else row.__rowNum__=R;}if(!dense||sheet[R])for(var C=r.s.c;C<=r.e.c;++C){var val=dense?sheet[R][C]:sheet[cols[C]+rr];if(val===undefined||val.t===undefined){if(defval===undefined)continue;if(hdr[C]!=null){row[hdr[C]]=defval;}continue;}var v=val.v;switch(val.t){case'z':if(v==null)break;continue;case'e':v=v==0?null:void 0;break;case's':case'd':case'b':case'n':break;default:throw new Error('unrecognized type '+val.t);}if(hdr[C]!=null){if(v==null){if(val.t=="e"&&v===null)row[hdr[C]]=null;else if(defval!==undefined)row[hdr[C]]=defval;else if(raw&&v===null)row[hdr[C]]=null;else continue;}else{row[hdr[C]]=raw&&(val.t!=="n"||val.t==="n"&&o.rawNumbers!==false)?v:format_cell(val,v,o);}if(v!=null)isempty=false;}}return{row:row,isempty:isempty};}function sheet_to_json(sheet,opts){if(sheet==null||sheet["!ref"]==null)return[];var val={t:'n',v:0},header=0,offset=1,hdr=[],v=0,vv="";var r={s:{r:0,c:0},e:{r:0,c:0}};var o=opts||{};var range=o.range!=null?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;else if(o.header==null)header=0;switch(typeof range==="undefined"?"undefined":(0,_typeof3.default)(range)){case'string':r=safe_decode_range(range);break;case'number':r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range;}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols=[];var out=[];var outi=0,counter=0;var dense=Array.isArray(sheet);var R=r.s.r,C=0;var header_cnt={};if(dense&&!sheet[R])sheet[R]=[];var colinfo=o.skipHidden&&sheet["!cols"]||[];var rowinfo=o.skipHidden&&sheet["!rows"]||[];for(C=r.s.c;C<=r.e.c;++C){if((colinfo[C]||{}).hidden)continue;cols[C]=encode_col(C);val=dense?sheet[R][C]:sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C-r.s.c;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val==null)val={w:"__EMPTY",t:"s"};vv=v=format_cell(val,null,o);counter=header_cnt[v]||0;if(!counter)header_cnt[v]=1;else{do{vv=v+"_"+counter++;}while(header_cnt[vv]);header_cnt[v]=counter;header_cnt[vv]=1;}hdr[C]=vv;}}for(R=r.s.r+offset;R<=r.e.r;++R){if((rowinfo[R]||{}).hidden)continue;var row=make_json_row(sheet,r,R,cols,header,hdr,dense,o);if(row.isempty===false||(header===1?o.blankrows!==false:!!o.blankrows))out[outi++]=row.row;}out.length=outi;return out;}var qreg=/"/g;function make_csv_row(sheet,r,R,cols,fs,rs,FS,o){var isempty=true;var row=[],txt="",rr=encode_row(R);for(var C=r.s.c;C<=r.e.c;++C){if(!cols[C])continue;var val=o.dense?(sheet[R]||[])[C]:sheet[cols[C]+rr];if(val==null)txt="";else if(val.v!=null){isempty=false;txt=''+(o.rawNumbers&&val.t=="n"?val.v:format_cell(val,null,o));for(var i=0,cc=0;i!==txt.length;++i){if((cc=txt.charCodeAt(i))===fs||cc===rs||cc===34||o.forceQuotes){txt="\""+txt.replace(qreg,'""')+"\"";break;}}if(txt=="ID")txt='"ID"';}else if(val.f!=null&&!val.F){isempty=false;txt='='+val.f;if(txt.indexOf(",")>=0)txt='"'+txt.replace(qreg,'""')+'"';}else txt="";row.push(txt);}if(o.blankrows===false&&isempty)return null;return row.join(FS);}function sheet_to_csv(sheet,opts){var out=[];var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null)return"";var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var endregex=new RegExp((FS=="|"?"\\|":FS)+"+$");var row="",cols=[];o.dense=Array.isArray(sheet);var colinfo=o.skipHidden&&sheet["!cols"]||[];var rowinfo=o.skipHidden&&sheet["!rows"]||[];for(var C=r.s.c;C<=r.e.c;++C){if(!(colinfo[C]||{}).hidden)cols[C]=encode_col(C);}var w=0;for(var R=r.s.r;R<=r.e.r;++R){if((rowinfo[R]||{}).hidden)continue;row=make_csv_row(sheet,r,R,cols,fs,rs,FS,o);if(row==null){continue;}if(o.strip)row=row.replace(endregex,"");if(row||o.blankrows!==false)out.push((w++?RS:"")+row);}delete o.dense;return out.join("");}function sheet_to_txt(sheet,opts){if(!opts)opts={};opts.FS="\t";opts.RS="\n";var s=sheet_to_csv(sheet,opts);if(typeof $cptable=='undefined'||opts.type=='string')return s;var o=$cptable.utils.encode(1200,s,'str');return String.fromCharCode(255)+String.fromCharCode(254)+o;}function sheet_to_formulae(sheet){var y="",x,val="";if(sheet==null||sheet["!ref"]==null)return[];var r=safe_decode_range(sheet['!ref']),rr="",cols=[],C;var cmds=[];var dense=Array.isArray(sheet);for(C=r.s.c;C<=r.e.c;++C){cols[C]=encode_col(C);}for(var R=r.s.r;R<=r.e.r;++R){rr=encode_row(R);for(C=r.s.c;C<=r.e.c;++C){y=cols[C]+rr;x=dense?(sheet[R]||[])[C]:sheet[y];val="";if(x===undefined)continue;else if(x.F!=null){y=x.F;if(!x.f)continue;val=x.f;if(y.indexOf(":")==-1)y=y+":"+y;}if(x.f!=null)val=x.f;else if(x.t=='z')continue;else if(x.t=='n'&&x.v!=null)val=""+x.v;else if(x.t=='b')val=x.v?"TRUE":"FALSE";else if(x.w!==undefined)val="'"+x.w;else if(x.v===undefined)continue;else if(x.t=='s')val="'"+x.v;else val=""+x.v;cmds[cmds.length]=y+"="+val;}}return cmds;}function sheet_add_json(_ws,js,opts){var o=opts||{};var offset=+!o.skipHeader;var ws=_ws||{};var _R=0,_C=0;if(ws&&o.origin!=null){if(typeof o.origin=='number')_R=o.origin;else{var _origin=typeof o.origin=="string"?decode_cell(o.origin):o.origin;_R=_origin.r;_C=_origin.c;}}var cell;var range={s:{c:0,r:0},e:{c:_C,r:_R+js.length-1+offset}};if(ws['!ref']){var _range=safe_decode_range(ws['!ref']);range.e.c=Math.max(range.e.c,_range.e.c);range.e.r=Math.max(range.e.r,_range.e.r);if(_R==-1){_R=_range.e.r+1;range.e.r=_R+js.length-1+offset;}}else{if(_R==-1){_R=0;range.e.r=js.length-1+offset;}}var hdr=o.header||[],C=0;js.forEach(function(JS,R){keys(JS).forEach(function(k){if((C=hdr.indexOf(k))==-1)hdr[C=hdr.length]=k;var v=JS[k];var t='z';var z="";var ref=encode_cell({c:_C+C,r:_R+R+offset});cell=ws_get_cell_stub(ws,ref);if(v&&(typeof v==="undefined"?"undefined":(0,_typeof3.default)(v))==='object'&&!(v instanceof Date)){ws[ref]=v;}else{if(typeof v=='number')t='n';else if(typeof v=='boolean')t='b';else if(typeof v=='string')t='s';else if(v instanceof Date){t='d';if(!o.cellDates){t='n';v=datenum(v);}z=o.dateNF||table_fmt[14];}else if(v===null&&o.nullError){t='e';v=0;}if(!cell)ws[ref]=cell={t:t,v:v};else{cell.t=t;cell.v=v;delete cell.w;delete cell.R;if(z)cell.z=z;}if(z)cell.z=z;}});});range.e.c=Math.max(range.e.c,_C+hdr.length-1);var __R=encode_row(_R);if(offset)for(C=0;C<hdr.length;++C){ws[encode_col(C+_C)+__R]={t:'s',v:hdr[C]};}ws['!ref']=encode_range(range);return ws;}function json_to_sheet(js,opts){return sheet_add_json(null,js,opts);}function ws_get_cell_stub(ws,R,C){if(typeof R=="string"){if(Array.isArray(ws)){var RC=decode_cell(R);if(!ws[RC.r])ws[RC.r]=[];return ws[RC.r][RC.c]||(ws[RC.r][RC.c]={t:'z'});}return ws[R]||(ws[R]={t:'z'});}if(typeof R!="number")return ws_get_cell_stub(ws,encode_cell(R));return ws_get_cell_stub(ws,encode_cell({r:R,c:C||0}));}function wb_sheet_idx(wb,sh){if(typeof sh=="number"){if(sh>=0&&wb.SheetNames.length>sh)return sh;throw new Error("Cannot find sheet # "+sh);}else if(typeof sh=="string"){var idx=wb.SheetNames.indexOf(sh);if(idx>-1)return idx;throw new Error("Cannot find sheet name |"+sh+"|");}else throw new Error("Cannot find sheet |"+sh+"|");}function book_new(){return{SheetNames:[],Sheets:{}};}function book_append_sheet(wb,ws,name,roll){var i=1;if(!name)for(;i<=0xFFFF;++i,name=undefined){if(wb.SheetNames.indexOf(name="Sheet"+i)==-1)break;}if(!name||wb.SheetNames.length>=0xFFFF)throw new Error("Too many worksheets");if(roll&&wb.SheetNames.indexOf(name)>=0){var m=name.match(/(^.*?)(\d+)$/);i=m&&+m[2]||0;var root=m&&m[1]||name;for(++i;i<=0xFFFF;++i){if(wb.SheetNames.indexOf(name=root+i)==-1)break;}}check_ws_name(name);if(wb.SheetNames.indexOf(name)>=0)throw new Error("Worksheet with name |"+name+"| already exists!");wb.SheetNames.push(name);wb.Sheets[name]=ws;return name;}function book_set_sheet_visibility(wb,sh,vis){if(!wb.Workbook)wb.Workbook={};if(!wb.Workbook.Sheets)wb.Workbook.Sheets=[];var idx=wb_sheet_idx(wb,sh);if(!wb.Workbook.Sheets[idx])wb.Workbook.Sheets[idx]={};switch(vis){case 0:case 1:case 2:break;default:throw new Error("Bad sheet visibility setting "+vis);}wb.Workbook.Sheets[idx].Hidden=vis;}function cell_set_number_format(cell,fmt){cell.z=fmt;return cell;}function cell_set_hyperlink(cell,target,tooltip){if(!target){delete cell.l;}else{cell.l={Target:target};if(tooltip)cell.l.Tooltip=tooltip;}return cell;}function cell_set_internal_link(cell,range,tooltip){return cell_set_hyperlink(cell,"#"+range,tooltip);}function cell_add_comment(cell,text,author){if(!cell.c)cell.c=[];cell.c.push({t:text,a:author||"SheetJS"});}function sheet_set_array_formula(ws,range,formula,dynamic){var rng=typeof range!="string"?range:safe_decode_range(range);var rngstr=typeof range=="string"?range:encode_range(range);for(var R=rng.s.r;R<=rng.e.r;++R){for(var C=rng.s.c;C<=rng.e.c;++C){var cell=ws_get_cell_stub(ws,R,C);cell.t='n';cell.F=rngstr;delete cell.v;if(R==rng.s.r&&C==rng.s.c){cell.f=formula;if(dynamic)cell.D=true;}}}return ws;}var utils={encode_col:encode_col,encode_row:encode_row,encode_cell:encode_cell,encode_range:encode_range,decode_col:decode_col,decode_row:decode_row,split_cell:split_cell,decode_cell:decode_cell,decode_range:decode_range,format_cell:format_cell,sheet_add_aoa:sheet_add_aoa,sheet_add_json:sheet_add_json,sheet_add_dom:sheet_add_dom,aoa_to_sheet:aoa_to_sheet,json_to_sheet:json_to_sheet,table_to_sheet:parse_dom_table,table_to_book:table_to_book,sheet_to_csv:sheet_to_csv,sheet_to_txt:sheet_to_txt,sheet_to_json:sheet_to_json,sheet_to_html:sheet_to_html,sheet_to_formulae:sheet_to_formulae,sheet_to_row_object_array:sheet_to_json,sheet_get_cell:ws_get_cell_stub,book_new:book_new,book_append_sheet:book_append_sheet,book_set_sheet_visibility:book_set_sheet_visibility,cell_set_number_format:cell_set_number_format,cell_set_hyperlink:cell_set_hyperlink,cell_set_internal_link:cell_set_internal_link,cell_add_comment:cell_add_comment,sheet_set_array_formula:sheet_set_array_formula,consts:{SHEET_VISIBLE:0,SHEET_HIDDEN:1,SHEET_VERY_HIDDEN:2}};var _Readable;function set_readable(R){_Readable=R;}function write_csv_stream(sheet,opts){var stream=_Readable();var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null){stream.push(null);return stream;}var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var endregex=new RegExp((FS=="|"?"\\|":FS)+"+$");var row="",cols=[];o.dense=Array.isArray(sheet);var colinfo=o.skipHidden&&sheet["!cols"]||[];var rowinfo=o.skipHidden&&sheet["!rows"]||[];for(var C=r.s.c;C<=r.e.c;++C){if(!(colinfo[C]||{}).hidden)cols[C]=encode_col(C);}var R=r.s.r;var BOM=false,w=0;stream._read=function(){if(!BOM){BOM=true;return stream.push("\uFEFF");}while(R<=r.e.r){++R;if((rowinfo[R-1]||{}).hidden)continue;row=make_csv_row(sheet,r,R-1,cols,fs,rs,FS,o);if(row!=null){if(o.strip)row=row.replace(endregex,"");if(row||o.blankrows!==false)return stream.push((w++?RS:"")+row);}}return stream.push(null);};return stream;}function write_html_stream(ws,opts){var stream=_Readable();var o=opts||{};var header=o.header!=null?o.header:HTML_BEGIN;var footer=o.footer!=null?o.footer:HTML_END;stream.push(header);var r=decode_range(ws['!ref']);o.dense=Array.isArray(ws);stream.push(make_html_preamble(ws,r,o));var R=r.s.r;var end=false;stream._read=function(){if(R>r.e.r){if(!end){end=true;stream.push("</table>"+footer);}return stream.push(null);}while(R<=r.e.r){stream.push(make_html_row(ws,r,R,o));++R;break;}};return stream;}function write_json_stream(sheet,opts){var stream=_Readable({objectMode:true});if(sheet==null||sheet["!ref"]==null){stream.push(null);return stream;}var val={t:'n',v:0},header=0,offset=1,hdr=[],v=0,vv="";var r={s:{r:0,c:0},e:{r:0,c:0}};var o=opts||{};var range=o.range!=null?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;switch(typeof range==="undefined"?"undefined":(0,_typeof3.default)(range)){case'string':r=safe_decode_range(range);break;case'number':r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range;}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols=[];var counter=0;var dense=Array.isArray(sheet);var R=r.s.r,C=0;var header_cnt={};if(dense&&!sheet[R])sheet[R]=[];var colinfo=o.skipHidden&&sheet["!cols"]||[];var rowinfo=o.skipHidden&&sheet["!rows"]||[];for(C=r.s.c;C<=r.e.c;++C){if((colinfo[C]||{}).hidden)continue;cols[C]=encode_col(C);val=dense?sheet[R][C]:sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C-r.s.c;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val==null)val={w:"__EMPTY",t:"s"};vv=v=format_cell(val,null,o);counter=header_cnt[v]||0;if(!counter)header_cnt[v]=1;else{do{vv=v+"_"+counter++;}while(header_cnt[vv]);header_cnt[v]=counter;header_cnt[vv]=1;}hdr[C]=vv;}}R=r.s.r+offset;stream._read=function(){while(R<=r.e.r){if((rowinfo[R-1]||{}).hidden)continue;var row=make_json_row(sheet,r,R,cols,header,hdr,dense,o);++R;if(row.isempty===false||(header===1?o.blankrows!==false:!!o.blankrows)){stream.push(row.row);return;}}return stream.push(null);};return stream;}var __stream={to_json:write_json_stream,to_html:write_html_stream,to_csv:write_csv_stream,set_readable:set_readable};var version=exports.version=XLSX.version;exports.parse_xlscfb=parse_xlscfb;exports.parse_zip=parse_zip;exports.read=readSync;exports.readFile=readFileSync;exports.readFileSync=readFileSync;exports.write=writeSync;exports.writeFile=writeFileSync;exports.writeFileSync=writeFileSync;exports.writeFileAsync=writeFileAsync;exports.writeXLSX=writeSyncXLSX;exports.writeFileXLSX=writeFileSyncXLSX;exports.utils=utils;exports.stream=__stream;exports.SSF=SSF;exports.CFB=CFB;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17).Buffer, __webpack_require__(22)))

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1749)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1703),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c05fd1d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1762)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(1715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b521c2fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/feedback.165ff8f.png";

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMSAzNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjEgMzQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOm5vbmU7fQ0KCS5zdDF7ZmlsbDojMzk1OEJDO3N0cm9rZTojMDAwMDAwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30NCjwvc3R5bGU+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNLTEsNWgyM3YyM0gtMVY1eiIvPg0KPHBhdGggY2xhc3M9InN0MSIgZD0iTTE4LjIsNi45SDIuOGMtMS4xLDAtMS45LDAuOS0xLjksMS45bDAsMTcuMmwzLjgtMy44aDEzLjRjMS4xLDAsMS45LTAuOSwxLjktMS45VjguOA0KCUMyMC4xLDcuOCwxOS4yLDYuOSwxOC4yLDYuOXoiLz4NCjxyZWN0IHg9IjkuNSIgeT0iMTYuNSIgd2lkdGg9IjEuOSIgaGVpZ2h0PSIxLjkiLz4NCjxyZWN0IHg9IjkuNSIgeT0iMTAuOCIgd2lkdGg9IjEuOSIgaGVpZ2h0PSIzLjgiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABGdBTUEAALGPC/xhBQAABQtJREFUSA21V2tsFFUU/u7Mvndb6PthW7CGopj0gVqkD/FRUcKfKq1EU2JJ1MQfoqKJSSOxRlT80ZCYJhJjoqZNjLYYSJRExCgpEF+Ij0pjS6pQ22JpC32t0nZnPGe6O5273dltJN5ssvc8vzn33DnnjMAyVnOzrhzr76hASNRC4BZAz4WOXMNUYAgQQ0SfhqofqimsP9XcLLREbkU8hTsbv/SEQqO7NB3PQdcz4+maMiFGFIEWVU1/86v37vrH5EdtbIGrGzq36bq2Xwfyo2yWRZLjASGUZ7va6w7GMlCimbqui8qGjlc1Xev8r6Dsk23ZB/tin9E4EoMVqho6PiCl7dGK10h/eKK9/mEhBD3PwpIirtrRuZfYywbNTvfhmR2lyEz10BUwfUZ8W/+3h32bPBOYc0rWTaYkwWZL9Sq07bsPG0uyMDg0QmcbF5jlTQZG2K8BzLeXL1ICLFN894Y8ND1xGzxuFcMjlxf4UtJMVWnDGIzFTAOYXxm+DJKWDVFclIo9T5abUoXeHaGoJh1vwxiMxToKFwfjPY1nEZZxHnc1lMKhmhnCujU5cDsX6URuGIsx1fmCmyuh4alEBiwvLkrDo7XrJFV+iPOD4+j/Mwi6tZLMhvD/PnH2mGKUQRuNCFul4+Rot25aHWFJ/7t3ViAjxWXoSAI7gkqvslB77TSAZL8TNRsp/QSclxWIqZgUcOOtl2pQmJe0PHCq95QcKvg2i6PkizQ2foUcashM89loAtkZAbz9cg023ZqzDHA9VzG7TAyX62/KwO0lOQgGZ0iqIeBzSlqj49MS7XE7sPfpKlSVZcYHp85mex2tOc3NDJAj4OIlGehA+3F0/0Zd0bL4fr3wWDkCXoqJjWIsnUon51i2NBV1lBdnG1RFWYHx/2PPsCnlTUhX8fy+o/hjYEzip6zworF2rW01o6s6TBFTE4+xHHSTU5KNIoN7q9eiaFUyuvvGJc3VeWmY/NuBx5sOGa+UVVi5Pg+aNm8TtRjiHJ+2GkT2brechdY9m7F754aI2PgvzE+lqqUgGPKh5Z2Tkiw/ZyWSvHzUS4+bsvG9wuOKZBEmpoNzmJq5aooCfhdWJLlNmjdz8xSRphkl86dzcv5ZroVmYx63ruiHFZ6RqORQe5EXVWB09/4lM6Ooto+/oUwxU+C67GRJGqLaODEVY/IhLMakWi00SmeLZGUQAoe/6F3KJs7I2BSa93+CX/quULQOQ+eBe9ZIul3f9tHzcPOQyyhjGZiszYMZiQckS3ovTp65hAuD4bZnEU5SJOeHZ+DypVJrdOKRrUWov7/IogF0fHoGqtMr4TIGY7Gi+TjcpHlGslrrWgj5GQLvvvEgASxEZpVPTs/CT0WFa7l1dR75Aa8f6IInkAVFXbRThFIXGf7MRnrh5496CkoecpGD6kUnAhPT8zj1XQ/uKL8ePg+LF5fbpUKJ6kifHT+LV1qPwulLJ1DnYscS4jWau1oj1tKjUqVZMuxx9dFCV+FVg2jcVoq6LWXweuTSyc5+7R3C+we/xucnzsHtz4DD6TdetTDQkmFPAmYlA5yHPsv8xeA6FYP52Wlos1O48YZUZKcnG8c/dnkG/VS5Lo7OwOHyw+VZSZHSydBJGP2ZI22re9E6YTLOEmBm8ooe6BmcHoZ+IapIc3QKc0Tzl4qAQjdbcbgIiDInqAozaIKB3haYwe0+YbhFSgXJ8GJGeG2fMAwcWf/HR9u/FCLsOFJA2qoAAAAASUVORK5CYII="

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABGdBTUEAALGPC/xhBQAABQdJREFUSA21V31MlVUY/51zL/dePi4fghAgEFA5cGUbTOMCBZvmNNbaIEtZm2b/9mHi1tQhrGKr1tpaY3NzC7fEobloa9OaG2ZBX1At6GMu0zuUawQGF66CcN/Ted5778t7LveDcp0p73k+f+c55znPeS7DCkabaOPnTpxxLWraE4CogGB5jIk8MhWCjYGJMYANWTnv3bRj60Aba9PiuWWxFOr66hxz126+wITYJyCyY+mGZAxsXDD2tiM/6d3z9efnQvzwb1RgV3dlo6axd2RIBeFGK6IZG+Vc7B3YOXg6kj4PZwq5d67jG17X/PjwP4OSU7lg8kG+yGc4jsIgharjG05Io6fCFe+IZqznq+ZvdzCZGCE/SsTV3Rtf+zegdyXn4uXKFuQk5kgzw2fI99JXBqL7XuLAAA6cqXbAJIs5fay4Ad0NPajKrcbVP6/KrY2pDk3TDhBGSEsHpuzVEynEjfPdVLgZB12tcFgd8PxNNymOQVBMGIRFpA5MV4aSYSXmD2StR2t1u6FqYRYwvkJkiaFjETAVB7qnhqcYEzrHlyr3wcqthlZ53jrYLXaDjjchLMK0LK69Va0J7fl4BiRfv/pB7Lr/WUWVFuGedOPS7O+QWavIohDJV36+dI4HymAUlSCbtpOibSh9PKJiS+1+rLZnx85skyVhyjOWtTfGSLWlYXPRFj1rC1Iip4HTkYojW4+iNLV0heCiglPBj4ZLUR52tePG1CSEJpCdHL1c5zpzcXTb+6jLr48PLjF56JWJBF6RU4mqfBd8Ph8g35sUm1NRm5j5S6Ed1kR01L+B2tyHY4ITpn6dFOsgoZ9pSeBM8535Otfj9SiqnX2dGLk2rPDk64RXqg7CyZ3RwQUTXH9PFdMgISvRxryHdMJ1d43+/cHzvaLp537s/eRFXJ64rPBXJa3C7nXPRa1m0rWHBx5xxU4nrMyKjMQMff5o2Rbcm34fRibU6IqziuG1TmPPqV3ySl1RnNQU1kAsylc8Ug2XjYPcajakWASJ8KLQue0IWlz7FdWSzBK9at1M9OGtC28qsoKMQjiZzIkINZwJNsipXVEsgsTs7VnMzHsNkdPuRJoj3aBpsrC4oGc7szD8OK0eA8n98/6IwBYL/5hTj0TtCimaB1WhYY+6tWY5zY993RVgyYKVn74mMA/+9csuwDu3tPCQkLAIk1NjRj1SSGB8pbPe3z4ySPNk3DuO1t5DGJ78CcwaKJONa5vMKrhw8XPAIlkBsSEjLMLUrxM1ZrLQjhpSmkiD/utfwH3DrbCJ8M5Nw+1zw5aRAEdCIprLn8H2sqcVvZNDPbA4CNk0JIaOJVnGevRGgPos0xB+gSJLEbq2fyAB9GfUJAWm56dlUUkB1XLzODV4Eh19r8KebYdMIkPELWgKNX+GxejpsV8Lm9bYZPrXGppyWVMLU+j/5Us8ck8dkmxJhogm1AhwtuSYeJ+OnEX7mcOwZiaAJ8jbGnyxOOcdA83fvUc6NIyIiZCgy5o9uofavIbkW8nYXbEHjRVPLlsA2VIFOzbQhc8unoUt0w5rsqlBiNDsKcAhcGrMqEcimgaBUzFY9C1CzABlWeXISc3RI56cncAfsnJd93l0sIQ0GamNyoP8J6OlSPt3fnNIzpUbvQw4AAWEN/QETsWAzl2jinRbC1Yl6TyB/sttlfeZmil9e+M09FGBaQHRfsLQE7lsBCO8458wZsf/x4+2fwDynAkXRznK+gAAAABJRU5ErkJggg=="

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leak_red.43d26ae.gif";

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leak_red_anim.f4d285d.gif";

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABGdBTUEAALGPC/xhBQAABOVJREFUSA21V11oXFUQ/s69N/ufpLFNss0Ssy3SSsUKbak1mBhL82BbqJiCxKe8iEUhIVQFNUJArSiagn/UB0XqQxAtWvEHFKW0WBAMKCY1FLSbbJsmMRsxmzQ/u3uPM3f3bu652d2sFgd275k5M/Odc8/MnLkCZZDs79fGh841SzP9IEzslkI0CIkGNpUCE0LKCWgYEprx2a272y6K/n5zPbeilMKVrjafNpXpNiGPk15dKV3H3LQG8bpZr7+x5YNzSw65MiwKHDvY0iElTtKeGhWLshkRFwK90a8unClkormFUkoRO9TyEj0/+e+g7FU2so+crzUbVARZ0NZBSPmwe0E3xQvxUfTL851CUGTkSNnx2OHWF/8NqF4XRs2xHojaOjLL+7R9rz5pI5bvVQnFYo6sMzXlsza/3jNw4AFETp2Gd889mLl6jYK9NEnyzRi2lgXM0ZsNJFtc+ulv3Y/a3mcgvD4kp66DggjKmRUxZwzG4mkLmFOm3EDy7LgTtcf78q6FpsFg5LJINmaxCJiLQy5P1zXlc7zlsW4Iw8jr1mzfAXi8eX69AWMxplWRSLms4uC5Yye8t21XfGteLwIt96NEaCn6jMVVULPKoHvKzWu6FbWh9kPuGYtveqIX2FhbOrIdloypce11yNYMRWUV/G0HrKjVGyJr5llghCoRee0diOjW8sAJU+OCX9AbCflMNz3Zh7lEAhkaV1C+FiNvfRiNA+/C03zfuuCMqdm3TCGH3rt2IbBnHxZu3CBngB4MKWpLiRmF13w+NDz3Aox995YEZ8x8AVE8EMO7DbYftMSe8GYKHomlqUlFbeS9U/jr0rAi46Su734aaVpksWom6R6lV40J1TLLcZQGdu21mJq9zdYz+evP2cncv2GauPz8U0iOxRR5xYYahDq7SlQzcZ1eNV3iBcjUDRjkgCm8vx361m1YGR1RNKuaoqicn8Nwz6OYj48pc5V3NyNFCyu0a8bUuHNQLHKMoPx0UvTVNxF5nNLGQYGmLVbV2ri0iNhbA44ZIBhpxHKwskh+i580blcUixxjLswjPZ/MTxmhEPSq6jzPg0wqhTRHuyZQcekXZY6ZpUwGZoHKIgz9rMY9EulMu60Elf2kO3BcSr8PfmhdDlypfWE1KyWBppJzLguLnWZMjRsz7pHcGlz3Z7/+3C22+MU/pzF0oh/p0WFrtyysPvyQojt58QIqSOK+Pxgri0mT3JiRStxpyXmW/vEHLMTHnWJrzDuR18YR9npgUO5WdXRiw5Gjil7s048RNHTXdSniWSzHNZpt7rjPWqU0HdAcBcnOt9+HTnevmzK0AD0YpDtOV6b+OHsGsYGX0RjwwUPXpk3U+hy1m7+8lAVCEydsJX7q9LqDV8cx1HMMy7OzzilrrFMdd4PGv/sGoydfQR2/Dcd7Zt82KBtzXOSJco46TLXZ4zxczJiY8fqx+ZEuRI90wPD78zb2YPa3EVwePI3E998i4veiqsKghefcF2j2FGB2wuDcmHGPZDtl8BV67X+n0kjQInzbboevrt56/cuzCcyPXUFqehLV1CBsop36dC4PHFiUG7TTpi/O9zk7TPa7BtgGczf0DM4NHZ/7ClWkZfpxjvKm+Bx99OMd8vEwIP2XbOiLAvMCin3CmLQIZ12wYBjKAsTNfcIwsE3/x0fbP2Mx9m7KmtzQAAAAAElFTkSuQmCC"

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pin_blue.991b57b.png";

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pin_green.2bb2701.png";

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pin_red.7a84d51.png";

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAfCAYAAAAIjIbwAAAD4klEQVRIia2Vz28UZRjHP/O8M8NC5QALLa1QijHBWC1JQyQmKqnEiyHxgprggfgjeDMCF5QDJ02QP4DUGIFEPIiEABpLCRISxIuhtCzCki6kLF27bNtlS9PdnXnfeT1Q2t3arRT4XibzfZ75zPNMnmdemEWu5wNsBA54C2IpEdGAdRxHewtiKeAAsHEy7z9yZvHWuZ7/nQ6D9fHlz5oVq15SscVNiPKJTEDpfoahdMKM5AaV6/l/6TD4BOidC/qhiHy7fMVq57l17yqJtwMyy3sjopFL3Ow9anJDAzaKou3AwYdRVZH5EfD92rYOWfXKDnHqmms08qAWZ1ET8dWvy0Lnngxnb70DpIGeSmi7iJx8oe1Nib+8HRyvBmwm22VRQzvPOHlGcwObrbW/AP8IgOv5nfWNLU68dVuNdueSEG/dRn1ji+N6fieAC3ToMFi/pm0LVmLV+aZIKXMOG5np4kQRa+oAtXDKsxJjTdsWGfrtm/VAhysiW5cuazISb1fMVClL78Uf0WEwZbmez4bNL0JdS3W98XaW1a80o8OZra7y/E0NK1vVrG3XtbDh/R9wgjwXfvqU197rxPpLan6GhpWtqlAY3iQ6KDfHFjdVhcOh8yS7d2Lzvdh8L/n+4wDk+49PecnunYRD56ueiy1uQgflZtdaq0RVb4YujzF89w7Dv35V5V+91AV0Td03l8eonBNRPtZaJSISRLpYo6X5KdJFRCQU5fmpibHBpwKdGBtEeX6/hOVSV2agz1irnwhorSYz0GfCcqnLBY4U8rkdOnsRb8UbAHixJdQ3tvB8+wc1If2XjuDFpidBZy9SyOcUcMQBcD3/zJKlDR1rN32trCyYd5VOVCZ59kuTH82e02HwlgDoMNiVy6aleOfMvIEAxTtnyGXTosNgF0xPfJ9S6vD1npPGCQvzqzIscL3npFFKHQb6KqEYY/aUJu7rws0T84IWbp6gNHFfG2P2PPQqdzNjjNn3d8/piGLm0YjFDNcud1tjzD5g6qGZC7/fcZx8LvnzIzEn80aB/ZX+TOi4DoPdNxIXoHBtbmLhGjcSF9BhsBsYnwsKcND1/OTtxNEIoprM24mjkev5SSrOprmgRofBZ+lbCdHZP2cF6rt/kL6VEB0GnwNmZrzW2dHtev7ZVO8x40TlqoATlUldPmZcz/+dyl/WI0DRYbBjJDcoE+nTVf5E+jQjucGHVc6quU65KyJyKNlzamohnLBAsueUEZFDwJXHgT5YiOJ4eC/1YCHupU5QKo6HlYP+uNqrXC969e0vrHK9CNj7pECAOtfzc67nW9fzc0Dd04ACfAzYyev/6l+1YK5mFCodnAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMSAzNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjEgMzQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiMwMDAwRkY7c3Ryb2tlOiMwMDAwMDA7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KCS5zdDF7ZmlsbDpub25lO30NCjwvc3R5bGU+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTEsN2MtMy45LDAtNywzLjEtNyw3YzAsNS4yLDcsMTMsNywxM3M3LTcuOCw3LTEzQzE4LDEwLjEsMTQuOSw3LDExLDd6Ii8+DQo8Y2lyY2xlIGN4PSIxMSIgY3k9IjE0IiByPSIyLjUiLz4NCjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0tMSw1aDI0djI0SC0xVjV6Ii8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABGdBTUEAALGPC/xhBQAAA95JREFUSA3FV11IVEEU/mbu3V3tz0grM5SSqB6koh+oVCroLfqBDAksIijqJajoIXrZhwr6kSDqoZfoQYpcoyIiIqnAqJCKkEi0/ywti7JM1N29dzpnrve6u6zrlmkDuzNz5pzznfn75lyBNEowqGTt69BSWGIdBBYAKg8KedpUoBUQrdR/DENdWVm44X4wKOzB3IpUCsu33MmwrK+7bIW9UGpSKl1vTIh2KVBpGDkn755b0ePJExoDApdW1KxXyj6hgPwEm7S65LhFCLm7rqrsUjIDmShUSoniitAhW9k1fwvKPtmWfbAv9pmIEydghZKK0AVSKk9UHGL/4r2qDRuFEBSPUwy3wXXtq6JDVO2Mlf2jdtHZy42+lobQbdefN2PeU14ad2A4ailkmbvnGphPbzTypXkoe5pOoATWYvomzuTTbrIBX5nBQOmEY/+2RVg8d0pSjM6uMA6eqUfTm46k4yxkDMai5lHJ5KDv6YDqZECgUL1YtmgqssdnJP1NmzoORTMmpPDiDDEWY4qSzdUlykJdKgtl24iEO5GbZWHO7FxMz8/G1vJibVL/9C2u1TbgZ1cET16EaVYm6PSmcgdhoFRqGkyiFmdLHdM/Gp9/mLj5oA0Pn7Z4Fu/aOkn2CfXPf9HKGHGgcT48C2oQ9UqHex0p3WO9rMf3FePa6TWYMytbD/AMBIVpBsbAFxgHIfXR0GNS+uDPyILhyyTKdmbKfkrm5+LGmbU4sH0h+fSurwNEfE+EUd1E8pks4b0smOzH+cp1WqG7N4poNMGIFtMgMh6V6dM6kaiNHtIjVN13/hR8pkRGwAlw1Y4rtBWs4xSKr9kkP84rwzKKwEC4bxjIZMOA103aYACf6U865gpNIzYokhJm/5rpPs0ucYKu9T+sFVEn7zG9p7Fl+JEFVBu9TvSIj3gRrZKW9vFI49KOP5Kcrow0sJLqqsk50q2XNe10onVq0xO2vDg+furAh7bvXv9PGoUFOZiYPVab9Eb6fdJdb19ZWHbf5MSsdFOokjj0CNEE3n7owK26RhTNysP+Y9fxrOlz/BVNB52u5ZJ5eQjuWY07D1+DHxDZRzqcjzGmvmDus0jvcb4V6UZv11fNToHROZqx0sGK1WEiCnd/gx3tgT9zgmY8yr+YYrxn0bvZnAhYtkWJANEmPQqsxTQ5GOHHArpth3ppeelmMiD9aT+xiYCX+rxvqG4smFvuJ5VSISk6jrCPe12H6dYOt5O99uOAkrPDlHedcn14M2YBRTpiyV5cekuRKs4GOTo3siHXzkzjMkz2GTfjWJDhTugHBOYg/ssnTOzsh+Oj7TcGYZYvd0o/WwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABGdBTUEAALGPC/xhBQAAA81JREFUSA3FV91rFEkQ/1XPzF4+0ANjRBPDaQ58MqegRjdnMILC3ZtwQVEf9VkQBR9EXfADFETuuP/gNMFTQQU/In7BYaKnAUFFDUKUmCgBE92gSXZ3pq3qdWZnN7vJohscWKa3uur3q+ruqq4hFPHEdExdb7/SlPK8DYBeBk01RLpGTLWmAZAeAKjbVur8us2/d8Yo5k0FS5MptNxqKRvr/7SDtN6loedMpuvPEWhQEx0vq6346/ba22O+PPddkLipbfkfnkcnOKS6XKOi/hP1KaV3dm55cC6fvsoVal67plONhz0XZ7+aVEDZYcEQLMHM5ckSiEL0VGM7G23KVfym/0Snu7b+v5n4YPg4WRH/2rbyUMlJhYkDMdg+K7+DiM2eyvJO46MstPp7bojTp/djj+zLNPJymNRXVlu5SE67LUSSMlORak9jb3Q/orXRvL7FEyM42BnDs6GneeeNkAMzXMAxJcVB8rSwNm8RkyKh0FK3FlXls/P+Fv64EIurGiaDMXPCZThXt61cnXLd/yazEOLUSApzvXn4pWYJ6qt/xrbm7cbkXu89XHx4HiPJOLo/dcOzXV7R4OjkhbUtq1mly+DEea5AGSEPrUoLb+03uNp/BV2v7gRzrz68RAfL7r7vgmdlk2ZhBBaAcHI6ce398nAem2U90fInLrd2YEn1UjMjEZBFsCttODNskJ3JQuUQnJkOrHIryBHBaa5Zg2sbb2Bf9AAfnyB9faZltOqfFc+ZfJFIZEkX/LAA7RvPGIXR1Ch7l/qinHlZsFARqTCCpJfEWGpiSXbIRplTbnR++3c94skPGQBQjy23TOAQO6aS5qAbpXI7bRiymDB0lAMn4kyQhwU2Oxp+hDOzZjxjljrwIqxa4rEmrcx9GsbN3Y7wXInGTPFGpS/xEiEWC8ONAy81dRerXyo90vRASbtSKsBicSxLXbClR+o4eWnQb23G3Uxq9A/34/VwX7F4WXr11fWonpHulhJuIpiT1kg4bWnMVp1sPM5H+qgUit6hXlx70oGG+Q3Yc2E3Hr99xEahKhZAFB5IdkTnN+HghkO4+eIm4ok4eGmNgfRjwmkQ/WtRu16dO+pi/F2CFQmRqoipWIUpCsxwj5kYSsAd9xCZ5ZiKR4qpQtdiEIo0Am5Kc5+VrmACKWVyqoKfj9rUAzedl2lC4SSEG4GgpPSdG3j6U2tdhIGaRdn8prhl8pGKzNT2EIYhVepI59b7f/s2QcQiYE+/T7PHnmnpBhV753v2rW/Byu0wBTMr4jDJdDf0BYnFie/yCROOfjo+2j4DTOKv+lIsK4QAAAAASUVORK5CYII="

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMSAzNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjEgMzQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiMwMEQ2MEE7c3Ryb2tlOiMwMDAwMDA7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMSw3Yy0zLjksMC03LDMuMS03LDdjMCw1LjIsNywxMyw3LDEzczctNy44LDctMTNDMTgsMTAuMSwxNC45LDcsMTEsN3oiLz4NCjxjaXJjbGUgY3g9IjExIiBjeT0iMTQiIHI9IjIuNSIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMSAzNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjEgMzQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRjAwMDA7c3Ryb2tlOiMwMDAwMDA7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMSw3Yy0zLjksMC03LDMuMS03LDdjMCw1LjIsNywxMyw3LDEzczctNy44LDctMTNDMTgsMTAuMSwxNC45LDcsMTEsN3oiLz4NCjxjaXJjbGUgY3g9IjExIiBjeT0iMTQiIHI9IjIuNSIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABGdBTUEAALGPC/xhBQAAA8lJREFUSA3FV91LFFEUP+fO7LqaZbmaYaxsPZhh9GKRiCu+ZgZBQfUQ1D8QWA+iT1ukUGRBr730UlEY9EEGFSgJRZZFUIT24KppuRhG69fq7tzOmd2Znd12x82PunB37px7zu937tx7zj2LkEWTfr8Y6e+pkVrkEGhQJRFLUUIpm0qEcZRyHAT0o1Dvl1XVv0S/X1sKFu0Uhk7Wu8RE9LQG8izpbbbTtcwFBWCHVqJc23ajZ94iTxpmJA40+A5LCVdpTZ4ki6xfcBQRmrxdvffSmYhUoZQSAwd8bfTsXD4po0oPY8Sx/lhgkiBGWncbpDya6tCK3hHveB+/OI5IJyPeklY83Fh3YdVJmYgWomMbrPQ0VxzbU/68a9doxUeMPdeJ+fTCRHRwZXuajcM4CiVKOZ92ldXjIWN7ejU64u6mFlhXtS8tQ3Q6BJNX2mDxy0Da+ZhQepiLxpcEJ4d4nGY0YNIZOhZ5NXWgFLrTdmeZFxwVlRkxjAnmYk4cPlhfq0UivcZEumeUiKcWFmGqqAQKKnfDeu92qDhxSlcN9vfByJNHIEMh2PDxHeSQLu1lOhhTJlTVJ/Q0aIosA4sxH/0ChwruH0GIdj+Fn29emYqR0RHQSOZ63weOVFILhmlAA+YUnHsNIcUx8GctPn8ZPLceQg6tjhuvQKW+kcgLnQ5wikQUOgWC2+mEfFWhdB1rjOOsrgXP3S5wn2mlaDLDN6ZAnDjU4BugmXKWMOnC1jLYcf2mriDn50BGIjFly69UFFBy82I6i4sgw2lSsuoA4XLpOoFjjYChXwkExEGVbxnDH40Gs0IxFdCVmwh0U5o8QIcDuNs1qahJOMxpfB3dTkLsU9uBrMacpHtU8H1qBTNWb5Wt/hi/Cf0SX31kW0TmFFw52GqtySS+FVyurAm2DSiqygOVa6TA6+dB0tNLGy0cNk1mxsdgevyr+f43gwLKbq6iYt1ELiQwSRBkTpULs+H9vg7KoReRDn14JABj3c9g085d8OFcC4Q+f0oKhWzIOSzz91bDnlY/TPZ2g0YXiBJPOlyPMWfStahJzTMdicLYXJiyE0Jpbg4oGdKenQOciL7PL8BsNApbXDl6xhM6TuJaNLM5FwKapnVyOEXIkCc4TS6V8NM5wCmSMRiLHedkwTjUzULATCBcGQhFtLNnnIsd1JdDyo6wHdszDhPrpALbjepD1+Efo5GnVGH+h2KPPJN6NUjeGc6s9Im80pQKkzHNPU4l+OcFveGAvh9UmNFON5OM4zzbxn9hmrmos+5pqnHGFVsV1+JP22+5UJwNg6jL+wAAAABJRU5ErkJggg=="

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABGdBTUEAALGPC/xhBQAAA6dJREFUSA3FV0trFEEQ/qpndt0k6ho1IpH4Aj1pREUwMQEPHjwKCuLZuyAePIgQiAoKQfBPiKCgHgRFRBB8gBsjeNAgxBgTg2/zcDfJTpdVPTuT7GazJibGhp7uruqur6q7q7qGMIvC3Gbw8n4zbP6QTN8ttR4gqVp4QD5aMzD+Tew48JiozSqnUqFKTO7Zn8K33AkQnWLmNZXmRjwi+gTmDqxMXaFND3MRvbSdEZg7mw+D7WUGGkoXzWYsgvtA5iTtenyj3HxTShTLiDPN55nt9b8FVZm61slwsniagUUEBcWLpqvMOFqq0HzGRLiGnU+OyTGIPmEptrhz37mFBlUYJ1NkFzBdE1usZ6pbM5W50H0icyQ6cwdcuL3d8znT2SgpYH1y27fqbffdAnGZP4FaKzM2nIFJN5XHyA+Be9tB2dfl+UJVDFL3BC4ZFxzET2ecLQwFHclKJ70fSKwqX6s2wVZtqyQm5LmY0GaIu1paOMg/qrQiCBhff+YxOLIWqdpGVK3YjIbG427Jj4/P8PntbRg7jPolGaSSVuJNfHXKiiXPb/ULYbDMBF0smyPFyN2vXebB0CByvwaQndgp1BCYxnpRk72L6pRB0vdKQCdlOEHRR0KvupPGXlfEj9222s2Xge13wDU7HF0t8H3CyrSPutoEkslJi5YkDNYIbXmNKFZwTpWTX9oKNN4Drz8r7hQaUIDRZjdx5943Qt+qIz3LYbsR6T1XdSgEOVjOh/0pX8sC4leHFJ6QedNDMiMB8lJuTtB1EB4PxRLEjm651frKhBpZeVNGsgbpaIqpinpFbVHUoQTgSS0pk3sierEPr4hP9UUydEuC6dtStGRBBgwWYPeexvIWAxfEH9VifcQXuwwocGaxUcH03Lh0ZbGRPe+W73KkF3c/ycUKUxs7FquRG+5HbvhDPJ5Lp1qiW7K6LlxixyUKhV2XGkle5mtixpm9HUK+qIEiGO3Bl3f3sGz1dvQ9PY3c91cSjeYCqe7D8FY0YUtLO34NPkBNID48GV06FNOJjJ7FwHLD0GiA94NjEv4M1q9Nuog1N1ggCID+z+MYzQZYV5d0Ec8YgoDFz2JsiyYC1gbX1Z3y8igoQ8PknwJ+OaVcyMyLswrTE0A1VuVMTQQKOy8MyQYNeRdUs6TE34TUvwFVRXSdrlc5nhcqL/AXouzDzdFPVETT/5PsiabsskHRLlJmvq1aWpphqsz4jEsB/nVCPyOwKvJffmGm7sC/+Gn7Db4ng67qRVoqAAAAAElFTkSuQmCC"

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GAES_SINGLE.d9f34ec.png";

/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GAES_VERTICAL.7a5a18a.png";

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1742)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1696),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e4f6626",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./feedback.png": 708,
	"./feedback.svg": 709,
	"./leak_blue.gif": 710,
	"./leak_blue.png": 711,
	"./leak_blue_old.png": 712,
	"./leak_green.gif": 713,
	"./leak_green.png": 714,
	"./leak_green_old.png": 715,
	"./leak_green_static.png": 716,
	"./leak_red.gif": 717,
	"./leak_red_anim.gif": 718,
	"./leak_red_old.gif": 719,
	"./leak_red_old.png": 720,
	"./pin_blue.png": 721,
	"./pin_green.png": 722,
	"./pin_red.png": 723,
	"./place.png": 724,
	"./place.svg": 725,
	"./place_blue.png": 726,
	"./place_green.png": 727,
	"./place_green.svg": 728,
	"./place_red.gif": 729,
	"./place_red.svg": 730,
	"./place_red_old.png": 731,
	"./place_yellow.png": 732
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 762;

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./PdfDiv": 326,
	"./PdfDiv.vue": 326,
	"./PdfPressureDiv": 327,
	"./PdfPressureDiv.vue": 327,
	"./Poll": 328,
	"./Poll.vue": 328,
	"./Presion": 329,
	"./Presion.vue": 329,
	"./Pressure": 330,
	"./Pressure.vue": 330,
	"./PressureReport": 331,
	"./PressureReport.vue": 331,
	"./Reportepoll": 332,
	"./Reportepoll.vue": 332
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 763;

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1745)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(811),
  /* template */
  __webpack_require__(1699),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1744)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1698),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46569db3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_LEAKS_PROCESSED_IN_BATCH; });
var MAX_LEAKS_PROCESSED_IN_BATCH = 30;

/***/ }),

/***/ 802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    'options': {
      handler: function handler(newOption, oldOption) {
        this._chart.destroy();
        this.renderChart(this.chartData, this.options);
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),

/***/ 803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    'options': {
      handler: function handler(newOption, oldOption) {
        this._chart.destroy();
        this.renderChart(this.chartData, this.options);
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, { responsive: true, maintainAspectRadio: false });
  }
}));

/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    'options': {
      handler: function handler(newOption, oldOption) {
        this._chart.destroy();
        this.renderChart(this.chartData, this.options);
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, { responsive: true, maintainAspectRadio: false });
  }
}));

/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_routes__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_css__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_sidebar_menu__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_sidebar_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_sidebar_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_sidebar_menu_dist_vue_sidebar_menu_css__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_sidebar_menu_dist_vue_sidebar_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_sidebar_menu_dist_vue_sidebar_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_apexcharts__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_multiselect_dist_vue_multiselect_min_css__);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_sidebar_menu___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_apexcharts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_10_vue_apexcharts___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default.a);

Number.prototype.toFixedDown = function (digits) {
  var re = new RegExp('(-{0,1}\\d+\\.\\d{' + digits + '})(\\d)');
  var m = this.toString().match(re);
  return m ? parseFloat(m[1]) : this.valueOf();
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = "production" === 'production';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_ls___default.a);

var theme =  true ? 'gaes' : 'default';
var link = document.createElement('link');
link.rel = 'stylesheet';
link.href = '/static/css/' + theme + '-theme.css';
document.head.appendChild(link);

__WEBPACK_IMPORTED_MODULE_2__router_routes__["a" /* default */].beforeEach(function (to, from, next) {
  setTimeout(function () {
    document.querySelectorAll('.cov-datepicker').forEach(function (inp) {
      inp.value = '';
    });
  }, 10);
  __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.fill = true;
  var user = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('user');
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!user) {
      next({
        path: '/'
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router_routes__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('user')) {
      __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit('SET_USER', __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('user'));
    }

    var title = document.createElement('title');
    title.innerText =  true ? 'Ductos GAES' : 'Pipe Eagle';
    document.head.appendChild(title);
    this.healthCheck();
  },
  methods: {
    healthCheck: function healthCheck() {
      var url = "https://api.ductos-gaes.com/" + 'version';
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('Error de conexión con el servidor ' + response.status);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__site__ = __webpack_require__(807);






var Section = function () {
    function Section() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
        key: 'addSite',
        value: function addSite(site) {
            if (!site) {
                return;
            }
            this._sites[site.id] = site;
        }
    }, {
        key: 'addSiteFromData',
        value: function addSiteFromData(siteData) {
            this.addSite(__WEBPACK_IMPORTED_MODULE_2__site__["a" /* default */].fromData(siteData));
        }
    }, {
        key: 'id',
        get: function get() {
            return this._id;
        }
    }, {
        key: 'name',
        get: function get() {
            return this._name;
        }
    }, {
        key: 'part',
        get: function get() {
            return this._part;
        }
    }, {
        key: 'dimension',
        get: function get() {
            return this._dimension;
        }
    }, {
        key: 'sites',
        get: function get() {
            return this._sites;
        }
    }], [{
        key: 'fromData',
        value: function fromData(data) {
            if (!data) {
                return null;
            }

            var section = new Section();
            section._id = data.section_id || -1;
            section._name = data.section_name || null;
            section._part = data.section_part || -1;
            section._dimension = data.section_dimension || 0;
            section._sites = {};

            return section;
        }
    }]);

    return Section;
}();

/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







var Site = function () {
    function Site() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Site);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Site, [{
        key: 'hasData',
        value: function hasData() {
            return this._rtu_timestamp !== null && this._pressure !== null && this._flow !== null && this._battery !== null && this._site_door !== null && this._cabinet_door !== null && this._leak !== null && this._gps !== null && this._rtu_formated_date !== null && this._online !== null && this._comm_online !== null && this._enabled !== null;
        }
    }, {
        key: 'hasFailure',
        value: function hasFailure() {
            return !this.hasData() || this._site_door === 1 || this._cabinet_door === 1 || this._gps === 0 || this._online === 0;
        }
    }, {
        key: 'hasPressueAlarm',
        value: function hasPressueAlarm() {
            return this._pressure && Number(this._pressure) <= 2;
        }
    }, {
        key: 'isOffline',
        value: function isOffline() {
            return !this._online || !this._rtu_timestamp || !__WEBPACK_IMPORTED_MODULE_3_moment___default()(this._rtu_formated_date).isValid();
        }
    }, {
        key: 'id',
        get: function get() {
            return this._id;
        }
    }, {
        key: 'name',
        get: function get() {
            return this._name;
        }
    }, {
        key: 'km',
        get: function get() {
            return this._km;
        }
    }, {
        key: 'lat',
        get: function get() {
            return this._lat;
        }
    }, {
        key: 'lon',
        get: function get() {
            return this._lon;
        }
    }, {
        key: 'formattedCoord',
        get: function get() {
            return this._lat + ', ' + this._lon;
        }
    }, {
        key: 'city',
        get: function get() {
            return this._city;
        }
    }, {
        key: 'state',
        get: function get() {
            return this._state;
        }
    }, {
        key: 'trackedKm',
        get: function get() {
            return this._tracked_km;
        }
    }, {
        key: 'rtuTimestamp',
        get: function get() {
            return this._rtu_timestamp;
        }
    }, {
        key: 'pressure',
        get: function get() {
            return this._pressure;
        }
    }, {
        key: 'flow',
        get: function get() {
            return this._flow;
        }
    }, {
        key: 'battery',
        get: function get() {
            return this._battery;
        }
    }, {
        key: 'siteDoor',
        get: function get() {
            return this._site_door;
        }
    }, {
        key: 'cabinetDoor',
        get: function get() {
            return this._cabinet_door;
        }
    }, {
        key: 'leak',
        get: function get() {
            return this._leak;
        },
        set: function set(val) {
            this._leak = val;
        }
    }, {
        key: 'gps',
        get: function get() {
            return this._gps;
        }
    }, {
        key: 'rtuFormatedDate',
        get: function get() {
            return this._rtu_formated_date;
        }
    }, {
        key: 'online',
        get: function get() {
            return this._online;
        }
    }, {
        key: 'insertTimestamp',
        get: function get() {
            return this._insert_timestamp;
        }
    }, {
        key: 'comm_online',
        get: function get() {
            return this._comm_online;
        }
    }, {
        key: 'enabled',
        get: function get() {
            return this._enabled;
        }
    }, {
        key: 'section_id',
        get: function get() {
            return this._section_id;
        }
    }, {
        key: 'site_id',
        get: function get() {
            return this._site_id;
        }
    }], [{
        key: 'fromData',
        value: function fromData(data) {
            if (!data) {
                return null;
            }
            var site = new Site();
            site._id = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.site_id) ? data.site_id : -1;
            site._section_id = data.section_id || null;
            site._site_id = data.site_id || null;
            site._name = data.site_name || null;
            site._km = data.site_km || -1;
            site._lat = data.site_lat || 0;
            site._lon = data.site_lon || 0;
            site._city = data.site_city || null;
            site._state = data.site_state || null;
            site._tracked_km = data.site_tracked_km || 0;
            site._rtu_timestamp = data.rtu_timestamp || null;
            site._pressure = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.rtu_pressure) ? data.rtu_pressure : null;
            site._flow = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.rtu_flow) ? data.rtu_flow : null;
            site._battery = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.rtu_battery) ? data.rtu_battery : null;
            site._site_door = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.rtu_site_door) ? data.rtu_site_door : null;
            site._cabinet_door = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.rtu_cabinet_door) ? data.rtu_cabinet_door : null;
            site._leak = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.rtu_leak) ? data.rtu_leak : null;
            site._gps = __WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* default */].isNumber(data.rtu_gps) ? data.rtu_gps : null;
            site._rtu_formated_date = data.formated_date || null;
            site._online = data.online || 0;
            site._insert_timestamp = data.insert_timestamp || 'N/A';
            site._comm_online = data.comm_online || 0;
            site._enabled = data.enabled || 0;

            return site;
        }
    }, {
        key: '_hasData',
        value: function _hasData(site) {
            return site._rtu_timestamp !== null && site._pressure !== null && site._flow !== null && site._battery !== null && site._site_door !== null && site._cabinet_door !== null && site._leak !== null && site._gps !== null && site._rtu_formated_date !== null && site._online !== null && site._comm_online !== null && site._enabled !== null;
        }
    }, {
        key: '_hasFailure',
        value: function _hasFailure(site) {
            return !Site._hasData(site) || site._site_door === 1 || site._cabinet_door === 1 || site._gps === 0 || site._online === 0;
        }
    }, {
        key: '_hasPressureAlarm',
        value: function _hasPressureAlarm(site) {
            return site._pressure && Number(site._pressure) <= 2;
        }
    }, {
        key: '_isOffline',
        value: function _isOffline(site) {
            return !site._online || !site._rtu_timestamp || !__WEBPACK_IMPORTED_MODULE_3_moment___default()(site._rtu_formated_date).isValid();
        }
    }]);

    return Site;
}();

/* harmony default export */ __webpack_exports__["a"] = (Site);

/***/ }),

/***/ 808:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(231);
var _this = this;





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_ls___default.a);
__WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].state.fill = true;

var _appSections = {
  DASHBOARD: 'DASHBOARD',
  HISTORIC_ALARM: 'HISTORIC_ALARM',
  HISTORIC_REPORT: 'HISTORIC_REPORT',
  PRESION: 'PRESION',
  BINNACLE: 'BINNACLE',
  CAMP: 'CAMP',
  DIR_GENERAL: 'DIR_GENERAL',
  DIR_TREND: 'DIR_TREND',
  REPORT_POLL: 'REPORT_POLL',
  REPORT_TABLE_POLL: 'REPORT_TABLE_POLL',
  MONITOR: 'MONITOR',
  HELP: 'HELP',
  HEALTH: 'HEALTH'
};

var jwtDecode = function jwtDecode(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
};

var getRecoveryGuid = function getRecoveryGuid() {
  var recovery = __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].state.recovery;

  if (!recovery) {
    return null;
  }

  return recovery.recoveryGuid;
};

var getUser = function getUser() {
  var user = __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].state.user;

  if (!user) {
    user = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('user');
  }
  if (!user) {
    return null;
  }

  try {
    var decodedUser = jwtDecode(user.accessToken);
    decodedUser.permissions = decodedUser.permissions && JSON.parse(decodedUser.permissions);
    return decodedUser;
  } catch (error) {
    return null;
  }
};

var isTokenExpired = function isTokenExpired(user) {
  if (!user) {
    return true;
  }

  var currentTime = Date.now() / 1000;
  if (user && user.exp > currentTime) {
    return false;
  }

  if (_this.$store) {
    _this.$store.dispatch('clearUser');
  }
  return true;
};

var _userHasAccess = function _userHasAccess(appSection, user, from) {
  var permissions = user && user.permissions;
  var found = permissions && permissions.find(function (x) {
    return x === appSection;
  });
  return found;
};

var Gard = {
  dashboardGard: function dashboardGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.DASHBOARD, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  historicAlarmGard: function historicAlarmGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.HISTORIC_ALARM, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  historicDetailAlarmGard: function historicDetailAlarmGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.HISTORIC_ALARM, user, from)) {
      next();
    } else if (_userHasAccess(_appSections.DASHBOARD, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  historicReportGard: function historicReportGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.HISTORIC_REPORT, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  presionGard: function presionGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.PRESION, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  binnacleGard: function binnacleGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.BINNACLE, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  campGard: function campGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.CAMP, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  dirGeneralGard: function dirGeneralGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.DIR_GENERAL, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  dirTrendGard: function dirTrendGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.DIR_TREND, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  reportPollGard: function reportPollGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.REPORT_POLL, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  reportTablePollGard: function reportTablePollGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.REPORT_TABLE_POLL, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  monitorGard: function monitorGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.MONITOR, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  healthGard: function healthGard(to, from, next) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      next('/login');
    } else if (_userHasAccess(_appSections.HEALTH, user, from)) {
      next();
    } else {
      next('/unauthorized');
    }
  },
  userHasAccess: function userHasAccess(appSection) {
    var user = getUser();
    if (!user || isTokenExpired(user)) {
      return false;
    }
    return _userHasAccess(appSection, user, null);
  },
  recoveryGard: function recoveryGard(to, from, next) {
    var recoveryGuid = getRecoveryGuid();
    if (recoveryGuid) {
      next();
    } else {
      next('/dashboard');
    }
  },
  appSections: function appSections() {
    return _appSections.DASHBOARD;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Gard);

/***/ }),

/***/ 809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(1, 'M') : next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      } else {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('YYYY');
      this.checked.month = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('MM');
      this.checked.day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).day();

      var previousMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      var nextMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(i)
        });
        if (i === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).format('D')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).year() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).year() && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).month() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('YYYY') && _this.checked.month === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('MM') && d === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      var tmpMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');

          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
});

/***/ }),

/***/ 810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      type: String,
      default: "xls"
    },

    data: {
      type: Array,
      required: false,
      default: null
    },

    fields: {
      type: Object,
      required: false
    },

    exportFields: {
      type: Object,
      required: false
    },

    defaultValue: {
      type: String,
      required: false,
      default: ""
    },

    title: {
      default: null
    },

    footer: {
      default: null
    },

    name: {
      type: String,
      default: "data.xls"
    },
    fetch: {
      type: Function
    },
    meta: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    worksheet: {
      type: String,
      default: "Sheet1"
    },

    beforeGenerate: {
      type: Function
    },

    beforeFinish: {
      type: Function
    }
  },
  computed: {
    idName: function idName() {
      var now = new Date().getTime();
      return "export_" + now;
    },
    downloadFields: function downloadFields() {
      if (this.fields !== undefined) return this.fields;

      if (this.exportFields !== undefined) return this.exportFields;
    }
  },
  methods: {
    generate: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, json;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof this.beforeGenerate === 'function')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.beforeGenerate();

              case 3:
                data = this.data;

                if (!(typeof this.fetch === 'function' || !data)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return this.fetch();

              case 7:
                data = _context.sent;

              case 8:
                if (!(!data || !data.length)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                json = this.getProcessedJson(data, this.downloadFields);

                if (!(this.type === "html")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", this.export(this.jsonToXLS(json), this.name.replace(".xls", ".html"), "text/html"));

              case 15:
                if (!(this.type === "csv")) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", this.export(this.jsonToCSV(json), this.name.replace(".xls", ".csv"), "application/csv"));

              case 17:
                return _context.abrupt("return", this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel"));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generate() {
        return _ref.apply(this, arguments);
      }

      return generate;
    }(),

    export: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(data, filename, mime) {
        var blob;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                blob = this.base64ToBlob(data, mime);

                if (!(typeof this.beforeFinish === 'function')) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.beforeFinish();

              case 4:
                __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(blob, filename, mime);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _export(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return _export;
    }(),
    jsonToXLS: function jsonToXLS(data) {
      var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>${table}</table></body></html>';
      var xlsData = "<thead>";
      var colspan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data[0]).length;
      var _self = this;

      if (this.title != null) {
        xlsData += this.parseExtraData(this.title, '<tr><th colspan="' + colspan + '">${data}</th></tr>');
      }

      xlsData += "<tr>";
      for (var key in data[0]) {
        xlsData += "<th>" + key + "</th>";
      }
      xlsData += "</tr>";
      xlsData += "</thead>";

      xlsData += "<tbody>";
      data.map(function (item, index) {
        xlsData += "<tr>";
        for (var _key in item) {
          xlsData += "<td>" + _self.valueReformattedForMultilines(item[_key]) + "</td>";
        }
        xlsData += "</tr>";
      });
      xlsData += "</tbody>";

      if (this.footer != null) {
        xlsData += "<tfoot>";
        xlsData += this.parseExtraData(this.footer, '<tr><td colspan="' + colspan + '">${data}</td></tr>');
        xlsData += "</tfoot>";
      }

      return xlsTemp.replace("${table}", xlsData).replace("${worksheet}", this.worksheet);
    },
    jsonToCSV: function jsonToCSV(data) {
      var csvData = [];

      if (this.title != null) {
        csvData.push(this.parseExtraData(this.title, "${data}\r\n"));
      }

      for (var key in data[0]) {
        csvData.push(key);
        csvData.push(",");
      }
      csvData.pop();
      csvData.push("\r\n");

      data.map(function (item) {
        for (var _key2 in item) {
          var escapedCSV = '=\"' + item[_key2] + '\"';
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
          }
          csvData.push(escapedCSV);
          csvData.push(",");
        }
        csvData.pop();
        csvData.push("\r\n");
      });

      if (this.footer != null) {
        csvData.push(this.parseExtraData(this.footer, "${data}\r\n"));
      }
      return csvData.join("");
    },
    getProcessedJson: function getProcessedJson(data, header) {
      var keys = this.getKeys(data, header);
      var newData = [];
      var _self = this;
      data.map(function (item, index) {
        var newItem = {};
        for (var label in keys) {
          var property = keys[label];
          newItem[label] = _self.getValue(property, item);
        }
        newData.push(newItem);
      });

      return newData;
    },
    getKeys: function getKeys(data, header) {
      if (header) {
        return header;
      }

      var keys = {};
      for (var key in data[0]) {
        keys[key] = key;
      }
      return keys;
    },
    parseExtraData: function parseExtraData(extraData, format) {
      var parseData = "";
      if (Array.isArray(extraData)) {
        for (var i = 0; i < extraData.length; i++) {
          parseData += format.replace("${data}", extraData[i]);
        }
      } else {
        parseData += format.replace("${data}", extraData);
      }
      return parseData;
    },
    getValue: function getValue(key, item) {
      var field = (typeof key === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(key)) !== "object" ? key : key.field;
      var indexes = typeof field !== "string" ? [] : field.split(".");
      var value = this.defaultValue;

      if (!field) value = item;else if (indexes.length > 1) value = this.getValueFromNestedItem(item, indexes);else value = this.parseValue(item[field]);

      if (key.hasOwnProperty('callback')) value = this.getValueFromCallback(value, key.callback);

      return value;
    },
    valueReformattedForMultilines: function valueReformattedForMultilines(value) {
      if (typeof value == "string") return value.replace(/\n/ig, "<br/>");else return value;
    },
    getValueFromNestedItem: function getValueFromNestedItem(item, indexes) {
      var nestedItem = item;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(indexes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var index = _step.value;

          if (nestedItem) nestedItem = nestedItem[index];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.parseValue(nestedItem);
    },
    getValueFromCallback: function getValueFromCallback(item, callback) {
      if (typeof callback !== "function") return this.defaultValue;
      var value = callback(item);
      return this.parseValue(value);
    },
    parseValue: function parseValue(value) {
      return value || value === 0 || typeof value === 'boolean' ? value : this.defaultValue;
    },
    base64ToBlob: function base64ToBlob(data, mime) {
      var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      var bstr = atob(base64);
      var n = bstr.length;
      var u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }
  } });

/***/ }),

/***/ 811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Modal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reusable_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modals_Loading__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modals_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Modals_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_persistant_Menu__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_persistant_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_persistant_Menu__);


var $ = __webpack_require__(54);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  methods: {
    setModalInfo: function setModalInfo(info) {
      this.$refs.l_gen_m.setInfo(info);
    },
    closeModal: function closeModal() {
      $('#loading-general-modal #dismiss-button').click();
    }
  },
  components: {
    SideMenu: __WEBPACK_IMPORTED_MODULE_2_persistant_Menu___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_0_reusable_Modal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_1_components_Modals_Loading___default.a
  }
});

/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Input__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reusable_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reusable_SingleTable__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reusable_SingleTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reusable_SingleTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reusable_Modal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reusable_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reusable_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reusable_Map__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reusable_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_reusable_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_json_excel__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_json_excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_json_excel__);












/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      list: 'a',
      jsonData: [],
      jsonFields: {
        section: 'Sección',
        user: 'Usuario',
        fecha: 'Fecha',
        concepto: 'Concepto',
        comment: 'Comentario'
      },
      jsonMeta: [{ 'key': 'charset', 'value': 'utf-8' }],
      bitacoraNames: {
        'f1': {
          name: 'Sección'
        },
        'f2': {
          name: 'Usuario'
        },
        'f3': {
          name: 'Fecha'
        },
        'f4': {
          name: 'Concepto'
        },
        'f5': {
          name: 'Comentario'
        }
      },
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde,
      comentario: '',
      ducto: '',
      concepto: '',
      conceptoGet: '',
      ductoGet: '',
      desde: '',
      hasta: '',
      options: null,
      ductos: [],
      conceptos: [],
      getBitacora: [],
      showEx: false
    };
  },

  watch: {
    list: function list() {
      return this.list;
    }
  },
  methods: {
    setVal: function setVal(e) {
      this[e] = document.querySelector('#' + e).value;
    },
    postBitacora: function postBitacora() {
      var _this = this;

      var user = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('user');
      this.$store.dispatch('POST_BITACORA', {
        username: user.username,
        id_section: this.ducto,
        id_concept: this.concepto,
        comment: this.comentario
      }).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success('Se a añadido exitosamente tu comentario !');
        _this.ducto = '';
        _this.concepto = '';
        _this.comentario = '';
        document.querySelector('#ducto').value = '';
        document.querySelector('#concepto').value = '';
        document.querySelector('#comentario').value = '';
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.error('Hubo un error, Favor de volver a intentarlo');
        console.log('Error', err);
      });
    },
    searchBitacora: function searchBitacora() {
      var _this2 = this;

      this.ductoGet = document.querySelector('#ductoGet').value;
      this.conceptoGet = document.querySelector('#conceptoGet').value;
      if (this.desde === '' || this.hasta === '' || this.ductoGet === '' || this.conceptoGet === '') {
        return;
      }
      this.$store.dispatch('LOAD_BITACORA', {
        desde: this.desde,
        hasta: this.hasta,
        concepto: this.conceptoGet,
        ducto: this.ductoGet
      }).then(function (resp) {
        if (resp.data.length === 0) {
          __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.error('No se encontró información');
          return;
        }
        _this2.showEx = true;
        resp.data.forEach(function (d) {
          _this2.getBitacora.push({
            section: d.section_name,
            user: d.user_name,
            fecha: d.date,
            concepto: d.concept_name,
            comment: d.comment
          });
        });
        _this2.jsonData = _this2.getBitacora;
      });
    },
    changeMarkers: function changeMarkers(e) {
      this.list = e;
    },
    validate: function validate(e, d) {
      this[d] = e;
      var max = this.hasta;
      var min = this.desde;
      if (max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor';
        this.hastaText = 'Este valor debe ser mayor';
        this.validation = false;
      } else {
        this.desdeText = '';
        this.hastaText = '';
        this.validation = true;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.dispatch('LOAD_CONCEPTOS').then(function (resp) {
      resp.data.forEach(function (con) {
        _this3.conceptos.push({
          name: con.name,
          value: con.id_journal_concept
        });
      });
    }).catch(function (err) {
      console.log('Error', err);
    });
    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this3.ductos = _this3.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    }).catch(function (err) {
      console.log('Error', err);
    });
  },

  components: {
    selectC: __WEBPACK_IMPORTED_MODULE_2_reusable_Select___default.a,
    cInput: __WEBPACK_IMPORTED_MODULE_3_reusable_Input___default.a,
    cTable: __WEBPACK_IMPORTED_MODULE_4_reusable_SingleTable___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_5_reusable_Modal___default.a,
    cMap: __WEBPACK_IMPORTED_MODULE_6_reusable_Map___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue___default.a,
    JsonEx: __WEBPACK_IMPORTED_MODULE_8_vue_json_excel___default.a
  }
});

/***/ }),

/***/ 813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_json_excel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reusable_Input__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reusable_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_reusable_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reusable_DropDownTable__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reusable_DropDownTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_reusable_DropDownTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Campo_CampoTable__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Campo_CampoTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Campo_CampoTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_toastr__);












var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      jsonData: [],
      jsonFields: {},
      jsonMeta: [{ 'key': 'charset', 'value': 'utf-8' }],
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsFecha,
      fecha: '',
      ductos: '',
      data: [],
      batId: '',
      baterias: [],
      bitacoraNames: {
        'f1': {
          name: 'Estación'
        },
        'f2': {
          name: 'Antena'
        },
        'f3': {
          name: 'Fecha'
        },
        'f4': {
          name: 'Retardo'
        },
        'f5': {
          name: 'Presión A'
        },
        'f6': {
          name: 'Sensibilidad'
        },
        'f7': {
          name: 'Factor'
        },
        'f9': {
          name: 'Batería'
        },
        'f10': {
          name: 'USB Libre'
        },
        'f11': {
          name: 'Señal'
        },
        'f15': {
          name: 'Rango PIT'
        }
      },
      camposBotNames: {
        'c1': {
          name: 'Ducto'
        },
        'c2': {
          name: 'Estación'
        },
        'c3': {
          name: '00:00'
        },
        'c4': {
          name: '01:00'
        },
        'c5': {
          name: '02:00'
        },
        'c6': {
          name: '03:00'
        },
        'c7': {
          name: '04:00'
        },
        'c8': {
          name: '05:00'
        },
        'c9': {
          name: '06:00'
        },
        'c10': {
          name: '07:00'
        },
        'c11': {
          name: '08:00'
        },
        'c12': {
          name: '09:00'
        },
        'c13': {
          name: '10:00'
        },
        'c14': {
          name: '11:00'
        },
        'c15': {
          name: '12:00'
        },
        'c16': {
          name: '13:00'
        },
        'c17': {
          name: '14:00'
        },
        'c18': {
          name: '15:00'
        },
        'c19': {
          name: '16:00'
        },
        'c20': {
          name: '17:00'
        },
        'c21': {
          name: '18:00'
        },
        'c22': {
          name: '19:00'
        },
        'c23': {
          name: '20:00'
        },
        'c24': {
          name: '21:00'
        },
        'c125': {
          name: '22:00'
        },
        'c26': {
          name: '23:00'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this.ductos = _this.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    });

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.camposBotNames).forEach(function (f, k) {
      if (_this.camposBotNames[f].name !== 'Ducto' || _this.camposBotNames[f].name !== 'Estación') {
        _this.jsonFields[k] = _this.camposBotNames[f].name;
      }
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this.camposBotNames).length === k + 1) {
        _this.jsonFields[k + 2] = 'Ducto';
        _this.jsonFields[k + 3] = 'Estación';
      }
    });
  },

  watch: {
    baterias: function baterias() {
      var _this2 = this;

      this.baterias.forEach(function (f, key) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(f).forEach(function (item, k) {
          if (!_this2.jsonData[key]) {
            _this2.jsonData[key] = {};
            _this2.jsonData[key][0] = f['ducto'];
            _this2.jsonData[key][1] = f['estacion'];
          }
          if (item === 'ducto' || item === 'estacion') {
            return;
          }
          if (item.split('')[0] === '0') {
            _this2.jsonData[key][String(Number(item.split('')[1]) + 2)] = f[String(item)] || 0;
          } else {
            _this2.jsonData[key][String(Number(item) + 2)] = f[String(item)] || 0;
          }
        });
      });
    }
  },
  methods: {
    csvExport: function csvExport() {
      var csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.jsonData);
      window.open(encodeURI(csvContent));
    },
    loading: function loading() {
      document.querySelector('#loading-btn').click();
    },
    formatDate: function formatDate(date) {
      if (date === '') {
        date = new Date().toLocaleString('es-US', {
          hour12: false
        }).split(' ');
      }

      var time = date[1];
      var mdy = date[0].split('/');
      var month = parseInt(mdy[0]);
      var day = parseInt(mdy[1]);
      var year = parseInt(mdy[2]);
      return year + '-' + day + '-' + month + ' ' + time;
    },
    bateriaEvent: function bateriaEvent(e) {
      var _this3 = this;

      if (this.batId === '') {
        return;
      }
      this.loading();
      var hasta = null;
      var d = document.querySelector('#' + this.batId).value;
      if (this.fecha === '') {
        this.fecha = new Date(new Date().setHours(0, 0, 0)).toLocaleString('es-US', { hour12: false }).split(' ');
        this.fecha = this.formatDate(this.fecha);
        hasta = new Date().toLocaleString('es-US', { hour12: false }).split(' ');
        hasta = this.formatDate(hasta);
      } else {
        var temp = this.fecha;
        temp = temp.split('-');
        temp[2] = temp[2].split(' ')[0];
        hasta = temp[0] + '-' + temp[1] + '-' + temp[2] + ' 23:59';
      }

      this.$store.dispatch('LOAD_BATERIA', {
        estacion: '',
        ducto: d,
        desde: this.fecha,
        hasta: hasta
      }).then(function (resp) {
        if (resp.data.length === 0) {
          __WEBPACK_IMPORTED_MODULE_10_toastr___default.a.error('No se encontró información');
          _this3.loading();
          return;
        }
        _this3.loading();
        var arr = {};
        var temp = [];
        var firstMin = [];

        resp.data.forEach(function (r) {
          var time = r.formated_date.split(' ')[1].split(':');
          if (!temp['\'' + time[0] + '\'']) {
            temp['\'' + time[0] + '\''] = [];
            temp['\'' + time[0] + '\''].push(time[1]);
          } else {
            temp['\'' + time[0] + '\''].push(time[1]);
          }
        });

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(temp).map(function (t, i) {
          var min = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(temp[t]));
          firstMin.push(min[min.length - 1]);
        });
        temp = [];

        resp.data.forEach(function (r, i) {
          for (var index = 0; index < 24; index++) {
            var time = r.formated_date.split(' ')[1].split(':');
            if (Number(time[0]) === Number(index) && time[1] === firstMin[index]) {
              temp.push(r);
            }
          }
        });

        temp.reverse().forEach(function (z) {
          var hExists = 0;
          if (!arr[z.rtu_name]) {
            arr[z.rtu_name] = [];
            arr[z.rtu_name].push(z);
          } else {
            arr[z.rtu_name].forEach(function (a) {
              var aH = a.formated_date.split(' ')[1].split(':')[0];
              var zH = z.formated_date.split(' ')[1].split(':')[0];

              if (Number(aH) === Number(zH)) {
                hExists++;
              }
            });
            if (hExists === 0) {
              arr[z.rtu_name].push(z);
            }
          }
        });

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(arr).map(function (k, i) {
          _this3.baterias.push({
            ducto: arr[k][0].section_name,
            estacion: arr[k][0].rtu_name
          });
          arr[k].forEach(function (a, index) {
            _this3.baterias[i][a.formated_date.split(' ')[1].split(':')[0]] = a.battery;
          });
        });
      }).catch(function (err) {
        console.log('Error', err);
      });
    },
    ductosEvent: function ductosEvent(e) {
      var _this4 = this;

      this.loading();
      var d = document.querySelector('#' + e);
      this.$store.dispatch('LOAD_ESTADOS', {
        estado: 1
      }).then(function (resp) {
        if (resp.data.length === 0) {
          __WEBPACK_IMPORTED_MODULE_10_toastr___default.a.error('No se encontró información');
          _this4.loading();
          return;
        }
        _this4.loading();
        var data = resp.data.filter(function (ducto) {
          return d.value === ducto.id_section;
        });
        data.forEach(function (dat) {
          _this4.data.push({
            estacion: dat.id_section,
            site: dat.site_name,
            antena: dat.antena || 0,
            fecha: new Date(Number(dat.gps_timestamp)).toLocaleString('es-US', { hour12: false }) || null,
            retardo: dat.retardo || 0,
            presion: dat.pressure || 0,
            sensibilidad: dat.sesns || 0,
            factor: dat.factor || 0,
            bateria: dat.battery || 0,
            usb: dat.usb || 0,
            senal: dat.senal || 0,
            pit: dat.pit || 0
          });
        });
      }).catch(function (err) {
        console.log('error', err);
      });
    }
  },
  components: {
    selectC: __WEBPACK_IMPORTED_MODULE_5_reusable_Select___default.a,
    cInput: __WEBPACK_IMPORTED_MODULE_6_reusable_Input___default.a,
    cTable: __WEBPACK_IMPORTED_MODULE_7_reusable_DropDownTable___default.a,
    singleTable: __WEBPACK_IMPORTED_MODULE_8_components_Campo_CampoTable___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue___default.a,
    Modal: Modal,
    LoadingModal: LoadingModal,
    JsonEx: __WEBPACK_IMPORTED_MODULE_4_vue_json_excel___default.a
  }
});

/***/ }),

/***/ 814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data', 'names', 'id', 'modalTarget', 'height']
});

/***/ }),

/***/ 815:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChart_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      initial_loading: false,
      chartOps: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            display: true,
            time: {
              unit: 'hour',
              displayFormats: {
                day: 'MMM D',
                hour: 'DD MMM,	HH:mm'
              },
              min: new Date().getTime() - 86400000,
              max: new Date().getTime() + 28800000,
              stepSize: 3
            }
          }],
          yAxes: [{
            ticks: {
              min: 1,
              max: 50,
              stepSize: 10,
              callback: function callback(value, index, values) {
                return Number(value.toString());
              }
            }
          }]
        }
      },
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde,
      desde: '',
      hasta: '',
      tipo: 'FILTER_DATA',
      click: false,
      hastaEmpty: true,
      presion: null,
      pollTimer: null,
      datacollection: null,
      chartOptions: null,
      preasure: [],
      opDuctos: [],
      ductos: [],
      ducto: null,
      estaciones: [],
      estacion: null,
      opEstaciones: [],
      fechas: [],
      newestGpsTimestamp: -1,
      maxChart: 0,
      desdeText: '',
      hastaText: '',
      validation: false,
      showNewWindow: false
    };
  },

  props: ['pdesde', 'phasta', 'pducto', 'pestacion'],
  methods: {
    updateInfo: function updateInfo(data) {
      var _this = this;

      var section = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data)[0];
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[section]);
      var datasets = [];
      var colors = ['#e74c3c ', '#28b463 ', '#5dade2 ', '#f4d03f ', '#FFFFFF ', '#884ea0 ', '#e67e22 ', '#6c3483 ', '#f1948a ', '#45b39d ', '#76d7c4 ', '#c0392b ', '#d7bde2 ', '#2e86c1 ', '#117a65 ', '#d35400 ', '#239b56 '];

      var index = 0;
      var didUpdate = false;
      labels.forEach(function (station) {
        data[section][station].pressure.filter(function (yValue) {
          if (yValue.y >= _this.maxChart) {
            _this.maxChart = yValue.y;
            didUpdate = true;
          }
        });
      });
      if (didUpdate) {
        this.maxChart = Math.ceil(this.maxChart / 5) * 5;
      }
      labels.forEach(function (station) {
        datasets.push({
          label: station,
          data: data[section][station].pressure,
          fill: false,
          backgroundColor: colors[index],
          borderColor: colors[index],
          pointBorderWidth: 1,
          borderWidth: 1,
          pointRadius: 0
        });
        index = index + 1;
      });
      this.datacollection = {
        datasets: datasets
      };
      this.chartOps.scales.xAxes[0].time.min = this.desde;
      this.chartOps.scales.xAxes[0].time.max = this.hasta;

      for (var idx in this.datacollection.datasets) {
        var _dataSet = this.datacollection.datasets[idx];
        var _station = _dataSet.label;
        var _data = _dataSet.data;
        if (data[section] && data[section][_station] && data[section][_station].pressure) {
          this.datacollection.datasets[idx].data = data[section][_station].pressure.concat(_data);
          var unixtime = Date.parse(data.newest_data);
          this.chartOps.scales.xAxes[0].time.max = unixtime;
        }
      }
      var max = void 0;
      this.hasta === 'null' ? max = new Date() : max = this.hasta;
      var min = this.desde;
      var timeDiff = Math.abs(new Date(max).getTime() - new Date(min).getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (diffDays > 2) {
        this.chartOps.scales.xAxes[0].time.unit = 'day';
        this.chartOps.scales.xAxes[0].time.stepSize = 1;
      } else {
        this.chartOps.scales.xAxes[0].time.unit = 'hour';
        this.chartOps.scales.xAxes[0].time.stepSize = 3;
      }

      this.chartOps.scales.yAxes[0].ticks.max = this.maxChart;

      this.maxChart <= 30 ? this.chartOps.scales.yAxes[0].ticks.stepSize = 5 : this.chartOps.scales.yAxes[0].ticks.stepSize = 10;
    },
    fill: function fill(presion) {
      if (!presion || presion.length <= 0) {
        __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('No se encontró información');
        return;
      }

      this.initial_loading = true;
      var data = {};
      var timestamps = {};
      presion.forEach(function (event) {
        if (!data[event['section_name']]) {
          data[event['section_name']] = {};
        }
        if (!data[event['section_name']][event['rtu_name']]) {
          data[event['section_name']][event['rtu_name']] = {};
          data[event['section_name']][event['rtu_name']].pressure = [];
        }
        data[event['section_name']][event['rtu_name']].pressure.push({
          y: event.pressure,
          x: event.formated_date
        });
        timestamps[event['formated_date']] = event['formated_date'];
      });
      this.updateInfo(data);
    },
    pollData: function pollData(options) {
      var _this2 = this;

      this.$store.dispatch('GET_PRESION', {
        lastTimestamp: options.gpsTimestamp,
        ducto: options.ducto,
        estacion: options.estacion,
        desde: options.desde,
        hasta: options.hasta
      }).then(function (resp) {
        if (!resp || !resp.data || resp.data.length <= 0) {
          __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('No se encontró información');
        } else {
          _this2.fill(resp.data);
        }
      }).catch(function (err) {
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error(err);
      });
    }
  },
  watch: {
    cclick: function cclick() {
      this.$store.state.cclick = true;
      if (!this.desde && !this.ducto) {
        this.desde = this.pdesde;
        this.hasta = this.phasta;
        this.estacion = this.pestacion;
        this.ducto = this.pducto;
        document.querySelector('#line-charts').style.width = '100%';
      }

      setTimeout(function () {}, 500);
      this.pollData(this.options);
    }
  },
  mounted: function mounted() {
    this.options = this.$route.query;
    this.datacollection = null;
    this.pollData(this.options);
  },

  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChart_js__["a" /* default */]
  }
});

/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChart_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);



var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      modalName: 'loading-modal2',
      info: {
        modalName: this.modalName
      },
      initial_loading: false,
      chartOps: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            display: true,
            time: {
              unit: 'hour',
              displayFormats: {
                day: 'MMM D',
                hour: 'DD MMM,	HH:mm'
              },
              min: new Date().getTime() - 86400000,
              max: new Date().getTime() + 28800000,
              stepSize: 3
            }
          }],
          yAxes: [{
            ticks: {
              min: 1,
              max: 50,
              stepSize: 10,
              callback: function callback(value, index, values) {
                return Number(value.toString());
              }
            }
          }]
        }
      },
      desde: this.$route.params.desde,
      hasta: this.$route.params.hasta,
      hastaEmpty: true,
      presion: null,
      pollTimer: null,
      datacollection: {},
      chartOptions: null,
      preasure: [],
      opDuctos: [],
      ductos: [],
      ducto: this.$route.params.ducto,
      estaciones: [],
      estacion: this.$route.params.estacion,
      opEstaciones: [],
      fechas: [],
      newestGpsTimestamp: -1,
      maxChart: 0,
      desdeText: '',
      hastaText: '',
      validation: false,
      showNewWindow: false
    };
  },

  props: ['pdesde', 'phasta', 'pducto', 'pestacion', 'cclick'],
  methods: {
    filterData: function filterData() {
      var _this = this;

      this.maxChart = 0;

      this.$store.dispatch('LOAD_PRESION', {
        lastTimestamp: -1,
        ducto: this.ducto,
        estacion: this.estacion === 'TODAS' || this.estacion === '' ? '' : this.estacion,
        desde: this.desde,
        hasta: this.hasta
      }).then(function (resp) {
        if (resp === 'no-data' && _this.$store.state.cclick === true) {
          _this.$store.state.cclick = false;
          __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('No se encontró información');
          _this.loading();
        }
        _this.fill();
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateInfo: function updateInfo(label, data) {
      var _this2 = this;

      var section = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data)[0];
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[section]);
      var datasets = [];
      var colors = ['#e74c3c ', '#28b463 ', '#5dade2 ', '#f4d03f ', '#232323 ', '#884ea0 ', '#e67e22 ', '#6c3483 ', '#f1948a ', '#45b39d ', '#76d7c4 ', '#c0392b ', '#d7bde2 ', '#2e86c1 ', '#117a65 ', '#d35400 ', '#239b56 '];

      var index = 0;
      var didUpdate = false;
      labels.forEach(function (station) {
        data[section][station].pressure.filter(function (yValue) {
          if (yValue.y >= _this2.maxChart) {
            _this2.maxChart = yValue.y;
            didUpdate = true;
          }
        });
      });
      if (didUpdate) {
        this.maxChart = Math.ceil(this.maxChart / 5) * 5;
      }

      labels.forEach(function (station) {
        datasets.push({
          label: station,
          data: data[section][station].pressure,
          fill: false,
          backgroundColor: colors[index],
          borderColor: colors[index],
          pointBorderWidth: 1,
          borderWidth: 1,
          pointRadius: 1
        });
        index = index + 1;
      });
      this.datacollection = {
        datasets: datasets
      };

      this.chartOps.scales.xAxes[0].time.min = this.desde;
      this.chartOps.scales.xAxes[0].time.max = this.hasta;

      var max = void 0;
      this.hasta === 'null' ? max = new Date() : max = this.hasta;
      var min = this.desde;
      var timeDiff = Math.abs(new Date(max).getTime() - new Date(min).getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (diffDays > 2) {
        this.chartOps.scales.xAxes[0].time.unit = 'day';
        this.chartOps.scales.xAxes[0].time.stepSize = 1;
      } else {
        this.chartOps.scales.xAxes[0].time.unit = 'hour';
        this.chartOps.scales.xAxes[0].time.stepSize = 3;
      }

      this.chartOps.scales.yAxes[0].ticks.max = this.maxChart;

      this.maxChart <= 30 ? this.chartOps.scales.yAxes[0].ticks.stepSize = 5 : this.chartOps.scales.yAxes[0].ticks.stepSize = 10;

      this.$refs.chart._chart.update(0);
      if (this.$store.state.cclick) {
        setTimeout(function () {
          var canvasEle = document.querySelector('#line-chart');
          canvasEle = canvasEle.toDataURL();
          var imgC = document.createElement('img');
          imgC.id = 'chartImg';
          imgC.src = canvasEle;
          imgC.style = 'width:100%;';
          document.querySelector('#imgChart').innerHTML = '';
          document.querySelector('#imgChart').appendChild(imgC);
          _this2.$store.state.cclick = false;
        }, 500);
      }
      this.loading();
    },
    fill: function fill() {
      var _this3 = this;

      var state = this.$store.state;
      if (state.cached_presion === null) {
        this.pollTimer = setTimeout(function () {
          _this3.pollData(-1);
        }, 500);
        return;
      }

      this.initial_loading = true;
      this.presion = this.$store.state.cached_presion;
      var data = {};
      var timestamps = {};
      var newestData = null;
      if (this.presion.length > 0) {
        this.presion.forEach(function (event) {
          if (!data[event['section_name']]) {
            data[event['section_name']] = {};
          }
          if (!data[event['section_name']][event['rtu_name']]) {
            data[event['section_name']][event['rtu_name']] = {};
            data[event['section_name']][event['rtu_name']].pressure = [];
          }
          data[event['section_name']][event['rtu_name']].pressure.push({
            y: event.pressure,
            x: event.formated_date
          });
          timestamps[event['formated_date']] = event['formated_date'];
          if (!newestData || newestData < event['formated_date']) {
            newestData = event['formated_date'];
          }
          if (_this3.newestGpsTimestamp < event['gps_timestamp']) {
            _this3.newestGpsTimestamp = event['gps_timestamp'];
          }
        });
        data['newest_data'] = newestData;
        this.updateInfo(this.ducto, data);
      }
    },
    loading: function loading() {
      document.querySelector('#loading-btn-chart').click();
    },
    pollData: function pollData(gpsTimestamp) {
      var _this4 = this;

      if (this.hastaEmpty) {
        this.$store.commit('SET_PRESION', { data: {} });
        this.$store.dispatch('LOAD_PRESION', {
          lastTimestamp: gpsTimestamp,
          ducto: this.ducto,
          estacion: this.estacion,
          desde: this.desde,
          hasta: this.hasta
        }).then(function (resp) {
          if (resp === 'no-data' && _this4.$store.state.cclick === true) {
            _this4.$store.state.cclick = false;
            _this4.loading();
            __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('No se encontró información');
          } else {
            _this4.fill();
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  },
  watch: {
    cclick: function cclick() {
      var _this5 = this;

      this.$store.state.cclick = true;
      if (!this.desde && !this.ducto) {
        this.desde = this.pdesde;
        this.hasta = this.phasta;
        this.estacion = this.pestacion;
        this.ducto = this.pducto;
        document.querySelector('#line-charts').style.width = '100%';
      }

      setTimeout(function () {
        _this5.loading();
      }, 500);
      this.pollData(-1);
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    if (this.cclick === undefined) {
      this.datacollection = null;
      setTimeout(function () {
        _this6.loading();
      }, 500);
      this.datacollection = null;
      this.pollData(-1);
    }
  },

  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChart_js__["a" /* default */],
    Modal: Modal,
    LoadingModal: LoadingModal
  }
});

/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Modal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reusable_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modals_LoginModal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modals_LoginModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Modals_LoginModal__);








var $ = __webpack_require__(54);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      section: 'Monitoreo',
      monitoringData: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$store.monitoring),
      rtuData: [],
      leaksData: [],

      updateTimer: undefined,
      info: {
        modalName: this.modalName
      },
      modalName: 'loading-modal',

      modalSite: {},
      modalType: 0,
      showInitialLoading: false,

      publishLeak: -1
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    $('#loading-btn').click();
    var fetchMonitoring = function fetchMonitoring() {
      _this2.$store.dispatch('GET_MONITORING').then(function (data) {}).catch(function (err) {}).then(function () {
        if (!_this2.showInitialLoading) {
          _this2.showInitialLoading = true;
          $('#loading-btn').click();
          setTimeout(function () {
            _this2.modalType = 1;
          }, 500);
        }
        _this2.updateTimer = setTimeout(fetchMonitoring, 60000);
      });
    };
    fetchMonitoring();
    this.$store.watch(function (state) {
      return state.monitoring;
    }, function () {
      _this2.drawMonitrongInfo();
    }, {
      immediate: true
    });

    var _this = this;
    var user = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].ls.get('user');
    $('#config-leak-manual').click(function () {
      var slider = this;
      _this.modalType = 0;
      setTimeout(function () {
        $('#loading-btn').click();
      }, 200);
      var checked = $(slider).prop('checked') || false;
      _this.$store.dispatch('POST_MONITORING_SETTING', {
        setting: 'leak_default_status',
        value: checked ? -1 : 0,
        username: user.username
      }).then(function (data) {}).catch(function (err) {
        $('#config-leak-manual').prop('checked', !checked);
      }).then(function () {
        setTimeout(function () {
          $('#loading-btn').click();setTimeout(function () {
            _this.modalType = 1;
          }, 500);
        }, 100);
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.updateTimer);
  },

  methods: {
    drawMonitrongInfo: function drawMonitrongInfo() {
      var monitoring = this.$store.getters.GET_MONITORING;
      if (!monitoring) {
        return;
      }
      this.monitoringData = monitoring;
      var settings = this.monitoringData.settings;
      var value = parseInt(settings['leak_default_status']);
      $('#config-leak-manual').prop('checked', value);
    },
    sectionHasData: function sectionHasData(section) {
      var hasInfo = false;
      section.sites.some(function (s) {
        if (s.timestamp) {
          hasInfo = true;
          return true;
        }
      });
      return hasInfo;
    },
    showDucto: function showDucto(id) {
      $('.' + id).toggleClass('no-show');
    },
    showLeaks: function showLeaks() {
      $('.leaks-oor').toggleClass('no-show');
    },
    promptSiteStatus: function promptSiteStatus(site) {
      this.modalType = 1;
      this.modalSite = site;
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
        $('#enable-btn').click();
      });
    },
    postSiteEnabled: function postSiteEnabled(site) {
      var _this3 = this;

      var user = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].ls.get('user');
      this.modalType = 0;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, site, { enabled: site.enabled ? 0 : 1, username: user.username });
      this.$store.dispatch('POST_MONITORING_SITE_ENABLED', params).then(function (data) {
        _this3.monitoringData.rtu[site.key_section].sites[site.key_site].enabled = site.enabled ? 0 : 1;
        _this3.monitoringData.rtu[site.key_section].sites[site.key_site].redraw = true;
      }).catch(function (err) {}).then(function () {
        $('#loading-btn').click();
        setTimeout(function () {
          _this3.modalType = 1;
        }, 500);
      });
    },
    promptPublishLeak: function promptPublishLeak(idLeak) {
      this.modalType = 2;
      this.publishLeak = idLeak;
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
        $('#publish-btn').click();
      });
    },
    postPublishLeak: function postPublishLeak(idLeak) {
      var _this4 = this;

      var user = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].ls.get('user');
      this.modalType = 0;
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { id_leak: idLeak, username: user.username });
      this.$store.dispatch('POST_MONITORING_PUBLISH_LEAK', params).then(function (data) {
        var index = _this4.monitoringData.leaks.findIndex(function (l) {
          return idLeak === l.id_leak;
        });
        _this4.monitoringData.leaks[index].username = user.username;
        _this4.monitoringData.leaks[index].status = 1;
      }).catch(function (err) {}).then(function () {
        $('#loading-btn').click();
        setTimeout(function () {
          _this4.modalType = 2;
        }, 500);
      });
    },
    sectionHasFailure: function sectionHasFailure(section, type, val) {
      var _this5 = this;

      var failure = false;
      section.sites.some(function (v) {
        if (_this5.siteHasFailure(v, type, val)) {
          failure = true;
          return true;
        }
      });
      return failure;
    },
    siteHasFailure: function siteHasFailure(site, type, val) {
      if (!site.timestamp) {
        return false;
      }
      if (!type) {
        return site.battery <= 10 || site.pressure === 0 || site.site_door === 1 || site.cabinet_door === 1 || site.gps === 0 || site.online === 0;
      } else if (type === 'battery') {
        return site[type] <= val;
      } else {
        return site[type] === val;
      }
    }
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3_reusable_Modal___default.a,
    LoadingModal: __WEBPACK_IMPORTED_MODULE_4__Modals_LoginModal___default.a
  }
});

/***/ }),

/***/ 818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);


var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {
        modalName: 'loading-modal'
      },
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsFecha,
      tablaConteo: [],
      tablaFuera: [],
      tablaInfo: [],
      sitiosTotal: 0,
      fecha: null
    };
  },

  components: {
    SelectC: __WEBPACK_IMPORTED_MODULE_0_reusable_Select___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    LoadingModal: LoadingModal,
    Modal: Modal
  },
  methods: {
    loading: function loading() {
      document.querySelector('#loading-btn').click();
    },
    actualizar: function actualizar() {
      var _this = this;

      this.loading();
      this.$store.dispatch('LOAD_GENERAL', { fecha: this.fecha }).then(function (resp) {
        if (resp.data.length === 0) {
          __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('No se encontró información');
          _this.loading();
          return;
        }
        _this.tablaConteo = [];
        resp.data.forEach(function (re) {
          var temp = JSON.parse(re.section_info);
          _this.sitiosTotal += Number(temp.site_count);
          _this.tablaConteo.push({
            ducto: temp.section_name,
            alarms: temp.alarm_count,
            sitios: temp.site_count
          });
        });
        _this.loading();
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.loading();
    }, 500);
    this.$store.dispatch('LOAD_GENERAL', { fecha: null }).then(function (resp) {
      resp.data.forEach(function (re) {
        var temp = JSON.parse(re.section_info);
        _this2.tablaInfo.push({
          ducto: temp.section_name,
          site: temp.site_count,
          kmInit: temp.km_init,
          kmFinal: temp.km_final,
          kmTracked: temp.km_tracked
        });
        _this2.sitiosTotal += Number(temp.site_count);
        _this2.tablaConteo.push({
          ducto: temp.section_name,
          alarms: temp.alarm_count,
          sitios: temp.site_count
        });

        var s = temp.sites;
        s.forEach(function (r) {
          if (!r.last_info || r.time_since_last_info < 0 || r.time_since_last_info > 300) {
            _this2.tablaFuera.push({
              ducto: temp.section_name,
              est: r.site_name,
              info: r.last_info || 'No Info',
              hours: r.time_since_last_info === -1 ? 'No Info' : r.time_since_last_info
            });
          }
        });
      });
      setTimeout(function () {
        _this2.loading();
      }, 500);
    });
  }
});

/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Charts_BarChart_KM_js__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Charts_PieChart_City_js__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Charts_PieChart_Ducts_js__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_axios__ = __webpack_require__(346);





var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};









/* harmony default export */ __webpack_exports__["default"] = ({
  'bar-chart': __WEBPACK_IMPORTED_MODULE_4_components_Charts_BarChart_KM_js__["a" /* default */],
  'pie-chart-city': __WEBPACK_IMPORTED_MODULE_5_components_Charts_PieChart_City_js__["a" /* default */],
  'pie-chart-duct': __WEBPACK_IMPORTED_MODULE_6_components_Charts_PieChart_Ducts_js__["a" /* default */],
  data: function data() {
    return {
      modalName: 'loading-modal',
      info: {
        modalName: this.modalName
      },
      initial_loading: false,
      pieChartOps: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false
      },
      chartOps: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        ticks: {
          stepSize: 1,
          min: 0,
          autoSkip: false
        }
      },
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde,
      desde: '',
      hasta: '',
      tipo: 'FILTER_DATA',
      click: false,
      hastaEmpty: true,
      presion: null,
      pollTimer: null,
      datacollection: null,
      CityDatac: null,
      DuctDatac: null,
      KMsDatac: null,
      chartOptions: null,
      preasure: [],
      opDuctos: [],
      ductos: [],
      ducto: null,
      estaciones: [],
      estacion: null,
      opEstaciones: [],
      fechas: [],
      newestGpsTimestamp: -1,
      maxChart: 0,
      desdeText: '',
      hastaText: '',
      validation: false,
      showNewWindow: false,
      data_response: [],
      data_by_duct: [],
      data_by_city: [],
      data_by_km: [],
      data_by_duct_data: [],
      data_by_duct_label: [],
      data_by_city_data: [],
      data_by_city_label: [],
      data_by_km_data: [],
      data_by_km_label: [],
      direction_trends_object: []
    };
  },

  computed: {},
  methods: {
    DIVIDE_KM_ARRAY: function DIVIDE_KM_ARRAY() {
      var kms = this.data_by_km;
      var datasets = [];
      var colorlist = ['#e74c3c', '#28b463', '#5dade2', '#f4d03f', '#FFFFFF', '#884ea0', '#e67e22', '#6c3483', '#f1948a', '#45b39d', '#76d7c4', '#c0392b', '#d7bde2', '#2e86c1', '#117a65', '#d35400', '#239b56', '#47145c', '#808080', '#800080', '#3366ff', '#800000', '#99cc00', '#666699', '#333300', '#9F609C', '#E4D183', '#0F3057', '#404B69', '#333333'];
      for (var i = 0; i < kms.length; i++) {
        this.data_by_km_data[i] = kms[i].data;
        this.data_by_km_label[i] = kms[i].label;
      }
      datasets.push({
        label: 'ALERTAS CADA 10 KM',
        data: this.data_by_km_data,
        fill: true,
        backgroundColor: colorlist,
        pointBorderWidth: 1,
        borderWidth: 1,
        pointRadius: 0
      });
      this.KMsDatac = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.datasets, { labels: this.data_by_km_label, datasets: datasets });
    },
    DIVIDE_DUCT_ARRAY: function DIVIDE_DUCT_ARRAY() {
      var datasets = [];
      var colorlist = ['#e74c3c', '#28b463', '#5dade2', '#f4d03f', '#FFFFFF', '#884ea0', '#e67e22', '#6c3483', '#f1948a', '#45b39d', '#76d7c4', '#c0392b', '#d7bde2', '#2e86c1', '#117a65', '#d35400', '#239b56', '#47145c', '#808080', '#800080', '#3366ff', '#800000', '#99cc00', '#666699', '#333300', '#9F609C', '#E4D183', '#0F3057', '#404B69', '#333333'];
      var duct = this.data_by_duct;
      for (var i = 0; i < duct.length; i++) {
        this.data_by_duct_data[i] = duct[i].data;
        this.data_by_duct_label[i] = duct[i].label;
      }
      datasets.push({
        label: this.data_by_duct_label,
        data: this.data_by_duct_data,
        fill: false,
        backgroundColor: colorlist,
        pointBorderWidth: 1,
        borderWidth: 1,
        pointRadius: 0
      });
      this.DuctDatac = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.datasets, { labels: this.data_by_duct_label, datasets: datasets });
    },
    DIVIDE_CITY_ARRAY: function DIVIDE_CITY_ARRAY() {
      var datasets = [];
      var colorlist = ['#e74c3c', '#28b463', '#5dade2', '#f4d03f', '#FFFFFF', '#884ea0', '#e67e22', '#6c3483', '#f1948a', '#45b39d', '#76d7c4', '#c0392b', '#d7bde2', '#2e86c1', '#117a65', '#d35400', '#239b56', '#47145c', '#808080'];
      var city = this.data_by_city;
      for (var i = 0; i < city.length; i++) {
        this.data_by_city_data[i] = city[i].data;
        this.data_by_city_label[i] = city[i].label;
      }
      datasets.push({
        label: this.data_by_city_label,
        data: this.data_by_city_data,
        fill: false,
        backgroundColor: colorlist,
        pointBorderWidth: 1,
        borderWidth: 1,
        pointRadius: 0
      });
      this.CityDatac = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.datasets, { labels: this.data_by_city_label, datasets: datasets });
    },
    GET_DIRECTION_TRENDS: function GET_DIRECTION_TRENDS() {
      var _this = this;

      if (document.querySelector('#buscar-btn').classList.contains('disabled')) {
        return;
      }
      this.showNewWindow = true;
      this.maxChart = 0;

      this.click = true;
      this.loading();
      this.ducto = document.querySelector('#ducto').value;
      var splitfrom = this.desde.split(' ');
      var splitto = this.hasta.split(' ');
      var from = splitfrom[0];
      var to = splitto[0];
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.loading();
        __WEBPACK_IMPORTED_MODULE_9__common_axios__["a" /* default */].get("https://api.ductos-gaes.com/" + ('direction/trends?id_section=' + _this.ducto + '&dateFrom=' + from + '&dateTo=' + to)).then(function (response) {
          _this.data_by_duct = response.data.data[0];
          _this.data_by_city = response.data.data[1];
          _this.data_by_km = response.data.data[2];

          return resolve(_this.DIVIDE_CITY_ARRAY(), _this.DIVIDE_KM_ARRAY(), _this.DIVIDE_DUCT_ARRAY());
        }).catch(function (err) {
          return reject(err);
        });
      });
    },
    hastaEvent: function hastaEvent(e) {
      this.hasta = e;
      this.hastaEmpty = false;
      this.validate();
    },
    desdeEvent: function desdeEvent(e) {
      this.desde = e;
      this.validate();
    },
    validate: function validate() {
      var max = this.hasta;
      var min = this.desde;
      if (max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor';
        this.hastaText = 'Este valor debe ser mayor';
        this.validation = false;
      } else {
        this.desdeText = '';
        this.hastaText = '';
        this.validation = true;
      }
    },
    formatDate: function formatDate() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (date === '') {
        date = new Date().toLocaleString('es-US', {
          hour12: false
        }).split(' ');
      }

      var time = date[1];
      var mdy = date[0].split('/');
      var month = parseInt(mdy[0]);
      var day = parseInt(mdy[1]);
      var year = parseInt(mdy[2]);
      return year + '-' + day + '-' + month + ' ' + time;
    },
    filterData: function filterData() {
      var _this2 = this;

      if (document.querySelector('#buscar-btn').classList.contains('disabled')) {
        return;
      }
      this.showNewWindow = true;
      this.maxChart = 0;

      this.click = true;
      this.loading();

      this.desde = this.desde || new Date().getTime() - 86400000;
      this.hasta = this.hasta || null;
      this.estacion = document.querySelector('#estaciones').value;
      this.ducto = document.querySelector('#ducto').value;
      this.$store.dispatch('LOAD_STATISTICS', {
        lastTimestamp: -1,
        ducto: this.ducto,
        estacion: this.estacion === 'TODAS' || this.estacion === '' ? '' : this.estacion,
        desde: this.desde,
        hasta: this.hasta
      }).then(function (resp) {
        if (resp === 'same-data' && _this2.click) {
          __WEBPACK_IMPORTED_MODULE_8_toastr___default.a.warning('Información repetida');
          _this2.loading();
        } else if (resp === 'no-data' && _this2.click) {
          __WEBPACK_IMPORTED_MODULE_8_toastr___default.a.error('No se encontró información');
          _this2.loading();
        }

        _this2.fill();
      }).catch(function (err) {
        console.log(err);
      });
    },
    GET_DATA: function GET_DATA(data) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return this.$store.getters.GET_PRESION_SPECIFIC_DATA(data);
    },
    updateInfo: function updateInfo(label, data) {
      var _this3 = this;

      var section = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data)[0];
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[section]);
      var datasets = [];
      var colors = ['#e74c3c ', '#28b463 ', '#5dade2 ', '#f4d03f ', '#ffffff ', '#b400ff ', '#e67e22 ', '#6c3483 ', '#f1948a ', '#45b39d ', '#76d7c4 ', '#c0392b ', '#d7bde2 ', '#2e86c1 ', '#117a65 ', '#d35400 ', '#239b56 '];
      var index = 0;
      var didUpdate = false;
      labels.forEach(function (station) {
        data[section][station].pressure.filter(function (yValue) {
          if (yValue.y >= _this3.maxChart) {
            _this3.maxChart = yValue.y;
            didUpdate = true;
          }
        });
      });
      if (didUpdate) {
        this.maxChart = Math.ceil(this.maxChart / 5) * 5;
      }

      if (!this.datacollection || this.click) {
        labels.forEach(function (station) {
          datasets.push({
            label: station,
            data: data[section][station].pressure,
            fill: false,
            backgroundColor: colors[index],
            borderColor: colors[index],
            pointBorderWidth: 1,
            borderWidth: 1,
            pointRadius: 1
          });
          index = index + 1;
        });
        this.datacollection = {
          datasets: datasets
        };

        this.chartOps.scales.xAxes[0].time.min = this.desde;
        this.chartOps.scales.xAxes[0].time.max = this.hasta;
      }

      if (!this.click && this.hastaEmpty) {
        for (var idx in this.datacollection.datasets) {
          var _dataSet = this.datacollection.datasets[idx];
          var _station = _dataSet.label;
          var _data = _dataSet.data;
          if (data[section] && data[section][_station] && data[section][_station].pressure) {
            this.datacollection.datasets[idx].data = data[section][_station].pressure.concat(_data);
            var unixtime = Date.parse(data.newest_data);
            this.chartOps.scales.xAxes[0].time.max = unixtime;
          }
        }
      }

      var max = this.hasta || new Date();
      var min = this.desde;
      var timeDiff = Math.abs(new Date(max).getTime() - new Date(min).getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays > 2) {
        this.chartOps.scales.xAxes[0].time.unit = 'day';
        this.chartOps.scales.xAxes[0].time.stepSize = 1;
      } else {
        this.chartOps.scales.xAxes[0].time.unit = 'hour';
        this.chartOps.scales.xAxes[0].time.stepSize = 3;
      }

      this.chartOps.scales.yAxes[0].ticks.max = this.maxChart;

      this.maxChart <= 30 ? this.chartOps.scales.yAxes[0].ticks.stepSize = 5 : this.chartOps.scales.yAxes[0].ticks.stepSize = 10;

      this.$refs.chart._chart.update(0);
    },
    setEstaciones: function setEstaciones(e) {
      this.estaciones = this.$store.getters.GET_OP({
        filteredBy: 'sites',
        ducto: document.querySelector('#' + e).value
      });
      this.estaciones.push('TODAS');
    },
    fill: function fill() {
      var _this4 = this;

      var state = this.$store.state;
      if (state.cached_presion === null) {
        this.pollTimer = setTimeout(function () {
          _this4.pollData(-1);
        }, 500);
        return;
      }

      if (state.fill) {
        this.initial_loading = true;
        this.presion = this.$store.state.cached_presion;
        var data = {};
        var timestamps = {};
        var newestData = null;
        if (this.presion.length > 0 || !this.click) {
          this.presion.forEach(function (event) {
            if (!data[event['section_name']]) {
              data[event['section_name']] = {};
            }
            if (!data[event['section_name']][event['rtu_name']]) {
              data[event['section_name']][event['rtu_name']] = {};
              data[event['section_name']][event['rtu_name']].pressure = [];
            }
            data[event['section_name']][event['rtu_name']].pressure.push({
              y: event.pressure,
              x: event.formated_date
            });
            timestamps[event['formated_date']] = event['formated_date'];
            if (!newestData || newestData < event['formated_date']) {
              newestData = event['formated_date'];
            }
            if (_this4.newestGpsTimestamp < event['gps_timestamp']) {
              _this4.newestGpsTimestamp = event['gps_timestamp'];
            }
          });
          data['newest_data'] = newestData;
          this.updateInfo(document.querySelector('#ducto').value, data);

          if (this.click) {
            this.loading();
          }

          this.click = false;
        }
      }

      this.pollTimer = setTimeout(function () {
        _this4.pollData(_this4.newestGpsTimestamp);
      }, 1000 * 10 * 1);
    },
    loading: function loading() {
      document.querySelector('#loading-btn').click();
    },
    pollData: function pollData(gpsTimestamp) {
      var _this5 = this;

      if (this.hastaEmpty) {
        this.click = false;
        var estaciones = document.querySelector('#estaciones').value;
        this.$store.dispatch('LOAD_PRESION', {
          lastTimestamp: gpsTimestamp,
          ducto: document.querySelector('#ducto').value,
          estacion: estaciones === 'TODAS' || estaciones === '' ? '' : estaciones,
          desde: this.desde,
          hasta: null
        }).then(function (resp) {
          if (resp === 'no-data' && _this5.click) {
            __WEBPACK_IMPORTED_MODULE_8_toastr___default.a.error('No se encontró información');
          }
          if (_this5.hastaEmpty && _this5.initial_loading && !_this5.click) {
            _this5.fill();
          }
        }).catch(function (err) {
          console.log(err);
          _this5.pollTimer = setTimeout(function () {
            _this5.pollData(gpsTimestamp);
          }, 1000 * 60 * 1);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this6.ductos = _this6.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    }).catch(function (err) {
      console.log(err);
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.pollTimer);
  },

  components: {
    selectC: __WEBPACK_IMPORTED_MODULE_3_components_reusable_Select___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_4_components_Charts_BarChart_KM_js__["a" /* default */],
    PieChartCity: __WEBPACK_IMPORTED_MODULE_5_components_Charts_PieChart_City_js__["a" /* default */],
    PieChartDuct: __WEBPACK_IMPORTED_MODULE_6_components_Charts_PieChart_Ducts_js__["a" /* default */],
    datePicker: __WEBPACK_IMPORTED_MODULE_7_vue_datepicker_vue_datepicker_es6_vue___default.a,
    Modal: Modal,
    LoadingModal: LoadingModal
  }
});

/***/ }),

/***/ 820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_json_excel__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_json_excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_json_excel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reusable_Map__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reusable_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reusable_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_toastr__);







var Modal = function Modal() {
	return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
	return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			info: {
				modalName: 'loading-modal'
			},
			jsonData: [],
			eventsFields: {
				Id: 'id',
				Fecha: 'fecha',
				Hora: 'hora',
				Lat: 'lat',
				Lng: 'lng',
				Km: 'km',
				Tipo: 'tipo',
				Estado: 'estado',
				Municipio: 'municipio'
			},
			middlePointsFields: {
				Id: 'id',
				Fecha: 'fecha',
				Hora: 'hora',
				Lat: 'lat',
				Lng: 'lng',
				Km: 'km',
				Eventos: 'tipo',
				Estado: 'estado',
				Municipio: 'municipio'
			},
			jsonFields: {},
			jsonMeta: [{ key: 'charset', value: 'utf-8' }],
			mcStyle: {
				height: '52vh',
				width: '100%'
			},
			wStyle: {
				padding: '0'
			},
			alarmType: undefined,
			date: this.$store.state.dpDate,
			option: this.$store.state.dpOpsHasta,
			option2: this.$store.state.dpOpsDesde,
			historico: [],
			historicoMiddlePoints: [],
			desde: '',
			hasta: '',
			ducto: '',
			ductos: [],
			tipo: null,
			isFormClosed: false,
			kmFrom: 0,
			kmTo: 10000,
			timer: null,
			validation: false,
			desdeText: '',
			hastaText: '',
			historicoTemp: [],
			selectedEventRow: null,
			selectedChartRange: 15,
			selectedTramo: null,
			selectedDucto: null,
			ductoFound: null,
			leak_id: null,
			leak_detail: false,
			isChartVisible: false
		};
	},

	watch: {
		historico: function historico() {
			this.$refs.map.fillMap(this.historicoMiddlePoints);
		},
		historicoMiddlePoints: function historicoMiddlePoints() {
			this.$refs.map.fillMap(this.historicoMiddlePoints, this.ducto);
		},
		markersFill: function markersFill() {
			this.$refs.map.fillMark();
		}
	},
	methods: {
		loading: function loading() {
			document.querySelector('#loading-btn').click();
		},
		selectEvent: function selectEvent(e) {
			var _this = this;

			this.ducto = document.querySelector('#' + e).value;
			this.ductoFound = this.ductos && this.ductos.find(function (x) {
				return x.id === Number(_this.ducto);
			});
			this.selectedDucto = this.ductoFound && this.ductoFound.ducto;
			console.log('Selected ducto:', this.selectedDucto);
		},
		validate: function validate(e, d) {
			this[d] = e;
			var max = this.hasta;
			var min = this.desde;
			if (max !== '' && (max <= min || min === '')) {
				this.desdeText = 'Este valor debe ser menor';
				this.hastaText = 'Este valor debe ser mayor';
				this.validation = false;
			} else {
				this.desdeText = '';
				this.hastaText = '';
				this.validation = true;
			}
		},
		historicoMark: function historicoMark() {
			this.$refs.map.fillMark();
		},
		searchById: function searchById(id) {
			var _this2 = this;

			this.loading();
			this.$store.dispatch('LOAD_HISTORICO_ID', {
				id: id
			}).then(function (resp) {
				_this2.handleResponse(resp);
			});
		},
		search: function search() {
			var _this3 = this;

			if (!this.desde || !this.ducto || this.validation === false) return;
			this.loading();
			this.$store.dispatch('LOAD_HISTORICAL_LEGACY', {
				pipeline: this.selectedDucto,
				startDate: this.desde + ':00',
				endDate: this.hasta + ':00'
			}).then(function (resp) {
				_this3.handleResponse(resp);
			});
		},
		handleResponse: function handleResponse(resp) {
			var _this4 = this;

			console.log('Response:', resp);
			var response = resp.data;

			if (response.length === 0) {
				__WEBPACK_IMPORTED_MODULE_5_toastr___default.a.error('No se encontró información');
				this.loading();
				return;
			}

			this.historico = [];

			response.sort(function (a, b) {
				return b.id - a.id;
			});
			response.forEach(function (res) {
				_this4.historicoMiddlePoints.push({
					id: res.id,
					km: res.km,
					fecha: '' + res.date.split('T')[0],
					hora: '' + res.date.split('T')[1],
					lat: res.lat,
					lng: res.lon,
					tipo: res.type,
					estado: res.state,
					municipio: res.city,
					isMP: true
				});
			});
			this.jsonData = this.historicoMiddlePoints;
			this.historicoTemp = this.historicoMiddlePoints;

			console.log('Historico:', this.historicoMiddlePoints);

			if (this.leak_id) {
				var row = this.historico.find(function (s) {
					return s.id === parseInt(_this4.leak_id);
				});
				this.onSelectRow(row);
			} else {
				this.loading();
			}
		},
		onSelectRow: function onSelectRow(row) {
			this.isChartVisible = true;
			this.selectedEventRow = row;
			this.$refs.map.zoom(row);
		}
	},
	components: {
		SelectC: __WEBPACK_IMPORTED_MODULE_3_reusable_Select___default.a,
		GoogleMaps: __WEBPACK_IMPORTED_MODULE_2_reusable_Map___default.a,
		DatePicker: __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue___default.a,
		JsonEx: __WEBPACK_IMPORTED_MODULE_1_vue_json_excel___default.a,
		LoadingModal: LoadingModal,
		Modal: Modal
	},
	mounted: function mounted() {
		var _this5 = this;

		this.jsonFields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.eventsFields);
		this.historicoMark();
		this.$store.dispatch('LOAD_OPS_LEGACY').then(function () {
			_this5.ductos = _this5.$store.state.optionsLegacy;
		}).catch(function (err) {
			console.log('Error', err);
		});
		$('#map-div').css('z-index', '0');
		if (this.$route.params.id) {
			this.leak_detail = true;
			this.leak_id = this.$route.params.id;
			this.searchById(this.$route.params.id);
		}
	}
});

/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_json_excel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reusable_Map__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reusable_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_reusable_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PdfView__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PdfView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__PdfView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);







__webpack_require__(1296);





var echarts = __webpack_require__(404);
var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {
        modalName: 'loading-modal'
      },
      tipoOps: {
        uno: {
          name: 'Eventos',
          value: 0
        },
        dos: {
          name: 'Puntos Medios',
          value: 3
        }
      },
      chartRange: [{
        name: '5 min',
        value: 5
      }, {
        name: '10 min',
        value: 10
      }, {
        name: '15 min',
        value: 15
      }, {
        name: '20 min',
        value: 20
      }, {
        name: '25 min',
        value: 25
      }, {
        name: '30 min',
        value: 30
      }],
      jsonData: [],
      eventsFields: {
        'Id': 'id',
        'Sección': 'section',
        'Fecha': 'fecha',
        'Hora': 'hora',
        'Lat': 'lat',
        'Lng': 'lng',
        'Km': 'km',
        'Tipo': 'tipo',
        'Estado': 'estado',
        'Municipio': 'municipio'
      },
      middlePointsFields: {
        'Id': 'id',
        'Fecha': 'fecha',
        'Lat': 'lat',
        'Lng': 'lng',
        'Km': 'km',
        'Eventos': 'tipo',
        'Estado': 'estado',
        'Municipio': 'municipio'
      },
      jsonFields: {},
      jsonMeta: [{ 'key': 'charset', 'value': 'utf-8' }],
      mcStyle: {
        height: '52vh'
      },
      wStyle: {
        padding: '0'
      },
      alarmType: undefined,
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde,
      historico: [],
      historicoMiddlePoints: [],
      desde: '',
      hasta: '',
      ducto: '',
      ductos: [],
      kms: {},
      tipo: null,
      gd: {
        lat: '',
        lng: ''
      },
      gms: {
        lat: {
          check: {
            n: '',
            s: ''
          },
          g: '',
          m: '',
          s: ''
        },
        lng: {
          check: {
            e: '',
            o: ''
          },
          g: '',
          m: '',
          s: ''
        }
      },
      kmFrom: 0,
      kmTo: 10000,
      timer: null,
      validation: false,
      desdeText: '',
      hastaText: '',
      historicoTemp: [],
      selectedEventRow: null,
      selectedChartRange: 15,
      selectedTramo: null,
      selectedDucto: null,
      chartCanvas: [],
      pdfMap: null,
      leak_id: null,
      leak_detail: false,
      isChartVisible: false
    };
  },

  watch: {
    historico: function historico() {
      this.$refs.map.fillMap(this.historico, this.ducto);
    },
    historicoMiddlePoints: function historicoMiddlePoints() {
      this.$refs.map.fillMap(this.historicoMiddlePoints, this.ducto);
    },
    markersFill: function markersFill() {
      this.$refs.map.fillMark();
    }
  },
  methods: {
    onMarkerClick: function onMarkerClick(mark) {},
    loading: function loading() {
      document.querySelector('#loading-btn').click();
    },
    filterByLatLng: function filterByLatLng(type) {
      var _this = this;

      if (this.historico.length === 0) {
        return;
      }

      var temp = '';
      this.historico = this.historicoTemp;

      if (type === 'gd') {
        temp = this.historico.filter(function (hist) {
          if (_this.gd.lng && _this.gd.lat) {
            return Number(hist.lat) === Number(_this.gd.lat) && Number(hist.lng) === Number(_this.gd.lng);
          } else if (_this.gd.lat && !_this.gd.lng) {
            return Number(hist.lat) === Number(_this.gd.lat);
          } else if (_this.gd.lng && !_this.gd.lat) {
            return Number(hist.lng) === Number(_this.gd.lng);
          }
        });
      } else if (type === 'gms') {
        temp = this.historico.filter(function (hist) {
          if (_this.gms.lat.g !== '' && _this.gms.lat.m !== '' && _this.gms.lat.s !== '') {
            var lat = Number(_this.gms.lat.g) + Number(Number(_this.gms.lat.m) / 60) + Number(Number(_this.gms.lat.s) / 3600);
            return Number(hist.lat) === Number(lat.toFixed(4));
          } else if (_this.gms.lng.g !== '' && _this.gms.lng.m !== '' && _this.gms.lng.s !== '') {
            var lng = Number(_this.gms.lng.g) + Number(Number(_this.gms.lng.m) / 60) + Number(Number(_this.gms.lng.s) / 3600);
            return Number(String(hist.lng).split('-')[1] || String(hist.lng).split('-')[0]) === Number(lng.toFixed(4));
          }
        });
      }
      if (temp.length !== 0) {
        this.historicoTemp = this.historico;
        this.historico = temp;
      }
    },
    selectEvent: function selectEvent(e) {
      var _this2 = this;

      this.ducto = document.querySelector('#' + e).value;
      var ductoFound = this.ductos && this.ductos.find(function (x) {
        return x.value === _this2.ducto;
      });
      this.selectedDucto = ductoFound && ductoFound.name;
      var kmsData = this.kms[this.ducto];
      if (!kmsData) {
        return;
      }
      this.kmFrom = kmsData.min;
      this.kmTo = kmsData.max;
    },
    selectType: function selectType(e) {
      var type = document.querySelector('#' + e).value;
      this.alarmType = type;
      if (type === '3') {
        this.jsonFields = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.middlePointsFields);
        return;
      }
      this.jsonFields = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.eventsFields);
    },
    selectChartRange: function selectChartRange(e) {
      var minutes = document.querySelector('#' + e).value;
      this.selectedChartRange = minutes;
      this.fetchPressureChartData();
    },
    isMiddlePoint: function isMiddlePoint() {
      return this.alarmType === 3 || this.alarmType === '3';
    },
    validate: function validate(e, d) {
      this[d] = e;
      var max = this.hasta;
      var min = this.desde;
      if (max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor';
        this.hastaText = 'Este valor debe ser mayor';
        this.validation = false;
      } else {
        this.desdeText = '';
        this.hastaText = '';
        this.validation = true;
      }
    },
    historicoMark: function historicoMark() {
      this.$refs.map.fillMark();
    },
    searchById: function searchById(id) {
      var _this3 = this;

      this.loading();
      this.$store.dispatch('LOAD_HISTORICO_ID', {
        id: id
      }).then(function (resp) {
        _this3.handleResponse(resp);
      });
    },
    search: function search() {
      var _this4 = this;

      if (!this.desde || !this.ducto || this.validation === false) {
        return;
      }
      this.loading();
      var gms = '';
      var gd = '';
      var id = '';
      var tipo = document.querySelector('#tipo').value;
      this.alarmType = tipo;
      this.$store.dispatch('LOAD_HISTORICO', {
        desde: this.desde,
        hasta: this.hasta || '',
        id: id || null,
        ducto: this.ducto,
        tipo: tipo || null,
        kmFrom: this.kmFrom || null,
        kmTo: this.kmTo || null,
        gms: gms || null,
        gd: gd || null
      }).then(function (resp) {
        _this4.handleResponse(resp);
      });
    },
    handleResponse: function handleResponse(resp) {
      var _this5 = this;

      var response = resp.data;

      if (response.length === 0) {
        __WEBPACK_IMPORTED_MODULE_10_toastr___default.a.error('No se encontró información');
        this.loading();
        return;
      }
      if (this.isMiddlePoint()) {
        this.historicoMiddlePoints = [];
      } else {
        this.historico = [];
      }
      if (this.isMiddlePoint()) {
        response.sort(function (a, b) {
          return b.id_leak - a.id_leak;
        });
        response.forEach(function (res) {
          _this5.historicoMiddlePoints.push({
            id: res.id_leak,
            km: res.avg_km,
            fecha: res.event_start + ' / ' + res.event_end,
            lat: res.avg_n_lat || res.avg_lat,
            lng: res.avg_n_lon || res.avg_lon,
            tipo: res.events_count,
            estado: res.state,
            municipio: res.city,
            isMP: true
          });
        });
        this.jsonData = this.historicoMiddlePoints;
        this.historicoTemp = this.historicoMiddlePoints;
      } else {
        response.sort(function (a, b) {
          return b.id_leak - a.id_leak;
        });

        response.forEach(function (res) {
          _this5.historico.push({
            id: res.id_leak,
            section: res.section_1_name,
            km: res.km,
            fecha: __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(res.detection_timestamp).format('YYYY-MM-DD'),
            hora: __WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(res.detection_timestamp).format('HH:mm:ss'),
            lat: res.n_lat || res.lat,
            lng: res.n_lon || res.lon,
            tipo: res.type || 'No Data',
            estado: res.state_1_name || 'No Data',
            municipio: res.city_1_name || 'No Data',
            timestamp: res.detection_timestamp
          });
        });
        this.jsonData = this.historico;
        this.historicoTemp = this.historico;
      }

      if (this.leak_id) {
        var row = this.historico.find(function (s) {
          return s.id === parseInt(_this5.leak_id);
        });

        this.onSelectRow(row);
      } else {
        this.loading();
      }
    },
    updateInfo: function updateInfo(res) {
      res.data = this.normalizedData(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(res)));


      var minY = res.data.length == 0 ? 0 : res.data.reduce(function (min, p) {
        return p.pressure < min ? p.pressure : min;
      }, res.data[0].pressure);
      var maxY = res.data.length == 0 ? 1 : res.data.reduce(function (max, p) {
        return p.pressure > max ? p.pressure : max;
      }, res.data[0].pressure);

      var datasets = [{
        name: res.site_one_name,
        type: 'line',
        symbolSize: 0,
        data: res.data.filter(function (x) {
          return x.id_rtu == res.site_one;
        }).map(function (x) {
          var returnArray = [];
          returnArray.push(new Date(__WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(x.date_time).format('YYYY-MM-DD HH:mm:ss.ms')));
          returnArray.push(x.pressure);
          return returnArray;
        })
      }, {
        name: res.site_two_name,
        type: 'line',
        symbolSize: 0,
        data: res.data.filter(function (x) {
          return x.id_rtu == res.site_two;
        }).map(function (x) {
          var returnArray = [];
          returnArray.push(new Date(__WEBPACK_IMPORTED_MODULE_11_moment___default.a.utc(x.date_time).format('YYYY-MM-DD HH:mm:ss.ms')));
          returnArray.push(x.pressure);
          return returnArray;
        })
      }];
      if (this.selectedEventRow) {
        datasets.push({
          name: 'Fuga detectada',
          type: 'line',
          symbolSize: 0,
          lineStyle: {
            color: 'red',
            width: 3 },
          data: [[this.selectedEventRow.timestamp, minY], [this.selectedEventRow.timestamp, maxY]]
        });
      }

      var option = {
        legend: {
          show: true
        },
        title: {
          text: 'PRESION NORMALIZADA'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var param = params[0]['value'];
            return 'Tiempo: ' + __WEBPACK_IMPORTED_MODULE_11_moment___default()(param[0]).format('HH:mm:ss.ms') + '<br/>' + 'Presión: ' + param[1];
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: 50,
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {
              text: 'Descargar'
            }
          }
        },
        dataZoom: [{
          type: 'slider',
          xAxisIndex: 0,
          filterMode: 'weakFilter',
          height: 20,
          bottom: 0,
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '80%',
          showDetail: false
        }, {
          type: 'inside',
          id: 'insideX',
          xAxisIndex: 0,
          filterMode: 'weakFilter',
          zoomOnMouseWheel: false,
          moveOnMouseMove: true
        }],
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLabel: {
            formatter: function formatter(value) {
              return __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).format('HH:mm:ss.ms');
            }
          }
        },
        yAxis: {
          type: 'value',
          min: minY,
          max: maxY
        },
        series: datasets
      };

      this.pressureChart.setOption(option, true);
      this.selectedTramo = res.site_one_name.toUpperCase() + ' - ' + res.site_two_name.toUpperCase();
      this.pressureChart.hideLoading();
      this.getChartFromCanvas();
    },
    normalizedData: function normalizedData(res) {
      if (res && res.data) {
        var siteOneData = res.data.filter(function (x) {
          return x.id_rtu == res.site_one;
        });
        var siteTwoData = res.data.filter(function (x) {
          return x.id_rtu == res.site_two;
        });

        var offsetSeries = 0;

        if (siteOneData && siteOneData.length > 0) {
          var sOneMinY = siteOneData ? siteOneData.reduce(function (min, p) {
            return p.pressure < min ? p.pressure : min;
          }, siteOneData[0].pressure) : 0;
          var sOneMaxY = siteOneData ? siteOneData.reduce(function (max, p) {
            return p.pressure > max ? p.pressure : max;
          }, siteOneData[0].pressure) : 0;

          siteOneData.map(function (res) {
            var pr = res.pressure - sOneMinY;
            var pn = pr / sOneMaxY;
            res.pressure = pn.toFixed(4);
            return res;
          });

          var SiteOneAvg = siteOneData.reduce(function (a, s) {
            a += Number(s.pressure);return a;
          }, 0) / siteOneData.length;
          siteOneData.map(function (res) {
            var pn = Number(SiteOneAvg) + Number(res.pressure);
            res.pressure = pn.toFixed(4);
            return res;
          });

          var pnAvgMin = siteOneData.reduce(function (min, p) {
            return p.pressure < min ? p.pressure : min;
          }, siteOneData[0].pressure);
          var pnAvgMax = siteOneData.reduce(function (max, p) {
            return p.pressure > max ? p.pressure : max;
          }, siteOneData[0].pressure);
          offsetSeries = pnAvgMax - pnAvgMin;
        } else {
          __WEBPACK_IMPORTED_MODULE_10_toastr___default.a.error('El sitio ' + res.site_one_name + ' no tiene informaci\xF3n');
        }

        if (siteTwoData && siteTwoData.length > 0) {
          var sTwoMinY = siteTwoData.reduce(function (min, p) {
            return p.pressure < min ? p.pressure : min;
          }, siteTwoData[0].pressure);
          var sTwoMaxY = siteTwoData.reduce(function (max, p) {
            return p.pressure > max ? p.pressure : max;
          }, siteTwoData[0].pressure);

          siteTwoData.map(function (res) {
            var pr = res.pressure - sTwoMinY;
            var pn = pr / sTwoMaxY;
            res.pressure = pn.toFixed(4);
            return res;
          });

          var SiteTwoAvg = siteTwoData.reduce(function (a, s) {
            a += Number(s.pressure);return a;
          }, 0) / siteTwoData.length + offsetSeries;
          siteTwoData.map(function (res) {
            var pn = Number(SiteTwoAvg) + Number(res.pressure);
            res.pressure = pn.toFixed(4);
            return res;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_10_toastr___default.a.error('El sitio ' + res.site_two_name + ' no tiene informaci\xF3n');
        }

        return siteOneData.concat(siteTwoData);
      }
    },
    getChartFromCanvas: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var canvas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.delay(2500);

              case 2:
                canvas = document.querySelectorAll('div.chart-pressure canvas');

                this.chartCanvas = canvas;
                if (this.selectedEventRow) {
                  this.selectedEventRow['ducto'] = this.selectedDucto;
                  this.selectedEventRow['tramo'] = this.selectedTramo;
                }
                this.pdfMap = 'https://maps.googleapis.com/maps/api/staticmap?center=' + this.selectedEventRow.lat + ',' + this.selectedEventRow.lng + '&zoom=10&size=600x150&markers=color:red%7C' + this.selectedEventRow.lat + ',' + this.selectedEventRow.lng + '&key=AIzaSyAA-A7plJZRYMqQp06YF7c-WL6nFU0YZnY';

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getChartFromCanvas() {
        return _ref.apply(this, arguments);
      }

      return getChartFromCanvas;
    }(),
    delay: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(ms) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, ms);
                });

              case 2:
                return _context2.abrupt('return', _context2.sent);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function delay(_x) {
        return _ref2.apply(this, arguments);
      }

      return delay;
    }(),
    onSelectRow: function onSelectRow(row) {
      this.isChartVisible = true;
      this.selectedEventRow = row;
      this.$refs.map.zoom(row);
      this.fetchPressureChartData();
    },
    fetchPressureChartData: function fetchPressureChartData() {
      var _this6 = this;

      if (this.selectedEventRow) {
        this.selectedTramo = null;
        this.pressureChart.showLoading();
        this.$store.dispatch('LOAD_PRESSURE_BY_ID', {
          reportId: this.selectedEventRow.id,
          chartRange: this.selectedChartRange
        }).then(function (resp) {
          _this6.pressureChart.hideLoading();
          _this6.updateInfo(resp.data);
        });
      }
    },
    print: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var content, mywindow;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.delay(1600);

              case 2:
                this.getChartFromCanvas();
                content = document.querySelector('.pdf-content').innerHTML;
                mywindow = window.open('', 'Print', 'height=600,width=800');

                mywindow.document.write('<html><head><title>Print</title>');
                mywindow.document.write('</head><body>');

                mywindow.document.write('<style>');
                mywindow.document.write('\n        #pdf {\n          width: 100%;\n        }\n          #row {\n            padding: 25px;\n          }\n          img.logo{\n            width: 200px;\n          }\n\n          img.logo_pem{\n            float:right;\n          }\n          hr {\n            color: var(--btn-default);\n          }\n          h4 {\n            text-align: center;\n            text-transform: uppercase;\n            color: var(--btn-default);\n          }\n          .pdf__info {\n            margin: 0 auto;\n            display: block;\n          }\n          .pdf__titles {\n            color: var(--btn-default);\n          }\n      \n      .mydiv{\n          background-color:#fff;\n          font-family: \'Roboto\', sans-serif;\n          }\n          .mydiv div#pdf{\n            max-height:200px;\n            height:200px;\n          }\n          .mydiv div#img_map{\n            width:70%;\n            margin:auto;\n          }\n          .mydiv div#linechart{\n            display:none;\n          }\n          .mydiv img#leak{\n              display:inline-block;\n              width:115px;\n            }\n          .mydiv img#pem{\n              padding-left: 400px;\n              display:inline-block;\n              width:115px;\n            }\n          .mydiv h4#h41{\n              font-size:30px;\n              font-weight:400;\n              text-transform: uppercase;\n              padding:0;\n              margin-top:10px;\n              margin-bottom:10px;\n            }\n          .mydiv hr#hr1{\n                background-color: #fff;\n                border-top: 2px solid var(--btn-default);\n            }\n          .mydiv span#titles{\n            color: var(--btn-default);\n            text-transform: uppercase;\n            margin-left:4px;\n          }\n          .mydiv div#tablecontainer{\n            height:440px;\n          }\n          .mydiv table#tableholder{\n            height: 50%;\n            width:100%;\n            margin:0;\n          }\n          .mydiv thead#header{\n            width:100%;\n            padding:2px;\n            background-color:var(--btn-default);\n          }\n          .mydiv tr#trh{\n            width:100%;\n            padding:2px;\n            background-color:var(--btn-default);\n          }\n          .mydiv th#thh{\n            font-size:12px;\n            align:left;\n            font-weight:400;\n            padding:5px;\n            border: 1.5px solid var(--btn-default);\n          }\n          .mydiv td#tdc{\n            font-size:8px;\n            text-align:center;\n            padding:2px;\n            border: 1px solid #777777;\n          }\n        \n      ');
                mywindow.document.write('</style>');

                mywindow.document.write('<div class="mydiv">' + content + '</div>');
                mywindow.document.write('</body>');
                mywindow.document.write('</html>');
                mywindow.document.close();
                mywindow.focus();
                setTimeout(function () {
                  mywindow.print();
                  mywindow.close();
                }, 100);
                return _context3.abrupt('return', true);

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function print() {
        return _ref3.apply(this, arguments);
      }

      return print;
    }()
  },
  components: {
    SelectC: __WEBPACK_IMPORTED_MODULE_7_reusable_Select___default.a,
    GoogleMaps: __WEBPACK_IMPORTED_MODULE_6_reusable_Map___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_9_vue_datepicker_vue_datepicker_es6_vue___default.a,
    JsonEx: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel___default.a,
    LoadingModal: LoadingModal,
    Modal: Modal,
    PdfView: __WEBPACK_IMPORTED_MODULE_8__PdfView___default.a
  },
  mounted: function mounted() {
    var _this7 = this;

    this.pressureChart = echarts.init(document.getElementById('pressure-chart-div'));

    this.jsonFields = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.eventsFields);
    this.historicoMark();
    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this7.ductos = _this7.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
      _this7.kms = _this7.$store.getters.GET_KM_RANGE();
    }).catch(function (err) {
      console.log('Error', err);
    });
    $('#map-div').css('z-index', '0');
    $('#range').ionRangeSlider({
      min: 0,
      max: 0,
      from: 0,
      to: 0,
      type: 'double',
      prefix: 'KM ',
      grid: true,
      grid_num: 2,
      onChange: function onChange() {
        _this7.kmFrom = $('#range').data().from;
        _this7.kmTo = $('#range').data().to;
      }
    });

    if (this.$route.params.id) {
      this.leak_detail = true;
      this.leak_id = this.$route.params.id;
      this.searchById(this.$route.params.id);
    }
  }
});

/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Charts_CustomLineChartPdfHist__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Charts_CustomLineChartPdfHist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_Charts_CustomLineChartPdfHist__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      click: false,
      middlePoint: {
        km: 0,
        lat: 0,
        lng: 0
      }
    };
  },

  props: ['site', 'desde', 'hasta'],
  components: {
    CustomLineChart: __WEBPACK_IMPORTED_MODULE_0_components_Charts_CustomLineChartPdfHist___default.a
  },
  computed: {
    logoUrl: function logoUrl() {
      return __webpack_require__(169);
    }
  },
  watch: {
    site: function site() {
      var _this = this;

      this.$store.state.cclick = true;
      this.click = !this.click;
      this.site.events.forEach(function (e) {
        _this.middlePoint.km += e.km;
        _this.middlePoint.lat += e.lat;
        _this.middlePoint.lng += e.lng;
      });
      this.middlePoint.km /= this.site.events.length;
      this.middlePoint.lat /= this.site.events.length;
      this.middlePoint.lng /= this.site.events.length;
    }
  }
});

/***/ }),

/***/ 823:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      click: false,
      pressureChart: null,
      desde: null,
      hasta: null
    };
  },

  props: ['event', 'mapImg', 'chartRage', 'chartCanvas'],
  components: {},
  watch: {
    event: function event() {},
    chartCanvas: function chartCanvas() {}
  },
  computed: {
    logoUrl: function logoUrl() {
      return __webpack_require__(169);
    },
    fromCompany: function fromCompany() {
      return "GA Energy Services, S.A.P.I. de C.V.";
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Historico_PdfDiv__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Historico_PdfDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Historico_PdfDiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);


var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      modalName: 'loading-modal',
      info: {
        modalName: this.modalName
      },
      serached: false,
      data: null,
      sitePdf: null,
      kmFrom: 0,
      kmTo: 10000,
      objDucto: {},
      desde: '',
      hasta: '',
      ductos: [],
      ducto: null,
      content: null,
      currDucto: '',
      desdeText: '',
      hastaText: '',
      ductoSelected: null,
      validation: false,
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde
    };
  },

  methods: {
    loading: function loading() {
      document.querySelector('#loading-btn-chart2').click();
    },
    imgUrl: function imgUrl(url) {
      return __webpack_require__(1810)("" + url);
    },
    print: function print() {
      var content = document.querySelector('.panel-body-two').innerHTML;
      var mywindow = window.open('', 'Print', 'height=600,width=800');

      mywindow.document.write('<html><head><title>Print</title>');
      mywindow.document.write('</head><body>');

      mywindow.document.write('<style>');
      mywindow.document.write('\n        #pdf {\n          width: 100%;\n        }\n          #row {\n            padding: 25px;\n          }\n          img.logo{\n            width: 200px;\n          }\n\n          img.logo_pem{\n            float:right;\n          }\n          hr {\n            color: var(--btn-default);\n          }\n          h4 {\n            text-align: center;\n            text-transform: uppercase;\n            color: var(--btn-default);\n          }\n          .pdf__info {\n            margin: 0 auto;\n            display: block;\n          }\n          .pdf__titles {\n            color: var(--btn-default);\n          }\n      \n       .mydiv{\n          background-color:#fff;\n          font-family: \'Roboto\', sans-serif;\n          }\n          .mydiv div#pdf{\n            max-height:200px;\n            height:200px;\n          }\n          .mydiv div#img_map{\n            width:70%;\n            margin:auto;\n          }\n          .mydiv div#linechart{\n            display:none;\n          }\n          .mydiv img#leak{\n              display:inline-block;\n              width:115px;\n            }\n          .mydiv img#pem{\n              padding-left: 400px;\n              display:inline-block;\n              width:115px;\n            }\n          .mydiv h4#h41{\n              font-size:30px;\n              font-weight:400;\n              text-transform: uppercase;\n              padding:0;\n              margin-top:10px;\n              margin-bottom:10px;\n            }\n          .mydiv hr#hr1{\n              \tbackground-color: #fff;\n\t              border-top: 2px solid var(--btn-default);\n            }\n          .mydiv span#titles{\n            color: var(--btn-default);\n            text-transform: uppercase;\n            margin-left:4px;\n          }\n          .mydiv div#tablecontainer{\n            height:440px;\n          }\n          .mydiv table#tableholder{\n            height: 50%;\n            width:100%;\n            margin:0;\n          }\n          .mydiv thead#header{\n             width:100%;\n             padding:2px;\n             background-color:var(--btn-default);\n          }\n           .mydiv tr#trh{\n             width:100%;\n             padding:2px;\n             background-color:var(--btn-default);\n          }\n          .mydiv th#thh{\n            font-size:12px;\n            align:left;\n             font-weight:400;\n             padding:5px;\n             border: 1.5px solid var(--btn-default);\n          }\n          .mydiv td#tdc{\n            font-size:8px;\n             text-align:center;\n             padding:2px;\n             border: 1px solid #777777;\n          }\n        \n      ');
      mywindow.document.write('</style>');

      mywindow.document.write('<div class="mydiv">' + content + '</div>');
      mywindow.document.write('</body>');
      mywindow.document.write('</html>');
      mywindow.document.close();
      mywindow.focus();
      setTimeout(function () {
        mywindow.print();
        mywindow.close();
      }, 100);
      return true;
    },
    validate: function validate(e, d) {
      this[d] = e;
      var max = this.hasta;
      var min = this.desde;
      if (max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor';
        this.hastaText = 'Este valor debe ser mayor';
        this.validation = false;
      } else {
        this.desdeText = '';
        this.hastaText = '';
        this.validation = true;
      }
    },
    changeSelected: function changeSelected() {
      this.ductoSelected = document.querySelector('#ducto').value;
    },
    formatDate: function formatDate() {
      var date = new Date().toLocaleString('es-US', {
        hour12: false
      }).split(' ');

      var time = date[1];
      var mdy = date[0].split('/');
      var month = parseInt(mdy[0]);
      var day = parseInt(mdy[1]);
      var year = parseInt(mdy[2]);
      return year + '-' + day + '-' + month + ' ' + time;
    },
    submitInfo: function submitInfo() {
      var _this = this;

      this.loading();
      this.serached = true;
      if (!this.hasta) {
        this.hasta = this.formatDate();
      }

      if (this.desde && this.ductoSelected && this.validation === true) {
        this.$store.dispatch('LOAD_HISTORICO', {
          desde: this.desde,
          hasta: this.hasta,
          ducto: document.querySelector('#ducto').value,
          kmFrom: this.kmFrom,
          kmTo: this.kmTo
        }).then(function (resp) {
          _this.loading();
          if (resp.data.length === 0) {
            __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('No se encontró información');
            return;
          }
          _this.data = resp.data;
          _this.fillTable();
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('No se encontró información');
          console.log('Error', err);
        });
      } else {
        this.loading();
      }
    },
    fillTable: function fillTable() {
      var _this2 = this;

      this.objDucto = {};
      this.data.forEach(function (d) {
        _this2.ducto = d.section_1_name;
        var leakKey = '' + d.site_1_id + d.site_2_id;
        if (!_this2.objDucto[leakKey]) {
          _this2.objDucto[leakKey] = {};
          _this2.objDucto[leakKey].section = d.section_1_name;
          _this2.objDucto[leakKey].sectionId = d.section_1_id;
          _this2.objDucto[leakKey].sites = d.site_1_name + ' - ' + d.site_2_name;
          _this2.objDucto[leakKey].sitesIds = d.site_1_id + ',' + d.site_2_id;
          _this2.objDucto[leakKey].events = [];
        }
        _this2.objDucto[leakKey].events.push({
          fecha: d.detection_timestamp,
          lat: d.lat,
          lng: d.lon,
          km: d.km,
          id: d.id_leak,
          type: d.type
        });
      });
    },
    passName: function passName(r) {
      var markers = [];
      var center = { lat: 0, lng: 0 };
      r.events.forEach(function (alarm) {
        markers.push('markers=color:green%7C' + alarm.lat + ',' + alarm.lng);
        center.lat += alarm.lat;
        center.lng += alarm.lng;
      });
      center.lat /= r.events.length;
      center.lng /= r.events.length;
      r.map = 'https://maps.googleapis.com/maps/api/staticmap?center=' + center.lat + ',' + center.lng + '&zoom=10&size=800x400&' + markers.join('&') + '&key=AIzaSyAA-A7plJZRYMqQp06YF7c-WL6nFU0YZnY';
      this.sitePdf = r;
    }
  },
  components: {
    SelectC: __WEBPACK_IMPORTED_MODULE_0_reusable_Select___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    PdfDiv: __WEBPACK_IMPORTED_MODULE_2_components_Historico_PdfDiv___default.a,
    Modal: Modal,
    LoadingModal: LoadingModal
  },
  mounted: function mounted() {
    var _this3 = this;

    document.querySelector('#ducto').addEventListener('change', function (e) {
      _this3.kmFrom = $('#range').data().from;
      _this3.kmTo = $('#range').data().to;
    });

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this3.ductos = _this3.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    }).catch(function (err) {
      console.log('Error', err);
    });

    $('#range').ionRangeSlider({
      min: 0,
      max: 10000,
      from: 0,
      to: 10000,
      type: 'double',
      prefix: 'KM ',
      grid: true,
      grid_num: 2,
      onChange: function onChange() {
        _this3.kmFrom = $('#range').data().from;
        _this3.kmTo = $('#range').data().to;
        var ev = new Event('change');
        document.querySelector('#ducto').dispatchEvent(ev);
      }
    });
  }
});

/***/ }),

/***/ 825:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reusable_Modal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reusable_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reusable_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_leak__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);










var $ = __webpack_require__(54);
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    parentRefs: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      seen: true,
      conceptos: [],
      selected: '',
      comentario: '',
      dbSize: 0,
      ducto: '',
      ductoActivo: {},
      tempInterval: '',
      ducts: '',
      leaks: '',
      filtAlarms: '',
      interval: null,
      mapComp: this.parentRefs.map,
      alarmIndex: 0,
      isAllowedToIdentifyLeak: false
    };
  },

  computed: {
    groupedLeaks: function groupedLeaks() {
      var _this = this;

      if (!this.filtAlarms) return {};

      var grouped = this.filtAlarms.reduce(function (acc, leak) {
        if (_this.alarmIndex === 2 && !leak.is_operational_movement) return acc;

        if (_this.alarmIndex === 0 && (leak.status >= 2 || leak.is_operational_movement)) return acc;

        if (_this.alarmIndex === 1 && (leak.status < 2 || leak.is_operational_movement)) return acc;

        if (!acc[leak._name_section_1]) {
          acc[leak._name_section_1] = [];
        }
        acc[leak._name_section_1].push(leak);
        return acc;
      }, {});

      return Object.fromEntries(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(grouped).sort(function (_ref, _ref2) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
            a = _ref4[0];

        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 1),
            b = _ref3[0];

        return a.localeCompare(b);
      }));
    }
  },
  methods: {
    whenClicked: function whenClicked() {
      this.active = !this.active;
    },
    clipboardText: function clipboardText(leak) {
      var datetime = leak.formattedDetectionTimestamp.split(' ');
      return leak.formattedSectionName + ', ' + leak.formattedSiteName + ', ' + leak.km + ', ' + leak.lat + ', ' + leak.lon + ', ' + datetime[0] + ', ' + datetime[1];
    },
    copyToClipboardClick: function copyToClipboardClick(clipboard_id) {
      var copyText = $('#' + clipboard_id);


      var $temp = $('<input>');
      $('body').append($temp);
      $temp.val(copyText.val()).select();

      document.execCommand('copy');
      $temp.remove();
    },
    locateLeak: function locateLeak(leak) {
      this.mapComp.onLocateLeak(leak);
    },
    identifyLeak: function identifyLeak(leak) {
      this.mapComp.onIdentifyLeak(leak, function (result) {
        result.status = __WEBPACK_IMPORTED_MODULE_6__models_leak__["a" /* default */].Status.RECOGNIZED;
      });
    },
    postBitacora: function postBitacora() {
      var _this2 = this;

      if (this.comentario === '' || this.selected === '') {
        return;
      }

      var user = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].ls.get('user');
      this.$store.dispatch('POST_BITACORA', {
        username: user.username,
        id_section: this.ducto,
        id_concept: this.selected,
        comment: this.comentario
      }).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_5_toastr___default.a.success('Se a añadido exitosamente tu comentario !');
        _this2.comentario = '';
        _this2.selected = '';
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_5_toastr___default.a.error('Hubo un error, Favor de volver a intentarlo');
        console.log('Error', err);
      });
    },
    recFilter: function recFilter() {
      this.filtAlarms = this.$store.getters.GET_HOME_LEAKS_TABLE;
    },
    setMap: function setMap(sectionId, site) {
      this.mapComp.onSiteTableClicked(sectionId, site);
    },
    leakClicked: function leakClicked(leakId) {
      this.mapComp.onLeakTableClicked(leakId);
    },
    recAlarm: function recAlarm(t) {
      this.alarmIndex = t;
      if (t === 2) {
        $('tr.reconocidas').hide();
        $('tr.no-reconocidas').hide();
        $('tr.operational').show();

        $('#operational').removeClass('not-active');
        $('#no-reconocidas').addClass('not-active');
        $('#reconocidas').addClass('not-active');
      } else if (t === 1) {
        $('tr.reconocidas').show();
        $('tr.no-reconocidas').hide();
        $('tr.operational').hide();

        $('#operational').addClass('not-active');
        $('#no-reconocidas').addClass('not-active');
        $('#reconocidas').removeClass('not-active');
      } else {
        $('tr.reconocidas').hide();
        $('tr.no-reconocidas').show();
        $('tr.operational').hide();

        $('#operational').addClass('not-active');
        $('#no-reconocidas').removeClass('not-active');
        $('#reconocidas').addClass('not-active');
      }
    },
    getLeakDescription: function getLeakDescription(leak) {
      if (leak.is_operational_movement === true) {
        return 'Movimiento operativo';
      }
      if (leak.offline_status) {
        return 'Fuga reconocida';
      }
      return 'Fuga no reconocida';
    },
    getColor: function getColor(leak) {
      if (leak.is_operational_movement === true) {
        return 'color: orange';
      }
      if (leak.offline_status) {
        return 'color: red';
      }
      return 'color: green';
    },
    getIcon: function getIcon(leak) {
      if (leak.is_operational_movement === true) {
        return 'fa fa-cogs';
      }
      if (leak.offline_status) {
        return 'fa fa-chain-broken';
      }
      return 'fa fa-bolt';
    },
    showDucto: function showDucto(id) {
      $('.' + id).toggleClass('no-show');
    },
    passName: function passName(leak) {
      var _this3 = this;

      this.ducto = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.ducts).filter(function (duc) {
        return leak._name_section_1 === _this3.ducts[duc]._name;
      });
      $('#label-name').text('Ducto: ' + leak._name_section_1);
    },
    fillData: function fillData() {
      this.ducts = this.$store.getters.GET_HOME_DUCTOS_TABLE;
    },
    fillLeaks: function fillLeaks() {
      this.recFilter();
    }
  },
  updated: function updated() {
    this.recAlarm(this.alarmIndex);
  },
  mounted: function mounted() {
    var _this4 = this;

    var user = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].ls.get('user');
    this.isAllowedToIdentifyLeak = user.userPermissions && user.userPermissions.includes('Alertas');
    this.$store.dispatch('LOAD_CONCEPTOS').then(function (resp) {
      resp.data.forEach(function (con) {
        _this4.conceptos.push({
          name: con.name,
          value: con.id_journal_concept
        });
      });
    }).catch(function (err) {
      console.log('Error', err);
    });
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4_reusable_Modal___default.a
  }
});

/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Map__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Home_DataTable__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Home_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Home_DataTable__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lists: {},
      pollDuctsTimer: undefined,
      pollLeaksTimer: undefined,
      ductosTimer: undefined,
      leaksTimer: undefined,
      ducts: undefined
    };
  },

  methods: {
    pollDuctsData: function pollDuctsData() {
      var _this = this;

      this.$store.dispatch('LOAD_DUCTOS').then(function (data) {
        _this.$refs.home_data_table.fillData();
        _this.$refs.map.fillMap();

        if (_this.$store.state.user) {
          _this.pollDuctsTimer = setTimeout(function () {
            _this.pollDuctsData();
          }, 3000);
        }
      }).catch(function (err) {
        if (!_this.$store.state.user) {
          _this.pollDuctsTimer = setTimeout(function () {
            _this.pollDuctsData();
          }, 3000);
        }
      });
    },
    pollLeaksData: function pollLeaksData() {
      var _this2 = this;

      this.$store.dispatch('LOAD_FUGAS', { current: 1 }).then(function (data) {
        if (_this2.$refs && _this2.$refs.home_data_table) {
          _this2.$refs.home_data_table.fillLeaks();
        }
        if (_this2.$refs && _this2.$refs.map) {
          _this2.$refs.map.fillLeaks().then(function () {
            if (_this2.$store.state.user) {
              _this2.pollLeaksTimer = setTimeout(_this2.pollLeaksData, 10000);
            }
          });
        }
      }).catch(function (err) {
        if (!_this2.$store.state.user) {
          _this2.pollLeaksTimer = setTimeout(_this2.pollLeaksData, 10000);
        }
      });
    }
  },
  mounted: function mounted() {
    this.pollDuctsData();
    this.pollLeaksData();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pollDuctsTimer) {
      clearTimeout(this.pollDuctsTimer);
    }
    if (this.pollLeaksTimer) {
      clearTimeout(this.pollLeaksTimer);
    }
    this.pollDuctsTimer = null;
    this.pollLeaksTimer = null;
  },

  components: {
    GoogleMaps: __WEBPACK_IMPORTED_MODULE_0_components_Map___default.a,
    DataTable: __WEBPACK_IMPORTED_MODULE_1_components_Home_DataTable___default.a
  }
});

/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(224);



var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      section: 'Localiza Pérdida Integridad',
      username: '',
      password: '',
      modalName: 'loading-modal'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['user', 'modalInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    duplicateSession: function duplicateSession(state) {
      return state.duplicateSession;
    }
  })),
  methods: {
    imgUrl: function imgUrl() {
      var img = __webpack_require__(319);
      return img;
    },
    login: function login() {
      this.$store.dispatch('login', { username: this.username, password: this.password });
    }
  },
  components: {
    Modal: Modal,
    LoadingModal: LoadingModal
  },
  created: function created() {
    if (this.user) {
      return this.$router.replace('/dashboard');
    }
  },
  mounted: function mounted() {
    document.querySelector('body').addEventListener('keydown', function (e) {
      if (e.code === 'Enter') {
        var loginBtn = document.querySelector('#login-btn');
        if (loginBtn) loginBtn.click();
      }
    });
    if (this.duplicateSession) {
      this.$store.commit('SET_DUPLICATE_SESSION', false);
      alert('Hay otra sesión activa, cierra la sesión anterior para poder iniciar una nueva');
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.querySelector('body').removeEventListener('click', function () {
      console.log('removed');
    });
  }
});

/***/ }),

/***/ 828:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_imgs_logos_logo_pemex_original_png__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_imgs_logos_logo_pemex_original_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_imgs_logos_logo_pemex_original_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marker_clusterer_plus__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marker_clusterer_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marker_clusterer_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_leak__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_constants_js__ = __webpack_require__(801);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['cclass', 'mcStyle', 'wStyle', 'mcClass'],
  data: function data() {
    return {
      statusAlarm: 'place_red',

      mapReady: false,
      markers: [],
      infowindow: undefined,
      leakIndex: 0,
      markerClusterer: undefined,
      is_chrome: navigator.userAgent.indexOf('Chrome') > -1,
      is_explorer: navigator.userAgent.indexOf('MSIE') > -1,
      is_firefox: navigator.userAgent.indexOf('Firefox') > -1,
      is_safari: navigator.userAgent.indexOf('Safari') > -1,
      is_opera: navigator.userAgent.toLowerCase().indexOf('op') > -1
    };
  },

  methods: {
    imgUrl: function imgUrl(url) {
      return __webpack_require__(762)("./" + url);
    },
    alarmStatus: function alarmStatus() {
      var skipAlarm = "production" === 'development';

      if (skipAlarm) {
        return;
      }

      var audio = this.$refs.alarm;

      if (!audio) {
        return;
      }
      var leakFound = this.$store.getters.GET_HOME_LEAKS_TABLE.some(function (l) {
        if (l.is_operational_movement === true) {
          return false;
        }
        return l.status == __WEBPACK_IMPORTED_MODULE_5__models_leak__["a" /* default */].Status.SYSTEM_IDENTIFIED;
      });

      if (leakFound) {
        audio.muted = false;
        if (audio.paused) {
          audio.play();
        }
      } else {
        audio.pause();
        audio.muted = true;
      }
    },
    drawDucts: function drawDucts() {
      var data = this.$store.getters.GET_ROUTES;
      var colorArray = ['#FF6633', '#FFB399', '#FF33FF', '#00B3E6', '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D', '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC', '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399', '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933', '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];
      var index = 0;

      var sections = this.$store.getters.allowedSections;
      for (var id in data) {
        if (!__WEBPACK_IMPORTED_MODULE_2_ramda__["o" /* contains */](id, sections)) {
          continue;
        }
        var route = data[id];
        var linePath = new google.maps.Polyline({
          path: route,
          geodesic: false,
          strokeColor: colorArray[index],
          strokeWeight: 5,
          strokeOpacity: 1.0
        });
        linePath.setMap(this.$store.state.map);

        index++;
      }
    },
    fillMap: function fillMap() {
      var _this = this;

      if (!this.$store.state.user) {
        return;
      }

      var ducts = this.$store.getters.GET_HOME_DUCTOS_TABLE;
      var focusSections = [];
      if (this.$store.state.user.config && this.$store.state.user.config.focus) {
        focusSections = this.$store.state.user.config.focus;
      }
      var focusMarker = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(ducts).forEach(function (idSection) {
        var section = ducts[idSection];
        var isFocusRequired = focusSections.length === 0 || focusSections.includes(section.id);

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(section.sites).forEach(function (idSite) {
          var site = section.sites[idSite];
          var imgSrc = 'place_red.gif';

          if (!site.hasFailure()) {
            imgSrc = 'place_green.png';
          }
          if (site.battery < 12 || site.hasPressueAlarm()) {
            imgSrc = 'place_yellow.png';
          }

          if (site.isOffline() || site.cabinet_door === 1 || site.gps === 0 || site.site_door === 1 || site.pressure === 0) {
            imgSrc = 'place_red.gif';
          }

          var img = new google.maps.MarkerImage(_this.imgUrl(imgSrc));


          var marker = _this.getMarker(section.id, site.id);

          if (!marker) {
            marker = new google.maps.Marker({
              position: new google.maps.LatLng(site.lat, site.lon),
              map: _this.$store.state.map,
              icon: img,
              customInfo: {
                section: section.id,
                site: site.id
              }
            });
            if (isFocusRequired) {
              focusMarker.push(marker);
            }

            _this.markerListener(marker, section, site);
            _this.markers.push(marker);
          } else {
            marker.setIcon(img);
          }
        });
        _this.alarmStatus();
      });
      if (focusMarker.length > 0) {
        var bounds = new google.maps.LatLngBounds();
        focusMarker.forEach(function (marker) {
          bounds.extend(marker.getPosition());
        });
        this.$store.state.map.fitBounds(bounds);
      }
    },
    fillLeaks: function fillLeaks() {
      var _this2 = this;

      var leaks = this.$store.getters.GET_HOME_LEAKS_TABLE;
      var leaksLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(leaks).length;


      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.drawLeak(leaks, leaksLength).then(function () {
          return resolve();
        }).catch(function (err) {
          return reject(err);
        });
      });
    },
    drawLeak: function drawLeak(leaks, len) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var currentMax = _this3.leakIndex;
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(leaks);

        if (currentMax >= len) {
          return resolve();
        }
        for (var i = currentMax; i < len && i < currentMax + __WEBPACK_IMPORTED_MODULE_6__common_constants_js__["a" /* MAX_LEAKS_PROCESSED_IN_BATCH */]; i++) {
          var leak = leaks[keys[i]];
          var anim = google.maps.Animation.BOUNCE;
          var imgSrc = 'leak_red.gif';
          if (leak.status === __WEBPACK_IMPORTED_MODULE_5__models_leak__["a" /* default */].Status.RECOGNIZED) {
            imgSrc = 'leak_blue.png';
            anim = null;
          } else if (leak.status === __WEBPACK_IMPORTED_MODULE_5__models_leak__["a" /* default */].Status.IN_DAILY_REPORT) {
            imgSrc = 'leak_green.png';
            anim = null;
          }
          var updateIcon = false;

          var leakMarker = _this3.getLeakMarker(leak.id);
          var markerTitle = 'Alarma de ' + (leak.type === 1 ? 'Apertura' : 'Cierre');
          if (!leakMarker) {
            leakMarker = new google.maps.Marker({
              position: { lat: leak.lat, lng: leak.lon },
              title: markerTitle,

              zIndex: google.maps.Marker.MAX_ZINDEX + 1,
              customInfo: leak
            });
            updateIcon = true;
            anim = google.maps.Animation.DROP;
            _this3.leakMarkerListener(leakMarker);
            _this3.markerClusterer.addMarker(leakMarker);
          } else if (leak.status !== leakMarker.customInfo.status) {
            updateIcon = true;
          }
          if (updateIcon) {
            leakMarker.setIcon(new google.maps.MarkerImage(_this3.imgUrl(imgSrc)));
            leakMarker.setAnimation(anim);
          }
          _this3.leakIndex++;
        }
        _this3.alarmStatus();
        setTimeout(function () {
          return _this3.drawLeak(leaks, len).then(function () {
            return resolve();
          });
        }, 50);
      });
    },
    markerListener: function markerListener(marker, section, site) {
      var _this4 = this;

      var imgIcon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'place_green.png';

      var fallaMsg = '';
      marker.addListener('click', function () {
        _this4.$store.state.map.panTo(marker.getPosition());
        google.maps.event.addListenerOnce(_this4.$store.state.map, 'idle', function () {
          _this4.$store.state.map.setOptions({
            center: marker.getPosition(),
            zoom: 18
          });
        });
        site._battery <= 10 ? fallaMsg = 'Batería baja' : site._cabinet_door === 1 ? fallaMsg = 'Fallo en la puerta' : site._gps === 0 ? fallaMsg = 'Fallo en el gps' : site._site_door === 1 ? fallaMsg = 'Fallo en la puerta del site' : fallaMsg = '';
        if (fallaMsg !== '') {
          fallaMsg = fallaMsg + '</p>';
        }

        _this4.infowindow.setContent('\n        <div style="width: 310px; color: #222; font-weight:400;">        \n          <div><img width="116" height="32" src="' + __WEBPACK_IMPORTED_MODULE_3__assets_imgs_logos_logo_pemex_original_png___default.a + '"></div>\n          \n          <div style="color: var(--btn-default); font-size: 16px; font-weight:500; margin-top: 10px; margin-bottom: 10px"><span>' + section.name + '</span></div>\n\n          <div style=\'width: 50%; float: left; margin-top: 10px\'>\n            <div style=\'width: 15%; float: left; text-align: center;\' >\n              <i class="fa fa-signal" style=\'font-size: 16px; color: #166FB8; margin-top: 5px\' aria-hidden="true"></i>\n            </div>\n            <div style=\'width: 85%; float: left; display: block;\'>\n              <div style=\'text-align: left; color: var(--btn-default); font-weight:400;\'>' + site.name + '</div>\n              <div style=\'font-size: 10px\'>Sitio</div>\n            </div> \n          </div>\n\n          <div style=\'width: 50%; float: left; margin-top: 10px\'>\n            <div style=\'width: 11%; float: left; text-align: center;\' >\n              <i class="fa fa-map-marker" style=\'font-size: 20px; color: #166FB8; margin-top: 5px\' aria-hidden="true"></i>\n            </div>\n            <div style=\'width: 89%; float: left; display: block;\'>\n              <div style=\'text-align: left; color: var(--btn-default); font-weight:400;\'>' + (site.city + ', Km ' + site.km) + '</div>\n              <div style=\'font-size: 10px\'>(' + (site.lat.toFixed(5) + ' , ' + site.lon.toFixed(5)) + ')</div>\n            </div> \n          </div>\n\n          <div style=\'width: 50%; float: left; margin-top: 10px\'>\n            <div style=\'width: 15%; float: left; text-align: center;\' >\n              <i class="fa fa-battery-full" style=\'font-size: 14px; color: #166FB8; margin-top: 5px\' aria-hidden="true"></i>\n            </div>\n            <div style=\'width: 85%; float: left; display: block;\'>\n              <div style=\'text-align: left; color: var(--btn-default); font-weight:400;\'>' + site.battery + '</div>\n              <div style=\'font-size: 10px\'>Carga de bater\xEDa</div>\n            </div> \n          </div>\n\n          <div style=\'width: 50%; float: left; margin-top: 10px\'>\n            <div style=\'width: 15%; float: left; text-align: center;\' >\n              <i class="fa fa-tint" style=\'font-size: 18px; color: #166FB8; margin-top: 5px\' aria-hidden="true"></i>\n            </div>\n            <div style=\'width: 85%; float: left; display: block;\'>\n              <div style=\'text-align: left; color: var(--btn-default); font-weight:400;\'>' + (site.pressure + ' kg/cm2') + '</div>\n              <div style=\'font-size: 10px\'>Presi\xF3n</div>\n            </div> \n          </div>\n\n          <div style=\'width: 50%; float: left; margin-top: 10px\'>\n            <div style=\'width: 15%; float: left; text-align: center;\' >\n              <i class="fa fa-power-off" style=\'font-size: 18px; color: #166FB8; margin-top: 5px\' aria-hidden="true"></i>\n            </div>\n            <div style=\'width: 85%; float: left; display: block;\'>\n              <div style=\'text-align: left; color: var(--btn-default); font-weight:400;\'>' + (site.online === 1 ? 'Encendido' : 'Apagado') + '</div>\n              <div style=\'font-size: 10px\'>Estado</div>\n            </div> \n          </div>\n\n          <div style=\'width: 50%; float: left; margin-top: 10px; margin-bottom: 20px\'>\n            <div style=\'width: 15%; float: left; text-align: center;\' >\n              <i class="fa fa-clock-o" style=\'font-size: 18px; color: #166FB8; margin-top: 5px\' aria-hidden="true"></i>\n            </div>\n            <div style=\'width: 85%; float: left; display: block;\'>\n              <div style=\'text-align: left; color: var(--btn-default); font-weight:400;\'>' + site.insertTimestamp + '</div>\n              <div style=\'font-size: 10px\'>\xDAltimo evento</div>\n            </div> \n          </div>\n          \n        </div>');
        _this4.infowindow.open(_this4.$store.state.map, marker);
      });
    },
    onLeakTableClicked: function onLeakTableClicked(leak) {
      var leakMarker = this.getLeakMarker(leak.id);
      if (!leakMarker || !leakMarker.customInfo) {
        return;
      }
      google.maps.event.trigger(leakMarker, 'click');
    },
    onSiteTableClicked: function onSiteTableClicked(sectionId, site) {
      var marker = this.getMarker(sectionId, site.id || site._id);
      if (!marker || !marker.customInfo) {
        return;
      }
      google.maps.event.trigger(marker, 'click');
    },
    onLocateLeak: function onLocateLeak(leak) {
      var _this5 = this;

      var marker = this.getLeakMarker(leak.id);
      if (!marker) {
        return;
      }
      this.$store.state.map.panTo(marker.getPosition());
      google.maps.event.addListenerOnce(this.$store.state.map, 'idle', function () {
        _this5.$store.state.map.setOptions({
          center: marker.getPosition(),
          zoom: 18
        });
      });
    },
    onIdentifyLeak: function onIdentifyLeak(leak, callback) {
      var _this6 = this;

      this.$store.dispatch('IDENTIFY_FUGA', { id: leak.id, status: __WEBPACK_IMPORTED_MODULE_5__models_leak__["a" /* default */].Status.RECOGNIZED }).then(function (data) {
        if (data && data.affectedRows === 1) {
          var marker = _this6.getLeakMarker(leak.id);
          marker.customInfo.status = __WEBPACK_IMPORTED_MODULE_5__models_leak__["a" /* default */].Status.RECOGNIZED;
          marker.setIcon(new google.maps.MarkerImage(_this6.imgUrl('leak_blue.png')));
          if (typeof callback === 'function') {
            callback(leak);
          }
          _this6.infowindow.close();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    onPipeLineSelected: function onPipeLineSelected(section) {
      var markers = this.markers.filter(function (marker) {
        return marker.customInfo && marker.customInfo.section === section;
      }).slice(0);

      if (markers.length >= 2) {
        var first = markers[0].getPosition();
        var last = markers.pop().getPosition();

        var bounds = new google.maps.LatLngBounds();
        bounds.extend(new google.maps.LatLng(first.lat(), first.lng()));
        bounds.extend(new google.maps.LatLng(last.lat(), last.lng()));

        this.$store.state.map.setOptions({
          center: bounds.getCenter(),
          zoom: 9.6
        });
      }
    },
    leakMarkerListener: function leakMarkerListener(marker) {
      var _this7 = this;

      marker.addListener('click', function () {
        _this7.$store.state.map.panTo(marker.getPosition());
        google.maps.event.addListenerOnce(_this7.$store.state.map, 'idle', function () {
          _this7.$store.state.map.setOptions({
            center: marker.getPosition(),
            zoom: 18
          });
        });

        var btwnStr = marker.customInfo.isSameSection() ? '<h5 style="margin-top:0.1em;margin-bottom:0em;">Entreeee:</h5>' + ('<h6 style="margin-top:0.1em;margin-bottom:0em;">' + marker.customInfo.section1Name + '</h6>') + ('<h6 style="margin-top:0.1em;margin-bottom:0em;"><span style="font-style:italic">' + marker.customInfo.site1Name + '</span> ') + ('y <span style="font-style:italic">' + marker.customInfo.site2Name + '</span></h6>') : '<h5 style="margin-top:0.1em;margin-bottom:0em;">Entre:</h5>' + ('<h6 style="margin-top:0.1em;margin-bottom:0em;">' + marker.customInfo.section1Name + ' <span style="font-style:italic">' + marker.customInfo.site1Name + '</span> ') + ('y ' + marker.customInfo.section2Name + ' <span style="font-style:italic">' + marker.customInfo.site2Name + '</span></h6>');
        _this7.infowindow.setContent('<div style=\'width: 310px\'>\n          <div style=\'color: var(--btn-default); font-size: 22px; font-weight:500; text-align: center\'>\n            ' + marker.title + '\n          </div>\n          <div style=\'color: #555; font-size: 14px; font-weight:410; margin-top:10px; text-align: center\'\'>\n            ' + marker.customInfo.section1Name + ' <span style=\'font-size: 12px; color: #888\'>(' + marker.customInfo.site1Name + ' y ' + marker.customInfo.site2Name + ')</span>\n          </div>\n          <div style=\'color: #555; font-size: 12.5px; font-weight:410; margin-top:10px\'>            \n            <i class="fa fa-map-marker" style=\'font-size: 16px; color: #166FB8;\' aria-hidden="true"></i>\n            <span style="margin-left:5px;">(' + marker.customInfo.lat + ' , ' + marker.customInfo.lon + ')</span>               \n          </div>\n          <div style=\'color: #555; font-size: 12.5px; font-weight:410; margin-top:10px\'>            \n            <i class="fa fa-road" style=\'font-size: 16px; color: #166FB8;\' aria-hidden="true"></i>\n            <span>Km ' + marker.customInfo.km + '</span>               \n          </div>\n          <div style=\'color: #555; font-size: 12.5px; font-weight:410; margin-top:10px\'>            \n            <i class="fa fa-clock-o" style=\'font-size: 16px; color: #166FB8;\' aria-hidden="true"></i>\n            <span style="margin-left:5px;">' + marker.customInfo.formattedDetectionTimestamp + '</span>               \n          </div>\n          <p class=\'pull-right\' style=\'color: red; font-weight: 800;\'></p>\n\n        </div>');
        _this7.infowindow.open(_this7.$store.state.map, marker);
        if (marker.customInfo.status > __WEBPACK_IMPORTED_MODULE_5__models_leak__["a" /* default */].Status.SYSTEM_IDENTIFIED) {
          return;
        }
      });
    },
    startGoogleMaps: function startGoogleMaps() {
      var _this8 = this;

      var myOptions = {
        zoom: 5.2,
        center: {
          lat: 24.9305093,
          lng: -102.2925067
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DEFAULT,
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        styles: [{
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#e1edfb' }]
        }, {
          featureType: 'road.highway',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'on' }]
        }, {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#fafbfd' }]
        }, {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ visibility: 'off' }]
        }, {
          featureType: 'poi.park',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }]
        }]
      };

      this.$store.state.map = new google.maps.Map(document.getElementById('map_canvas'), myOptions);
      google.maps.event.addListenerOnce(this.$store.state.map, 'idle', function () {
        _this8.mapReady = true;

        _this8.infowindow = new google.maps.InfoWindow({
          size: new google.maps.Size(350, 250),
          maxWidth: 350
        });
      });
      this.markerClusterer = new __WEBPACK_IMPORTED_MODULE_4_marker_clusterer_plus___default.a(this.$store.state.map, [], {
        maxZoom: 100,

        averageCenter: true
      });
    },
    isMapReady: function isMapReady() {
      return this.mapReady;
    },
    getMarker: function getMarker(section, site) {
      return this.markers.find(function (marker) {
        return marker.customInfo && marker.customInfo.section === section && marker.customInfo.site === site;
      });
    },
    getLeakMarker: function getLeakMarker(idLeak) {
      var result = void 0;
      var markers = this.markerClusterer.getMarkers();
      markers.some(function (marker) {
        if (marker.customInfo && marker.customInfo.id === idLeak) {
          result = marker;
          return true;
        }
        return false;
      });
      return result;
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    this.mapReady = false;
    this.startGoogleMaps();

    this.$store.dispatch('LOAD_PIPELINE_SHAPES');
    this.$store.watch(function (state) {
      return state.routes;
    }, function () {
      _this9.drawDucts();
    }, {
      immediate: true
    });

    var wH = $(window).height();
    $('#map_canvas').css({ height: wH });
  },

  watch: {}
});

/***/ }),

/***/ 829:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {}
    };
  },
  mounted: function mounted() {},

  watch: {
    info: function info() {}
  },
  methods: {
    setInfo: function setInfo(options) {
      this.info = options;
    },
    close: function close() {}
  }
});

/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ready: false,
      theInfo: {}
    };
  },

  props: ['info'],
  mounted: function mounted() {
    var _this = this;

    var modal = document.querySelector('#loading-modal-modal');
    if (modal !== null) {
      modal.removeAttribute('tabindex');
      modal.setAttribute('data-backdrop', 'static');
    }

    setInterval(function () {
      if (_this.info.ready !== undefined) {
        _this.ready = _this.info.ready;
        clearInterval();
      }
    }, 500);
  },

  watch: {
    info: function info() {
      this.ready = this.info.ready;
    }
  }
});

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      code: ['', '', '', '', '', '']
    };
  },

  methods: {
    onInput: function onInput(index) {
      if (this.code[index].length === 1 && index < 5) {
        this.$refs.inputs[index + 1].focus();
      }
      this.$emit('input', this.code.join(''));
    },
    onBackspace: function onBackspace(index) {
      if (this.code[index] === '' && index > 0) {
        this.$refs.inputs[index - 1].focus();
      }
    }
  }
});

/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CodeInput_vue__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CodeInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CodeInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(224);



var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      recovery: this.$store.state.recovery,
      steps: ['email', 'code', 'password', 'start', 'error'],
      currentStep: 0,
      password: '',
      confirmPassword: '',
      email: '',
      emailHint: '',
      modalName: 'loading-modal',
      verificationCode: '',
      guid: ''
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['user', 'modalInfo']),
  methods: {
    imgUrl: function imgUrl() {
      return __webpack_require__(319);
    },
    onCodeInput: function onCodeInput(code) {
      this.verificationCode = code;
    },
    requestCode: function requestCode() {
      var _this = this;

      this.$store.dispatch('requestCode', { email: this.email, guid: this.guid }).then(function (resp) {
        console.log('request code', resp);
        if (resp) {
          _this.currentStep = 1;
        }
        _this.closeModal();
      }).catch(function (err) {
        _this.closeModal();
        console.log(err);
      });
    },
    verifyCode: function verifyCode() {
      var _this2 = this;

      this.$store.dispatch('verifyCode', { code: this.verificationCode, guid: this.guid }).then(function (resp) {
        console.log('verify code', resp);
        if (resp) {
          _this2.currentStep = 2;
        }
        _this2.closeModal();
      }).catch(function (err) {
        console.log(err);
        _this2.closeModal();
      });
    },
    resetPassword: function resetPassword() {
      var _this3 = this;

      this.$store.dispatch('resetPassword', {
        password: this.password,
        confirmPassword: this.confirmPassword,
        guid: this.recovery.recoveryGuid,
        code: this.verificationCode
      }).then(function (resp) {
        _this3.closeModal();
        _this3.currentStep = 3;
      }).catch(function (err) {
        _this3.closeModal();
      });
    },
    gotoLogin: function gotoLogin() {
      this.$router.replace('/login');
    },
    closeModal: function closeModal() {
      $(this.$router.app.$children[0])[0].closeModal();
    }
  },
  components: {
    CodeInput: __WEBPACK_IMPORTED_MODULE_0__CodeInput_vue___default.a,
    Modal: Modal,
    LoadingModal: LoadingModal
  },
  created: function created() {
    var recovery = this.recovery;
    this.guid = recovery.recoveryGuid;

    if (!this.recovery) {
      return this.$router.replace('');
    }

    this.emailHint = recovery ? recovery.email : 'Correo';
    if (!recovery) {
      return this.$router.replace('/dashboard');
    }
  },
  mounted: function mounted() {
    this.$store.commit('setModalInfo', { modalName: this.modalName });
    document.querySelector('body').addEventListener('keydown', function (e) {
      if (e.code === 'Enter') {
        var loginBtn = document.querySelector('#login-btn');
        if (loginBtn) loginBtn.click();
      }
    });
  }
});

/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showSidepanel: true,
      ductos: [],
      selectedStations: null,
      minutes: [15, 30, 45, 60],
      selectedMinutes: 15,
      selectedDucto: null,
      filterDuctos: [],
      filterMinutes: 0,
      isChartVisible: false,
      isInitialSetup: true,
      isDestroyed: false,
      seriesList: [],
      intervals: {},
      chartOptions: {
        noData: {
          text: ''
        },
        chart: {
          type: 'line',
          width: '100%',
          height: '100%',
          responsive: true,
          maintainAspectRatio: false,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          },
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 1.9
        },
        title: {
          text: '',
          align: 'left'
        },
        markers: {
          size: 0
        },
        yaxis: {
          forceNiceScale: true,
          tickAmount: 6,
          logarithmic: false,
          title: {
            text: ''
          },
          max: function max(value) {
            return value * 1.01;
          },
          min: function min(value) {
            return value * 0.99;
          }
        },
        xaxis: {
          type: 'category',
          tickAmount: 4,
          tooltip: {
            enabled: false
          },
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false
          },
          axisTicks: {
            show: true
          }
        }
      }
    };
  },
  computed: {
    filteredStations: function filteredStations() {
      var _this = this;

      if (!this.selectedDucto) {
        return this.ductos;
      }
      return this.ductos.filter(function (q) {
        return q.id_section === _this.selectedDucto.id_section;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this2.ductos = resp;
    }).catch(function (err) {
      console.log(err);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearAllIntervals();
    this.isDestroyed = true;
  },

  methods: {
    onApplyFilter: function onApplyFilter() {
      this.filterDuctos = this.selectedStations;
      this.filterMinutes = this.selectedMinutes;

      this.seriesList = [];

      if (this.filterDuctos && this.filterDuctos.length > 0) {
        this.filterDuctos.forEach(function (q) {
          q.report_data_id = 0;
        });

        this.isInitialSetup = false;
        this.showSidepanel = false;
        this.isChartVisible = true;

        this.updateEmptyCharts();

        this.loadDecimationSites();
      }
    },
    updateEmptyCharts: function updateEmptyCharts() {
      var _this3 = this;

      this.seriesList = [];

      this.filterDuctos.forEach(function (x) {
        var ducto = _this3.ductos.find(function (d) {
          return d.id_section === x.id_section;
        });
        var site = ducto.sites.find(function (s) {
          return s.id_site === x.id_site;
        });

        var chartName = ducto.id_section + ' - ' + site.site_name;
        _this3.seriesList.push({
          series: [{
            name: chartName,
            data: []
          }],
          name: chartName,
          options: _this3.chartOptions,
          loading: true,
          error: false,
          errorMessage: 'No fue posible cargar los datos, intente reducir el rango de fechas'
        });
      });
    },
    loadDecimationSites: function loadDecimationSites() {
      if (this.isDestroyed) {
        return;
      }

      for (var i = 0; i < this.filterDuctos.length; i++) {
        var ducto = this.filterDuctos[i];
        this.loadDecimationSite(ducto);
      }
    },
    loadDecimationSite: function loadDecimationSite(ducto) {
      var _this4 = this;

      var chartName = ducto.id_section + ' - ' + ducto.site_name;

      this.clearIntervalForSite(chartName);

      if (this.isDestroyed) {
        return;
      }

      var request = {
        sites: [ducto]
      };
      var sites_json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(request);
      var targetData = this.seriesList.filter(function (q) {
        return q.name === chartName;
      });

      this.$store.dispatch('LOAD_DECIMATION_SITES', {
        minutes: this.filterMinutes,
        sites_json: btoa(sites_json)
      }).then(function (resp) {
        _this4.addChartData(chartName, resp, ducto, targetData[0]);
      }).catch(function (err) {
        console.log('Error:', err);
        targetData.forEach(function (q) {
          if (!q.loading) {
            q.errorMessage = 'No fue posible cargar los datos, intente nuevamente';
          }
          q.loading = false;
          q.error = true;
        });
      });
    },
    addChartData: function addChartData(chartName, reportData, ducto, targetData) {
      var _this5 = this;

      var chartData = [];

      if (reportData && reportData.data && reportData.data.data) {
        chartData = reportData.data.data;
      }
      var wasLoading = targetData.loading;
      targetData.loading = false;
      targetData.error = false;

      var data = [];

      if (chartData && chartData.length > 0) {
        var last = chartData[chartData.length - 1];
        ducto.report_data_id = last.report_data_id;
        data = chartData.map(function (q) {
          return { x: q.report_date, y: q.data, timestamp: q.timestamp };
        });
      }

      var index = this.seriesList.indexOf(targetData);

      if (wasLoading && data.length === 0) {
        var chartOptions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.chartOptions);
        chartOptions.noData.text = 'No hay datos disponibles';
        this.$refs.rows[index].updateOptions(chartOptions);
      } else if (data.length > 0) {
        var series = targetData.series[0];
        series.data = series.data.concat(data);

        this.$refs.rows[index].updateSeries([{
          data: series.data
        }]);
        this.setIntervalForSite(chartName, function () {
          return _this5.loadDecimationSite(ducto);
        }, 1000);
      } else {
        this.setIntervalForSite(chartName, function () {
          return _this5.loadDecimationSite(ducto);
        }, 1000 * 10);
      }
    },
    setIntervalForSite: function setIntervalForSite(siteId, callback, interval) {
      this.clearIntervalForSite(siteId);
      this.intervals[siteId] = setInterval(callback, interval);
    },
    clearIntervalForSite: function clearIntervalForSite(siteId) {
      if (this.intervals[siteId]) {
        clearInterval(this.intervals[siteId]);
        delete this.intervals[siteId];
      }
    },
    clearAllIntervals: function clearAllIntervals() {
      for (var siteId in this.intervals) {
        clearInterval(this.intervals[siteId]);
      }
      this.intervals = {};
    }
  }
});

/***/ }),

/***/ 834:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showSidepanel: true,
      ductos: [],
      selectedStations: null,
      selectedDucto: null,
      minutes: [10, 20, 30],
      selectedMinutes: 10,
      filterDuctos: [],
      filterMinutes: 0,
      selectedDate: null,
      isChartVisible: false,
      isDestroyed: false,
      series: [{
        name: '',
        data: []
      }],
      chartOptions: {
        noData: {
          text: 'Cargando...'
        },
        chart: {
          type: 'line',
          width: '100%',
          height: '80%',
          responsive: true,
          maintainAspectRatio: false,
          zoom: {
            type: 'x',
            enabled: false,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          },
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 1.9
        },
        title: {
          text: '',
          align: 'left'
        },
        markers: {
          size: 0
        },
        yaxis: {
          forceNiceScale: true,
          tickAmount: 6,
          min: 0,
          max: 100,
          logarithmic: false,
          title: {
            text: ''
          }
        },
        xaxis: {
          type: 'category',
          tickAmount: 4,
          tooltip: {
            enabled: false
          },
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false
          },
          axisTicks: {
            show: true
          }
        }
      }
    };
  },
  computed: {
    filteredStations: function filteredStations() {
      var _this = this;

      if (!this.selectedDucto) {
        return this.ductos;
      }
      return this.ductos.filter(function (q) {
        return q.id_section === _this.selectedDucto.id_section;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this2.ductos = resp;
    }).catch(function (err) {
      console.log(err);
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    this.isDestroyed = true;
  },

  methods: {
    onApplyFilter: function onApplyFilter() {
      this.filterDuctos = this.selectedStations;
      this.filterMinutes = this.selectedMinutes;
      this.filterDuctos.forEach(function (q) {
        q.report_data_id = 0;
      });

      this.series = [];

      if (this.filterDuctos.length > 0) {
        this.showSidepanel = false;
        this.isChartVisible = true;
        this.loadDecimationSites();
      }
    },
    loadDecimationSites: function loadDecimationSites() {
      var _this3 = this;

      clearInterval(this.timer);
      var sites = {
        sites: this.filterDuctos
      };
      var sites_json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sites);
      if (this.isDestroyed) {
        return;
      }
      this.$store.dispatch('LOAD_DECIMATION_SITES', {
        minutes: this.filterMinutes,
        sites_json: btoa(sites_json)
      }).then(function (resp) {
        if (resp.data === null || resp.data.length === 0) {
          _this3.timer = setInterval(_this3.loadDecimationSites, 30000);
          return;
        }
        if (_this3.addChartData(resp.data)) {
          _this3.timer = setInterval(_this3.loadDecimationSites, 500);
        } else {
          _this3.timer = setInterval(_this3.loadDecimationSites, 10000);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    addChartData: function addChartData(reportData) {
      var _this4 = this;

      var newChartData = reportData.data;
      var limit = reportData.limit[0].lower_limit_timestamp;

      if (newChartData.length == 0) {
        return false;
      }

      var fixedChartData = [];
      this.filterDuctos.forEach(function (x) {
        var ducto = _this4.ductos.find(function (d) {
          return d.id_section === x.id_section;
        });
        var site = ducto.sites.find(function (s) {
          return s.id_site === x.id_site;
        });

        var chartName = ducto.id_section + ' - ' + site.site_name;
        var chartData = newChartData.filter(function (f) {
          return f.id_site === x.id_site && f.id_section === x.id_section;
        });

        var siteChart = {
          name: chartName,
          data: []
        };

        if (chartData && chartData.length > 0) {
          var last = chartData[chartData.length - 1];
          x.report_data_id = last.report_data_id;
          siteChart.data = chartData.map(function (q) {
            return { x: q.report_date, y: 0, real_value: q.data, timestamp: q.timestamp };
          });
        }

        fixedChartData.push(siteChart);
      });

      this.series = this.normalizeData(this.series.filter(function (q) {
        return q.name !== '';
      }), fixedChartData, limit);

      return true;
    },
    normalizeData: function normalizeData(sourceSeries, chartData, limit) {
      chartData.forEach(function (x) {
        var target = sourceSeries.filter(function (q) {
          return q.name == x.name;
        });
        if (target && target.length > 0) {
          target[0].data = target[0].data.concat(x.data);
        } else {
          sourceSeries.push(x);
        }
      });

      sourceSeries.forEach(function (x) {
        x.data = x.data.filter(function (q) {
          return q.timestamp >= limit;
        });

        if (x.data.length > 0) {
          var max = Math.max.apply(Math, x.data.map(function (q) {
            return q.real_value;
          }));
          var min = Math.min.apply(Math, x.data.map(function (q) {
            return q.real_value;
          }));
          var _limit = max - min;
          x.data.forEach(function (q) {
            var y = (q.real_value - min) / _limit * 100;
            q.y = parseFloat(y.toFixed(4));
          });
        }
      });

      return sourceSeries;
    }
  }
});

/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showSidepanel: true,
      ductos: [],
      selectedStations: null,
      selectedDucto: null,
      selectedDateFrom: null,
      selectedDateTo: null,
      filterDuctos: [],
      filterDateFrom: null,
      filterDateTo: null,
      isChartVisible: false,
      isInitialSetup: true,
      isDestroyed: false,
      seriesList: [],
      validation: false,
      desdeText: '',
      hastaText: '',
      intervals: {},
      date: {
        showInfo: {
          hour: true
        },
        startTime: {
          time: ''
        },
        endtime: {}
      },
      dateFrom: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm',
        placeholder: 'Desde',
        color: {
          header: 'var(--date-picker-background-color)',
          headerText: '#fff'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Cancelar'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      dateTo: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm',
        placeholder: 'Hasta',
        color: {
          header: 'var(--date-picker-background-color)',
          headerText: '#fff'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Cancelar'
        },
        overlayOpacity: 0.5,
        dismissible: true },
      chartOptions: {
        noData: {
          text: ''
        },
        chart: {
          type: 'line',
          width: '100%',
          height: '100%',
          responsive: true,
          maintainAspectRatio: false,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          },
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 1.9
        },
        title: {
          text: '',
          align: 'left'
        },
        markers: {
          size: 0
        },
        yaxis: {
          forceNiceScale: true,
          tickAmount: 6,
          logarithmic: false,
          title: {
            text: ''
          },
          max: function max(value) {
            return value * 1.01;
          },
          min: function min(value) {
            return value * 0.99;
          }
        },
        xaxis: {
          type: 'category',
          tickAmount: 4,
          tooltip: {
            enabled: false
          },
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false
          },
          axisTicks: {
            show: true
          }
        }
      }
    };
  },
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a
  },
  computed: {
    filteredStations: function filteredStations() {
      var _this = this;

      if (!this.selectedDucto) {
        return this.ductos;
      }
      return this.ductos.filter(function (q) {
        return q.id_section === _this.selectedDucto.id_section;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this2.ductos = resp;
    }).catch(function (err) {
      console.log(err);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearAllIntervals();
    this.isDestroyed = true;
  },

  methods: {
    validate: function validate(e, d) {
      this[d] = e;
      var max = this.selectedDateTo;
      var min = this.selectedDateFrom;
      if (max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor';
        this.hastaText = 'Este valor debe ser mayor';
        this.validation = false;
      } else {
        this.desdeText = '';
        this.hastaText = '';
        this.validation = true;
      }
    },
    onApplyFilter: function onApplyFilter() {
      this.filterDuctos = this.selectedStations;
      this.filterDateFrom = this.selectedDateFrom;
      this.filterDateTo = this.selectedDateTo;
      this.filterDuctos.forEach(function (q) {
        q.report_data_id = 0;
      });

      this.seriesList = [];

      if (this.filterDuctos.length > 0 && this.filterDateFrom && this.filterDateTo) {
        this.isInitialSetup = false;
        this.showSidepanel = false;
        this.isChartVisible = true;

        this.updateEmptyCharts();

        this.loadDecimationSites();
      }
    },
    updateEmptyCharts: function updateEmptyCharts() {
      var _this3 = this;

      this.seriesList = [];

      this.filterDuctos.forEach(function (x) {
        var ducto = _this3.ductos.find(function (d) {
          return d.id_section === x.id_section;
        });
        var site = ducto.sites.find(function (s) {
          return s.id_site === x.id_site;
        });

        var chartName = ducto.id_section + ' - ' + site.site_name;
        _this3.seriesList.push({
          series: [{
            name: chartName,
            data: []
          }],
          name: chartName,
          options: _this3.chartOptions,
          loading: true,
          error: false
        });
      });
    },
    loadDecimationSites: function loadDecimationSites() {
      if (this.isDestroyed) {
        return;
      }

      for (var i = 0; i < this.filterDuctos.length; i++) {
        var ducto = this.filterDuctos[i];
        this.loadDecimationSite(ducto);
      }
    },
    loadDecimationSite: function loadDecimationSite(ducto) {
      var _this4 = this;

      var chartName = ducto.id_section + ' - ' + ducto.site_name;

      this.clearIntervalForSite(chartName);

      if (this.isDestroyed) {
        return;
      }
      var request = {
        sites: [ducto]
      };
      var sites_json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(request);
      var targetData = this.seriesList.filter(function (q) {
        return q.name === chartName;
      });

      this.$store.dispatch('LOAD_DECIMATION_DATE_RANGE', {
        dateFrom: this.filterDateFrom,
        dateTo: this.filterDateTo,
        sites_json: btoa(sites_json)
      }).then(function (resp) {
        if (_this4.addChartData(resp, ducto, targetData[0])) {
          _this4.setIntervalForSite(chartName, function () {
            return _this4.loadDecimationSite(ducto);
          }, 1000);
        }
      }).catch(function (err) {
        console.log('Error:', err);
        targetData.forEach(function (q) {
          q.loading = false;
          q.error = true;
        });
      });
    },
    addChartData: function addChartData(reportData, ducto, targetData) {
      var chartData = [];

      if (reportData && reportData.data) {
        chartData = reportData.data;
      }
      var wasLoading = targetData.loading;
      targetData.loading = false;
      targetData.error = false;

      var data = [];

      if (chartData && chartData.length > 0) {
        var last = chartData[chartData.length - 1];
        ducto.report_data_id = last.report_data_id;
        data = chartData.map(function (q) {
          return { x: q.report_date, y: q.data, timestamp: q.timestamp };
        });
      }
      console.log('data.length > 0', data.length > 0);

      var index = this.seriesList.indexOf(targetData);

      if (wasLoading && data.length === 0) {
        var chartOptions = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.chartOptions);
        chartOptions.noData.text = 'No hay datos disponibles';
        this.$refs.rows[index].updateOptions(chartOptions);
      } else if (data.length > 0) {
        var series = targetData.series[0];
        series.data = series.data.concat(data);

        this.$refs.rows[index].updateSeries([{
          data: series.data
        }]);
      }

      return data.length > 0;
    },
    setIntervalForSite: function setIntervalForSite(siteId, callback, interval) {
      this.clearIntervalForSite(siteId);
      this.intervals[siteId] = setInterval(callback, interval);
    },
    clearIntervalForSite: function clearIntervalForSite(siteId) {
      if (this.intervals[siteId]) {
        clearInterval(this.intervals[siteId]);
        delete this.intervals[siteId];
      }
    },
    clearAllIntervals: function clearAllIntervals() {
      for (var siteId in this.intervals) {
        clearInterval(this.intervals[siteId]);
      }
      this.intervals = {};
    }
  }
});

/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChartImp_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_groupBy__);






/* harmony default export */ __webpack_exports__["default"] = ({
  'line-chart': __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChartImp_js__["a" /* default */],
  data: function data() {
    return {
      isChartDisplayed: false,
      click: false,
      grouped: [],
      datachart: null,
      data_preassure: [],
      DataPoll: null,
      chartOptions: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: false }
        }
      }
    };
  },

  props: ['duct', 'site', 'desde', 'hasta', 'header', 'showViewColumn', 'chartLimit', 'isDetails', 'datetimeTag'],
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChartImp_js__["a" /* default */]
  },
  computed: {
    logoUrl: function logoUrl() {
      return __webpack_require__(169);
    }
  },
  methods: {
    onAnimationComplete: function onAnimationComplete() {
      this.isChartDisplayed = true;
    },
    open: function open(data) {
      this.$emit('openDetails', data);
    },
    orderbystations: function orderbystations() {
      var full = this.site;
      this.grouped = __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy___default()(full, function (x) {
        return x.namestation;
      });
    },
    filterLettersAndNumbers: function filterLettersAndNumbers(input) {
      var tag = input;
      if (this.datetimeTag) {
        tag += '_' + this.datetimeTag;
      }
      return tag.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
    },
    getChartDataFromSite: function getChartDataFromSite(options) {
      var _this = this;

      var value = options.value;
      var key = options.key;
      var colorlist = '#e74c3c';
      var data = [];
      var labels = [];
      var limit = parseInt(this.chartLimit);
      var startTime = null;
      if (this.datetimeTag) {
        startTime = new Date(this.datetimeTag.replace(/-/g, ' '));
      }

      var _loop = function _loop(i) {
        var record = value.find(function (val) {
          return val.h == i;
        });
        var pressure = record && record.p ? record.p : null;
        if (startTime) {
          var newTime = new Date(startTime);
          newTime.setMinutes(newTime.getMinutes() + i * 10);
          var formattedTime = newTime.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          });
          labels.push(formattedTime);
        } else {
          labels.push(i.toString().padStart(2, '0') + ':50');
        }
        data.push(pressure);
      };

      for (var i = 0; i < limit; i++) {
        _loop(i);
      }

      var datasets = [{
        label: key,
        data: data,
        backgroundColor: colorlist,
        borderColor: colorlist,
        borderWidth: 1,
        pointBorderWidth: 1,
        fill: false,
        pointRadius: 0
      }];
      var chartData = {
        labels: labels,
        datasets: datasets
      };

      setTimeout(function () {
        var siteClass = _this.filterLettersAndNumbers(key);
        var canvasEle = document.querySelector('.' + siteClass + ' #line-chart');
        canvasEle = canvasEle.toDataURL();
        var imgC = document.createElement('img');
        imgC.id = 'chartImg' + siteClass;
        imgC.src = canvasEle;
        imgC.style = 'width:100%;';
        document.querySelector('#imgChart-' + siteClass).innerHTML = '';
        document.querySelector('#imgChart-' + siteClass).appendChild(imgC);
        _this.$store.state.cclick = false;
      }, 500);
      return chartData;
    },
    getChartOptions: function getChartOptions() {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.chartOptions);
      return options;
    }
  },
  watch: {
    site: function site() {
      this.grouped = this.site;
    }
  }
});

/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChartImp_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_groupBy__);






/* harmony default export */ __webpack_exports__["default"] = ({
  'line-chart': __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChartImp_js__["a" /* default */],
  data: function data() {
    return {
      isChartDisplayed: false,
      click: false,
      grouped: [],
      datachart: null,
      data_preassure: [],
      DataPoll: null,
      chartOptions: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: false }
        }
      }
    };
  },

  props: ['duct', 'site', 'desde', 'hasta', 'header', 'showViewColumn', 'chartLimit', 'isDetails', 'datetimeTag'],
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChartImp_js__["a" /* default */]
  },
  computed: {
    logoUrl: function logoUrl() {
      return __webpack_require__(169);
    }
  },
  methods: {
    onAnimationComplete: function onAnimationComplete() {
      this.isChartDisplayed = true;
    },
    open: function open(data) {
      this.$emit('openDetails', data);
    },
    orderbystations: function orderbystations() {
      var full = this.site;
      this.grouped = __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy___default()(full, function (x) {
        return x.namestation;
      });
    },
    filterLettersAndNumbers: function filterLettersAndNumbers(input) {
      var tag = input;
      if (this.datetimeTag) {
        tag += '_' + this.datetimeTag;
      }
      return tag.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
    },
    getChartDataFromSite: function getChartDataFromSite(options) {
      var _this = this;

      var value = options.value;
      var key = options.key;
      var colorlist = '#e74c3c';
      var data = [];
      var labels = [];
      var limit = parseInt(this.chartLimit);
      var startTime = null;
      if (this.datetimeTag) {
        startTime = new Date(this.datetimeTag.replace(/-/g, ' '));
      }

      var _loop = function _loop(i) {
        var record = value.find(function (val) {
          return val.h == i;
        });
        var pressure = record && record.p ? record.p : null;
        if (startTime) {
          var newTime = new Date(startTime);
          newTime.setMinutes(newTime.getMinutes() + i * 10);
          var formattedTime = newTime.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          });
          labels.push(formattedTime);
        } else {
          labels.push(i.toString().padStart(2, '0') + ':50');
        }
        data.push(pressure);
      };

      for (var i = 0; i < limit; i++) {
        _loop(i);
      }

      var datasets = [{
        label: key,
        data: data,
        backgroundColor: colorlist,
        borderColor: colorlist,
        borderWidth: 1,
        pointBorderWidth: 1,
        fill: false,
        pointRadius: 0
      }];
      var chartData = {
        labels: labels,
        datasets: datasets
      };

      setTimeout(function () {
        var siteClass = _this.filterLettersAndNumbers(key);
        var canvasEle = document.querySelector('.' + siteClass + ' #line-chart');
        canvasEle = canvasEle.toDataURL();
        var imgC = document.createElement('img');
        imgC.id = 'chartImg' + siteClass;
        imgC.src = canvasEle;
        imgC.style = 'width:100%;';
        document.querySelector('#imgChart-' + siteClass).innerHTML = '';
        document.querySelector('#imgChart-' + siteClass).appendChild(imgC);
        _this.$store.state.cclick = false;
      }, 500);
      return chartData;
    },
    getChartOptions: function getChartOptions() {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.chartOptions);
      return options;
    }
  },
  watch: {
    site: function site() {
      this.grouped = this.site;
    }
  }
});

/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Reportes_PdfDiv__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Reportes_PdfDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Reportes_PdfDiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_xlsx__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_xlsx__);





var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      datetimeTag: null,
      modalName: 'loading-modal',
      metaInfo: {
        meta: [{ charset: 'utf-8' }, { name: 'viewport', content: 'initial-scale = 1.0,maximum-scale = 1.0' }]
      },
      info: {
        modalName: this.modalName
      },
      storedData: {},
      data: null,
      pushdates: [],
      lastDate: '',
      ductsender: '',
      sitePdf: null,
      siteDetailsPdf: null,
      showDetails: false,
      estacionesOps: '',
      kmFrom: 0,
      kmTo: 10000,
      objDucto: [],
      desde: '',
      hasta: '',
      ductos: [],
      section: {},
      ducto: null,
      currDucto: '',
      desdeText: '',
      hastaText: '',
      ductoSelected: null,
      ductoNameSelected: null,
      validation: false,
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde
    };
  },

  methods: {
    openDetails: function openDetails(data) {
      var _this = this;

      var key = this.ductoSelected + document.querySelector('#estacion').value.padStart(2, '0') + '_' + data.i_ts;

      if (this.storedData[key]) {
        this.siteDetailsPdf = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, key, this.storedData[key]);
        this.showDetails = true;
        return;
      }

      this.loading();
      this.showDetails = false;

      this.$store.dispatch('LOAD_REPORTE_POOL_DETAILS', {
        desde: data.i_ts,
        ducto: this.ductoSelected,
        estacion: document.querySelector('#estacion').value
      }).then(function (resp) {
        _this.loading();
        if (resp.data.length === 0) {
          __WEBPACK_IMPORTED_MODULE_6_toastr___default.a.error('No se encontró información');
          return;
        }
        var sitename = '' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.data[_this.lastDate])[0].trim();

        _this.storedData[key] = resp.data;
        _this.datetimeTag = data.i_ts;

        _this.siteDetailsPdf = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, sitename, resp.data);
        _this.showDetails = true;
      }).catch(function (err) {
        _this.loading();
        __WEBPACK_IMPORTED_MODULE_6_toastr___default.a.error('No se encontró información');
        console.log('Error', err);
        _this.showDetails = false;
      });
    },
    loading: function loading() {
      document.querySelector('#loading-btn-chart2').click();
    },
    imgUrl: function imgUrl(url) {
      return __webpack_require__(763)("" + url);
    },
    getStyleColor: function getStyleColor(name) {
      var rootStyles = getComputedStyle(document.documentElement);
      var btnDefaultColor = rootStyles.getPropertyValue(name).trim();
      return btnDefaultColor;
    },
    showReport: function showReport() {
      this.showDetails = false;
    },
    Popup: function Popup() {
      if (!this.sitePdf) {
        return;
      }
      var btnColor = this.getStyleColor('--btn-default');
      var divToPrint = document.querySelector('.panel-body-two').innerHTML;
      var mywindow = window.open('', 'Print-Window', 'height=600,width=1100');
      mywindow.document.write('\n        <html><head><title>Print</title>\n        <link href="https://fonts.googleapis.com/css?family=Roboto:300,400" rel="stylesheet">\n        <style>\n          .mydiv{\n          background-color:#fff;\n          font-family: \'Roboto\', sans-serif;\n          }\n          .mydiv div#pdf{\n            max-height:200px;\n            height:200px;\n          }\n          .mydiv div#linechart{\n            display:none;\n          }\n          .mydiv img#leak{\n              display:inline-block;\n              width:115px;\n            }\n          .mydiv img#pem{\n              padding-left: 400px;\n              display:inline-block;\n              width:115px;\n            }\n          .mydiv h4#h41{\n              font-size:20px;\n              font-weight:400;\n              text-transform: uppercase;\n              padding:0;\n              margin-top:10px;\n              margin-bottom:10px;\n            }\n          .mydiv hr#hr1{\n              \tbackground-color: #fff;\n\t              border-top: 2px solid ' + btnColor + ';\n            }\n          .mydiv span#titles{\n            color: ' + btnColor + ';\n            text-transform: uppercase;\n            margin-left:4px;\n          }\n          .mydiv table#tableholder{\n            height: 50%;\n            width:100%;\n            margin:0;\n          }\n          .mydiv thead#header{\n             width:100%;\n             padding:2px;\n             background-color: ' + btnColor + ';\n          }\n           .mydiv tr#trh{\n             width:100%;\n             padding:2px;\n             background-color: ' + btnColor + ';\n          }\n          .mydiv th#thh{\n            font-size:12px;\n            align:left;\n            font-weight:400;\n            padding:4px;\n            border: 1.5px solid ' + btnColor + ';\n            color: white;\n            background-color: ' + btnColor + ';\n          }\n          .mydiv td#tdc{\n            font-size:10px;\n            font-weight:200;\n            text-align:center;\n            padding:2px;\n            border: 0px;\n          }\n          .highlight {\n            color: red;\n          }\n          @media print {\n            .mydiv th#thh {\n              background-color: ' + btnColor + ' !important;\n              color: black !important;\n            }\n            .mydiv tr#trh {\n              background-color: ' + btnColor + ' !important;\n            }\n            .mydiv thead#header {\n              background-color: ' + btnColor + ' !important;\n            }\n              .print-hidden {\n                display: none;\n              }\n          }\n        </style>\n        </head>\n        <body onload="window.print()">\n          <div class="mydiv"> ' + divToPrint + ' </div>\n        </body>\n        </html>\n      ');
      mywindow.document.close();
      setTimeout(function () {
        return mywindow.close();
      }, 200);
      return true;
    },
    validate: function validate(e, d) {
      this[d] = e;
      var max = this.hasta;
      var min = this.desde;
      if (max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor';
        this.hastaText = 'Este valor debe ser mayor';
        this.validation = false;
      } else {
        this.desdeText = '';
        this.hastaText = '';
        this.validation = true;
      }
    },
    changeSelected: function changeSelected() {
      var selectElement = document.querySelector('#ducto');
      var selectedIndex = selectElement.selectedIndex;
      var selectedOption = selectElement.options[selectedIndex];
      this.ductoNameSelected = selectedOption.text;
      this.ductoSelected = selectElement.value;
      this.estacionesOps = this.$store.getters.GET_OP({
        filteredBy: 'sites',
        ducto: this.ductoSelected
      });
    },
    formatDate: function formatDate() {
      var date = new Date().toLocaleString('es-US', {
        hour12: false
      }).split(' ');

      var time = date[1];
      var mdy = date[0].split('/');
      var month = parseInt(mdy[0]);
      var day = parseInt(mdy[1]);
      var year = parseInt(mdy[2]);
      return year + '-' + day + '-' + month + ' ' + time;
    },
    submitInfo: function submitInfo() {
      var _this2 = this;

      this.loading();
      this.storedData = {};
      if (!this.hasta) {
        this.hasta = this.formatDate();
      }
      this.showDetails = false;

      if (this.desde && this.ductoSelected && this.validation === true) {
        this.$store.dispatch('LOAD_REPORTE_POLL', {
          desde: this.desde,
          hasta: this.hasta,
          ducto: this.ductoSelected,
          estacion: document.querySelector('#estacion').value,
          kmFrom: this.kmFrom,
          kmTo: this.kmTo
        }).then(function (resp) {
          _this2.sitePdf = null;
          _this2.loading();
          if (resp.data.length === 0) {
            __WEBPACK_IMPORTED_MODULE_6_toastr___default.a.error('No se encontró información');
            return;
          }
          _this2.data = resp.data;
        }).catch(function (err) {
          _this2.loading();
          __WEBPACK_IMPORTED_MODULE_6_toastr___default.a.error('No se encontró información');
          console.log('Error', err);
        });
      } else {
        this.loading();
      }
    },
    identifyContinousPressure: function identifyContinousPressure(array) {
      var count = 0;
      var markSamePressure = [];
      var result = array.map(function (item, index) {
        if (index > 0 && item.p === array[index - 1].p) {
          count++;
        } else {
          count = 1;
        }

        if (count >= 2) {
          if (!array[index - 1].samePressure) {
            markSamePressure.push(index - 1);
          }
          markSamePressure.push(index);
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { samePressure: false, groupStart: '', groupEnd: '' });
      });

      markSamePressure.forEach(function (index) {
        result[index].samePressure = true;
      });

      return result;
    },
    open: function open(date) {
      this.showDetails = false;
      this.lastDate = date;
      this.ductsender = this.ductoSelected;
      var sitename = '' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data[date])[0].trim();
      var arrayData = this.data[date][sitename];
      var pdfData = this.identifyContinousPressure(arrayData);
      this.sitePdf = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, sitename, pdfData);
    },
    pdfName: function pdfName(date) {
      var sitename = '' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data[date])[0].trim();
      sitename = sitename.replace(/[^a-zA-Z0-9]/g, '_');
      return date.replaceAll('-', '_').replaceAll('__', '_') + '_' + sitename;
    },
    downloadExcel: function downloadExcel(date) {
      var selectedStation = document.querySelector('#estacion').value;
      var sitename = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data[date])[0];
      var pageName = this.ductoSelected + selectedStation.padStart(2, '0') + '_' + date;
      var excelName = this.pdfName(date);
      var arrayData = this.data[date][sitename];
      var excelData = arrayData.map(function (item) {
        return {
          'Fecha de Solicitud': item.r_ts,
          'Mensaje': item.r_f,
          'Fecha de Recepción': item.i_ts,
          'Presión': item.p
        };
      });

      var worksheet = __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].json_to_sheet(excelData);
      var workbook = __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].book_new();
      __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].book_append_sheet(workbook, worksheet, pageName);

      var fileName = excelName + '.xlsx';

      __WEBPACK_IMPORTED_MODULE_7_xlsx__["writeFile"](workbook, fileName);
    },
    downloadCSV: function downloadCSV(date) {
      var sitename = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data[date])[0];
      var csvName = this.pdfName(date);
      var arrayData = this.data[date][sitename];
      var csvData = arrayData.map(function (item) {
        return {
          'Fecha de Solicitud': item.r_ts,
          'Mensaje': item.r_f,
          'Fecha de Recepción': item.i_ts,
          'Presión': item.p
        };
      });

      var worksheet = __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].json_to_sheet(csvData);
      var csv = __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].sheet_to_csv(worksheet);

      var bom = '\uFEFF';
      var blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = csvName + '.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  components: {
    SelectC: __WEBPACK_IMPORTED_MODULE_3_reusable_Select___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue___default.a,
    PdfDiv: __WEBPACK_IMPORTED_MODULE_5_components_Reportes_PdfDiv___default.a,
    Modal: Modal,
    LoadingModal: LoadingModal
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this3.ductos = _this3.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    }).catch(function (err) {
      console.log('Error', err);
    });
  }
});

/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raphael_raphael__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raphael_raphael___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raphael_raphael__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_morris__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_morris___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_morris__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue__);




global.Raphael = __WEBPACK_IMPORTED_MODULE_1_raphael_raphael___default.a;


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde,
      ductos: [],
      estaciones: [],
      desde: '',
      hasta: '',
      options: {
        op1: {
          value: '2pm',
          name: '2:00 pm'
        },
        op2: {
          value: '2am',
          name: '2:00 am'
        },
        op3: {
          value: 'all',
          name: 'All'
        }
      },
      line: [{
        year: '2013',
        and: 30,
        ios: 10,
        win: 5
      }, {
        year: '2014',
        and: 20,
        ios: 40,
        win: 15
      }, {
        year: '2015',
        and: 30,
        ios: 20,
        win: 25
      }, {
        year: '2016',
        and: 50,
        ios: 30,
        win: 20
      }]
    };
  },

  methods: {
    setEstaciones: function setEstaciones(e) {
      this.estaciones = this.$store.getters.GET_OP({
        filteredBy: 'sites',
        ducto: document.querySelector('#' + e).value
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this.ductos = _this.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    }).catch(function (err) {
      console.log(err);
    });
  },

  components: {
    selectC: __WEBPACK_IMPORTED_MODULE_0_components_reusable_Select___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_2_vue_morris__["LineChart"],
    DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue_datepicker_vue_datepicker_es6_vue___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Reportes_PdfPressureDiv__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Reportes_PdfPressureDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Reportes_PdfPressureDiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_xlsx__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_xlsx__);





var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      datetimeTag: null,
      modalName: 'loading-modal',
      metaInfo: {
        meta: [{ charset: 'utf-8' }, { name: 'viewport', content: 'initial-scale = 1.0,maximum-scale = 1.0' }]
      },
      info: {
        modalName: this.modalName
      },
      storedData: {},
      data: null,
      pushdates: [],
      lastDate: '',
      ductsender: '',
      sitePdf: null,
      siteDetailsPdf: null,
      showDetails: false,
      estacionesOps: '',
      kmFrom: 0,
      kmTo: 10000,
      objDucto: [],
      desde: '',
      hasta: '',
      ductos: [],
      section: {},
      ducto: null,
      currDucto: '',
      desdeText: '',
      hastaText: '',
      ductoSelected: null,
      ductoNameSelected: null,
      validation: false,
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde
    };
  },

  methods: {
    openDetails: function openDetails(data) {
      var _this = this;

      var key = this.ductoSelected + document.querySelector('#estacion').value.padStart(2, '0') + '_' + data.i_ts;

      if (this.storedData[key]) {
        this.siteDetailsPdf = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, key, this.storedData[key]);
        this.showDetails = true;
        return;
      }

      this.loading();
      this.showDetails = false;

      this.$store.dispatch('LOAD_REPORTE_PRESSURE_DETAILS', {
        desde: data.i_ts,
        ducto: this.ductoSelected,
        estacion: document.querySelector('#estacion').value
      }).then(function (resp) {
        _this.loading();
        if (resp.data.length === 0) {
          __WEBPACK_IMPORTED_MODULE_6_toastr___default.a.error('No se encontró información');
          return;
        }
        var sitename = '' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.data[_this.lastDate])[0].trim();

        _this.storedData[key] = resp.data;
        _this.datetimeTag = data.i_ts;

        _this.siteDetailsPdf = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, sitename, resp.data);
        _this.showDetails = true;
      }).catch(function (err) {
        _this.loading();
        __WEBPACK_IMPORTED_MODULE_6_toastr___default.a.error('No se encontró información');
        console.log('Error', err);
        _this.showDetails = false;
      });
    },
    loading: function loading() {
      document.querySelector('#loading-btn-chart2').click();
    },
    imgUrl: function imgUrl(url) {
      return __webpack_require__(763)("" + url);
    },
    getStyleColor: function getStyleColor(name) {
      var rootStyles = getComputedStyle(document.documentElement);
      var btnDefaultColor = rootStyles.getPropertyValue(name).trim();
      return btnDefaultColor;
    },
    showReport: function showReport() {
      this.showDetails = false;
    },
    Popup: function Popup() {
      if (!this.sitePdf) {
        return;
      }
      var btnColor = this.getStyleColor('--btn-default');
      var divToPrint = document.querySelector('.panel-body-two').innerHTML;
      var mywindow = window.open('', 'Print-Window', 'height=600,width=1100');
      mywindow.document.write('\n        <html><head><title>Print</title>\n        <link href="https://fonts.googleapis.com/css?family=Roboto:300,400" rel="stylesheet">\n        <style>\n          .mydiv{\n          background-color:#fff;\n          font-family: \'Roboto\', sans-serif;\n          }\n          .mydiv div#pdf{\n            max-height:200px;\n            height:200px;\n          }\n          .mydiv div#linechart{\n            display:none;\n          }\n          .mydiv img#leak{\n              display:inline-block;\n              width:115px;\n            }\n          .mydiv img#pem{\n              padding-left: 400px;\n              display:inline-block;\n              width:115px;\n            }\n          .mydiv h4#h41{\n              font-size:20px;\n              font-weight:400;\n              text-transform: uppercase;\n              padding:0;\n              margin-top:10px;\n              margin-bottom:10px;\n            }\n          .mydiv hr#hr1{\n              \tbackground-color: #fff;\n\t              border-top: 2px solid ' + btnColor + ';\n            }\n          .mydiv span#titles{\n            color: ' + btnColor + ';\n            text-transform: uppercase;\n            margin-left:4px;\n          }\n          .mydiv table#tableholder{\n            height: 50%;\n            width:100%;\n            margin:0;\n          }\n          .mydiv thead#header{\n             width:100%;\n             padding:2px;\n             background-color: ' + btnColor + ';\n          }\n           .mydiv tr#trh{\n             width:100%;\n             padding:2px;\n             background-color: ' + btnColor + ';\n          }\n          .mydiv th#thh{\n            font-size:12px;\n            align:left;\n            font-weight:400;\n            padding:4px;\n            border: 1.5px solid ' + btnColor + ';\n            color: white;\n            background-color: ' + btnColor + ';\n          }\n          .mydiv td#tdc{\n            font-size:10px;\n            font-weight:200;\n            text-align:center;\n            padding:2px;\n            border: 0px;\n          }\n          .highlight {\n            color: red;\n          }\n          @media print {\n            .mydiv th#thh {\n              background-color: ' + btnColor + ' !important;\n              color: black !important;\n            }\n            .mydiv tr#trh {\n              background-color: ' + btnColor + ' !important;\n            }\n            .mydiv thead#header {\n              background-color: ' + btnColor + ' !important;\n            }\n              .print-hidden {\n                display: none;\n              }\n          }\n        </style>\n        </head>\n        <body onload="window.print()">\n          <div class="mydiv"> ' + divToPrint + ' </div>\n        </body>\n        </html>\n      ');
      mywindow.document.close();
      setTimeout(function () {
        return mywindow.close();
      }, 200);
      return true;
    },
    validate: function validate(e, d) {
      this[d] = e;
      var max = this.hasta;
      var min = this.desde;
      if (max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor';
        this.hastaText = 'Este valor debe ser mayor';
        this.validation = false;
      } else {
        this.desdeText = '';
        this.hastaText = '';
        this.validation = true;
      }
    },
    changeSelected: function changeSelected() {
      var selectElement = document.querySelector('#ducto');
      var selectedIndex = selectElement.selectedIndex;
      var selectedOption = selectElement.options[selectedIndex];
      this.ductoNameSelected = selectedOption.text;
      this.ductoSelected = selectElement.value;
      this.estacionesOps = this.$store.getters.GET_OP({
        filteredBy: 'sites',
        ducto: this.ductoSelected
      });
    },
    formatDate: function formatDate() {
      var date = new Date().toLocaleString('es-US', {
        hour12: false
      }).split(' ');

      var time = date[1];
      var mdy = date[0].split('/');
      var month = parseInt(mdy[0]);
      var day = parseInt(mdy[1]);
      var year = parseInt(mdy[2]);
      return year + '-' + day + '-' + month + ' ' + time;
    },
    submitInfo: function submitInfo() {
      var _this2 = this;

      this.loading();
      this.storedData = {};
      if (!this.hasta) {
        this.hasta = this.formatDate();
      }
      this.showDetails = false;

      if (this.desde && this.ductoSelected && this.validation === true) {
        this.$store.dispatch('LOAD_REPORTE_PRESSURE', {
          desde: this.desde,
          hasta: this.hasta,
          ducto: this.ductoSelected,
          estacion: document.querySelector('#estacion').value,
          kmFrom: this.kmFrom,
          kmTo: this.kmTo
        }).then(function (resp) {
          _this2.sitePdf = null;
          _this2.loading();
          if (resp.data.length === 0) {
            __WEBPACK_IMPORTED_MODULE_6_toastr___default.a.error('No se encontró información');
            return;
          }
          _this2.data = resp.data;
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_6_toastr___default.a.error('No se encontró información');
          console.log('Error', err);
        });
      } else {
        this.loading();
      }
    },
    identifyContinousPressure: function identifyContinousPressure(array) {
      var count = 0;
      var markSamePressure = [];
      var result = array.map(function (item, index) {
        if (index > 0 && item.p === array[index - 1].p) {
          count++;
        } else {
          count = 1;
        }

        if (count >= 2) {
          if (!array[index - 1].samePressure) {
            markSamePressure.push(index - 1);
          }
          markSamePressure.push(index);
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { samePressure: false, groupStart: '', groupEnd: '' });
      });

      markSamePressure.forEach(function (index) {
        result[index].samePressure = true;
      });

      return result;
    },
    open: function open(date) {
      this.showDetails = false;
      this.lastDate = date;
      this.ductsender = this.ductoSelected;
      var sitename = '' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data[date])[0].trim();
      var arrayData = this.data[date][sitename];
      var pdfData = this.identifyContinousPressure(arrayData);
      this.sitePdf = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, sitename, pdfData);
    },
    pdfName: function pdfName(date) {
      var sitename = '' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data[date])[0].trim();
      sitename = sitename.replace(/[^a-zA-Z0-9]/g, '_');
      return date.replaceAll('-', '_').replaceAll('__', '_') + '_' + sitename;
    },
    downloadExcel: function downloadExcel(date) {
      var selectedStation = document.querySelector('#estacion').value;
      var sitename = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data[date])[0];
      var pageName = this.ductoSelected + selectedStation.padStart(2, '0') + '_' + date;
      var excelName = this.pdfName(date);
      var arrayData = this.data[date][sitename];
      var excelData = arrayData.map(function (item) {
        return {
          'Fecha de Solicitud': item.i_ts,
          'Latitud': item.lat,
          'Longitud': item.lon,
          'Presión': item.p
        };
      });

      var worksheet = __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].json_to_sheet(excelData);
      var workbook = __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].book_new();
      __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].book_append_sheet(workbook, worksheet, pageName);

      var fileName = excelName + '.xlsx';

      __WEBPACK_IMPORTED_MODULE_7_xlsx__["writeFile"](workbook, fileName);
    },
    downloadCSV: function downloadCSV(date) {
      var sitename = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data[date])[0];
      var csvName = this.pdfName(date);
      var arrayData = this.data[date][sitename];
      var csvData = arrayData.map(function (item) {
        return {
          'Fecha de Solicitud': item.i_ts,
          'Latitud': item.lat,
          'Longitud': item.lon,
          'Presión': item.p
        };
      });

      var worksheet = __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].json_to_sheet(csvData);
      var csv = __WEBPACK_IMPORTED_MODULE_7_xlsx__["utils"].sheet_to_csv(worksheet);

      var bom = '\uFEFF';
      var blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = csvName + '.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  components: {
    SelectC: __WEBPACK_IMPORTED_MODULE_3_reusable_Select___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_4_vue_datepicker_vue_datepicker_es6_vue___default.a,
    PdfPressureDiv: __WEBPACK_IMPORTED_MODULE_5_components_Reportes_PdfPressureDiv___default.a,
    Modal: Modal,
    LoadingModal: LoadingModal
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this3.ductos = _this3.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    }).catch(function (err) {
      console.log('Error', err);
    });
  }
});

/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_0_vue_datepicker_vue_datepicker_es6_vue___default.a,
    SelectC: __WEBPACK_IMPORTED_MODULE_1_reusable_Select___default.a
  },
  data: function data() {
    return {
      selectedDate: {
        showInfo: {
          hour: false
        },
        startTime: {
          time: ''
        }
      },
      selectedDucto: null,
      ductos: [],
      pdfUrl: '',
      pdfData: null,
      loading: false,
      disabledDates: [{
        type: 'fromto',
        to: this.getPreviousDay()
      }],
      datePickerOptions: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'Seleccione un dia',
        inputStyle: {
          'padding-top': '14px',
          'border-bottom': '2px solid #aaa',
          'color': 'black'
        },
        color: {
          header: 'var(--date-picker-background-color)',
          headerText: '#fff'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Cancelar'
        },
        dismissible: true
      }
    };
  },

  methods: {
    getPreviousDay: function getPreviousDay() {
      var today = new Date();
      today.setDate(today.getDate() - 1);
      return today;
    },
    handleDateChange: function handleDateChange(date) {
      this.selectedDate = this.formatDate(date);
    },
    formatDate: function formatDate(date) {
      var d = new Date(date);
      var day = String(d.getDate()).padStart(2, '0');
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var year = d.getFullYear();
      return year + '-' + month + '-' + day;
    },
    fetchPdf: function fetchPdf() {
      var _this = this;

      this.loading = true;
      this.pdfUrl = '';
      var date = this.selectedDate.time || this.formatDate(new Date());
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://api.ductos-gaes.com/" + 'reports?date=' + date + '&section=' + this.selectedDucto, {
        responseType: 'blob' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        _this.pdfUrl = URL.createObjectURL(blob);
        _this.pdfData = blob;
        _this.loading = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('No se encontró información');
        _this.loading = false;
      });
    },
    printPdf: function printPdf() {
      var iframe = document.querySelector('iframe');
      if (iframe) {
        iframe.contentWindow.print();
      }
    },
    savePdf: function savePdf() {
      if (this.pdfData) {
        var link = document.createElement('a');
        link.href = URL.createObjectURL(this.pdfData);
        link.download = 'report_' + this.selectedDate + '_' + this.selectedDucto + '.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } else {
        __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('No se encontró información');
      }
    },
    onSelectedValue: function onSelectedValue(value) {
      this.selectedDucto = value;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this2.ductos = _this2.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    }).catch(function (err) {
      console.log('Error', err);
    });
  }
});

/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);




var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {
        modalName: 'loading-modal'
      },
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsFecha,
      desde: '',
      estaciones: [],
      estacionesOps: '',
      hasta: '',
      ductos: null
    };
  },

  methods: {
    chooseEstacion: function chooseEstacion() {
      this.estacionesOps = this.$store.getters.GET_OP({
        filteredBy: 'sites',
        ducto: document.querySelector('#ducto').value
      });
    },
    loading: function loading() {
      document.querySelector('#loading-btn').click();
    },
    actualizar: function actualizar() {
      var _this = this;

      this.loading();
      if (this.desde === '') {
        this.desde = new Date().toLocaleString().split(',');
        this.desde = this.desde[0] + ' 00:00';
      }
      this.hasta = this.desde.split(' ')[0];
      this.hasta += ' 23:59';

      this.$store.dispatch('LOAD_PRESION', {
        lastTimestamp: -1,
        ducto: document.querySelector('#ducto').value,
        estacion: document.querySelector('#estacion').value,
        desde: this.desde || null,
        hasta: this.hasta || null
      }).then(function (resp) {
        if (resp === 'no-data') {
          __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('No se encontró información');
        } else {
          _this.estaciones = [];
          resp.data.forEach(function (r) {
            _this.estaciones.push({
              date: r.formated_date,
              pres: r.pressure
            });
          });
        }
        _this.loading();
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  components: {
    SelectC: __WEBPACK_IMPORTED_MODULE_0_reusable_Select___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_1_vue_datepicker_vue_datepicker_es6_vue___default.a,
    Modal: Modal,
    LoadingModal: LoadingModal
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch('LOAD_OPS').then(function (resp) {
      _this2.ductos = _this2.$store.getters.GET_OP({
        filteredBy: 'section_name'
      });
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),

/***/ 843:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reusable_Select__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      siteData: [],
      ductos: [],
      selectedDucto: null,
      timer: null
    };
  },

  components: {
    CustomSelect: __WEBPACK_IMPORTED_MODULE_1_reusable_Select___default.a
  },
  methods: {
    fillSite: function fillSite() {
      var _this = this;

      this.siteData = [];
      var ducts = this.$store.getters.GET_HOME_DUCTOS_TABLE;
      if (!ducts) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ducts).forEach(function (idSection) {
        var section = ducts[idSection];
        if (!_this.ductos.find(function (d) {
          return d.value == section.id;
        })) {
          _this.ductos.push({ name: section.name, value: section.id });
        }
        if (_this.selectedDucto == null || _this.selectedDucto == section.id) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(section.sites).forEach(function (idSite) {
            var site = section.sites[idSite];
            _this.siteData.push({ section: section, site: site });
          });
        }
      });
    },
    loadHealth: function loadHealth() {
      var _this2 = this;

      this.$store.dispatch('LOAD_DUCTOS').then(function () {
        _this2.fillSite();
      });
    },
    siteClick: function siteClick(site) {
      var section_id = site.section_id;
      var site_id = site.site_id;

      var routeUrl = this.$router.resolve({
        path: '/sitio/' + section_id + '/' + site_id
      });
      window.open(routeUrl.href, '_blank');

      return false;
    },
    selectedDuctoEvent: function selectedDuctoEvent(e) {
      var d = document.querySelector('#' + e);
      this.selectedDucto = d.value;
      this.fillSite();
    }
  },
  created: function created() {
    this.loadHealth();
    this.timer = setInterval(this.loadHealth, 150000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
});

/***/ }),

/***/ 844:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var $ = __webpack_require__(54);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      section: null,
      site: -1,
      site_info: null,
      map_link: '',
      isEmpty: false,
      isChartVisible: true,
      last_report_data_id: -1,
      timer: null,
      reportData: [],
      pressure: '',
      last_update: '',
      series: [{
        name: '',
        data: []
      }],
      chartOptions: {
        noData: {
          text: 'Cargando...'
        },
        chart: {
          type: 'line',
          width: '100%',
          height: 'auto',
          zoom: {
            type: 'x',
            enabled: false
          },
          toolbar: {
            autoSelected: 'zoom'
          },
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 1.9
        },
        title: {
          text: '',
          align: 'left'
        },
        markers: {
          size: 0
        },
        theme: {
          monochrome: {
            enabled: true,
            color: '#1976bc',
            shadeTo: 'dark',
            shadeIntensity: 0.65
          }
        },
        yaxis: {
          forceNiceScale: true,
          tickAmount: 6,
          logarithmic: true,
          title: {
            text: ''
          }
        },
        xaxis: {
          type: 'category',
          tickAmount: 4,
          tooltip: {
            enabled: false
          },
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false
          },
          axisTicks: {
            show: true
          }
        }
      }
    };
  },

  methods: {
    loadDecimation: function loadDecimation() {
      var _this = this;

      this.$store.dispatch('LOAD_DECIMATION', {
        section: this.section,
        site: this.site
      }).then(function (resp) {
        if (resp.data === null || resp.data.length === 0) {
          _this.isEmpty = true;
          _this.isChartVisible = false;
          return;
        }
        var size = resp.data.length;
        _this.last_report_data_id = resp.data[size - 1].report_data_id;

        var chartData = resp.data.map(function (q) {
          return { x: q.report_date, y: q.data };
        });
        _this.addChartData(chartData);
        _this.timer = setInterval(_this.loadDecimationStep, 500);
      });
    },
    loadDecimationStep: function loadDecimationStep() {
      var _this2 = this;

      clearInterval(this.timer);
      this.$store.dispatch('LOAD_DECIMATION_STEP', {
        section: this.section,
        site: this.site,
        report_data_id: this.last_report_data_id
      }).then(function (resp) {
        if (resp.data === null || resp.data.length === 0) {
          _this2.timer = setInterval(_this2.loadDecimationStep, 30000);
          return;
        }
        var size = resp.data.length;
        _this2.last_report_data_id = resp.data[size - 1].report_data_id;

        var chartData = resp.data.map(function (q) {
          return { x: q.report_date, y: q.data };
        });
        _this2.addChartData(chartData);
        _this2.timer = setInterval(_this2.loadDecimationStep, 500);
      });
    },
    addChartData: function addChartData(newChartData) {
      this.reportData = this.reportData.concat(newChartData);


      if (this.reportData.length > 2400) {
        this.reportData = this.reportData.slice(200, this.reportData.length);
      }

      var last = this.reportData[this.reportData.length - 1];

      this.last_update = last.x;
      this.pressure = last.y;

      this.series = [{
        data: this.reportData
      }];
    }
  },
  created: function created() {
    var _this3 = this;

    this.section = this.$route.params.section;
    this.site = this.$route.params.site;

    this.$store.dispatch('LOAD_SITE_INFO', { section: this.section, site: this.site }).then(function (resp) {
      _this3.site_info = resp.data[0];

      _this3.map_link = 'https://maps.google.com?q=' + _this3.site_info.site_lat + ',' + _this3.site_info.site_lon;
      _this3.chartOptions.title.text = 'PRESION DUCTO ' + _this3.site_info.section_name + ' ' + _this3.site_info.site_name;
      _this3.loadDecimation();
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
});

/***/ }),

/***/ 845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '401 No autorizado',
      description: 'Usuario no autorizado para acceder a esta pagina'
    };
  },

  watch: {},
  methods: {
    goBack: function goBack() {
      this.$router.go(-2);
    }
  }
});

/***/ }),

/***/ 846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raphael_raphael__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raphael_raphael___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raphael_raphael__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_morris__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_morris___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_morris__);






global.Raphael = __WEBPACK_IMPORTED_MODULE_3_raphael_raphael___default.a;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      alarmType: '',
      options: {
        op1: {
          value: '2pm',
          name: '2:00 pm'
        },
        op2: {
          value: '2am',
          name: '2:00 am'
        },
        op3: {
          value: 'all',
          name: 'All'
        }
      },
      line: [{ year: '2013', and: 30, ios: 10, win: 5 }, { year: '2014', and: 20, ios: 40, win: 15 }, { year: '2015', and: 30, ios: 20, win: 25 }, { year: '2016', and: 50, ios: 30, win: 20 }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    type1: 'alarmType1'
  })),
  components: {
    selectC: __WEBPACK_IMPORTED_MODULE_1_components_reusable_Select___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_4_vue_morris__["LineChart"]
  },
  mounted: function mounted() {
    this.alarmType = this.type1;
    $('#map-div').css('z-index', '0');
    $('#example_id').ionRangeSlider({
      min: 0,
      max: 10000,
      from: 1000,
      to: 9000,
      type: 'double',
      prefix: 'KM ',
      grid: true,
      grid_num: 2
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),

/***/ 847:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Modal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reusable_Modal__);




var CambiarContra = function CambiarContra() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1827));
};
var Ayuda = function Ayuda() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1829));
};
var Changelog = function Changelog() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1828));
};
var RegistrarUsuario = function RegistrarUsuario() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1830));
};
var ActualizarUsuario = function ActualizarUsuario() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1826));
};
var $ = __webpack_require__(54);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menu: [],
      collapsed: true,
      showChangePass: false,
      section: 'Monitorea Ducto',
      appSections: {
        DASHBOARD: 'DASHBOARD',
        HISTORIC_ALARM: 'HISTORIC_ALARM',
        HISTORIC_REPORT: 'HISTORIC_REPORT',
        PRESION: 'PRESION',
        BINNACLE: 'BINNACLE',
        CAMP: 'CAMP',
        DIR_GENERAL: 'DIR_GENERAL',
        DIR_TREND: 'DIR_TREND',
        REPORT_POLL: 'REPORT_POLL',
        REPORT_TABLE_POLL: 'REPORT_TABLE_POLL',
        MONITOR: 'MONITOR',
        HELP: 'HELP',
        WEB_RELEASE: 'WEB_RELEASE',
        USER_REGISTER: 'USER_REGISTER',
        HEALTH: 'HEALTH'
      }
    };
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0_reusable_Modal___default.a,
    CambiarContra: CambiarContra,
    Ayuda: Ayuda,
    Changelog: Changelog,
    RegistrarUsuario: RegistrarUsuario,
    ActualizarUsuario: ActualizarUsuario
  },
  computed: {
    isAdmin: function isAdmin() {
      var user = this.$store.state.user;
      return user && user.accessLevel && user.accessLevel === this.$store.state.AccessLevel.Admin;
    },
    getUserName: function getUserName() {
      return this.$store.state.user.name.split(' ')[0];
    },
    logoUrl: function logoUrl() {
      return __webpack_require__(734);
    },
    logoUrlIcon: function logoUrlIcon() {
      return __webpack_require__(733);
    }
  },
  methods: {
    userHasAccess: function userHasAccess(appSection) {
      var user = this.$store.state.user;
      var permissions = user && user.permissions;
      var permission = permissions && permissions.find(function (x) {
        return x.appSection == appSection;
      });
      return permission && (permission.permAdmin || permission.permRead);
    },
    onToggleCollapse: function onToggleCollapse(collapsed) {
      this.collapsed = collapsed;
    },
    menuBtnClick: function menuBtnClick() {
      return false;
    },
    onItemClick: function onItemClick(event, item, node) {
      if (item.to === 'logout') {
        this.$store.dispatch('logout');
      } else if (item.to === 'change-pass') {
        this.$refs.changePassBtn.click();
      } else if (item.to === 'register-user' && this.isAdmin) {
        this.$refs.registerUserBtn.click();
      } else if (item.to === 'update-user' && this.isAdmin) {
        this.$refs.updateUserBtn.click();
      } else if (item.to === 'ayuda') {
        this.$refs.helpBtn.click();
      }
    },
    loadMenu: function loadMenu() {
      var mainSubeMenu = [{
        title: 'Cerrar Sesión',
        to: 'logout',
        icon: 'fa fa-sign-out'
      }, {
        title: 'Cambiar Contraseña',
        to: 'change-pass',
        icon: 'fa fa-lock'
      }];

      if (this.userHasAccess(this.appSections.USER_REGISTER)) {
        mainSubeMenu.push({
          title: 'Registrar Usuario',
          to: 'register-user',
          icon: 'fa fa-user-plus'
        });
        mainSubeMenu.push({
          title: 'Actualizar Usuario',
          to: 'update-user',
          icon: 'fa fa-user'
        });
      }

      this.menu.push({
        title: 'Opciones',
        icon: 'fa fa-user',
        child: mainSubeMenu
      });

      if (this.userHasAccess(this.appSections.DASHBOARD)) {
        this.menu.push({
          href: { path: '/dashboard' },
          title: 'Dashboard',
          icon: 'fa fa-home'
        });
      }
      if (this.userHasAccess(this.appSections.HEALTH)) {
        this.menu.push({
          href: { path: '/salud' },
          title: 'Salud',
          icon: 'fa fa-heartbeat'
        });
      }
      if ("GAES" === 'GAES' && this.userHasAccess(this.appSections.HISTORIC_ALARM)) {
        this.menu.push({
          href: { path: '/historico-legacy' },
          title: 'Reporte de Eventos (Histórico)',
          icon: 'fa fa-file-archive-o'
        });
      }
      if (this.userHasAccess(this.appSections.HISTORIC_ALARM)) {
        this.menu.push({
          href: { path: '/historico' },
          title: 'Reporte de Eventos',
          icon: 'fa fa-file-text'
        });
      }
      if (this.userHasAccess(this.appSections.PRESION)) {
        var submenu3 = [];

        submenu3.push({
          href: { path: '/presion' },
          title: 'Presión por estación',
          icon: 'fa fa-globe'
        });

        submenu3.push({
          href: { path: '/presionrange' },
          title: 'Por rango de tiempo',
          icon: 'fa fa-binoculars'
        });

        submenu3.push({
          href: { path: '/presionnormal' },
          title: 'Presión normalizado',
          icon: 'fa fa-line-chart'
        });

        this.menu.push({
          title: 'Graficas',
          icon: 'fa fa-area-chart',
          child: submenu3
        });
      }
      if (this.userHasAccess(this.appSections.BINNACLE)) {
        this.menu.push({
          href: { path: '/bitacora' },
          title: 'Bitácora',
          icon: 'fa fa-binoculars'
        });
      }
      if (this.userHasAccess(this.appSections.CAMP)) {
        this.menu.push({
          href: { path: '/campo' },
          title: 'Campo',
          icon: 'fa fa-signal'
        });
      }
      if (this.userHasAccess(this.appSections.DIR_GENERAL) || this.userHasAccess(this.appSections.DIR_TREND)) {
        var submenu1 = [];

        if (this.userHasAccess(this.appSections.DIR_GENERAL)) {
          submenu1.push({
            href: { path: '/direccion/general' },
            title: 'General',
            icon: 'fa fa-globe'
          });
        }

        if (this.userHasAccess(this.appSections.DIR_TREND)) {
          submenu1.push({
            href: { path: '/direccion/tendencias' },
            title: 'Tendencias',
            icon: 'fa fa-binoculars'
          });
        }

        this.menu.push({
          title: 'Analíticos',
          icon: 'fa fa-desktop',
          child: submenu1
        });
      }

      if (this.userHasAccess(this.appSections.REPORT_POLL) || this.userHasAccess(this.appSections.REPORT_TABLE_POLL)) {
        var submenu2 = [];

        if (this.userHasAccess(this.appSections.REPORT_POLL)) {
          submenu2.push({
            href: { path: '/reporte/pressure' },
            title: 'Reporte de Presión',
            icon: 'fa fa-area-chart'
          });
        }

        if (this.userHasAccess(this.appSections.REPORT_POLL)) {
          submenu2.push({
            href: { path: '/reporte/pressurereport' },
            title: 'Presión por Ducto',
            icon: 'fa fa-area-chart'
          });
        }

        if (this.userHasAccess(this.appSections.REPORT_POLL)) {
          submenu2.push({
            href: { path: '/reporte/poll' },
            title: 'Reportes de Poll',
            icon: 'fa fa-bar-chart'
          });
        }

        if (this.userHasAccess(this.appSections.REPORT_TABLE_POLL)) {
          submenu2.push({
            href: { path: '/reporte/reportepoll' },
            title: 'Tablas de Poll',
            icon: 'fa fa-line-chart'
          });
        }

        this.menu.push({
          title: 'Estado de Sitios',
          icon: 'fa fa-battery-three-quarters',
          child: submenu2
        });
      }

      if (this.userHasAccess(this.appSections.MONITOR)) {
        this.menu.push({
          href: { path: '/configuracion' },
          title: 'Monitoreo',
          icon: 'fa fa-cog'
        });
      }

      if (this.userHasAccess(this.appSections.HELP)) {
        this.menu.push({
          to: 'ayuda',
          title: 'Ayuda',
          icon: 'fa fa-question-circle'
        });
      }

      if (this.userHasAccess(this.appSections.WEB_RELEASE)) {
        this.menu.push({
          title: 'v0.1.6',
          icon: 'fa fa-info-circle'
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.loadMenu();
  },
  updated: function updated() {}
});

/***/ }),

/***/ 848:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Select__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reusable_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reusable_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChart_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);


var $ = __webpack_require__(54);


var Modal = function Modal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var LoadingModal = function LoadingModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data', 'names', 'id', 'modalTarget', 'height', 'tbClass'],
  data: function data() {
    return {
      colspan: 0,
      status: false,
      opts: [{
        name: 'Bateria',
        value: 'bateria'
      }, {
        name: 'USB',
        value: 'usb'
      }, {
        name: 'Antena',
        value: 'antena'
      }, {
        name: 'RAM',
        value: 'ram'
      }],
      datacollection: {
        datasets: []
      },
      chartOps: {
        legend: {
          display: false
        },
        responsive: false,
        scales: {
          xAxes: [{
            type: 'time',
            display: true,
            time: {
              unit: 'hour',
              displayFormats: {
                day: 'MMM D',
                hour: 'DD MMM,	HH:mm'
              },
              min: new Date().setHours('00', '00', '00', '00'),
              max: new Date().setHours('24', '00', '00', '00'),
              stepSize: 2
            }
          }],
          yAxes: [{
            ticks: {
              min: 10,
              max: 16,
              stepSize: 1
            }
          }]
        }
      }
    };
  },

  methods: {
    formatDate: function formatDate() {
      var date = new Date(new Date().setHours(0, 0, 0, 0)).toLocaleString('es-US', { hour12: false });
      date = date.split(' ');
      var time = date[1];
      var mdy = date[0].split('/');
      var month = parseInt(mdy[0]);
      var day = parseInt(mdy[1]);
      var year = parseInt(mdy[2]);
      return year + '-' + day + '-' + month + ' ' + time;
    },
    chooseTipo: function chooseTipo(e, id) {
      var _this = this;

      this.loading();
      var desde = this.formatDate();
      var hasta = desde.split(' ');
      hasta = hasta[0] + ' 23:59:59';

      this.$store.dispatch('LOAD_BATERIA', {
        ducto: document.querySelector('#ducto-campo').value,
        estacion: '',
        desde: desde,
        hasta: hasta
      }).then(function (resp) {
        _this.loading();
        var temp = [];
        var response = resp.data.filter(function (rd) {
          return rd.rtu_name === _this.data[id].site;
        });
        if (response.length === 0) {
          __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('No se encontró información');
          return;
        }
        response.forEach(function (r) {
          temp.push({
            x: r.formated_date,
            y: r.battery
          });
        });
        _this.datacollection.datasets[0] = {
          label: 'DATA',
          data: temp,
          fill: false,
          backgroundColor: 'white',
          borderColor: 'red',
          pointBorderWidth: 1,
          borderWidth: 1,
          pointRadius: 1
        };

        if (temp[0].x.split(' ')[1].split(':')[0] - temp[temp.length - 1].x.split(' ')[1].split(':')[0] < 12) {
          _this.chartOps.scales.xAxes[0].time.stepSize = 1;
        } else {
          _this.chartOps.scales.xAxes[0].time.stepSize = 2;
        }
        _this.chartOps.scales.xAxes[0].time.min = temp[temp.length - 1].x;
        _this.chartOps.scales.xAxes[0].time.max = temp[0].x;
        _this.chartOps.scales.yAxes[0].ticks.min = Math.min.apply(Math, temp.map(function (o) {
          return o.y;
        })) - 1;
        _this.chartOps.scales.yAxes[0].ticks.max = Math.max.apply(Math, temp.map(function (o) {
          return o.y;
        })) + 1;
        _this.$refs.chart[id]._chart.update(0);
      }).catch(function (err) {
        console.log('Err', err);
      });
    },
    toggleTD: function toggleTD(r, id) {
      $('#' + r).toggleClass('hidden');
      if (this.datacollection.datasets[0]) {
        this.datacollection.datasets[0].data = '';
        this.$refs.chart[id]._chart.update(0);
      }
    },
    loading: function loading() {
      document.querySelector('#loading-btnData').click();
    },
    imgUrl: function imgUrl(url) {
      return __webpack_require__(1809)("./" + url);
    }
  },
  watch: {
    data: function data() {
      var _this2 = this;

      this.data.forEach(function (d, i) {
        _this2.data[i].bitArr = {
          cd: { name: 'Cálculo deshabilitado', val: d.calculo || 0 },
          gps: { name: 'Error GPS', val: d.gps || 0 },
          puerto: { name: 'Error Puerto S', val: d.puerto || 0 },
          buf: { name: 'Bufereando', val: d.buf || 0 },
          grab: { name: 'Grabando', val: d.grab || 0 },
          fuga: { name: 'Evento de Fuga', val: d.leak || 0 },
          puerta_gabinete: { name: 'Puerta abierta de gabinete', val: d.buf || 0 },
          puerta_sensor: { name: 'Puerta abierta de sensor', val: d.sen || 0 }
        };
        setTimeout(function () {
          var percent = 0;
          if (d.bateria >= 10) {
            percent = (d.bateria - 10 + 1) / 6 * 100;
          } else {
            percent = 1;
          }

          document.querySelector('#' + d.estacion + i + 'Bar').style.width = percent + '%';
          document.querySelector('#' + d.estacion + i + 'Ubs').style.width = percent + '%';
        }, 500);
      });
    }
  },
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_1_components_Charts_LineChart_js__["a" /* default */],
    selectC: __WEBPACK_IMPORTED_MODULE_0_reusable_Select___default.a,
    Modal: Modal,
    LoadingModal: LoadingModal
  },
  mounted: function mounted() {
    for (var i in this.names) {
      if (this.names.hasOwnProperty(i)) {
        this.colspan++;
      }
    }
  }
});

/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var $ = __webpack_require__(54);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'name', 'value', 'cclass', 'val', 'cid', 'label', 'cstyle', 'parClass', 'colorChng'],
  data: function data() {
    return {
      customid: this.cid ? this.cid : this._uid,
      customStyle: this.cstyle
    };
  },

  methods: {
    validation: function validation(val) {
      var input = $('#' + this.customid);
      var inputValue = $('#' + this.customid).val();
      this.$emit('getVal', inputValue);
      val = val.split('|');
      var type = val[0];
      var min = val[1];
      var max = val[2];
      if (min === undefined) {
        min = 1;
      }


      switch (type) {
        case 'name':
          if (inputValue === '' || inputValue.length <= 1) {
            $(input).addClass('error');
          } else {
            $(input).removeClass('error');
          }
          break;

        case 'number':
          if ($.isNumeric(inputValue)) {
            input.attr('maxlength', max);
            if (inputValue.length < min) {
              input.addClass('error');
            }
            if (inputValue.length >= min) {
              input.removeClass('error');
            }
          } else {
            $(input).addClass('error');
            input.val('');
          }
          break;

        case 'not-req-number':
          if ($.isNumeric(inputValue)) {
            input.attr('maxlength', max);
          } else {
            input.val('');
          }
          break;

        case 'email':
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(inputValue)) {
            $(input).addClass('error');
          } else {
            $(input).removeClass('error');
          }

          break;

        case 'verify_email':
          var email = $('#email').val();
          if (inputValue !== email) {
            $(input).addClass('error');
          } else {
            $(input).removeClass('error');
          }

          break;

        case 'select':
          if ($(input).prop('selectedIndex') !== 0) {
            $(input).removeClass('error');
          } else {
            $(input).addClass('error');
          }
          break;

        case 'next':
          var i = 0;
          $('form input, form select, .error-check-img-cont').each(function (index, input) {
            if ($(input).hasClass('error')) {
              i = input;
              return false;
            }
          });
          if (i !== 0) {
            var offset = $(input).offset();
            offset.left -= 200;
            offset.top -= 200;
            $('html, body').animate({
              scrollTop: offset.top,
              scrollLeft: offset.left
            });
            input.scrollIntoView(true);
            input.focus();
            return i;
          }
          break;

        case 'back-error':
          val = 0;
          $('form input, form select, .error-check-img-cont').each(function (index, input) {
            if ($(input).hasClass('error')) {
              var offset = $(input).offset();
              offset.left -= 200;
              offset.top -= 200;
              $('html, body').animate({
                scrollTop: offset.top,
                scrollLeft: offset.left
              });
              input.scrollIntoView(true);
              input.focus();
              return false;
            }
          });

          if (val !== 0) {
            return val;
          }
          break;

        case 'required':

          if (inputValue === '' || inputValue.length < 1) {
            $(input).addClass('error');
          } else {
            $(input).removeClass('error');
          }

          break;

        case 'document-image':

          if (inputValue === '' || inputValue.length < 1) {
            $(input).addClass('error');
          } else {
            $(input).removeClass('error');
          }

          break;

        case 'alpha-numeric':

          re = /^[a-z0-9]+$/i;
          input.attr('maxlength', max);
          if (inputValue.length < min) {
            $(input).addClass('error');
          } else if (!re.test(inputValue)) {
            $(input).addClass('error');
          } else {
            $(input).removeClass('error');
          }
          break;
      }
    }
  }
});

/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_imgs_logos_logo_pemex_original_png__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_imgs_logos_logo_pemex_original_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_imgs_logos_logo_pemex_original_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(209);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['cclass', 'mcStyle', 'wStyle', 'mcClass', 'markerList'],
  data: function data() {
    return {
      map: null,
      markers: [],
      markersMap: [],
      infowindow: undefined
    };
  },

  methods: {
    imgUrl: function imgUrl(url) {
      return __webpack_require__(762)("./" + url);
    },
    leakMarkerListener: function leakMarkerListener(marker, d) {
      var _this = this;

      marker.addListener('click', function () {
        _this.$emit('marker-clicked', marker);
        _this.map.panTo(marker.getPosition());
        google.maps.event.addListenerOnce(_this.map, 'idle', function () {
          _this.map.setOptions({
            center: marker.getPosition(),
            zoom: 35
          });
        });
        _this.infowindow.setContent('<h5 style="color: var(--btn-default); font-weight:800">Alarma de fuga</h5>' + ('<p style="color: var(--btn-default); font-size: 13px; font-weight: 400;"> ' + d.estado + ' - ' + d.municipio + ' <br> KM ' + d.km + '</p>') + ('<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Latitud:</span> ' + d.lat + '</p>') + ('<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Longitud:</span> ' + d.lng + '</p>') + ('<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Fecha:</span> ' + d.fecha + '</p> <br>') + ('<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">' + (d.isMP ? 'Eventos' : 'Tipo') + ':</span> ' + (d.isMP ? d.tipo : d.tipo === 1 ? 'Apertura' : 'Cierre') + '</p> <br>'));
        _this.infowindow.open(_this.map, marker);
      });
    },
    fillMark: function fillMark() {
      var _this2 = this;

      var ducts = this.$store.getters.GET_HOME_DUCTOS_TABLE;
      if (!ducts) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ducts).forEach(function (idSection) {
        var section = ducts[idSection];

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(section.sites).forEach(function (idSite) {
          var site = section.sites[idSite];
          var imgSrc = 'place_red.gif';

          if (!site.hasFailure()) {
            imgSrc = 'place_green.png';
          }

          if (site.battery < 12 || site.hasPressueAlarm()) {
            imgSrc = 'place_yellow.png';
          }

          if (site.isOffline() || site.cabinet_door === 1 || site.gps === 0 || site.site_door === 1 || site.pressure === 0) {
            imgSrc = 'place_red.gif';
          }

          var img = new google.maps.MarkerImage(_this2.imgUrl(imgSrc));

          var marker = _this2.getMarker(section.id, site.id);
          if (!marker) {
            marker = new google.maps.Marker({
              position: new google.maps.LatLng(site.lat, site.lon),
              map: _this2.map,
              icon: img
            });
            _this2.markerListener(marker, section, site);
            _this2.markersMap.push(marker);
          } else {
            marker.setIcon(img);
          }
        });
      });
    },
    markerListener: function markerListener(marker, section, site) {
      var _this3 = this;

      var imgIcon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'place_green.png';

      var fallaMsg = '';
      marker.addListener('click', function () {
        _this3.$emit('marker-clicked', site);
        site._battery <= 10 ? fallaMsg = 'Batería baja' : site._cabinet_door === 1 ? fallaMsg = 'Fallo en la puerta' : site._gps === 0 ? fallaMsg = 'Fallo en el gps' : site._site_door === 1 ? fallaMsg = 'Fallo en la puerta del site' : fallaMsg = '';
        if (fallaMsg !== '') {
          fallaMsg = fallaMsg + '</p>';
        }

        _this3.infowindow.setContent('<img width="116" height="32" src="' + __WEBPACK_IMPORTED_MODULE_1__assets_imgs_logos_logo_pemex_original_png___default.a + '"> ' + '<h5> ' + section.name + ' </h5> <br>' + '<h6 style="color: var(--btn-default)">' + site.name + ' </h6>' + '<p style="font-size:12px;">' + site.lat + ' ' + site.lon + '<br>' + site.city + '<br> KM ' + site.km + ' <br> Carga de batería ' + site.battery + ' <br> Presión ' + site.pressure + ' <br> Online ' + site.online + '</p>' + ' <br> Último evento ' + site.insertTimestamp + '</p>' + '<p class="pull-right" style="color: red; font-weight: 800;">' + fallaMsg + '</p>');
        _this3.infowindow.open(_this3.map, marker);
      });
    },
    fillMap: function fillMap(data, ducto) {
      var _this4 = this;

      if (!this.infowindow) {
        this.infowindow = new google.maps.InfoWindow({
          size: new google.maps.Size(150, 50),
          maxWidth: 300
        });
      }

      if (this.markers.length !== 0) {
        this.markers.forEach(function (mar) {
          mar.setMap(null);
        });
      }
      this.markers = [];
      var bounds = new google.maps.LatLngBounds();
      data.forEach(function (d) {
        if (d.lat === 0 && d.lng === 0) {
          return;
        }

        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(d.lat, d.lng),
          draggable: false,
          map: _this4.map,
          customInfo: d.id
        });
        var img = new google.maps.MarkerImage(_this4.imgUrl('leak_green.png'));
        marker.setIcon(img);
        bounds.extend(marker.getPosition());

        _this4.markers.push(marker);
        _this4.leakMarkerListener(marker, d);
      });
      this.map.setZoom(7);
      this.map.fitBounds(bounds);
    },
    drawDucts: function drawDucts() {
      var data = this.$store.getters.GET_ROUTES;
      var sections = this.$store.getters.allowedSections;
      for (var id in data) {
        if (!__WEBPACK_IMPORTED_MODULE_2_ramda__["o" /* contains */](id, sections)) {
          continue;
        }
        var route = data[id];
        var linePath = new google.maps.Polyline({
          path: route,
          geodesic: false,
          strokeColor: '#FF0000',
          strokeWeight: 5,
          strokeOpacity: 1.0
        });
        linePath.setMap(this.map);
      }
    },
    getMarker: function getMarker(section, site) {
      var result = void 0;
      this.markers.some(function (marker) {
        if (marker.customInfo && marker.customInfo.section === section && marker.customInfo.site === site) {
          result = marker;
          return true;
        }
        return false;
      });
      return result;
    },
    zoom: function zoom(mark) {
      var result = null;
      var id = mark.id;
      this.markers.some(function (marker) {
        if (marker.customInfo && marker.customInfo === id) {
          result = marker;
          return true;
        }
        return false;
      });
      if (!result) {
        return;
      }
      google.maps.event.trigger(result, 'click');
    },
    startGoogleMaps: function startGoogleMaps() {
      var _this5 = this;

      var myOptions = {
        zoom: 5,
        center: { lat: 23.878211, lng: -102.770344 },
        mapTypeControl: true
      };

      this.map = new google.maps.Map(document.getElementById('map_canvas'), myOptions);

      google.maps.event.addListenerOnce(this.map, 'idle', function () {
        var data = _this5.$store.getters.GET_ROUTES;
        var update = !data || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).length <= 0;
        if (update) {
          _this5.$store.dispatch('LOAD_PIPELINE_SHAPES');
          _this5.$store.watch(function (state) {
            return state.routes;
          }, function () {
            _this5.drawDucts();
          }, {
            immediate: true
          });
        } else {
          _this5.drawDucts();
        }

        data = _this5.$store.getters.GET_HOME_DUCTOS_TABLE;
        if (!data) {
          console.log('polling ducts');
          _this5.$store.dispatch('LOAD_DUCTOS').then(function (data) {
            _this5.fillMark();
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.startGoogleMaps();
  }
});

/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'cclass'],
  data: function data() {
    return {
      modalEventTime: null
    };
  },

  methods: {
    timeoutM: function timeoutM(mbd) {
      var _this = this;

      if (mbd) {
        mbd.addEventListener('click', function () {
          if (mbd.parentNode !== null) {
            mbd.parentNode.removeChild(mbd);
          }

          clearInterval(_this.modalEventTime);
        });
      }
    }
  },
  mounted: function mounted() {
    var mbd = document.querySelector('.modal-backdrop');
    var glob = this;
    if (mbd !== null) {
      this.timeoutM(mbd);
    } else {
      this.modalEventTime = setInterval(function () {
        var mbd = document.querySelector('.modal-backdrop');
        if (mbd !== null) {
          glob.timeoutM(mbd);
        }
      }, 500);
    }
  }
});

/***/ }),

/***/ 852:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'id', 'options', 'placeholder', 'passSelectedValue', 'value'],
  data: function data() {
    return {
      internalValue: this.value || ''
    };
  },

  watch: {
    value: function value(newValue) {
      console.log('newValue', newValue);
      this.internalValue = newValue;
    }
  },
  methods: {
    handleChange: function handleChange() {
      if (this.passSelectedValue) {
        this.$emit('onSelectedValue', this.internalValue);
      } else {
        this.$emit('changeSelect', this.id);
      }
    }
  }
});

/***/ }),

/***/ 853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data', 'names', 'id', 'modalTarget', 'height']
});

/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var echarts = __webpack_require__(404);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {},
  components: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-030d371f],.row[data-v-030d371f]{margin:0;padding:0}#bitacora[data-v-030d371f]{background-color:#eee;height:100%}#bitacora #formulario-top[data-v-030d371f]{height:35vh;margin-top:80px;border-bottom:1px solid rgba(0,0,0,.34)}@media screen and (max-width:767px){#bitacora #formulario-top[data-v-030d371f]{height:45vh}}#bitacora #graficas[data-v-030d371f]{height:75vh}@media screen and (max-width:767px){#bitacora #buttons[data-v-030d371f]{text-align:center}}#bitacora .btn-default[data-v-030d371f]{margin-top:0;background-color:var(--btn-default)}#bitacora .btn-default[data-v-030d371f]:active,#bitacora .btn-default[data-v-030d371f]:focus,#bitacora .btn-default[data-v-030d371f]:hover{background-color:var(--btn-default-hover)!important}#bitacora #search[data-v-030d371f]{margin:15px}@media screen and (max-width:991px){#bitacora #search #buscar[data-v-030d371f]{margin-top:15px}}#bitacora .tabla-bottom[data-v-030d371f]{height:100vh}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Bitacora/Bitacora.vue"],"names":[],"mappings":"AACA,wDACE,SAAU,AACV,SAAW,CACZ,AACD,2BACE,sBAA0B,AAC1B,WAAa,CACd,AACD,2CACI,YAAa,AACb,gBAAiB,AACjB,uCAA6C,CAChD,AACD,oCACA,2CACQ,WAAa,CACpB,CACA,AACD,qCACI,WAAa,CAChB,AACD,oCACA,oCACM,iBAAmB,CACxB,CACA,AACD,wCACI,aAAc,AACd,mCAAqC,CACxC,AACD,2IACM,mDAAsD,CAC3D,AACD,mCACI,WAAa,CAChB,AACD,oCACA,2CACQ,eAAiB,CACxB,CACA,AACD,yCACI,YAAc,CACjB","file":"Bitacora.vue","sourcesContent":["\n.container-fluid[data-v-030d371f], .row[data-v-030d371f] {\n  margin: 0;\n  padding: 0;\n}\n#bitacora[data-v-030d371f] {\n  background-color: #eeeeee;\n  height: 100%;\n}\n#bitacora #formulario-top[data-v-030d371f] {\n    height: 35vh;\n    margin-top: 80px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n@media screen and (max-width: 767px) {\n#bitacora #formulario-top[data-v-030d371f] {\n        height: 45vh;\n}\n}\n#bitacora #graficas[data-v-030d371f] {\n    height: 75vh;\n}\n@media screen and (max-width: 767px) {\n#bitacora #buttons[data-v-030d371f] {\n      text-align: center;\n}\n}\n#bitacora .btn-default[data-v-030d371f] {\n    margin-top: 0;\n    background-color: var(--btn-default);\n}\n#bitacora .btn-default[data-v-030d371f]:hover, #bitacora .btn-default[data-v-030d371f]:active, #bitacora .btn-default[data-v-030d371f]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n#bitacora #search[data-v-030d371f] {\n    margin: 15px;\n}\n@media screen and (max-width: 991px) {\n#bitacora #search #buscar[data-v-030d371f] {\n        margin-top: 15px;\n}\n}\n#bitacora .tabla-bottom[data-v-030d371f] {\n    height: 100vh;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".md-card[data-v-03179529]{background:#f7f7f7}.card-header[data-v-03179529]{font-size:large;font-weight:700}.main-text[data-v-03179529]{font-weight:700;font-size:small}.detail-text[data-v-03179529]{font-size:small}.md-empty-state.md-theme-default.md-rounded[data-v-03179529]{background-color:var(--no-data-background-color)}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Sitio/sitio.vue"],"names":[],"mappings":"AACA,0BACE,kBAAoB,CACrB,AACD,8BACE,gBAAiB,AACjB,eAAkB,CACnB,AACD,4BACE,gBAAkB,AAClB,eAAiB,CAClB,AACD,8BACE,eAAiB,CAClB,AACD,6DACE,gDAAkD,CACnD","file":"sitio.vue","sourcesContent":["\n.md-card[data-v-03179529] {\n  background: #f7f7f7;\n}\n.card-header[data-v-03179529] {\n  font-size: large;\n  font-weight: bold;\n}\n.main-text[data-v-03179529] {\n  font-weight: bold;\n  font-size: small;\n}\n.detail-text[data-v-03179529] {\n  font-size: small;\n}\n.md-empty-state.md-theme-default.md-rounded[data-v-03179529] {\n  background-color: var(--no-data-background-color);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-0976a3b6]{margin:0;padding:0}#presion[data-v-0976a3b6]{background-color:#eee;min-height:100vh}#presion #formulario-top[data-v-0976a3b6]{height:25vh;margin-top:80px;border-bottom:1px solid rgba(0,0,0,.34)}#presion #graficas[data-v-0976a3b6]{background-color:#d3d3d3;height:100vh;width:100%;margin:0;padding:0;padding-top:15vh}#presion .btn-default[data-v-0976a3b6]{margin-top:0;background-color:var(--btn-default)}#presion .btn-default[data-v-0976a3b6]:active,#presion .btn-default[data-v-0976a3b6]:focus,#presion .btn-default[data-v-0976a3b6]:hover{background-color:var(--btn-default-hover)!important}@media screen and (max-width:767px){#presion .btn-default[data-v-0976a3b6]{margin-top:50px}}#line-chart[data-v-0976a3b6]{width:80vw;height:auto;margin:50px auto}#loading-modal-modal[data-v-0976a3b6]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Charts/CustomLineChartPdfHist.vue"],"names":[],"mappings":"AACA,kCACE,SAAU,AACV,SAAW,CACZ,AACD,0BACE,sBAA0B,AAC1B,gBAAkB,CACnB,AACD,0CACI,YAAa,AACb,gBAAiB,AACjB,uCAA6C,CAChD,AACD,oCACI,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,SAAU,AACV,UAAW,AACX,gBAAkB,CACrB,AACD,uCACI,aAAc,AACd,mCAAqC,CACxC,AACD,wIACM,mDAAsD,CAC3D,AACD,oCACA,uCACQ,eAAiB,CACxB,CACA,AACD,6BACE,WAAY,AACZ,YAAa,AACb,gBAAkB,CACnB,AACD,sCACE,0DAA6D,CAC9D","file":"CustomLineChartPdfHist.vue","sourcesContent":["\n.container-fluid[data-v-0976a3b6] {\n  margin: 0;\n  padding: 0;\n}\n#presion[data-v-0976a3b6] {\n  background-color: #eeeeee;\n  min-height: 100vh;\n}\n#presion #formulario-top[data-v-0976a3b6] {\n    height: 25vh;\n    margin-top: 80px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n#presion #graficas[data-v-0976a3b6] {\n    background-color: #d3d3d3;\n    height: 100vh;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    padding-top: 15vh;\n}\n#presion .btn-default[data-v-0976a3b6] {\n    margin-top: 0;\n    background-color: var(--btn-default);\n}\n#presion .btn-default[data-v-0976a3b6]:hover, #presion .btn-default[data-v-0976a3b6]:active, #presion .btn-default[data-v-0976a3b6]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n@media screen and (max-width: 767px) {\n#presion .btn-default[data-v-0976a3b6] {\n        margin-top: 50px;\n}\n}\n#line-chart[data-v-0976a3b6] {\n  width: 80vw;\n  height: auto;\n  margin: 50px auto;\n}\n#loading-modal-modal[data-v-0976a3b6] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".button-style[data-v-0b79e1cc]{width:150px;padding:20px;background-color:var(--btn-default)!important}.half[data-v-0b79e1cc]{height:50vh;width:50vw}@media screen and (max-width:991px){.half[data-v-0b79e1cc]{width:100vw!important}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Map.vue"],"names":[],"mappings":"AACA,+BACE,YAAa,AACb,aAAc,AACd,6CAAgD,CACjD,AACD,uBACE,YAAa,AACb,UAAY,CACb,AACD,oCACA,uBACM,qBAAwB,CAC7B,CACA","file":"Map.vue","sourcesContent":["\n.button-style[data-v-0b79e1cc] {\n  width: 150px;\n  padding: 20px;\n  background-color: var(--btn-default) !important;\n}\n.half[data-v-0b79e1cc] {\n  height: 50vh;\n  width: 50vw;\n}\n@media screen and (max-width: 991px) {\n.half[data-v-0b79e1cc] {\n      width: 100vw !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".code-input[data-v-0ebef27e]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;padding-bottom:30px}.code-input input[data-v-0ebef27e]{width:40px;height:40px;text-align:center;font-size:24px;margin:0 5px}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/PasswordRecovery/CodeInput.vue"],"names":[],"mappings":"AACA,6BACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,8BAA+B,AACnC,mBAAqB,CACtB,AACD,mCACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,YAAc,CACf","file":"CodeInput.vue","sourcesContent":["\n.code-input[data-v-0ebef27e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding-bottom: 30px;\n}\n.code-input input[data-v-0ebef27e] {\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  font-size: 24px;\n  margin: 0 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-13815d32]{margin:0;padding:0}#presion[data-v-13815d32]{background-color:#eee}#presion #formulario-top[data-v-13815d32]{height:10vh;margin-top:80px;border-bottom:1px solid rgba(0,0,0,.34)}#presion #graficas[data-v-13815d32]{height:65vh}#presion .btn-default[data-v-13815d32]{margin-top:0;background-color:var(--btn-default)}#presion .btn-default[data-v-13815d32]:active,#presion .btn-default[data-v-13815d32]:focus,#presion .btn-default[data-v-13815d32]:hover{background-color:var(--btn-default-hover)!important}.nomen[data-v-13815d32]{height:100%;border-right:3px solid gray;text-align:center}.panel-body[data-v-13815d32],table[data-v-13815d32]{overflow:scroll;height:32vh;padding:0;border-bottom:1px solid #999;margin:20px 0}@media screen and (max-width:991px){.panel-body[data-v-13815d32],table[data-v-13815d32]{padding:0}}.panel-body .info td[data-v-13815d32],table .info td[data-v-13815d32]{background-color:#eee}.panel-body th[data-v-13815d32],table th[data-v-13815d32]{text-align:left;padding-left:25px}@media screen and (max-width:415px){.panel-body th[data-v-13815d32],table th[data-v-13815d32]{font-size:12px}}.panel-body td[data-v-13815d32],table td[data-v-13815d32]{text-align:left;padding-left:25px}.panel-body td i[data-v-13815d32],table td i[data-v-13815d32]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body td i[data-v-13815d32]:hover,table td i[data-v-13815d32]:hover{color:var(--btn-default)}.panel-body .nombre-alarma[data-v-13815d32],table .nombre-alarma[data-v-13815d32]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-13815d32],table .panel-body[data-v-13815d32]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-13815d32],table .panel-title[data-v-13815d32]{font-size:12px}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/test.vue"],"names":[],"mappings":"AACA,kCACE,SAAU,AACV,SAAW,CACZ,AACD,0BACE,qBAA0B,CAC3B,AACD,0CACI,YAAa,AACb,gBAAiB,AACjB,uCAA6C,CAChD,AACD,oCACI,WAAa,CAChB,AACD,uCACI,aAAc,AACd,mCAAqC,CACxC,AACD,wIACM,mDAAsD,CAC3D,AACD,wBACE,YAAa,AACb,4BAA6B,AAC7B,iBAAmB,CACpB,AACD,oDAEE,gBAAiB,AACjB,YAAa,AACb,UAAmB,AACnB,6BAA8B,AAC9B,aAAiB,CAClB,AACD,oCACA,oDAEM,SAAW,CAChB,CACA,AACD,sEAEI,qBAA0B,CAC7B,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,8DAEM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,0EAEQ,wBAA0B,CACjC,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAW,CACd,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA","file":"test.vue","sourcesContent":["\n.container-fluid[data-v-13815d32] {\n  margin: 0;\n  padding: 0;\n}\n#presion[data-v-13815d32] {\n  background-color: #eeeeee;\n}\n#presion #formulario-top[data-v-13815d32] {\n    height: 10vh;\n    margin-top: 80px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n#presion #graficas[data-v-13815d32] {\n    height: 65vh;\n}\n#presion .btn-default[data-v-13815d32] {\n    margin-top: 0;\n    background-color: var(--btn-default);\n}\n#presion .btn-default[data-v-13815d32]:hover, #presion .btn-default[data-v-13815d32]:active, #presion .btn-default[data-v-13815d32]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n.nomen[data-v-13815d32] {\n  height: 100%;\n  border-right: 3px solid gray;\n  text-align: center;\n}\ntable[data-v-13815d32],\n.panel-body[data-v-13815d32] {\n  overflow: scroll;\n  height: 32vh;\n  padding: 0px 0 0 0;\n  border-bottom: 1px solid #999;\n  margin: 20px 0px;\n}\n@media screen and (max-width: 991px) {\ntable[data-v-13815d32],\n    .panel-body[data-v-13815d32] {\n      padding: 0;\n}\n}\ntable .info td[data-v-13815d32],\n  .panel-body .info td[data-v-13815d32] {\n    background-color: #eeeeee;\n}\ntable th[data-v-13815d32],\n  .panel-body th[data-v-13815d32] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-13815d32],\n      .panel-body th[data-v-13815d32] {\n        font-size: 12px;\n}\n}\ntable td[data-v-13815d32],\n  .panel-body td[data-v-13815d32] {\n    text-align: left;\n    padding-left: 25px;\n}\ntable td i[data-v-13815d32],\n    .panel-body td i[data-v-13815d32] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\ntable td i[data-v-13815d32]:hover,\n      .panel-body td i[data-v-13815d32]:hover {\n        color: var(--btn-default);\n}\ntable .nombre-alarma[data-v-13815d32],\n  .panel-body .nombre-alarma[data-v-13815d32] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-13815d32],\n  .panel-body .panel-body[data-v-13815d32] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-13815d32],\n    .panel-body .panel-title[data-v-13815d32] {\n      font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".col-md-6[data-v-14af0ed9],.col-xs-12[data-v-14af0ed9]{padding:0!important}.container-fluid[data-v-14af0ed9]{background-color:#fff;width:100%;padding:0;margin:0}.panel-body[data-v-14af0ed9],table[data-v-14af0ed9]{height:70vh;margin:0}.panel-body .organgeTR[data-v-14af0ed9],table .organgeTR[data-v-14af0ed9]{background-color:var(--btn-default);color:#fff}.panel-body .info td[data-v-14af0ed9],table .info td[data-v-14af0ed9]{background-color:#eee}.panel-body th[data-v-14af0ed9],table th[data-v-14af0ed9]{text-align:center;padding-left:25px}@media screen and (max-width:415px){.panel-body th[data-v-14af0ed9],table th[data-v-14af0ed9]{font-size:12px}}.panel-body td[data-v-14af0ed9],table td[data-v-14af0ed9]{text-align:center;padding-left:25px}.panel-body .nombre-alarma[data-v-14af0ed9],table .nombre-alarma[data-v-14af0ed9]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-14af0ed9],table .panel-body[data-v-14af0ed9]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-14af0ed9],table .panel-title[data-v-14af0ed9]{font-size:12px}}.btn-default[data-v-14af0ed9]{background:var(--btn-default-hover)}.btn-default[data-v-14af0ed9]:active,.btn-default[data-v-14af0ed9]:focus,.btn-default[data-v-14af0ed9]:hover{background:var(--btn-default)!important}#reportes-page[data-v-14af0ed9]{padding-top:50px;height:100vh;background-color:#eee}#reportes-page #formulario-top[data-v-14af0ed9]{height:15vh}@media screen and (max-width:767px){#reportes-page #formulario-top[data-v-14af0ed9]{height:45vh}}#reportes-page #range-wrapper[data-v-14af0ed9]{margin:50px auto}.color-2 .irs-bar-edge[data-v-14af0ed9],.color-2 .irs-bar[data-v-14af0ed9]{background:red}.panel[data-v-14af0ed9]{margin-bottom:0}.fa[data-v-14af0ed9]{margin-left:3px;margin-top:3px}@media screen and (max-width:1010px){.fa[data-v-14af0ed9]{margin-top:-5px;margin-left:13px}}@media screen and (max-width:991px){.fa[data-v-14af0ed9]{margin-left:3px;margin-top:3px}}@media screen and (max-width:582px){.fa[data-v-14af0ed9]{margin-top:-5px;margin-left:13px}}@media screen and (max-width:415px){.fa[data-v-14af0ed9]{margin-left:12px;margin-top:3px}}.row[data-v-14af0ed9]{margin-right:0}.no-show[data-v-14af0ed9]{display:none}h3[data-v-14af0ed9]{color:#000;cursor:pointer}span[data-v-14af0ed9]{padding:0 20px}@media screen and (max-width:400px){span[data-v-14af0ed9]{padding:0 10px}}.panel-body[data-v-14af0ed9],table[data-v-14af0ed9]{background-color:#eee;overflow:scroll;height:40vh;padding:0;padding-left:0;border-top:1px solid #999}table[data-v-14af0ed9]{height:35vh}.not-active[data-v-14af0ed9]{color:rgba(0,0,0,.34)}.col-md-5[data-v-14af0ed9],.col-md-7[data-v-14af0ed9]{margin:0;padding:0}.panel-default[data-v-14af0ed9]{background-color:#e0e0e0;border:none;border-radius:0}#data-table[data-v-14af0ed9]{position:absolute;color:rgba(0,0,0,.87);width:100vw;height:30vh;bottom:0}#ductos h3[data-v-14af0ed9]{padding-left:15px}#ductos .ducto[data-v-14af0ed9]{color:#fff;font-size:12px;cursor:pointer;background-color:var(--btn-default)}#alarmas th[data-v-14af0ed9]{text-align:left;padding-left:25px}@media screen and (max-width:415px){#alarmas th[data-v-14af0ed9]{font-size:12px}}#alarmas td[data-v-14af0ed9]{text-align:left;padding-left:25px;background-color:#eee}#alarmas td i[data-v-14af0ed9]{color:rgba(0,0,0,.34);cursor:pointer}#alarmas td i[data-v-14af0ed9]:hover{color:var(--btn-default)}#alarmas .nombre-alarma[data-v-14af0ed9]{background-color:var(--btn-default);color:#fff}#alarmas .panel-body[data-v-14af0ed9]{padding:0}@media screen and (max-width:415px){#alarmas .panel-title[data-v-14af0ed9]{font-size:12px}}#comentario-modal h3[data-v-14af0ed9]{color:rgba(0,0,0,.87)}#comentario-modal .btn-default[data-v-14af0ed9]{background-color:var(--btn-default)}#comentario-modal .btn-default[data-v-14af0ed9]:active,#comentario-modal .btn-default[data-v-14af0ed9]:focus,#comentario-modal .btn-default[data-v-14af0ed9]:hover{background-color:var(--btn-default-hover)!important}#comentario-modal label[data-v-14af0ed9]{color:var(--btn-default)}#comentario-modal #label-name[data-v-14af0ed9]{color:#fff;width:100%;font-size:16px;padding:5px;background-color:var(--btn-default)}#comentario-modal #selectDonde[data-v-14af0ed9]{-webkit-appearance:none;-webkit-border-radius:0;width:80%;height:40px;padding:5px}#loading-modal-modal[data-v-14af0ed9]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Direccion/General.vue"],"names":[],"mappings":"AACA,uDAEE,mBAAwB,CACzB,AACD,kCACE,sBAAwB,AACxB,WAAY,AACZ,UAAW,AACX,QAAU,CACX,AACD,oDAGE,YAAa,AAEb,QAAU,CACX,AACD,0EAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,sEAEI,qBAA0B,CAC7B,AACD,0DAEI,kBAAmB,AACnB,iBAAmB,CACtB,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,0DAEI,kBAAmB,AACnB,iBAAmB,CACtB,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAW,CACd,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA,AACD,8BACE,mCAAqC,CACtC,AACD,6GACI,uCAA0C,CAC7C,AACD,gCACE,iBAAkB,AAClB,aAAc,AACd,qBAA0B,CAC3B,AACD,gDACI,WAAa,CAChB,AACD,oCACA,gDACQ,WAAa,CACpB,CACA,AACD,+CACI,gBAAkB,CACrB,AACD,2EAEE,cAAgB,CACjB,AACD,wBACE,eAAiB,CAClB,AACD,qBACE,gBAAiB,AACjB,cAAgB,CACjB,AACD,qCACA,qBACM,gBAAiB,AACjB,gBAAkB,CACvB,CACA,AACD,oCACA,qBACM,gBAAiB,AACjB,cAAgB,CACrB,CACA,AACD,oCACA,qBACM,gBAAiB,AACjB,gBAAkB,CACvB,CACA,AACD,oCACA,qBACM,iBAAkB,AAClB,cAAgB,CACrB,CACA,AACD,sBACE,cAAkB,CACnB,AACD,0BACE,YAAc,CACf,AACD,oBACE,WAAa,AACb,cAAgB,CACjB,AACD,sBACE,cAAgB,CACjB,AACD,oCACA,sBACM,cAAgB,CACrB,CACA,AACD,oDAEE,sBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,UAAW,AACX,eAAkB,AAClB,yBAA2B,CAC5B,AACD,uBACE,WAAa,CACd,AACD,6BACE,qBAA2B,CAC5B,AACD,sDAEE,SAAU,AACV,SAAW,CACZ,AACD,gCACE,yBAA0B,AAC1B,YAAa,AACb,eAAiB,CAClB,AACD,6BACE,kBAAmB,AACnB,sBAA2B,AAC3B,YAAa,AACb,YAAa,AACb,QAAU,CACX,AACD,4BACE,iBAAmB,CACpB,AACD,gCACE,WAAa,AACb,eAAgB,AAChB,eAAgB,AAChB,mCAAqC,CACtC,AACD,6BACE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,oCACA,6BACM,cAAgB,CACrB,CACA,AACD,6BACE,gBAAiB,AACjB,kBAAmB,AACnB,qBAA0B,CAC3B,AACD,+BACI,sBAA2B,AAC3B,cAAgB,CACnB,AACD,qCACM,wBAA0B,CAC/B,AACD,yCACE,oCAAqC,AACrC,UAAa,CACd,AACD,sCACE,SAAW,CACZ,AACD,oCACA,uCACI,cAAgB,CACnB,CACA,AACD,sCACE,qBAA2B,CAC5B,AACD,gDACE,mCAAqC,CACtC,AACD,mKACI,mDAAsD,CACzD,AACD,yCACE,wBAA0B,CAC3B,AACD,+CACE,WAAa,AACb,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,mCAAqC,CACtC,AACD,gDACE,wBAAyB,AACzB,wBAA2B,AAC3B,UAAW,AACX,YAAa,AACb,WAAa,CACd,AACD,sCACE,0DAA6D,CAC9D","file":"General.vue","sourcesContent":["\n.col-md-6[data-v-14af0ed9],\n.col-xs-12[data-v-14af0ed9] {\n  padding: 0px !important;\n}\n.container-fluid[data-v-14af0ed9] {\n  background-color: white;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\ntable[data-v-14af0ed9],\n.panel-body[data-v-14af0ed9] {\n  overflow: scroll;\n  height: 70vh;\n  padding: 0px 0;\n  margin: 0;\n}\ntable .organgeTR[data-v-14af0ed9],\n  .panel-body .organgeTR[data-v-14af0ed9] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .info td[data-v-14af0ed9],\n  .panel-body .info td[data-v-14af0ed9] {\n    background-color: #eeeeee;\n}\ntable th[data-v-14af0ed9],\n  .panel-body th[data-v-14af0ed9] {\n    text-align: center;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-14af0ed9],\n      .panel-body th[data-v-14af0ed9] {\n        font-size: 12px;\n}\n}\ntable td[data-v-14af0ed9],\n  .panel-body td[data-v-14af0ed9] {\n    text-align: center;\n    padding-left: 25px;\n}\ntable .nombre-alarma[data-v-14af0ed9],\n  .panel-body .nombre-alarma[data-v-14af0ed9] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-14af0ed9],\n  .panel-body .panel-body[data-v-14af0ed9] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-14af0ed9],\n    .panel-body .panel-title[data-v-14af0ed9] {\n      font-size: 12px;\n}\n}\n.btn-default[data-v-14af0ed9] {\n  background: var(--btn-default-hover);\n}\n.btn-default[data-v-14af0ed9]:hover, .btn-default[data-v-14af0ed9]:focus, .btn-default[data-v-14af0ed9]:active {\n    background: var(--btn-default) !important;\n}\n#reportes-page[data-v-14af0ed9] {\n  padding-top: 50px;\n  height: 100vh;\n  background-color: #eeeeee;\n}\n#reportes-page #formulario-top[data-v-14af0ed9] {\n    height: 15vh;\n}\n@media screen and (max-width: 767px) {\n#reportes-page #formulario-top[data-v-14af0ed9] {\n        height: 45vh;\n}\n}\n#reportes-page #range-wrapper[data-v-14af0ed9] {\n    margin: 50px auto;\n}\n.color-2 .irs-bar[data-v-14af0ed9],\n.color-2 .irs-bar-edge[data-v-14af0ed9] {\n  background: red;\n}\n.panel[data-v-14af0ed9] {\n  margin-bottom: 0;\n}\n.fa[data-v-14af0ed9] {\n  margin-left: 3px;\n  margin-top: 3px;\n}\n@media screen and (max-width: 1010px) {\n.fa[data-v-14af0ed9] {\n      margin-top: -5px;\n      margin-left: 13px;\n}\n}\n@media screen and (max-width: 991px) {\n.fa[data-v-14af0ed9] {\n      margin-left: 3px;\n      margin-top: 3px;\n}\n}\n@media screen and (max-width: 582px) {\n.fa[data-v-14af0ed9] {\n      margin-top: -5px;\n      margin-left: 13px;\n}\n}\n@media screen and (max-width: 415px) {\n.fa[data-v-14af0ed9] {\n      margin-left: 12px;\n      margin-top: 3px;\n}\n}\n.row[data-v-14af0ed9] {\n  margin-right: 0px;\n}\n.no-show[data-v-14af0ed9] {\n  display: none;\n}\nh3[data-v-14af0ed9] {\n  color: black;\n  cursor: pointer;\n}\nspan[data-v-14af0ed9] {\n  padding: 0 20px;\n}\n@media screen and (max-width: 400px) {\nspan[data-v-14af0ed9] {\n      padding: 0 10px;\n}\n}\ntable[data-v-14af0ed9],\n.panel-body[data-v-14af0ed9] {\n  background-color: #eeeeee;\n  overflow: scroll;\n  height: 40vh;\n  padding: 0;\n  padding-left: 0px;\n  border-top: 1px solid #999;\n}\ntable[data-v-14af0ed9] {\n  height: 35vh;\n}\n.not-active[data-v-14af0ed9] {\n  color: rgba(0, 0, 0, 0.34);\n}\n.col-md-5[data-v-14af0ed9],\n.col-md-7[data-v-14af0ed9] {\n  margin: 0;\n  padding: 0;\n}\n.panel-default[data-v-14af0ed9] {\n  background-color: #E0E0E0;\n  border: none;\n  border-radius: 0;\n}\n#data-table[data-v-14af0ed9] {\n  position: absolute;\n  color: rgba(0, 0, 0, 0.87);\n  width: 100vw;\n  height: 30vh;\n  bottom: 0;\n}\n#ductos h3[data-v-14af0ed9] {\n  padding-left: 15px;\n}\n#ductos .ducto[data-v-14af0ed9] {\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  background-color: var(--btn-default);\n}\n#alarmas th[data-v-14af0ed9] {\n  text-align: left;\n  padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\n#alarmas th[data-v-14af0ed9] {\n      font-size: 12px;\n}\n}\n#alarmas td[data-v-14af0ed9] {\n  text-align: left;\n  padding-left: 25px;\n  background-color: #eeeeee;\n}\n#alarmas td i[data-v-14af0ed9] {\n    color: rgba(0, 0, 0, 0.34);\n    cursor: pointer;\n}\n#alarmas td i[data-v-14af0ed9]:hover {\n      color: var(--btn-default);\n}\n#alarmas .nombre-alarma[data-v-14af0ed9] {\n  background-color: var(--btn-default);\n  color: white;\n}\n#alarmas .panel-body[data-v-14af0ed9] {\n  padding: 0;\n}\n@media screen and (max-width: 415px) {\n#alarmas .panel-title[data-v-14af0ed9] {\n    font-size: 12px;\n}\n}\n#comentario-modal h3[data-v-14af0ed9] {\n  color: rgba(0, 0, 0, 0.87);\n}\n#comentario-modal .btn-default[data-v-14af0ed9] {\n  background-color: var(--btn-default);\n}\n#comentario-modal .btn-default[data-v-14af0ed9]:hover, #comentario-modal .btn-default[data-v-14af0ed9]:active, #comentario-modal .btn-default[data-v-14af0ed9]:focus {\n    background-color: var(--btn-default-hover) !important;\n}\n#comentario-modal label[data-v-14af0ed9] {\n  color: var(--btn-default);\n}\n#comentario-modal #label-name[data-v-14af0ed9] {\n  color: white;\n  width: 100%;\n  font-size: 16px;\n  padding: 5px;\n  background-color: var(--btn-default);\n}\n#comentario-modal #selectDonde[data-v-14af0ed9] {\n  -webkit-appearance: none;\n  -webkit-border-radius: 0px;\n  width: 80%;\n  height: 40px;\n  padding: 5px;\n}\n#loading-modal-modal[data-v-14af0ed9] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#historical-legacy-page[data-v-14dce9b6]{height:100vh;background-color:#eee;display:-ms-grid;display:grid;-ms-grid-rows:1fr 1fr;grid-template-rows:1fr 1fr;-ms-grid-columns:1fr 2fr;grid-template-columns:1fr 2fr}#historical-legacy-page .form-container[data-v-14dce9b6]{grid-row:1/2;grid-column:1/2;overflow-y:auto;overflow-x:hidden;height:100%;padding:1rem}#historical-legacy-page .map-container[data-v-14dce9b6]{grid-row:1/2;grid-column:2/3;height:100%}#historical-legacy-page .table-container[data-v-14dce9b6]{grid-row:2/3;grid-column:1/3;height:100%;overflow-y:auto}#historical-legacy-page .table-container table[data-v-14dce9b6]{position:relative;width:100%;border-collapse:collapse}#historical-legacy-page .table-container table thead[data-v-14dce9b6]{position:-webkit-sticky;position:sticky;top:0;z-index:10;background-color:var(--btn-header-bg);box-shadow:0 2px 2px rgba(0,0,0,.1)}#historical-legacy-page .table-container table td[data-v-14dce9b6],#historical-legacy-page .table-container table th[data-v-14dce9b6]{padding:5px;border:1px solid #ddd}@media (max-width:995px){#historical-legacy-page[data-v-14dce9b6]{-ms-grid-rows:min-content 1fr 1fr;grid-template-rows:min-content 1fr 1fr;-ms-grid-columns:1fr;grid-template-columns:1fr;height:auto}#historical-legacy-page .form-container[data-v-14dce9b6]{-ms-grid-row:1;grid-row:1;-ms-grid-column:1;grid-column:1;min-height:320px;height:auto}#historical-legacy-page .map-container[data-v-14dce9b6]{-ms-grid-row:2;grid-row:2;-ms-grid-column:1;grid-column:1;height:50vh;overflow:scroll}#historical-legacy-page .table-container[data-v-14dce9b6]{-ms-grid-row:3;grid-row:3;-ms-grid-column:1;grid-column:1;max-height:50vh;overflow-y:auto}}.row[data-v-14dce9b6]{margin:0;padding:0}.row .title[data-v-14dce9b6]{font-size:14px}@media screen and (max-width:991px){.row .title[data-v-14dce9b6]{width:200px;display:inline-block;padding-top:5px;display:block}}.row .sub[data-v-14dce9b6]{position:absolute;color:rgba(0,0,0,.34);font-weight:500;font-size:12px}@media screen and (max-width:991px){.row .sub[data-v-14dce9b6]{display:inline-block}}.row #borrar[data-v-14dce9b6]{height:30px;font-size:12px;padding-top:1px;margin-top:-5px}.row #borrar i[data-v-14dce9b6]{font-size:inherit;padding:0!important}@media screen and (max-width:991px){.row #borrar[data-v-14dce9b6]{display:block;margin:30px auto}}@media screen and (max-width:991px){.row .bottom-input[data-v-14dce9b6]{margin-top:20px;padding-left:30px;margin-bottom:50px}}.row .input-field[data-v-14dce9b6]{display:inline-block}.row .input-field #latitud[data-v-14dce9b6],.row .input-field #longitud[data-v-14dce9b6]{width:100px}@media screen and (max-width:991px){.row .input-field #latitud[data-v-14dce9b6],.row .input-field #longitud[data-v-14dce9b6]{width:70px}}.row .input-field .input-3[data-v-14dce9b6]{width:40px;margin:0 10px}.btn-default[data-v-14dce9b6]:active,.btn-default[data-v-14dce9b6]:focus,.btn-default[data-v-14dce9b6]:hover{background:var(--btn-default)!important}@media screen and (max-width:991px){.btn-default[data-v-14dce9b6]{margin:25px}}.color-2 .irs-bar-edge[data-v-14dce9b6],.color-2 .irs-bar[data-v-14dce9b6]{background:red}.col-md-6[data-v-14dce9b6],.col-xs-12[data-v-14dce9b6]{margin:0;padding:0}.container-fluid[data-v-14dce9b6]{background-color:#fff;width:100%;padding:0;margin:0}.panel-body[data-v-14dce9b6],table[data-v-14dce9b6]{padding:0;margin:0}@media screen and (max-width:991px){.panel-body[data-v-14dce9b6],table[data-v-14dce9b6]{padding:0}}.panel-body .info[data-v-14dce9b6],table .info[data-v-14dce9b6]{cursor:pointer;background-color:#fff}.panel-body .info td[data-v-14dce9b6],table .info td[data-v-14dce9b6]{text-align:left;padding-left:25px;background-color:transparent}.panel-body .info[data-v-14dce9b6]:hover,table .info[data-v-14dce9b6]:hover{background-color:#e0e0e0}.panel-body th[data-v-14dce9b6],table th[data-v-14dce9b6]{text-align:left;padding-left:25px;background-color:var(--btn-header-bg);color:#fff}@media screen and (max-width:415px){.panel-body th[data-v-14dce9b6],table th[data-v-14dce9b6]{font-size:12px}}.panel-body .nombre-alarma[data-v-14dce9b6],table .nombre-alarma[data-v-14dce9b6]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-14dce9b6],table .panel-body[data-v-14dce9b6]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-14dce9b6],table .panel-title[data-v-14dce9b6]{font-size:12px}}.panel-body .selectedRow[data-v-14dce9b6],table .selectedRow[data-v-14dce9b6]{background:var(--selected-row);color:#fff}.panel-body .selectedRow[data-v-14dce9b6]:hover,table .selectedRow[data-v-14dce9b6]:hover{background:var(--selected-row-hover);color:#fff}#loading-modal-modal[data-v-14dce9b6]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/HistoricalLegacy/style.scss"],"names":[],"mappings":"AACA,yCACE,aAAc,AACd,sBAA0B,AAC1B,iBAAkB,AAClB,aAAc,AACd,sBAAuB,AACnB,2BAA4B,AAChC,yBAA0B,AACtB,6BAA+B,CACpC,AACD,yDACI,aAAgB,AAChB,gBAAmB,AACnB,gBAAiB,AACjB,kBAAmB,AACnB,YAAa,AACb,YAAc,CACjB,AACD,wDACI,aAAgB,AAChB,gBAAmB,AACnB,WAAa,CAChB,AACD,0DACI,aAAgB,AAChB,gBAAmB,AACnB,YAAa,AACb,eAAiB,CACpB,AACD,gEACM,kBAAmB,AACnB,WAAY,AACZ,wBAA0B,CAC/B,AACD,sEACQ,wBAAyB,AACzB,gBAAiB,AACjB,MAAO,AACP,WAAY,AACZ,sCAAuC,AACvC,mCAAyC,CAChD,AACD,sIAEQ,YAAa,AACb,qBAAuB,CAC9B,AACD,yBACA,yCACM,kCAAmC,AAC/B,uCAAwC,AAC5C,qBAAsB,AAClB,0BAA2B,AAC/B,WAAa,CAClB,AACD,yDACQ,eAAgB,AACZ,WAAY,AAChB,kBAAmB,AACf,cAAe,AACnB,iBAAkB,AAClB,WAAa,CACpB,AACD,wDACQ,eAAgB,AACZ,WAAY,AAChB,kBAAmB,AACf,cAAe,AACnB,YAAa,AACb,eAAiB,CACxB,AACD,0DACQ,eAAgB,AACZ,WAAY,AAChB,kBAAmB,AACf,cAAe,AACnB,gBAAiB,AACjB,eAAiB,CACxB,CACA,AACD,sBACE,SAAU,AACV,SAAW,CACZ,AACD,6BACE,cAAgB,CACjB,AACD,oCACA,6BACM,YAAa,AACb,qBAAsB,AACtB,gBAAiB,AAKjB,aAAe,CAJpB,CACA,AAMD,2BACE,kBAAmB,AACnB,sBAA2B,AAC3B,gBAAiB,AACjB,cAAgB,CACjB,AACD,oCACA,2BACM,oBAAsB,CAC3B,CACA,AACD,8BACE,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CAClB,AACD,gCACI,kBAAmB,AACnB,mBAAsB,CACzB,AACD,oCACA,8BACM,cAAe,AACf,gBAAkB,CACvB,CACA,AACD,oCACA,oCACI,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACvB,CACA,AACD,mCACE,oBAAsB,CACvB,AACD,yFAEI,WAAa,CAChB,AACD,oCACA,yFAEQ,UAAY,CACnB,CACA,AACD,4CACI,WAAY,AACZ,aAAe,CAClB,AACD,6GACE,uCAA0C,CAC3C,AACD,oCACA,8BACI,WAAa,CAChB,CACA,AACD,2EAEE,cAAgB,CACjB,AACD,uDAEE,SAAU,AACV,SAAW,CACZ,AACD,kCACE,sBAAwB,AACxB,WAAY,AACZ,UAAW,AACX,QAAU,CACX,AACD,oDAEE,UAAW,AACX,QAAU,CACX,AACD,oCACA,oDAEM,SAAW,CAChB,CACA,AACD,gEAEI,eAAgB,AAChB,qBAAuB,CAC1B,AACD,sEAEM,gBAAiB,AACjB,kBAAmB,AACnB,4BAA8B,CACnC,AACD,4EAEM,wBAA0B,CAC/B,AACD,0DAEI,gBAAiB,AACjB,kBAAmB,AACnB,sCAAuC,AACvC,UAAY,CACf,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAW,CACd,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA,AACD,8EAEI,+BAAgC,AAChC,UAAY,CACf,AACD,0FAEI,qCAAsC,AACtC,UAAY,CACf,AAID,sCACE,0DAA6D,CAC9D","file":"style.scss","sourcesContent":["\n#historical-legacy-page[data-v-14dce9b6] {\n  height: 100vh;\n  background-color: #eeeeee;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-rows: 1fr 1fr;\n      grid-template-rows: 1fr 1fr;\n  -ms-grid-columns: 1fr 2fr;\n      grid-template-columns: 1fr 2fr;\n}\n#historical-legacy-page .form-container[data-v-14dce9b6] {\n    grid-row: 1 / 2;\n    grid-column: 1 / 2;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 100%;\n    padding: 1rem;\n}\n#historical-legacy-page .map-container[data-v-14dce9b6] {\n    grid-row: 1 / 2;\n    grid-column: 2 / 3;\n    height: 100%;\n}\n#historical-legacy-page .table-container[data-v-14dce9b6] {\n    grid-row: 2 / 3;\n    grid-column: 1 / 3;\n    height: 100%;\n    overflow-y: auto;\n}\n#historical-legacy-page .table-container table[data-v-14dce9b6] {\n      position: relative;\n      width: 100%;\n      border-collapse: collapse;\n}\n#historical-legacy-page .table-container table thead[data-v-14dce9b6] {\n        position: -webkit-sticky;\n        position: sticky;\n        top: 0;\n        z-index: 10;\n        background-color: var(--btn-header-bg);\n        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);\n}\n#historical-legacy-page .table-container table th[data-v-14dce9b6],\n      #historical-legacy-page .table-container table td[data-v-14dce9b6] {\n        padding: 5px;\n        border: 1px solid #ddd;\n}\n@media (max-width: 995px) {\n#historical-legacy-page[data-v-14dce9b6] {\n      -ms-grid-rows: min-content 1fr 1fr;\n          grid-template-rows: min-content 1fr 1fr;\n      -ms-grid-columns: 1fr;\n          grid-template-columns: 1fr;\n      height: auto;\n}\n#historical-legacy-page .form-container[data-v-14dce9b6] {\n        -ms-grid-row: 1;\n            grid-row: 1;\n        -ms-grid-column: 1;\n            grid-column: 1;\n        min-height: 320px;\n        height: auto;\n}\n#historical-legacy-page .map-container[data-v-14dce9b6] {\n        -ms-grid-row: 2;\n            grid-row: 2;\n        -ms-grid-column: 1;\n            grid-column: 1;\n        height: 50vh;\n        overflow: scroll;\n}\n#historical-legacy-page .table-container[data-v-14dce9b6] {\n        -ms-grid-row: 3;\n            grid-row: 3;\n        -ms-grid-column: 1;\n            grid-column: 1;\n        max-height: 50vh;\n        overflow-y: auto;\n}\n}\n.row[data-v-14dce9b6] {\n  margin: 0;\n  padding: 0;\n}\n.row .title[data-v-14dce9b6] {\n  font-size: 14px;\n}\n@media screen and (max-width: 991px) {\n.row .title[data-v-14dce9b6] {\n      width: 200px;\n      display: inline-block;\n      padding-top: 5px;\n}\n}\n@media screen and (max-width: 991px) {\n.row .title[data-v-14dce9b6] {\n      display: block;\n}\n}\n.row .sub[data-v-14dce9b6] {\n  position: absolute;\n  color: rgba(0, 0, 0, 0.34);\n  font-weight: 500;\n  font-size: 12px;\n}\n@media screen and (max-width: 991px) {\n.row .sub[data-v-14dce9b6] {\n      display: inline-block;\n}\n}\n.row #borrar[data-v-14dce9b6] {\n  height: 30px;\n  font-size: 12px;\n  padding-top: 1px;\n  margin-top: -5px;\n}\n.row #borrar i[data-v-14dce9b6] {\n    font-size: inherit;\n    padding: 0 !important;\n}\n@media screen and (max-width: 991px) {\n.row #borrar[data-v-14dce9b6] {\n      display: block;\n      margin: 30px auto;\n}\n}\n@media screen and (max-width: 991px) {\n.row .bottom-input[data-v-14dce9b6] {\n    margin-top: 20px;\n    padding-left: 30px;\n    margin-bottom: 50px;\n}\n}\n.row .input-field[data-v-14dce9b6] {\n  display: inline-block;\n}\n.row .input-field #latitud[data-v-14dce9b6],\n  .row .input-field #longitud[data-v-14dce9b6] {\n    width: 100px;\n}\n@media screen and (max-width: 991px) {\n.row .input-field #latitud[data-v-14dce9b6],\n      .row .input-field #longitud[data-v-14dce9b6] {\n        width: 70px;\n}\n}\n.row .input-field .input-3[data-v-14dce9b6] {\n    width: 40px;\n    margin: 0 10px;\n}\n.btn-default[data-v-14dce9b6]:hover, .btn-default[data-v-14dce9b6]:focus, .btn-default[data-v-14dce9b6]:active {\n  background: var(--btn-default) !important;\n}\n@media screen and (max-width: 991px) {\n.btn-default[data-v-14dce9b6] {\n    margin: 25px;\n}\n}\n.color-2 .irs-bar[data-v-14dce9b6],\n.color-2 .irs-bar-edge[data-v-14dce9b6] {\n  background: red;\n}\n.col-md-6[data-v-14dce9b6],\n.col-xs-12[data-v-14dce9b6] {\n  margin: 0;\n  padding: 0;\n}\n.container-fluid[data-v-14dce9b6] {\n  background-color: white;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\ntable[data-v-14dce9b6],\n.panel-body[data-v-14dce9b6] {\n  padding: 0;\n  margin: 0;\n}\n@media screen and (max-width: 991px) {\ntable[data-v-14dce9b6],\n    .panel-body[data-v-14dce9b6] {\n      padding: 0;\n}\n}\ntable .info[data-v-14dce9b6],\n  .panel-body .info[data-v-14dce9b6] {\n    cursor: pointer;\n    background-color: #fff;\n}\ntable .info td[data-v-14dce9b6],\n    .panel-body .info td[data-v-14dce9b6] {\n      text-align: left;\n      padding-left: 25px;\n      background-color: transparent;\n}\ntable .info[data-v-14dce9b6]:hover,\n    .panel-body .info[data-v-14dce9b6]:hover {\n      background-color: #E0E0E0;\n}\ntable th[data-v-14dce9b6],\n  .panel-body th[data-v-14dce9b6] {\n    text-align: left;\n    padding-left: 25px;\n    background-color: var(--btn-header-bg);\n    color: #fff;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-14dce9b6],\n      .panel-body th[data-v-14dce9b6] {\n        font-size: 12px;\n}\n}\ntable .nombre-alarma[data-v-14dce9b6],\n  .panel-body .nombre-alarma[data-v-14dce9b6] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-14dce9b6],\n  .panel-body .panel-body[data-v-14dce9b6] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-14dce9b6],\n    .panel-body .panel-title[data-v-14dce9b6] {\n      font-size: 12px;\n}\n}\ntable .selectedRow[data-v-14dce9b6],\n  .panel-body .selectedRow[data-v-14dce9b6] {\n    background: var(--selected-row);\n    color: #fff;\n}\ntable .selectedRow[data-v-14dce9b6]:hover,\n  .panel-body .selectedRow[data-v-14dce9b6]:hover {\n    background: var(--selected-row-hover);\n    color: #fff;\n}\n#loading-modal-modal[data-v-14dce9b6] {\n  background-color: var(--loading-background-color) !important;\n}\n#loading-modal-modal[data-v-14dce9b6] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".row[data-v-18f81f81]{margin:0;padding:0}.col-md-6[data-v-18f81f81],.col-xs-12[data-v-18f81f81]{padding:0!important}.container-fluid[data-v-18f81f81]{background-color:#fff;width:100%;padding:0;margin:0}.panel-body[data-v-18f81f81],table[data-v-18f81f81]{overflow:scroll;height:65vh;padding:0;margin:0}.panel-body .info td[data-v-18f81f81],table .info td[data-v-18f81f81]{background-color:#eee}.panel-body th[data-v-18f81f81],table th[data-v-18f81f81]{text-align:left;padding-left:25px}@media screen and (max-width:415px){.panel-body th[data-v-18f81f81],table th[data-v-18f81f81]{font-size:12px}}.panel-body td[data-v-18f81f81],table td[data-v-18f81f81]{text-align:left;padding-left:25px}.panel-body td i[data-v-18f81f81],table td i[data-v-18f81f81]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body td i[data-v-18f81f81]:hover,table td i[data-v-18f81f81]:hover{color:var(--btn-default)}.panel-body .nombre-alarma[data-v-18f81f81],table .nombre-alarma[data-v-18f81f81]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-18f81f81],table .panel-body[data-v-18f81f81]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-18f81f81],table .panel-title[data-v-18f81f81]{font-size:12px}}.panel-body-two[data-v-18f81f81]{overflow:scroll;height:65vh;padding:0;margin:0}.panel-body-two .info td[data-v-18f81f81]{background-color:#eee}.panel-body-two th[data-v-18f81f81]{text-align:left;padding-left:25px}@media screen and (max-width:415px){.panel-body-two th[data-v-18f81f81]{font-size:12px}}.panel-body-two td[data-v-18f81f81]{text-align:left;padding-left:25px}.panel-body-two td i[data-v-18f81f81]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body-two td i[data-v-18f81f81]:hover{color:var(--btn-default)}.panel-body-two .nombre-alarma[data-v-18f81f81]{background-color:var(--btn-default);color:#fff}.panel-body-two .panel-body[data-v-18f81f81]{padding:0}@media screen and (max-width:415px){.panel-body-two .panel-title[data-v-18f81f81]{font-size:12px}}.btn-default[data-v-18f81f81]{background:var(--btn-default-hover)}.btn-default[data-v-18f81f81]:active,.btn-default[data-v-18f81f81]:focus,.btn-default[data-v-18f81f81]:hover{background:var(--btn-default)!important}#reportes-page[data-v-18f81f81]{padding-top:70px;background-color:#eee;height:100vh}#reportes-page #formulario-top[data-v-18f81f81]{height:30vh}@media screen and (max-width:767px){#reportes-page #formulario-top[data-v-18f81f81]{height:45vh}}#reportes-page #range-wrapper[data-v-18f81f81]{margin:50px auto}.color-2 .irs-bar-edge[data-v-18f81f81],.color-2 .irs-bar[data-v-18f81f81]{background:red}.error[data-v-18f81f81]{border:2px solid red!important}.print_btn[data-v-18f81f81]{width:100%;background-color:var(--btn-default);padding:8px;font-weight:500;color:#fff}.print_btn[data-v-18f81f81]:hover{background-color:var(--btn-default-bg)}.print_btn[data-v-18f81f81]:active{background-color:gray;color:#fff}#loading-modal-modal[data-v-18f81f81]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Historico/Reportes.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,SAAW,CACZ,AACD,uDAEE,mBAAwB,CACzB,AACD,kCACE,sBAAwB,AACxB,WAAY,AACZ,UAAW,AACX,QAAU,CACX,AACD,oDAEE,gBAAiB,AACjB,YAAa,AACb,UAAa,AACb,QAAU,CACX,AACD,sEAEI,qBAA0B,CAC7B,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,8DAEM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,0EAEQ,wBAA0B,CACjC,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAW,CACd,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA,AACD,iCACE,gBAAiB,AACjB,YAAa,AACb,UAAe,AACf,QAAU,CACX,AACD,0CACI,qBAA0B,CAC7B,AACD,oCACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,oCACQ,cAAgB,CACvB,CACA,AACD,oCACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,sCACM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,4CACQ,wBAA0B,CACjC,AACD,gDACI,oCAAqC,AACrC,UAAa,CAChB,AACD,6CACI,SAAW,CACd,AACD,oCACA,8CACM,cAAgB,CACrB,CACA,AACD,8BACE,mCAAqC,CACtC,AACD,6GACI,uCAA0C,CAC7C,AACD,gCACE,iBAAkB,AAClB,sBAA0B,AAC1B,YAAc,CACf,AACD,gDACI,WAAa,CAChB,AACD,oCACA,gDACQ,WAAa,CACpB,CACA,AACD,+CACI,gBAAkB,CACrB,AACD,2EAEE,cAAgB,CACjB,AACD,wBACE,8BAAiC,CAClC,AACD,4BACE,WAAY,AACZ,oCAAqC,AACrC,YAAa,AACb,gBAAiB,AACjB,UAAa,CACd,AACD,kCACE,sCAAwC,CACzC,AACD,mCACE,sBAAuB,AACvB,UAAa,CACd,AACD,sCACE,0DAA6D,CAC9D","file":"Reportes.vue","sourcesContent":["\n.row[data-v-18f81f81] {\n  margin: 0;\n  padding: 0;\n}\n.col-md-6[data-v-18f81f81],\n.col-xs-12[data-v-18f81f81] {\n  padding: 0px !important;\n}\n.container-fluid[data-v-18f81f81] {\n  background-color: white;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\ntable[data-v-18f81f81],\n.panel-body[data-v-18f81f81] {\n  overflow: scroll;\n  height: 65vh;\n  padding: 0px;\n  margin: 0;\n}\ntable .info td[data-v-18f81f81],\n  .panel-body .info td[data-v-18f81f81] {\n    background-color: #eeeeee;\n}\ntable th[data-v-18f81f81],\n  .panel-body th[data-v-18f81f81] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-18f81f81],\n      .panel-body th[data-v-18f81f81] {\n        font-size: 12px;\n}\n}\ntable td[data-v-18f81f81],\n  .panel-body td[data-v-18f81f81] {\n    text-align: left;\n    padding-left: 25px;\n}\ntable td i[data-v-18f81f81],\n    .panel-body td i[data-v-18f81f81] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\ntable td i[data-v-18f81f81]:hover,\n      .panel-body td i[data-v-18f81f81]:hover {\n        color: var(--btn-default);\n}\ntable .nombre-alarma[data-v-18f81f81],\n  .panel-body .nombre-alarma[data-v-18f81f81] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-18f81f81],\n  .panel-body .panel-body[data-v-18f81f81] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-18f81f81],\n    .panel-body .panel-title[data-v-18f81f81] {\n      font-size: 12px;\n}\n}\n.panel-body-two[data-v-18f81f81] {\n  overflow: scroll;\n  height: 65vh;\n  padding: 0px 0;\n  margin: 0;\n}\n.panel-body-two .info td[data-v-18f81f81] {\n    background-color: #eeeeee;\n}\n.panel-body-two th[data-v-18f81f81] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\n.panel-body-two th[data-v-18f81f81] {\n        font-size: 12px;\n}\n}\n.panel-body-two td[data-v-18f81f81] {\n    text-align: left;\n    padding-left: 25px;\n}\n.panel-body-two td i[data-v-18f81f81] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\n.panel-body-two td i[data-v-18f81f81]:hover {\n        color: var(--btn-default);\n}\n.panel-body-two .nombre-alarma[data-v-18f81f81] {\n    background-color: var(--btn-default);\n    color: white;\n}\n.panel-body-two .panel-body[data-v-18f81f81] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\n.panel-body-two .panel-title[data-v-18f81f81] {\n      font-size: 12px;\n}\n}\n.btn-default[data-v-18f81f81] {\n  background: var(--btn-default-hover);\n}\n.btn-default[data-v-18f81f81]:hover, .btn-default[data-v-18f81f81]:focus, .btn-default[data-v-18f81f81]:active {\n    background: var(--btn-default) !important;\n}\n#reportes-page[data-v-18f81f81] {\n  padding-top: 70px;\n  background-color: #eeeeee;\n  height: 100vh;\n}\n#reportes-page #formulario-top[data-v-18f81f81] {\n    height: 30vh;\n}\n@media screen and (max-width: 767px) {\n#reportes-page #formulario-top[data-v-18f81f81] {\n        height: 45vh;\n}\n}\n#reportes-page #range-wrapper[data-v-18f81f81] {\n    margin: 50px auto;\n}\n.color-2 .irs-bar[data-v-18f81f81],\n.color-2 .irs-bar-edge[data-v-18f81f81] {\n  background: red;\n}\n.error[data-v-18f81f81] {\n  border: 2px solid red !important;\n}\n.print_btn[data-v-18f81f81] {\n  width: 100%;\n  background-color: var(--btn-default);\n  padding: 8px;\n  font-weight: 500;\n  color: white;\n}\n.print_btn[data-v-18f81f81]:hover {\n  background-color: var(--btn-default-bg);\n}\n.print_btn[data-v-18f81f81]:active {\n  background-color: gray;\n  color: white;\n}\n#loading-modal-modal[data-v-18f81f81] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#pdf[data-v-195b8fc4]{width:100%}#pdf .logo_leak[data-v-195b8fc4]{width:200px;text-align:left}#pdf .logo_pem[data-v-195b8fc4]{width:200px;float:right}#pdf #row[data-v-195b8fc4]{padding:25px}#pdf img[data-v-195b8fc4]{width:100%}#pdf hr[data-v-195b8fc4]{color:var(--btn-default)}#pdf #imgChart[data-v-195b8fc4]{width:100%;margin-top:100px}#pdf h4[data-v-195b8fc4]{text-align:center;text-transform:uppercase;color:#000}#pdf .pdf__info[data-v-195b8fc4]{margin:0 auto;display:block}#pdf .pdf__titles[data-v-195b8fc4]{color:var(--btn-default)}#pdf div#pdf[data-v-195b8fc4]{max-height:200px;height:200px}#pdf div#linechart[data-v-195b8fc4]{display:none}#pdf img#leak[data-v-195b8fc4],#pdf img#pem[data-v-195b8fc4]{display:inline-block;width:115px}#pdf img#pem[data-v-195b8fc4]{padding-left:400px}#pdf h4#h41[data-v-195b8fc4]{font-size:30px;font-weight:400;text-transform:uppercase;padding:0;margin-top:10px;margin-bottom:10px}#pdf hr#hr1[data-v-195b8fc4]{background-color:#fff;border-top:2px solid var(--btn-default)}#pdf span#titles[data-v-195b8fc4]{color:var(--btn-default);text-transform:uppercase;margin-left:4px}#pdf #tablecontainer[data-v-195b8fc4]{height:440px}#pdf table#tableholder[data-v-195b8fc4]{height:50%;width:100%;margin:0;text-align:center}#pdf thead#header[data-v-195b8fc4],#pdf tr#trh[data-v-195b8fc4]{width:100%;padding:2px;background-color:var(--btn-default)}#pdf th#thh[data-v-195b8fc4]{font-size:12pt;align:left;font-weight:400;padding:5px;border:1.5px solid var(--btn-default);color:#fff}#pdf td#tdc[data-v-195b8fc4]{font-size:10pt;text-align:left;padding:2px;border:1px solid #777}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Historico/PdfDiv.vue"],"names":[],"mappings":"AACA,sBACE,UAAY,CACb,AACD,iCACI,YAAa,AACb,eAAiB,CACpB,AACD,gCACI,YAAa,AACb,WAAa,CAChB,AACD,2BACI,YAAc,CACjB,AACD,0BACI,UAAY,CACf,AACD,yBACI,wBAA0B,CAC7B,AACD,gCACI,WAAY,AACZ,gBAAkB,CACrB,AACD,yBACI,kBAAmB,AACnB,yBAA0B,AAC1B,UAAY,CACf,AACD,iCACI,cAAe,AACf,aAAe,CAClB,AACD,mCACI,wBAA0B,CAC7B,AACD,8BACI,iBAAkB,AAClB,YAAc,CACjB,AACD,oCACI,YAAc,CACjB,AAKD,6DAHI,qBAAsB,AACtB,WAAa,CAMhB,AAJD,8BACI,kBAAoB,CAGvB,AACD,6BACI,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,UAAW,AACX,gBAAiB,AACjB,kBAAoB,CACvB,AACD,6BACI,sBAAuB,AACvB,uCAAyC,CAC5C,AACD,kCACI,yBAA0B,AAC1B,yBAA0B,AAC1B,eAAiB,CACpB,AACD,sCACI,YAAc,CACjB,AACD,wCACI,WAAY,AACZ,WAAY,AACZ,SAAU,AACV,iBAAmB,CACtB,AAMD,gEAJI,WAAY,AACZ,YAAa,AACb,mCAAqC,CAMxC,AACD,6BACI,eAAgB,AAChB,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,sCAAuC,AACvC,UAAa,CAChB,AACD,6BACI,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,qBAA0B,CAC7B","file":"PdfDiv.vue","sourcesContent":["\n#pdf[data-v-195b8fc4] {\n  width: 100%;\n}\n#pdf .logo_leak[data-v-195b8fc4] {\n    width: 200px;\n    text-align: left;\n}\n#pdf .logo_pem[data-v-195b8fc4] {\n    width: 200px;\n    float: right;\n}\n#pdf #row[data-v-195b8fc4] {\n    padding: 25px;\n}\n#pdf img[data-v-195b8fc4] {\n    width: 100%;\n}\n#pdf hr[data-v-195b8fc4] {\n    color: var(--btn-default);\n}\n#pdf #imgChart[data-v-195b8fc4] {\n    width: 100%;\n    margin-top: 100px;\n}\n#pdf h4[data-v-195b8fc4] {\n    text-align: center;\n    text-transform: uppercase;\n    color: #000;\n}\n#pdf .pdf__info[data-v-195b8fc4] {\n    margin: 0 auto;\n    display: block;\n}\n#pdf .pdf__titles[data-v-195b8fc4] {\n    color: var(--btn-default);\n}\n#pdf div#pdf[data-v-195b8fc4] {\n    max-height: 200px;\n    height: 200px;\n}\n#pdf div#linechart[data-v-195b8fc4] {\n    display: none;\n}\n#pdf img#leak[data-v-195b8fc4] {\n    display: inline-block;\n    width: 115px;\n}\n#pdf img#pem[data-v-195b8fc4] {\n    padding-left: 400px;\n    display: inline-block;\n    width: 115px;\n}\n#pdf h4#h41[data-v-195b8fc4] {\n    font-size: 30px;\n    font-weight: 400;\n    text-transform: uppercase;\n    padding: 0;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n#pdf hr#hr1[data-v-195b8fc4] {\n    background-color: #fff;\n    border-top: 2px solid var(--btn-default);\n}\n#pdf span#titles[data-v-195b8fc4] {\n    color: var(--btn-default);\n    text-transform: uppercase;\n    margin-left: 4px;\n}\n#pdf #tablecontainer[data-v-195b8fc4] {\n    height: 440px;\n}\n#pdf table#tableholder[data-v-195b8fc4] {\n    height: 50%;\n    width: 100%;\n    margin: 0;\n    text-align: center;\n}\n#pdf thead#header[data-v-195b8fc4] {\n    width: 100%;\n    padding: 2px;\n    background-color: var(--btn-default);\n}\n#pdf tr#trh[data-v-195b8fc4] {\n    width: 100%;\n    padding: 2px;\n    background-color: var(--btn-default);\n}\n#pdf th#thh[data-v-195b8fc4] {\n    font-size: 12pt;\n    align: left;\n    font-weight: 400;\n    padding: 5px;\n    border: 1.5px solid var(--btn-default);\n    color: white;\n}\n#pdf td#tdc[data-v-195b8fc4] {\n    font-size: 10pt;\n    text-align: left;\n    padding: 2px;\n    border: 1px solid #777777;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-19b0c63f]{margin:0;padding:0;width:400vw;height:300vh;z-index:1;margin-top:-50px;background-color:#000}#presion[data-v-19b0c63f],canvas[data-v-19b0c63f]{background-color:#000}#presion #formulario-top[data-v-19b0c63f]{margin-top:80px;border-bottom:1px solid rgba(0,0,0,.34)}#presion #graficas[data-v-19b0c63f]{background-color:#000;margin:0;padding:0;padding-top:15vh}#presion .btn-default[data-v-19b0c63f]{margin-top:0;background-color:var(--btn-default)}#presion .btn-default[data-v-19b0c63f]:active,#presion .btn-default[data-v-19b0c63f]:focus,#presion .btn-default[data-v-19b0c63f]:hover{background-color:var(--btn-default-hover)!important}@media screen and (max-width:767px){#presion .btn-default[data-v-19b0c63f]{margin-top:50px}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Charts/CustomLineChart.vue"],"names":[],"mappings":"AACA,kCACE,SAAU,AACV,UAAW,AACX,YAAa,AACb,aAAc,AACd,UAAW,AACX,iBAAkB,AAClB,qBAAuB,CACxB,AAID,kDACE,qBAAwB,CACzB,AACD,0CACI,gBAAiB,AACjB,uCAA6C,CAChD,AACD,oCACI,sBAA0B,AAC1B,SAAU,AACV,UAAW,AACX,gBAAkB,CACrB,AACD,uCACI,aAAc,AACd,mCAAqC,CACxC,AACD,wIACM,mDAAsD,CAC3D,AACD,oCACA,uCACQ,eAAiB,CACxB,CACA","file":"CustomLineChart.vue","sourcesContent":["\n.container-fluid[data-v-19b0c63f] {\n  margin: 0;\n  padding: 0;\n  width: 400vw;\n  height: 300vh;\n  z-index: 1;\n  margin-top: -50px;\n  background-color: #000;\n}\ncanvas[data-v-19b0c63f] {\n  background-color: black;\n}\n#presion[data-v-19b0c63f] {\n  background-color: black;\n}\n#presion #formulario-top[data-v-19b0c63f] {\n    margin-top: 80px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n#presion #graficas[data-v-19b0c63f] {\n    background-color: #000000;\n    margin: 0;\n    padding: 0;\n    padding-top: 15vh;\n}\n#presion .btn-default[data-v-19b0c63f] {\n    margin-top: 0;\n    background-color: var(--btn-default);\n}\n#presion .btn-default[data-v-19b0c63f]:hover, #presion .btn-default[data-v-19b0c63f]:active, #presion .btn-default[data-v-19b0c63f]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n@media screen and (max-width: 767px) {\n#presion .btn-default[data-v-19b0c63f] {\n        margin-top: 50px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".md-card[data-v-1ba72a1b]{width:240px;height:11.5rem;margin:6px;display:inline-block;vertical-align:top;border-radius:10px;border:1px solid #dfdfdf;background:#f7f7f7}.box-icons[data-v-1ba72a1b]{font-size:small;color:#166fb8;margin-top:5px}.card-normal-text[data-v-1ba72a1b]{font-size:12px}.card-detail-text[data-v-1ba72a1b]{font-size:smaller}.card-small-text[data-v-1ba72a1b]{font-size:xx-small}.box[data-v-1ba72a1b]{display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;height:100%}.box .content[data-v-1ba72a1b]{-ms-flex:1 1 auto;flex:1 1 auto;padding:4px 8px;background-color:#fff}.box .header[data-v-1ba72a1b]{-ms-flex:0 1 auto;flex:0 1 auto;padding:4px 6px}.box .header .header-text[data-v-1ba72a1b]{font-size:small;color:#000}.box .footer[data-v-1ba72a1b]{-ms-flex:0 1 auto;flex:0 1 auto;padding:4px 6px}.box .footer .footer-text[data-v-1ba72a1b]{font-size:smaller;color:gray}.box .sub-header[data-v-1ba72a1b]{font-size:small;color:gray;margin:4px 0}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Salud/Salud.vue"],"names":[],"mappings":"AACA,0BACE,YAAa,AACb,eAAgB,AAChB,WAAY,AACZ,qBAAsB,AACtB,mBAAoB,AACpB,mBAAoB,AAGpB,yBAAsB,AACtB,kBAAoB,CACrB,AACD,4BACE,gBAAiB,AACjB,cAAe,AACf,cAAgB,CACjB,AACD,mCACE,cAAgB,CACjB,AACD,mCACE,iBAAmB,CACpB,AACD,kCACE,kBAAoB,CACrB,AACD,sBACE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,iBAAkB,AACtB,WAAa,CACd,AACD,+BACE,kBAAmB,AACf,cAAe,AACnB,gBAAyB,AACzB,qBAAwB,CACzB,AACD,8BACE,kBAAmB,AACf,cAAe,AACnB,eAAyB,CAM1B,AACD,2CACE,gBAAiB,AACjB,UAAa,CACd,AACD,8BACE,kBAAmB,AACf,cAAe,AACnB,eAAyB,CAC1B,AACD,2CACE,kBAAmB,AACnB,UAAY,CACb,AACD,kCACE,gBAAiB,AACjB,WAAY,AACZ,YAAwB,CACzB","file":"Salud.vue","sourcesContent":["\n.md-card[data-v-1ba72a1b] {\n  width: 240px;\n  height: 11.5rem;\n  margin: 6px;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 10px;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #dfdfdf;\n  background: #f7f7f7;\n}\n.box-icons[data-v-1ba72a1b] {\n  font-size: small;\n  color: #166FB8;\n  margin-top: 5px;\n}\n.card-normal-text[data-v-1ba72a1b] {\n  font-size: 12px;\n}\n.card-detail-text[data-v-1ba72a1b] {\n  font-size: smaller;\n}\n.card-small-text[data-v-1ba72a1b] {\n  font-size: xx-small;\n}\n.box[data-v-1ba72a1b] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  height: 100%;\n}\n.box .content[data-v-1ba72a1b] {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  padding: 4px 8px 4px 8px;\n  background-color: white;\n}\n.box .header[data-v-1ba72a1b] {\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n  padding: 4px 6px 4px 6px;\n  /* The above is shorthand for:\n  flex-grow: 0,\n  flex-shrink: 1,\n  flex-basis: auto\n  */\n}\n.box .header .header-text[data-v-1ba72a1b] {\n  font-size: small;\n  color: black;\n}\n.box .footer[data-v-1ba72a1b] {\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n  padding: 4px 6px 4px 6px;\n}\n.box .footer .footer-text[data-v-1ba72a1b] {\n  font-size: smaller;\n  color: gray;\n}\n.box .sub-header[data-v-1ba72a1b] {\n  font-size: small;\n  color: gray;\n  margin: 4px 0px 4px 0px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".bottom-offset[data-v-218db49c]{margin-bottom:20px}.hide-line-chart[data-v-218db49c]{display:none}.highlight[data-v-218db49c]{color:red}td i[data-v-218db49c]{color:rgba(0,0,0,.34);cursor:pointer}td i[data-v-218db49c]:hover{color:var(--btn-default)}td .center-option[data-v-218db49c]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}#pdf[data-v-218db49c]{width:100%}#pdf .logo_leak[data-v-218db49c]{width:150px;text-align:left}#pdf .logo_pem[data-v-218db49c]{width:150px;float:right}#pdf #row[data-v-218db49c]{padding:25px}#pdf img[data-v-218db49c]{width:100%}#pdf hr[data-v-218db49c]{color:var(--btn-default)}#pdf table[data-v-218db49c]{width:100%}#pdf .title__td[data-v-218db49c]{background-color:var(--btn-default);border:0 solid #e0e0e0;color:#fff}#pdf th[data-v-218db49c]{padding:10px}#pdf td[data-v-218db49c]{padding:5px;border:1px solid #e0e0e0}#pdf #imgChart[data-v-218db49c]{width:100%;margin-top:100px}#pdf h4[data-v-218db49c]{text-align:left;text-transform:uppercase;color:#666}#pdf .pdf__info[data-v-218db49c]{margin:0 auto;display:block}#pdf p[data-v-218db49c]{color:#666}#pdf .pdf__titles[data-v-218db49c]{color:var(--btn-default)}#pdf .yellow__hr[data-v-218db49c]{background-color:var(--btn-default);height:2px}#pagebreak[data-v-218db49c]{display:block;page-break-after:always}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Reportes/PdfDiv.vue"],"names":[],"mappings":"AACA,gCACE,kBAAoB,CACrB,AACD,kCACE,YAAc,CACf,AACD,4BACE,SAAW,CACZ,AACD,sBACE,sBAA2B,AAC3B,cAAgB,CACjB,AACD,4BACI,wBAA0B,CAC7B,AACD,mCACE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,sBACE,UAAY,CACb,AACD,iCACI,YAAa,AACb,eAAiB,CACpB,AACD,gCACI,YAAa,AACb,WAAa,CAChB,AACD,2BACI,YAAc,CACjB,AACD,0BACI,UAAY,CACf,AACD,yBACI,wBAA0B,CAC7B,AACD,4BACI,UAAY,CACf,AACD,iCACI,oCAAqC,AACrC,uBAA0B,AAC1B,UAAa,CAChB,AACD,yBACI,YAAc,CACjB,AACD,yBACI,YAAa,AACb,wBAA0B,CAC7B,AACD,gCACI,WAAY,AACZ,gBAAkB,CACrB,AACD,yBACI,gBAAiB,AACjB,yBAA0B,AAC1B,UAAY,CACf,AACD,iCACI,cAAe,AACf,aAAe,CAClB,AACD,wBACI,UAAY,CACf,AACD,mCACI,wBAA0B,CAC7B,AACD,kCACI,oCAAqC,AACrC,UAAY,CACf,AACD,4BACE,cAAe,AACf,uBAAyB,CAC1B","file":"PdfDiv.vue","sourcesContent":["\n.bottom-offset[data-v-218db49c] {\n  margin-bottom: 20px;\n}\n.hide-line-chart[data-v-218db49c] {\n  display: none;\n}\n.highlight[data-v-218db49c] {\n  color: red;\n}\ntd i[data-v-218db49c] {\n  color: rgba(0, 0, 0, 0.34);\n  cursor: pointer;\n}\ntd i[data-v-218db49c]:hover {\n    color: var(--btn-default);\n}\ntd .center-option[data-v-218db49c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n#pdf[data-v-218db49c] {\n  width: 100%;\n}\n#pdf .logo_leak[data-v-218db49c] {\n    width: 150px;\n    text-align: left;\n}\n#pdf .logo_pem[data-v-218db49c] {\n    width: 150px;\n    float: right;\n}\n#pdf #row[data-v-218db49c] {\n    padding: 25px;\n}\n#pdf img[data-v-218db49c] {\n    width: 100%;\n}\n#pdf hr[data-v-218db49c] {\n    color: var(--btn-default);\n}\n#pdf table[data-v-218db49c] {\n    width: 100%;\n}\n#pdf .title__td[data-v-218db49c] {\n    background-color: var(--btn-default);\n    border: 0px solid #E0E0E0;\n    color: white;\n}\n#pdf th[data-v-218db49c] {\n    padding: 10px;\n}\n#pdf td[data-v-218db49c] {\n    padding: 5px;\n    border: 1px solid #E0E0E0;\n}\n#pdf #imgChart[data-v-218db49c] {\n    width: 100%;\n    margin-top: 100px;\n}\n#pdf h4[data-v-218db49c] {\n    text-align: left;\n    text-transform: uppercase;\n    color: #666;\n}\n#pdf .pdf__info[data-v-218db49c] {\n    margin: 0 auto;\n    display: block;\n}\n#pdf p[data-v-218db49c] {\n    color: #666;\n}\n#pdf .pdf__titles[data-v-218db49c] {\n    color: var(--btn-default);\n}\n#pdf .yellow__hr[data-v-218db49c] {\n    background-color: var(--btn-default);\n    height: 2px;\n}\n#pagebreak[data-v-218db49c] {\n  display: block;\n  page-break-after: always;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".row[data-v-3ad23b5c]{margin:0;padding:0}.col-md-6[data-v-3ad23b5c],.col-xs-12[data-v-3ad23b5c]{padding:0!important}.container-fluid[data-v-3ad23b5c]{background-color:#fff;width:100%;padding:0;margin:0}.panel-body[data-v-3ad23b5c],table[data-v-3ad23b5c]{overflow-y:scroll;overflow-x:hidden;max-height:65vh;height:100%;padding:0;margin:0}.panel-body tr[data-v-3ad23b5c],table tr[data-v-3ad23b5c]{margin:0!important;padding:0!important}.panel-body .info td[data-v-3ad23b5c],table .info td[data-v-3ad23b5c]{background-color:#eee}.panel-body th[data-v-3ad23b5c],table th[data-v-3ad23b5c]{text-align:left;padding-left:25px}@media screen and (max-width:415px){.panel-body th[data-v-3ad23b5c],table th[data-v-3ad23b5c]{font-size:12px}}.panel-body td[data-v-3ad23b5c],table td[data-v-3ad23b5c]{vertical-align:inherit}.panel-body td i[data-v-3ad23b5c],table td i[data-v-3ad23b5c]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body td i[data-v-3ad23b5c]:hover,table td i[data-v-3ad23b5c]:hover{color:var(--btn-default)}.panel-body td .view-report[data-v-3ad23b5c],table td .view-report[data-v-3ad23b5c]{padding-left:10px}.panel-body .nombre-alarma[data-v-3ad23b5c],table .nombre-alarma[data-v-3ad23b5c]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-3ad23b5c],table .panel-body[data-v-3ad23b5c]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-3ad23b5c],table .panel-title[data-v-3ad23b5c]{font-size:12px}}.panel-body-two[data-v-3ad23b5c]{overflow:scroll;overflow-x:hidden;max-height:65vh;height:99%;padding:3px 0;margin:0}.panel-body-two .info td[data-v-3ad23b5c]{background-color:#eee}.panel-body-two th[data-v-3ad23b5c]{text-align:left;padding-left:25px}@media screen and (max-width:415px){.panel-body-two th[data-v-3ad23b5c]{font-size:12px}}.panel-body-two td[data-v-3ad23b5c]{text-align:left;padding-left:25px}.panel-body-two td i[data-v-3ad23b5c]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body-two td i[data-v-3ad23b5c]:hover{color:var(--btn-default)}.panel-body-two .nombre-alarma[data-v-3ad23b5c]{background-color:var(--btn-default);color:#fff}.panel-body-two .panel-body[data-v-3ad23b5c]{padding:0}@media screen and (max-width:415px){.panel-body-two .panel-title[data-v-3ad23b5c]{font-size:12px}}.btn-default[data-v-3ad23b5c]{background:var(--btn-default-hover)}.btn-default[data-v-3ad23b5c]:active,.btn-default[data-v-3ad23b5c]:focus,.btn-default[data-v-3ad23b5c]:hover{background:var(--btn-default)!important}#pagebreak[data-v-3ad23b5c]{display:block;page-break-after:always}#reportes-page[data-v-3ad23b5c]{padding-top:70px;background-color:#eee;height:100vh}#reportes-page #formulario-top[data-v-3ad23b5c]{height:20vh;padding-top:5vh}@media screen and (max-width:767px){#reportes-page #formulario-top[data-v-3ad23b5c]{height:45vh}}.color-2 .irs-bar-edge[data-v-3ad23b5c],.color-2 .irs-bar[data-v-3ad23b5c]{background:red}.error[data-v-3ad23b5c]{border:2px solid red!important}.print_btn[data-v-3ad23b5c]{width:100%;background-color:var(--btn-default);padding:8px;font-weight:500;color:#fff}.print_btn[data-v-3ad23b5c]:hover{background-color:var(--btn-default-bg)}.print_btn[data-v-3ad23b5c]:active{background-color:gray;color:#fff}#loading-modal-modal[data-v-3ad23b5c]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Reportes/Poll.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,SAAW,CACZ,AACD,uDAEE,mBAAwB,CACzB,AACD,kCACE,sBAAwB,AACxB,WAAY,AACZ,UAAW,AACX,QAAU,CACX,AACD,oDAEE,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,UAAa,AACb,QAAY,CACb,AACD,0DAEI,mBAAuB,AACvB,mBAAwB,CAC3B,AACD,sEAEI,qBAA0B,CAC7B,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,0DAEI,sBAAwB,CAC3B,AACD,8DAEM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,0EAEQ,wBAA0B,CACjC,AACD,oFAEM,iBAAmB,CACxB,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAa,CAChB,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA,AACD,iCACE,gBAAiB,AACjB,kBAAmB,AACnB,gBAAiB,AACjB,WAAY,AACZ,cAAe,AACf,QAAU,CACX,AACD,0CACI,qBAA0B,CAC7B,AACD,oCACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,oCACQ,cAAgB,CACvB,CACA,AACD,oCACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,sCACM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,4CACQ,wBAA0B,CACjC,AACD,gDACI,oCAAqC,AACrC,UAAa,CAChB,AACD,6CACI,SAAW,CACd,AACD,oCACA,8CACM,cAAgB,CACrB,CACA,AACD,8BACE,mCAAqC,CACtC,AACD,6GACI,uCAA0C,CAC7C,AACD,4BACE,cAAe,AACf,uBAAyB,CAC1B,AACD,gCACE,iBAAkB,AAClB,sBAA0B,AAC1B,YAAc,CACf,AACD,gDACI,YAAa,AACb,eAAiB,CACpB,AACD,oCACA,gDACQ,WAAa,CACpB,CACA,AACD,2EAEE,cAAgB,CACjB,AACD,wBACE,8BAAiC,CAClC,AACD,4BACE,WAAY,AACZ,oCAAqC,AACrC,YAAa,AACb,gBAAiB,AACjB,UAAa,CACd,AACD,kCACE,sCAAwC,CACzC,AACD,mCACE,sBAAuB,AACvB,UAAa,CACd,AACD,sCACE,0DAA6D,CAC9D","file":"Poll.vue","sourcesContent":["\n.row[data-v-3ad23b5c] {\n  margin: 0;\n  padding: 0;\n}\n.col-md-6[data-v-3ad23b5c],\n.col-xs-12[data-v-3ad23b5c] {\n  padding: 0px !important;\n}\n.container-fluid[data-v-3ad23b5c] {\n  background-color: white;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\ntable[data-v-3ad23b5c],\n.panel-body[data-v-3ad23b5c] {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  max-height: 65vh;\n  height: 100%;\n  padding: 0px;\n  margin: 0px;\n}\ntable tr[data-v-3ad23b5c],\n  .panel-body tr[data-v-3ad23b5c] {\n    margin: 0px !important;\n    padding: 0px !important;\n}\ntable .info td[data-v-3ad23b5c],\n  .panel-body .info td[data-v-3ad23b5c] {\n    background-color: #eeeeee;\n}\ntable th[data-v-3ad23b5c],\n  .panel-body th[data-v-3ad23b5c] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-3ad23b5c],\n      .panel-body th[data-v-3ad23b5c] {\n        font-size: 12px;\n}\n}\ntable td[data-v-3ad23b5c],\n  .panel-body td[data-v-3ad23b5c] {\n    vertical-align: inherit;\n}\ntable td i[data-v-3ad23b5c],\n    .panel-body td i[data-v-3ad23b5c] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\ntable td i[data-v-3ad23b5c]:hover,\n      .panel-body td i[data-v-3ad23b5c]:hover {\n        color: var(--btn-default);\n}\ntable td .view-report[data-v-3ad23b5c],\n    .panel-body td .view-report[data-v-3ad23b5c] {\n      padding-left: 10px;\n}\ntable .nombre-alarma[data-v-3ad23b5c],\n  .panel-body .nombre-alarma[data-v-3ad23b5c] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-3ad23b5c],\n  .panel-body .panel-body[data-v-3ad23b5c] {\n    padding: 0px;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-3ad23b5c],\n    .panel-body .panel-title[data-v-3ad23b5c] {\n      font-size: 12px;\n}\n}\n.panel-body-two[data-v-3ad23b5c] {\n  overflow: scroll;\n  overflow-x: hidden;\n  max-height: 65vh;\n  height: 99%;\n  padding: 3px 0;\n  margin: 0;\n}\n.panel-body-two .info td[data-v-3ad23b5c] {\n    background-color: #eeeeee;\n}\n.panel-body-two th[data-v-3ad23b5c] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\n.panel-body-two th[data-v-3ad23b5c] {\n        font-size: 12px;\n}\n}\n.panel-body-two td[data-v-3ad23b5c] {\n    text-align: left;\n    padding-left: 25px;\n}\n.panel-body-two td i[data-v-3ad23b5c] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\n.panel-body-two td i[data-v-3ad23b5c]:hover {\n        color: var(--btn-default);\n}\n.panel-body-two .nombre-alarma[data-v-3ad23b5c] {\n    background-color: var(--btn-default);\n    color: white;\n}\n.panel-body-two .panel-body[data-v-3ad23b5c] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\n.panel-body-two .panel-title[data-v-3ad23b5c] {\n      font-size: 12px;\n}\n}\n.btn-default[data-v-3ad23b5c] {\n  background: var(--btn-default-hover);\n}\n.btn-default[data-v-3ad23b5c]:hover, .btn-default[data-v-3ad23b5c]:focus, .btn-default[data-v-3ad23b5c]:active {\n    background: var(--btn-default) !important;\n}\n#pagebreak[data-v-3ad23b5c] {\n  display: block;\n  page-break-after: always;\n}\n#reportes-page[data-v-3ad23b5c] {\n  padding-top: 70px;\n  background-color: #eeeeee;\n  height: 100vh;\n}\n#reportes-page #formulario-top[data-v-3ad23b5c] {\n    height: 20vh;\n    padding-top: 5vh;\n}\n@media screen and (max-width: 767px) {\n#reportes-page #formulario-top[data-v-3ad23b5c] {\n        height: 45vh;\n}\n}\n.color-2 .irs-bar[data-v-3ad23b5c],\n.color-2 .irs-bar-edge[data-v-3ad23b5c] {\n  background: red;\n}\n.error[data-v-3ad23b5c] {\n  border: 2px solid red !important;\n}\n.print_btn[data-v-3ad23b5c] {\n  width: 100%;\n  background-color: var(--btn-default);\n  padding: 8px;\n  font-weight: 500;\n  color: white;\n}\n.print_btn[data-v-3ad23b5c]:hover {\n  background-color: var(--btn-default-bg);\n}\n.print_btn[data-v-3ad23b5c]:active {\n  background-color: gray;\n  color: white;\n}\n#loading-modal-modal[data-v-3ad23b5c] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-3c99c86a]{margin:0;padding:0}#presion[data-v-3c99c86a]{background-color:#eee}#presion #formulario-top[data-v-3c99c86a]{height:25vh;margin-top:80px;border-bottom:1px solid rgba(0,0,0,.34)}#presion #graficas[data-v-3c99c86a]{height:65vh}#presion .btn-default[data-v-3c99c86a]{margin-top:0;background-color:var(--btn-default)}#presion .btn-default[data-v-3c99c86a]:active,#presion .btn-default[data-v-3c99c86a]:focus,#presion .btn-default[data-v-3c99c86a]:hover{background-color:var(--btn-default-hover)!important}.nomen[data-v-3c99c86a]{height:100%;border-left:3px solid gray;text-align:center}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Reportes/Presion.vue"],"names":[],"mappings":"AACA,kCACE,SAAU,AACV,SAAW,CACZ,AACD,0BACE,qBAA0B,CAC3B,AACD,0CACI,YAAa,AACb,gBAAiB,AACjB,uCAA6C,CAChD,AACD,oCACI,WAAa,CAChB,AACD,uCACI,aAAc,AACd,mCAAqC,CACxC,AACD,wIACM,mDAAsD,CAC3D,AACD,wBACE,YAAa,AACb,2BAA4B,AAC5B,iBAAmB,CACpB","file":"Presion.vue","sourcesContent":["\n.container-fluid[data-v-3c99c86a] {\n  margin: 0;\n  padding: 0;\n}\n#presion[data-v-3c99c86a] {\n  background-color: #eeeeee;\n}\n#presion #formulario-top[data-v-3c99c86a] {\n    height: 25vh;\n    margin-top: 80px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n#presion #graficas[data-v-3c99c86a] {\n    height: 65vh;\n}\n#presion .btn-default[data-v-3c99c86a] {\n    margin-top: 0;\n    background-color: var(--btn-default);\n}\n#presion .btn-default[data-v-3c99c86a]:hover, #presion .btn-default[data-v-3c99c86a]:active, #presion .btn-default[data-v-3c99c86a]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n.nomen[data-v-3c99c86a] {\n  height: 100%;\n  border-left: 3px solid gray;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#home[data-v-3d9a511f]{margin:0;padding:0}#home-container[data-v-3d9a511f]{margin-right:.25rem;margin-bottom:0}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Home/Home.vue"],"names":[],"mappings":"AACA,uBACE,SAAU,AACV,SAAW,CACZ,AACD,iCACE,oBAAqB,AACrB,eAAmB,CACpB","file":"Home.vue","sourcesContent":["\n#home[data-v-3d9a511f] {\n  margin: 0;\n  padding: 0;\n}\n#home-container[data-v-3d9a511f] {\n  margin-right: .25rem;\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-3e30d702]{margin:0;padding:0}#presion[data-v-3e30d702]{background-color:#eee}#presion #formulario-top[data-v-3e30d702]{height:10vh;margin-top:80px;border-bottom:1px solid rgba(0,0,0,.34)}#presion #graficas[data-v-3e30d702]{height:65vh}#presion .btn-default[data-v-3e30d702]{margin-top:0;background-color:var(--btn-default)}#presion .btn-default[data-v-3e30d702]:active,#presion .btn-default[data-v-3e30d702]:focus,#presion .btn-default[data-v-3e30d702]:hover{background-color:var(--btn-default-hover)!important}.nomen[data-v-3e30d702]{height:100%;border-right:3px solid gray;text-align:center}.panel-body[data-v-3e30d702],table[data-v-3e30d702]{overflow:scroll;height:32vh;padding:0;border-bottom:1px solid #999;margin:20px 0}@media screen and (max-width:991px){.panel-body[data-v-3e30d702],table[data-v-3e30d702]{padding:0}}.panel-body .info td[data-v-3e30d702],table .info td[data-v-3e30d702]{background-color:#eee}.panel-body th[data-v-3e30d702],table th[data-v-3e30d702]{text-align:left;padding-left:25px}@media screen and (max-width:415px){.panel-body th[data-v-3e30d702],table th[data-v-3e30d702]{font-size:12px}}.panel-body td[data-v-3e30d702],table td[data-v-3e30d702]{text-align:left;padding-left:25px}.panel-body td i[data-v-3e30d702],table td i[data-v-3e30d702]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body td i[data-v-3e30d702]:hover,table td i[data-v-3e30d702]:hover{color:var(--btn-default)}.panel-body .nombre-alarma[data-v-3e30d702],table .nombre-alarma[data-v-3e30d702]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-3e30d702],table .panel-body[data-v-3e30d702]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-3e30d702],table .panel-title[data-v-3e30d702]{font-size:12px}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Volumetria/Volumetria.vue"],"names":[],"mappings":"AACA,kCACE,SAAU,AACV,SAAW,CACZ,AACD,0BACE,qBAA0B,CAC3B,AACD,0CACI,YAAa,AACb,gBAAiB,AACjB,uCAA6C,CAChD,AACD,oCACI,WAAa,CAChB,AACD,uCACI,aAAc,AACd,mCAAqC,CACxC,AACD,wIACM,mDAAsD,CAC3D,AACD,wBACE,YAAa,AACb,4BAA6B,AAC7B,iBAAmB,CACpB,AACD,oDAEE,gBAAiB,AACjB,YAAa,AACb,UAAmB,AACnB,6BAA8B,AAC9B,aAAiB,CAClB,AACD,oCACA,oDAEM,SAAW,CAChB,CACA,AACD,sEAEI,qBAA0B,CAC7B,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,8DAEM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,0EAEQ,wBAA0B,CACjC,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAW,CACd,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA","file":"Volumetria.vue","sourcesContent":["\n.container-fluid[data-v-3e30d702] {\n  margin: 0;\n  padding: 0;\n}\n#presion[data-v-3e30d702] {\n  background-color: #eeeeee;\n}\n#presion #formulario-top[data-v-3e30d702] {\n    height: 10vh;\n    margin-top: 80px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n#presion #graficas[data-v-3e30d702] {\n    height: 65vh;\n}\n#presion .btn-default[data-v-3e30d702] {\n    margin-top: 0;\n    background-color: var(--btn-default);\n}\n#presion .btn-default[data-v-3e30d702]:hover, #presion .btn-default[data-v-3e30d702]:active, #presion .btn-default[data-v-3e30d702]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n.nomen[data-v-3e30d702] {\n  height: 100%;\n  border-right: 3px solid gray;\n  text-align: center;\n}\ntable[data-v-3e30d702],\n.panel-body[data-v-3e30d702] {\n  overflow: scroll;\n  height: 32vh;\n  padding: 0px 0 0 0;\n  border-bottom: 1px solid #999;\n  margin: 20px 0px;\n}\n@media screen and (max-width: 991px) {\ntable[data-v-3e30d702],\n    .panel-body[data-v-3e30d702] {\n      padding: 0;\n}\n}\ntable .info td[data-v-3e30d702],\n  .panel-body .info td[data-v-3e30d702] {\n    background-color: #eeeeee;\n}\ntable th[data-v-3e30d702],\n  .panel-body th[data-v-3e30d702] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-3e30d702],\n      .panel-body th[data-v-3e30d702] {\n        font-size: 12px;\n}\n}\ntable td[data-v-3e30d702],\n  .panel-body td[data-v-3e30d702] {\n    text-align: left;\n    padding-left: 25px;\n}\ntable td i[data-v-3e30d702],\n    .panel-body td i[data-v-3e30d702] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\ntable td i[data-v-3e30d702]:hover,\n      .panel-body td i[data-v-3e30d702]:hover {\n        color: var(--btn-default);\n}\ntable .nombre-alarma[data-v-3e30d702],\n  .panel-body .nombre-alarma[data-v-3e30d702] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-3e30d702],\n  .panel-body .panel-body[data-v-3e30d702] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-3e30d702],\n    .panel-body .panel-title[data-v-3e30d702] {\n      font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".group[data-v-3e4f6626]{position:relative;margin-bottom:30px;margin-top:30px}input[data-v-3e4f6626]{font-size:18px;padding:10px 10px 10px 5px;display:block;width:100%;border:none;border-bottom:1px solid var(--btn-default-bg);background-color:transparent}input[data-v-3e4f6626]:focus{outline:none}label[data-v-3e4f6626]{color:var(--btn-default-hover);font-size:18px;font-weight:400;position:absolute;pointer-events:none;left:5px;top:10px;transition:all .2s ease;-moz-transition:.2s ease all;-webkit-transition:all .2s ease}input:focus~label[data-v-3e4f6626],input:valid~label[data-v-3e4f6626]{top:-20px;font-size:14px;color:var(--btn-default-hover)}.bar[data-v-3e4f6626]{display:block;width:100%}.bar[data-v-3e4f6626]:after,.bar[data-v-3e4f6626]:before{content:\"\";height:2px;width:0;bottom:1px;position:absolute;background:var(--btn-default-bg);transition:all .2s ease;-moz-transition:.2s ease all;-webkit-transition:all .2s ease}.bar[data-v-3e4f6626]:before{left:50%}.bar[data-v-3e4f6626]:after{right:50%}input:focus~.bar[data-v-3e4f6626]:after,input:focus~.bar[data-v-3e4f6626]:before{width:50%}.highlight[data-v-3e4f6626]{position:absolute;height:60%;width:100px;top:20%;left:0;pointer-events:none;opacity:.5}input:focus~.highlight[data-v-3e4f6626]{animation:inputHighlighter-data-v-3e4f6626 .3s ease}.center-placeholder[data-v-3e4f6626]::-webkit-input-placeholder{text-align:center}.center-placeholder[data-v-3e4f6626]:-moz-placeholder,.center-placeholder[data-v-3e4f6626]::-moz-placeholder{text-align:center}.center-placeholder[data-v-3e4f6626]:-ms-input-placeholder{text-align:center}.error[data-v-3e4f6626]{border:2px solid #000!important;border-bottom-color:#fff}.changeColor input[data-v-3e4f6626]{border-color:var(--btn-default-bg)}.changeColor input:focus~label[data-v-3e4f6626],.changeColor input:valid~label[data-v-3e4f6626],.changeColor label[data-v-3e4f6626]{color:gray}.changeColor .bar[data-v-3e4f6626]:after,.changeColor .bar[data-v-3e4f6626]:before{color:var(--btn-default-bg)}@keyframes inputHighlighter-data-v-3e4f6626{0%{background:var(--btn-default-bg)}to{width:0;background:transparent}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/reusable/Input.vue"],"names":[],"mappings":"AACA,wBACE,kBAAmB,AACnB,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,eAAgB,AAChB,2BAA4B,AAC5B,cAAe,AACf,WAAY,AACZ,YAAa,AACb,8CAA+C,AAC/C,4BAA8B,CAC/B,AACD,6BACE,YAAc,CACf,AAGD,uBACE,+BAAgC,AAChC,eAAgB,AAChB,gBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,SAAU,AACV,SAAU,AACV,wBAA0B,AAC1B,6BAA+B,AAC/B,+BAAkC,CACnC,AAGD,sEAEE,UAAW,AACX,eAAgB,AAChB,8BAAgC,CACjC,AAGD,sBACE,cAAe,AACf,UAAY,CACb,AACD,yDAEE,WAAY,AACZ,WAAY,AACZ,QAAS,AACT,WAAY,AACZ,kBAAmB,AACnB,iCAAkC,AAClC,wBAA0B,AAC1B,6BAA+B,AAC/B,+BAAkC,CACnC,AACD,6BACE,QAAU,CACX,AACD,4BACE,SAAW,CACZ,AAGD,iFAEE,SAAW,CACZ,AAGD,4BACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,QAAS,AACT,OAAQ,AACR,oBAAqB,AACrB,UAAa,CACd,AAGD,wCACE,mDAAsD,CACvD,AAcD,gEACE,iBAAmB,CACpB,AAKD,6GAEE,iBAAmB,CACpB,AACD,2DACE,iBAAmB,CACpB,AACD,wBACE,gCAAmC,AACnC,wBAA2B,CAC5B,AACD,oCACE,kCAAoC,CACrC,AAID,oIAEE,UAAY,CACb,AACD,mFAEE,2BAA6B,CAC9B,AACD,4CACA,GACI,gCAAkC,CACrC,AACD,GACI,QAAS,AACT,sBAAwB,CAC3B,CACA","file":"Input.vue","sourcesContent":["/* form starting stylings ------------------------------- */\n.group[data-v-3e4f6626] {\n  position: relative;\n  margin-bottom: 30px;\n  margin-top: 30px;\n}\ninput[data-v-3e4f6626] {\n  font-size: 18px;\n  padding: 10px 10px 10px 5px;\n  display: block;\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid var(--btn-default-bg);\n  background-color: transparent;\n}\ninput[data-v-3e4f6626]:focus {\n  outline: none;\n}\n\n/* LABEL ======================================= */\nlabel[data-v-3e4f6626] {\n  color: var(--btn-default-hover);\n  font-size: 18px;\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  left: 5px;\n  top: 10px;\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n}\n\n/* active state */\ninput:focus ~ label[data-v-3e4f6626],\ninput:valid ~ label[data-v-3e4f6626] {\n  top: -20px;\n  font-size: 14px;\n  color: var(--btn-default-hover);\n}\n\n/* BOTTOM BARS ================================= */\n.bar[data-v-3e4f6626] {\n  display: block;\n  width: 100%;\n}\n.bar[data-v-3e4f6626]:before,\n.bar[data-v-3e4f6626]:after {\n  content: '';\n  height: 2px;\n  width: 0;\n  bottom: 1px;\n  position: absolute;\n  background: var(--btn-default-bg);\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n}\n.bar[data-v-3e4f6626]:before {\n  left: 50%;\n}\n.bar[data-v-3e4f6626]:after {\n  right: 50%;\n}\n\n/* active state */\ninput:focus ~ .bar[data-v-3e4f6626]:before,\ninput:focus ~ .bar[data-v-3e4f6626]:after {\n  width: 50%;\n}\n\n/* HIGHLIGHTER ================================== */\n.highlight[data-v-3e4f6626] {\n  position: absolute;\n  height: 60%;\n  width: 100px;\n  top: 20%;\n  left: 0;\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n/* active state */\ninput:focus ~ .highlight[data-v-3e4f6626] {\n  animation: inputHighlighter-data-v-3e4f6626 0.3s ease;\n}\n\n/* ANIMATIONS ================ */\n@keyframes inputHighlighter-data-v-3e4f6626 {\nfrom {\n    background: var(--btn-default-bg);\n}\nto {\n    width: 0;\n    background: transparent;\n}\n}\n\n/*  CENTER PLACEHOLDER */\n.center-placeholder[data-v-3e4f6626]::-webkit-input-placeholder {\n  text-align: center;\n}\n.center-placeholder[data-v-3e4f6626]:-moz-placeholder {\n  /* Firefox 18- */\n  text-align: center;\n}\n.center-placeholder[data-v-3e4f6626]::-moz-placeholder {\n  /* Firefox 19+ */\n  text-align: center;\n}\n.center-placeholder[data-v-3e4f6626]:-ms-input-placeholder {\n  text-align: center;\n}\n.error[data-v-3e4f6626] {\n  border: 2px solid black !important;\n  border-bottom-color: white;\n}\n.changeColor input[data-v-3e4f6626] {\n  border-color: var(--btn-default-bg);\n}\n.changeColor label[data-v-3e4f6626] {\n  color: gray;\n}\n.changeColor input:focus ~ label[data-v-3e4f6626],\n.changeColor input:valid ~ label[data-v-3e4f6626] {\n  color: gray;\n}\n.changeColor .bar[data-v-3e4f6626]:before,\n.changeColor .bar[data-v-3e4f6626]:after {\n  color: var(--btn-default-bg);\n}\n@keyframes inputHighlighter-data-v-3e4f6626 {\nfrom {\n    background: var(--btn-default-bg);\n}\nto {\n    width: 0;\n    background: transparent;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#map-div[data-v-44d40890]{z-index:-10;margin:0;width:100%}#map_canvas[data-v-44d40890]{margin:0;padding:0;position:unset}.full[data-v-44d40890]{height:100vh;width:100vw}.half[data-v-44d40890]{height:50vh;width:50vw}@media screen and (max-width:991px){.half[data-v-44d40890]{width:100vw!important}}.modal[data-v-44d40890]{height:500px;width:600px}@media screen and (max-width:767px){.modal[data-v-44d40890]{height:90vh;width:auto}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/reusable/Map.vue"],"names":[],"mappings":"AACA,0BACE,YAAa,AACb,SAAU,AACV,UAAY,CACb,AACD,6BACE,SAAU,AACV,UAAW,AACX,cAAgB,CACjB,AACD,uBACE,aAAc,AACd,WAAa,CACd,AACD,uBACE,YAAa,AACb,UAAY,CACb,AACD,oCACA,uBACM,qBAAwB,CAC7B,CACA,AACD,wBACE,aAAc,AACd,WAAa,CACd,AACD,oCACA,wBACM,YAAa,AACb,UAAY,CACjB,CACA","file":"Map.vue","sourcesContent":["\n#map-div[data-v-44d40890] {\n  z-index: -10;\n  margin: 0;\n  width: 100%;\n}\n#map_canvas[data-v-44d40890] {\n  margin: 0;\n  padding: 0;\n  position: unset;\n}\n.full[data-v-44d40890] {\n  height: 100vh;\n  width: 100vw;\n}\n.half[data-v-44d40890] {\n  height: 50vh;\n  width: 50vw;\n}\n@media screen and (max-width: 991px) {\n.half[data-v-44d40890] {\n      width: 100vw !important;\n}\n}\n.modal[data-v-44d40890] {\n  height: 500px;\n  width: 600px;\n}\n@media screen and (max-width: 767px) {\n.modal[data-v-44d40890] {\n      height: 90vh;\n      width: auto;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#loading[data-v-46569db3]{position:relative}#loading .loading__login[data-v-46569db3]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}#loading .loading__login .fa-spinner[data-v-46569db3]{color:var(--btn-default-bg)}#loading .loading__login h4[data-v-46569db3]{color:var(--btn-default-hover);position:absolute;left:-30px}#loading #dismiss-button[data-v-46569db3]{position:absolute;z-index:-999999;visibility:hidden}#loading .info[data-v-46569db3]{position:absolute;background-color:#fff;width:100%;top:50%;left:50%;color:var(--btn-default-bg);transform:translate(-50%,-50%)}#loading .info h4[data-v-46569db3]{margin:0;padding:50px;color:#fff;margin-top:-100px}#loading .info .fa-exclamation-triangle[data-v-46569db3]{color:#fff}#loading .info .\\--warning[data-v-46569db3]{background-color:#e53935}#loading .info .\\--success[data-v-46569db3]{background-color:#2aa769}#loading .info .\\--searching[data-v-46569db3]{background-color:var(--btn-default-bg)}#loading .info h5[data-v-46569db3]{padding:50px 0;color:#000}#loading .info #info-button[data-v-46569db3]{margin-bottom:25px}.modal-body[data-v-46569db3]{height:55vh;background-color:transparent}@media screen and (max-width:767px){.modal-body[data-v-46569db3]{height:38vh}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Modals/Loading.vue"],"names":[],"mappings":"AACA,0BACE,iBAAmB,CACpB,AACD,0CACI,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,8BAAiC,CACpC,AACD,sDACM,2BAA6B,CAClC,AACD,6CACM,+BAAgC,AAChC,kBAAmB,AACnB,UAAY,CACjB,AACD,0CACI,kBAAmB,AACnB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,gCACI,kBAAmB,AACnB,sBAAwB,AACxB,WAAY,AACZ,QAAS,AACT,SAAU,AACV,4BAA6B,AAC7B,8BAAiC,CACpC,AACD,mCACM,SAAU,AACV,aAAc,AACd,WAAa,AACb,iBAAmB,CACxB,AACD,yDACM,UAAa,CAClB,AACD,4CACM,wBAA0B,CAC/B,AACD,4CACM,wBAA0B,CAC/B,AACD,8CACM,sCAAwC,CAC7C,AACD,mCACM,eAAgB,AAChB,UAAa,CAClB,AACD,6CACM,kBAAoB,CACzB,AACD,6BACE,YAAa,AACb,4BAA8B,CAC/B,AACD,oCACA,6BACM,WAAa,CAClB,CACA","file":"Loading.vue","sourcesContent":["\n#loading[data-v-46569db3] {\n  position: relative;\n}\n#loading .loading__login[data-v-46569db3] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n#loading .loading__login .fa-spinner[data-v-46569db3] {\n      color: var(--btn-default-bg);\n}\n#loading .loading__login h4[data-v-46569db3] {\n      color: var(--btn-default-hover);\n      position: absolute;\n      left: -30px;\n}\n#loading #dismiss-button[data-v-46569db3] {\n    position: absolute;\n    z-index: -999999;\n    visibility: hidden;\n}\n#loading .info[data-v-46569db3] {\n    position: absolute;\n    background-color: white;\n    width: 100%;\n    top: 50%;\n    left: 50%;\n    color: var(--btn-default-bg);\n    transform: translate(-50%, -50%);\n}\n#loading .info h4[data-v-46569db3] {\n      margin: 0;\n      padding: 50px;\n      color: white;\n      margin-top: -100px;\n}\n#loading .info .fa-exclamation-triangle[data-v-46569db3] {\n      color: white;\n}\n#loading .info .--warning[data-v-46569db3] {\n      background-color: #e53935;\n}\n#loading .info .--success[data-v-46569db3] {\n      background-color: #2aa769;\n}\n#loading .info .--searching[data-v-46569db3] {\n      background-color: var(--btn-default-bg);\n}\n#loading .info h5[data-v-46569db3] {\n      padding: 50px 0;\n      color: black;\n}\n#loading .info #info-button[data-v-46569db3] {\n      margin-bottom: 25px;\n}\n.modal-body[data-v-46569db3] {\n  height: 55vh;\n  background-color: transparent;\n}\n@media screen and (max-width: 767px) {\n.modal-body[data-v-46569db3] {\n      height: 38vh;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "html{background-color:#000}#router-view{margin-left:50px}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/App.vue"],"names":[],"mappings":"AACA,KACE,qBAAwB,CACzB,AACD,aACE,gBAAkB,CACnB","file":"App.vue","sourcesContent":["\nhtml {\n  background-color: black;\n}\n#router-view {\n  margin-left: 50px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "select[data-v-4e3a5d60]{height:47px;appearance:none;-webkit-appearance:none;-moz-appearance:none;-webkit-border-radius:0;-moz-border-radius:0;width:100%;padding:10px;background-color:transparent;border:none;border-bottom:2px solid rgba(0,0,0,.34);background-image:linear-gradient(45deg,transparent 50%,rgba(0,0,0,.34) 0),linear-gradient(135deg,rgba(0,0,0,.34) 50%,transparent 0),linear-gradient(90deg,#ccc,#ccc);background-position:calc(100% - 20px) calc(1em + 2px),calc(100% - 15px) calc(1em + 2px),calc(100% - 2.5em) .5em}select[data-v-4e3a5d60],select[data-v-4e3a5d60]:focus{background-size:5px 5px,5px 5px,1px 1.5em;background-repeat:no-repeat}select[data-v-4e3a5d60]:focus{background-image:linear-gradient(45deg,var(--btn-default) 50%,transparent 0),linear-gradient(135deg,transparent 50%,var(--btn-default) 0),linear-gradient(90deg,#ccc,#ccc);background-position:calc(100% - 15px) 1em,calc(100% - 20px) 1em,calc(100% - 2.5em) .5em;border-color:var(--btn-default);outline:0}select[data-v-4e3a5d60]:-moz-focusring{color:transparent;text-shadow:0 0 0 #000}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/reusable/Select.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,gBAAiB,AACjB,wBAAyB,AACzB,qBAAsB,AACtB,wBAA2B,AAC3B,qBAAwB,AACxB,WAAY,AACZ,aAAc,AACd,6BAA8B,AAC9B,YAAa,AACb,wCAA6C,AAG7C,qKAAgM,AAChM,+GAAoH,CAHrH,AASD,sDALE,0CAES,AACT,2BAA6B,CAW9B,AATD,8BACE,2KAA2L,AAC3L,wFAA4F,AAK5F,gCAAiC,AACjC,SAAW,CACZ,AACD,uCACE,kBAAmB,AACnB,sBAAwB,CACzB","file":"Select.vue","sourcesContent":["\nselect[data-v-4e3a5d60] {\n  height: 47px;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -webkit-border-radius: 0px;\n  -moz-border-radius: 0px;\n  width: 100%;\n  padding: 10px;\n  background-color: transparent;\n  border: none;\n  border-bottom: 2px solid rgba(0, 0, 0, 0.34);\n}\nselect[data-v-4e3a5d60] {\n  background-image: linear-gradient(45deg, transparent 50%, rgba(0, 0, 0, 0.34) 50%), linear-gradient(135deg, rgba(0, 0, 0, 0.34) 50%, transparent 50%), linear-gradient(to right, #cccccc, #ccc);\n  background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;\n  background-size: 5px 5px,\r 5px 5px,\r 1px 1.5em;\n  background-repeat: no-repeat;\n}\nselect[data-v-4e3a5d60]:focus {\n  background-image: linear-gradient(45deg, var(--btn-default) 50%, transparent 50%), linear-gradient(135deg, transparent 50%, var(--btn-default) 50%), linear-gradient(to right, #ccc, #ccc);\n  background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, calc(100% - 2.5em) 0.5em;\n  background-size: 5px 5px,\r 5px 5px,\r 1px 1.5em;\n  background-repeat: no-repeat;\n  border-color: var(--btn-default);\n  outline: 0;\n}\nselect[data-v-4e3a5d60]:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".centered-container[data-v-50d96a13]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;position:relative;height:100vh}.centered-container .title[data-v-50d96a13]{text-align:center;margin-bottom:30px}.centered-container .title img[data-v-50d96a13]{width:100%}.centered-container .actions .md-button[data-v-50d96a13]{margin:0}.centered-container .form[data-v-50d96a13]{margin-bottom:60px}.centered-container .background[data-v-50d96a13]{position:absolute;height:100%;width:100%;top:0;bottom:0;right:0;left:0;z-index:0;background-color:var(--loading-background-color);background-repeat:no-repeat;background-attachment:fixed;background-position:50%}.centered-container .md-content[data-v-50d96a13]{z-index:1;padding:40px;width:100%;max-width:400px;position:relative;border-radius:15px}#loading-modal-modal[data-v-50d96a13]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Login/Login.vue"],"names":[],"mappings":"AACA,qCACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,qBAAsB,AAClB,uBAAwB,AAC5B,kBAAmB,AACnB,YAAc,CACf,AACD,4CACI,kBAAmB,AACnB,kBAAoB,CACvB,AACD,gDACM,UAAY,CACjB,AACD,yDACI,QAAU,CACb,AACD,2CACI,kBAAoB,CACvB,AACD,iDACI,kBAAmB,AACnB,YAAa,AACb,WAAY,AACZ,MAAO,AACP,SAAU,AACV,QAAS,AACT,OAAQ,AACR,UAAW,AACX,iDAAkD,AAClD,4BAA6B,AAC7B,4BAA6B,AAC7B,uBAA4B,CAC/B,AACD,iDACI,UAAW,AACX,aAAc,AACd,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACvB,AACD,sCACE,0DAA6D,CAC9D","file":"Login.vue","sourcesContent":["\n.centered-container[data-v-50d96a13] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  position: relative;\n  height: 100vh;\n}\n.centered-container .title[data-v-50d96a13] {\n    text-align: center;\n    margin-bottom: 30px;\n}\n.centered-container .title img[data-v-50d96a13] {\n      width: 100%;\n}\n.centered-container .actions .md-button[data-v-50d96a13] {\n    margin: 0;\n}\n.centered-container .form[data-v-50d96a13] {\n    margin-bottom: 60px;\n}\n.centered-container .background[data-v-50d96a13] {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 0;\n    background-color: var(--loading-background-color);\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-position: center;\n}\n.centered-container .md-content[data-v-50d96a13] {\n    z-index: 1;\n    padding: 40px;\n    width: 100%;\n    max-width: 400px;\n    position: relative;\n    border-radius: 15px;\n}\n#loading-modal-modal[data-v-50d96a13] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-59e5df89]{background-color:rgba(0,0,0,.8)}.transparent[data-v-59e5df89]{background-color:transparent;box-shadow:none;border:none}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/reusable/Modal.vue"],"names":[],"mappings":"AACA,wBACE,+BAAqC,CACtC,AACD,8BACE,6BAA8B,AAC9B,gBAAiB,AACjB,WAAa,CACd","file":"Modal.vue","sourcesContent":["\n.modal[data-v-59e5df89] {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n.transparent[data-v-59e5df89] {\n  background-color: transparent;\n  box-shadow: none;\n  border: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#loading-modal-modal[data-v-5c05fd1d]{background-color:hsla(0,0%,100%,.8)!important}#loading[data-v-5c05fd1d]{position:relative}#loading .loading__login[data-v-5c05fd1d]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}#loading .loading__login .fa-spinner[data-v-5c05fd1d]{color:var(--loading-color)}#loading .loading__login h4[data-v-5c05fd1d]{color:var(--btn-default-hover);position:absolute;left:-30px}#loading #dismiss-button[data-v-5c05fd1d]{position:absolute;z-index:-999999;visibility:hidden}#loading .info[data-v-5c05fd1d]{position:absolute;background-color:#fff;width:100%;top:50%;left:50%;color:var(--btn-default-bg);transform:translate(-50%,-50%)}#loading .info h4[data-v-5c05fd1d]{background-color:#e53935;margin:0;padding:25px;color:#fff}#loading .info h5[data-v-5c05fd1d]{padding:50px 0;color:#000}#loading .info #info-button[data-v-5c05fd1d]{margin-bottom:25px}.modal-body[data-v-5c05fd1d]{height:55vh;background-color:transparent}@media screen and (max-width:767px){.modal-body[data-v-5c05fd1d]{height:38vh}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Modals/LoginModal.vue"],"names":[],"mappings":"AACA,sCACE,6CAAsD,CACvD,AACD,0BACE,iBAAmB,CACpB,AACD,0CACI,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,8BAAiC,CACpC,AACD,sDACM,0BAA4B,CACjC,AACD,6CACM,+BAAgC,AAChC,kBAAmB,AACnB,UAAY,CACjB,AACD,0CACI,kBAAmB,AACnB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,gCACI,kBAAmB,AACnB,sBAAwB,AACxB,WAAY,AACZ,QAAS,AACT,SAAU,AACV,4BAA6B,AAC7B,8BAAiC,CACpC,AACD,mCACM,yBAA0B,AAC1B,SAAU,AACV,aAAc,AACd,UAAa,CAClB,AACD,mCACM,eAAgB,AAChB,UAAa,CAClB,AACD,6CACM,kBAAoB,CACzB,AACD,6BACE,YAAa,AACb,4BAA8B,CAC/B,AACD,oCACA,6BACM,WAAa,CAClB,CACA","file":"LoginModal.vue","sourcesContent":["\n#loading-modal-modal[data-v-5c05fd1d] {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n}\n#loading[data-v-5c05fd1d] {\n  position: relative;\n}\n#loading .loading__login[data-v-5c05fd1d] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n#loading .loading__login .fa-spinner[data-v-5c05fd1d] {\n      color: var(--loading-color);\n}\n#loading .loading__login h4[data-v-5c05fd1d] {\n      color: var(--btn-default-hover);\n      position: absolute;\n      left: -30px;\n}\n#loading #dismiss-button[data-v-5c05fd1d] {\n    position: absolute;\n    z-index: -999999;\n    visibility: hidden;\n}\n#loading .info[data-v-5c05fd1d] {\n    position: absolute;\n    background-color: white;\n    width: 100%;\n    top: 50%;\n    left: 50%;\n    color: var(--btn-default-bg);\n    transform: translate(-50%, -50%);\n}\n#loading .info h4[data-v-5c05fd1d] {\n      background-color: #e53935;\n      margin: 0;\n      padding: 25px;\n      color: white;\n}\n#loading .info h5[data-v-5c05fd1d] {\n      padding: 50px 0;\n      color: black;\n}\n#loading .info #info-button[data-v-5c05fd1d] {\n      margin-bottom: 25px;\n}\n.modal-body[data-v-5c05fd1d] {\n  height: 55vh;\n  background-color: transparent;\n}\n@media screen and (max-width: 767px) {\n.modal-body[data-v-5c05fd1d] {\n      height: 38vh;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".panel[data-v-5c9fceb4]{margin-bottom:0}td[data-v-5c9fceb4]{cursor:pointer}.isHidden[data-v-5c9fceb4]{display:none}.transparent[data-v-5c9fceb4]{pointer-events:none}.oc-button[data-v-5c9fceb4]{pointer-events:auto;background-color:var(--btn-default);color:#fff;padding:10px;margin:0 10px;display:inline-block;position:relative;border-radius:1px solid #333}.oc-button[data-v-5c9fceb4]:active{background-color:#333;color:#fff}.row[data-v-5c9fceb4]{margin-right:-30px}.no-show[data-v-5c9fceb4]{display:none}h3[data-v-5c9fceb4]{color:#000;cursor:pointer}span[data-v-5c9fceb4]{padding:0 20px}@media screen and (max-width:400px){span[data-v-5c9fceb4]{padding:0 10px}}.panel-body[data-v-5c9fceb4],table[data-v-5c9fceb4]{background-color:#eee;overflow:scroll;height:100%;padding:0;padding-left:15px}table[data-v-5c9fceb4]{height:35vh}.not-active[data-v-5c9fceb4]{color:rgba(0,0,0,.34)}.col-md-5[data-v-5c9fceb4],.col-md-7[data-v-5c9fceb4]{margin:0;padding:0}.panel-default[data-v-5c9fceb4]{background-color:#e0e0e0;border:none;border-radius:0}#data-table[data-v-5c9fceb4]{position:absolute;color:rgba(0,0,0,.87);width:100vw;height:50vh;bottom:0;padding-left:30px}#ductos h3[data-v-5c9fceb4]{padding-left:15px}#ductos .ducto[data-v-5c9fceb4]{color:#fff;font-size:12px;cursor:pointer;background-color:var(--btn-default)}#alarmas th[data-v-5c9fceb4]{text-align:left}@media screen and (max-width:415px){#alarmas th[data-v-5c9fceb4]{font-size:12px}}#alarmas td[data-v-5c9fceb4]{text-align:left;background-color:#eee;cursor:pointer}#alarmas td.table-option[data-v-5c9fceb4]{padding:8px 1px}#alarmas td.table-option button[data-v-5c9fceb4]{border-width:0;margin:0;padding:0 4px}#alarmas td tr[data-v-5c9fceb4]{cursor:pointer}#alarmas td i[data-v-5c9fceb4]{color:rgba(0,0,0,.34);cursor:pointer}#alarmas td i[data-v-5c9fceb4]:hover{color:var(--btn-default)}#alarmas td i.identify-leak[data-v-5c9fceb4],#alarmas td i.open-leak[data-v-5c9fceb4]{color:var(--md-theme-default-primary);font-size:16px}#alarmas .nombre-alarma[data-v-5c9fceb4]{height:40px;background-color:var(--btn-default);color:#fff}#alarmas .panel-body[data-v-5c9fceb4]{padding:0}@media screen and (max-width:415px){#alarmas .panel-title[data-v-5c9fceb4]{font-size:12px}}#comentario-modal h3[data-v-5c9fceb4]{color:rgba(0,0,0,.87)}#comentario-modal .btn-default[data-v-5c9fceb4]{background-color:var(--btn-default)}#comentario-modal .btn-default[data-v-5c9fceb4]:active,#comentario-modal .btn-default[data-v-5c9fceb4]:focus,#comentario-modal .btn-default[data-v-5c9fceb4]:hover{background-color:var(--btn-default-hover)!important}#comentario-modal label[data-v-5c9fceb4]{color:var(--btn-default)}#comentario-modal #label-name[data-v-5c9fceb4]{color:#fff;width:100%;font-size:16px;padding:5px;background-color:var(--btn-default)}#comentario-modal #selectDonde[data-v-5c9fceb4]{-webkit-appearance:none;-webkit-border-radius:0;width:80%;height:40px;padding:5px}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Home/DataTable.vue"],"names":[],"mappings":"AACA,wBACE,eAAiB,CAClB,AACD,oBACE,cAAgB,CACjB,AACD,2BACE,YAAc,CACf,AACD,8BACE,mBAAqB,CACtB,AACD,4BACE,oBAAqB,AACrB,oCAAqC,AACrC,WAAa,AACb,aAAc,AACd,cAAe,AACf,qBAAsB,AACtB,kBAAmB,AACnB,4BAA8B,CAC/B,AACD,mCACE,sBAAuB,AACvB,UAAa,CACd,AACD,sBACE,kBAAoB,CACrB,AACD,0BACE,YAAc,CACf,AACD,oBACE,WAAa,AACb,cAAgB,CACjB,AACD,sBACE,cAAgB,CACjB,AACD,oCACA,sBACM,cAAgB,CACrB,CACA,AACD,oDAEE,sBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,UAAW,AACX,iBAAmB,CACpB,AACD,uBACE,WAAa,CACd,AACD,6BACE,qBAA2B,CAC5B,AACD,sDAEE,SAAU,AACV,SAAW,CACZ,AACD,gCACE,yBAA0B,AAC1B,YAAa,AACb,eAAiB,CAClB,AACD,6BACE,kBAAmB,AACnB,sBAA2B,AAC3B,YAAa,AACb,YAAa,AACb,SAAU,AACV,iBAAmB,CACpB,AACD,4BACE,iBAAmB,CACpB,AACD,gCACE,WAAa,AACb,eAAgB,AAChB,eAAgB,AAChB,mCAAqC,CACtC,AACD,6BACE,eAAiB,CAClB,AACD,oCACA,6BACM,cAAgB,CACrB,CACA,AACD,6BACE,gBAAiB,AACjB,sBAA0B,AAC1B,cAAgB,CACjB,AACD,0CACI,eAAiB,CACpB,AACD,iDACM,eAAkB,AAClB,SAAY,AACZ,aAAiB,CACtB,AACD,gCACI,cAAgB,CACnB,AACD,+BACI,sBAA2B,AAC3B,cAAgB,CACnB,AACD,qCACM,wBAA0B,CAC/B,AAKD,sFACM,sCAAuC,AACvC,cAAgB,CACrB,AACD,yCACE,YAAa,AACb,oCAAqC,AACrC,UAAa,CACd,AACD,sCACE,SAAW,CACZ,AACD,oCACA,uCACI,cAAgB,CACnB,CACA,AACD,sCACE,qBAA2B,CAC5B,AACD,gDACE,mCAAqC,CACtC,AACD,mKACI,mDAAsD,CACzD,AACD,yCACE,wBAA0B,CAC3B,AACD,+CACE,WAAa,AACb,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,mCAAqC,CACtC,AACD,gDACE,wBAAyB,AACzB,wBAA2B,AAC3B,UAAW,AACX,YAAa,AACb,WAAa,CACd","file":"DataTable.vue","sourcesContent":["\n.panel[data-v-5c9fceb4] {\n  margin-bottom: 0;\n}\ntd[data-v-5c9fceb4] {\n  cursor: pointer;\n}\n.isHidden[data-v-5c9fceb4] {\n  display: none;\n}\n.transparent[data-v-5c9fceb4] {\n  pointer-events: none;\n}\n.oc-button[data-v-5c9fceb4] {\n  pointer-events: auto;\n  background-color: var(--btn-default);\n  color: white;\n  padding: 10px;\n  margin: 0 10px;\n  display: inline-block;\n  position: relative;\n  border-radius: 1px solid #333;\n}\n.oc-button[data-v-5c9fceb4]:active {\n  background-color: #333;\n  color: white;\n}\n.row[data-v-5c9fceb4] {\n  margin-right: -30px;\n}\n.no-show[data-v-5c9fceb4] {\n  display: none;\n}\nh3[data-v-5c9fceb4] {\n  color: black;\n  cursor: pointer;\n}\nspan[data-v-5c9fceb4] {\n  padding: 0 20px;\n}\n@media screen and (max-width: 400px) {\nspan[data-v-5c9fceb4] {\n      padding: 0 10px;\n}\n}\ntable[data-v-5c9fceb4],\n.panel-body[data-v-5c9fceb4] {\n  background-color: #eeeeee;\n  overflow: scroll;\n  height: 100%;\n  padding: 0;\n  padding-left: 15px;\n}\ntable[data-v-5c9fceb4] {\n  height: 35vh;\n}\n.not-active[data-v-5c9fceb4] {\n  color: rgba(0, 0, 0, 0.34);\n}\n.col-md-5[data-v-5c9fceb4],\n.col-md-7[data-v-5c9fceb4] {\n  margin: 0;\n  padding: 0;\n}\n.panel-default[data-v-5c9fceb4] {\n  background-color: #E0E0E0;\n  border: none;\n  border-radius: 0;\n}\n#data-table[data-v-5c9fceb4] {\n  position: absolute;\n  color: rgba(0, 0, 0, 0.87);\n  width: 100vw;\n  height: 50vh;\n  bottom: 0;\n  padding-left: 30px;\n}\n#ductos h3[data-v-5c9fceb4] {\n  padding-left: 15px;\n}\n#ductos .ducto[data-v-5c9fceb4] {\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  background-color: var(--btn-default);\n}\n#alarmas th[data-v-5c9fceb4] {\n  text-align: left;\n}\n@media screen and (max-width: 415px) {\n#alarmas th[data-v-5c9fceb4] {\n      font-size: 12px;\n}\n}\n#alarmas td[data-v-5c9fceb4] {\n  text-align: left;\n  background-color: #eeeeee;\n  cursor: pointer;\n}\n#alarmas td.table-option[data-v-5c9fceb4] {\n    padding: 8px 1px;\n}\n#alarmas td.table-option button[data-v-5c9fceb4] {\n      border-width: 0px;\n      margin: 0px;\n      padding: 0px 4px;\n}\n#alarmas td tr[data-v-5c9fceb4] {\n    cursor: pointer;\n}\n#alarmas td i[data-v-5c9fceb4] {\n    color: rgba(0, 0, 0, 0.34);\n    cursor: pointer;\n}\n#alarmas td i[data-v-5c9fceb4]:hover {\n      color: var(--btn-default);\n}\n#alarmas td i.identify-leak[data-v-5c9fceb4] {\n      color: var(--md-theme-default-primary);\n      font-size: 16px;\n}\n#alarmas td i.open-leak[data-v-5c9fceb4] {\n      color: var(--md-theme-default-primary);\n      font-size: 16px;\n}\n#alarmas .nombre-alarma[data-v-5c9fceb4] {\n  height: 40px;\n  background-color: var(--btn-default);\n  color: white;\n}\n#alarmas .panel-body[data-v-5c9fceb4] {\n  padding: 0;\n}\n@media screen and (max-width: 415px) {\n#alarmas .panel-title[data-v-5c9fceb4] {\n    font-size: 12px;\n}\n}\n#comentario-modal h3[data-v-5c9fceb4] {\n  color: rgba(0, 0, 0, 0.87);\n}\n#comentario-modal .btn-default[data-v-5c9fceb4] {\n  background-color: var(--btn-default);\n}\n#comentario-modal .btn-default[data-v-5c9fceb4]:hover, #comentario-modal .btn-default[data-v-5c9fceb4]:active, #comentario-modal .btn-default[data-v-5c9fceb4]:focus {\n    background-color: var(--btn-default-hover) !important;\n}\n#comentario-modal label[data-v-5c9fceb4] {\n  color: var(--btn-default);\n}\n#comentario-modal #label-name[data-v-5c9fceb4] {\n  color: white;\n  width: 100%;\n  font-size: 16px;\n  padding: 5px;\n  background-color: var(--btn-default);\n}\n#comentario-modal #selectDonde[data-v-5c9fceb4] {\n  -webkit-appearance: none;\n  -webkit-border-radius: 0px;\n  width: 80%;\n  height: 40px;\n  padding: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-68ea2e87]{margin:0;padding:0}#presion[data-v-68ea2e87]{background-color:#eee;min-height:100vh}#presion #formulario-top[data-v-68ea2e87]{height:25vh;margin-top:80px;border-bottom:1px solid rgba(0,0,0,.34)}#presion #graficas[data-v-68ea2e87]{background-color:#d3d3d3;height:100%;width:100%;margin:0;padding:0}#presion .btn-default[data-v-68ea2e87]{margin-top:0;background-color:var(--btn-default)}#presion .btn-default[data-v-68ea2e87]:active,#presion .btn-default[data-v-68ea2e87]:focus,#presion .btn-default[data-v-68ea2e87]:hover{background-color:var(--btn-default-hover)!important}@media screen and (max-width:767px){#presion .btn-default[data-v-68ea2e87]{margin-top:50px}}#line-chart[data-v-68ea2e87]{width:80vw;margin:50px auto}#pie-chart[data-v-68ea2e87]{height:auto;margin:50px auto}.container1[data-v-68ea2e87]{padding-top:100px;max-width:100%;margin:0 auto}.container2[data-v-68ea2e87]{max-width:400px;margin:0 auto}#loading-modal-modal[data-v-68ea2e87]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Direccion/Tendencias.vue"],"names":[],"mappings":"AACA,kCACE,SAAU,AACV,SAAW,CACZ,AACD,0BACE,sBAA0B,AAC1B,gBAAkB,CACnB,AACD,0CACI,YAAa,AACb,gBAAiB,AACjB,uCAA6C,CAChD,AACD,oCACI,yBAA0B,AAC1B,YAAa,AACb,WAAY,AACZ,SAAU,AACV,SAAW,CACd,AACD,uCACI,aAAc,AACd,mCAAqC,CACxC,AACD,wIACM,mDAAsD,CAC3D,AACD,oCACA,uCACQ,eAAiB,CACxB,CACA,AACD,6BACE,WAAY,AACZ,gBAAkB,CACnB,AACD,4BACE,YAAa,AACb,gBAAkB,CACnB,AACD,6BACE,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAChB,AACD,6BACE,gBAAiB,AACjB,aAAe,CAChB,AACD,sCACE,0DAA6D,CAC9D","file":"Tendencias.vue","sourcesContent":["\n.container-fluid[data-v-68ea2e87] {\n  margin: 0;\n  padding: 0;\n}\n#presion[data-v-68ea2e87] {\n  background-color: #eeeeee;\n  min-height: 100vh;\n}\n#presion #formulario-top[data-v-68ea2e87] {\n    height: 25vh;\n    margin-top: 80px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n#presion #graficas[data-v-68ea2e87] {\n    background-color: #d3d3d3;\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n}\n#presion .btn-default[data-v-68ea2e87] {\n    margin-top: 0;\n    background-color: var(--btn-default);\n}\n#presion .btn-default[data-v-68ea2e87]:hover, #presion .btn-default[data-v-68ea2e87]:active, #presion .btn-default[data-v-68ea2e87]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n@media screen and (max-width: 767px) {\n#presion .btn-default[data-v-68ea2e87] {\n        margin-top: 50px;\n}\n}\n#line-chart[data-v-68ea2e87] {\n  width: 80vw;\n  margin: 50px auto;\n}\n#pie-chart[data-v-68ea2e87] {\n  height: auto;\n  margin: 50px auto;\n}\n.container1[data-v-68ea2e87] {\n  padding-top: 100px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n.container2[data-v-68ea2e87] {\n  max-width: 400px;\n  margin: 0 auto;\n}\n#loading-modal-modal[data-v-68ea2e87] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-693d4b3f],.row[data-v-693d4b3f]{margin:0;padding:0}.unauthorized[data-v-693d4b3f]{background-color:rgba(238,158,7,.95);height:100%;color:#fff;margin:auto;text-align:center}@media screen and (max-width:767px){.unauthorized[data-v-693d4b3f]{height:100vh}}.unauthorized .title[data-v-693d4b3f]{margin:auto;text-align:center;display:block;font-size:40px;font-weight:700;width:35%;margin-top:25px}@media screen and (max-width:991px){.unauthorized .title[data-v-693d4b3f]{font-size:25px}}@media screen and (max-width:767px){.unauthorized .title[data-v-693d4b3f]{width:90%;font-size:25px;margin-top:15px}}.unauthorized .description[data-v-693d4b3f]{text-align:center;display:block;font-size:15px;font-weight:400;width:35%;margin:auto;margin-top:15px}@media screen and (max-width:767px){.unauthorized .description[data-v-693d4b3f]{width:75%;font-size:13px;margin-top:5px}}.unauthorized .back-button[data-v-693d4b3f]{padding:30px;width:35%;font-size:45px;font-weight:300;background-color:#fff;color:rgba(238,158,7,.95);text-align:center;margin:auto;cursor:pointer}@media screen and (max-width:767px){.unauthorized .back-button[data-v-693d4b3f]{width:70%}}.unauthorized .back-button[data-v-693d4b3f]:hover{background-color:rgba(0,0,0,.87)}.unauthorized .signboard[data-v-693d4b3f]{margin:auto;width:35%;height:45vh}@media screen and (max-width:767px){.unauthorized .signboard[data-v-693d4b3f]{height:25vh}}.unauthorized .signboard .circle[data-v-693d4b3f]{margin:auto;width:35px;height:35px;background-color:#fff;border-radius:50%}@media screen and (max-width:767px){.unauthorized .signboard .circle[data-v-693d4b3f]{margin:auto;width:25px;height:25px}}.unauthorized .signboard .left[data-v-693d4b3f]{border-right:3px solid #fff;height:41.5vh;width:50%}@media screen and (max-width:767px){.unauthorized .signboard .left[data-v-693d4b3f]{height:25.5vh}}.unauthorized #formulario-top[data-v-693d4b3f]{height:100vh;margin-top:120px;border-bottom:1px solid rgba(0,0,0,.34)}@media screen and (max-width:767px){.unauthorized #formulario-top[data-v-693d4b3f]{height:45vh}}.unauthorized #graficas[data-v-693d4b3f]{height:75vh}.unauthorized #buttons[data-v-693d4b3f]{display:block;margin-left:0}@media screen and (max-width:767px){.unauthorized #buttons[data-v-693d4b3f]{text-align:center}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Unauthorized/Unauthorized.vue"],"names":[],"mappings":"AACA,wDACE,SAAU,AACV,SAAW,CACZ,AACD,+BACE,qCAA0C,AAC1C,YAAa,AACb,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AACD,oCACA,+BACM,YAAc,CACnB,CACA,AACD,sCACI,YAAa,AACb,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,UAAW,AACX,eAAiB,CACpB,AACD,oCACA,sCACQ,cAAgB,CACvB,CACA,AACD,oCACA,sCACQ,UAAW,AACX,eAAgB,AAChB,eAAiB,CACxB,CACA,AACD,4CACI,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,UAAW,AACX,YAAa,AACb,eAAiB,CACpB,AACD,oCACA,4CACQ,UAAW,AACX,eAAgB,AAChB,cAAgB,CACvB,CACA,AACD,4CACI,aAAc,AACd,UAAW,AACX,eAAgB,AAChB,gBAAiB,AACjB,sBAAuB,AACvB,0BAA+B,AAC/B,kBAAmB,AACnB,YAAa,AACb,cAAgB,CACnB,AACD,oCACA,4CACQ,SAAW,CAClB,CACA,AACD,kDACI,gCAAsC,CACzC,AACD,0CACI,YAAa,AACb,UAAW,AACX,WAAa,CAChB,AACD,oCACA,0CACQ,WAAa,CACpB,CACA,AACD,kDACM,YAAa,AACb,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,iBAAmB,CACxB,AACD,oCACA,kDACU,YAAa,AACb,WAAY,AACZ,WAAa,CACtB,CACA,AACD,gDACM,4BAA6B,AAC7B,cAAe,AACf,SAAW,CAChB,AACD,oCACA,gDACU,aAAe,CACxB,CACA,AACD,+CACI,aAAc,AACd,iBAAkB,AAClB,uCAA6C,CAChD,AACD,oCACA,+CACQ,WAAa,CACpB,CACA,AACD,yCACI,WAAa,CAChB,AACD,wCACI,cAAe,AACf,aAAe,CAClB,AACD,oCACA,wCACQ,iBAAmB,CAC1B,CACA","file":"Unauthorized.vue","sourcesContent":["\n.container-fluid[data-v-693d4b3f], .row[data-v-693d4b3f] {\n  margin: 0;\n  padding: 0;\n}\n.unauthorized[data-v-693d4b3f] {\n  background-color: rgba(238, 158, 7, 0.95);\n  height: 100%;\n  color: #fff;\n  margin: auto;\n  text-align: center;\n}\n@media screen and (max-width: 767px) {\n.unauthorized[data-v-693d4b3f] {\n      height: 100vh;\n}\n}\n.unauthorized .title[data-v-693d4b3f] {\n    margin: auto;\n    text-align: center;\n    display: block;\n    font-size: 40px;\n    font-weight: 700;\n    width: 35%;\n    margin-top: 25px;\n}\n@media screen and (max-width: 991px) {\n.unauthorized .title[data-v-693d4b3f] {\n        font-size: 25px;\n}\n}\n@media screen and (max-width: 767px) {\n.unauthorized .title[data-v-693d4b3f] {\n        width: 90%;\n        font-size: 25px;\n        margin-top: 15px;\n}\n}\n.unauthorized .description[data-v-693d4b3f] {\n    text-align: center;\n    display: block;\n    font-size: 15px;\n    font-weight: 400;\n    width: 35%;\n    margin: auto;\n    margin-top: 15px;\n}\n@media screen and (max-width: 767px) {\n.unauthorized .description[data-v-693d4b3f] {\n        width: 75%;\n        font-size: 13px;\n        margin-top: 5px;\n}\n}\n.unauthorized .back-button[data-v-693d4b3f] {\n    padding: 30px;\n    width: 35%;\n    font-size: 45px;\n    font-weight: 300;\n    background-color: #fff;\n    color: rgba(238, 158, 7, 0.95);\n    text-align: center;\n    margin: auto;\n    cursor: pointer;\n}\n@media screen and (max-width: 767px) {\n.unauthorized .back-button[data-v-693d4b3f] {\n        width: 70%;\n}\n}\n.unauthorized .back-button[data-v-693d4b3f]:hover {\n    background-color: rgba(0, 0, 0, 0.87);\n}\n.unauthorized .signboard[data-v-693d4b3f] {\n    margin: auto;\n    width: 35%;\n    height: 45vh;\n}\n@media screen and (max-width: 767px) {\n.unauthorized .signboard[data-v-693d4b3f] {\n        height: 25vh;\n}\n}\n.unauthorized .signboard .circle[data-v-693d4b3f] {\n      margin: auto;\n      width: 35px;\n      height: 35px;\n      background-color: #fff;\n      border-radius: 50%;\n}\n@media screen and (max-width: 767px) {\n.unauthorized .signboard .circle[data-v-693d4b3f] {\n          margin: auto;\n          width: 25px;\n          height: 25px;\n}\n}\n.unauthorized .signboard .left[data-v-693d4b3f] {\n      border-right: 3px solid #fff;\n      height: 41.5vh;\n      width: 50%;\n}\n@media screen and (max-width: 767px) {\n.unauthorized .signboard .left[data-v-693d4b3f] {\n          height: 25.5vh;\n}\n}\n.unauthorized #formulario-top[data-v-693d4b3f] {\n    height: 100vh;\n    margin-top: 120px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n@media screen and (max-width: 767px) {\n.unauthorized #formulario-top[data-v-693d4b3f] {\n        height: 45vh;\n}\n}\n.unauthorized #graficas[data-v-693d4b3f] {\n    height: 75vh;\n}\n.unauthorized #buttons[data-v-693d4b3f] {\n    display: block;\n    margin-left: 0;\n}\n@media screen and (max-width: 767px) {\n.unauthorized #buttons[data-v-693d4b3f] {\n        text-align: center;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".logo{width:auto;height:40px!important;margin:10px auto;display:block}.login,.logo{text-align:center}.login{color:#fff}.fade-enter-active,.fade-leave-active{transition:opacity .25s}.fade-enter,.fade-leave-to{opacity:0}.vsm--scroll-wrapper::-webkit-scrollbar{display:none}.vsm--scroll-wrapper{-ms-overflow-style:none;scrollbar-width:none}.v-sidebar-menu .vsm--icon,.v-sidebar-menu .vsm--title,.vsm--arrow.vsm--arrow_slot>span>i.fa-caret-right{color:var(--sidebar-menu-unselected-color)}.vsm--arrow.vsm--arrow_open.vsm--arrow_slot>span>i.fa-caret-right{color:var(--sidebar-menu-selected-color)}.v-sidebar-menu .vsm--link_hover{text-decoration:none!important}.v-sidebar-menu .vsm--link_level-1.vsm--link_active,.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active{box-shadow:3px 0 0 0 var(--menu-color) inset;background-color:var(--sidebar-menu-selected-background-color)}.v-sidebar-menu .vsm--toggle-btn{color:var(--sidebar-menu-expander-toogle-btn-color)}.vsm--arrow .vsm--arrow_slot span{color:var(--md-theme-default-primary)}.v-sidebar-menu .vsm--mobile-bg,.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1{background-color:var(--md-theme-default-accent)}.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1>.vsm--title{color:var(--sidebar-menu-selected-color)}.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon>.vsm--icon,.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1>.vsm--icon{color:var(--sidebar-menu-selected-color);background-color:var(--sidebar-menu-background-open-icon-color)}.v-sidebar-menu.vsm_collapsed .vsm--item.vsm--item_open,.vsm--link.vsm--link_mobile-item>.vsm--title{color:var(--sidebar-menu-selected-color)}.v-sidebar-menu .vsm--link:hover,.v-sidebar-menu .vsm--link_hover{background-color:var(--sidebar-menu-hover-color)}.vsm--arrow vsm--arrow_open vsm--arrow_slot span{color:var(--sidebar-menu-text-color-selected)}.vsm--arrow .vsm--arrow_slot>span{color:var(--sidebar-menu-text-color-unselected)!important}.vsm--toggle-btn_slot:active,.vsm--toggle-btn_slot:focus,.vsm--toggle-btn_slot:hover{background-color:transparent}.v-sidebar-menu .vsm--link:hover>.vsm--arrow>span>i.fa-caret-right,.v-sidebar-menu .vsm--link:hover>.vsm--icon,.v-sidebar-menu .vsm--link:hover>.vsm--title{color:var(--sidebar-menu-color-hover)}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/persistant/Menu.vue"],"names":[],"mappings":"AACA,MACI,WAAY,AACZ,sBAAwB,AACxB,iBAAkB,AAElB,aAAe,CAClB,AACD,aAHI,iBAAmB,CAMtB,AAHD,OACE,UAAa,CAEd,AACD,sCAEI,uBAAwB,CAC3B,AACD,2BAEI,SAAU,CACb,AACD,wCACI,YAAc,CACjB,AACD,qBACI,wBAAyB,AACzB,oBAAsB,CACzB,AAOD,yGACE,0CAA4C,CAC7C,AACD,kEACE,wCAA0C,CAC3C,AACD,iCACE,8BAAiC,CAClC,AACD,8GACE,6CAAoD,AACpD,8DAAgE,CACjE,AACD,iCACE,mDAAqD,CACtD,AACD,kCACE,qCAAuC,CACxC,AAID,gGACI,+CAAkD,CACrD,AAQD,4EACI,wCAA0C,CAC7C,AAOD,oOAHI,yCAA0C,AAC1C,+DAAkE,CAKrE,AACD,qGAEE,wCAA0C,CAC3C,AACD,kEACI,gDAAkD,CACrD,AACD,iDACE,6CAA+C,CAChD,AACD,kCACE,yDAA4D,CAC7D,AACD,qFACI,4BAA8B,CACjC,AAOD,4JACI,qCAAuC,CAC1C","file":"Menu.vue","sourcesContent":["\n.logo {\r\n    width: auto;\r\n    height: 40px !important;\r\n    margin: 10px auto;\r\n    text-align: center;\r\n    display: block;\n}\n.login {\r\n  color: white;\r\n  text-align: center;\n}\n.fade-enter-active,\r\n.fade-leave-active {\r\n    transition: opacity .25s\n}\n.fade-enter,\r\n.fade-leave-to {\r\n    opacity: 0\n}\n.vsm--scroll-wrapper::-webkit-scrollbar {\r\n    display: none;\n}\n.vsm--scroll-wrapper {\r\n    -ms-overflow-style: none; /* IE and Edge */\r\n    scrollbar-width: none; /* Firefox */\n}\n.v-sidebar-menu .vsm--title {\r\n  color:var(--sidebar-menu-unselected-color);\n}\n.v-sidebar-menu .vsm--icon {\r\n  color:var(--sidebar-menu-unselected-color);\n}\n.vsm--arrow.vsm--arrow_slot > span > i.fa-caret-right {\r\n  color: var(--sidebar-menu-unselected-color);\n}\n.vsm--arrow.vsm--arrow_open.vsm--arrow_slot  > span > i.fa-caret-right {\r\n  color: var(--sidebar-menu-selected-color);\n}\n.v-sidebar-menu .vsm--link_hover {\r\n  text-decoration: none !important;\n}\n.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active, .v-sidebar-menu .vsm--link_level-1.vsm--link_active {\r\n  box-shadow: 3px 0px 0px 0px var(--menu-color) inset;\r\n  background-color: var(--sidebar-menu-selected-background-color);\n}\n.v-sidebar-menu .vsm--toggle-btn {\r\n  color: var(--sidebar-menu-expander-toogle-btn-color);\n}\n.vsm--arrow .vsm--arrow_slot span {\r\n  color: var(--md-theme-default-primary);\n}\n.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {\r\n    background-color: var(--md-theme-default-accent);\n}\n.v-sidebar-menu .vsm--mobile-bg {\r\n    background-color:  var(--md-theme-default-accent);\n}\r\n\r\n/* .v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon, \r\n.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon\r\n{\r\n    color: var(--md-theme-default-primary);\r\n    background-color:  var(--md-theme-default-accent);\r\n} */\n.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 > .vsm--title {\r\n    color: var(--sidebar-menu-selected-color);\n}\n.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon, \r\n.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon > .vsm--icon\r\n{\r\n    color: var(--sidebar-menu-selected-color);\r\n    background-color:  var(--sidebar-menu-background-open-icon-color);\n}\n.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 > .vsm--icon {\r\n  color: var(--sidebar-menu-selected-color);\r\n  background-color:  var(--sidebar-menu-background-open-icon-color);\n}\n.v-sidebar-menu.vsm_collapsed .vsm--item.vsm--item_open,\r\n.vsm--link.vsm--link_mobile-item > .vsm--title{\r\n  color: var(--sidebar-menu-selected-color);\n}\n.v-sidebar-menu .vsm--link_hover, .v-sidebar-menu .vsm--link:hover {\r\n    background-color: var(--sidebar-menu-hover-color);\n}\n.vsm--arrow vsm--arrow_open vsm--arrow_slot span {\r\n  color: var(--sidebar-menu-text-color-selected);\n}\n.vsm--arrow .vsm--arrow_slot > span {\r\n  color: var(--sidebar-menu-text-color-unselected) !important;\n}\n.vsm--toggle-btn_slot:hover, .vsm--toggle-btn_slot:focus, .vsm--toggle-btn_slot:active {\r\n    background-color: transparent;\n}\n.v-sidebar-menu .vsm--link:hover > .vsm--title {\r\n    color: var(--sidebar-menu-color-hover);\n}\n.v-sidebar-menu .vsm--link:hover > .vsm--icon {\r\n    color: var(--sidebar-menu-color-hover);\n}\n.v-sidebar-menu .vsm--link:hover > .vsm--arrow > span > i.fa-caret-right {\r\n    color: var(--sidebar-menu-color-hover);\n}\r\n\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".pressure-range .datepicker-overlay{position:relative!important;background-color:var(--md-theme-default-primary)!important}.pressure-range .cov-date-body{display:contents!important;position:relative!important}.pressure-range .cov-date-body .watch-box .hour-item,.pressure-range .cov-date-body .watch-box .min-item{font-size:36px!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Presion/PresionRange.vue"],"names":[],"mappings":"AACA,oCACE,4BAA8B,AAC9B,0DAA6D,CAC9D,AACD,+BACE,2BAA6B,AAC7B,2BAA8B,CAC/B,AAID,yGACE,wBAA2B,CAC5B","file":"PresionRange.vue","sourcesContent":["\n.pressure-range .datepicker-overlay {\r\n  position: relative !important;\r\n  background-color: var(--md-theme-default-primary) !important;\n}\n.pressure-range .cov-date-body {\r\n  display: contents !important;\r\n  position: relative !important;\n}\n.pressure-range .cov-date-body .watch-box .hour-item {\r\n  font-size: 36px !important;\n}\n.pressure-range .cov-date-body .watch-box .min-item {\r\n  font-size: 36px !important;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".custom-select[data-v-6f5a2cfc]{padding:4px 16px}.md-drawer[data-v-6f5a2cfc]{width:320px;max-width:calc(100vw - 125px);z-index:10}.toolbar-title[data-v-6f5a2cfc]{min-height:44px}.md-datepicker[data-v-6f5a2cfc],.md-list[data-v-6f5a2cfc],.md-radio[data-v-6f5a2cfc]{margin:0}.switch[data-v-6f5a2cfc]{position:relative;display:inline-block;width:30px;height:17px}.switch input[data-v-6f5a2cfc]{opacity:0;width:0;height:0}.slider[data-v-6f5a2cfc]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider[data-v-6f5a2cfc]:before{position:absolute;content:\"\";height:13px;width:13px;left:2px;bottom:2px;background-color:#fff;transition:.4s}input:checked+.slider[data-v-6f5a2cfc]{background-color:var(--radio-button-checked)}input:focus+.slider[data-v-6f5a2cfc]{box-shadow:0 0 1px var(--radio-button-checked)}input:checked+.slider[data-v-6f5a2cfc]:before{transform:translateX(13px)}.slider.round[data-v-6f5a2cfc]{border-radius:17px}.slider.round[data-v-6f5a2cfc]:before{border-radius:50%}.slider-text[data-v-6f5a2cfc]{margin:0 8px;font-size:12px;position:absolute;cursor:pointer}.pe-radio[data-v-6f5a2cfc]{display:block;position:relative;padding-left:17.5px;margin-bottom:6px;cursor:pointer;font-size:22px;-webkit-user-select:none;-ms-user-select:none;user-select:none}.pe-radio-text[data-v-6f5a2cfc]{font-size:14px;margin:0 8px;display:block}.pe-radio input[data-v-6f5a2cfc]{position:absolute;opacity:0;cursor:pointer}.checkmark[data-v-6f5a2cfc]{position:absolute;top:0;left:0;height:16px;width:16px;background-color:#eee;border-radius:50%}.pe-radio:hover input~.checkmark[data-v-6f5a2cfc]{background-color:#ccc}.pe-radio input:checked~.checkmark[data-v-6f5a2cfc]{background-color:var(--radio-button-checked)}.checkmark[data-v-6f5a2cfc]:after{content:\"\";position:absolute;display:none}.pe-radio input:checked~.checkmark[data-v-6f5a2cfc]:after{display:block}.pe-radio .checkmark[data-v-6f5a2cfc]:after{top:4.5px;left:4.5px;width:6px;height:6px;border-radius:50%;background:#fff}.error-message[data-v-6f5a2cfc],.loading-spinner[data-v-6f5a2cfc]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:315px;position:absolute;top:0;left:0;right:0;bottom:0;font-size:14px;background-color:hsla(0,0%,50%,.5);z-index:1}.error-message[data-v-6f5a2cfc]{font-weight:700;color:red}.chart-wrapper[data-v-6f5a2cfc]{position:relative}.chart-inner[data-v-6f5a2cfc]{position:relative;height:300px}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Presion/PresionRange.vue"],"names":[],"mappings":"AACA,gCACE,gBAAkB,CACnB,AACD,4BACE,YAAa,AACb,8BAA+B,AAC/B,UAAY,CACb,AACD,gCACE,eAAiB,CAClB,AAOD,qFACE,QAAU,CACX,AAGD,yBACE,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,WAAa,CACd,AAGD,+BACE,UAAW,AACX,QAAS,AACT,QAAU,CACX,AAGD,yBACE,kBAAmB,AACnB,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,sBAAuB,AACvB,cAAgB,CACjB,AACD,gCACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,SAAU,AACV,WAAY,AACZ,sBAAwB,AACxB,cAAgB,CACjB,AACD,uCACE,4CAA8C,CAC/C,AACD,qCACE,8CAAgD,CACjD,AACD,8CACE,0BAA4B,CAC7B,AAGD,+BACE,kBAAoB,CACrB,AACD,sCACE,iBAAmB,CACpB,AACD,8BACE,aAAc,AACd,eAAgB,AAChB,kBAAmB,AACnB,cAAgB,CACjB,AAGD,2BACE,cAAe,AACf,kBAAmB,AACnB,oBAAqB,AACrB,kBAAmB,AACnB,eAAgB,AAChB,eAAgB,AAChB,yBAA0B,AAC1B,qBAAsB,AACtB,gBAAkB,CACnB,AACD,gCACE,eAAgB,AAChB,aAAc,AACd,aAAe,CAChB,AAGD,iCACE,kBAAmB,AACnB,UAAW,AACX,cAAgB,CACjB,AAGD,4BACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,sBAAuB,AACvB,iBAAmB,CACpB,AAGD,kDACE,qBAAuB,CACxB,AAGD,oDACE,4CAA8C,CAC/C,AAGD,kCACE,WAAY,AACZ,kBAAmB,AACnB,YAAc,CACf,AAGD,0DACE,aAAe,CAChB,AAGD,4CACE,UAAW,AACX,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,eAAkB,CACnB,AAmBD,kEAjBE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,mBAAoB,AACxB,aAAc,AACd,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,eAAgB,AAChB,mCAA2C,AAE3C,SAAW,CAqBZ,AAnBD,gCAaE,gBAAkB,AAIlB,SAAW,CAEZ,AACD,gCACE,iBAAmB,CACpB,AACD,8BACE,kBAAmB,AACnB,YAAc,CACf","file":"PresionRange.vue","sourcesContent":["\n.custom-select[data-v-6f5a2cfc] {\n  padding: 4px 16px;\n}\n.md-drawer[data-v-6f5a2cfc] {\n  width: 320px;\n  max-width: calc(100vw - 125px);\n  z-index: 10;\n}\n.toolbar-title[data-v-6f5a2cfc] {\n  min-height: 44px;\n}\n.md-radio[data-v-6f5a2cfc] {\n  margin: 0;\n}\n.md-datepicker[data-v-6f5a2cfc] {\n  margin: 0;\n}\n.md-list[data-v-6f5a2cfc] {\n  margin: 0;\n}\n\n/* The switch - the box around the slider */\n.switch[data-v-6f5a2cfc] {\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  height: 17px;\n}\n\n/* Hide default HTML checkbox */\n.switch input[data-v-6f5a2cfc] {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider */\n.slider[data-v-6f5a2cfc] {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n}\n.slider[data-v-6f5a2cfc]:before {\n  position: absolute;\n  content: \"\";\n  height: 13px;\n  width: 13px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: .4s;\n}\ninput:checked + .slider[data-v-6f5a2cfc] {\n  background-color: var(--radio-button-checked);\n}\ninput:focus + .slider[data-v-6f5a2cfc] {\n  box-shadow: 0 0 1px var(--radio-button-checked);\n}\ninput:checked + .slider[data-v-6f5a2cfc]:before {\n  transform: translateX(13px);\n}\n\n/* Rounded sliders */\n.slider.round[data-v-6f5a2cfc] {\n  border-radius: 17px;\n}\n.slider.round[data-v-6f5a2cfc]:before {\n  border-radius: 50%;\n}\n.slider-text[data-v-6f5a2cfc] {\n  margin: 0 8px;\n  font-size: 12px;\n  position: absolute;\n  cursor: pointer;\n}\n\n/* The container */\n.pe-radio[data-v-6f5a2cfc] {\n  display: block;\n  position: relative;\n  padding-left: 17.5px;\n  margin-bottom: 6px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.pe-radio-text[data-v-6f5a2cfc] {\n  font-size: 14px;\n  margin: 0 8px;\n  display: block;\n}\n\n/* Hide the browser's default radio button */\n.pe-radio input[data-v-6f5a2cfc] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n/* Create a custom radio button */\n.checkmark[data-v-6f5a2cfc] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background-color: #eee;\n  border-radius: 50%;\n}\n\n/* On mouse-over, add a grey background color */\n.pe-radio:hover input ~ .checkmark[data-v-6f5a2cfc] {\n  background-color: #ccc;\n}\n\n/* When the radio button is checked, add a blue background */\n.pe-radio input:checked ~ .checkmark[data-v-6f5a2cfc] {\n  background-color: var(--radio-button-checked);\n}\n\n/* Create the indicator (the dot/circle - hidden when not checked) */\n.checkmark[data-v-6f5a2cfc]:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the indicator (dot/circle) when checked */\n.pe-radio input:checked ~ .checkmark[data-v-6f5a2cfc]:after {\n  display: block;\n}\n\n/* Style the indicator (dot/circle) */\n.pe-radio .checkmark[data-v-6f5a2cfc]:after {\n  top: 4.5px;\n  left: 4.5px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: white;\n}\n.loading-spinner[data-v-6f5a2cfc] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 315px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  font-size: 14px;\n  background-color: rgba(128, 128, 128, 0.5);\n  /* Gray transparent background */\n  z-index: 1;\n}\n.error-message[data-v-6f5a2cfc] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 315px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  font-weight: bold;\n  font-size: 14px;\n  background-color: rgba(128, 128, 128, 0.5);\n  /* Gray transparent background */\n  color: red;\n  z-index: 1;\n}\n.chart-wrapper[data-v-6f5a2cfc] {\n  position: relative;\n}\n.chart-inner[data-v-6f5a2cfc] {\n  position: relative;\n  height: 300px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#formulario-top[data-v-73cc693a]{margin-top:75px;height:12vh}@media screen and (max-width:767px){#formulario-top[data-v-73cc693a]{height:45vh}}.col-md-6[data-v-73cc693a],.col-xs-12[data-v-73cc693a]{padding:0!important}.container-fluid[data-v-73cc693a]{background-color:#e0e0e0;width:100%;padding:0;margin:0}.panel-body[data-v-73cc693a],table[data-v-73cc693a]{height:65vh;margin:0}.panel-body .info td[data-v-73cc693a],table .info td[data-v-73cc693a]{background-color:#eee}.panel-body th[data-v-73cc693a],table th[data-v-73cc693a]{text-align:center;padding-left:25px}@media screen and (max-width:415px){.panel-body th[data-v-73cc693a],table th[data-v-73cc693a]{font-size:12px}}.panel-body td[data-v-73cc693a],table td[data-v-73cc693a]{text-align:left;padding-left:25px}.panel-body td i[data-v-73cc693a],table td i[data-v-73cc693a]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body td i[data-v-73cc693a]:hover,table td i[data-v-73cc693a]:hover{color:var(--btn-default)}.panel-body .nombre-alarma[data-v-73cc693a],table .nombre-alarma[data-v-73cc693a]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-73cc693a],table .panel-body[data-v-73cc693a]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-73cc693a],table .panel-title[data-v-73cc693a]{font-size:12px}}.btn-default[data-v-73cc693a]{background:var(--btn-default-hover)}.btn-default[data-v-73cc693a]:active,.btn-default[data-v-73cc693a]:focus,.btn-default[data-v-73cc693a]:hover{background:var(--btn-default)!important}#reportes-page[data-v-73cc693a]{padding-top:70px;background-color:#eee;height:100vh}#reportes-page #formulario-top[data-v-73cc693a]{height:15vh}@media screen and (max-width:767px){#reportes-page #formulario-top[data-v-73cc693a]{height:45vh}}#reportes-page #range-wrapper[data-v-73cc693a]{margin:50px auto}.color-2 .irs-bar-edge[data-v-73cc693a],.color-2 .irs-bar[data-v-73cc693a]{background:red}.panel[data-v-73cc693a]{margin-bottom:0}.fa[data-v-73cc693a]{margin-left:3px;margin-top:3px}@media screen and (max-width:1010px){.fa[data-v-73cc693a]{margin-top:-5px;margin-left:13px}}@media screen and (max-width:991px){.fa[data-v-73cc693a]{margin-left:3px;margin-top:3px}}@media screen and (max-width:582px){.fa[data-v-73cc693a]{margin-top:-5px;margin-left:13px}}@media screen and (max-width:415px){.fa[data-v-73cc693a]{margin-left:12px;margin-top:3px}}.row[data-v-73cc693a]{margin-right:0}.no-show[data-v-73cc693a]{display:none}h3[data-v-73cc693a]{color:#000;cursor:pointer}span[data-v-73cc693a]{padding:0 20px}@media screen and (max-width:400px){span[data-v-73cc693a]{padding:0 10px}}.panel-body[data-v-73cc693a],table[data-v-73cc693a]{background-color:#eee;overflow:scroll;height:80vh;padding:0;padding-left:0;border-top:1px solid #999}table[data-v-73cc693a]{height:35vh}.not-active[data-v-73cc693a]{color:rgba(0,0,0,.34)}.col-md-5[data-v-73cc693a],.col-md-7[data-v-73cc693a]{margin:0;padding:0}.panel-default[data-v-73cc693a]{background-color:#e0e0e0;border:none;border-radius:0}#data-table[data-v-73cc693a]{position:absolute;color:rgba(0,0,0,.87);width:100vw;height:30vh;bottom:0}#ductos h3[data-v-73cc693a]{padding-left:15px}#ductos .ducto[data-v-73cc693a]{color:#fff;font-size:12px;cursor:pointer;background-color:var(--btn-default)}#alarmas th[data-v-73cc693a]{text-align:left;padding-left:25px}@media screen and (max-width:415px){#alarmas th[data-v-73cc693a]{font-size:12px}}#alarmas td[data-v-73cc693a]{text-align:left;padding-left:25px;background-color:#eee}#alarmas td i[data-v-73cc693a]{color:rgba(0,0,0,.34);cursor:pointer}#alarmas td i[data-v-73cc693a]:hover{color:var(--btn-default)}#alarmas .nombre-alarma[data-v-73cc693a]{background-color:var(--btn-default);color:#fff}#alarmas .panel-body[data-v-73cc693a]{padding:0}@media screen and (max-width:415px){#alarmas .panel-title[data-v-73cc693a]{font-size:12px}}#comentario-modal h3[data-v-73cc693a]{color:rgba(0,0,0,.87)}#comentario-modal .btn-default[data-v-73cc693a]{background-color:var(--btn-default)}#comentario-modal .btn-default[data-v-73cc693a]:active,#comentario-modal .btn-default[data-v-73cc693a]:focus,#comentario-modal .btn-default[data-v-73cc693a]:hover{background-color:var(--btn-default-hover)!important}#comentario-modal label[data-v-73cc693a]{color:var(--btn-default)}#comentario-modal #label-name[data-v-73cc693a]{color:#fff;width:100%;font-size:16px;padding:5px;background-color:var(--btn-default)}#comentario-modal #selectDonde[data-v-73cc693a]{-webkit-appearance:none;-webkit-border-radius:0;width:80%;height:40px;padding:5px}#loading-modal-modal[data-v-73cc693a]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Reportes/Reportepoll.vue"],"names":[],"mappings":"AACA,iCACE,gBAAiB,AACjB,WAAa,CACd,AACD,oCACA,iCACM,WAAa,CAClB,CACA,AACD,uDAEE,mBAAwB,CACzB,AACD,kCACE,yBAA0B,AAC1B,WAAY,AACZ,UAAW,AACX,QAAU,CACX,AACD,oDAGE,YAAa,AAEb,QAAU,CACX,AACD,sEAEI,qBAA0B,CAC7B,AACD,0DAEI,kBAAmB,AACnB,iBAAmB,CACtB,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,8DAEM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,0EAEQ,wBAA0B,CACjC,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAW,CACd,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA,AACD,8BACE,mCAAqC,CACtC,AACD,6GACI,uCAA0C,CAC7C,AACD,gCACE,iBAAkB,AAClB,sBAA0B,AAC1B,YAAc,CACf,AACD,gDACI,WAAa,CAChB,AACD,oCACA,gDACQ,WAAa,CACpB,CACA,AACD,+CACI,gBAAkB,CACrB,AACD,2EAEE,cAAgB,CACjB,AACD,wBACE,eAAiB,CAClB,AACD,qBACE,gBAAiB,AACjB,cAAgB,CACjB,AACD,qCACA,qBACM,gBAAiB,AACjB,gBAAkB,CACvB,CACA,AACD,oCACA,qBACM,gBAAiB,AACjB,cAAgB,CACrB,CACA,AACD,oCACA,qBACM,gBAAiB,AACjB,gBAAkB,CACvB,CACA,AACD,oCACA,qBACM,iBAAkB,AAClB,cAAgB,CACrB,CACA,AACD,sBACE,cAAkB,CACnB,AACD,0BACE,YAAc,CACf,AACD,oBACE,WAAa,AACb,cAAgB,CACjB,AACD,sBACE,cAAgB,CACjB,AACD,oCACA,sBACM,cAAgB,CACrB,CACA,AACD,oDAEE,sBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,UAAW,AACX,eAAkB,AAClB,yBAA2B,CAC5B,AACD,uBACE,WAAa,CACd,AACD,6BACE,qBAA2B,CAC5B,AACD,sDAEE,SAAU,AACV,SAAW,CACZ,AACD,gCACE,yBAA0B,AAC1B,YAAa,AACb,eAAiB,CAClB,AACD,6BACE,kBAAmB,AACnB,sBAA2B,AAC3B,YAAa,AACb,YAAa,AACb,QAAU,CACX,AACD,4BACE,iBAAmB,CACpB,AACD,gCACE,WAAa,AACb,eAAgB,AAChB,eAAgB,AAChB,mCAAqC,CACtC,AACD,6BACE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,oCACA,6BACM,cAAgB,CACrB,CACA,AACD,6BACE,gBAAiB,AACjB,kBAAmB,AACnB,qBAA0B,CAC3B,AACD,+BACI,sBAA2B,AAC3B,cAAgB,CACnB,AACD,qCACM,wBAA0B,CAC/B,AACD,yCACE,oCAAqC,AACrC,UAAa,CACd,AACD,sCACE,SAAW,CACZ,AACD,oCACA,uCACI,cAAgB,CACnB,CACA,AACD,sCACE,qBAA2B,CAC5B,AACD,gDACE,mCAAqC,CACtC,AACD,mKACI,mDAAsD,CACzD,AACD,yCACE,wBAA0B,CAC3B,AACD,+CACE,WAAa,AACb,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,mCAAqC,CACtC,AACD,gDACE,wBAAyB,AACzB,wBAA2B,AAC3B,UAAW,AACX,YAAa,AACb,WAAa,CACd,AACD,sCACE,0DAA6D,CAC9D","file":"Reportepoll.vue","sourcesContent":["\n#formulario-top[data-v-73cc693a] {\n  margin-top: 75px;\n  height: 12vh;\n}\n@media screen and (max-width: 767px) {\n#formulario-top[data-v-73cc693a] {\n      height: 45vh;\n}\n}\n.col-md-6[data-v-73cc693a],\n.col-xs-12[data-v-73cc693a] {\n  padding: 0px !important;\n}\n.container-fluid[data-v-73cc693a] {\n  background-color: #E0E0E0;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\ntable[data-v-73cc693a],\n.panel-body[data-v-73cc693a] {\n  overflow: scroll;\n  height: 65vh;\n  padding: 0px 0;\n  margin: 0;\n}\ntable .info td[data-v-73cc693a],\n  .panel-body .info td[data-v-73cc693a] {\n    background-color: #eeeeee;\n}\ntable th[data-v-73cc693a],\n  .panel-body th[data-v-73cc693a] {\n    text-align: center;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-73cc693a],\n      .panel-body th[data-v-73cc693a] {\n        font-size: 12px;\n}\n}\ntable td[data-v-73cc693a],\n  .panel-body td[data-v-73cc693a] {\n    text-align: left;\n    padding-left: 25px;\n}\ntable td i[data-v-73cc693a],\n    .panel-body td i[data-v-73cc693a] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\ntable td i[data-v-73cc693a]:hover,\n      .panel-body td i[data-v-73cc693a]:hover {\n        color: var(--btn-default);\n}\ntable .nombre-alarma[data-v-73cc693a],\n  .panel-body .nombre-alarma[data-v-73cc693a] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-73cc693a],\n  .panel-body .panel-body[data-v-73cc693a] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-73cc693a],\n    .panel-body .panel-title[data-v-73cc693a] {\n      font-size: 12px;\n}\n}\n.btn-default[data-v-73cc693a] {\n  background: var(--btn-default-hover);\n}\n.btn-default[data-v-73cc693a]:hover, .btn-default[data-v-73cc693a]:focus, .btn-default[data-v-73cc693a]:active {\n    background: var(--btn-default) !important;\n}\n#reportes-page[data-v-73cc693a] {\n  padding-top: 70px;\n  background-color: #eeeeee;\n  height: 100vh;\n}\n#reportes-page #formulario-top[data-v-73cc693a] {\n    height: 15vh;\n}\n@media screen and (max-width: 767px) {\n#reportes-page #formulario-top[data-v-73cc693a] {\n        height: 45vh;\n}\n}\n#reportes-page #range-wrapper[data-v-73cc693a] {\n    margin: 50px auto;\n}\n.color-2 .irs-bar[data-v-73cc693a],\n.color-2 .irs-bar-edge[data-v-73cc693a] {\n  background: red;\n}\n.panel[data-v-73cc693a] {\n  margin-bottom: 0;\n}\n.fa[data-v-73cc693a] {\n  margin-left: 3px;\n  margin-top: 3px;\n}\n@media screen and (max-width: 1010px) {\n.fa[data-v-73cc693a] {\n      margin-top: -5px;\n      margin-left: 13px;\n}\n}\n@media screen and (max-width: 991px) {\n.fa[data-v-73cc693a] {\n      margin-left: 3px;\n      margin-top: 3px;\n}\n}\n@media screen and (max-width: 582px) {\n.fa[data-v-73cc693a] {\n      margin-top: -5px;\n      margin-left: 13px;\n}\n}\n@media screen and (max-width: 415px) {\n.fa[data-v-73cc693a] {\n      margin-left: 12px;\n      margin-top: 3px;\n}\n}\n.row[data-v-73cc693a] {\n  margin-right: 0px;\n}\n.no-show[data-v-73cc693a] {\n  display: none;\n}\nh3[data-v-73cc693a] {\n  color: black;\n  cursor: pointer;\n}\nspan[data-v-73cc693a] {\n  padding: 0 20px;\n}\n@media screen and (max-width: 400px) {\nspan[data-v-73cc693a] {\n      padding: 0 10px;\n}\n}\ntable[data-v-73cc693a],\n.panel-body[data-v-73cc693a] {\n  background-color: #eeeeee;\n  overflow: scroll;\n  height: 80vh;\n  padding: 0;\n  padding-left: 0px;\n  border-top: 1px solid #999;\n}\ntable[data-v-73cc693a] {\n  height: 35vh;\n}\n.not-active[data-v-73cc693a] {\n  color: rgba(0, 0, 0, 0.34);\n}\n.col-md-5[data-v-73cc693a],\n.col-md-7[data-v-73cc693a] {\n  margin: 0;\n  padding: 0;\n}\n.panel-default[data-v-73cc693a] {\n  background-color: #E0E0E0;\n  border: none;\n  border-radius: 0;\n}\n#data-table[data-v-73cc693a] {\n  position: absolute;\n  color: rgba(0, 0, 0, 0.87);\n  width: 100vw;\n  height: 30vh;\n  bottom: 0;\n}\n#ductos h3[data-v-73cc693a] {\n  padding-left: 15px;\n}\n#ductos .ducto[data-v-73cc693a] {\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  background-color: var(--btn-default);\n}\n#alarmas th[data-v-73cc693a] {\n  text-align: left;\n  padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\n#alarmas th[data-v-73cc693a] {\n      font-size: 12px;\n}\n}\n#alarmas td[data-v-73cc693a] {\n  text-align: left;\n  padding-left: 25px;\n  background-color: #eeeeee;\n}\n#alarmas td i[data-v-73cc693a] {\n    color: rgba(0, 0, 0, 0.34);\n    cursor: pointer;\n}\n#alarmas td i[data-v-73cc693a]:hover {\n      color: var(--btn-default);\n}\n#alarmas .nombre-alarma[data-v-73cc693a] {\n  background-color: var(--btn-default);\n  color: white;\n}\n#alarmas .panel-body[data-v-73cc693a] {\n  padding: 0;\n}\n@media screen and (max-width: 415px) {\n#alarmas .panel-title[data-v-73cc693a] {\n    font-size: 12px;\n}\n}\n#comentario-modal h3[data-v-73cc693a] {\n  color: rgba(0, 0, 0, 0.87);\n}\n#comentario-modal .btn-default[data-v-73cc693a] {\n  background-color: var(--btn-default);\n}\n#comentario-modal .btn-default[data-v-73cc693a]:hover, #comentario-modal .btn-default[data-v-73cc693a]:active, #comentario-modal .btn-default[data-v-73cc693a]:focus {\n    background-color: var(--btn-default-hover) !important;\n}\n#comentario-modal label[data-v-73cc693a] {\n  color: var(--btn-default);\n}\n#comentario-modal #label-name[data-v-73cc693a] {\n  color: white;\n  width: 100%;\n  font-size: 16px;\n  padding: 5px;\n  background-color: var(--btn-default);\n}\n#comentario-modal #selectDonde[data-v-73cc693a] {\n  -webkit-appearance: none;\n  -webkit-border-radius: 0px;\n  width: 80%;\n  height: 40px;\n  padding: 5px;\n}\n#loading-modal-modal[data-v-73cc693a] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".row[data-v-78745261]{margin:0;padding:0}.panel-body[data-v-78745261],table[data-v-78745261]{background-color:#eee;overflow:scroll;padding:0}.panel-default[data-v-78745261]{background-color:#e0e0e0;border:none;border-radius:0}table thead tr th[data-v-78745261]{color:#fff;background-color:var(--btn-default)}table th[data-v-78745261]{text-align:left}@media screen and (max-width:415px){table th[data-v-78745261]{font-size:12px}}table tbody td[data-v-78745261]{text-align:left;background-color:#eee!important;max-width:700px}table tbody td p[data-v-78745261]{font-size:12px}table tbody td i[data-v-78745261]{color:rgba(0,0,0,.34);cursor:pointer}table tbody td i[data-v-78745261]:hover{color:var(--btn-default)}table .table-name[data-v-78745261]{background-color:var(--btn-default);color:#fff}table .panel-body[data-v-78745261]{padding-right:-15px}@media screen and (max-width:415px){table .panel-title[data-v-78745261]{font-size:12px}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Campo/CampoTable.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,SAAW,CACZ,AACD,oDAEE,sBAA0B,AAC1B,gBAAiB,AACjB,SAAW,CACZ,AACD,gCACE,yBAA0B,AAC1B,YAAa,AACb,eAAiB,CAClB,AACD,mCACE,WAAa,AACb,mCAAqC,CACtC,AACD,0BACE,eAAiB,CAClB,AACD,oCACA,0BACM,cAAgB,CACrB,CACA,AACD,gCACE,gBAAiB,AACjB,gCAAqC,AACrC,eAAiB,CAClB,AACD,kCACI,cAAgB,CACnB,AACD,kCACI,sBAA2B,AAC3B,cAAgB,CACnB,AACD,wCACM,wBAA0B,CAC/B,AACD,mCACE,oCAAqC,AACrC,UAAa,CACd,AACD,mCACE,mBAAqB,CACtB,AACD,oCACA,oCACI,cAAgB,CACnB,CACA","file":"CampoTable.vue","sourcesContent":["\n.row[data-v-78745261] {\n  margin: 0;\n  padding: 0;\n}\ntable[data-v-78745261],\n.panel-body[data-v-78745261] {\n  background-color: #eeeeee;\n  overflow: scroll;\n  padding: 0;\n}\n.panel-default[data-v-78745261] {\n  background-color: #E0E0E0;\n  border: none;\n  border-radius: 0;\n}\ntable thead tr th[data-v-78745261] {\n  color: white;\n  background-color: var(--btn-default);\n}\ntable th[data-v-78745261] {\n  text-align: left;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-78745261] {\n      font-size: 12px;\n}\n}\ntable tbody td[data-v-78745261] {\n  text-align: left;\n  background-color: #eeeeee !important;\n  max-width: 700px;\n}\ntable tbody td p[data-v-78745261] {\n    font-size: 12px;\n}\ntable tbody td i[data-v-78745261] {\n    color: rgba(0, 0, 0, 0.34);\n    cursor: pointer;\n}\ntable tbody td i[data-v-78745261]:hover {\n      color: var(--btn-default);\n}\ntable .table-name[data-v-78745261] {\n  background-color: var(--btn-default);\n  color: white;\n}\ntable .panel-body[data-v-78745261] {\n  padding-right: -15px;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-78745261] {\n    font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#pdf[data-v-a8a8e030]{width:100%}#pdf .logo_leak[data-v-a8a8e030]{width:200px;text-align:left}#pdf .logo_pem[data-v-a8a8e030]{width:200px;float:right}#pdf #row[data-v-a8a8e030]{padding:25px}#pdf img[data-v-a8a8e030]{width:100%}#pdf hr[data-v-a8a8e030]{color:var(--btn-default)}#pdf #imgChart[data-v-a8a8e030]{width:100%;margin-top:100px}#pdf h4[data-v-a8a8e030]{text-align:center;text-transform:uppercase;color:#000}#pdf .pdf__info[data-v-a8a8e030]{margin:0 auto;display:block}#pdf .pdf__titles[data-v-a8a8e030]{color:var(--btn-default)}#pdf div#pdf[data-v-a8a8e030]{max-height:200px;height:200px}#pdf div#linechart[data-v-a8a8e030]{display:none}#pdf img#leak[data-v-a8a8e030],#pdf img#pem[data-v-a8a8e030]{display:inline-block;width:115px}#pdf img#pem[data-v-a8a8e030]{padding-left:400px}#pdf h4#h41[data-v-a8a8e030]{font-size:30px;font-weight:400;text-transform:uppercase;padding:0;margin-top:10px;margin-bottom:10px}#pdf hr#hr1[data-v-a8a8e030]{background-color:#fff;border-top:2px solid var(--btn-default)}#pdf span#titles[data-v-a8a8e030]{color:var(--btn-default);text-transform:uppercase;margin-left:4px}#pdf #tablecontainer[data-v-a8a8e030]{height:440px}#pdf table#tableholder[data-v-a8a8e030]{height:50%;width:100%;margin:0;text-align:center}#pdf thead#header[data-v-a8a8e030],#pdf tr#trh[data-v-a8a8e030]{width:100%;padding:2px;background-color:var(--btn-default)}#pdf th#thh[data-v-a8a8e030]{font-size:12pt;align:left;font-weight:400;padding:5px;border:1.5px solid var(--btn-default);color:#fff}#pdf td#tdc[data-v-a8a8e030]{font-size:10pt;text-align:left;padding:2px;border:1px solid #777}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Historico/PdfView.vue"],"names":[],"mappings":"AACA,sBACE,UAAY,CACb,AACD,iCACI,YAAa,AACb,eAAiB,CACpB,AACD,gCACI,YAAa,AACb,WAAa,CAChB,AACD,2BACI,YAAc,CACjB,AACD,0BACI,UAAY,CACf,AACD,yBACI,wBAA0B,CAC7B,AACD,gCACI,WAAY,AACZ,gBAAkB,CACrB,AACD,yBACI,kBAAmB,AACnB,yBAA0B,AAC1B,UAAY,CACf,AACD,iCACI,cAAe,AACf,aAAe,CAClB,AACD,mCACI,wBAA0B,CAC7B,AACD,8BACI,iBAAkB,AAClB,YAAc,CACjB,AACD,oCACI,YAAc,CACjB,AAKD,6DAHI,qBAAsB,AACtB,WAAa,CAMhB,AAJD,8BACI,kBAAoB,CAGvB,AACD,6BACI,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,UAAW,AACX,gBAAiB,AACjB,kBAAoB,CACvB,AACD,6BACI,sBAAuB,AACvB,uCAAyC,CAC5C,AACD,kCACI,yBAA0B,AAC1B,yBAA0B,AAC1B,eAAiB,CACpB,AACD,sCACI,YAAc,CACjB,AACD,wCACI,WAAY,AACZ,WAAY,AACZ,SAAU,AACV,iBAAmB,CACtB,AAMD,gEAJI,WAAY,AACZ,YAAa,AACb,mCAAqC,CAMxC,AACD,6BACI,eAAgB,AAChB,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,sCAAuC,AACvC,UAAa,CAChB,AACD,6BACI,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,qBAA0B,CAC7B","file":"PdfView.vue","sourcesContent":["\n#pdf[data-v-a8a8e030] {\n  width: 100%;\n}\n#pdf .logo_leak[data-v-a8a8e030] {\n    width: 200px;\n    text-align: left;\n}\n#pdf .logo_pem[data-v-a8a8e030] {\n    width: 200px;\n    float: right;\n}\n#pdf #row[data-v-a8a8e030] {\n    padding: 25px;\n}\n#pdf img[data-v-a8a8e030] {\n    width: 100%;\n}\n#pdf hr[data-v-a8a8e030] {\n    color: var(--btn-default);\n}\n#pdf #imgChart[data-v-a8a8e030] {\n    width: 100%;\n    margin-top: 100px;\n}\n#pdf h4[data-v-a8a8e030] {\n    text-align: center;\n    text-transform: uppercase;\n    color: #000;\n}\n#pdf .pdf__info[data-v-a8a8e030] {\n    margin: 0 auto;\n    display: block;\n}\n#pdf .pdf__titles[data-v-a8a8e030] {\n    color: var(--btn-default);\n}\n#pdf div#pdf[data-v-a8a8e030] {\n    max-height: 200px;\n    height: 200px;\n}\n#pdf div#linechart[data-v-a8a8e030] {\n    display: none;\n}\n#pdf img#leak[data-v-a8a8e030] {\n    display: inline-block;\n    width: 115px;\n}\n#pdf img#pem[data-v-a8a8e030] {\n    padding-left: 400px;\n    display: inline-block;\n    width: 115px;\n}\n#pdf h4#h41[data-v-a8a8e030] {\n    font-size: 30px;\n    font-weight: 400;\n    text-transform: uppercase;\n    padding: 0;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n#pdf hr#hr1[data-v-a8a8e030] {\n    background-color: #fff;\n    border-top: 2px solid var(--btn-default);\n}\n#pdf span#titles[data-v-a8a8e030] {\n    color: var(--btn-default);\n    text-transform: uppercase;\n    margin-left: 4px;\n}\n#pdf #tablecontainer[data-v-a8a8e030] {\n    height: 440px;\n}\n#pdf table#tableholder[data-v-a8a8e030] {\n    height: 50%;\n    width: 100%;\n    margin: 0;\n    text-align: center;\n}\n#pdf thead#header[data-v-a8a8e030] {\n    width: 100%;\n    padding: 2px;\n    background-color: var(--btn-default);\n}\n#pdf tr#trh[data-v-a8a8e030] {\n    width: 100%;\n    padding: 2px;\n    background-color: var(--btn-default);\n}\n#pdf th#thh[data-v-a8a8e030] {\n    font-size: 12pt;\n    align: left;\n    font-weight: 400;\n    padding: 5px;\n    border: 1.5px solid var(--btn-default);\n    color: white;\n}\n#pdf td#tdc[data-v-a8a8e030] {\n    font-size: 10pt;\n    text-align: left;\n    padding: 2px;\n    border: 1px solid #777777;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".bottom-offset[data-v-a9c628d2]{margin-bottom:20px}.hide-line-chart[data-v-a9c628d2]{display:none}.highlight[data-v-a9c628d2]{color:red}td i[data-v-a9c628d2]{color:rgba(0,0,0,.34);cursor:pointer}td i[data-v-a9c628d2]:hover{color:var(--btn-default)}td .center-option[data-v-a9c628d2]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}#pdf[data-v-a9c628d2]{width:100%}#pdf .logo_leak[data-v-a9c628d2]{width:150px;text-align:left}#pdf .logo_pem[data-v-a9c628d2]{width:150px;float:right}#pdf #row[data-v-a9c628d2]{padding:25px}#pdf img[data-v-a9c628d2]{width:100%}#pdf hr[data-v-a9c628d2]{color:var(--btn-default)}#pdf table[data-v-a9c628d2]{width:100%}#pdf .title__td[data-v-a9c628d2]{background-color:var(--btn-default);border:0 solid #e0e0e0;color:#fff}#pdf th[data-v-a9c628d2]{padding:10px}#pdf td[data-v-a9c628d2]{padding:5px;border:1px solid #e0e0e0}#pdf #imgChart[data-v-a9c628d2]{width:100%;margin-top:100px}#pdf h4[data-v-a9c628d2]{text-align:left;text-transform:uppercase;color:#666}#pdf .pdf__info[data-v-a9c628d2]{margin:0 auto;display:block}#pdf p[data-v-a9c628d2]{color:#666}#pdf .pdf__titles[data-v-a9c628d2]{color:var(--btn-default)}#pdf .yellow__hr[data-v-a9c628d2]{background-color:var(--btn-default);height:2px}#pagebreak[data-v-a9c628d2]{display:block;page-break-after:always}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Reportes/PdfPressureDiv.vue"],"names":[],"mappings":"AACA,gCACE,kBAAoB,CACrB,AACD,kCACE,YAAc,CACf,AACD,4BACE,SAAW,CACZ,AACD,sBACE,sBAA2B,AAC3B,cAAgB,CACjB,AACD,4BACI,wBAA0B,CAC7B,AACD,mCACE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,sBACE,UAAY,CACb,AACD,iCACI,YAAa,AACb,eAAiB,CACpB,AACD,gCACI,YAAa,AACb,WAAa,CAChB,AACD,2BACI,YAAc,CACjB,AACD,0BACI,UAAY,CACf,AACD,yBACI,wBAA0B,CAC7B,AACD,4BACI,UAAY,CACf,AACD,iCACI,oCAAqC,AACrC,uBAA0B,AAC1B,UAAa,CAChB,AACD,yBACI,YAAc,CACjB,AACD,yBACI,YAAa,AACb,wBAA0B,CAC7B,AACD,gCACI,WAAY,AACZ,gBAAkB,CACrB,AACD,yBACI,gBAAiB,AACjB,yBAA0B,AAC1B,UAAY,CACf,AACD,iCACI,cAAe,AACf,aAAe,CAClB,AACD,wBACI,UAAY,CACf,AACD,mCACI,wBAA0B,CAC7B,AACD,kCACI,oCAAqC,AACrC,UAAY,CACf,AACD,4BACE,cAAe,AACf,uBAAyB,CAC1B","file":"PdfPressureDiv.vue","sourcesContent":["\n.bottom-offset[data-v-a9c628d2] {\n  margin-bottom: 20px;\n}\n.hide-line-chart[data-v-a9c628d2] {\n  display: none;\n}\n.highlight[data-v-a9c628d2] {\n  color: red;\n}\ntd i[data-v-a9c628d2] {\n  color: rgba(0, 0, 0, 0.34);\n  cursor: pointer;\n}\ntd i[data-v-a9c628d2]:hover {\n    color: var(--btn-default);\n}\ntd .center-option[data-v-a9c628d2] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n#pdf[data-v-a9c628d2] {\n  width: 100%;\n}\n#pdf .logo_leak[data-v-a9c628d2] {\n    width: 150px;\n    text-align: left;\n}\n#pdf .logo_pem[data-v-a9c628d2] {\n    width: 150px;\n    float: right;\n}\n#pdf #row[data-v-a9c628d2] {\n    padding: 25px;\n}\n#pdf img[data-v-a9c628d2] {\n    width: 100%;\n}\n#pdf hr[data-v-a9c628d2] {\n    color: var(--btn-default);\n}\n#pdf table[data-v-a9c628d2] {\n    width: 100%;\n}\n#pdf .title__td[data-v-a9c628d2] {\n    background-color: var(--btn-default);\n    border: 0px solid #E0E0E0;\n    color: white;\n}\n#pdf th[data-v-a9c628d2] {\n    padding: 10px;\n}\n#pdf td[data-v-a9c628d2] {\n    padding: 5px;\n    border: 1px solid #E0E0E0;\n}\n#pdf #imgChart[data-v-a9c628d2] {\n    width: 100%;\n    margin-top: 100px;\n}\n#pdf h4[data-v-a9c628d2] {\n    text-align: left;\n    text-transform: uppercase;\n    color: #666;\n}\n#pdf .pdf__info[data-v-a9c628d2] {\n    margin: 0 auto;\n    display: block;\n}\n#pdf p[data-v-a9c628d2] {\n    color: #666;\n}\n#pdf .pdf__titles[data-v-a9c628d2] {\n    color: var(--btn-default);\n}\n#pdf .yellow__hr[data-v-a9c628d2] {\n    background-color: var(--btn-default);\n    height: 2px;\n}\n#pagebreak[data-v-a9c628d2] {\n  display: block;\n  page-break-after: always;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".row[data-v-aac9873c]{margin:0;padding:0}.col-md-6[data-v-aac9873c],.col-xs-12[data-v-aac9873c]{padding:0!important}.container-fluid[data-v-aac9873c]{background-color:#fff;width:100%;padding:0;margin:0}.panel-body[data-v-aac9873c],table[data-v-aac9873c]{overflow-y:scroll;overflow-x:hidden;max-height:65vh;height:100%;padding:0;margin:0}.panel-body tr[data-v-aac9873c],table tr[data-v-aac9873c]{margin:0!important;padding:0!important}.panel-body .info td[data-v-aac9873c],table .info td[data-v-aac9873c]{background-color:#eee}.panel-body th[data-v-aac9873c],table th[data-v-aac9873c]{text-align:left;padding-left:25px}@media screen and (max-width:415px){.panel-body th[data-v-aac9873c],table th[data-v-aac9873c]{font-size:12px}}.panel-body td[data-v-aac9873c],table td[data-v-aac9873c]{vertical-align:inherit}.panel-body td i[data-v-aac9873c],table td i[data-v-aac9873c]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body td i[data-v-aac9873c]:hover,table td i[data-v-aac9873c]:hover{color:var(--btn-default)}.panel-body td .view-report[data-v-aac9873c],table td .view-report[data-v-aac9873c]{padding-left:10px}.panel-body .nombre-alarma[data-v-aac9873c],table .nombre-alarma[data-v-aac9873c]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-aac9873c],table .panel-body[data-v-aac9873c]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-aac9873c],table .panel-title[data-v-aac9873c]{font-size:12px}}.panel-body-two[data-v-aac9873c]{overflow:scroll;overflow-x:hidden;max-height:65vh;height:99%;padding:3px 0;margin:0}.panel-body-two .info td[data-v-aac9873c]{background-color:#eee}.panel-body-two th[data-v-aac9873c]{text-align:left;padding-left:25px}@media screen and (max-width:415px){.panel-body-two th[data-v-aac9873c]{font-size:12px}}.panel-body-two td[data-v-aac9873c]{text-align:left;padding-left:25px}.panel-body-two td i[data-v-aac9873c]{color:rgba(0,0,0,.34);cursor:pointer}.panel-body-two td i[data-v-aac9873c]:hover{color:var(--btn-default)}.panel-body-two .nombre-alarma[data-v-aac9873c]{background-color:var(--btn-default);color:#fff}.panel-body-two .panel-body[data-v-aac9873c]{padding:0}@media screen and (max-width:415px){.panel-body-two .panel-title[data-v-aac9873c]{font-size:12px}}.btn-default[data-v-aac9873c]{background:var(--btn-default-hover)}.btn-default[data-v-aac9873c]:active,.btn-default[data-v-aac9873c]:focus,.btn-default[data-v-aac9873c]:hover{background:var(--btn-default)!important}#pagebreak[data-v-aac9873c]{display:block;page-break-after:always}#reportes-page[data-v-aac9873c]{padding-top:70px;background-color:#eee;height:100vh}#reportes-page #formulario-top[data-v-aac9873c]{height:20vh;padding-top:5vh}@media screen and (max-width:767px){#reportes-page #formulario-top[data-v-aac9873c]{height:45vh}}.color-2 .irs-bar-edge[data-v-aac9873c],.color-2 .irs-bar[data-v-aac9873c]{background:red}.error[data-v-aac9873c]{border:2px solid red!important}.print_btn[data-v-aac9873c]{width:100%;background-color:var(--btn-default);padding:8px;font-weight:500;color:#fff}.print_btn[data-v-aac9873c]:hover{background-color:var(--btn-default-bg)}.print_btn[data-v-aac9873c]:active{background-color:gray;color:#fff}#loading-modal-modal[data-v-aac9873c]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Reportes/Pressure.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,SAAW,CACZ,AACD,uDAEE,mBAAwB,CACzB,AACD,kCACE,sBAAwB,AACxB,WAAY,AACZ,UAAW,AACX,QAAU,CACX,AACD,oDAEE,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,UAAa,AACb,QAAY,CACb,AACD,0DAEI,mBAAuB,AACvB,mBAAwB,CAC3B,AACD,sEAEI,qBAA0B,CAC7B,AACD,0DAEI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,0DAEI,sBAAwB,CAC3B,AACD,8DAEM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,0EAEQ,wBAA0B,CACjC,AACD,oFAEM,iBAAmB,CACxB,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAa,CAChB,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA,AACD,iCACE,gBAAiB,AACjB,kBAAmB,AACnB,gBAAiB,AACjB,WAAY,AACZ,cAAe,AACf,QAAU,CACX,AACD,0CACI,qBAA0B,CAC7B,AACD,oCACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,oCACQ,cAAgB,CACvB,CACA,AACD,oCACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,sCACM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,4CACQ,wBAA0B,CACjC,AACD,gDACI,oCAAqC,AACrC,UAAa,CAChB,AACD,6CACI,SAAW,CACd,AACD,oCACA,8CACM,cAAgB,CACrB,CACA,AACD,8BACE,mCAAqC,CACtC,AACD,6GACI,uCAA0C,CAC7C,AACD,4BACE,cAAe,AACf,uBAAyB,CAC1B,AACD,gCACE,iBAAkB,AAClB,sBAA0B,AAC1B,YAAc,CACf,AACD,gDACI,YAAa,AACb,eAAiB,CACpB,AACD,oCACA,gDACQ,WAAa,CACpB,CACA,AACD,2EAEE,cAAgB,CACjB,AACD,wBACE,8BAAiC,CAClC,AACD,4BACE,WAAY,AACZ,oCAAqC,AACrC,YAAa,AACb,gBAAiB,AACjB,UAAa,CACd,AACD,kCACE,sCAAwC,CACzC,AACD,mCACE,sBAAuB,AACvB,UAAa,CACd,AACD,sCACE,0DAA6D,CAC9D","file":"Pressure.vue","sourcesContent":["\n.row[data-v-aac9873c] {\n  margin: 0;\n  padding: 0;\n}\n.col-md-6[data-v-aac9873c],\n.col-xs-12[data-v-aac9873c] {\n  padding: 0px !important;\n}\n.container-fluid[data-v-aac9873c] {\n  background-color: white;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\ntable[data-v-aac9873c],\n.panel-body[data-v-aac9873c] {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  max-height: 65vh;\n  height: 100%;\n  padding: 0px;\n  margin: 0px;\n}\ntable tr[data-v-aac9873c],\n  .panel-body tr[data-v-aac9873c] {\n    margin: 0px !important;\n    padding: 0px !important;\n}\ntable .info td[data-v-aac9873c],\n  .panel-body .info td[data-v-aac9873c] {\n    background-color: #eeeeee;\n}\ntable th[data-v-aac9873c],\n  .panel-body th[data-v-aac9873c] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-aac9873c],\n      .panel-body th[data-v-aac9873c] {\n        font-size: 12px;\n}\n}\ntable td[data-v-aac9873c],\n  .panel-body td[data-v-aac9873c] {\n    vertical-align: inherit;\n}\ntable td i[data-v-aac9873c],\n    .panel-body td i[data-v-aac9873c] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\ntable td i[data-v-aac9873c]:hover,\n      .panel-body td i[data-v-aac9873c]:hover {\n        color: var(--btn-default);\n}\ntable td .view-report[data-v-aac9873c],\n    .panel-body td .view-report[data-v-aac9873c] {\n      padding-left: 10px;\n}\ntable .nombre-alarma[data-v-aac9873c],\n  .panel-body .nombre-alarma[data-v-aac9873c] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-aac9873c],\n  .panel-body .panel-body[data-v-aac9873c] {\n    padding: 0px;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-aac9873c],\n    .panel-body .panel-title[data-v-aac9873c] {\n      font-size: 12px;\n}\n}\n.panel-body-two[data-v-aac9873c] {\n  overflow: scroll;\n  overflow-x: hidden;\n  max-height: 65vh;\n  height: 99%;\n  padding: 3px 0;\n  margin: 0;\n}\n.panel-body-two .info td[data-v-aac9873c] {\n    background-color: #eeeeee;\n}\n.panel-body-two th[data-v-aac9873c] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\n.panel-body-two th[data-v-aac9873c] {\n        font-size: 12px;\n}\n}\n.panel-body-two td[data-v-aac9873c] {\n    text-align: left;\n    padding-left: 25px;\n}\n.panel-body-two td i[data-v-aac9873c] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\n.panel-body-two td i[data-v-aac9873c]:hover {\n        color: var(--btn-default);\n}\n.panel-body-two .nombre-alarma[data-v-aac9873c] {\n    background-color: var(--btn-default);\n    color: white;\n}\n.panel-body-two .panel-body[data-v-aac9873c] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\n.panel-body-two .panel-title[data-v-aac9873c] {\n      font-size: 12px;\n}\n}\n.btn-default[data-v-aac9873c] {\n  background: var(--btn-default-hover);\n}\n.btn-default[data-v-aac9873c]:hover, .btn-default[data-v-aac9873c]:focus, .btn-default[data-v-aac9873c]:active {\n    background: var(--btn-default) !important;\n}\n#pagebreak[data-v-aac9873c] {\n  display: block;\n  page-break-after: always;\n}\n#reportes-page[data-v-aac9873c] {\n  padding-top: 70px;\n  background-color: #eeeeee;\n  height: 100vh;\n}\n#reportes-page #formulario-top[data-v-aac9873c] {\n    height: 20vh;\n    padding-top: 5vh;\n}\n@media screen and (max-width: 767px) {\n#reportes-page #formulario-top[data-v-aac9873c] {\n        height: 45vh;\n}\n}\n.color-2 .irs-bar[data-v-aac9873c],\n.color-2 .irs-bar-edge[data-v-aac9873c] {\n  background: red;\n}\n.error[data-v-aac9873c] {\n  border: 2px solid red !important;\n}\n.print_btn[data-v-aac9873c] {\n  width: 100%;\n  background-color: var(--btn-default);\n  padding: 8px;\n  font-weight: 500;\n  color: white;\n}\n.print_btn[data-v-aac9873c]:hover {\n  background-color: var(--btn-default-bg);\n}\n.print_btn[data-v-aac9873c]:active {\n  background-color: gray;\n  color: white;\n}\n#loading-modal-modal[data-v-aac9873c] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".centered-container[data-v-afb55d82]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;position:relative;height:100vh}.centered-container .title[data-v-afb55d82]{text-align:center;margin-bottom:30px}.centered-container .title img[data-v-afb55d82]{width:100%}.centered-container .instructions[data-v-afb55d82]{text-align:center;font-size:16px;margin:20px 0;padding:10px;background-color:#f9f9f9;border-radius:5px;box-shadow:0 2px 4px rgba(0,0,0,.1)}.centered-container .actions .md-button[data-v-afb55d82]{margin:0}.centered-container .form[data-v-afb55d82]{margin-bottom:60px}.centered-container .recovery-done[data-v-afb55d82]{text-align:center;margin-bottom:20px;margin-top:40px}.centered-container .background[data-v-afb55d82]{position:absolute;height:100%;width:100%;top:0;bottom:0;right:0;left:0;z-index:0;background-color:var(--loading-background-color);background-repeat:no-repeat;background-attachment:fixed;background-position:50%}.centered-container .md-content[data-v-afb55d82]{z-index:1;padding:40px;width:100%;max-width:400px;position:relative;border-radius:15px}#loading-modal-modal[data-v-afb55d82]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/PasswordRecovery/PasswordRecovery.vue"],"names":[],"mappings":"AACA,qCACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,qBAAsB,AAClB,uBAAwB,AAC5B,kBAAmB,AACnB,YAAc,CACf,AACD,4CACI,kBAAmB,AACnB,kBAAoB,CACvB,AACD,gDACM,UAAY,CACjB,AACD,mDACI,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,aAAc,AACd,yBAA0B,AAC1B,kBAAmB,AACnB,mCAAyC,CAC5C,AACD,yDACI,QAAU,CACb,AACD,2CACI,kBAAoB,CACvB,AACD,oDACI,kBAAmB,AACnB,mBAAoB,AACpB,eAAiB,CACpB,AACD,iDACI,kBAAmB,AACnB,YAAa,AACb,WAAY,AACZ,MAAO,AACP,SAAU,AACV,QAAS,AACT,OAAQ,AACR,UAAW,AACX,iDAAkD,AAClD,4BAA6B,AAC7B,4BAA6B,AAC7B,uBAA4B,CAC/B,AACD,iDACI,UAAW,AACX,aAAc,AACd,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACvB,AACD,sCACE,0DAA6D,CAC9D","file":"PasswordRecovery.vue","sourcesContent":["\n.centered-container[data-v-afb55d82] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  position: relative;\n  height: 100vh;\n}\n.centered-container .title[data-v-afb55d82] {\n    text-align: center;\n    margin-bottom: 30px;\n}\n.centered-container .title img[data-v-afb55d82] {\n      width: 100%;\n}\n.centered-container .instructions[data-v-afb55d82] {\n    text-align: center;\n    font-size: 16px;\n    margin: 20px 0;\n    padding: 10px;\n    background-color: #f9f9f9;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.centered-container .actions .md-button[data-v-afb55d82] {\n    margin: 0;\n}\n.centered-container .form[data-v-afb55d82] {\n    margin-bottom: 60px;\n}\n.centered-container .recovery-done[data-v-afb55d82] {\n    text-align: center;\n    margin-bottom: 20px;\n    margin-top: 40px;\n}\n.centered-container .background[data-v-afb55d82] {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 0;\n    background-color: var(--loading-background-color);\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-position: center;\n}\n.centered-container .md-content[data-v-afb55d82] {\n    z-index: 1;\n    padding: 40px;\n    width: 100%;\n    max-width: 400px;\n    position: relative;\n    border-radius: 15px;\n}\n#loading-modal-modal[data-v-afb55d82] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".datepicker-overlay[data-v-b521c2fa]{position:fixed;width:100%;height:100%;z-index:998;top:0;left:0;overflow:hidden;animation:fadein-data-v-b521c2fa .5s}@keyframes fadein-data-v-b521c2fa{0%{opacity:0}to{opacity:1}}.cov-date-body[data-v-b521c2fa]{display:inline-block;background:#3f51b5;overflow:hidden;position:relative;font-size:16px;font-family:Roboto;font-weight:400;position:fixed;display:block;width:400px;max-width:100%;z-index:999;top:50%;left:50%;transform:translate(-50%,-50%);box-shadow:0 1px 3px 0 rgba(0,0,0,.2)}.cov-picker-box[data-v-b521c2fa]{background:#fff;width:100%;display:inline-block;padding:25px;box-sizing:border-box!important;-moz-box-sizing:border-box!important;-webkit-box-sizing:border-box!important;-ms-box-sizing:border-box!important;width:400px;max-width:100%;height:280px;text-align:start!important}.cov-picker-box td[data-v-b521c2fa]{height:34px;width:34px;padding:0;line-height:34px;color:#000;background:#fff;text-align:center;cursor:pointer}.cov-picker-box td[data-v-b521c2fa]:hover{background:#e6e6e6}table[data-v-b521c2fa]{border-collapse:collapse;border-spacing:0;width:100%}.day[data-v-b521c2fa]{width:14.2857143%;display:inline-block;text-align:center;cursor:pointer;height:34px;padding:0;line-height:34px;color:#000;background:#fff;vertical-align:middle}.week ul[data-v-b521c2fa]{margin:0 0 8px;padding:0;list-style:none}.week ul li[data-v-b521c2fa]{width:14.2%;display:inline-block;text-align:center;background:transparent;color:#000;font-weight:700}.passive-day[data-v-b521c2fa]{color:#bbb}.checked[data-v-b521c2fa]{background:#f50057;color:#fff!important;border-radius:3px}.unavailable[data-v-b521c2fa]{color:#ccc;cursor:not-allowed}.cov-date-monthly[data-v-b521c2fa]{height:150px}.cov-date-monthly>div[data-v-b521c2fa]{display:inline-block;padding:0;margin:0;vertical-align:middle;color:#fff;height:150px;float:left;text-align:center;cursor:pointer}.cov-date-next[data-v-b521c2fa],.cov-date-previous[data-v-b521c2fa]{position:relative;width:20%!important;text-indent:-300px;overflow:hidden;color:#fff}.cov-date-caption[data-v-b521c2fa]{width:60%;padding:50px 0!important;box-sizing:border-box;font-size:24px}.cov-date-caption span[data-v-b521c2fa]:hover{color:hsla(0,0%,100%,.7)}.cov-date-next[data-v-b521c2fa]:hover,.cov-date-previous[data-v-b521c2fa]:hover{background:hsla(0,0%,100%,.1)}.day[data-v-b521c2fa]:hover{background:#eaeaea}.unavailable[data-v-b521c2fa]:hover{background:none}.checked[data-v-b521c2fa]:hover{background:#ff4f8e}.cov-date-next[data-v-b521c2fa]:before,.cov-date-previous[data-v-b521c2fa]:before{width:20px;height:2px;text-align:center;position:absolute;background:#fff;top:50%;margin-top:-7px;margin-left:-7px;left:50%;line-height:0;content:\"\";transform:rotate(45deg)}.cov-date-next[data-v-b521c2fa]:after,.cov-date-previous[data-v-b521c2fa]:after{width:20px;height:2px;text-align:center;position:absolute;background:#fff;margin-top:6px;margin-left:-7px;top:50%;left:50%;line-height:0;content:\"\";transform:rotate(-45deg)}.cov-date-previous[data-v-b521c2fa]:after{transform:rotate(45deg)}.cov-date-previous[data-v-b521c2fa]:before{transform:rotate(-45deg)}.date-item[data-v-b521c2fa]{text-align:center;font-size:20px;padding:10px 0;cursor:pointer}.date-item[data-v-b521c2fa]:hover{background:#e0e0e0}.date-list[data-v-b521c2fa]{overflow:auto;vertical-align:top;padding:0}.cov-vue-date[data-v-b521c2fa]{display:inline-block;color:#5d5d5d}.button-box[data-v-b521c2fa]{background:#fff;vertical-align:top;height:50px;line-height:50px;text-align:right;padding-right:20px}.button-box span[data-v-b521c2fa]{cursor:pointer;padding:10px 20px}.watch-box[data-v-b521c2fa]{height:100%;overflow:hidden}.hour-box[data-v-b521c2fa],.min-box[data-v-b521c2fa]{display:inline-block;width:50%;text-align:center;height:100%;overflow:auto;float:left}.hour-box ul[data-v-b521c2fa],.min-box ul[data-v-b521c2fa]{list-style:none;margin:0;padding:0}.hour-item[data-v-b521c2fa],.min-item[data-v-b521c2fa]{padding:10px;font-size:36px;cursor:pointer}.hour-item[data-v-b521c2fa]:hover,.min-item[data-v-b521c2fa]:hover{background:#e3e3e3}.hour-box .active[data-v-b521c2fa],.min-box .active[data-v-b521c2fa]{background:#f50057;color:#fff!important}[data-v-b521c2fa]::-webkit-scrollbar{width:2px}[data-v-b521c2fa]::-webkit-scrollbar-track{background:#e3e3e3}[data-v-b521c2fa]::-webkit-scrollbar-thumb{background:#c1c1c1;border-radius:2px}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/node_modules/vue-datepicker/vue-datepicker-es6.vue"],"names":[],"mappings":"AACA,qCACE,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,YAAa,AACb,MAAO,AACP,OAAQ,AACR,gBAAiB,AAKjB,oCAAuC,CACxC,AACD,kCACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA,AAKD,gCACE,qBAAsB,AACtB,mBAAoB,AACpB,gBAAiB,AACjB,kBAAmB,AACnB,eAAgB,AAChB,mBAAsB,AACtB,gBAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,YAAa,AACb,eAAgB,AAChB,YAAa,AACb,QAAS,AACT,SAAU,AACV,+BAAiC,AACjC,qCAA2C,CAC5C,AACD,iCACE,gBAAiB,AACjB,WAAY,AACZ,qBAAsB,AACtB,aAAc,AACd,gCAAkC,AAClC,qCAAuC,AACvC,wCAA0C,AAC1C,oCAAsC,AACtC,YAAa,AACb,eAAgB,AAChB,aAAc,AACd,0BAA4B,CAC7B,AACD,oCACE,YAAa,AACb,WAAY,AACZ,UAAW,AACX,iBAAkB,AAClB,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,cAAgB,CACjB,AACD,0CACE,kBAAoB,CACrB,AACD,uBACE,yBAA0B,AAC1B,iBAAkB,AAClB,UAAY,CACb,AACD,sBACE,kBAAmB,AACnB,qBAAsB,AACtB,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,WAAY,AACZ,gBAAiB,AACjB,qBAAuB,CACxB,AACD,0BACE,eAAgB,AAChB,UAAW,AACX,eAAiB,CAClB,AACD,6BACE,YAAa,AACb,qBAAsB,AACtB,kBAAmB,AACnB,uBAAwB,AACxB,WAAY,AACZ,eAAkB,CACnB,AACD,8BACE,UAAY,CACb,AACD,0BACE,mBAAoB,AACpB,qBAAuB,AACvB,iBAAmB,CACpB,AACD,8BACE,WAAY,AACZ,kBAAoB,CACrB,AACD,mCACE,YAAc,CACf,AACD,uCACE,qBAAsB,AACtB,UAAW,AACX,SAAU,AACV,sBAAuB,AACvB,WAAY,AACZ,aAAc,AACd,WAAY,AACZ,kBAAmB,AACnB,cAAgB,CACjB,AACD,oEAEE,kBAAmB,AACnB,oBAAsB,AACtB,mBAAoB,AACpB,gBAAiB,AACjB,UAAY,CACb,AACD,mCACE,UAAW,AACX,yBAA0B,AAC1B,sBAAuB,AACvB,cAAgB,CACjB,AACD,8CACE,wBAAgC,CACjC,AACD,gFAEE,6BAAqC,CACtC,AACD,4BACE,kBAAoB,CACrB,AACD,oCACE,eAAiB,CAClB,AACD,gCACE,kBAAoB,CACrB,AACD,kFAEE,WAAY,AACZ,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,QAAS,AACT,gBAAiB,AACjB,iBAAkB,AAClB,SAAU,AACV,cAAe,AACf,WAAY,AACZ,uBAAyB,CAC1B,AACD,gFAEE,WAAY,AACZ,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAClB,QAAS,AACT,SAAU,AACV,cAAe,AACf,WAAY,AACZ,wBAA0B,CAC3B,AACD,0CACE,uBAAyB,CAC1B,AACD,2CACE,wBAA0B,CAC3B,AACD,4BACE,kBAAmB,AACnB,eAAgB,AAChB,eAAgB,AAChB,cAAgB,CACjB,AACD,kCACE,kBAAoB,CACrB,AACD,4BACE,cAAe,AACf,mBAAoB,AACpB,SAAW,CACZ,AACD,+BACE,qBAAsB,AACtB,aAAe,CAChB,AACD,6BACE,gBAAiB,AACjB,mBAAoB,AACpB,YAAa,AACb,iBAAkB,AAClB,iBAAkB,AAClB,kBAAoB,CACrB,AACD,kCACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,4BACE,YAAa,AACb,eAAiB,CAClB,AACD,qDAEE,qBAAsB,AACtB,UAAW,AACX,kBAAmB,AACnB,YAAa,AACb,cAAe,AACf,UAAY,CACb,AACD,2DAEE,gBAAiB,AACjB,SAAU,AACV,SAAW,CACZ,AACD,uDAEE,aAAc,AACd,eAAgB,AAChB,cAAgB,CACjB,AACD,mEAEE,kBAAoB,CACrB,AACD,qEAEE,mBAAoB,AACpB,oBAAuB,CACxB,AACD,qCACE,SAAW,CACZ,AACD,2CACE,kBAAoB,CACrB,AACD,2CACE,mBAAoB,AACpB,iBAAmB,CACpB","file":"vue-datepicker-es6.vue","sourcesContent":["\n.datepicker-overlay[data-v-b521c2fa] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 998;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  /* Safari, Chrome and Opera > 12.1 */\n  /* Firefox < 16 */\n  /* Internet Explorer */\n  /* Opera < 12.1 */\n  animation: fadein-data-v-b521c2fa 0.5s;\n}\n@keyframes fadein-data-v-b521c2fa {\nfrom {\n    opacity: 0;\n}\nto {\n    opacity: 1;\n}\n}\n/* Firefox < 16 */\n/* Safari, Chrome and Opera > 12.1 */\n/* Internet Explorer */\n/* Opera < 12.1 */\n.cov-date-body[data-v-b521c2fa] {\n  display: inline-block;\n  background: #3F51B5;\n  overflow: hidden;\n  position: relative;\n  font-size: 16px;\n  font-family: 'Roboto';\n  font-weight: 400;\n  position: fixed;\n  display: block;\n  width: 400px;\n  max-width: 100%;\n  z-index: 999;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n}\n.cov-picker-box[data-v-b521c2fa] {\n  background: #fff;\n  width: 100%;\n  display: inline-block;\n  padding: 25px;\n  box-sizing: border-box !important;\n  -moz-box-sizing: border-box !important;\n  -webkit-box-sizing: border-box !important;\n  -ms-box-sizing: border-box !important;\n  width: 400px;\n  max-width: 100%;\n  height: 280px;\n  text-align: start!important;\n}\n.cov-picker-box td[data-v-b521c2fa] {\n  height: 34px;\n  width: 34px;\n  padding: 0;\n  line-height: 34px;\n  color: #000;\n  background: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n.cov-picker-box td[data-v-b521c2fa]:hover {\n  background: #E6E6E6;\n}\ntable[data-v-b521c2fa] {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n.day[data-v-b521c2fa] {\n  width: 14.2857143%;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  height: 34px;\n  padding: 0;\n  line-height: 34px;\n  color: #000;\n  background: #fff;\n  vertical-align: middle;\n}\n.week ul[data-v-b521c2fa] {\n  margin: 0 0 8px;\n  padding: 0;\n  list-style: none;\n}\n.week ul li[data-v-b521c2fa] {\n  width: 14.2%;\n  display: inline-block;\n  text-align: center;\n  background: transparent;\n  color: #000;\n  font-weight: bold;\n}\n.passive-day[data-v-b521c2fa] {\n  color: #bbb;\n}\n.checked[data-v-b521c2fa] {\n  background: #F50057;\n  color: #FFF !important;\n  border-radius: 3px;\n}\n.unavailable[data-v-b521c2fa] {\n  color: #ccc;\n  cursor: not-allowed;\n}\n.cov-date-monthly[data-v-b521c2fa] {\n  height: 150px;\n}\n.cov-date-monthly > div[data-v-b521c2fa] {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  vertical-align: middle;\n  color: #fff;\n  height: 150px;\n  float: left;\n  text-align: center;\n  cursor: pointer;\n}\n.cov-date-previous[data-v-b521c2fa],\n.cov-date-next[data-v-b521c2fa] {\n  position: relative;\n  width: 20% !important;\n  text-indent: -300px;\n  overflow: hidden;\n  color: #fff;\n}\n.cov-date-caption[data-v-b521c2fa] {\n  width: 60%;\n  padding: 50px 0!important;\n  box-sizing: border-box;\n  font-size: 24px;\n}\n.cov-date-caption span[data-v-b521c2fa]:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n.cov-date-previous[data-v-b521c2fa]:hover,\n.cov-date-next[data-v-b521c2fa]:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n.day[data-v-b521c2fa]:hover {\n  background: #EAEAEA;\n}\n.unavailable[data-v-b521c2fa]:hover {\n  background: none;\n}\n.checked[data-v-b521c2fa]:hover {\n  background: #FF4F8E;\n}\n.cov-date-next[data-v-b521c2fa]::before,\n.cov-date-previous[data-v-b521c2fa]::before {\n  width: 20px;\n  height: 2px;\n  text-align: center;\n  position: absolute;\n  background: #fff;\n  top: 50%;\n  margin-top: -7px;\n  margin-left: -7px;\n  left: 50%;\n  line-height: 0;\n  content: '';\n  transform: rotate(45deg);\n}\n.cov-date-next[data-v-b521c2fa]::after,\n.cov-date-previous[data-v-b521c2fa]::after {\n  width: 20px;\n  height: 2px;\n  text-align: center;\n  position: absolute;\n  background: #fff;\n  margin-top: 6px;\n  margin-left: -7px;\n  top: 50%;\n  left: 50%;\n  line-height: 0;\n  content: '';\n  transform: rotate(-45deg);\n}\n.cov-date-previous[data-v-b521c2fa]::after {\n  transform: rotate(45deg);\n}\n.cov-date-previous[data-v-b521c2fa]::before {\n  transform: rotate(-45deg);\n}\n.date-item[data-v-b521c2fa] {\n  text-align: center;\n  font-size: 20px;\n  padding: 10px 0;\n  cursor: pointer;\n}\n.date-item[data-v-b521c2fa]:hover {\n  background: #e0e0e0;\n}\n.date-list[data-v-b521c2fa] {\n  overflow: auto;\n  vertical-align: top;\n  padding: 0;\n}\n.cov-vue-date[data-v-b521c2fa] {\n  display: inline-block;\n  color: #5D5D5D;\n}\n.button-box[data-v-b521c2fa] {\n  background: #fff;\n  vertical-align: top;\n  height: 50px;\n  line-height: 50px;\n  text-align: right;\n  padding-right: 20px;\n}\n.button-box span[data-v-b521c2fa] {\n  cursor: pointer;\n  padding: 10px 20px;\n}\n.watch-box[data-v-b521c2fa] {\n  height: 100%;\n  overflow: hidden;\n}\n.hour-box[data-v-b521c2fa],\n.min-box[data-v-b521c2fa] {\n  display: inline-block;\n  width: 50%;\n  text-align: center;\n  height: 100%;\n  overflow: auto;\n  float: left;\n}\n.hour-box ul[data-v-b521c2fa],\n.min-box ul[data-v-b521c2fa] {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.hour-item[data-v-b521c2fa],\n.min-item[data-v-b521c2fa] {\n  padding: 10px;\n  font-size: 36px;\n  cursor: pointer;\n}\n.hour-item[data-v-b521c2fa]:hover,\n.min-item[data-v-b521c2fa]:hover {\n  background: #E3E3E3;\n}\n.hour-box .active[data-v-b521c2fa],\n.min-box .active[data-v-b521c2fa] {\n  background: #F50057;\n  color: #FFF !important;\n}\n[data-v-b521c2fa]::-webkit-scrollbar {\n  width: 2px;\n}\n[data-v-b521c2fa]::-webkit-scrollbar-track {\n  background: #E3E3E3;\n}\n[data-v-b521c2fa]::-webkit-scrollbar-thumb {\n  background: #C1C1C1;\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".custom-select[data-v-c0391d90]{padding:4px 16px}.md-drawer[data-v-c0391d90]{width:320px;max-width:calc(100vw - 125px);z-index:10}.toolbar-title[data-v-c0391d90]{min-height:44px}.md-datepicker[data-v-c0391d90],.md-list[data-v-c0391d90],.md-radio[data-v-c0391d90]{margin:0}.switch[data-v-c0391d90]{position:relative;display:inline-block;width:30px;height:17px}.switch input[data-v-c0391d90]{opacity:0;width:0;height:0}.slider[data-v-c0391d90]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider[data-v-c0391d90]:before{position:absolute;content:\"\";height:13px;width:13px;left:2px;bottom:2px;background-color:#fff;transition:.4s}input:checked+.slider[data-v-c0391d90]{background-color:var(--radio-button-checked)}input:focus+.slider[data-v-c0391d90]{box-shadow:0 0 1px var(--radio-button-checked)}input:checked+.slider[data-v-c0391d90]:before{transform:translateX(13px)}.slider.round[data-v-c0391d90]{border-radius:17px}.slider.round[data-v-c0391d90]:before{border-radius:50%}.slider-text[data-v-c0391d90]{margin:0 8px;font-size:12px;position:absolute;cursor:pointer}.pe-radio[data-v-c0391d90]{display:block;position:relative;padding-left:17.5px;margin-bottom:6px;cursor:pointer;font-size:22px;-webkit-user-select:none;-ms-user-select:none;user-select:none}.pe-radio-text[data-v-c0391d90]{font-size:14px;margin:0 8px;display:block}.pe-radio input[data-v-c0391d90]{position:absolute;opacity:0;cursor:pointer}.checkmark[data-v-c0391d90]{position:absolute;top:0;left:0;height:16px;width:16px;background-color:#eee;border-radius:50%}.pe-radio:hover input~.checkmark[data-v-c0391d90]{background-color:#ccc}.pe-radio input:checked~.checkmark[data-v-c0391d90]{background-color:var(--radio-button-checked)}.checkmark[data-v-c0391d90]:after{content:\"\";position:absolute;display:none}.pe-radio input:checked~.checkmark[data-v-c0391d90]:after{display:block}.pe-radio .checkmark[data-v-c0391d90]:after{top:4.5px;left:4.5px;width:6px;height:6px;border-radius:50%;background:#fff}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Presion/PresionNormal.vue"],"names":[],"mappings":"AACA,gCACE,gBAAkB,CACnB,AACD,4BACE,YAAa,AACb,8BAA+B,AAC/B,UAAY,CACb,AACD,gCACE,eAAiB,CAClB,AAOD,qFACE,QAAU,CACX,AAGD,yBACE,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,WAAa,CACd,AAGD,+BACE,UAAW,AACX,QAAS,AACT,QAAU,CACX,AAGD,yBACE,kBAAmB,AACnB,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,sBAAuB,AACvB,cAAgB,CACjB,AACD,gCACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,SAAU,AACV,WAAY,AACZ,sBAAwB,AACxB,cAAgB,CACjB,AACD,uCACE,4CAA8C,CAC/C,AACD,qCACE,8CAAgD,CACjD,AACD,8CACE,0BAA4B,CAC7B,AAGD,+BACE,kBAAoB,CACrB,AACD,sCACE,iBAAmB,CACpB,AACD,8BACE,aAAc,AACd,eAAgB,AAChB,kBAAmB,AACnB,cAAgB,CACjB,AAGD,2BACE,cAAe,AACf,kBAAmB,AACnB,oBAAqB,AACrB,kBAAmB,AACnB,eAAgB,AAChB,eAAgB,AAChB,yBAA0B,AAC1B,qBAAsB,AACtB,gBAAkB,CACnB,AACD,gCACE,eAAgB,AAChB,aAAc,AACd,aAAe,CAChB,AAGD,iCACE,kBAAmB,AACnB,UAAW,AACX,cAAgB,CACjB,AAGD,4BACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,sBAAuB,AACvB,iBAAmB,CACpB,AAGD,kDACE,qBAAuB,CACxB,AAGD,oDACE,4CAA8C,CAC/C,AAGD,kCACE,WAAY,AACZ,kBAAmB,AACnB,YAAc,CACf,AAGD,0DACE,aAAe,CAChB,AAGD,4CACE,UAAW,AACX,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,eAAkB,CACnB","file":"PresionNormal.vue","sourcesContent":["\n.custom-select[data-v-c0391d90] {\n  padding: 4px 16px;\n}\n.md-drawer[data-v-c0391d90] {\n  width: 320px;\n  max-width: calc(100vw - 125px);\n  z-index: 10;\n}\n.toolbar-title[data-v-c0391d90] {\n  min-height: 44px;\n}\n.md-radio[data-v-c0391d90] {\n  margin: 0;\n}\n.md-datepicker[data-v-c0391d90] {\n  margin: 0;\n}\n.md-list[data-v-c0391d90] {\n  margin: 0;\n}\n\n/* The switch - the box around the slider */\n.switch[data-v-c0391d90] {\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  height: 17px;\n}\n\n/* Hide default HTML checkbox */\n.switch input[data-v-c0391d90] {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider */\n.slider[data-v-c0391d90] {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n}\n.slider[data-v-c0391d90]:before {\n  position: absolute;\n  content: \"\";\n  height: 13px;\n  width: 13px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: .4s;\n}\ninput:checked + .slider[data-v-c0391d90] {\n  background-color: var(--radio-button-checked);\n}\ninput:focus + .slider[data-v-c0391d90] {\n  box-shadow: 0 0 1px var(--radio-button-checked);\n}\ninput:checked + .slider[data-v-c0391d90]:before {\n  transform: translateX(13px);\n}\n\n/* Rounded sliders */\n.slider.round[data-v-c0391d90] {\n  border-radius: 17px;\n}\n.slider.round[data-v-c0391d90]:before {\n  border-radius: 50%;\n}\n.slider-text[data-v-c0391d90] {\n  margin: 0 8px;\n  font-size: 12px;\n  position: absolute;\n  cursor: pointer;\n}\n\n/* The container */\n.pe-radio[data-v-c0391d90] {\n  display: block;\n  position: relative;\n  padding-left: 17.5px;\n  margin-bottom: 6px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.pe-radio-text[data-v-c0391d90] {\n  font-size: 14px;\n  margin: 0 8px;\n  display: block;\n}\n\n/* Hide the browser's default radio button */\n.pe-radio input[data-v-c0391d90] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n/* Create a custom radio button */\n.checkmark[data-v-c0391d90] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background-color: #eee;\n  border-radius: 50%;\n}\n\n/* On mouse-over, add a grey background color */\n.pe-radio:hover input ~ .checkmark[data-v-c0391d90] {\n  background-color: #ccc;\n}\n\n/* When the radio button is checked, add a blue background */\n.pe-radio input:checked ~ .checkmark[data-v-c0391d90] {\n  background-color: var(--radio-button-checked);\n}\n\n/* Create the indicator (the dot/circle - hidden when not checked) */\n.checkmark[data-v-c0391d90]:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the indicator (dot/circle) when checked */\n.pe-radio input:checked ~ .checkmark[data-v-c0391d90]:after {\n  display: block;\n}\n\n/* Style the indicator (dot/circle) */\n.pe-radio .checkmark[data-v-c0391d90]:after {\n  top: 4.5px;\n  left: 4.5px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".row[data-v-cc829a0e]{margin:0;padding:0}.bar[data-v-cc829a0e]{height:6px;border-radius:25px;width:100%;background-color:--loading-color}.indicator[data-v-cc829a0e]{width:102%!important;margin-left:-1%}.panel-body[data-v-cc829a0e],table[data-v-cc829a0e]{background-color:#eee;overflow:scroll;padding:0}.panel-default[data-v-cc829a0e]{background-color:#e0e0e0;border:none;border-radius:0}.table thead tr th[data-v-cc829a0e]{color:#fff;background-color:var(--btn-default)}.table th[data-v-cc829a0e]{text-align:left}@media screen and (max-width:415px){.table th[data-v-cc829a0e]{font-size:12px}}.table tbody tr td[data-v-cc829a0e]{background-color:transparent!important;max-width:700px}.table tbody tr td img[data-v-cc829a0e]{width:100%}.table tbody tr td .span_switch[data-v-cc829a0e]{width:40px;height:15px}.table tbody tr td .green[data-v-cc829a0e]{background-color:green}.table tbody tr td .red[data-v-cc829a0e]{background-color:red}.table tbody tr td p[data-v-cc829a0e]{font-size:12px}.table tbody tr td i[data-v-cc829a0e]{color:rgba(0,0,0,.34);cursor:pointer}.table tbody tr td i[data-v-cc829a0e]:hover{color:var(--btn-default)}.table .table-name[data-v-cc829a0e]{background-color:var(--btn-default);color:#fff}.table .panel-body[data-v-cc829a0e]{padding-right:-15px}@media screen and (max-width:415px){.table .panel-title[data-v-cc829a0e]{font-size:12px}}.striped[data-v-cc829a0e]:nth-child(odd){background-color:#eee!important}.striped[data-v-cc829a0e]:nth-child(2n){background-color:#fff!important}#loading-modal-modal[data-v-cc829a0e]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/reusable/DropDownTable.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,SAAW,CACZ,AACD,sBACE,WAAY,AACZ,mBAAoB,AACpB,WAAY,AACZ,gCAAkC,CACnC,AACD,4BACE,qBAAuB,AACvB,eAAiB,CAClB,AACD,oDAEE,sBAA0B,AAC1B,gBAAiB,AACjB,SAAW,CACZ,AACD,gCACE,yBAA0B,AAC1B,YAAa,AACb,eAAiB,CAClB,AACD,oCACE,WAAa,AACb,mCAAqC,CACtC,AACD,2BACE,eAAiB,CAClB,AACD,oCACA,2BACM,cAAgB,CACrB,CACA,AACD,oCACE,uCAAyC,AACzC,eAAiB,CAClB,AACD,wCACI,UAAY,CACf,AACD,iDACI,WAAY,AACZ,WAAa,CAChB,AACD,2CACI,sBAAwB,CAC3B,AACD,yCACI,oBAAsB,CACzB,AACD,sCACI,cAAgB,CACnB,AACD,sCACI,sBAA2B,AAC3B,cAAgB,CACnB,AACD,4CACM,wBAA0B,CAC/B,AACD,oCACE,oCAAqC,AACrC,UAAa,CACd,AACD,oCACE,mBAAqB,CACtB,AACD,oCACA,qCACI,cAAgB,CACnB,CACA,AACD,yCACE,+BAAqC,CACtC,AACD,wCACE,+BAAmC,CACpC,AACD,sCACE,0DAA6D,CAC9D","file":"DropDownTable.vue","sourcesContent":["\n.row[data-v-cc829a0e] {\n  margin: 0;\n  padding: 0;\n}\n.bar[data-v-cc829a0e] {\n  height: 6px;\n  border-radius: 25px;\n  width: 100%;\n  background-color: --loading-color;\n}\n.indicator[data-v-cc829a0e] {\n  width: 102% !important;\n  margin-left: -1%;\n}\ntable[data-v-cc829a0e],\n.panel-body[data-v-cc829a0e] {\n  background-color: #eeeeee;\n  overflow: scroll;\n  padding: 0;\n}\n.panel-default[data-v-cc829a0e] {\n  background-color: #E0E0E0;\n  border: none;\n  border-radius: 0;\n}\n.table thead tr th[data-v-cc829a0e] {\n  color: white;\n  background-color: var(--btn-default);\n}\n.table th[data-v-cc829a0e] {\n  text-align: left;\n}\n@media screen and (max-width: 415px) {\n.table th[data-v-cc829a0e] {\n      font-size: 12px;\n}\n}\n.table tbody tr td[data-v-cc829a0e] {\n  background-color: transparent !important;\n  max-width: 700px;\n}\n.table tbody tr td img[data-v-cc829a0e] {\n    width: 100%;\n}\n.table tbody tr td .span_switch[data-v-cc829a0e] {\n    width: 40px;\n    height: 15px;\n}\n.table tbody tr td .green[data-v-cc829a0e] {\n    background-color: green;\n}\n.table tbody tr td .red[data-v-cc829a0e] {\n    background-color: red;\n}\n.table tbody tr td p[data-v-cc829a0e] {\n    font-size: 12px;\n}\n.table tbody tr td i[data-v-cc829a0e] {\n    color: rgba(0, 0, 0, 0.34);\n    cursor: pointer;\n}\n.table tbody tr td i[data-v-cc829a0e]:hover {\n      color: var(--btn-default);\n}\n.table .table-name[data-v-cc829a0e] {\n  background-color: var(--btn-default);\n  color: white;\n}\n.table .panel-body[data-v-cc829a0e] {\n  padding-right: -15px;\n}\n@media screen and (max-width: 415px) {\n.table .panel-title[data-v-cc829a0e] {\n    font-size: 12px;\n}\n}\n.striped[data-v-cc829a0e]:nth-child(odd) {\n  background-color: #eeeeee !important;\n}\n.striped[data-v-cc829a0e]:nth-child(even) {\n  background-color: white !important;\n}\n#loading-modal-modal[data-v-cc829a0e] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".container[data-v-d6789794]{margin-top:20px;height:100vh}.text-center[data-v-d6789794]{text-align:center}.center-content[data-v-d6789794]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.iframe-container[data-v-d6789794],.pdf-container[data-v-d6789794]{height:100%}iframe[data-v-d6789794]{width:100%;height:100%}.datepicker-container[data-v-d6789794] :-ms-input-placeholder{color:#000}.datepicker-container[data-v-d6789794] ::placeholder{color:#000}textarea.materialize-textarea[readonly=readonly][data-v-d6789794]{all:unset}.buttons-container[data-v-d6789794]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.buttons-container .btn[data-v-d6789794]{-ms-flex:1;flex:1;margin:0 5px}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Reportes/PressureReport.vue"],"names":[],"mappings":"AACA,4BACE,gBAAiB,AACjB,YAAc,CACf,AACD,8BACE,iBAAmB,CACpB,AACD,iCACE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,kBAAoB,CACzB,AAID,mEACE,WAAa,CACd,AACD,wBACE,WAAY,AACZ,WAAa,CACd,AACD,8DACE,UAAa,CACd,AACD,qDACE,UAAa,CACd,AAGD,kEACE,SAAW,CACZ,AACD,oCACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,6BAA+B,CACpC,AACD,yCACE,WAAY,AACR,OAAQ,AACZ,YAAc,CACf","file":"PressureReport.vue","sourcesContent":["\n.container[data-v-d6789794] {\r\n  margin-top: 20px;\r\n  height: 100vh; /* Ensure the container takes the full viewport height */\n}\n.text-center[data-v-d6789794] {\r\n  text-align: center;\n}\n.center-content[data-v-d6789794] {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n  -ms-flex-align: center;\r\n      align-items: center;\n}\n.pdf-container[data-v-d6789794] {\r\n  height: 100%;\n}\n.iframe-container[data-v-d6789794] {\r\n  height: 100%;\n}\niframe[data-v-d6789794] {\r\n  width: 100%;\r\n  height: 100%; /* Make the iframe fill the height of its container */\n}\n.datepicker-container[data-v-d6789794] :-ms-input-placeholder {\r\n  color: black;\n}\n.datepicker-container[data-v-d6789794] ::placeholder {\r\n  color: black;\n}\r\n\r\n/* Remove styles for textarea.materialize-textarea[readonly=\"readonly\"] */\ntextarea.materialize-textarea[readonly=\"readonly\"][data-v-d6789794] {\r\n  all: unset; /* Unset all styles */\n}\n.buttons-container[data-v-d6789794] {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: justify;\r\n      justify-content: space-between;\n}\n.buttons-container .btn[data-v-d6789794] {\r\n  -ms-flex: 1;\r\n      flex: 1;\r\n  margin: 0 5px;\n}\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".col-md-12[data-v-d6fddac6],.col-sm-12[data-v-d6fddac6],.container-fluid[data-v-d6fddac6],.row[data-v-d6fddac6]{margin:0;padding:0}#form-bot[data-v-d6fddac6]{margin-bottom:25px}#campo[data-v-d6fddac6]{background-color:#eee}#campo #formulario-top[data-v-d6fddac6]{height:15vh;margin-top:80px;border-bottom:1px solid rgba(0,0,0,.34)}@media screen and (max-width:991px){#campo #formulario-top[data-v-d6fddac6]{height:30vh}}@media screen and (max-width:991px){#campo .buttons[data-v-d6fddac6]{margin-top:25px}}#campo #input-check[data-v-d6fddac6]{text-align:center}#campo #input-check input[data-v-d6fddac6]{padding:5px}#campo #input-check label[data-v-d6fddac6]{font-size:16px;padding-left:10px}@media screen and (max-width:991px){#campo #input-check input[data-v-d6fddac6]{margin-top:20px}}#campo .btn-default[data-v-d6fddac6]{margin-top:0;background-color:var(--btn-default)}#campo .btn-default[data-v-d6fddac6]:active,#campo .btn-default[data-v-d6fddac6]:focus,#campo .btn-default[data-v-d6fddac6]:hover{background-color:var(--btn-default-hover)!important}.tabla-bottom[data-v-d6fddac6]{height:100vh}.sub-table[data-v-d6fddac6]:nth-child(odd){background-color:#fff!important}.sub-table[data-v-d6fddac6]:nth-child(2n){background-color:#eee!important}#loading-modal-modal[data-v-d6fddac6]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Campo/Campo.vue"],"names":[],"mappings":"AAMA,gHAEE,SAAU,AACV,SAAW,CACZ,AACD,2BACE,kBAAoB,CACrB,AACD,wBACE,qBAA0B,CAC3B,AACD,wCACI,YAAa,AACb,gBAAiB,AACjB,uCAA6C,CAChD,AACD,oCACA,wCACQ,WAAa,CACpB,CACA,AACD,oCACA,iCACM,eAAiB,CACtB,CACA,AACD,qCACI,iBAAmB,CACtB,AACD,2CACM,WAAa,CAClB,AACD,2CACM,eAAgB,AAChB,iBAAmB,CACxB,AACD,oCACA,2CACQ,eAAiB,CACxB,CACA,AACD,qCACI,aAAc,AACd,mCAAqC,CACxC,AACD,kIACM,mDAAsD,CAC3D,AACD,+BACE,YAAc,CACf,AACD,2CACE,+BAAmC,CACpC,AACD,0CACE,+BAAqC,CACtC,AACD,sCACE,0DAA6D,CAC9D","file":"Campo.vue","sourcesContent":["\n.col-md-12[data-v-d6fddac6],\n.col-sm-12[data-v-d6fddac6] {\n  margin: 0;\n  padding: 0;\n}\n.container-fluid[data-v-d6fddac6],\n.row[data-v-d6fddac6] {\n  margin: 0;\n  padding: 0;\n}\n#form-bot[data-v-d6fddac6] {\n  margin-bottom: 25px;\n}\n#campo[data-v-d6fddac6] {\n  background-color: #eeeeee;\n}\n#campo #formulario-top[data-v-d6fddac6] {\n    height: 15vh;\n    margin-top: 80px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.34);\n}\n@media screen and (max-width: 991px) {\n#campo #formulario-top[data-v-d6fddac6] {\n        height: 30vh;\n}\n}\n@media screen and (max-width: 991px) {\n#campo .buttons[data-v-d6fddac6] {\n      margin-top: 25px;\n}\n}\n#campo #input-check[data-v-d6fddac6] {\n    text-align: center;\n}\n#campo #input-check input[data-v-d6fddac6] {\n      padding: 5px;\n}\n#campo #input-check label[data-v-d6fddac6] {\n      font-size: 16px;\n      padding-left: 10px;\n}\n@media screen and (max-width: 991px) {\n#campo #input-check input[data-v-d6fddac6] {\n        margin-top: 20px;\n}\n}\n#campo .btn-default[data-v-d6fddac6] {\n    margin-top: 0;\n    background-color: var(--btn-default);\n}\n#campo .btn-default[data-v-d6fddac6]:hover, #campo .btn-default[data-v-d6fddac6]:active, #campo .btn-default[data-v-d6fddac6]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n.tabla-bottom[data-v-d6fddac6] {\n  height: 100vh;\n}\n.sub-table[data-v-d6fddac6]:nth-child(odd) {\n  background-color: white !important;\n}\n.sub-table[data-v-d6fddac6]:nth-child(even) {\n  background-color: #eeeeee !important;\n}\n#loading-modal-modal[data-v-d6fddac6] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, ".row[data-v-daec1c7c]{margin:0;padding:0}.panel-body[data-v-daec1c7c],table[data-v-daec1c7c]{background-color:#eee;overflow:scroll;padding:0}.panel-default[data-v-daec1c7c]{background-color:#e0e0e0;border:none;border-radius:0}table thead tr th[data-v-daec1c7c]{color:#fff;background-color:var(--btn-default)}table th[data-v-daec1c7c]{text-align:left}@media screen and (max-width:415px){table th[data-v-daec1c7c]{font-size:12px}}table tbody td[data-v-daec1c7c]{text-align:left;background-color:#eee!important;max-width:700px}table tbody td p[data-v-daec1c7c]{font-size:12px}table tbody td i[data-v-daec1c7c]{color:rgba(0,0,0,.34);cursor:pointer}table tbody td i[data-v-daec1c7c]:hover{color:var(--btn-default)}table .table-name[data-v-daec1c7c]{background-color:var(--btn-default);color:#fff}table .panel-body[data-v-daec1c7c]{padding-right:-15px}@media screen and (max-width:415px){table .panel-title[data-v-daec1c7c]{font-size:12px}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/reusable/SingleTable.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,SAAW,CACZ,AACD,oDAEE,sBAA0B,AAC1B,gBAAiB,AACjB,SAAW,CACZ,AACD,gCACE,yBAA0B,AAC1B,YAAa,AACb,eAAiB,CAClB,AACD,mCACE,WAAa,AACb,mCAAqC,CACtC,AACD,0BACE,eAAiB,CAClB,AACD,oCACA,0BACM,cAAgB,CACrB,CACA,AACD,gCACE,gBAAiB,AACjB,gCAAqC,AACrC,eAAiB,CAClB,AACD,kCACI,cAAgB,CACnB,AACD,kCACI,sBAA2B,AAC3B,cAAgB,CACnB,AACD,wCACM,wBAA0B,CAC/B,AACD,mCACE,oCAAqC,AACrC,UAAa,CACd,AACD,mCACE,mBAAqB,CACtB,AACD,oCACA,oCACI,cAAgB,CACnB,CACA","file":"SingleTable.vue","sourcesContent":["\n.row[data-v-daec1c7c] {\n  margin: 0;\n  padding: 0;\n}\ntable[data-v-daec1c7c],\n.panel-body[data-v-daec1c7c] {\n  background-color: #eeeeee;\n  overflow: scroll;\n  padding: 0;\n}\n.panel-default[data-v-daec1c7c] {\n  background-color: #E0E0E0;\n  border: none;\n  border-radius: 0;\n}\ntable thead tr th[data-v-daec1c7c] {\n  color: white;\n  background-color: var(--btn-default);\n}\ntable th[data-v-daec1c7c] {\n  text-align: left;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-daec1c7c] {\n      font-size: 12px;\n}\n}\ntable tbody td[data-v-daec1c7c] {\n  text-align: left;\n  background-color: #eeeeee !important;\n  max-width: 700px;\n}\ntable tbody td p[data-v-daec1c7c] {\n    font-size: 12px;\n}\ntable tbody td i[data-v-daec1c7c] {\n    color: rgba(0, 0, 0, 0.34);\n    cursor: pointer;\n}\ntable tbody td i[data-v-daec1c7c]:hover {\n      color: var(--btn-default);\n}\ntable .table-name[data-v-daec1c7c] {\n  background-color: var(--btn-default);\n  color: white;\n}\ntable .panel-body[data-v-daec1c7c] {\n  padding-right: -15px;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-daec1c7c] {\n    font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "#configuracion[data-v-dffbd7e2]{min-height:100vh;padding-bottom:30px}#configuracion .container[data-v-dffbd7e2]{margin-top:80px;height:100vh}#configuracion .container .row[data-v-dffbd7e2]{margin-bottom:20px}#configuracion .container p[data-v-dffbd7e2]{font-size:9pt}#configuracion .container h5[data-v-dffbd7e2]{font-size:15pt;color:#999;font-weight:800}#configuracion .switch[data-v-dffbd7e2]{position:relative;display:inline-block;width:40px;height:20px;margin-top:20%}#configuracion .switch input[data-v-dffbd7e2]{display:none}#configuracion .slider[data-v-dffbd7e2]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}#configuracion .slider[data-v-dffbd7e2]:before{position:absolute;content:\"\";height:20px;width:20px;left:0;bottom:0;border:1px solid #d3d3d3;background-color:#fff;transition:.4s}#configuracion input:checked+.slider[data-v-dffbd7e2]{background-color:#2196f3}#configuracion input:focus+.slider[data-v-dffbd7e2]{box-shadow:0 0 1px #2196f3}#configuracion input:checked+.slider[data-v-dffbd7e2]:before{transform:translateX(26px)}#configuracion .slider.round[data-v-dffbd7e2]{border-radius:34px}#configuracion .slider.round[data-v-dffbd7e2]:before{border-radius:50%}#configuracion th[data-v-dffbd7e2]{text-align:left;padding-left:25px}@media screen and (max-width:415px){#configuracion th[data-v-dffbd7e2]{font-size:12px}}#configuracion td[data-v-dffbd7e2]{text-align:left;padding-left:25px;background-color:#eee;cursor:pointer}#configuracion td tr[data-v-dffbd7e2]{cursor:pointer}#configuracion td i[data-v-dffbd7e2]{color:rgba(0,0,0,.34);cursor:pointer}#configuracion td i[data-v-dffbd7e2]:hover{color:#fff}#configuracion .nombre-ducto[data-v-dffbd7e2]{cursor:pointer;height:40px;background-color:var(--btn-default);color:#fff;vertical-align:middle}#configuracion .fail-icon[data-v-dffbd7e2]{color:#FF0000CC;vertical-align:middle;text-align:center}#configuracion .fail-icon[data-v-dffbd7e2]:hover{color:red}#configuracion .material-icons.md-18[data-v-dffbd7e2]{font-size:18px}#configuracion .material-icons.md-24[data-v-dffbd7e2]{font-size:24px}#configuracion .material-icons.md-36[data-v-dffbd7e2]{font-size:36px}#configuracion .material-icons.md-48[data-v-dffbd7e2]{font-size:48px}#configuracion .panel-body[data-v-dffbd7e2]{padding:0}@media screen and (max-width:415px){#configuracion .panel-title[data-v-dffbd7e2]{font-size:12px}}#configuracion .no-show[data-v-dffbd7e2]{display:none}#configuracion td.failure[data-v-dffbd7e2]{background-color:#FF0000CC!important}#configuracion tbody[data-v-dffbd7e2]{margin-bottom:20px!important}#configuracion tr.site-disabled>td[data-v-dffbd7e2]{background-color:rgba(68,68,68,.8)}#configuracion .leak-table-toggle[data-v-dffbd7e2]{cursor:pointer;height:40px;background-color:var(--btn-default);color:#fff;vertical-align:middle;margin:auto;padding-top:4px}#configuracion .leak-table-toggle>i[data-v-dffbd7e2]{color:rgba(0,0,0,.34)}#configuracion .leak-table-toggle>i[data-v-dffbd7e2]:hover{color:#fff}#configuracion tr.site-disabled>td i[data-v-dffbd7e2]{margin-right:10px;float:right}#configuracion #comentario-modal h3[data-v-dffbd7e2],#configuracion #publish-modal h3[data-v-dffbd7e2]{color:rgba(0,0,0,.87);display:none}#configuracion #comentario-modal .btn-default[data-v-dffbd7e2],#configuracion #publish-modal .btn-default[data-v-dffbd7e2]{background-color:var(--btn-default)}#configuracion #comentario-modal .btn-default[data-v-dffbd7e2]:active,#configuracion #comentario-modal .btn-default[data-v-dffbd7e2]:focus,#configuracion #comentario-modal .btn-default[data-v-dffbd7e2]:hover,#configuracion #publish-modal .btn-default[data-v-dffbd7e2]:active,#configuracion #publish-modal .btn-default[data-v-dffbd7e2]:focus,#configuracion #publish-modal .btn-default[data-v-dffbd7e2]:hover{background-color:var(--btn-default-hover)!important}#configuracion #comentario-modal label[data-v-dffbd7e2],#configuracion #publish-modal label[data-v-dffbd7e2]{color:var(--btn-default)}#configuracion #comentario-modal #label-name[data-v-dffbd7e2],#configuracion #publish-modal #label-name[data-v-dffbd7e2]{color:#fff;width:100%;font-size:16px;padding:5px;background-color:var(--btn-default)}#configuracion #comentario-modal #selectDonde[data-v-dffbd7e2],#configuracion #publish-modal #selectDonde[data-v-dffbd7e2]{-webkit-appearance:none;-webkit-border-radius:0;width:80%;height:40px;padding:5px}#loading-modal-modal[data-v-dffbd7e2]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Configuracion/Configuracion.vue"],"names":[],"mappings":"AACA,gCACE,iBAAkB,AAClB,mBAAqB,CAKtB,AACD,2CACI,gBAAiB,AACjB,YAAc,CACjB,AACD,gDACM,kBAAoB,CACzB,AACD,6CACM,aAAe,CACpB,AACD,8CACM,eAAgB,AAChB,WAAY,AACZ,eAAiB,CACtB,AACD,wCACI,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,cAAgB,CACnB,AACD,8CACI,YAAc,CACjB,AACD,wCACI,kBAAmB,AACnB,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,sBAAuB,AACvB,cAAgB,CACnB,AACD,+CACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,OAAU,AACV,SAAY,AACZ,yBAA4B,AAC5B,sBAAwB,AACxB,cAAgB,CACnB,AACD,sDACI,wBAA0B,CAC7B,AACD,oDACI,0BAA4B,CAC/B,AACD,6DACI,0BAA4B,CAC/B,AACD,8CACI,kBAAoB,CACvB,AACD,qDACI,iBAAmB,CACtB,AACD,mCACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,mCACQ,cAAgB,CACvB,CACA,AACD,mCACI,gBAAiB,AACjB,kBAAmB,AACnB,sBAA0B,AAC1B,cAAgB,CACnB,AACD,sCACM,cAAgB,CACrB,AACD,qCACM,sBAA2B,AAC3B,cAAgB,CACrB,AACD,2CACQ,UAAa,CACpB,AACD,8CACI,eAAgB,AAChB,YAAa,AACb,oCAAqC,AACrC,WAAa,AACb,qBAAuB,CAC1B,AACD,2CACI,gBAAiB,AACjB,sBAAuB,AACvB,iBAAmB,CACtB,AACD,iDACI,SAAW,CACd,AACD,sDACI,cAAgB,CACnB,AACD,sDACI,cAAgB,CACnB,AACD,sDACI,cAAgB,CACnB,AACD,sDACI,cAAgB,CACnB,AACD,4CACI,SAAW,CACd,AACD,oCACA,6CACM,cAAgB,CACrB,CACA,AACD,yCACI,YAAc,CACjB,AACD,2CACI,oCAAuC,CAC1C,AACD,sCACI,4BAA+B,CAClC,AACD,oDACI,kCAAwC,CAC3C,AACD,mDACI,eAAgB,AAChB,YAAa,AACb,oCAAqC,AACrC,WAAa,AACb,sBAAuB,AACvB,YAAa,AACb,eAAiB,CACpB,AACD,qDACI,qBAA2B,CAC9B,AACD,2DACM,UAAa,CAClB,AACD,sDACI,kBAAmB,AACnB,WAAa,CAChB,AACD,uGACI,sBAA2B,AAC3B,YAAc,CACjB,AACD,2HACI,mCAAqC,CACxC,AACD,uZACM,mDAAsD,CAC3D,AACD,6GACI,wBAA0B,CAC7B,AACD,yHACI,WAAa,AACb,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,mCAAqC,CACxC,AACD,2HACI,wBAAyB,AACzB,wBAA2B,AAC3B,UAAW,AACX,YAAa,AACb,WAAa,CAChB,AACD,sCACE,0DAA6D,CAC9D","file":"Configuracion.vue","sourcesContent":["\n#configuracion[data-v-dffbd7e2] {\n  min-height: 100vh;\n  padding-bottom: 30px;\n  /* The switch - the box around the slider */\n  /* Hide default HTML checkbox */\n  /* The slider */\n  /* Rounded sliders */\n}\n#configuracion .container[data-v-dffbd7e2] {\n    margin-top: 80px;\n    height: 100vh;\n}\n#configuracion .container .row[data-v-dffbd7e2] {\n      margin-bottom: 20px;\n}\n#configuracion .container p[data-v-dffbd7e2] {\n      font-size: 9pt;\n}\n#configuracion .container h5[data-v-dffbd7e2] {\n      font-size: 15pt;\n      color: #999;\n      font-weight: 800;\n}\n#configuracion .switch[data-v-dffbd7e2] {\n    position: relative;\n    display: inline-block;\n    width: 40px;\n    height: 20px;\n    margin-top: 20%;\n}\n#configuracion .switch input[data-v-dffbd7e2] {\n    display: none;\n}\n#configuracion .slider[data-v-dffbd7e2] {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    transition: .4s;\n}\n#configuracion .slider[data-v-dffbd7e2]:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: 0px;\n    bottom: 0px;\n    border: 1px solid lightgray;\n    background-color: white;\n    transition: .4s;\n}\n#configuracion input:checked + .slider[data-v-dffbd7e2] {\n    background-color: #2196F3;\n}\n#configuracion input:focus + .slider[data-v-dffbd7e2] {\n    box-shadow: 0 0 1px #2196F3;\n}\n#configuracion input:checked + .slider[data-v-dffbd7e2]:before {\n    transform: translateX(26px);\n}\n#configuracion .slider.round[data-v-dffbd7e2] {\n    border-radius: 34px;\n}\n#configuracion .slider.round[data-v-dffbd7e2]:before {\n    border-radius: 50%;\n}\n#configuracion th[data-v-dffbd7e2] {\n    text-align: left;\n    padding-left: 25px;\n}\n@media screen and (max-width: 415px) {\n#configuracion th[data-v-dffbd7e2] {\n        font-size: 12px;\n}\n}\n#configuracion td[data-v-dffbd7e2] {\n    text-align: left;\n    padding-left: 25px;\n    background-color: #eeeeee;\n    cursor: pointer;\n}\n#configuracion td tr[data-v-dffbd7e2] {\n      cursor: pointer;\n}\n#configuracion td i[data-v-dffbd7e2] {\n      color: rgba(0, 0, 0, 0.34);\n      cursor: pointer;\n}\n#configuracion td i[data-v-dffbd7e2]:hover {\n        color: white;\n}\n#configuracion .nombre-ducto[data-v-dffbd7e2] {\n    cursor: pointer;\n    height: 40px;\n    background-color: var(--btn-default);\n    color: white;\n    vertical-align: middle;\n}\n#configuracion .fail-icon[data-v-dffbd7e2] {\n    color: #FF0000CC;\n    vertical-align: middle;\n    text-align: center;\n}\n#configuracion .fail-icon[data-v-dffbd7e2]:hover {\n    color: red;\n}\n#configuracion .material-icons.md-18[data-v-dffbd7e2] {\n    font-size: 18px;\n}\n#configuracion .material-icons.md-24[data-v-dffbd7e2] {\n    font-size: 24px;\n}\n#configuracion .material-icons.md-36[data-v-dffbd7e2] {\n    font-size: 36px;\n}\n#configuracion .material-icons.md-48[data-v-dffbd7e2] {\n    font-size: 48px;\n}\n#configuracion .panel-body[data-v-dffbd7e2] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\n#configuracion .panel-title[data-v-dffbd7e2] {\n      font-size: 12px;\n}\n}\n#configuracion .no-show[data-v-dffbd7e2] {\n    display: none;\n}\n#configuracion td.failure[data-v-dffbd7e2] {\n    background-color: #FF0000CC !important;\n}\n#configuracion tbody[data-v-dffbd7e2] {\n    margin-bottom: 20px !important;\n}\n#configuracion tr.site-disabled > td[data-v-dffbd7e2] {\n    background-color: rgba(68, 68, 68, 0.8);\n}\n#configuracion .leak-table-toggle[data-v-dffbd7e2] {\n    cursor: pointer;\n    height: 40px;\n    background-color: var(--btn-default);\n    color: white;\n    vertical-align: middle;\n    margin: auto;\n    padding-top: 4px;\n}\n#configuracion .leak-table-toggle > i[data-v-dffbd7e2] {\n    color: rgba(0, 0, 0, 0.34);\n}\n#configuracion .leak-table-toggle > i[data-v-dffbd7e2]:hover {\n      color: white;\n}\n#configuracion tr.site-disabled > td i[data-v-dffbd7e2] {\n    margin-right: 10px;\n    float: right;\n}\n#configuracion #comentario-modal h3[data-v-dffbd7e2], #configuracion #publish-modal h3[data-v-dffbd7e2] {\n    color: rgba(0, 0, 0, 0.87);\n    display: none;\n}\n#configuracion #comentario-modal .btn-default[data-v-dffbd7e2], #configuracion #publish-modal .btn-default[data-v-dffbd7e2] {\n    background-color: var(--btn-default);\n}\n#configuracion #comentario-modal .btn-default[data-v-dffbd7e2]:hover, #configuracion #comentario-modal .btn-default[data-v-dffbd7e2]:active, #configuracion #comentario-modal .btn-default[data-v-dffbd7e2]:focus, #configuracion #publish-modal .btn-default[data-v-dffbd7e2]:hover, #configuracion #publish-modal .btn-default[data-v-dffbd7e2]:active, #configuracion #publish-modal .btn-default[data-v-dffbd7e2]:focus {\n      background-color: var(--btn-default-hover) !important;\n}\n#configuracion #comentario-modal label[data-v-dffbd7e2], #configuracion #publish-modal label[data-v-dffbd7e2] {\n    color: var(--btn-default);\n}\n#configuracion #comentario-modal #label-name[data-v-dffbd7e2], #configuracion #publish-modal #label-name[data-v-dffbd7e2] {\n    color: white;\n    width: 100%;\n    font-size: 16px;\n    padding: 5px;\n    background-color: var(--btn-default);\n}\n#configuracion #comentario-modal #selectDonde[data-v-dffbd7e2], #configuracion #publish-modal #selectDonde[data-v-dffbd7e2] {\n    -webkit-appearance: none;\n    -webkit-border-radius: 0px;\n    width: 80%;\n    height: 40px;\n    padding: 5px;\n}\n#loading-modal-modal[data-v-dffbd7e2] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports


// module
exports.push([module.i, "@media screen and (max-width:991px){i[data-v-f1ff1b3e]{padding:10px}}.row[data-v-f1ff1b3e]{margin:0;padding:0}.color-slider[data-v-f1ff1b3e]{padding:15px!important}.row .title[data-v-f1ff1b3e]{font-size:14px}@media screen and (max-width:991px){.row .title[data-v-f1ff1b3e]{width:200px;display:inline-block;padding-top:5px;display:block}}.row .sub[data-v-f1ff1b3e]{position:absolute;color:rgba(0,0,0,.34);font-weight:500;font-size:12px}@media screen and (max-width:991px){.row .sub[data-v-f1ff1b3e]{display:inline-block}}.row #borrar[data-v-f1ff1b3e]{height:30px;font-size:12px;padding-top:1px;margin-top:-5px}.row #borrar i[data-v-f1ff1b3e]{font-size:inherit;padding:0!important}@media screen and (max-width:991px){.row #borrar[data-v-f1ff1b3e]{display:block;margin:30px auto}}@media screen and (max-width:991px){.row .bottom-input[data-v-f1ff1b3e]{margin-top:20px;padding-left:30px;margin-bottom:50px}}.row .input-field[data-v-f1ff1b3e]{display:inline-block}.row .input-field #latitud[data-v-f1ff1b3e],.row .input-field #longitud[data-v-f1ff1b3e]{width:100px}@media screen and (max-width:991px){.row .input-field #latitud[data-v-f1ff1b3e],.row .input-field #longitud[data-v-f1ff1b3e]{width:70px}}.row .input-field .input-3[data-v-f1ff1b3e]{width:40px;margin:0 10px}.btn-default[data-v-f1ff1b3e]:active,.btn-default[data-v-f1ff1b3e]:focus,.btn-default[data-v-f1ff1b3e]:hover{background:var(--btn-default)!important}@media screen and (max-width:991px){.btn-default[data-v-f1ff1b3e]{margin:25px}}#historico-page[data-v-f1ff1b3e]{background-color:#eee}#historico-page .form-container[data-v-f1ff1b3e]{overflow-y:scroll;height:45vh;overflow-x:hidden}#historico-page .chart-container[data-v-f1ff1b3e]{height:45vh}#historico-page .chart-container #line-chart[data-v-f1ff1b3e]{width:auto;height:auto}.color-2 .irs-bar-edge[data-v-f1ff1b3e],.color-2 .irs-bar[data-v-f1ff1b3e]{background:red}.col-md-6[data-v-f1ff1b3e],.col-xs-12[data-v-f1ff1b3e]{margin:0;padding:0}.container-fluid[data-v-f1ff1b3e]{background-color:#fff;width:100%;padding:0;margin:0}.panel-body[data-v-f1ff1b3e]{height:52vh}.panel-body[data-v-f1ff1b3e],table[data-v-f1ff1b3e]{overflow:scroll;padding:0;margin:0}@media screen and (max-width:991px){.panel-body[data-v-f1ff1b3e],table[data-v-f1ff1b3e]{padding:0}}.panel-body .info[data-v-f1ff1b3e],table .info[data-v-f1ff1b3e]{cursor:pointer;background-color:#fff}.panel-body .info td[data-v-f1ff1b3e],table .info td[data-v-f1ff1b3e]{text-align:left;padding-left:25px;background-color:transparent}.panel-body .info[data-v-f1ff1b3e]:hover,table .info[data-v-f1ff1b3e]:hover{background-color:#e0e0e0}.panel-body th[data-v-f1ff1b3e],table th[data-v-f1ff1b3e]{text-align:left;padding-left:25px;background-color:var(--btn-header-bg);color:#fff}@media screen and (max-width:415px){.panel-body th[data-v-f1ff1b3e],table th[data-v-f1ff1b3e]{font-size:12px}}.panel-body .nombre-alarma[data-v-f1ff1b3e],table .nombre-alarma[data-v-f1ff1b3e]{background-color:var(--btn-default);color:#fff}.panel-body .panel-body[data-v-f1ff1b3e],table .panel-body[data-v-f1ff1b3e]{padding:0}@media screen and (max-width:415px){.panel-body .panel-title[data-v-f1ff1b3e],table .panel-title[data-v-f1ff1b3e]{font-size:12px}}.panel-body .selectedRow[data-v-f1ff1b3e],table .selectedRow[data-v-f1ff1b3e]{background:var(--selected-row);color:#fff}.panel-body .selectedRow[data-v-f1ff1b3e]:hover,table .selectedRow[data-v-f1ff1b3e]:hover{background:var(--selected-row-hover);color:#fff}#loading-modal-modal[data-v-f1ff1b3e]{background-color:var(--loading-background-color)!important}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Historico/Historico.vue"],"names":[],"mappings":"AACA,oCACA,mBACI,YAAc,CACjB,CACA,AACD,sBACE,SAAU,AACV,SAAW,CACZ,AACD,+BACE,sBAAyB,CAC1B,AACD,6BACE,cAAgB,CACjB,AACD,oCACA,6BACM,YAAa,AACb,qBAAsB,AACtB,gBAAiB,AAKjB,aAAe,CAJpB,CACA,AAMD,2BACE,kBAAmB,AACnB,sBAA2B,AAC3B,gBAAiB,AACjB,cAAgB,CACjB,AACD,oCACA,2BACM,oBAAsB,CAC3B,CACA,AACD,8BACE,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CAClB,AACD,gCACI,kBAAmB,AACnB,mBAAsB,CACzB,AACD,oCACA,8BACM,cAAe,AACf,gBAAkB,CACvB,CACA,AACD,oCACA,oCACI,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACvB,CACA,AACD,mCACE,oBAAsB,CACvB,AACD,yFAEI,WAAa,CAChB,AACD,oCACA,yFAEQ,UAAY,CACnB,CACA,AACD,4CACI,WAAY,AACZ,aAAe,CAClB,AACD,6GACE,uCAA0C,CAC3C,AACD,oCACA,8BACI,WAAa,CAChB,CACA,AACD,iCACE,qBAA0B,CAC3B,AACD,iDACI,kBAAmB,AACnB,YAAa,AACb,iBAAmB,CACtB,AACD,kDACI,WAAa,CAChB,AACD,8DACM,WAAY,AACZ,WAAa,CAClB,AACD,2EAEE,cAAgB,CACjB,AACD,uDAEE,SAAU,AACV,SAAW,CACZ,AACD,kCACE,sBAAwB,AACxB,WAAY,AACZ,UAAW,AACX,QAAU,CACX,AACD,6BACE,WAAa,CACd,AACD,oDAEE,gBAAiB,AACjB,UAAW,AACX,QAAU,CACX,AACD,oCACA,oDAEM,SAAW,CAChB,CACA,AACD,gEAEI,eAAgB,AAChB,qBAAuB,CAC1B,AACD,sEAEM,gBAAiB,AACjB,kBAAmB,AACnB,4BAA8B,CACnC,AACD,4EAEM,wBAA0B,CAC/B,AACD,0DAEI,gBAAiB,AACjB,kBAAmB,AACnB,sCAAuC,AACvC,UAAY,CACf,AACD,oCACA,0DAEQ,cAAgB,CACvB,CACA,AACD,kFAEI,oCAAqC,AACrC,UAAa,CAChB,AACD,4EAEI,SAAW,CACd,AACD,oCACA,8EAEM,cAAgB,CACrB,CACA,AACD,8EAEI,+BAAgC,AAChC,UAAY,CACf,AACD,0FAEI,qCAAsC,AACtC,UAAY,CACf,AAID,sCACE,0DAA6D,CAC9D","file":"Historico.vue","sourcesContent":["\n@media screen and (max-width: 991px) {\ni[data-v-f1ff1b3e] {\n    padding: 10px;\n}\n}\n.row[data-v-f1ff1b3e] {\n  margin: 0;\n  padding: 0;\n}\n.color-slider[data-v-f1ff1b3e] {\n  padding: 15px !important;\n}\n.row .title[data-v-f1ff1b3e] {\n  font-size: 14px;\n}\n@media screen and (max-width: 991px) {\n.row .title[data-v-f1ff1b3e] {\n      width: 200px;\n      display: inline-block;\n      padding-top: 5px;\n}\n}\n@media screen and (max-width: 991px) {\n.row .title[data-v-f1ff1b3e] {\n      display: block;\n}\n}\n.row .sub[data-v-f1ff1b3e] {\n  position: absolute;\n  color: rgba(0, 0, 0, 0.34);\n  font-weight: 500;\n  font-size: 12px;\n}\n@media screen and (max-width: 991px) {\n.row .sub[data-v-f1ff1b3e] {\n      display: inline-block;\n}\n}\n.row #borrar[data-v-f1ff1b3e] {\n  height: 30px;\n  font-size: 12px;\n  padding-top: 1px;\n  margin-top: -5px;\n}\n.row #borrar i[data-v-f1ff1b3e] {\n    font-size: inherit;\n    padding: 0 !important;\n}\n@media screen and (max-width: 991px) {\n.row #borrar[data-v-f1ff1b3e] {\n      display: block;\n      margin: 30px auto;\n}\n}\n@media screen and (max-width: 991px) {\n.row .bottom-input[data-v-f1ff1b3e] {\n    margin-top: 20px;\n    padding-left: 30px;\n    margin-bottom: 50px;\n}\n}\n.row .input-field[data-v-f1ff1b3e] {\n  display: inline-block;\n}\n.row .input-field #latitud[data-v-f1ff1b3e],\n  .row .input-field #longitud[data-v-f1ff1b3e] {\n    width: 100px;\n}\n@media screen and (max-width: 991px) {\n.row .input-field #latitud[data-v-f1ff1b3e],\n      .row .input-field #longitud[data-v-f1ff1b3e] {\n        width: 70px;\n}\n}\n.row .input-field .input-3[data-v-f1ff1b3e] {\n    width: 40px;\n    margin: 0 10px;\n}\n.btn-default[data-v-f1ff1b3e]:hover, .btn-default[data-v-f1ff1b3e]:focus, .btn-default[data-v-f1ff1b3e]:active {\n  background: var(--btn-default) !important;\n}\n@media screen and (max-width: 991px) {\n.btn-default[data-v-f1ff1b3e] {\n    margin: 25px;\n}\n}\n#historico-page[data-v-f1ff1b3e] {\n  background-color: #eeeeee;\n}\n#historico-page .form-container[data-v-f1ff1b3e] {\n    overflow-y: scroll;\n    height: 45vh;\n    overflow-x: hidden;\n}\n#historico-page .chart-container[data-v-f1ff1b3e] {\n    height: 45vh;\n}\n#historico-page .chart-container #line-chart[data-v-f1ff1b3e] {\n      width: auto;\n      height: auto;\n}\n.color-2 .irs-bar[data-v-f1ff1b3e],\n.color-2 .irs-bar-edge[data-v-f1ff1b3e] {\n  background: red;\n}\n.col-md-6[data-v-f1ff1b3e],\n.col-xs-12[data-v-f1ff1b3e] {\n  margin: 0;\n  padding: 0;\n}\n.container-fluid[data-v-f1ff1b3e] {\n  background-color: white;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\n.panel-body[data-v-f1ff1b3e] {\n  height: 52vh;\n}\ntable[data-v-f1ff1b3e],\n.panel-body[data-v-f1ff1b3e] {\n  overflow: scroll;\n  padding: 0;\n  margin: 0;\n}\n@media screen and (max-width: 991px) {\ntable[data-v-f1ff1b3e],\n    .panel-body[data-v-f1ff1b3e] {\n      padding: 0;\n}\n}\ntable .info[data-v-f1ff1b3e],\n  .panel-body .info[data-v-f1ff1b3e] {\n    cursor: pointer;\n    background-color: #fff;\n}\ntable .info td[data-v-f1ff1b3e],\n    .panel-body .info td[data-v-f1ff1b3e] {\n      text-align: left;\n      padding-left: 25px;\n      background-color: transparent;\n}\ntable .info[data-v-f1ff1b3e]:hover,\n    .panel-body .info[data-v-f1ff1b3e]:hover {\n      background-color: #E0E0E0;\n}\ntable th[data-v-f1ff1b3e],\n  .panel-body th[data-v-f1ff1b3e] {\n    text-align: left;\n    padding-left: 25px;\n    background-color: var(--btn-header-bg);\n    color: #fff;\n}\n@media screen and (max-width: 415px) {\ntable th[data-v-f1ff1b3e],\n      .panel-body th[data-v-f1ff1b3e] {\n        font-size: 12px;\n}\n}\ntable .nombre-alarma[data-v-f1ff1b3e],\n  .panel-body .nombre-alarma[data-v-f1ff1b3e] {\n    background-color: var(--btn-default);\n    color: white;\n}\ntable .panel-body[data-v-f1ff1b3e],\n  .panel-body .panel-body[data-v-f1ff1b3e] {\n    padding: 0;\n}\n@media screen and (max-width: 415px) {\ntable .panel-title[data-v-f1ff1b3e],\n    .panel-body .panel-title[data-v-f1ff1b3e] {\n      font-size: 12px;\n}\n}\ntable .selectedRow[data-v-f1ff1b3e],\n  .panel-body .selectedRow[data-v-f1ff1b3e] {\n    background: var(--selected-row);\n    color: #fff;\n}\ntable .selectedRow[data-v-f1ff1b3e]:hover,\n  .panel-body .selectedRow[data-v-f1ff1b3e]:hover {\n    background: var(--selected-row-hover);\n    color: #fff;\n}\n#loading-modal-modal[data-v-f1ff1b3e] {\n  background-color: var(--loading-background-color) !important;\n}\n#loading-modal-modal[data-v-f1ff1b3e] {\n  background-color: var(--loading-background-color) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ })

},[805]);


// WEBPACK FOOTER //
// static/js/app.eedbbcbfe9716757c5b0.js